(() => {
var _window$dateFns;function ownKeys(e,r){var t=Object.keys(e);if(Object.getOwnPropertySymbols){var o=Object.getOwnPropertySymbols(e);r&&(o=o.filter(function(r){return Object.getOwnPropertyDescriptor(e,r).enumerable;})),t.push.apply(t,o);}return t;}function _objectSpread(e){for(var r=1;r<arguments.length;r++){var t=null!=arguments[r]?arguments[r]:{};r%2?ownKeys(Object(t),!0).forEach(function(r){_defineProperty(e,r,t[r]);}):Object.getOwnPropertyDescriptors?Object.defineProperties(e,Object.getOwnPropertyDescriptors(t)):ownKeys(Object(t)).forEach(function(r){Object.defineProperty(e,r,Object.getOwnPropertyDescriptor(t,r));});}return e;}function _defineProperty(obj,key,value){key=_toPropertyKey(key);if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}function _toPropertyKey(t){var i=_toPrimitive(t,"string");return"symbol"==_typeof(i)?i:String(i);}function _toPrimitive(t,r){if("object"!=_typeof(t)||!t)return t;var e=t[Symbol.toPrimitive];if(void 0!==e){var i=e.call(t,r||"default");if("object"!=_typeof(i))return i;throw new TypeError("@@toPrimitive must return a primitive value.");}return("string"===r?String:Number)(t);}function _slicedToArray(arr,i){return _arrayWithHoles(arr)||_iterableToArrayLimit(arr,i)||_unsupportedIterableToArray(arr,i)||_nonIterableRest();}function _nonIterableRest(){throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");}function _unsupportedIterableToArray(o,minLen){if(!o)return;if(typeof o==="string")return _arrayLikeToArray(o,minLen);var n=Object.prototype.toString.call(o).slice(8,-1);if(n==="Object"&&o.constructor)n=o.constructor.name;if(n==="Map"||n==="Set")return Array.from(o);if(n==="Arguments"||/^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n))return _arrayLikeToArray(o,minLen);}function _arrayLikeToArray(arr,len){if(len==null||len>arr.length)len=arr.length;for(var i=0,arr2=new Array(len);i<len;i++)arr2[i]=arr[i];return arr2;}function _iterableToArrayLimit(r,l){var t=null==r?null:"undefined"!=typeof Symbol&&r[Symbol.iterator]||r["@@iterator"];if(null!=t){var e,n,i,u,a=[],f=!0,o=!1;try{if(i=(t=t.call(r)).next,0===l){if(Object(t)!==t)return;f=!1;}else for(;!(f=(e=i.call(t)).done)&&(a.push(e.value),a.length!==l);f=!0);}catch(r){o=!0,n=r;}finally{try{if(!f&&null!=t.return&&(u=t.return(),Object(u)!==u))return;}finally{if(o)throw n;}}return a;}}function _arrayWithHoles(arr){if(Array.isArray(arr))return arr;}function _typeof(o){"@babel/helpers - typeof";return _typeof="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(o){return typeof o;}:function(o){return o&&"function"==typeof Symbol&&o.constructor===Symbol&&o!==Symbol.prototype?"symbol":typeof o;},_typeof(o);}var __defProp=Object.defineProperty;
var __export=function __export(target,all){
for(var name in all)
__defProp(target,name,{
get:all[name],
enumerable:true,
configurable:true,
set:function set(newValue){return all[name]=function(){return newValue;};}
});
};

// lib/locale.js
var exports_locale={};
__export(exports_locale,{
zhTW:function zhTW(){return _zhTW;},
zhHK:function zhHK(){return _zhHK;},
zhCN:function zhCN(){return _zhCN;},
vi:function vi(){return _vi;},
uzCyrl:function uzCyrl(){return _uzCyrl;},
uz:function uz(){return _uz;},
uk:function uk(){return _uk;},
ug:function ug(){return _ug;},
tr:function tr(){return _tr;},
th:function th(){return _th;},
te:function te(){return _te;},
ta:function ta(){return _ta;},
sv:function sv(){return _sv;},
srLatn:function srLatn(){return _srLatn;},
sr:function sr(){return _sr;},
sq:function sq(){return _sq;},
sl:function sl(){return _sl;},
sk:function sk(){return _sk;},
se:function se(){return _se;},
ru:function ru(){return _ru;},
ro:function ro(){return _ro;},
ptBR:function ptBR(){return _ptBR;},
pt:function pt(){return _pt;},
pl:function pl(){return _pl;},
oc:function oc(){return _oc;},
nn:function nn(){return _nn;},
nlBE:function nlBE(){return _nlBE;},
nl:function nl(){return _nl;},
nb:function nb(){return _nb;},
mt:function mt(){return _mt;},
ms:function ms(){return _ms;},
mn:function mn(){return _mn;},
mk:function mk(){return _mk;},
lv:function lv(){return _lv;},
lt:function lt(){return _lt;},
lb:function lb(){return _lb;},
ko:function ko(){return _ko;},
kn:function kn(){return _kn;},
km:function km(){return _km;},
kk:function kk(){return _kk;},
ka:function ka(){return _ka;},
jaHira:function jaHira(){return _jaHira;},
ja:function ja(){return _ja;},
itCH:function itCH(){return _itCH;},
it:function it(){return _it;},
is:function is(){return _is;},
id:function id(){return _id;},
hy:function hy(){return _hy;},
hu:function hu(){return _hu;},
ht:function ht(){return _ht;},
hr:function hr(){return _hr;},
hi:function hi(){return _hi;},
he:function he(){return _he;},
gu:function gu(){return _gu;},
gl:function gl(){return _gl;},
gd:function gd(){return _gd;},
fy:function fy(){return _fy;},
frCH:function frCH(){return _frCH;},
frCA:function frCA(){return _frCA;},
fr:function fr(){return _fr;},
fi:function fi(){return _fi;},
faIR:function faIR(){return _faIR;},
eu:function eu(){return _eu;},
et:function et(){return _et;},
es:function es(){return _es;},
eo:function eo(){return _eo;},
enZA:function enZA(){return _enZA;},
enUS:function enUS(){return _enUS;},
enNZ:function enNZ(){return _enNZ;},
enIN:function enIN(){return _enIN;},
enIE:function enIE(){return _enIE;},
enGB:function enGB(){return _enGB;},
enCA:function enCA(){return _enCA;},
enAU:function enAU(){return _enAU;},
el:function el(){return _el;},
deAT:function deAT(){return _deAT;},
de:function de(){return _de;},
da:function da(){return _da;},
cy:function cy(){return _cy;},
cs:function cs(){return _cs;},
ckb:function ckb(){return _ckb;},
ca:function ca(){return _ca;},
bs:function bs(){return _bs;},
bn:function bn(){return _bn;},
bg:function bg(){return _bg;},
beTarask:function beTarask(){return _beTarask;},
be:function be(){return _be;},
az:function az(){return _az;},
arTN:function arTN(){return _arTN;},
arSA:function arSA(){return _arSA;},
arMA:function arMA(){return _arMA;},
arEG:function arEG(){return _arEG;},
arDZ:function arDZ(){return _arDZ;},
ar:function ar(){return _ar;},
af:function af(){return _af;}
});

// lib/locale/af/_lib/formatDistance.js
var formatDistanceLocale={
lessThanXSeconds:{
one:"minder as 'n sekonde",
other:"minder as {{count}} sekondes"
},
xSeconds:{
one:"1 sekonde",
other:"{{count}} sekondes"
},
halfAMinute:"'n halwe minuut",
lessThanXMinutes:{
one:"minder as 'n minuut",
other:"minder as {{count}} minute"
},
xMinutes:{
one:"'n minuut",
other:"{{count}} minute"
},
aboutXHours:{
one:"ongeveer 1 uur",
other:"ongeveer {{count}} ure"
},
xHours:{
one:"1 uur",
other:"{{count}} ure"
},
xDays:{
one:"1 dag",
other:"{{count}} dae"
},
aboutXWeeks:{
one:"ongeveer 1 week",
other:"ongeveer {{count}} weke"
},
xWeeks:{
one:"1 week",
other:"{{count}} weke"
},
aboutXMonths:{
one:"ongeveer 1 maand",
other:"ongeveer {{count}} maande"
},
xMonths:{
one:"1 maand",
other:"{{count}} maande"
},
aboutXYears:{
one:"ongeveer 1 jaar",
other:"ongeveer {{count}} jaar"
},
xYears:{
one:"1 jaar",
other:"{{count}} jaar"
},
overXYears:{
one:"meer as 1 jaar",
other:"meer as {{count}} jaar"
},
almostXYears:{
one:"byna 1 jaar",
other:"byna {{count}} jaar"
}
};
var formatDistance=function formatDistance(token,count,options){
var result;
var tokenValue=formatDistanceLocale[token];
if(typeof tokenValue==="string"){
result=tokenValue;
}else if(count===1){
result=tokenValue.one;
}else{
result=tokenValue.other.replace("{{count}}",String(count));
}
if(options!==null&&options!==void 0&&options.addSuffix){
if(options.comparison&&options.comparison>0){
return"oor "+result;
}else{
return result+" gelede";
}
}
return result;
};

// lib/locale/_lib/buildFormatLongFn.js
function buildFormatLongFn(args){
return function(){var options=arguments.length>0&&arguments[0]!==undefined?arguments[0]:{};
var width=options.width?String(options.width):args.defaultWidth;
var format=args.formats[width]||args.formats[args.defaultWidth];
return format;
};
}

// lib/locale/af/_lib/formatLong.js
var dateFormats={
full:"EEEE, d MMMM yyyy",
long:"d MMMM yyyy",
medium:"d MMM yyyy",
short:"yyyy/MM/dd"
};
var timeFormats={
full:"HH:mm:ss zzzz",
long:"HH:mm:ss z",
medium:"HH:mm:ss",
short:"HH:mm"
};
var dateTimeFormats={
full:"{{date}} 'om' {{time}}",
long:"{{date}} 'om' {{time}}",
medium:"{{date}}, {{time}}",
short:"{{date}}, {{time}}"
};
var formatLong={
date:buildFormatLongFn({
formats:dateFormats,
defaultWidth:"full"
}),
time:buildFormatLongFn({
formats:timeFormats,
defaultWidth:"full"
}),
dateTime:buildFormatLongFn({
formats:dateTimeFormats,
defaultWidth:"full"
})
};

// lib/locale/af/_lib/formatRelative.js
var formatRelativeLocale={
lastWeek:"'verlede' eeee 'om' p",
yesterday:"'gister om' p",
today:"'vandag om' p",
tomorrow:"'m\xF4re om' p",
nextWeek:"eeee 'om' p",
other:"P"
};
var formatRelative=function formatRelative(token,_date,_baseDate,_options){return formatRelativeLocale[token];};

// lib/locale/_lib/buildLocalizeFn.js
function buildLocalizeFn(args){
return function(value,options){
var context=options!==null&&options!==void 0&&options.context?String(options.context):"standalone";
var valuesArray;
if(context==="formatting"&&args.formattingValues){
var defaultWidth=args.defaultFormattingWidth||args.defaultWidth;
var width=options!==null&&options!==void 0&&options.width?String(options.width):defaultWidth;
valuesArray=args.formattingValues[width]||args.formattingValues[defaultWidth];
}else{
var _defaultWidth=args.defaultWidth;
var _width=options!==null&&options!==void 0&&options.width?String(options.width):args.defaultWidth;
valuesArray=args.values[_width]||args.values[_defaultWidth];
}
var index=args.argumentCallback?args.argumentCallback(value):value;
return valuesArray[index];
};
}

// lib/locale/af/_lib/localize.js
var eraValues={
narrow:["vC","nC"],
abbreviated:["vC","nC"],
wide:["voor Christus","na Christus"]
};
var quarterValues={
narrow:["1","2","3","4"],
abbreviated:["K1","K2","K3","K4"],
wide:["1ste kwartaal","2de kwartaal","3de kwartaal","4de kwartaal"]
};
var monthValues={
narrow:["J","F","M","A","M","J","J","A","S","O","N","D"],
abbreviated:[
"Jan",
"Feb",
"Mrt",
"Apr",
"Mei",
"Jun",
"Jul",
"Aug",
"Sep",
"Okt",
"Nov",
"Des"],

wide:[
"Januarie",
"Februarie",
"Maart",
"April",
"Mei",
"Junie",
"Julie",
"Augustus",
"September",
"Oktober",
"November",
"Desember"]

};
var dayValues={
narrow:["S","M","D","W","D","V","S"],
short:["So","Ma","Di","Wo","Do","Vr","Sa"],
abbreviated:["Son","Maa","Din","Woe","Don","Vry","Sat"],
wide:[
"Sondag",
"Maandag",
"Dinsdag",
"Woensdag",
"Donderdag",
"Vrydag",
"Saterdag"]

};
var dayPeriodValues={
narrow:{
am:"vm",
pm:"nm",
midnight:"middernag",
noon:"middaguur",
morning:"oggend",
afternoon:"middag",
evening:"laat middag",
night:"aand"
},
abbreviated:{
am:"vm",
pm:"nm",
midnight:"middernag",
noon:"middaguur",
morning:"oggend",
afternoon:"middag",
evening:"laat middag",
night:"aand"
},
wide:{
am:"vm",
pm:"nm",
midnight:"middernag",
noon:"middaguur",
morning:"oggend",
afternoon:"middag",
evening:"laat middag",
night:"aand"
}
};
var formattingDayPeriodValues={
narrow:{
am:"vm",
pm:"nm",
midnight:"middernag",
noon:"uur die middag",
morning:"uur die oggend",
afternoon:"uur die middag",
evening:"uur die aand",
night:"uur die aand"
},
abbreviated:{
am:"vm",
pm:"nm",
midnight:"middernag",
noon:"uur die middag",
morning:"uur die oggend",
afternoon:"uur die middag",
evening:"uur die aand",
night:"uur die aand"
},
wide:{
am:"vm",
pm:"nm",
midnight:"middernag",
noon:"uur die middag",
morning:"uur die oggend",
afternoon:"uur die middag",
evening:"uur die aand",
night:"uur die aand"
}
};
var ordinalNumber=function ordinalNumber(dirtyNumber){
var number=Number(dirtyNumber);
var rem100=number%100;
if(rem100<20){
switch(rem100){
case 1:
case 8:
return number+"ste";
default:
return number+"de";
}
}
return number+"ste";
};
var localize={
ordinalNumber:ordinalNumber,
era:buildLocalizeFn({
values:eraValues,
defaultWidth:"wide"
}),
quarter:buildLocalizeFn({
values:quarterValues,
defaultWidth:"wide",
argumentCallback:function argumentCallback(quarter){return quarter-1;}
}),
month:buildLocalizeFn({
values:monthValues,
defaultWidth:"wide"
}),
day:buildLocalizeFn({
values:dayValues,
defaultWidth:"wide"
}),
dayPeriod:buildLocalizeFn({
values:dayPeriodValues,
defaultWidth:"wide",
formattingValues:formattingDayPeriodValues,
defaultFormattingWidth:"wide"
})
};

// lib/locale/_lib/buildMatchFn.js
function buildMatchFn(args){
return function(string){var options=arguments.length>1&&arguments[1]!==undefined?arguments[1]:{};
var width=options.width;
var matchPattern=width&&args.matchPatterns[width]||args.matchPatterns[args.defaultMatchWidth];
var matchResult=string.match(matchPattern);
if(!matchResult){
return null;
}
var matchedString=matchResult[0];
var parsePatterns=width&&args.parsePatterns[width]||args.parsePatterns[args.defaultParseWidth];
var key=Array.isArray(parsePatterns)?findIndex(parsePatterns,function(pattern){return pattern.test(matchedString);}):findKey(parsePatterns,function(pattern){return pattern.test(matchedString);});
var value;
value=args.valueCallback?args.valueCallback(key):key;
value=options.valueCallback?options.valueCallback(value):value;
var rest=string.slice(matchedString.length);
return{value:value,rest:rest};
};
}
function findKey(object,predicate){
for(var key in object){
if(Object.prototype.hasOwnProperty.call(object,key)&&predicate(object[key])){
return key;
}
}
return;
}
function findIndex(array,predicate){
for(var key=0;key<array.length;key++){
if(predicate(array[key])){
return key;
}
}
return;
}

// lib/locale/_lib/buildMatchPatternFn.js
function buildMatchPatternFn(args){
return function(string){var options=arguments.length>1&&arguments[1]!==undefined?arguments[1]:{};
var matchResult=string.match(args.matchPattern);
if(!matchResult)
return null;
var matchedString=matchResult[0];
var parseResult=string.match(args.parsePattern);
if(!parseResult)
return null;
var value=args.valueCallback?args.valueCallback(parseResult[0]):parseResult[0];
value=options.valueCallback?options.valueCallback(value):value;
var rest=string.slice(matchedString.length);
return{value:value,rest:rest};
};
}

// lib/locale/af/_lib/match.js
var matchOrdinalNumberPattern=/^(\d+)(ste|de)?/i;
var parseOrdinalNumberPattern=/\d+/i;
var matchEraPatterns={
narrow:/^([vn]\.? ?C\.?)/,
abbreviated:/^([vn]\. ?C\.?)/,
wide:/^((voor|na) Christus)/
};
var parseEraPatterns={
any:[/^v/,/^n/]
};
var matchQuarterPatterns={
narrow:/^[1234]/i,
abbreviated:/^K[1234]/i,
wide:/^[1234](st|d)e kwartaal/i
};
var parseQuarterPatterns={
any:[/1/i,/2/i,/3/i,/4/i]
};
var matchMonthPatterns={
narrow:/^[jfmasond]/i,
abbreviated:/^(Jan|Feb|Mrt|Apr|Mei|Jun|Jul|Aug|Sep|Okt|Nov|Dec)\.?/i,
wide:/^(Januarie|Februarie|Maart|April|Mei|Junie|Julie|Augustus|September|Oktober|November|Desember)/i
};
var parseMonthPatterns={
narrow:[
/^J/i,
/^F/i,
/^M/i,
/^A/i,
/^M/i,
/^J/i,
/^J/i,
/^A/i,
/^S/i,
/^O/i,
/^N/i,
/^D/i],

any:[
/^Jan/i,
/^Feb/i,
/^Mrt/i,
/^Apr/i,
/^Mei/i,
/^Jun/i,
/^Jul/i,
/^Aug/i,
/^Sep/i,
/^Okt/i,
/^Nov/i,
/^Dec/i]

};
var matchDayPatterns={
narrow:/^[smdwv]/i,
short:/^(So|Ma|Di|Wo|Do|Vr|Sa)/i,
abbreviated:/^(Son|Maa|Din|Woe|Don|Vry|Sat)/i,
wide:/^(Sondag|Maandag|Dinsdag|Woensdag|Donderdag|Vrydag|Saterdag)/i
};
var parseDayPatterns={
narrow:[/^S/i,/^M/i,/^D/i,/^W/i,/^D/i,/^V/i,/^S/i],
any:[/^So/i,/^Ma/i,/^Di/i,/^Wo/i,/^Do/i,/^Vr/i,/^Sa/i]
};
var matchDayPeriodPatterns={
any:/^(vm|nm|middernag|(?:uur )?die (oggend|middag|aand))/i
};
var parseDayPeriodPatterns={
any:{
am:/^vm/i,
pm:/^nm/i,
midnight:/^middernag/i,
noon:/^middaguur/i,
morning:/oggend/i,
afternoon:/middag/i,
evening:/laat middag/i,
night:/aand/i
}
};
var match={
ordinalNumber:buildMatchPatternFn({
matchPattern:matchOrdinalNumberPattern,
parsePattern:parseOrdinalNumberPattern,
valueCallback:function valueCallback(value){return parseInt(value,10);}
}),
era:buildMatchFn({
matchPatterns:matchEraPatterns,
defaultMatchWidth:"wide",
parsePatterns:parseEraPatterns,
defaultParseWidth:"any"
}),
quarter:buildMatchFn({
matchPatterns:matchQuarterPatterns,
defaultMatchWidth:"wide",
parsePatterns:parseQuarterPatterns,
defaultParseWidth:"any",
valueCallback:function valueCallback(index){return index+1;}
}),
month:buildMatchFn({
matchPatterns:matchMonthPatterns,
defaultMatchWidth:"wide",
parsePatterns:parseMonthPatterns,
defaultParseWidth:"any"
}),
day:buildMatchFn({
matchPatterns:matchDayPatterns,
defaultMatchWidth:"wide",
parsePatterns:parseDayPatterns,
defaultParseWidth:"any"
}),
dayPeriod:buildMatchFn({
matchPatterns:matchDayPeriodPatterns,
defaultMatchWidth:"any",
parsePatterns:parseDayPeriodPatterns,
defaultParseWidth:"any"
})
};

// lib/locale/af.js
var _af={
code:"af",
formatDistance:formatDistance,
formatLong:formatLong,
formatRelative:formatRelative,
localize:localize,
match:match,
options:{
weekStartsOn:0,
firstWeekContainsDate:1
}
};
// lib/locale/ar/_lib/formatDistance.js
var formatDistanceLocale2={
lessThanXSeconds:{
one:"\u0623\u0642\u0644 \u0645\u0646 \u062B\u0627\u0646\u064A\u0629",
two:"\u0623\u0642\u0644 \u0645\u0646 \u062B\u0627\u0646\u064A\u062A\u064A\u0646",
threeToTen:"\u0623\u0642\u0644 \u0645\u0646 {{count}} \u062B\u0648\u0627\u0646\u064A",
other:"\u0623\u0642\u0644 \u0645\u0646 {{count}} \u062B\u0627\u0646\u064A\u0629"
},
xSeconds:{
one:"\u062B\u0627\u0646\u064A\u0629 \u0648\u0627\u062D\u062F\u0629",
two:"\u062B\u0627\u0646\u064A\u062A\u0627\u0646",
threeToTen:"{{count}} \u062B\u0648\u0627\u0646\u064A",
other:"{{count}} \u062B\u0627\u0646\u064A\u0629"
},
halfAMinute:"\u0646\u0635\u0641 \u062F\u0642\u064A\u0642\u0629",
lessThanXMinutes:{
one:"\u0623\u0642\u0644 \u0645\u0646 \u062F\u0642\u064A\u0642\u0629",
two:"\u0623\u0642\u0644 \u0645\u0646 \u062F\u0642\u064A\u0642\u062A\u064A\u0646",
threeToTen:"\u0623\u0642\u0644 \u0645\u0646 {{count}} \u062F\u0642\u0627\u0626\u0642",
other:"\u0623\u0642\u0644 \u0645\u0646 {{count}} \u062F\u0642\u064A\u0642\u0629"
},
xMinutes:{
one:"\u062F\u0642\u064A\u0642\u0629 \u0648\u0627\u062D\u062F\u0629",
two:"\u062F\u0642\u064A\u0642\u062A\u0627\u0646",
threeToTen:"{{count}} \u062F\u0642\u0627\u0626\u0642",
other:"{{count}} \u062F\u0642\u064A\u0642\u0629"
},
aboutXHours:{
one:"\u0633\u0627\u0639\u0629 \u0648\u0627\u062D\u062F\u0629 \u062A\u0642\u0631\u064A\u0628\u0627\u064B",
two:"\u0633\u0627\u0639\u062A\u064A\u0646 \u062A\u0642\u0631\u064A\u0628\u0627",
threeToTen:"{{count}} \u0633\u0627\u0639\u0627\u062A \u062A\u0642\u0631\u064A\u0628\u0627\u064B",
other:"{{count}} \u0633\u0627\u0639\u0629 \u062A\u0642\u0631\u064A\u0628\u0627\u064B"
},
xHours:{
one:"\u0633\u0627\u0639\u0629 \u0648\u0627\u062D\u062F\u0629",
two:"\u0633\u0627\u0639\u062A\u0627\u0646",
threeToTen:"{{count}} \u0633\u0627\u0639\u0627\u062A",
other:"{{count}} \u0633\u0627\u0639\u0629"
},
xDays:{
one:"\u064A\u0648\u0645 \u0648\u0627\u062D\u062F",
two:"\u064A\u0648\u0645\u0627\u0646",
threeToTen:"{{count}} \u0623\u064A\u0627\u0645",
other:"{{count}} \u064A\u0648\u0645"
},
aboutXWeeks:{
one:"\u0623\u0633\u0628\u0648\u0639 \u0648\u0627\u062D\u062F \u062A\u0642\u0631\u064A\u0628\u0627",
two:"\u0623\u0633\u0628\u0648\u0639\u064A\u0646 \u062A\u0642\u0631\u064A\u0628\u0627",
threeToTen:"{{count}} \u0623\u0633\u0627\u0628\u064A\u0639 \u062A\u0642\u0631\u064A\u0628\u0627",
other:"{{count}} \u0623\u0633\u0628\u0648\u0639\u0627 \u062A\u0642\u0631\u064A\u0628\u0627"
},
xWeeks:{
one:"\u0623\u0633\u0628\u0648\u0639 \u0648\u0627\u062D\u062F",
two:"\u0623\u0633\u0628\u0648\u0639\u0627\u0646",
threeToTen:"{{count}} \u0623\u0633\u0627\u0628\u064A\u0639",
other:"{{count}} \u0623\u0633\u0628\u0648\u0639\u0627"
},
aboutXMonths:{
one:"\u0634\u0647\u0631 \u0648\u0627\u062D\u062F \u062A\u0642\u0631\u064A\u0628\u0627\u064B",
two:"\u0634\u0647\u0631\u064A\u0646 \u062A\u0642\u0631\u064A\u0628\u0627",
threeToTen:"{{count}} \u0623\u0634\u0647\u0631 \u062A\u0642\u0631\u064A\u0628\u0627",
other:"{{count}} \u0634\u0647\u0631\u0627 \u062A\u0642\u0631\u064A\u0628\u0627\u064B"
},
xMonths:{
one:"\u0634\u0647\u0631 \u0648\u0627\u062D\u062F",
two:"\u0634\u0647\u0631\u0627\u0646",
threeToTen:"{{count}} \u0623\u0634\u0647\u0631",
other:"{{count}} \u0634\u0647\u0631\u0627"
},
aboutXYears:{
one:"\u0633\u0646\u0629 \u0648\u0627\u062D\u062F\u0629 \u062A\u0642\u0631\u064A\u0628\u0627\u064B",
two:"\u0633\u0646\u062A\u064A\u0646 \u062A\u0642\u0631\u064A\u0628\u0627",
threeToTen:"{{count}} \u0633\u0646\u0648\u0627\u062A \u062A\u0642\u0631\u064A\u0628\u0627\u064B",
other:"{{count}} \u0633\u0646\u0629 \u062A\u0642\u0631\u064A\u0628\u0627\u064B"
},
xYears:{
one:"\u0633\u0646\u0629 \u0648\u0627\u062D\u062F",
two:"\u0633\u0646\u062A\u0627\u0646",
threeToTen:"{{count}} \u0633\u0646\u0648\u0627\u062A",
other:"{{count}} \u0633\u0646\u0629"
},
overXYears:{
one:"\u0623\u0643\u062B\u0631 \u0645\u0646 \u0633\u0646\u0629",
two:"\u0623\u0643\u062B\u0631 \u0645\u0646 \u0633\u0646\u062A\u064A\u0646",
threeToTen:"\u0623\u0643\u062B\u0631 \u0645\u0646 {{count}} \u0633\u0646\u0648\u0627\u062A",
other:"\u0623\u0643\u062B\u0631 \u0645\u0646 {{count}} \u0633\u0646\u0629"
},
almostXYears:{
one:"\u0645\u0627 \u064A\u0642\u0627\u0631\u0628 \u0633\u0646\u0629 \u0648\u0627\u062D\u062F\u0629",
two:"\u0645\u0627 \u064A\u0642\u0627\u0631\u0628 \u0633\u0646\u062A\u064A\u0646",
threeToTen:"\u0645\u0627 \u064A\u0642\u0627\u0631\u0628 {{count}} \u0633\u0646\u0648\u0627\u062A",
other:"\u0645\u0627 \u064A\u0642\u0627\u0631\u0628 {{count}} \u0633\u0646\u0629"
}
};
var formatDistance3=function formatDistance3(token,count,options){
var usageGroup=formatDistanceLocale2[token];
var result;
if(typeof usageGroup==="string"){
result=usageGroup;
}else if(count===1){
result=usageGroup.one;
}else if(count===2){
result=usageGroup.two;
}else if(count<=10){
result=usageGroup.threeToTen.replace("{{count}}",String(count));
}else{
result=usageGroup.other.replace("{{count}}",String(count));
}
if(options!==null&&options!==void 0&&options.addSuffix){
if(options.comparison&&options.comparison>0){
return"\u062E\u0644\u0627\u0644 "+result;
}else{
return"\u0645\u0646\u0630 "+result;
}
}
return result;
};

// lib/locale/ar/_lib/formatLong.js
var dateFormats2={
full:"EEEE\u060C do MMMM y",
long:"do MMMM y",
medium:"d MMM y",
short:"dd/MM/yyyy"
};
var timeFormats2={
full:"HH:mm:ss",
long:"HH:mm:ss",
medium:"HH:mm:ss",
short:"HH:mm"
};
var dateTimeFormats2={
full:"{{date}} '\u0639\u0646\u062F \u0627\u0644\u0633\u0627\u0639\u0629' {{time}}",
long:"{{date}} '\u0639\u0646\u062F \u0627\u0644\u0633\u0627\u0639\u0629' {{time}}",
medium:"{{date}}, {{time}}",
short:"{{date}}, {{time}}"
};
var formatLong3={
date:buildFormatLongFn({
formats:dateFormats2,
defaultWidth:"full"
}),
time:buildFormatLongFn({
formats:timeFormats2,
defaultWidth:"full"
}),
dateTime:buildFormatLongFn({
formats:dateTimeFormats2,
defaultWidth:"full"
})
};

// lib/locale/ar/_lib/formatRelative.js
var formatRelativeLocale2={
lastWeek:"eeee '\u0627\u0644\u0645\u0627\u0636\u064A \u0639\u0646\u062F \u0627\u0644\u0633\u0627\u0639\u0629' p",
yesterday:"'\u0627\u0644\u0623\u0645\u0633 \u0639\u0646\u062F \u0627\u0644\u0633\u0627\u0639\u0629' p",
today:"'\u0627\u0644\u064A\u0648\u0645 \u0639\u0646\u062F \u0627\u0644\u0633\u0627\u0639\u0629' p",
tomorrow:"'\u063A\u062F\u0627 \u0639\u0646\u062F \u0627\u0644\u0633\u0627\u0639\u0629' p",
nextWeek:"eeee '\u0627\u0644\u0642\u0627\u062F\u0645 \u0639\u0646\u062F \u0627\u0644\u0633\u0627\u0639\u0629' p",
other:"P"
};
var formatRelative3=function formatRelative3(token){return formatRelativeLocale2[token];};

// lib/locale/ar/_lib/localize.js
var eraValues2={
narrow:["\u0642","\u0628"],
abbreviated:["\u0642.\u0645.","\u0628.\u0645."],
wide:["\u0642\u0628\u0644 \u0627\u0644\u0645\u064A\u0644\u0627\u062F","\u0628\u0639\u062F \u0627\u0644\u0645\u064A\u0644\u0627\u062F"]
};
var quarterValues2={
narrow:["1","2","3","4"],
abbreviated:["\u06311","\u06312","\u06313","\u06314"],
wide:["\u0627\u0644\u0631\u0628\u0639 \u0627\u0644\u0623\u0648\u0644","\u0627\u0644\u0631\u0628\u0639 \u0627\u0644\u062B\u0627\u0646\u064A","\u0627\u0644\u0631\u0628\u0639 \u0627\u0644\u062B\u0627\u0644\u062B","\u0627\u0644\u0631\u0628\u0639 \u0627\u0644\u0631\u0627\u0628\u0639"]
};
var monthValues2={
narrow:["\u064A","\u0641","\u0645","\u0623","\u0645","\u064A","\u064A","\u0623","\u0633","\u0623","\u0646","\u062F"],
abbreviated:[
"\u064A\u0646\u0627\u064A\u0631",
"\u0641\u0628\u0631\u0627\u064A\u0631",
"\u0645\u0627\u0631\u0633",
"\u0623\u0628\u0631\u064A\u0644",
"\u0645\u0627\u064A\u0648",
"\u064A\u0648\u0646\u064A\u0648",
"\u064A\u0648\u0644\u064A\u0648",
"\u0623\u063A\u0633\u0637\u0633",
"\u0633\u0628\u062A\u0645\u0628\u0631",
"\u0623\u0643\u062A\u0648\u0628\u0631",
"\u0646\u0648\u0641\u0645\u0628\u0631",
"\u062F\u064A\u0633\u0645\u0628\u0631"],

wide:[
"\u064A\u0646\u0627\u064A\u0631",
"\u0641\u0628\u0631\u0627\u064A\u0631",
"\u0645\u0627\u0631\u0633",
"\u0623\u0628\u0631\u064A\u0644",
"\u0645\u0627\u064A\u0648",
"\u064A\u0648\u0646\u064A\u0648",
"\u064A\u0648\u0644\u064A\u0648",
"\u0623\u063A\u0633\u0637\u0633",
"\u0633\u0628\u062A\u0645\u0628\u0631",
"\u0623\u0643\u062A\u0648\u0628\u0631",
"\u0646\u0648\u0641\u0645\u0628\u0631",
"\u062F\u064A\u0633\u0645\u0628\u0631"]

};
var dayValues2={
narrow:["\u062D","\u0646","\u062B","\u0631","\u062E","\u062C","\u0633"],
short:["\u0623\u062D\u062F","\u0627\u062B\u0646\u064A\u0646","\u062B\u0644\u0627\u062B\u0627\u0621","\u0623\u0631\u0628\u0639\u0627\u0621","\u062E\u0645\u064A\u0633","\u062C\u0645\u0639\u0629","\u0633\u0628\u062A"],
abbreviated:["\u0623\u062D\u062F","\u0627\u062B\u0646\u064A\u0646","\u062B\u0644\u0627\u062B\u0627\u0621","\u0623\u0631\u0628\u0639\u0627\u0621","\u062E\u0645\u064A\u0633","\u062C\u0645\u0639\u0629","\u0633\u0628\u062A"],
wide:[
"\u0627\u0644\u0623\u062D\u062F",
"\u0627\u0644\u0627\u062B\u0646\u064A\u0646",
"\u0627\u0644\u062B\u0644\u0627\u062B\u0627\u0621",
"\u0627\u0644\u0623\u0631\u0628\u0639\u0627\u0621",
"\u0627\u0644\u062E\u0645\u064A\u0633",
"\u0627\u0644\u062C\u0645\u0639\u0629",
"\u0627\u0644\u0633\u0628\u062A"]

};
var dayPeriodValues2={
narrow:{
am:"\u0635",
pm:"\u0645",
morning:"\u0627\u0644\u0635\u0628\u0627\u062D",
noon:"\u0627\u0644\u0638\u0647\u0631",
afternoon:"\u0628\u0639\u062F \u0627\u0644\u0638\u0647\u0631",
evening:"\u0627\u0644\u0645\u0633\u0627\u0621",
night:"\u0627\u0644\u0644\u064A\u0644",
midnight:"\u0645\u0646\u062A\u0635\u0641 \u0627\u0644\u0644\u064A\u0644"
},
abbreviated:{
am:"\u0635",
pm:"\u0645",
morning:"\u0627\u0644\u0635\u0628\u0627\u062D",
noon:"\u0627\u0644\u0638\u0647\u0631",
afternoon:"\u0628\u0639\u062F \u0627\u0644\u0638\u0647\u0631",
evening:"\u0627\u0644\u0645\u0633\u0627\u0621",
night:"\u0627\u0644\u0644\u064A\u0644",
midnight:"\u0645\u0646\u062A\u0635\u0641 \u0627\u0644\u0644\u064A\u0644"
},
wide:{
am:"\u0635",
pm:"\u0645",
morning:"\u0627\u0644\u0635\u0628\u0627\u062D",
noon:"\u0627\u0644\u0638\u0647\u0631",
afternoon:"\u0628\u0639\u062F \u0627\u0644\u0638\u0647\u0631",
evening:"\u0627\u0644\u0645\u0633\u0627\u0621",
night:"\u0627\u0644\u0644\u064A\u0644",
midnight:"\u0645\u0646\u062A\u0635\u0641 \u0627\u0644\u0644\u064A\u0644"
}
};
var formattingDayPeriodValues2={
narrow:{
am:"\u0635",
pm:"\u0645",
morning:"\u0641\u064A \u0627\u0644\u0635\u0628\u0627\u062D",
noon:"\u0627\u0644\u0638\u0647\u0631",
afternoon:"\u0628\u0639\u062F \u0627\u0644\u0638\u0647\u0631",
evening:"\u0641\u064A \u0627\u0644\u0645\u0633\u0627\u0621",
night:"\u0641\u064A \u0627\u0644\u0644\u064A\u0644",
midnight:"\u0645\u0646\u062A\u0635\u0641 \u0627\u0644\u0644\u064A\u0644"
},
abbreviated:{
am:"\u0635",
pm:"\u0645",
morning:"\u0641\u064A \u0627\u0644\u0635\u0628\u0627\u062D",
noon:"\u0627\u0644\u0638\u0647\u0631",
afternoon:"\u0628\u0639\u062F \u0627\u0644\u0638\u0647\u0631",
evening:"\u0641\u064A \u0627\u0644\u0645\u0633\u0627\u0621",
night:"\u0641\u064A \u0627\u0644\u0644\u064A\u0644",
midnight:"\u0645\u0646\u062A\u0635\u0641 \u0627\u0644\u0644\u064A\u0644"
},
wide:{
am:"\u0635",
pm:"\u0645",
morning:"\u0641\u064A \u0627\u0644\u0635\u0628\u0627\u062D",
noon:"\u0627\u0644\u0638\u0647\u0631",
afternoon:"\u0628\u0639\u062F \u0627\u0644\u0638\u0647\u0631",
evening:"\u0641\u064A \u0627\u0644\u0645\u0633\u0627\u0621",
night:"\u0641\u064A \u0627\u0644\u0644\u064A\u0644",
midnight:"\u0645\u0646\u062A\u0635\u0641 \u0627\u0644\u0644\u064A\u0644"
}
};
var ordinalNumber2=function ordinalNumber2(num){return String(num);};
var localize3={
ordinalNumber:ordinalNumber2,
era:buildLocalizeFn({
values:eraValues2,
defaultWidth:"wide"
}),
quarter:buildLocalizeFn({
values:quarterValues2,
defaultWidth:"wide",
argumentCallback:function argumentCallback(quarter){return quarter-1;}
}),
month:buildLocalizeFn({
values:monthValues2,
defaultWidth:"wide"
}),
day:buildLocalizeFn({
values:dayValues2,
defaultWidth:"wide"
}),
dayPeriod:buildLocalizeFn({
values:dayPeriodValues2,
defaultWidth:"wide",
formattingValues:formattingDayPeriodValues2,
defaultFormattingWidth:"wide"
})
};

// lib/locale/ar/_lib/match.js
var matchOrdinalNumberPattern2=/^(\d+)(th|st|nd|rd)?/i;
var parseOrdinalNumberPattern2=/\d+/i;
var matchEraPatterns2={
narrow:/[قب]/,
abbreviated:/[قب]\.م\./,
wide:/(قبل|بعد) الميلاد/
};
var parseEraPatterns2={
any:[/قبل/,/بعد/]
};
var matchQuarterPatterns2={
narrow:/^[1234]/i,
abbreviated:/ر[1234]/,
wide:/الربع (الأول|الثاني|الثالث|الرابع)/
};
var parseQuarterPatterns2={
any:[/1/i,/2/i,/3/i,/4/i]
};
var matchMonthPatterns2={
narrow:/^[أيفمسند]/,
abbreviated:/^(يناير|فبراير|مارس|أبريل|مايو|يونيو|يوليو|أغسطس|سبتمبر|أكتوبر|نوفمبر|ديسمبر)/,
wide:/^(يناير|فبراير|مارس|أبريل|مايو|يونيو|يوليو|أغسطس|سبتمبر|أكتوبر|نوفمبر|ديسمبر)/
};
var parseMonthPatterns2={
narrow:[
/^ي/i,
/^ف/i,
/^م/i,
/^أ/i,
/^م/i,
/^ي/i,
/^ي/i,
/^أ/i,
/^س/i,
/^أ/i,
/^ن/i,
/^د/i],

any:[
/^يناير/i,
/^فبراير/i,
/^مارس/i,
/^أبريل/i,
/^مايو/i,
/^يونيو/i,
/^يوليو/i,
/^أغسطس/i,
/^سبتمبر/i,
/^أكتوبر/i,
/^نوفمبر/i,
/^ديسمبر/i]

};
var matchDayPatterns2={
narrow:/^[حنثرخجس]/i,
short:/^(أحد|اثنين|ثلاثاء|أربعاء|خميس|جمعة|سبت)/i,
abbreviated:/^(أحد|اثنين|ثلاثاء|أربعاء|خميس|جمعة|سبت)/i,
wide:/^(الأحد|الاثنين|الثلاثاء|الأربعاء|الخميس|الجمعة|السبت)/i
};
var parseDayPatterns2={
narrow:[/^ح/i,/^ن/i,/^ث/i,/^ر/i,/^خ/i,/^ج/i,/^س/i],
wide:[
/^الأحد/i,
/^الاثنين/i,
/^الثلاثاء/i,
/^الأربعاء/i,
/^الخميس/i,
/^الجمعة/i,
/^السبت/i],

any:[/^أح/i,/^اث/i,/^ث/i,/^أر/i,/^خ/i,/^ج/i,/^س/i]
};
var matchDayPeriodPatterns2={
narrow:/^(ص|م|منتصف الليل|الظهر|بعد الظهر|في الصباح|في المساء|في الليل)/,
any:/^(ص|م|منتصف الليل|الظهر|بعد الظهر|في الصباح|في المساء|في الليل)/
};
var parseDayPeriodPatterns2={
any:{
am:/^ص/,
pm:/^م/,
midnight:/منتصف الليل/,
noon:/الظهر/,
afternoon:/بعد الظهر/,
morning:/في الصباح/,
evening:/في المساء/,
night:/في الليل/
}
};
var match3={
ordinalNumber:buildMatchPatternFn({
matchPattern:matchOrdinalNumberPattern2,
parsePattern:parseOrdinalNumberPattern2,
valueCallback:function valueCallback(value){return parseInt(value,10);}
}),
era:buildMatchFn({
matchPatterns:matchEraPatterns2,
defaultMatchWidth:"wide",
parsePatterns:parseEraPatterns2,
defaultParseWidth:"any"
}),
quarter:buildMatchFn({
matchPatterns:matchQuarterPatterns2,
defaultMatchWidth:"wide",
parsePatterns:parseQuarterPatterns2,
defaultParseWidth:"any",
valueCallback:function valueCallback(index){return index+1;}
}),
month:buildMatchFn({
matchPatterns:matchMonthPatterns2,
defaultMatchWidth:"wide",
parsePatterns:parseMonthPatterns2,
defaultParseWidth:"any"
}),
day:buildMatchFn({
matchPatterns:matchDayPatterns2,
defaultMatchWidth:"wide",
parsePatterns:parseDayPatterns2,
defaultParseWidth:"any"
}),
dayPeriod:buildMatchFn({
matchPatterns:matchDayPeriodPatterns2,
defaultMatchWidth:"any",
parsePatterns:parseDayPeriodPatterns2,
defaultParseWidth:"any"
})
};

// lib/locale/ar.js
var _ar={
code:"ar",
formatDistance:formatDistance3,
formatLong:formatLong3,
formatRelative:formatRelative3,
localize:localize3,
match:match3,
options:{
weekStartsOn:6,
firstWeekContainsDate:1
}
};
// lib/locale/ar-DZ/_lib/formatDistance.js
var formatDistanceLocale3={
lessThanXSeconds:{
one:"\u0623\u0642\u0644 \u0645\u0646 \u062B\u0627\u0646\u064A\u0629 \u0648\u0627\u062D\u062F\u0629",
two:"\u0623\u0642\u0644 \u0645\u0646 \u062B\u0627\u0646\u062A\u064A\u0646",
threeToTen:"\u0623\u0642\u0644 \u0645\u0646 {{count}} \u062B\u0648\u0627\u0646\u064A",
other:"\u0623\u0642\u0644 \u0645\u0646 {{count}} \u062B\u0627\u0646\u064A\u0629"
},
xSeconds:{
one:"\u062B\u0627\u0646\u064A\u0629 \u0648\u0627\u062D\u062F\u0629",
two:"\u062B\u0627\u0646\u062A\u064A\u0646",
threeToTen:"{{count}} \u062B\u0648\u0627\u0646\u064A",
other:"{{count}} \u062B\u0627\u0646\u064A\u0629"
},
halfAMinute:"\u0646\u0635\u0641 \u062F\u0642\u064A\u0642\u0629",
lessThanXMinutes:{
one:"\u0623\u0642\u0644 \u0645\u0646 \u062F\u0642\u064A\u0642\u0629",
two:"\u0623\u0642\u0644 \u0645\u0646 \u062F\u0642\u064A\u0642\u062A\u064A\u0646",
threeToTen:"\u0623\u0642\u0644 \u0645\u0646 {{count}} \u062F\u0642\u0627\u0626\u0642",
other:"\u0623\u0642\u0644 \u0645\u0646 {{count}} \u062F\u0642\u064A\u0642\u0629"
},
xMinutes:{
one:"\u062F\u0642\u064A\u0642\u0629 \u0648\u0627\u062D\u062F\u0629",
two:"\u062F\u0642\u064A\u0642\u062A\u064A\u0646",
threeToTen:"{{count}} \u062F\u0642\u0627\u0626\u0642",
other:"{{count}} \u062F\u0642\u064A\u0642\u0629"
},
aboutXHours:{
one:"\u0633\u0627\u0639\u0629 \u0648\u0627\u062D\u062F\u0629 \u062A\u0642\u0631\u064A\u0628\u0627\u064B",
two:"\u0633\u0627\u0639\u062A\u064A\u0646 \u062A\u0642\u0631\u064A\u0628\u0627\u064B",
threeToTen:"{{count}} \u0633\u0627\u0639\u0627\u062A \u062A\u0642\u0631\u064A\u0628\u0627\u064B",
other:"{{count}} \u0633\u0627\u0639\u0629 \u062A\u0642\u0631\u064A\u0628\u0627\u064B"
},
xHours:{
one:"\u0633\u0627\u0639\u0629 \u0648\u0627\u062D\u062F\u0629",
two:"\u0633\u0627\u0639\u062A\u064A\u0646",
threeToTen:"{{count}} \u0633\u0627\u0639\u0627\u062A",
other:"{{count}} \u0633\u0627\u0639\u0629"
},
xDays:{
one:"\u064A\u0648\u0645 \u0648\u0627\u062D\u062F",
two:"\u064A\u0648\u0645\u064A\u0646",
threeToTen:"{{count}} \u0623\u064A\u0627\u0645",
other:"{{count}} \u064A\u0648\u0645"
},
aboutXWeeks:{
one:"\u0623\u0633\u0628\u0648\u0639 \u0648\u0627\u062D\u062F \u062A\u0642\u0631\u064A\u0628\u0627\u064B",
two:"\u0623\u0633\u0628\u0648\u0639\u064A\u0646 \u062A\u0642\u0631\u064A\u0628\u0627\u064B",
threeToTen:"{{count}} \u0623\u0633\u0627\u0628\u064A\u0639 \u062A\u0642\u0631\u064A\u0628\u0627\u064B",
other:"{{count}} \u0623\u0633\u0628\u0648\u0639 \u062A\u0642\u0631\u064A\u0628\u0627\u064B"
},
xWeeks:{
one:"\u0623\u0633\u0628\u0648\u0639 \u0648\u0627\u062D\u062F",
two:"\u0623\u0633\u0628\u0648\u0639\u064A\u0646",
threeToTen:"{{count}} \u0623\u0633\u0627\u0628\u064A\u0639",
other:"{{count}} \u0623\u0633\u0628\u0648\u0639"
},
aboutXMonths:{
one:"\u0634\u0647\u0631 \u0648\u0627\u062D\u062F \u062A\u0642\u0631\u064A\u0628\u0627\u064B",
two:"\u0634\u0647\u0631\u064A\u0646 \u062A\u0642\u0631\u064A\u0628\u0627\u064B",
threeToTen:"{{count}} \u0623\u0634\u0647\u0631 \u062A\u0642\u0631\u064A\u0628\u0627\u064B",
other:"{{count}} \u0634\u0647\u0631 \u062A\u0642\u0631\u064A\u0628\u0627\u064B"
},
xMonths:{
one:"\u0634\u0647\u0631 \u0648\u0627\u062D\u062F",
two:"\u0634\u0647\u0631\u064A\u0646",
threeToTen:"{{count}} \u0623\u0634\u0647\u0631",
other:"{{count}} \u0634\u0647\u0631"
},
aboutXYears:{
one:"\u0639\u0627\u0645 \u0648\u0627\u062D\u062F \u062A\u0642\u0631\u064A\u0628\u0627\u064B",
two:"\u0639\u0627\u0645\u064A\u0646 \u062A\u0642\u0631\u064A\u0628\u0627\u064B",
threeToTen:"{{count}} \u0623\u0639\u0648\u0627\u0645 \u062A\u0642\u0631\u064A\u0628\u0627\u064B",
other:"{{count}} \u0639\u0627\u0645 \u062A\u0642\u0631\u064A\u0628\u0627\u064B"
},
xYears:{
one:"\u0639\u0627\u0645 \u0648\u0627\u062D\u062F",
two:"\u0639\u0627\u0645\u064A\u0646",
threeToTen:"{{count}} \u0623\u0639\u0648\u0627\u0645",
other:"{{count}} \u0639\u0627\u0645"
},
overXYears:{
one:"\u0623\u0643\u062B\u0631 \u0645\u0646 \u0639\u0627\u0645",
two:"\u0623\u0643\u062B\u0631 \u0645\u0646 \u0639\u0627\u0645\u064A\u0646",
threeToTen:"\u0623\u0643\u062B\u0631 \u0645\u0646 {{count}} \u0623\u0639\u0648\u0627\u0645",
other:"\u0623\u0643\u062B\u0631 \u0645\u0646 {{count}} \u0639\u0627\u0645"
},
almostXYears:{
one:"\u0639\u0627\u0645 \u0648\u0627\u062D\u062F \u062A\u0642\u0631\u064A\u0628\u0627\u064B",
two:"\u0639\u0627\u0645\u064A\u0646 \u062A\u0642\u0631\u064A\u0628\u0627\u064B",
threeToTen:"{{count}} \u0623\u0639\u0648\u0627\u0645 \u062A\u0642\u0631\u064A\u0628\u0627\u064B",
other:"{{count}} \u0639\u0627\u0645 \u062A\u0642\u0631\u064A\u0628\u0627\u064B"
}
};
var formatDistance5=function formatDistance5(token,count,options){
options=options||{};
var usageGroup=formatDistanceLocale3[token];
var result;
if(typeof usageGroup==="string"){
result=usageGroup;
}else if(count===1){
result=usageGroup.one;
}else if(count===2){
result=usageGroup.two;
}else if(count<=10){
result=usageGroup.threeToTen.replace("{{count}}",String(count));
}else{
result=usageGroup.other.replace("{{count}}",String(count));
}
if(options.addSuffix){
if(options.comparison&&options.comparison>0){
return"\u0641\u064A \u062E\u0644\u0627\u0644 "+result;
}else{
return"\u0645\u0646\u0630 "+result;
}
}
return result;
};

// lib/locale/ar-DZ/_lib/formatLong.js
var dateFormats3={
full:"EEEE, MMMM do, y",
long:"MMMM do, y",
medium:"MMM d, y",
short:"MM/dd/yyyy"
};
var timeFormats3={
full:"h:mm:ss a zzzz",
long:"h:mm:ss a z",
medium:"h:mm:ss a",
short:"h:mm a"
};
var dateTimeFormats3={
full:"{{date}} '\u0639\u0646\u062F' {{time}}",
long:"{{date}} '\u0639\u0646\u062F' {{time}}",
medium:"{{date}}, {{time}}",
short:"{{date}}, {{time}}"
};
var formatLong5={
date:buildFormatLongFn({
formats:dateFormats3,
defaultWidth:"full"
}),
time:buildFormatLongFn({
formats:timeFormats3,
defaultWidth:"full"
}),
dateTime:buildFormatLongFn({
formats:dateTimeFormats3,
defaultWidth:"full"
})
};

// lib/locale/ar-DZ/_lib/formatRelative.js
var formatRelativeLocale3={
lastWeek:"'\u0623\u062E\u0631' eeee '\u0639\u0646\u062F' p",
yesterday:"'\u0623\u0645\u0633 \u0639\u0646\u062F' p",
today:"'\u0627\u0644\u064A\u0648\u0645 \u0639\u0646\u062F' p",
tomorrow:"'\u063A\u062F\u0627\u064B \u0639\u0646\u062F' p",
nextWeek:"eeee '\u0639\u0646\u062F' p",
other:"P"
};
var formatRelative5=function formatRelative5(token,_date,_baseDate,_options){
return formatRelativeLocale3[token];
};

// lib/locale/ar-DZ/_lib/localize.js
var eraValues3={
narrow:["\u0642","\u0628"],
abbreviated:["\u0642.\u0645.","\u0628.\u0645."],
wide:["\u0642\u0628\u0644 \u0627\u0644\u0645\u064A\u0644\u0627\u062F","\u0628\u0639\u062F \u0627\u0644\u0645\u064A\u0644\u0627\u062F"]
};
var quarterValues3={
narrow:["1","2","3","4"],
abbreviated:["\u06311","\u06312","\u06313","\u06314"],
wide:["\u0627\u0644\u0631\u0628\u0639 \u0627\u0644\u0623\u0648\u0644","\u0627\u0644\u0631\u0628\u0639 \u0627\u0644\u062B\u0627\u0646\u064A","\u0627\u0644\u0631\u0628\u0639 \u0627\u0644\u062B\u0627\u0644\u062B","\u0627\u0644\u0631\u0628\u0639 \u0627\u0644\u0631\u0627\u0628\u0639"]
};
var monthValues3={
narrow:["\u062C","\u0641","\u0645","\u0623","\u0645","\u062C","\u062C","\u0623","\u0633","\u0623","\u0646","\u062F"],
abbreviated:[
"\u062C\u0627\u0646\u0640",
"\u0641\u064A\u0641\u0640",
"\u0645\u0627\u0631\u0633",
"\u0623\u0641\u0631\u064A\u0644",
"\u0645\u0627\u064A\u0640",
"\u062C\u0648\u0627\u0646\u0640",
"\u062C\u0648\u064A\u0640",
"\u0623\u0648\u062A",
"\u0633\u0628\u062A\u0640",
"\u0623\u0643\u062A\u0640",
"\u0646\u0648\u0641\u0640",
"\u062F\u064A\u0633\u0640"],

wide:[
"\u062C\u0627\u0646\u0641\u064A",
"\u0641\u064A\u0641\u0631\u064A",
"\u0645\u0627\u0631\u0633",
"\u0623\u0641\u0631\u064A\u0644",
"\u0645\u0627\u064A",
"\u062C\u0648\u0627\u0646",
"\u062C\u0648\u064A\u0644\u064A\u0629",
"\u0623\u0648\u062A",
"\u0633\u0628\u062A\u0645\u0628\u0631",
"\u0623\u0643\u062A\u0648\u0628\u0631",
"\u0646\u0648\u0641\u0645\u0628\u0631",
"\u062F\u064A\u0633\u0645\u0628\u0631"]

};
var dayValues3={
narrow:["\u062D","\u0646","\u062B","\u0631","\u062E","\u062C","\u0633"],
short:["\u0623\u062D\u062F","\u0627\u062B\u0646\u064A\u0646","\u062B\u0644\u0627\u062B\u0627\u0621","\u0623\u0631\u0628\u0639\u0627\u0621","\u062E\u0645\u064A\u0633","\u062C\u0645\u0639\u0629","\u0633\u0628\u062A"],
abbreviated:["\u0623\u062D\u062F","\u0627\u062B\u0646\u0640","\u062B\u0644\u0627","\u0623\u0631\u0628\u0640","\u062E\u0645\u064A\u0640","\u062C\u0645\u0639\u0629","\u0633\u0628\u062A"],
wide:[
"\u0627\u0644\u0623\u062D\u062F",
"\u0627\u0644\u0627\u062B\u0646\u064A\u0646",
"\u0627\u0644\u062B\u0644\u0627\u062B\u0627\u0621",
"\u0627\u0644\u0623\u0631\u0628\u0639\u0627\u0621",
"\u0627\u0644\u062E\u0645\u064A\u0633",
"\u0627\u0644\u062C\u0645\u0639\u0629",
"\u0627\u0644\u0633\u0628\u062A"]

};
var dayPeriodValues3={
narrow:{
am:"\u0635",
pm:"\u0645",
midnight:"\u0646",
noon:"\u0638",
morning:"\u0635\u0628\u0627\u062D\u0627\u064B",
afternoon:"\u0628\u0639\u062F \u0627\u0644\u0638\u0647\u0631",
evening:"\u0645\u0633\u0627\u0621\u0627\u064B",
night:"\u0644\u064A\u0644\u0627\u064B"
},
abbreviated:{
am:"\u0635",
pm:"\u0645",
midnight:"\u0646\u0635\u0641 \u0627\u0644\u0644\u064A\u0644",
noon:"\u0638\u0647\u0631",
morning:"\u0635\u0628\u0627\u062D\u0627\u064B",
afternoon:"\u0628\u0639\u062F \u0627\u0644\u0638\u0647\u0631",
evening:"\u0645\u0633\u0627\u0621\u0627\u064B",
night:"\u0644\u064A\u0644\u0627\u064B"
},
wide:{
am:"\u0635",
pm:"\u0645",
midnight:"\u0646\u0635\u0641 \u0627\u0644\u0644\u064A\u0644",
noon:"\u0638\u0647\u0631",
morning:"\u0635\u0628\u0627\u062D\u0627\u064B",
afternoon:"\u0628\u0639\u062F \u0627\u0644\u0638\u0647\u0631",
evening:"\u0645\u0633\u0627\u0621\u0627\u064B",
night:"\u0644\u064A\u0644\u0627\u064B"
}
};
var formattingDayPeriodValues3={
narrow:{
am:"\u0635",
pm:"\u0645",
midnight:"\u0646",
noon:"\u0638",
morning:"\u0641\u064A \u0627\u0644\u0635\u0628\u0627\u062D",
afternoon:"\u0628\u0639\u062F \u0627\u0644\u0638\u0640\u0647\u0631",
evening:"\u0641\u064A \u0627\u0644\u0645\u0633\u0627\u0621",
night:"\u0641\u064A \u0627\u0644\u0644\u064A\u0644"
},
abbreviated:{
am:"\u0635",
pm:"\u0645",
midnight:"\u0646\u0635\u0641 \u0627\u0644\u0644\u064A\u0644",
noon:"\u0638\u0647\u0631",
morning:"\u0641\u064A \u0627\u0644\u0635\u0628\u0627\u062D",
afternoon:"\u0628\u0639\u062F \u0627\u0644\u0638\u0647\u0631",
evening:"\u0641\u064A \u0627\u0644\u0645\u0633\u0627\u0621",
night:"\u0641\u064A \u0627\u0644\u0644\u064A\u0644"
},
wide:{
am:"\u0635",
pm:"\u0645",
midnight:"\u0646\u0635\u0641 \u0627\u0644\u0644\u064A\u0644",
noon:"\u0638\u0647\u0631",
morning:"\u0635\u0628\u0627\u062D\u0627\u064B",
afternoon:"\u0628\u0639\u062F \u0627\u0644\u0638\u0640\u0647\u0631",
evening:"\u0641\u064A \u0627\u0644\u0645\u0633\u0627\u0621",
night:"\u0641\u064A \u0627\u0644\u0644\u064A\u0644"
}
};
var ordinalNumber3=function ordinalNumber3(dirtyNumber){
return String(dirtyNumber);
};
var localize5={
ordinalNumber:ordinalNumber3,
era:buildLocalizeFn({
values:eraValues3,
defaultWidth:"wide"
}),
quarter:buildLocalizeFn({
values:quarterValues3,
defaultWidth:"wide",
argumentCallback:function argumentCallback(quarter){return Number(quarter)-1;}
}),
month:buildLocalizeFn({
values:monthValues3,
defaultWidth:"wide"
}),
day:buildLocalizeFn({
values:dayValues3,
defaultWidth:"wide"
}),
dayPeriod:buildLocalizeFn({
values:dayPeriodValues3,
defaultWidth:"wide",
formattingValues:formattingDayPeriodValues3,
defaultFormattingWidth:"wide"
})
};

// lib/locale/ar-DZ/_lib/match.js
var matchOrdinalNumberPattern3=/^(\d+)(th|st|nd|rd)?/i;
var parseOrdinalNumberPattern3=/\d+/i;
var matchEraPatterns3={
narrow:/^(ق|ب)/i,
abbreviated:/^(ق\.?\s?م\.?|ق\.?\s?م\.?\s?|a\.?\s?d\.?|c\.?\s?)/i,
wide:/^(قبل الميلاد|قبل الميلاد|بعد الميلاد|بعد الميلاد)/i
};
var parseEraPatterns3={
any:[/^قبل/i,/^بعد/i]
};
var matchQuarterPatterns3={
narrow:/^[1234]/i,
abbreviated:/^ر[1234]/i,
wide:/^الربع [1234]/i
};
var parseQuarterPatterns3={
any:[/1/i,/2/i,/3/i,/4/i]
};
var matchMonthPatterns3={
narrow:/^[جفمأسند]/i,
abbreviated:/^(جان|فيف|مار|أفر|ماي|جوا|جوي|أوت|سبت|أكت|نوف|ديس)/i,
wide:/^(جانفي|فيفري|مارس|أفريل|ماي|جوان|جويلية|أوت|سبتمبر|أكتوبر|نوفمبر|ديسمبر)/i
};
var parseMonthPatterns3={
narrow:[
/^ج/i,
/^ف/i,
/^م/i,
/^أ/i,
/^م/i,
/^ج/i,
/^ج/i,
/^أ/i,
/^س/i,
/^أ/i,
/^ن/i,
/^د/i],

any:[
/^جان/i,
/^فيف/i,
/^مار/i,
/^أفر/i,
/^ماي/i,
/^جوا/i,
/^جوي/i,
/^أوت/i,
/^سبت/i,
/^أكت/i,
/^نوف/i,
/^ديس/i]

};
var matchDayPatterns3={
narrow:/^[حنثرخجس]/i,
short:/^(أحد|اثنين|ثلاثاء|أربعاء|خميس|جمعة|سبت)/i,
abbreviated:/^(أحد|اثن|ثلا|أرب|خمي|جمعة|سبت)/i,
wide:/^(الأحد|الاثنين|الثلاثاء|الأربعاء|الخميس|الجمعة|السبت)/i
};
var parseDayPatterns3={
narrow:[/^ح/i,/^ن/i,/^ث/i,/^ر/i,/^خ/i,/^ج/i,/^س/i],
wide:[
/^الأحد/i,
/^الاثنين/i,
/^الثلاثاء/i,
/^الأربعاء/i,
/^الخميس/i,
/^الجمعة/i,
/^السبت/i],

any:[/^أح/i,/^اث/i,/^ث/i,/^أر/i,/^خ/i,/^ج/i,/^س/i]
};
var matchDayPeriodPatterns3={
narrow:/^(a|p|mi|n|(in the|at) (morning|afternoon|evening|night))/i,
any:/^([ap]\.?\s?m\.?|midnight|noon|(in the|at) (morning|afternoon|evening|night))/i
};
var parseDayPeriodPatterns3={
any:{
am:/^a/i,
pm:/^p/i,
midnight:/^mi/i,
noon:/^no/i,
morning:/morning/i,
afternoon:/afternoon/i,
evening:/evening/i,
night:/night/i
}
};
var match5={
ordinalNumber:buildMatchPatternFn({
matchPattern:matchOrdinalNumberPattern3,
parsePattern:parseOrdinalNumberPattern3,
valueCallback:function valueCallback(value){return parseInt(value,10);}
}),
era:buildMatchFn({
matchPatterns:matchEraPatterns3,
defaultMatchWidth:"wide",
parsePatterns:parseEraPatterns3,
defaultParseWidth:"any"
}),
quarter:buildMatchFn({
matchPatterns:matchQuarterPatterns3,
defaultMatchWidth:"wide",
parsePatterns:parseQuarterPatterns3,
defaultParseWidth:"any",
valueCallback:function valueCallback(index){return Number(index)+1;}
}),
month:buildMatchFn({
matchPatterns:matchMonthPatterns3,
defaultMatchWidth:"wide",
parsePatterns:parseMonthPatterns3,
defaultParseWidth:"any"
}),
day:buildMatchFn({
matchPatterns:matchDayPatterns3,
defaultMatchWidth:"wide",
parsePatterns:parseDayPatterns3,
defaultParseWidth:"any"
}),
dayPeriod:buildMatchFn({
matchPatterns:matchDayPeriodPatterns3,
defaultMatchWidth:"any",
parsePatterns:parseDayPeriodPatterns3,
defaultParseWidth:"any"
})
};

// lib/locale/ar-DZ.js
var _arDZ={
code:"ar-DZ",
formatDistance:formatDistance5,
formatLong:formatLong5,
formatRelative:formatRelative5,
localize:localize5,
match:match5,
options:{
weekStartsOn:0,
firstWeekContainsDate:1
}
};
// lib/locale/ar-EG/_lib/formatDistance.js
var formatDistanceLocale4={
lessThanXSeconds:{
one:"\u0623\u0642\u0644 \u0645\u0646 \u062B\u0627\u0646\u064A\u0629",
two:"\u0623\u0642\u0644 \u0645\u0646 \u062B\u0627\u0646\u064A\u062A\u064A\u0646",
threeToTen:"\u0623\u0642\u0644 \u0645\u0646 {{count}} \u062B\u0648\u0627\u0646\u064A",
other:"\u0623\u0642\u0644 \u0645\u0646 {{count}} \u062B\u0627\u0646\u064A\u0629"
},
xSeconds:{
one:"\u062B\u0627\u0646\u064A\u0629",
two:"\u062B\u0627\u0646\u064A\u062A\u064A\u0646",
threeToTen:"{{count}} \u062B\u0648\u0627\u0646\u064A",
other:"{{count}} \u062B\u0627\u0646\u064A\u0629"
},
halfAMinute:"\u0646\u0635 \u062F\u0642\u064A\u0642\u0629",
lessThanXMinutes:{
one:"\u0623\u0642\u0644 \u0645\u0646 \u062F\u0642\u064A\u0642\u0629",
two:"\u0623\u0642\u0644 \u0645\u0646 \u062F\u0642\u064A\u0642\u062A\u064A\u0646",
threeToTen:"\u0623\u0642\u0644 \u0645\u0646 {{count}} \u062F\u0642\u0627\u064A\u0642",
other:"\u0623\u0642\u0644 \u0645\u0646 {{count}} \u062F\u0642\u064A\u0642\u0629"
},
xMinutes:{
one:"\u062F\u0642\u064A\u0642\u0629",
two:"\u062F\u0642\u064A\u0642\u062A\u064A\u0646",
threeToTen:"{{count}} \u062F\u0642\u0627\u064A\u0642",
other:"{{count}} \u062F\u0642\u064A\u0642\u0629"
},
aboutXHours:{
one:"\u062D\u0648\u0627\u0644\u064A \u0633\u0627\u0639\u0629",
two:"\u062D\u0648\u0627\u0644\u064A \u0633\u0627\u0639\u062A\u064A\u0646",
threeToTen:"\u062D\u0648\u0627\u0644\u064A {{count}} \u0633\u0627\u0639\u0627\u062A",
other:"\u062D\u0648\u0627\u0644\u064A {{count}} \u0633\u0627\u0639\u0629"
},
xHours:{
one:"\u0633\u0627\u0639\u0629",
two:"\u0633\u0627\u0639\u062A\u064A\u0646",
threeToTen:"{{count}} \u0633\u0627\u0639\u0627\u062A",
other:"{{count}} \u0633\u0627\u0639\u0629"
},
xDays:{
one:"\u064A\u0648\u0645",
two:"\u064A\u0648\u0645\u064A\u0646",
threeToTen:"{{count}} \u0623\u064A\u0627\u0645",
other:"{{count}} \u064A\u0648\u0645"
},
aboutXWeeks:{
one:"\u062D\u0648\u0627\u0644\u064A \u0623\u0633\u0628\u0648\u0639",
two:"\u062D\u0648\u0627\u0644\u064A \u0623\u0633\u0628\u0648\u0639\u064A\u0646",
threeToTen:"\u062D\u0648\u0627\u0644\u064A {{count}} \u0623\u0633\u0627\u0628\u064A\u0639",
other:"\u062D\u0648\u0627\u0644\u064A {{count}} \u0623\u0633\u0628\u0648\u0639"
},
xWeeks:{
one:"\u0623\u0633\u0628\u0648\u0639",
two:"\u0623\u0633\u0628\u0648\u0639\u064A\u0646",
threeToTen:"{{count}} \u0623\u0633\u0627\u0628\u064A\u0639",
other:"{{count}} \u0623\u0633\u0628\u0648\u0639"
},
aboutXMonths:{
one:"\u062D\u0648\u0627\u0644\u064A \u0634\u0647\u0631",
two:"\u062D\u0648\u0627\u0644\u064A \u0634\u0647\u0631\u064A\u0646",
threeToTen:"\u062D\u0648\u0627\u0644\u064A {{count}} \u0623\u0634\u0647\u0631",
other:"\u062D\u0648\u0627\u0644\u064A {{count}} \u0634\u0647\u0631"
},
xMonths:{
one:"\u0634\u0647\u0631",
two:"\u0634\u0647\u0631\u064A\u0646",
threeToTen:"{{count}} \u0623\u0634\u0647\u0631",
other:"{{count}} \u0634\u0647\u0631"
},
aboutXYears:{
one:"\u062D\u0648\u0627\u0644\u064A \u0633\u0646\u0629",
two:"\u062D\u0648\u0627\u0644\u064A \u0633\u0646\u062A\u064A\u0646",
threeToTen:"\u062D\u0648\u0627\u0644\u064A {{count}} \u0633\u0646\u064A\u0646",
other:"\u062D\u0648\u0627\u0644\u064A {{count}} \u0633\u0646\u0629"
},
xYears:{
one:"\u0639\u0627\u0645",
two:"\u0639\u0627\u0645\u064A\u0646",
threeToTen:"{{count}} \u0623\u0639\u0648\u0627\u0645",
other:"{{count}} \u0639\u0627\u0645"
},
overXYears:{
one:"\u0623\u0643\u062B\u0631 \u0645\u0646 \u0633\u0646\u0629",
two:"\u0623\u0643\u062B\u0631 \u0645\u0646 \u0633\u0646\u062A\u064A\u0646",
threeToTen:"\u0623\u0643\u062B\u0631 \u0645\u0646 {{count}} \u0633\u0646\u064A\u0646",
other:"\u0623\u0643\u062B\u0631 \u0645\u0646 {{count}} \u0633\u0646\u0629"
},
almostXYears:{
one:"\u0639\u0627\u0645 \u062A\u0642\u0631\u064A\u0628\u064B\u0627",
two:"\u0639\u0627\u0645\u064A\u0646 \u062A\u0642\u0631\u064A\u0628\u064B\u0627",
threeToTen:"{{count}} \u0623\u0639\u0648\u0627\u0645 \u062A\u0642\u0631\u064A\u0628\u064B\u0627",
other:"{{count}} \u0639\u0627\u0645 \u062A\u0642\u0631\u064A\u0628\u064B\u0627"
}
};
var formatDistance7=function formatDistance7(token,count,options){
var result;
var tokenValue=formatDistanceLocale4[token];
if(typeof tokenValue==="string"){
result=tokenValue;
}else if(count===1){
result=tokenValue.one;
}else if(count===2){
result=tokenValue.two;
}else if(count<=10){
result=tokenValue.threeToTen.replace("{{count}}",String(count));
}else{
result=tokenValue.other.replace("{{count}}",String(count));
}
if(options!==null&&options!==void 0&&options.addSuffix){
if(options.comparison&&options.comparison>0){
return"\u0641\u064A \u062E\u0644\u0627\u0644 ".concat(result);
}else{
return"\u0645\u0646\u0630 ".concat(result);
}
}
return result;
};

// lib/locale/ar-EG/_lib/formatLong.js
var dateFormats4={
full:"EEEE\u060C do MMMM y",
long:"do MMMM y",
medium:"dd/MMM/y",
short:"d/MM/y"
};
var timeFormats4={
full:"h:mm:ss a zzzz",
long:"h:mm:ss a z",
medium:"h:mm:ss a",
short:"h:mm a"
};
var dateTimeFormats4={
full:"{{date}} '\u0627\u0644\u0633\u0627\u0639\u0629' {{time}}",
long:"{{date}} '\u0627\u0644\u0633\u0627\u0639\u0629' {{time}}",
medium:"{{date}}, {{time}}",
short:"{{date}}, {{time}}"
};
var formatLong7={
date:buildFormatLongFn({
formats:dateFormats4,
defaultWidth:"full"
}),
time:buildFormatLongFn({
formats:timeFormats4,
defaultWidth:"full"
}),
dateTime:buildFormatLongFn({
formats:dateTimeFormats4,
defaultWidth:"full"
})
};

// lib/locale/ar-EG/_lib/formatRelative.js
var formatRelativeLocale4={
lastWeek:"eeee '\u0627\u0644\u0644\u064A \u062C\u0627\u064A \u0627\u0644\u0633\u0627\u0639\u0629' p",
yesterday:"'\u0625\u0645\u0628\u0627\u0631\u062D \u0627\u0644\u0633\u0627\u0639\u0629' p",
today:"'\u0627\u0644\u0646\u0647\u0627\u0631\u062F\u0629 \u0627\u0644\u0633\u0627\u0639\u0629' p",
tomorrow:"'\u0628\u0643\u0631\u0629 \u0627\u0644\u0633\u0627\u0639\u0629' p",
nextWeek:"eeee '\u0627\u0644\u0633\u0627\u0639\u0629' p",
other:"P"
};
var formatRelative7=function formatRelative7(token,_date,_baseDate,_options){return formatRelativeLocale4[token];};

// lib/locale/ar-EG/_lib/localize.js
var eraValues4={
narrow:["\u0642","\u0628"],
abbreviated:["\u0642.\u0645","\u0628.\u0645"],
wide:["\u0642\u0628\u0644 \u0627\u0644\u0645\u064A\u0644\u0627\u062F","\u0628\u0639\u062F \u0627\u0644\u0645\u064A\u0644\u0627\u062F"]
};
var quarterValues4={
narrow:["1","2","3","4"],
abbreviated:["\u06311","\u06312","\u06313","\u06314"],
wide:["\u0627\u0644\u0631\u0628\u0639 \u0627\u0644\u0623\u0648\u0644","\u0627\u0644\u0631\u0628\u0639 \u0627\u0644\u062B\u0627\u0646\u064A","\u0627\u0644\u0631\u0628\u0639 \u0627\u0644\u062B\u0627\u0644\u062B","\u0627\u0644\u0631\u0628\u0639 \u0627\u0644\u0631\u0627\u0628\u0639"]
};
var monthValues4={
narrow:["\u064A","\u0641","\u0645","\u0623","\u0645","\u064A","\u064A","\u0623","\u0633","\u0623","\u0646","\u062F"],
abbreviated:[
"\u064A\u0646\u0627",
"\u0641\u0628\u0631",
"\u0645\u0627\u0631\u0633",
"\u0623\u0628\u0631\u064A\u0644",
"\u0645\u0627\u064A\u0648",
"\u064A\u0648\u0646\u0640",
"\u064A\u0648\u0644\u0640",
"\u0623\u063A\u0633\u0640",
"\u0633\u0628\u062A\u0640",
"\u0623\u0643\u062A\u0640",
"\u0646\u0648\u0641\u0640",
"\u062F\u064A\u0633\u0640"],

wide:[
"\u064A\u0646\u0627\u064A\u0631",
"\u0641\u0628\u0631\u0627\u064A\u0631",
"\u0645\u0627\u0631\u0633",
"\u0623\u0628\u0631\u064A\u0644",
"\u0645\u0627\u064A\u0648",
"\u064A\u0648\u0646\u064A\u0648",
"\u064A\u0648\u0644\u064A\u0648",
"\u0623\u063A\u0633\u0637\u0633",
"\u0633\u0628\u062A\u0645\u0628\u0631",
"\u0623\u0643\u062A\u0648\u0628\u0631",
"\u0646\u0648\u0641\u0645\u0628\u0631",
"\u062F\u064A\u0633\u0645\u0628\u0631"]

};
var dayValues4={
narrow:["\u062D","\u0646","\u062B","\u0631","\u062E","\u062C","\u0633"],
short:["\u0623\u062D\u062F","\u0627\u062B\u0646\u064A\u0646","\u062B\u0644\u0627\u062B\u0627\u0621","\u0623\u0631\u0628\u0639\u0627\u0621","\u062E\u0645\u064A\u0633","\u062C\u0645\u0639\u0629","\u0633\u0628\u062A"],
abbreviated:["\u0623\u062D\u062F","\u0627\u062B\u0646\u064A\u0646","\u062B\u0644\u0627\u062B\u0627\u0621","\u0623\u0631\u0628\u0639\u0627\u0621","\u062E\u0645\u064A\u0633","\u062C\u0645\u0639\u0629","\u0633\u0628\u062A"],
wide:[
"\u0627\u0644\u0623\u062D\u062F",
"\u0627\u0644\u0627\u062B\u0646\u064A\u0646",
"\u0627\u0644\u062B\u0644\u0627\u062B\u0627\u0621",
"\u0627\u0644\u0623\u0631\u0628\u0639\u0627\u0621",
"\u0627\u0644\u062E\u0645\u064A\u0633",
"\u0627\u0644\u062C\u0645\u0639\u0629",
"\u0627\u0644\u0633\u0628\u062A"]

};
var dayPeriodValues4={
narrow:{
am:"\u0635",
pm:"\u0645",
midnight:"\u0646",
noon:"\u0638",
morning:"\u0635\u0628\u0627\u062D\u0627\u064B",
afternoon:"\u0628\u0639\u062F \u0627\u0644\u0638\u0647\u0631",
evening:"\u0645\u0633\u0627\u0621\u064B",
night:"\u0644\u064A\u0644\u0627\u064B"
},
abbreviated:{
am:"\u0635",
pm:"\u0645",
midnight:"\u0646\u0635\u0641 \u0627\u0644\u0644\u064A\u0644",
noon:"\u0638\u0647\u0631\u0627\u064B",
morning:"\u0635\u0628\u0627\u062D\u0627\u064B",
afternoon:"\u0628\u0639\u062F \u0627\u0644\u0638\u0647\u0631",
evening:"\u0645\u0633\u0627\u0621\u064B",
night:"\u0644\u064A\u0644\u0627\u064B"
},
wide:{
am:"\u0635",
pm:"\u0645",
midnight:"\u0646\u0635\u0641 \u0627\u0644\u0644\u064A\u0644",
noon:"\u0638\u0647\u0631\u0627\u064B",
morning:"\u0635\u0628\u0627\u062D\u0627\u064B",
afternoon:"\u0628\u0639\u062F \u0627\u0644\u0638\u0647\u0631",
evening:"\u0645\u0633\u0627\u0621\u064B",
night:"\u0644\u064A\u0644\u0627\u064B"
}
};
var formattingDayPeriodValues4={
narrow:{
am:"\u0635",
pm:"\u0645",
midnight:"\u0646",
noon:"\u0638",
morning:"\u0641\u064A \u0627\u0644\u0635\u0628\u0627\u062D",
afternoon:"\u0628\u0639\u062F \u0627\u0644\u0638\u0647\u0631",
evening:"\u0641\u064A \u0627\u0644\u0645\u0633\u0627\u0621",
night:"\u0641\u064A \u0627\u0644\u0644\u064A\u0644"
},
abbreviated:{
am:"\u0635",
pm:"\u0645",
midnight:"\u0646\u0635\u0641 \u0627\u0644\u0644\u064A\u0644",
noon:"\u0638\u0647\u0631\u0627\u064B",
morning:"\u0641\u064A \u0627\u0644\u0635\u0628\u0627\u062D",
afternoon:"\u0628\u0639\u062F \u0627\u0644\u0638\u0647\u0631",
evening:"\u0641\u064A \u0627\u0644\u0645\u0633\u0627\u0621",
night:"\u0641\u064A \u0627\u0644\u0644\u064A\u0644"
},
wide:{
am:"\u0635",
pm:"\u0645",
midnight:"\u0646\u0635\u0641 \u0627\u0644\u0644\u064A\u0644",
morning:"\u0641\u064A \u0627\u0644\u0635\u0628\u0627\u062D",
noon:"\u0638\u0647\u0631\u0627\u064B",
afternoon:"\u0628\u0639\u062F \u0627\u0644\u0638\u0647\u0631",
evening:"\u0641\u064A \u0627\u0644\u0645\u0633\u0627\u0621",
night:"\u0641\u064A \u0627\u0644\u0644\u064A\u0644"
}
};
var ordinalNumber4=function ordinalNumber4(dirtyNumber,_options){
return String(dirtyNumber);
};
var localize7={
ordinalNumber:ordinalNumber4,
era:buildLocalizeFn({
values:eraValues4,
defaultWidth:"wide"
}),
quarter:buildLocalizeFn({
values:quarterValues4,
defaultWidth:"wide",
argumentCallback:function argumentCallback(quarter){return quarter-1;}
}),
month:buildLocalizeFn({
values:monthValues4,
defaultWidth:"wide"
}),
day:buildLocalizeFn({
values:dayValues4,
defaultWidth:"wide"
}),
dayPeriod:buildLocalizeFn({
values:dayPeriodValues4,
defaultWidth:"wide",
formattingValues:formattingDayPeriodValues4,
defaultFormattingWidth:"wide"
})
};

// lib/locale/ar-EG/_lib/match.js
var matchOrdinalNumberPattern4=/^(\d+)/;
var parseOrdinalNumberPattern4=/\d+/i;
var matchEraPatterns4={
narrow:/^(ق|ب)/g,
abbreviated:/^(ق.م|ب.م)/g,
wide:/^(قبل الميلاد|بعد الميلاد)/g
};
var parseEraPatterns4={
any:[/^ق/g,/^ب/g]
};
var matchQuarterPatterns4={
narrow:/^[1234]/,
abbreviated:/^ر[1234]/,
wide:/^الربع (الأول|الثاني|الثالث|الرابع)/
};
var parseQuarterPatterns4={
wide:[/الربع الأول/,/الربع الثاني/,/الربع الثالث/,/الربع الرابع/],
any:[/1/,/2/,/3/,/4/]
};
var matchMonthPatterns4={
narrow:/^(ي|ف|م|أ|س|ن|د)/,
abbreviated:/^(ينا|فبر|مارس|أبريل|مايو|يونـ|يولـ|أغسـ|سبتـ|أكتـ|نوفـ|ديسـ)/,
wide:/^(يناير|فبراير|مارس|أبريل|مايو|يونيو|يوليو|أغسطس|سبتمبر|أكتوبر|نوفمبر|ديسمبر)/
};
var parseMonthPatterns4={
narrow:[
/^ي/,
/^ف/,
/^م/,
/^أ/,
/^م/,
/^ي/,
/^ي/,
/^أ/,
/^س/,
/^أ/,
/^ن/,
/^د/],

any:[
/^ينا/,
/^فبر/,
/^مارس/,
/^أبريل/,
/^مايو/,
/^يون/,
/^يول/,
/^أغس/,
/^سبت/,
/^أكت/,
/^نوف/,
/^ديس/]

};
var matchDayPatterns4={
narrow:/^(ح|ن|ث|ر|خ|ج|س)/,
short:/^(أحد|اثنين|ثلاثاء|أربعاء|خميس|جمعة|سبت)/,
abbreviated:/^(أحد|اثنين|ثلاثاء|أربعاء|خميس|جمعة|سبت)/,
wide:/^(الأحد|الاثنين|الثلاثاء|الأربعاء|الخميس|الجمعة|السبت)/
};
var parseDayPatterns4={
narrow:[/^ح/,/^ن/,/^ث/,/^ر/,/^خ/,/^ج/,/^س/],
any:[/أحد/,/اثنين/,/ثلاثاء/,/أربعاء/,/خميس/,/جمعة/,/سبت/]
};
var matchDayPeriodPatterns4={
narrow:/^(ص|م|ن|ظ|في الصباح|بعد الظهر|في المساء|في الليل)/,
abbreviated:/^(ص|م|نصف الليل|ظهراً|في الصباح|بعد الظهر|في المساء|في الليل)/,
wide:/^(ص|م|نصف الليل|في الصباح|ظهراً|بعد الظهر|في المساء|في الليل)/,
any:/^(ص|م|صباح|ظهر|مساء|ليل)/
};
var parseDayPeriodPatterns4={
any:{
am:/^ص/,
pm:/^م/,
midnight:/^ن/,
noon:/^ظ/,
morning:/^ص/,
afternoon:/^بعد/,
evening:/^م/,
night:/^ل/
}
};
var match7={
ordinalNumber:buildMatchPatternFn({
matchPattern:matchOrdinalNumberPattern4,
parsePattern:parseOrdinalNumberPattern4,
valueCallback:function valueCallback(value){
return parseInt(value,10);
}
}),
era:buildMatchFn({
matchPatterns:matchEraPatterns4,
defaultMatchWidth:"wide",
parsePatterns:parseEraPatterns4,
defaultParseWidth:"any"
}),
quarter:buildMatchFn({
matchPatterns:matchQuarterPatterns4,
defaultMatchWidth:"wide",
parsePatterns:parseQuarterPatterns4,
defaultParseWidth:"any",
valueCallback:function valueCallback(index){return index+1;}
}),
month:buildMatchFn({
matchPatterns:matchMonthPatterns4,
defaultMatchWidth:"wide",
parsePatterns:parseMonthPatterns4,
defaultParseWidth:"any"
}),
day:buildMatchFn({
matchPatterns:matchDayPatterns4,
defaultMatchWidth:"wide",
parsePatterns:parseDayPatterns4,
defaultParseWidth:"any"
}),
dayPeriod:buildMatchFn({
matchPatterns:matchDayPeriodPatterns4,
defaultMatchWidth:"any",
parsePatterns:parseDayPeriodPatterns4,
defaultParseWidth:"any"
})
};

// lib/locale/ar-EG.js
var _arEG={
code:"ar-EG",
formatDistance:formatDistance7,
formatLong:formatLong7,
formatRelative:formatRelative7,
localize:localize7,
match:match7,
options:{
weekStartsOn:0,
firstWeekContainsDate:1
}
};
// lib/locale/ar-MA/_lib/formatDistance.js
var formatDistanceLocale5={
lessThanXSeconds:{
one:"\u0623\u0642\u0644 \u0645\u0646 \u062B\u0627\u0646\u064A\u0629 \u0648\u0627\u062D\u062F\u0629",
two:"\u0623\u0642\u0644 \u0645\u0646 \u062B\u0627\u0646\u062A\u064A\u0646",
threeToTen:"\u0623\u0642\u0644 \u0645\u0646 {{count}} \u062B\u0648\u0627\u0646\u064A",
other:"\u0623\u0642\u0644 \u0645\u0646 {{count}} \u062B\u0627\u0646\u064A\u0629"
},
xSeconds:{
one:"\u062B\u0627\u0646\u064A\u0629 \u0648\u0627\u062D\u062F\u0629",
two:"\u062B\u0627\u0646\u062A\u064A\u0646",
threeToTen:"{{count}} \u062B\u0648\u0627\u0646\u064A",
other:"{{count}} \u062B\u0627\u0646\u064A\u0629"
},
halfAMinute:"\u0646\u0635\u0641 \u062F\u0642\u064A\u0642\u0629",
lessThanXMinutes:{
one:"\u0623\u0642\u0644 \u0645\u0646 \u062F\u0642\u064A\u0642\u0629",
two:"\u0623\u0642\u0644 \u0645\u0646 \u062F\u0642\u064A\u0642\u062A\u064A\u0646",
threeToTen:"\u0623\u0642\u0644 \u0645\u0646 {{count}} \u062F\u0642\u0627\u0626\u0642",
other:"\u0623\u0642\u0644 \u0645\u0646 {{count}} \u062F\u0642\u064A\u0642\u0629"
},
xMinutes:{
one:"\u062F\u0642\u064A\u0642\u0629 \u0648\u0627\u062D\u062F\u0629",
two:"\u062F\u0642\u064A\u0642\u062A\u064A\u0646",
threeToTen:"{{count}} \u062F\u0642\u0627\u0626\u0642",
other:"{{count}} \u062F\u0642\u064A\u0642\u0629"
},
aboutXHours:{
one:"\u0633\u0627\u0639\u0629 \u0648\u0627\u062D\u062F\u0629 \u062A\u0642\u0631\u064A\u0628\u0627\u064B",
two:"\u0633\u0627\u0639\u062A\u064A\u0646 \u062A\u0642\u0631\u064A\u0628\u0627\u064B",
threeToTen:"{{count}} \u0633\u0627\u0639\u0627\u062A \u062A\u0642\u0631\u064A\u0628\u0627\u064B",
other:"{{count}} \u0633\u0627\u0639\u0629 \u062A\u0642\u0631\u064A\u0628\u0627\u064B"
},
xHours:{
one:"\u0633\u0627\u0639\u0629 \u0648\u0627\u062D\u062F\u0629",
two:"\u0633\u0627\u0639\u062A\u064A\u0646",
threeToTen:"{{count}} \u0633\u0627\u0639\u0627\u062A",
other:"{{count}} \u0633\u0627\u0639\u0629"
},
xDays:{
one:"\u064A\u0648\u0645 \u0648\u0627\u062D\u062F",
two:"\u064A\u0648\u0645\u064A\u0646",
threeToTen:"{{count}} \u0623\u064A\u0627\u0645",
other:"{{count}} \u064A\u0648\u0645"
},
aboutXWeeks:{
one:"\u0623\u0633\u0628\u0648\u0639 \u0648\u0627\u062D\u062F \u062A\u0642\u0631\u064A\u0628\u0627\u064B",
two:"\u0623\u0633\u0628\u0648\u0639\u064A\u0646 \u062A\u0642\u0631\u064A\u0628\u0627\u064B",
threeToTen:"{{count}} \u0623\u0633\u0627\u0628\u064A\u0639 \u062A\u0642\u0631\u064A\u0628\u0627\u064B",
other:"{{count}} \u0623\u0633\u0628\u0648\u0639 \u062A\u0642\u0631\u064A\u0628\u0627\u064B"
},
xWeeks:{
one:"\u0623\u0633\u0628\u0648\u0639 \u0648\u0627\u062D\u062F",
two:"\u0623\u0633\u0628\u0648\u0639\u064A\u0646",
threeToTen:"{{count}} \u0623\u0633\u0627\u0628\u064A\u0639",
other:"{{count}} \u0623\u0633\u0628\u0648\u0639"
},
aboutXMonths:{
one:"\u0634\u0647\u0631 \u0648\u0627\u062D\u062F \u062A\u0642\u0631\u064A\u0628\u0627\u064B",
two:"\u0634\u0647\u0631\u064A\u0646 \u062A\u0642\u0631\u064A\u0628\u0627\u064B",
threeToTen:"{{count}} \u0623\u0634\u0647\u0631 \u062A\u0642\u0631\u064A\u0628\u0627\u064B",
other:"{{count}} \u0634\u0647\u0631 \u062A\u0642\u0631\u064A\u0628\u0627\u064B"
},
xMonths:{
one:"\u0634\u0647\u0631 \u0648\u0627\u062D\u062F",
two:"\u0634\u0647\u0631\u064A\u0646",
threeToTen:"{{count}} \u0623\u0634\u0647\u0631",
other:"{{count}} \u0634\u0647\u0631"
},
aboutXYears:{
one:"\u0639\u0627\u0645 \u0648\u0627\u062D\u062F \u062A\u0642\u0631\u064A\u0628\u0627\u064B",
two:"\u0639\u0627\u0645\u064A\u0646 \u062A\u0642\u0631\u064A\u0628\u0627\u064B",
threeToTen:"{{count}} \u0623\u0639\u0648\u0627\u0645 \u062A\u0642\u0631\u064A\u0628\u0627\u064B",
other:"{{count}} \u0639\u0627\u0645 \u062A\u0642\u0631\u064A\u0628\u0627\u064B"
},
xYears:{
one:"\u0639\u0627\u0645 \u0648\u0627\u062D\u062F",
two:"\u0639\u0627\u0645\u064A\u0646",
threeToTen:"{{count}} \u0623\u0639\u0648\u0627\u0645",
other:"{{count}} \u0639\u0627\u0645"
},
overXYears:{
one:"\u0623\u0643\u062B\u0631 \u0645\u0646 \u0639\u0627\u0645",
two:"\u0623\u0643\u062B\u0631 \u0645\u0646 \u0639\u0627\u0645\u064A\u0646",
threeToTen:"\u0623\u0643\u062B\u0631 \u0645\u0646 {{count}} \u0623\u0639\u0648\u0627\u0645",
other:"\u0623\u0643\u062B\u0631 \u0645\u0646 {{count}} \u0639\u0627\u0645"
},
almostXYears:{
one:"\u0639\u0627\u0645 \u0648\u0627\u062D\u062F \u062A\u0642\u0631\u064A\u0628\u0627\u064B",
two:"\u0639\u0627\u0645\u064A\u0646 \u062A\u0642\u0631\u064A\u0628\u0627\u064B",
threeToTen:"{{count}} \u0623\u0639\u0648\u0627\u0645 \u062A\u0642\u0631\u064A\u0628\u0627\u064B",
other:"{{count}} \u0639\u0627\u0645 \u062A\u0642\u0631\u064A\u0628\u0627\u064B"
}
};
var formatDistance9=function formatDistance9(token,count,options){
options=options||{};
var usageGroup=formatDistanceLocale5[token];
var result;
if(typeof usageGroup==="string"){
result=usageGroup;
}else if(count===1){
result=usageGroup.one;
}else if(count===2){
result=usageGroup.two;
}else if(count<=10){
result=usageGroup.threeToTen.replace("{{count}}",String(count));
}else{
result=usageGroup.other.replace("{{count}}",String(count));
}
if(options.addSuffix){
if(options.comparison&&options.comparison>0){
return"\u0641\u064A \u062E\u0644\u0627\u0644 "+result;
}else{
return"\u0645\u0646\u0630 "+result;
}
}
return result;
};

// lib/locale/ar-MA/_lib/formatLong.js
var dateFormats5={
full:"EEEE, MMMM do, y",
long:"MMMM do, y",
medium:"MMM d, y",
short:"MM/dd/yyyy"
};
var timeFormats5={
full:"h:mm:ss a zzzz",
long:"h:mm:ss a z",
medium:"h:mm:ss a",
short:"h:mm a"
};
var dateTimeFormats5={
full:"{{date}} '\u0639\u0646\u062F' {{time}}",
long:"{{date}} '\u0639\u0646\u062F' {{time}}",
medium:"{{date}}, {{time}}",
short:"{{date}}, {{time}}"
};
var formatLong9={
date:buildFormatLongFn({
formats:dateFormats5,
defaultWidth:"full"
}),
time:buildFormatLongFn({
formats:timeFormats5,
defaultWidth:"full"
}),
dateTime:buildFormatLongFn({
formats:dateTimeFormats5,
defaultWidth:"full"
})
};

// lib/locale/ar-MA/_lib/formatRelative.js
var formatRelativeLocale5={
lastWeek:"'\u0623\u062E\u0631' eeee '\u0639\u0646\u062F' p",
yesterday:"'\u0623\u0645\u0633 \u0639\u0646\u062F' p",
today:"'\u0627\u0644\u064A\u0648\u0645 \u0639\u0646\u062F' p",
tomorrow:"'\u063A\u062F\u0627\u064B \u0639\u0646\u062F' p",
nextWeek:"eeee '\u0639\u0646\u062F' p",
other:"P"
};
var formatRelative9=function formatRelative9(token,_date,_baseDate,_options){
return formatRelativeLocale5[token];
};

// lib/locale/ar-MA/_lib/localize.js
var eraValues5={
narrow:["\u0642","\u0628"],
abbreviated:["\u0642.\u0645.","\u0628.\u0645."],
wide:["\u0642\u0628\u0644 \u0627\u0644\u0645\u064A\u0644\u0627\u062F","\u0628\u0639\u062F \u0627\u0644\u0645\u064A\u0644\u0627\u062F"]
};
var quarterValues5={
narrow:["1","2","3","4"],
abbreviated:["\u06311","\u06312","\u06313","\u06314"],
wide:["\u0627\u0644\u0631\u0628\u0639 \u0627\u0644\u0623\u0648\u0644","\u0627\u0644\u0631\u0628\u0639 \u0627\u0644\u062B\u0627\u0646\u064A","\u0627\u0644\u0631\u0628\u0639 \u0627\u0644\u062B\u0627\u0644\u062B","\u0627\u0644\u0631\u0628\u0639 \u0627\u0644\u0631\u0627\u0628\u0639"]
};
var monthValues5={
narrow:["\u064A","\u0641","\u0645","\u0623","\u0645","\u064A","\u064A","\u063A","\u0634","\u0623","\u0646","\u062F"],
abbreviated:[
"\u064A\u0646\u0627",
"\u0641\u0628\u0631",
"\u0645\u0627\u0631\u0633",
"\u0623\u0628\u0631\u064A\u0644",
"\u0645\u0627\u064A",
"\u064A\u0648\u0646\u0640",
"\u064A\u0648\u0644\u0640",
"\u063A\u0634\u062A",
"\u0634\u062A\u0646\u0640",
"\u0623\u0643\u062A\u0640",
"\u0646\u0648\u0646\u0640",
"\u062F\u062C\u0646\u0640"],

wide:[
"\u064A\u0646\u0627\u064A\u0631",
"\u0641\u0628\u0631\u0627\u064A\u0631",
"\u0645\u0627\u0631\u0633",
"\u0623\u0628\u0631\u064A\u0644",
"\u0645\u0627\u064A",
"\u064A\u0648\u0646\u064A\u0648",
"\u064A\u0648\u0644\u064A\u0648\u0632",
"\u063A\u0634\u062A",
"\u0634\u062A\u0646\u0628\u0631",
"\u0623\u0643\u062A\u0648\u0628\u0631",
"\u0646\u0648\u0646\u0628\u0631",
"\u062F\u062C\u0646\u0628\u0631"]

};
var dayValues5={
narrow:["\u062D","\u0646","\u062B","\u0631","\u062E","\u062C","\u0633"],
short:["\u0623\u062D\u062F","\u0627\u062B\u0646\u064A\u0646","\u062B\u0644\u0627\u062B\u0627\u0621","\u0623\u0631\u0628\u0639\u0627\u0621","\u062E\u0645\u064A\u0633","\u062C\u0645\u0639\u0629","\u0633\u0628\u062A"],
abbreviated:["\u0623\u062D\u062F","\u0627\u062B\u0646\u0640","\u062B\u0644\u0627","\u0623\u0631\u0628\u0640","\u062E\u0645\u064A\u0640","\u062C\u0645\u0639\u0629","\u0633\u0628\u062A"],
wide:[
"\u0627\u0644\u0623\u062D\u062F",
"\u0627\u0644\u0625\u062B\u0646\u064A\u0646",
"\u0627\u0644\u062B\u0644\u0627\u062B\u0627\u0621",
"\u0627\u0644\u0623\u0631\u0628\u0639\u0627\u0621",
"\u0627\u0644\u062E\u0645\u064A\u0633",
"\u0627\u0644\u062C\u0645\u0639\u0629",
"\u0627\u0644\u0633\u0628\u062A"]

};
var dayPeriodValues5={
narrow:{
am:"\u0635",
pm:"\u0645",
midnight:"\u0646",
noon:"\u0638",
morning:"\u0635\u0628\u0627\u062D\u0627\u064B",
afternoon:"\u0628\u0639\u062F \u0627\u0644\u0638\u0647\u0631",
evening:"\u0645\u0633\u0627\u0621\u0627\u064B",
night:"\u0644\u064A\u0644\u0627\u064B"
},
abbreviated:{
am:"\u0635",
pm:"\u0645",
midnight:"\u0646\u0635\u0641 \u0627\u0644\u0644\u064A\u0644",
noon:"\u0638\u0647\u0631",
morning:"\u0635\u0628\u0627\u062D\u0627\u064B",
afternoon:"\u0628\u0639\u062F \u0627\u0644\u0638\u0647\u0631",
evening:"\u0645\u0633\u0627\u0621\u0627\u064B",
night:"\u0644\u064A\u0644\u0627\u064B"
},
wide:{
am:"\u0635",
pm:"\u0645",
midnight:"\u0646\u0635\u0641 \u0627\u0644\u0644\u064A\u0644",
noon:"\u0638\u0647\u0631",
morning:"\u0635\u0628\u0627\u062D\u0627\u064B",
afternoon:"\u0628\u0639\u062F \u0627\u0644\u0638\u0647\u0631",
evening:"\u0645\u0633\u0627\u0621\u0627\u064B",
night:"\u0644\u064A\u0644\u0627\u064B"
}
};
var formattingDayPeriodValues5={
narrow:{
am:"\u0635",
pm:"\u0645",
midnight:"\u0646",
noon:"\u0638",
morning:"\u0641\u064A \u0627\u0644\u0635\u0628\u0627\u062D",
afternoon:"\u0628\u0639\u062F \u0627\u0644\u0638\u0640\u0647\u0631",
evening:"\u0641\u064A \u0627\u0644\u0645\u0633\u0627\u0621",
night:"\u0641\u064A \u0627\u0644\u0644\u064A\u0644"
},
abbreviated:{
am:"\u0635",
pm:"\u0645",
midnight:"\u0646\u0635\u0641 \u0627\u0644\u0644\u064A\u0644",
noon:"\u0638\u0647\u0631",
morning:"\u0641\u064A \u0627\u0644\u0635\u0628\u0627\u062D",
afternoon:"\u0628\u0639\u062F \u0627\u0644\u0638\u0647\u0631",
evening:"\u0641\u064A \u0627\u0644\u0645\u0633\u0627\u0621",
night:"\u0641\u064A \u0627\u0644\u0644\u064A\u0644"
},
wide:{
am:"\u0635",
pm:"\u0645",
midnight:"\u0646\u0635\u0641 \u0627\u0644\u0644\u064A\u0644",
noon:"\u0638\u0647\u0631",
morning:"\u0635\u0628\u0627\u062D\u0627\u064B",
afternoon:"\u0628\u0639\u062F \u0627\u0644\u0638\u0640\u0647\u0631",
evening:"\u0641\u064A \u0627\u0644\u0645\u0633\u0627\u0621",
night:"\u0641\u064A \u0627\u0644\u0644\u064A\u0644"
}
};
var ordinalNumber5=function ordinalNumber5(dirtyNumber){
return String(dirtyNumber);
};
var localize9={
ordinalNumber:ordinalNumber5,
era:buildLocalizeFn({
values:eraValues5,
defaultWidth:"wide"
}),
quarter:buildLocalizeFn({
values:quarterValues5,
defaultWidth:"wide",
argumentCallback:function argumentCallback(quarter){return Number(quarter)-1;}
}),
month:buildLocalizeFn({
values:monthValues5,
defaultWidth:"wide"
}),
day:buildLocalizeFn({
values:dayValues5,
defaultWidth:"wide"
}),
dayPeriod:buildLocalizeFn({
values:dayPeriodValues5,
defaultWidth:"wide",
formattingValues:formattingDayPeriodValues5,
defaultFormattingWidth:"wide"
})
};

// lib/locale/ar-MA/_lib/match.js
var matchOrdinalNumberPattern5=/^(\d+)(th|st|nd|rd)?/i;
var parseOrdinalNumberPattern5=/\d+/i;
var matchEraPatterns5={
narrow:/^(ق|ب)/i,
abbreviated:/^(ق\.?\s?م\.?|ق\.?\s?م\.?\s?|a\.?\s?d\.?|c\.?\s?)/i,
wide:/^(قبل الميلاد|قبل الميلاد|بعد الميلاد|بعد الميلاد)/i
};
var parseEraPatterns5={
any:[/^قبل/i,/^بعد/i]
};
var matchQuarterPatterns5={
narrow:/^[1234]/i,
abbreviated:/^ر[1234]/i,
wide:/^الربع [1234]/i
};
var parseQuarterPatterns5={
any:[/1/i,/2/i,/3/i,/4/i]
};
var matchMonthPatterns5={
narrow:/^[يفمأمسند]/i,
abbreviated:/^(ين|ف|مار|أب|ماي|يون|يول|غش|شت|أك|ن|د)/i,
wide:/^(ين|ف|مار|أب|ماي|يون|يول|غش|شت|أك|ن|د)/i
};
var parseMonthPatterns5={
narrow:[
/^ي/i,
/^ف/i,
/^م/i,
/^أ/i,
/^م/i,
/^ي/i,
/^ي/i,
/^غ/i,
/^ش/i,
/^أ/i,
/^ن/i,
/^د/i],

any:[
/^ين/i,
/^فب/i,
/^مار/i,
/^أب/i,
/^ماي/i,
/^يون/i,
/^يول/i,
/^غشت/i,
/^ش/i,
/^أك/i,
/^ن/i,
/^د/i]

};
var matchDayPatterns5={
narrow:/^[حنثرخجس]/i,
short:/^(أحد|إثنين|ثلاثاء|أربعاء|خميس|جمعة|سبت)/i,
abbreviated:/^(أحد|إثن|ثلا|أرب|خمي|جمعة|سبت)/i,
wide:/^(الأحد|الإثنين|الثلاثاء|الأربعاء|الخميس|الجمعة|السبت)/i
};
var parseDayPatterns5={
narrow:[/^ح/i,/^ن/i,/^ث/i,/^ر/i,/^خ/i,/^ج/i,/^س/i],
wide:[
/^الأحد/i,
/^الإثنين/i,
/^الثلاثاء/i,
/^الأربعاء/i,
/^الخميس/i,
/^الجمعة/i,
/^السبت/i],

any:[/^أح/i,/^إث/i,/^ث/i,/^أر/i,/^خ/i,/^ج/i,/^س/i]
};
var matchDayPeriodPatterns5={
narrow:/^(a|p|mi|n|(in the|at) (morning|afternoon|evening|night))/i,
any:/^([ap]\.?\s?m\.?|midnight|noon|(in the|at) (morning|afternoon|evening|night))/i
};
var parseDayPeriodPatterns5={
any:{
am:/^a/i,
pm:/^p/i,
midnight:/^mi/i,
noon:/^no/i,
morning:/morning/i,
afternoon:/afternoon/i,
evening:/evening/i,
night:/night/i
}
};
var match9={
ordinalNumber:buildMatchPatternFn({
matchPattern:matchOrdinalNumberPattern5,
parsePattern:parseOrdinalNumberPattern5,
valueCallback:function valueCallback(value){return parseInt(value,10);}
}),
era:buildMatchFn({
matchPatterns:matchEraPatterns5,
defaultMatchWidth:"wide",
parsePatterns:parseEraPatterns5,
defaultParseWidth:"any"
}),
quarter:buildMatchFn({
matchPatterns:matchQuarterPatterns5,
defaultMatchWidth:"wide",
parsePatterns:parseQuarterPatterns5,
defaultParseWidth:"any",
valueCallback:function valueCallback(index){return Number(index)+1;}
}),
month:buildMatchFn({
matchPatterns:matchMonthPatterns5,
defaultMatchWidth:"wide",
parsePatterns:parseMonthPatterns5,
defaultParseWidth:"any"
}),
day:buildMatchFn({
matchPatterns:matchDayPatterns5,
defaultMatchWidth:"wide",
parsePatterns:parseDayPatterns5,
defaultParseWidth:"any"
}),
dayPeriod:buildMatchFn({
matchPatterns:matchDayPeriodPatterns5,
defaultMatchWidth:"any",
parsePatterns:parseDayPeriodPatterns5,
defaultParseWidth:"any"
})
};

// lib/locale/ar-MA.js
var _arMA={
code:"ar-MA",
formatDistance:formatDistance9,
formatLong:formatLong9,
formatRelative:formatRelative9,
localize:localize9,
match:match9,
options:{
weekStartsOn:1,
firstWeekContainsDate:1
}
};
// lib/locale/ar-SA/_lib/formatDistance.js
var formatDistanceLocale6={
lessThanXSeconds:{
one:"\u0623\u0642\u0644 \u0645\u0646 \u062B\u0627\u0646\u064A\u0629 \u0648\u0627\u062D\u062F\u0629",
two:"\u0623\u0642\u0644 \u0645\u0646 \u062B\u0627\u0646\u062A\u064A\u0646",
threeToTen:"\u0623\u0642\u0644 \u0645\u0646 {{count}} \u062B\u0648\u0627\u0646\u064A",
other:"\u0623\u0642\u0644 \u0645\u0646 {{count}} \u062B\u0627\u0646\u064A\u0629"
},
xSeconds:{
one:"\u062B\u0627\u0646\u064A\u0629 \u0648\u0627\u062D\u062F\u0629",
two:"\u062B\u0627\u0646\u062A\u064A\u0646",
threeToTen:"{{count}} \u062B\u0648\u0627\u0646\u064A",
other:"{{count}} \u062B\u0627\u0646\u064A\u0629"
},
halfAMinute:"\u0646\u0635\u0641 \u062F\u0642\u064A\u0642\u0629",
lessThanXMinutes:{
one:"\u0623\u0642\u0644 \u0645\u0646 \u062F\u0642\u064A\u0642\u0629",
two:"\u0623\u0642\u0644 \u0645\u0646 \u062F\u0642\u064A\u0642\u062A\u064A\u0646",
threeToTen:"\u0623\u0642\u0644 \u0645\u0646 {{count}} \u062F\u0642\u0627\u0626\u0642",
other:"\u0623\u0642\u0644 \u0645\u0646 {{count}} \u062F\u0642\u064A\u0642\u0629"
},
xMinutes:{
one:"\u062F\u0642\u064A\u0642\u0629 \u0648\u0627\u062D\u062F\u0629",
two:"\u062F\u0642\u064A\u0642\u062A\u064A\u0646",
threeToTen:"{{count}} \u062F\u0642\u0627\u0626\u0642",
other:"{{count}} \u062F\u0642\u064A\u0642\u0629"
},
aboutXHours:{
one:"\u0633\u0627\u0639\u0629 \u0648\u0627\u062D\u062F\u0629 \u062A\u0642\u0631\u064A\u0628\u0627\u064B",
two:"\u0633\u0627\u0639\u062A\u064A\u0646 \u062A\u0642\u0631\u064A\u0628\u0627\u064B",
threeToTen:"{{count}} \u0633\u0627\u0639\u0627\u062A \u062A\u0642\u0631\u064A\u0628\u0627\u064B",
other:"{{count}} \u0633\u0627\u0639\u0629 \u062A\u0642\u0631\u064A\u0628\u0627\u064B"
},
xHours:{
one:"\u0633\u0627\u0639\u0629 \u0648\u0627\u062D\u062F\u0629",
two:"\u0633\u0627\u0639\u062A\u064A\u0646",
threeToTen:"{{count}} \u0633\u0627\u0639\u0627\u062A",
other:"{{count}} \u0633\u0627\u0639\u0629"
},
xDays:{
one:"\u064A\u0648\u0645 \u0648\u0627\u062D\u062F",
two:"\u064A\u0648\u0645\u064A\u0646",
threeToTen:"{{count}} \u0623\u064A\u0627\u0645",
other:"{{count}} \u064A\u0648\u0645"
},
aboutXWeeks:{
one:"\u0623\u0633\u0628\u0648\u0639 \u0648\u0627\u062D\u062F \u062A\u0642\u0631\u064A\u0628\u0627\u064B",
two:"\u0623\u0633\u0628\u0648\u0639\u064A\u0646 \u062A\u0642\u0631\u064A\u0628\u0627\u064B",
threeToTen:"{{count}} \u0623\u0633\u0627\u0628\u064A\u0639 \u062A\u0642\u0631\u064A\u0628\u0627\u064B",
other:"{{count}} \u0623\u0633\u0628\u0648\u0639 \u062A\u0642\u0631\u064A\u0628\u0627\u064B"
},
xWeeks:{
one:"\u0623\u0633\u0628\u0648\u0639 \u0648\u0627\u062D\u062F",
two:"\u0623\u0633\u0628\u0648\u0639\u064A\u0646",
threeToTen:"{{count}} \u0623\u0633\u0627\u0628\u064A\u0639",
other:"{{count}} \u0623\u0633\u0628\u0648\u0639"
},
aboutXMonths:{
one:"\u0634\u0647\u0631 \u0648\u0627\u062D\u062F \u062A\u0642\u0631\u064A\u0628\u0627\u064B",
two:"\u0634\u0647\u0631\u064A\u0646 \u062A\u0642\u0631\u064A\u0628\u0627\u064B",
threeToTen:"{{count}} \u0623\u0634\u0647\u0631 \u062A\u0642\u0631\u064A\u0628\u0627\u064B",
other:"{{count}} \u0634\u0647\u0631 \u062A\u0642\u0631\u064A\u0628\u0627\u064B"
},
xMonths:{
one:"\u0634\u0647\u0631 \u0648\u0627\u062D\u062F",
two:"\u0634\u0647\u0631\u064A\u0646",
threeToTen:"{{count}} \u0623\u0634\u0647\u0631",
other:"{{count}} \u0634\u0647\u0631"
},
aboutXYears:{
one:"\u0639\u0627\u0645 \u0648\u0627\u062D\u062F \u062A\u0642\u0631\u064A\u0628\u0627\u064B",
two:"\u0639\u0627\u0645\u064A\u0646 \u062A\u0642\u0631\u064A\u0628\u0627\u064B",
threeToTen:"{{count}} \u0623\u0639\u0648\u0627\u0645 \u062A\u0642\u0631\u064A\u0628\u0627\u064B",
other:"{{count}} \u0639\u0627\u0645 \u062A\u0642\u0631\u064A\u0628\u0627\u064B"
},
xYears:{
one:"\u0639\u0627\u0645 \u0648\u0627\u062D\u062F",
two:"\u0639\u0627\u0645\u064A\u0646",
threeToTen:"{{count}} \u0623\u0639\u0648\u0627\u0645",
other:"{{count}} \u0639\u0627\u0645"
},
overXYears:{
one:"\u0623\u0643\u062B\u0631 \u0645\u0646 \u0639\u0627\u0645",
two:"\u0623\u0643\u062B\u0631 \u0645\u0646 \u0639\u0627\u0645\u064A\u0646",
threeToTen:"\u0623\u0643\u062B\u0631 \u0645\u0646 {{count}} \u0623\u0639\u0648\u0627\u0645",
other:"\u0623\u0643\u062B\u0631 \u0645\u0646 {{count}} \u0639\u0627\u0645"
},
almostXYears:{
one:"\u0639\u0627\u0645 \u0648\u0627\u062D\u062F \u062A\u0642\u0631\u064A\u0628\u0627\u064B",
two:"\u0639\u0627\u0645\u064A\u0646 \u062A\u0642\u0631\u064A\u0628\u0627\u064B",
threeToTen:"{{count}} \u0623\u0639\u0648\u0627\u0645 \u062A\u0642\u0631\u064A\u0628\u0627\u064B",
other:"{{count}} \u0639\u0627\u0645 \u062A\u0642\u0631\u064A\u0628\u0627\u064B"
}
};
var formatDistance11=function formatDistance11(token,count,options){
var result;
var tokenValue=formatDistanceLocale6[token];
if(typeof tokenValue==="string"){
result=tokenValue;
}else if(count===1){
result=tokenValue.one;
}else if(count===2){
result=tokenValue.two;
}else if(count<=10){
result=tokenValue.threeToTen.replace("{{count}}",String(count));
}else{
result=tokenValue.other.replace("{{count}}",String(count));
}
if(options!==null&&options!==void 0&&options.addSuffix){
if(options.comparison&&options.comparison>0){
return"\u0641\u064A \u062E\u0644\u0627\u0644 "+result;
}else{
return"\u0645\u0646\u0630 "+result;
}
}
return result;
};

// lib/locale/ar-SA/_lib/formatLong.js
var dateFormats6={
full:"EEEE, MMMM do, y",
long:"MMMM do, y",
medium:"MMM d, y",
short:"MM/dd/yyyy"
};
var timeFormats6={
full:"h:mm:ss a zzzz",
long:"h:mm:ss a z",
medium:"h:mm:ss a",
short:"h:mm a"
};
var dateTimeFormats6={
full:"{{date}} '\u0639\u0646\u062F' {{time}}",
long:"{{date}} '\u0639\u0646\u062F' {{time}}",
medium:"{{date}}, {{time}}",
short:"{{date}}, {{time}}"
};
var formatLong11={
date:buildFormatLongFn({
formats:dateFormats6,
defaultWidth:"full"
}),
time:buildFormatLongFn({
formats:timeFormats6,
defaultWidth:"full"
}),
dateTime:buildFormatLongFn({
formats:dateTimeFormats6,
defaultWidth:"full"
})
};

// lib/locale/ar-SA/_lib/formatRelative.js
var formatRelativeLocale6={
lastWeek:"'\u0623\u062E\u0631' eeee '\u0639\u0646\u062F' p",
yesterday:"'\u0623\u0645\u0633 \u0639\u0646\u062F' p",
today:"'\u0627\u0644\u064A\u0648\u0645 \u0639\u0646\u062F' p",
tomorrow:"'\u063A\u062F\u0627\u064B \u0639\u0646\u062F' p",
nextWeek:"eeee '\u0639\u0646\u062F' p",
other:"P"
};
var formatRelative11=function formatRelative11(token,_date,_baseDate,_options){return formatRelativeLocale6[token];};

// lib/locale/ar-SA/_lib/localize.js
var eraValues6={
narrow:["\u0642","\u0628"],
abbreviated:["\u0642.\u0645.","\u0628.\u0645."],
wide:["\u0642\u0628\u0644 \u0627\u0644\u0645\u064A\u0644\u0627\u062F","\u0628\u0639\u062F \u0627\u0644\u0645\u064A\u0644\u0627\u062F"]
};
var quarterValues6={
narrow:["1","2","3","4"],
abbreviated:["\u06311","\u06312","\u06313","\u06314"],
wide:["\u0627\u0644\u0631\u0628\u0639 \u0627\u0644\u0623\u0648\u0644","\u0627\u0644\u0631\u0628\u0639 \u0627\u0644\u062B\u0627\u0646\u064A","\u0627\u0644\u0631\u0628\u0639 \u0627\u0644\u062B\u0627\u0644\u062B","\u0627\u0644\u0631\u0628\u0639 \u0627\u0644\u0631\u0627\u0628\u0639"]
};
var monthValues6={
narrow:["\u064A","\u0641","\u0645","\u0623","\u0645","\u064A","\u064A","\u0623","\u0633","\u0623","\u0646","\u062F"],
abbreviated:[
"\u064A\u0646\u0627",
"\u0641\u0628\u0631",
"\u0645\u0627\u0631\u0633",
"\u0623\u0628\u0631\u064A\u0644",
"\u0645\u0627\u064A\u0648",
"\u064A\u0648\u0646\u0640",
"\u064A\u0648\u0644\u0640",
"\u0623\u063A\u0633\u0640",
"\u0633\u0628\u062A\u0640",
"\u0623\u0643\u062A\u0640",
"\u0646\u0648\u0641\u0640",
"\u062F\u064A\u0633\u0640"],

wide:[
"\u064A\u0646\u0627\u064A\u0631",
"\u0641\u0628\u0631\u0627\u064A\u0631",
"\u0645\u0627\u0631\u0633",
"\u0623\u0628\u0631\u064A\u0644",
"\u0645\u0627\u064A\u0648",
"\u064A\u0648\u0646\u064A\u0648",
"\u064A\u0648\u0644\u064A\u0648",
"\u0623\u063A\u0633\u0637\u0633",
"\u0633\u0628\u062A\u0645\u0628\u0631",
"\u0623\u0643\u062A\u0648\u0628\u0631",
"\u0646\u0648\u0641\u0645\u0628\u0631",
"\u062F\u064A\u0633\u0645\u0628\u0631"]

};
var dayValues6={
narrow:["\u062D","\u0646","\u062B","\u0631","\u062E","\u062C","\u0633"],
short:["\u0623\u062D\u062F","\u0627\u062B\u0646\u064A\u0646","\u062B\u0644\u0627\u062B\u0627\u0621","\u0623\u0631\u0628\u0639\u0627\u0621","\u062E\u0645\u064A\u0633","\u062C\u0645\u0639\u0629","\u0633\u0628\u062A"],
abbreviated:["\u0623\u062D\u062F","\u0627\u062B\u0646\u0640","\u062B\u0644\u0627","\u0623\u0631\u0628\u0640","\u062E\u0645\u064A\u0640","\u062C\u0645\u0639\u0629","\u0633\u0628\u062A"],
wide:[
"\u0627\u0644\u0623\u062D\u062F",
"\u0627\u0644\u0627\u062B\u0646\u064A\u0646",
"\u0627\u0644\u062B\u0644\u0627\u062B\u0627\u0621",
"\u0627\u0644\u0623\u0631\u0628\u0639\u0627\u0621",
"\u0627\u0644\u062E\u0645\u064A\u0633",
"\u0627\u0644\u062C\u0645\u0639\u0629",
"\u0627\u0644\u0633\u0628\u062A"]

};
var dayPeriodValues6={
narrow:{
am:"\u0635",
pm:"\u0645",
midnight:"\u0646",
noon:"\u0638",
morning:"\u0635\u0628\u0627\u062D\u0627\u064B",
afternoon:"\u0628\u0639\u062F \u0627\u0644\u0638\u0647\u0631",
evening:"\u0645\u0633\u0627\u0621\u0627\u064B",
night:"\u0644\u064A\u0644\u0627\u064B"
},
abbreviated:{
am:"\u0635",
pm:"\u0645",
midnight:"\u0646\u0635\u0641 \u0627\u0644\u0644\u064A\u0644",
noon:"\u0638\u0647\u0631",
morning:"\u0635\u0628\u0627\u062D\u0627\u064B",
afternoon:"\u0628\u0639\u062F \u0627\u0644\u0638\u0647\u0631",
evening:"\u0645\u0633\u0627\u0621\u0627\u064B",
night:"\u0644\u064A\u0644\u0627\u064B"
},
wide:{
am:"\u0635",
pm:"\u0645",
midnight:"\u0646\u0635\u0641 \u0627\u0644\u0644\u064A\u0644",
noon:"\u0638\u0647\u0631",
morning:"\u0635\u0628\u0627\u062D\u0627\u064B",
afternoon:"\u0628\u0639\u062F \u0627\u0644\u0638\u0647\u0631",
evening:"\u0645\u0633\u0627\u0621\u0627\u064B",
night:"\u0644\u064A\u0644\u0627\u064B"
}
};
var formattingDayPeriodValues6={
narrow:{
am:"\u0635",
pm:"\u0645",
midnight:"\u0646",
noon:"\u0638",
morning:"\u0641\u064A \u0627\u0644\u0635\u0628\u0627\u062D",
afternoon:"\u0628\u0639\u062F \u0627\u0644\u0638\u0640\u0647\u0631",
evening:"\u0641\u064A \u0627\u0644\u0645\u0633\u0627\u0621",
night:"\u0641\u064A \u0627\u0644\u0644\u064A\u0644"
},
abbreviated:{
am:"\u0635",
pm:"\u0645",
midnight:"\u0646\u0635\u0641 \u0627\u0644\u0644\u064A\u0644",
noon:"\u0638\u0647\u0631",
morning:"\u0641\u064A \u0627\u0644\u0635\u0628\u0627\u062D",
afternoon:"\u0628\u0639\u062F \u0627\u0644\u0638\u0647\u0631",
evening:"\u0641\u064A \u0627\u0644\u0645\u0633\u0627\u0621",
night:"\u0641\u064A \u0627\u0644\u0644\u064A\u0644"
},
wide:{
am:"\u0635",
pm:"\u0645",
midnight:"\u0646\u0635\u0641 \u0627\u0644\u0644\u064A\u0644",
noon:"\u0638\u0647\u0631",
morning:"\u0635\u0628\u0627\u062D\u0627\u064B",
afternoon:"\u0628\u0639\u062F \u0627\u0644\u0638\u0640\u0647\u0631",
evening:"\u0641\u064A \u0627\u0644\u0645\u0633\u0627\u0621",
night:"\u0641\u064A \u0627\u0644\u0644\u064A\u0644"
}
};
var ordinalNumber6=function ordinalNumber6(dirtyNumber){
return String(dirtyNumber);
};
var localize11={
ordinalNumber:ordinalNumber6,
era:buildLocalizeFn({
values:eraValues6,
defaultWidth:"wide"
}),
quarter:buildLocalizeFn({
values:quarterValues6,
defaultWidth:"wide",
argumentCallback:function argumentCallback(quarter){return quarter-1;}
}),
month:buildLocalizeFn({
values:monthValues6,
defaultWidth:"wide"
}),
day:buildLocalizeFn({
values:dayValues6,
defaultWidth:"wide"
}),
dayPeriod:buildLocalizeFn({
values:dayPeriodValues6,
defaultWidth:"wide",
formattingValues:formattingDayPeriodValues6,
defaultFormattingWidth:"wide"
})
};

// lib/locale/ar-SA/_lib/match.js
var matchOrdinalNumberPattern6=/^(\d+)(th|st|nd|rd)?/i;
var parseOrdinalNumberPattern6=/\d+/i;
var matchEraPatterns6={
narrow:/^(ق|ب)/i,
abbreviated:/^(ق\.?\s?م\.?|ق\.?\s?م\.?\s?|a\.?\s?d\.?|c\.?\s?)/i,
wide:/^(قبل الميلاد|قبل الميلاد|بعد الميلاد|بعد الميلاد)/i
};
var parseEraPatterns6={
any:[/^قبل/i,/^بعد/i]
};
var matchQuarterPatterns6={
narrow:/^[1234]/i,
abbreviated:/^ر[1234]/i,
wide:/^الربع [1234]/i
};
var parseQuarterPatterns6={
any:[/1/i,/2/i,/3/i,/4/i]
};
var matchMonthPatterns6={
narrow:/^[يفمأمسند]/i,
abbreviated:/^(ين|ف|مار|أب|ماي|يون|يول|أغ|س|أك|ن|د)/i,
wide:/^(ين|ف|مار|أب|ماي|يون|يول|أغ|س|أك|ن|د)/i
};
var parseMonthPatterns6={
narrow:[
/^ي/i,
/^ف/i,
/^م/i,
/^أ/i,
/^م/i,
/^ي/i,
/^ي/i,
/^أ/i,
/^س/i,
/^أ/i,
/^ن/i,
/^د/i],

any:[
/^ين/i,
/^ف/i,
/^مار/i,
/^أب/i,
/^ماي/i,
/^يون/i,
/^يول/i,
/^أغ/i,
/^س/i,
/^أك/i,
/^ن/i,
/^د/i]

};
var matchDayPatterns6={
narrow:/^[حنثرخجس]/i,
short:/^(أحد|اثنين|ثلاثاء|أربعاء|خميس|جمعة|سبت)/i,
abbreviated:/^(أحد|اثن|ثلا|أرب|خمي|جمعة|سبت)/i,
wide:/^(الأحد|الاثنين|الثلاثاء|الأربعاء|الخميس|الجمعة|السبت)/i
};
var parseDayPatterns6={
narrow:[/^ح/i,/^ن/i,/^ث/i,/^ر/i,/^خ/i,/^ج/i,/^س/i],
wide:[
/^الأحد/i,
/^الاثنين/i,
/^الثلاثاء/i,
/^الأربعاء/i,
/^الخميس/i,
/^الجمعة/i,
/^السبت/i],

any:[/^أح/i,/^اث/i,/^ث/i,/^أر/i,/^خ/i,/^ج/i,/^س/i]
};
var matchDayPeriodPatterns6={
narrow:/^(a|p|mi|n|(in the|at) (morning|afternoon|evening|night))/i,
any:/^([ap]\.?\s?m\.?|midnight|noon|(in the|at) (morning|afternoon|evening|night))/i
};
var parseDayPeriodPatterns6={
any:{
am:/^a/i,
pm:/^p/i,
midnight:/^mi/i,
noon:/^no/i,
morning:/morning/i,
afternoon:/afternoon/i,
evening:/evening/i,
night:/night/i
}
};
var match11={
ordinalNumber:buildMatchPatternFn({
matchPattern:matchOrdinalNumberPattern6,
parsePattern:parseOrdinalNumberPattern6,
valueCallback:function valueCallback(value){return parseInt(value,10);}
}),
era:buildMatchFn({
matchPatterns:matchEraPatterns6,
defaultMatchWidth:"wide",
parsePatterns:parseEraPatterns6,
defaultParseWidth:"any"
}),
quarter:buildMatchFn({
matchPatterns:matchQuarterPatterns6,
defaultMatchWidth:"wide",
parsePatterns:parseQuarterPatterns6,
defaultParseWidth:"any",
valueCallback:function valueCallback(index){return index+1;}
}),
month:buildMatchFn({
matchPatterns:matchMonthPatterns6,
defaultMatchWidth:"wide",
parsePatterns:parseMonthPatterns6,
defaultParseWidth:"any"
}),
day:buildMatchFn({
matchPatterns:matchDayPatterns6,
defaultMatchWidth:"wide",
parsePatterns:parseDayPatterns6,
defaultParseWidth:"any"
}),
dayPeriod:buildMatchFn({
matchPatterns:matchDayPeriodPatterns6,
defaultMatchWidth:"any",
parsePatterns:parseDayPeriodPatterns6,
defaultParseWidth:"any"
})
};

// lib/locale/ar-SA.js
var _arSA={
code:"ar-SA",
formatDistance:formatDistance11,
formatLong:formatLong11,
formatRelative:formatRelative11,
localize:localize11,
match:match11,
options:{
weekStartsOn:0,
firstWeekContainsDate:1
}
};
// lib/locale/ar-TN/_lib/formatDistance.js
var formatDistanceLocale7={
lessThanXSeconds:{
one:"\u0623\u0642\u0644 \u0645\u0646 \u062B\u0627\u0646\u064A\u0629",
two:"\u0623\u0642\u0644 \u0645\u0646 \u0632\u0648\u0632 \u062B\u0648\u0627\u0646\u064A",
threeToTen:"\u0623\u0642\u0644 \u0645\u0646 {{count}} \u062B\u0648\u0627\u0646\u064A",
other:"\u0623\u0642\u0644 \u0645\u0646 {{count}} \u062B\u0627\u0646\u064A\u0629"
},
xSeconds:{
one:"\u062B\u0627\u0646\u064A\u0629",
two:"\u0632\u0648\u0632 \u062B\u0648\u0627\u0646\u064A",
threeToTen:"{{count}} \u062B\u0648\u0627\u0646\u064A",
other:"{{count}} \u062B\u0627\u0646\u064A\u0629"
},
halfAMinute:"\u0646\u0635 \u062F\u0642\u064A\u0642\u0629",
lessThanXMinutes:{
one:"\u0623\u0642\u0644 \u0645\u0646 \u062F\u0642\u064A\u0642\u0629",
two:"\u0623\u0642\u0644 \u0645\u0646 \u062F\u0642\u064A\u0642\u062A\u064A\u0646",
threeToTen:"\u0623\u0642\u0644 \u0645\u0646 {{count}} \u062F\u0642\u0627\u064A\u0642",
other:"\u0623\u0642\u0644 \u0645\u0646 {{count}} \u062F\u0642\u064A\u0642\u0629"
},
xMinutes:{
one:"\u062F\u0642\u064A\u0642\u0629",
two:"\u062F\u0642\u064A\u0642\u062A\u064A\u0646",
threeToTen:"{{count}} \u062F\u0642\u0627\u064A\u0642",
other:"{{count}} \u062F\u0642\u064A\u0642\u0629"
},
aboutXHours:{
one:"\u0633\u0627\u0639\u0629 \u062A\u0642\u0631\u064A\u0628",
two:"\u0633\u0627\u0639\u062A\u064A\u0646 \u062A\u0642\u0631\u064A\u0628",
threeToTen:"{{count}} \u0633\u0648\u0627\u064A\u0639 \u062A\u0642\u0631\u064A\u0628",
other:"{{count}} \u0633\u0627\u0639\u0629 \u062A\u0642\u0631\u064A\u0628"
},
xHours:{
one:"\u0633\u0627\u0639\u0629",
two:"\u0633\u0627\u0639\u062A\u064A\u0646",
threeToTen:"{{count}} \u0633\u0648\u0627\u064A\u0639",
other:"{{count}} \u0633\u0627\u0639\u0629"
},
xDays:{
one:"\u0646\u0647\u0627\u0631",
two:"\u0646\u0647\u0627\u0631\u064A\u0646",
threeToTen:"{{count}} \u0623\u064A\u0627\u0645",
other:"{{count}} \u064A\u0648\u0645"
},
aboutXWeeks:{
one:"\u062C\u0645\u0639\u0629 \u062A\u0642\u0631\u064A\u0628",
two:"\u062C\u0645\u0639\u062A\u064A\u0646 \u062A\u0642\u0631\u064A\u0628",
threeToTen:"{{count}} \u062C\u0645\u0627\u0639 \u062A\u0642\u0631\u064A\u0628",
other:"{{count}} \u062C\u0645\u0639\u0629 \u062A\u0642\u0631\u064A\u0628"
},
xWeeks:{
one:"\u062C\u0645\u0639\u0629",
two:"\u062C\u0645\u0639\u062A\u064A\u0646",
threeToTen:"{{count}} \u062C\u0645\u0627\u0639",
other:"{{count}} \u062C\u0645\u0639\u0629"
},
aboutXMonths:{
one:"\u0634\u0647\u0631 \u062A\u0642\u0631\u064A\u0628",
two:"\u0634\u0647\u0631\u064A\u0646 \u062A\u0642\u0631\u064A\u0628",
threeToTen:"{{count}} \u0623\u0634\u0647\u0631\u0629 \u062A\u0642\u0631\u064A\u0628",
other:"{{count}} \u0634\u0647\u0631 \u062A\u0642\u0631\u064A\u0628"
},
xMonths:{
one:"\u0634\u0647\u0631",
two:"\u0634\u0647\u0631\u064A\u0646",
threeToTen:"{{count}} \u0623\u0634\u0647\u0631\u0629",
other:"{{count}} \u0634\u0647\u0631"
},
aboutXYears:{
one:"\u0639\u0627\u0645 \u062A\u0642\u0631\u064A\u0628",
two:"\u0639\u0627\u0645\u064A\u0646 \u062A\u0642\u0631\u064A\u0628",
threeToTen:"{{count}} \u0623\u0639\u0648\u0627\u0645 \u062A\u0642\u0631\u064A\u0628",
other:"{{count}} \u0639\u0627\u0645 \u062A\u0642\u0631\u064A\u0628"
},
xYears:{
one:"\u0639\u0627\u0645",
two:"\u0639\u0627\u0645\u064A\u0646",
threeToTen:"{{count}} \u0623\u0639\u0648\u0627\u0645",
other:"{{count}} \u0639\u0627\u0645"
},
overXYears:{
one:"\u0623\u0643\u062B\u0631 \u0645\u0646 \u0639\u0627\u0645",
two:"\u0623\u0643\u062B\u0631 \u0645\u0646 \u0639\u0627\u0645\u064A\u0646",
threeToTen:"\u0623\u0643\u062B\u0631 \u0645\u0646 {{count}} \u0623\u0639\u0648\u0627\u0645",
other:"\u0623\u0643\u062B\u0631 \u0645\u0646 {{count}} \u0639\u0627\u0645"
},
almostXYears:{
one:"\u0639\u0627\u0645 \u062A\u0642\u0631\u064A\u0628",
two:"\u0639\u0627\u0645\u064A\u0646 \u062A\u0642\u0631\u064A\u0628",
threeToTen:"{{count}} \u0623\u0639\u0648\u0627\u0645 \u062A\u0642\u0631\u064A\u0628",
other:"{{count}} \u0639\u0627\u0645 \u062A\u0642\u0631\u064A\u0628"
}
};
var formatDistance13=function formatDistance13(token,count,options){
var usageGroup=formatDistanceLocale7[token];
var result;
if(typeof usageGroup==="string"){
result=usageGroup;
}else if(count===1){
result=usageGroup.one;
}else if(count===2){
result=usageGroup.two;
}else if(count<=10){
result=usageGroup.threeToTen.replace("{{count}}",String(count));
}else{
result=usageGroup.other.replace("{{count}}",String(count));
}
if(options!==null&&options!==void 0&&options.addSuffix){
if(options.comparison&&options.comparison>0){
return"\u0641\u064A "+result;
}else{
return"\u0639\u0646\u062F\u0648 "+result;
}
}
return result;
};

// lib/locale/ar-TN/_lib/formatLong.js
var dateFormats7={
full:"EEEE\u060C do MMMM y",
long:"do MMMM y",
medium:"d MMM y",
short:"dd/MM/yyyy"
};
var timeFormats7={
full:"HH:mm:ss",
long:"HH:mm:ss",
medium:"HH:mm:ss",
short:"HH:mm"
};
var dateTimeFormats7={
full:"{{date}} '\u0645\u0639' {{time}}",
long:"{{date}} '\u0645\u0639' {{time}}",
medium:"{{date}}, {{time}}",
short:"{{date}}, {{time}}"
};
var formatLong13={
date:buildFormatLongFn({
formats:dateFormats7,
defaultWidth:"full"
}),
time:buildFormatLongFn({
formats:timeFormats7,
defaultWidth:"full"
}),
dateTime:buildFormatLongFn({
formats:dateTimeFormats7,
defaultWidth:"full"
})
};

// lib/locale/ar-TN/_lib/formatRelative.js
var formatRelativeLocale7={
lastWeek:"eeee '\u0625\u0644\u064A \u0641\u0627\u062A \u0645\u0639' p",
yesterday:"'\u0627\u0644\u0628\u0627\u0631\u062D \u0645\u0639' p",
today:"'\u0627\u0644\u064A\u0648\u0645 \u0645\u0639' p",
tomorrow:"'\u063A\u062F\u0648\u0629 \u0645\u0639' p",
nextWeek:"eeee '\u0627\u0644\u062C\u0645\u0639\u0629 \u0627\u0644\u062C\u0627\u064A\u0629 \u0645\u0639' p '\u0646\u0647\u0627\u0631'",
other:"P"
};
var formatRelative13=function formatRelative13(token){return formatRelativeLocale7[token];};

// lib/locale/ar-TN/_lib/localize.js
var eraValues7={
narrow:["\u0642","\u0628"],
abbreviated:["\u0642.\u0645.","\u0628.\u0645."],
wide:["\u0642\u0628\u0644 \u0627\u0644\u0645\u064A\u0644\u0627\u062F","\u0628\u0639\u062F \u0627\u0644\u0645\u064A\u0644\u0627\u062F"]
};
var quarterValues7={
narrow:["1","2","3","4"],
abbreviated:["\u06311","\u06312","\u06313","\u06314"],
wide:["\u0627\u0644\u0631\u0628\u0639 \u0627\u0644\u0623\u0648\u0644","\u0627\u0644\u0631\u0628\u0639 \u0627\u0644\u062B\u0627\u0646\u064A","\u0627\u0644\u0631\u0628\u0639 \u0627\u0644\u062B\u0627\u0644\u062B","\u0627\u0644\u0631\u0628\u0639 \u0627\u0644\u0631\u0627\u0628\u0639"]
};
var monthValues7={
narrow:["\u062F","\u0646","\u0623","\u0633","\u0623","\u062C","\u062C","\u0645","\u0623","\u0645","\u0641","\u062C"],
abbreviated:[
"\u062C\u0627\u0646\u0641\u064A",
"\u0641\u064A\u0641\u0631\u064A",
"\u0645\u0627\u0631\u0633",
"\u0623\u0641\u0631\u064A\u0644",
"\u0645\u0627\u064A",
"\u062C\u0648\u0627\u0646",
"\u062C\u0648\u064A\u0644\u064A\u0629",
"\u0623\u0648\u062A",
"\u0633\u0628\u062A\u0645\u0628\u0631",
"\u0623\u0643\u062A\u0648\u0628\u0631",
"\u0646\u0648\u0641\u0645\u0628\u0631",
"\u062F\u064A\u0633\u0645\u0628\u0631"],

wide:[
"\u062C\u0627\u0646\u0641\u064A",
"\u0641\u064A\u0641\u0631\u064A",
"\u0645\u0627\u0631\u0633",
"\u0623\u0641\u0631\u064A\u0644",
"\u0645\u0627\u064A",
"\u062C\u0648\u0627\u0646",
"\u062C\u0648\u064A\u0644\u064A\u0629",
"\u0623\u0648\u062A",
"\u0633\u0628\u062A\u0645\u0628\u0631",
"\u0623\u0643\u062A\u0648\u0628\u0631",
"\u0646\u0648\u0641\u0645\u0628\u0631",
"\u062F\u064A\u0633\u0645\u0628\u0631"]

};
var dayValues7={
narrow:["\u062D","\u0646","\u062B","\u0631","\u062E","\u062C","\u0633"],
short:["\u0623\u062D\u062F","\u0627\u062B\u0646\u064A\u0646","\u062B\u0644\u0627\u062B\u0627\u0621","\u0623\u0631\u0628\u0639\u0627\u0621","\u062E\u0645\u064A\u0633","\u062C\u0645\u0639\u0629","\u0633\u0628\u062A"],
abbreviated:["\u0623\u062D\u062F","\u0627\u062B\u0646\u064A\u0646","\u062B\u0644\u0627\u062B\u0627\u0621","\u0623\u0631\u0628\u0639\u0627\u0621","\u062E\u0645\u064A\u0633","\u062C\u0645\u0639\u0629","\u0633\u0628\u062A"],
wide:[
"\u0627\u0644\u0623\u062D\u062F",
"\u0627\u0644\u0627\u062B\u0646\u064A\u0646",
"\u0627\u0644\u062B\u0644\u0627\u062B\u0627\u0621",
"\u0627\u0644\u0623\u0631\u0628\u0639\u0627\u0621",
"\u0627\u0644\u062E\u0645\u064A\u0633",
"\u0627\u0644\u062C\u0645\u0639\u0629",
"\u0627\u0644\u0633\u0628\u062A"]

};
var dayPeriodValues7={
narrow:{
am:"\u0635",
pm:"\u0639",
morning:"\u0627\u0644\u0635\u0628\u0627\u062D",
noon:"\u0627\u0644\u0642\u0627\u064A\u0644\u0629",
afternoon:"\u0628\u0639\u062F \u0627\u0644\u0642\u0627\u064A\u0644\u0629",
evening:"\u0627\u0644\u0639\u0634\u064A\u0629",
night:"\u0627\u0644\u0644\u064A\u0644",
midnight:"\u0646\u0635 \u0627\u0644\u0644\u064A\u0644"
},
abbreviated:{
am:"\u0635",
pm:"\u0639",
morning:"\u0627\u0644\u0635\u0628\u0627\u062D",
noon:"\u0627\u0644\u0642\u0627\u064A\u0644\u0629",
afternoon:"\u0628\u0639\u062F \u0627\u0644\u0642\u0627\u064A\u0644\u0629",
evening:"\u0627\u0644\u0639\u0634\u064A\u0629",
night:"\u0627\u0644\u0644\u064A\u0644",
midnight:"\u0646\u0635 \u0627\u0644\u0644\u064A\u0644"
},
wide:{
am:"\u0635",
pm:"\u0639",
morning:"\u0627\u0644\u0635\u0628\u0627\u062D",
noon:"\u0627\u0644\u0642\u0627\u064A\u0644\u0629",
afternoon:"\u0628\u0639\u062F \u0627\u0644\u0642\u0627\u064A\u0644\u0629",
evening:"\u0627\u0644\u0639\u0634\u064A\u0629",
night:"\u0627\u0644\u0644\u064A\u0644",
midnight:"\u0646\u0635 \u0627\u0644\u0644\u064A\u0644"
}
};
var formattingDayPeriodValues7={
narrow:{
am:"\u0635",
pm:"\u0639",
morning:"\u0641\u064A \u0627\u0644\u0635\u0628\u0627\u062D",
noon:"\u0641\u064A \u0627\u0644\u0642\u0627\u064A\u0644\u0629",
afternoon:"\u0628\u0639\u062F \u0627\u0644\u0642\u0627\u064A\u0644\u0629",
evening:"\u0641\u064A \u0627\u0644\u0639\u0634\u064A\u0629",
night:"\u0641\u064A \u0627\u0644\u0644\u064A\u0644",
midnight:"\u0646\u0635 \u0627\u0644\u0644\u064A\u0644"
},
abbreviated:{
am:"\u0635",
pm:"\u0639",
morning:"\u0641\u064A \u0627\u0644\u0635\u0628\u0627\u062D",
noon:"\u0641\u064A \u0627\u0644\u0642\u0627\u064A\u0644\u0629",
afternoon:"\u0628\u0639\u062F \u0627\u0644\u0642\u0627\u064A\u0644\u0629",
evening:"\u0641\u064A \u0627\u0644\u0639\u0634\u064A\u0629",
night:"\u0641\u064A \u0627\u0644\u0644\u064A\u0644",
midnight:"\u0646\u0635 \u0627\u0644\u0644\u064A\u0644"
},
wide:{
am:"\u0635",
pm:"\u0639",
morning:"\u0641\u064A \u0627\u0644\u0635\u0628\u0627\u062D",
noon:"\u0641\u064A \u0627\u0644\u0642\u0627\u064A\u0644\u0629",
afternoon:"\u0628\u0639\u062F \u0627\u0644\u0642\u0627\u064A\u0644\u0629",
evening:"\u0641\u064A \u0627\u0644\u0639\u0634\u064A\u0629",
night:"\u0641\u064A \u0627\u0644\u0644\u064A\u0644",
midnight:"\u0646\u0635 \u0627\u0644\u0644\u064A\u0644"
}
};
var ordinalNumber7=function ordinalNumber7(num){return String(num);};
var localize13={
ordinalNumber:ordinalNumber7,
era:buildLocalizeFn({
values:eraValues7,
defaultWidth:"wide"
}),
quarter:buildLocalizeFn({
values:quarterValues7,
defaultWidth:"wide",
argumentCallback:function argumentCallback(quarter){return quarter-1;}
}),
month:buildLocalizeFn({
values:monthValues7,
defaultWidth:"wide"
}),
day:buildLocalizeFn({
values:dayValues7,
defaultWidth:"wide"
}),
dayPeriod:buildLocalizeFn({
values:dayPeriodValues7,
defaultWidth:"wide",
formattingValues:formattingDayPeriodValues7,
defaultFormattingWidth:"wide"
})
};

// lib/locale/ar-TN/_lib/match.js
var matchOrdinalNumberPattern7=/^(\d+)(th|st|nd|rd)?/i;
var parseOrdinalNumberPattern7=/\d+/i;
var matchEraPatterns7={
narrow:/[قب]/,
abbreviated:/[قب]\.م\./,
wide:/(قبل|بعد) الميلاد/
};
var parseEraPatterns7={
any:[/قبل/,/بعد/]
};
var matchQuarterPatterns7={
narrow:/^[1234]/i,
abbreviated:/ر[1234]/,
wide:/الربع (الأول|الثاني|الثالث|الرابع)/
};
var parseQuarterPatterns7={
any:[/1/i,/2/i,/3/i,/4/i]
};
var matchMonthPatterns7={
narrow:/^[جفمأسند]/,
abbreviated:/^(جانفي|فيفري|مارس|أفريل|ماي|جوان|جويلية|أوت|سبتمبر|أكتوبر|نوفمبر|ديسمبر)/,
wide:/^(جانفي|فيفري|مارس|أفريل|ماي|جوان|جويلية|أوت|سبتمبر|أكتوبر|نوفمبر|ديسمبر)/
};
var parseMonthPatterns7={
narrow:[
/^ج/i,
/^ف/i,
/^م/i,
/^أ/i,
/^م/i,
/^ج/i,
/^ج/i,
/^أ/i,
/^س/i,
/^أ/i,
/^ن/i,
/^د/i],

any:[
/^جانفي/i,
/^فيفري/i,
/^مارس/i,
/^أفريل/i,
/^ماي/i,
/^جوان/i,
/^جويلية/i,
/^أوت/i,
/^سبتمبر/i,
/^أكتوبر/i,
/^نوفمبر/i,
/^ديسمبر/i]

};
var matchDayPatterns7={
narrow:/^[حنثرخجس]/i,
short:/^(أحد|اثنين|ثلاثاء|أربعاء|خميس|جمعة|سبت)/i,
abbreviated:/^(أحد|اثنين|ثلاثاء|أربعاء|خميس|جمعة|سبت)/i,
wide:/^(الأحد|الاثنين|الثلاثاء|الأربعاء|الخميس|الجمعة|السبت)/i
};
var parseDayPatterns7={
narrow:[/^ح/i,/^ن/i,/^ث/i,/^ر/i,/^خ/i,/^ج/i,/^س/i],
wide:[
/^الأحد/i,
/^الاثنين/i,
/^الثلاثاء/i,
/^الأربعاء/i,
/^الخميس/i,
/^الجمعة/i,
/^السبت/i],

any:[/^أح/i,/^اث/i,/^ث/i,/^أر/i,/^خ/i,/^ج/i,/^س/i]
};
var matchDayPeriodPatterns7={
narrow:/^(ص|ع|ن ل|ل|(في|مع) (صباح|قايلة|عشية|ليل))/,
any:/^([صع]|نص الليل|قايلة|(في|مع) (صباح|قايلة|عشية|ليل))/
};
var parseDayPeriodPatterns7={
any:{
am:/^ص/,
pm:/^ع/,
midnight:/نص الليل/,
noon:/قايلة/,
afternoon:/بعد القايلة/,
morning:/صباح/,
evening:/عشية/,
night:/ليل/
}
};
var match13={
ordinalNumber:buildMatchPatternFn({
matchPattern:matchOrdinalNumberPattern7,
parsePattern:parseOrdinalNumberPattern7,
valueCallback:function valueCallback(value){return parseInt(value,10);}
}),
era:buildMatchFn({
matchPatterns:matchEraPatterns7,
defaultMatchWidth:"wide",
parsePatterns:parseEraPatterns7,
defaultParseWidth:"any"
}),
quarter:buildMatchFn({
matchPatterns:matchQuarterPatterns7,
defaultMatchWidth:"wide",
parsePatterns:parseQuarterPatterns7,
defaultParseWidth:"any",
valueCallback:function valueCallback(index){return index+1;}
}),
month:buildMatchFn({
matchPatterns:matchMonthPatterns7,
defaultMatchWidth:"wide",
parsePatterns:parseMonthPatterns7,
defaultParseWidth:"any"
}),
day:buildMatchFn({
matchPatterns:matchDayPatterns7,
defaultMatchWidth:"wide",
parsePatterns:parseDayPatterns7,
defaultParseWidth:"any"
}),
dayPeriod:buildMatchFn({
matchPatterns:matchDayPeriodPatterns7,
defaultMatchWidth:"any",
parsePatterns:parseDayPeriodPatterns7,
defaultParseWidth:"any"
})
};

// lib/locale/ar-TN.js
var _arTN={
code:"ar-TN",
formatDistance:formatDistance13,
formatLong:formatLong13,
formatRelative:formatRelative13,
localize:localize13,
match:match13,
options:{
weekStartsOn:1,
firstWeekContainsDate:1
}
};
// lib/locale/az/_lib/formatDistance.js
var formatDistanceLocale8={
lessThanXSeconds:{
one:"bir saniy\u0259d\u0259n az",
other:"{{count}} bir saniy\u0259d\u0259n az"
},
xSeconds:{
one:"1 saniy\u0259",
other:"{{count}} saniy\u0259"
},
halfAMinute:"yar\u0131m d\u0259qiq\u0259",
lessThanXMinutes:{
one:"bir d\u0259qiq\u0259d\u0259n az",
other:"{{count}} bir d\u0259qiq\u0259d\u0259n az"
},
xMinutes:{
one:"bir d\u0259qiq\u0259",
other:"{{count}} d\u0259qiq\u0259"
},
aboutXHours:{
one:"t\u0259xmin\u0259n 1 saat",
other:"t\u0259xmin\u0259n {{count}} saat"
},
xHours:{
one:"1 saat",
other:"{{count}} saat"
},
xDays:{
one:"1 g\xFCn",
other:"{{count}} g\xFCn"
},
aboutXWeeks:{
one:"t\u0259xmin\u0259n 1 h\u0259ft\u0259",
other:"t\u0259xmin\u0259n {{count}} h\u0259ft\u0259"
},
xWeeks:{
one:"1 h\u0259ft\u0259",
other:"{{count}} h\u0259ft\u0259"
},
aboutXMonths:{
one:"t\u0259xmin\u0259n 1 ay",
other:"t\u0259xmin\u0259n {{count}} ay"
},
xMonths:{
one:"1 ay",
other:"{{count}} ay"
},
aboutXYears:{
one:"t\u0259xmin\u0259n 1 il",
other:"t\u0259xmin\u0259n {{count}} il"
},
xYears:{
one:"1 il",
other:"{{count}} il"
},
overXYears:{
one:"1 ild\u0259n \xE7ox",
other:"{{count}} ild\u0259n \xE7ox"
},
almostXYears:{
one:"dem\u0259k olar ki 1 il",
other:"dem\u0259k olar ki {{count}} il"
}
};
var formatDistance15=function formatDistance15(token,count,options){
var result;
var tokenValue=formatDistanceLocale8[token];
if(typeof tokenValue==="string"){
result=tokenValue;
}else if(count===1){
result=tokenValue.one;
}else{
result=tokenValue.other.replace("{{count}}",String(count));
}
if(options!==null&&options!==void 0&&options.addSuffix){
if(options.comparison&&options.comparison>0){
return result+" sonra";
}else{
return result+" \u0259vv\u0259l";
}
}
return result;
};

// lib/locale/az/_lib/formatLong.js
var dateFormats8={
full:"EEEE, do MMMM y 'il'",
long:"do MMMM y 'il'",
medium:"d MMM y 'il'",
short:"dd.MM.yyyy"
};
var timeFormats8={
full:"H:mm:ss zzzz",
long:"H:mm:ss z",
medium:"H:mm:ss",
short:"H:mm"
};
var dateTimeFormats8={
full:"{{date}} {{time}} - 'd\u0259'",
long:"{{date}} {{time}} - 'd\u0259'",
medium:"{{date}}, {{time}}",
short:"{{date}}, {{time}}"
};
var formatLong15={
date:buildFormatLongFn({
formats:dateFormats8,
defaultWidth:"full"
}),
time:buildFormatLongFn({
formats:timeFormats8,
defaultWidth:"full"
}),
dateTime:buildFormatLongFn({
formats:dateTimeFormats8,
defaultWidth:"full"
})
};

// lib/locale/az/_lib/formatRelative.js
var formatRelativeLocale8={
lastWeek:"'sonuncu' eeee p -'d\u0259'",
yesterday:"'d\xFCn\u0259n' p -'d\u0259'",
today:"'bug\xFCn' p -'d\u0259'",
tomorrow:"'sabah' p -'d\u0259'",
nextWeek:"eeee p -'d\u0259'",
other:"P"
};
var formatRelative15=function formatRelative15(token,_date,_baseDate,_options){return formatRelativeLocale8[token];};

// lib/locale/az/_lib/localize.js
var eraValues8={
narrow:["e.\u0259","b.e"],
abbreviated:["e.\u0259","b.e"],
wide:["eram\u0131zdan \u0259vv\u0259l","bizim era"]
};
var quarterValues8={
narrow:["1","2","3","4"],
abbreviated:["K1","K2","K3","K4"],
wide:["1ci kvartal","2ci kvartal","3c\xFC kvartal","4c\xFC kvartal"]
};
var monthValues8={
narrow:["Y","F","M","A","M","\u0130","\u0130","A","S","O","N","D"],
abbreviated:[
"Yan",
"Fev",
"Mar",
"Apr",
"May",
"\u0130yun",
"\u0130yul",
"Avq",
"Sen",
"Okt",
"Noy",
"Dek"],

wide:[
"Yanvar",
"Fevral",
"Mart",
"Aprel",
"May",
"\u0130yun",
"\u0130yul",
"Avqust",
"Sentyabr",
"Oktyabr",
"Noyabr",
"Dekabr"]

};
var dayValues8={
narrow:["B.","B.e","\xC7.a","\xC7.","C.a","C.","\u015E."],
short:["B.","B.e","\xC7.a","\xC7.","C.a","C.","\u015E."],
abbreviated:["Baz","Baz.e","\xC7\u0259r.a","\xC7\u0259r","C\xFCm.a","C\xFCm","\u015E\u0259"],
wide:[
"Bazar",
"Bazar ert\u0259si",
"\xC7\u0259r\u015F\u0259nb\u0259 ax\u015Fam\u0131",
"\xC7\u0259r\u015F\u0259nb\u0259",
"C\xFCm\u0259 ax\u015Fam\u0131",
"C\xFCm\u0259",
"\u015E\u0259nb\u0259"]

};
var dayPeriodValues8={
narrow:{
am:"am",
pm:"pm",
midnight:"gec\u0259yar\u0131",
noon:"g\xFCn",
morning:"s\u0259h\u0259r",
afternoon:"g\xFCnd\xFCz",
evening:"ax\u015Fam",
night:"gec\u0259"
},
abbreviated:{
am:"AM",
pm:"PM",
midnight:"gec\u0259yar\u0131",
noon:"g\xFCn",
morning:"s\u0259h\u0259r",
afternoon:"g\xFCnd\xFCz",
evening:"ax\u015Fam",
night:"gec\u0259"
},
wide:{
am:"a.m.",
pm:"p.m.",
midnight:"gec\u0259yar\u0131",
noon:"g\xFCn",
morning:"s\u0259h\u0259r",
afternoon:"g\xFCnd\xFCz",
evening:"ax\u015Fam",
night:"gec\u0259"
}
};
var formattingDayPeriodValues8={
narrow:{
am:"a",
pm:"p",
midnight:"gec\u0259yar\u0131",
noon:"g\xFCn",
morning:"s\u0259h\u0259r",
afternoon:"g\xFCnd\xFCz",
evening:"ax\u015Fam",
night:"gec\u0259"
},
abbreviated:{
am:"AM",
pm:"PM",
midnight:"gec\u0259yar\u0131",
noon:"g\xFCn",
morning:"s\u0259h\u0259r",
afternoon:"g\xFCnd\xFCz",
evening:"ax\u015Fam",
night:"gec\u0259"
},
wide:{
am:"a.m.",
pm:"p.m.",
midnight:"gec\u0259yar\u0131",
noon:"g\xFCn",
morning:"s\u0259h\u0259r",
afternoon:"g\xFCnd\xFCz",
evening:"ax\u015Fam",
night:"gec\u0259"
}
};
var suffixes={
1:"-inci",
5:"-inci",
8:"-inci",
70:"-inci",
80:"-inci",
2:"-nci",
7:"-nci",
20:"-nci",
50:"-nci",
3:"-\xFCnc\xFC",
4:"-\xFCnc\xFC",
100:"-\xFCnc\xFC",
6:"-nc\u0131",
9:"-uncu",
10:"-uncu",
30:"-uncu",
60:"-\u0131nc\u0131",
90:"-\u0131nc\u0131"
};
var getSuffix=function getSuffix(number){
if(number===0){
return number+"-\u0131nc\u0131";
}
var a=number%10;
var b=number%100-a;
var c=number>=100?100:null;
if(suffixes[a]){
return suffixes[a];
}else if(suffixes[b]){
return suffixes[b];
}else if(c!==null){
return suffixes[c];
}
return"";
};
var ordinalNumber8=function ordinalNumber8(dirtyNumber,_options){
var number=Number(dirtyNumber);
var suffix=getSuffix(number);
return number+suffix;
};
var localize15={
ordinalNumber:ordinalNumber8,
era:buildLocalizeFn({
values:eraValues8,
defaultWidth:"wide"
}),
quarter:buildLocalizeFn({
values:quarterValues8,
defaultWidth:"wide",
argumentCallback:function argumentCallback(quarter){return quarter-1;}
}),
month:buildLocalizeFn({
values:monthValues8,
defaultWidth:"wide"
}),
day:buildLocalizeFn({
values:dayValues8,
defaultWidth:"wide"
}),
dayPeriod:buildLocalizeFn({
values:dayPeriodValues8,
defaultWidth:"wide",
formattingValues:formattingDayPeriodValues8,
defaultFormattingWidth:"wide"
})
};

// lib/locale/az/_lib/match.js
var matchOrdinalNumberPattern8=/^(\d+)(-?(ci|inci|nci|uncu|üncü|ncı))?/i;
var parseOrdinalNumberPattern8=/\d+/i;
var matchEraPatterns8={
narrow:/^(b|a)$/i,
abbreviated:/^(b\.?\s?c\.?|b\.?\s?c\.?\s?e\.?|a\.?\s?d\.?|c\.?\s?e\.?)$/i,
wide:/^(bizim eradan əvvəl|bizim era)$/i
};
var parseEraPatterns8={
any:[/^b$/i,/^(a|c)$/i]
};
var matchQuarterPatterns8={
narrow:/^[1234]$/i,
abbreviated:/^K[1234]$/i,
wide:/^[1234](ci)? kvartal$/i
};
var parseQuarterPatterns8={
any:[/1/i,/2/i,/3/i,/4/i]
};
var matchMonthPatterns8={
narrow:/^[(?-i)yfmaisond]$/i,
abbreviated:/^(Yan|Fev|Mar|Apr|May|İyun|İyul|Avq|Sen|Okt|Noy|Dek)$/i,
wide:/^(Yanvar|Fevral|Mart|Aprel|May|İyun|İyul|Avgust|Sentyabr|Oktyabr|Noyabr|Dekabr)$/i
};
var parseMonthPatterns8={
narrow:[
/^[(?-i)y]$/i,
/^[(?-i)f]$/i,
/^[(?-i)m]$/i,
/^[(?-i)a]$/i,
/^[(?-i)m]$/i,
/^[(?-i)i]$/i,
/^[(?-i)i]$/i,
/^[(?-i)a]$/i,
/^[(?-i)s]$/i,
/^[(?-i)o]$/i,
/^[(?-i)n]$/i,
/^[(?-i)d]$/i],

abbreviated:[
/^Yan$/i,
/^Fev$/i,
/^Mar$/i,
/^Apr$/i,
/^May$/i,
/^İyun$/i,
/^İyul$/i,
/^Avg$/i,
/^Sen$/i,
/^Okt$/i,
/^Noy$/i,
/^Dek$/i],

wide:[
/^Yanvar$/i,
/^Fevral$/i,
/^Mart$/i,
/^Aprel$/i,
/^May$/i,
/^İyun$/i,
/^İyul$/i,
/^Avgust$/i,
/^Sentyabr$/i,
/^Oktyabr$/i,
/^Noyabr$/i,
/^Dekabr$/i]

};
var matchDayPatterns8={
narrow:/^(B\.|B\.e|Ç\.a|Ç\.|C\.a|C\.|Ş\.)$/i,
short:/^(B\.|B\.e|Ç\.a|Ç\.|C\.a|C\.|Ş\.)$/i,
abbreviated:/^(Baz\.e|Çər|Çər\.a|Cüm|Cüm\.a|Şə)$/i,
wide:/^(Bazar|Bazar ertəsi|Çərşənbə axşamı|Çərşənbə|Cümə axşamı|Cümə|Şənbə)$/i
};
var parseDayPatterns8={
narrow:[
/^B\.$/i,
/^B\.e$/i,
/^Ç\.a$/i,
/^Ç\.$/i,
/^C\.a$/i,
/^C\.$/i,
/^Ş\.$/i],

abbreviated:[
/^Baz$/i,
/^Baz\.e$/i,
/^Çər\.a$/i,
/^Çər$/i,
/^Cüm\.a$/i,
/^Cüm$/i,
/^Şə$/i],

wide:[
/^Bazar$/i,
/^Bazar ertəsi$/i,
/^Çərşənbə axşamı$/i,
/^Çərşənbə$/i,
/^Cümə axşamı$/i,
/^Cümə$/i,
/^Şənbə$/i],

any:[
/^B\.$/i,
/^B\.e$/i,
/^Ç\.a$/i,
/^Ç\.$/i,
/^C\.a$/i,
/^C\.$/i,
/^Ş\.$/i]

};
var matchDayPeriodPatterns8={
narrow:/^(a|p|gecəyarı|gün|səhər|gündüz|axşam|gecə)$/i,
any:/^(am|pm|a\.m\.|p\.m\.|AM|PM|gecəyarı|gün|səhər|gündüz|axşam|gecə)$/i
};
var parseDayPeriodPatterns8={
any:{
am:/^a$/i,
pm:/^p$/i,
midnight:/^gecəyarı$/i,
noon:/^gün$/i,
morning:/səhər$/i,
afternoon:/gündüz$/i,
evening:/axşam$/i,
night:/gecə$/i
}
};
var match15={
ordinalNumber:buildMatchPatternFn({
matchPattern:matchOrdinalNumberPattern8,
parsePattern:parseOrdinalNumberPattern8,
valueCallback:function valueCallback(value){return parseInt(value,10);}
}),
era:buildMatchFn({
matchPatterns:matchEraPatterns8,
defaultMatchWidth:"wide",
parsePatterns:parseEraPatterns8,
defaultParseWidth:"any"
}),
quarter:buildMatchFn({
matchPatterns:matchQuarterPatterns8,
defaultMatchWidth:"wide",
parsePatterns:parseQuarterPatterns8,
defaultParseWidth:"any",
valueCallback:function valueCallback(index){return index+1;}
}),
month:buildMatchFn({
matchPatterns:matchMonthPatterns8,
defaultMatchWidth:"wide",
parsePatterns:parseMonthPatterns8,
defaultParseWidth:"narrow"
}),
day:buildMatchFn({
matchPatterns:matchDayPatterns8,
defaultMatchWidth:"wide",
parsePatterns:parseDayPatterns8,
defaultParseWidth:"any"
}),
dayPeriod:buildMatchFn({
matchPatterns:matchDayPeriodPatterns8,
defaultMatchWidth:"any",
parsePatterns:parseDayPeriodPatterns8,
defaultParseWidth:"any"
})
};

// lib/locale/az.js
var _az={
code:"az",
formatDistance:formatDistance15,
formatLong:formatLong15,
formatRelative:formatRelative15,
localize:localize15,
match:match15,
options:{
weekStartsOn:1,
firstWeekContainsDate:1
}
};
// lib/locale/be/_lib/formatDistance.js
function declension(scheme,count){
if(scheme.one!==undefined&&count===1){
return scheme.one;
}
var rem10=count%10;
var rem100=count%100;
if(rem10===1&&rem100!==11){
return scheme.singularNominative.replace("{{count}}",String(count));
}else if(rem10>=2&&rem10<=4&&(rem100<10||rem100>20)){
return scheme.singularGenitive.replace("{{count}}",String(count));
}else{
return scheme.pluralGenitive.replace("{{count}}",String(count));
}
}
function buildLocalizeTokenFn(scheme){
return function(count,options){
if(options&&options.addSuffix){
if(options.comparison&&options.comparison>0){
if(scheme.future){
return declension(scheme.future,count);
}else{
return"\u043F\u0440\u0430\u0437 "+declension(scheme.regular,count);
}
}else{
if(scheme.past){
return declension(scheme.past,count);
}else{
return declension(scheme.regular,count)+" \u0442\u0430\u043C\u0443";
}
}
}else{
return declension(scheme.regular,count);
}
};
}
var halfAMinute=function halfAMinute(_,options){
if(options&&options.addSuffix){
if(options.comparison&&options.comparison>0){
return"\u043F\u0440\u0430\u0437 \u043F\u0430\u045E\u0445\u0432\u0456\u043B\u0456\u043D\u044B";
}else{
return"\u043F\u0430\u045E\u0445\u0432\u0456\u043B\u0456\u043D\u044B \u0442\u0430\u043C\u0443";
}
}
return"\u043F\u0430\u045E\u0445\u0432\u0456\u043B\u0456\u043D\u044B";
};
var formatDistanceLocale9={
lessThanXSeconds:buildLocalizeTokenFn({
regular:{
one:"\u043C\u0435\u043D\u0448 \u0437\u0430 \u0441\u0435\u043A\u0443\u043D\u0434\u0443",
singularNominative:"\u043C\u0435\u043D\u0448 \u0437\u0430 {{count}} \u0441\u0435\u043A\u0443\u043D\u0434\u0443",
singularGenitive:"\u043C\u0435\u043D\u0448 \u0437\u0430 {{count}} \u0441\u0435\u043A\u0443\u043D\u0434\u044B",
pluralGenitive:"\u043C\u0435\u043D\u0448 \u0437\u0430 {{count}} \u0441\u0435\u043A\u0443\u043D\u0434"
},
future:{
one:"\u043C\u0435\u043D\u0448, \u0447\u044B\u043C \u043F\u0440\u0430\u0437 \u0441\u0435\u043A\u0443\u043D\u0434\u0443",
singularNominative:"\u043C\u0435\u043D\u0448, \u0447\u044B\u043C \u043F\u0440\u0430\u0437 {{count}} \u0441\u0435\u043A\u0443\u043D\u0434\u0443",
singularGenitive:"\u043C\u0435\u043D\u0448, \u0447\u044B\u043C \u043F\u0440\u0430\u0437 {{count}} \u0441\u0435\u043A\u0443\u043D\u0434\u044B",
pluralGenitive:"\u043C\u0435\u043D\u0448, \u0447\u044B\u043C \u043F\u0440\u0430\u0437 {{count}} \u0441\u0435\u043A\u0443\u043D\u0434"
}
}),
xSeconds:buildLocalizeTokenFn({
regular:{
singularNominative:"{{count}} \u0441\u0435\u043A\u0443\u043D\u0434\u0430",
singularGenitive:"{{count}} \u0441\u0435\u043A\u0443\u043D\u0434\u044B",
pluralGenitive:"{{count}} \u0441\u0435\u043A\u0443\u043D\u0434"
},
past:{
singularNominative:"{{count}} \u0441\u0435\u043A\u0443\u043D\u0434\u0443 \u0442\u0430\u043C\u0443",
singularGenitive:"{{count}} \u0441\u0435\u043A\u0443\u043D\u0434\u044B \u0442\u0430\u043C\u0443",
pluralGenitive:"{{count}} \u0441\u0435\u043A\u0443\u043D\u0434 \u0442\u0430\u043C\u0443"
},
future:{
singularNominative:"\u043F\u0440\u0430\u0437 {{count}} \u0441\u0435\u043A\u0443\u043D\u0434\u0443",
singularGenitive:"\u043F\u0440\u0430\u0437 {{count}} \u0441\u0435\u043A\u0443\u043D\u0434\u044B",
pluralGenitive:"\u043F\u0440\u0430\u0437 {{count}} \u0441\u0435\u043A\u0443\u043D\u0434"
}
}),
halfAMinute:halfAMinute,
lessThanXMinutes:buildLocalizeTokenFn({
regular:{
one:"\u043C\u0435\u043D\u0448 \u0437\u0430 \u0445\u0432\u0456\u043B\u0456\u043D\u0443",
singularNominative:"\u043C\u0435\u043D\u0448 \u0437\u0430 {{count}} \u0445\u0432\u0456\u043B\u0456\u043D\u0443",
singularGenitive:"\u043C\u0435\u043D\u0448 \u0437\u0430 {{count}} \u0445\u0432\u0456\u043B\u0456\u043D\u044B",
pluralGenitive:"\u043C\u0435\u043D\u0448 \u0437\u0430 {{count}} \u0445\u0432\u0456\u043B\u0456\u043D"
},
future:{
one:"\u043C\u0435\u043D\u0448, \u0447\u044B\u043C \u043F\u0440\u0430\u0437 \u0445\u0432\u0456\u043B\u0456\u043D\u0443",
singularNominative:"\u043C\u0435\u043D\u0448, \u0447\u044B\u043C \u043F\u0440\u0430\u0437 {{count}} \u0445\u0432\u0456\u043B\u0456\u043D\u0443",
singularGenitive:"\u043C\u0435\u043D\u0448, \u0447\u044B\u043C \u043F\u0440\u0430\u0437 {{count}} \u0445\u0432\u0456\u043B\u0456\u043D\u044B",
pluralGenitive:"\u043C\u0435\u043D\u0448, \u0447\u044B\u043C \u043F\u0440\u0430\u0437 {{count}} \u0445\u0432\u0456\u043B\u0456\u043D"
}
}),
xMinutes:buildLocalizeTokenFn({
regular:{
singularNominative:"{{count}} \u0445\u0432\u0456\u043B\u0456\u043D\u0430",
singularGenitive:"{{count}} \u0445\u0432\u0456\u043B\u0456\u043D\u044B",
pluralGenitive:"{{count}} \u0445\u0432\u0456\u043B\u0456\u043D"
},
past:{
singularNominative:"{{count}} \u0445\u0432\u0456\u043B\u0456\u043D\u0443 \u0442\u0430\u043C\u0443",
singularGenitive:"{{count}} \u0445\u0432\u0456\u043B\u0456\u043D\u044B \u0442\u0430\u043C\u0443",
pluralGenitive:"{{count}} \u0445\u0432\u0456\u043B\u0456\u043D \u0442\u0430\u043C\u0443"
},
future:{
singularNominative:"\u043F\u0440\u0430\u0437 {{count}} \u0445\u0432\u0456\u043B\u0456\u043D\u0443",
singularGenitive:"\u043F\u0440\u0430\u0437 {{count}} \u0445\u0432\u0456\u043B\u0456\u043D\u044B",
pluralGenitive:"\u043F\u0440\u0430\u0437 {{count}} \u0445\u0432\u0456\u043B\u0456\u043D"
}
}),
aboutXHours:buildLocalizeTokenFn({
regular:{
singularNominative:"\u043A\u0430\u043B\u044F {{count}} \u0433\u0430\u0434\u0437\u0456\u043D\u044B",
singularGenitive:"\u043A\u0430\u043B\u044F {{count}} \u0433\u0430\u0434\u0437\u0456\u043D",
pluralGenitive:"\u043A\u0430\u043B\u044F {{count}} \u0433\u0430\u0434\u0437\u0456\u043D"
},
future:{
singularNominative:"\u043F\u0440\u044B\u0431\u043B\u0456\u0437\u043D\u0430 \u043F\u0440\u0430\u0437 {{count}} \u0433\u0430\u0434\u0437\u0456\u043D\u0443",
singularGenitive:"\u043F\u0440\u044B\u0431\u043B\u0456\u0437\u043D\u0430 \u043F\u0440\u0430\u0437 {{count}} \u0433\u0430\u0434\u0437\u0456\u043D\u044B",
pluralGenitive:"\u043F\u0440\u044B\u0431\u043B\u0456\u0437\u043D\u0430 \u043F\u0440\u0430\u0437 {{count}} \u0433\u0430\u0434\u0437\u0456\u043D"
}
}),
xHours:buildLocalizeTokenFn({
regular:{
singularNominative:"{{count}} \u0433\u0430\u0434\u0437\u0456\u043D\u0430",
singularGenitive:"{{count}} \u0433\u0430\u0434\u0437\u0456\u043D\u044B",
pluralGenitive:"{{count}} \u0433\u0430\u0434\u0437\u0456\u043D"
},
past:{
singularNominative:"{{count}} \u0433\u0430\u0434\u0437\u0456\u043D\u0443 \u0442\u0430\u043C\u0443",
singularGenitive:"{{count}} \u0433\u0430\u0434\u0437\u0456\u043D\u044B \u0442\u0430\u043C\u0443",
pluralGenitive:"{{count}} \u0433\u0430\u0434\u0437\u0456\u043D \u0442\u0430\u043C\u0443"
},
future:{
singularNominative:"\u043F\u0440\u0430\u0437 {{count}} \u0433\u0430\u0434\u0437\u0456\u043D\u0443",
singularGenitive:"\u043F\u0440\u0430\u0437 {{count}} \u0433\u0430\u0434\u0437\u0456\u043D\u044B",
pluralGenitive:"\u043F\u0440\u0430\u0437 {{count}} \u0433\u0430\u0434\u0437\u0456\u043D"
}
}),
xDays:buildLocalizeTokenFn({
regular:{
singularNominative:"{{count}} \u0434\u0437\u0435\u043D\u044C",
singularGenitive:"{{count}} \u0434\u043D\u0456",
pluralGenitive:"{{count}} \u0434\u0437\u0451\u043D"
}
}),
aboutXWeeks:buildLocalizeTokenFn({
regular:{
singularNominative:"\u043A\u0430\u043B\u044F {{count}} \u0442\u044B\u0434\u043D\u0456",
singularGenitive:"\u043A\u0430\u043B\u044F {{count}} \u0442\u044B\u0434\u043D\u044F\u045E",
pluralGenitive:"\u043A\u0430\u043B\u044F {{count}} \u0442\u044B\u0434\u043D\u044F\u045E"
},
future:{
singularNominative:"\u043F\u0440\u044B\u0431\u043B\u0456\u0437\u043D\u0430 \u043F\u0440\u0430\u0437 {{count}} \u0442\u044B\u0434\u0437\u0435\u043D\u044C",
singularGenitive:"\u043F\u0440\u044B\u0431\u043B\u0456\u0437\u043D\u0430 \u043F\u0440\u0430\u0437 {{count}} \u0442\u044B\u0434\u043D\u0456",
pluralGenitive:"\u043F\u0440\u044B\u0431\u043B\u0456\u0437\u043D\u0430 \u043F\u0440\u0430\u0437 {{count}} \u0442\u044B\u0434\u043D\u044F\u045E"
}
}),
xWeeks:buildLocalizeTokenFn({
regular:{
singularNominative:"{{count}} \u0442\u044B\u0434\u0437\u0435\u043D\u044C",
singularGenitive:"{{count}} \u0442\u044B\u0434\u043D\u0456",
pluralGenitive:"{{count}} \u0442\u044B\u0434\u043D\u044F\u045E"
}
}),
aboutXMonths:buildLocalizeTokenFn({
regular:{
singularNominative:"\u043A\u0430\u043B\u044F {{count}} \u043C\u0435\u0441\u044F\u0446\u0430",
singularGenitive:"\u043A\u0430\u043B\u044F {{count}} \u043C\u0435\u0441\u044F\u0446\u0430\u045E",
pluralGenitive:"\u043A\u0430\u043B\u044F {{count}} \u043C\u0435\u0441\u044F\u0446\u0430\u045E"
},
future:{
singularNominative:"\u043F\u0440\u044B\u0431\u043B\u0456\u0437\u043D\u0430 \u043F\u0440\u0430\u0437 {{count}} \u043C\u0435\u0441\u044F\u0446",
singularGenitive:"\u043F\u0440\u044B\u0431\u043B\u0456\u0437\u043D\u0430 \u043F\u0440\u0430\u0437 {{count}} \u043C\u0435\u0441\u044F\u0446\u044B",
pluralGenitive:"\u043F\u0440\u044B\u0431\u043B\u0456\u0437\u043D\u0430 \u043F\u0440\u0430\u0437 {{count}} \u043C\u0435\u0441\u044F\u0446\u0430\u045E"
}
}),
xMonths:buildLocalizeTokenFn({
regular:{
singularNominative:"{{count}} \u043C\u0435\u0441\u044F\u0446",
singularGenitive:"{{count}} \u043C\u0435\u0441\u044F\u0446\u044B",
pluralGenitive:"{{count}} \u043C\u0435\u0441\u044F\u0446\u0430\u045E"
}
}),
aboutXYears:buildLocalizeTokenFn({
regular:{
singularNominative:"\u043A\u0430\u043B\u044F {{count}} \u0433\u043E\u0434\u0430",
singularGenitive:"\u043A\u0430\u043B\u044F {{count}} \u0433\u0430\u0434\u043E\u045E",
pluralGenitive:"\u043A\u0430\u043B\u044F {{count}} \u0433\u0430\u0434\u043E\u045E"
},
future:{
singularNominative:"\u043F\u0440\u044B\u0431\u043B\u0456\u0437\u043D\u0430 \u043F\u0440\u0430\u0437 {{count}} \u0433\u043E\u0434",
singularGenitive:"\u043F\u0440\u044B\u0431\u043B\u0456\u0437\u043D\u0430 \u043F\u0440\u0430\u0437 {{count}} \u0433\u0430\u0434\u044B",
pluralGenitive:"\u043F\u0440\u044B\u0431\u043B\u0456\u0437\u043D\u0430 \u043F\u0440\u0430\u0437 {{count}} \u0433\u0430\u0434\u043E\u045E"
}
}),
xYears:buildLocalizeTokenFn({
regular:{
singularNominative:"{{count}} \u0433\u043E\u0434",
singularGenitive:"{{count}} \u0433\u0430\u0434\u044B",
pluralGenitive:"{{count}} \u0433\u0430\u0434\u043E\u045E"
}
}),
overXYears:buildLocalizeTokenFn({
regular:{
singularNominative:"\u0431\u043E\u043B\u044C\u0448 \u0437\u0430 {{count}} \u0433\u043E\u0434",
singularGenitive:"\u0431\u043E\u043B\u044C\u0448 \u0437\u0430 {{count}} \u0433\u0430\u0434\u044B",
pluralGenitive:"\u0431\u043E\u043B\u044C\u0448 \u0437\u0430 {{count}} \u0433\u0430\u0434\u043E\u045E"
},
future:{
singularNominative:"\u0431\u043E\u043B\u044C\u0448, \u0447\u044B\u043C \u043F\u0440\u0430\u0437 {{count}} \u0433\u043E\u0434",
singularGenitive:"\u0431\u043E\u043B\u044C\u0448, \u0447\u044B\u043C \u043F\u0440\u0430\u0437 {{count}} \u0433\u0430\u0434\u044B",
pluralGenitive:"\u0431\u043E\u043B\u044C\u0448, \u0447\u044B\u043C \u043F\u0440\u0430\u0437 {{count}} \u0433\u0430\u0434\u043E\u045E"
}
}),
almostXYears:buildLocalizeTokenFn({
regular:{
singularNominative:"\u0430\u043C\u0430\u043B\u044C {{count}} \u0433\u043E\u0434",
singularGenitive:"\u0430\u043C\u0430\u043B\u044C {{count}} \u0433\u0430\u0434\u044B",
pluralGenitive:"\u0430\u043C\u0430\u043B\u044C {{count}} \u0433\u0430\u0434\u043E\u045E"
},
future:{
singularNominative:"\u0430\u043C\u0430\u043B\u044C \u043F\u0440\u0430\u0437 {{count}} \u0433\u043E\u0434",
singularGenitive:"\u0430\u043C\u0430\u043B\u044C \u043F\u0440\u0430\u0437 {{count}} \u0433\u0430\u0434\u044B",
pluralGenitive:"\u0430\u043C\u0430\u043B\u044C \u043F\u0440\u0430\u0437 {{count}} \u0433\u0430\u0434\u043E\u045E"
}
})
};
var formatDistance17=function formatDistance17(token,count,options){
options=options||{};
return formatDistanceLocale9[token](count,options);
};

// lib/locale/be/_lib/formatLong.js
var dateFormats9={
full:"EEEE, d MMMM y '\u0433.'",
long:"d MMMM y '\u0433.'",
medium:"d MMM y '\u0433.'",
short:"dd.MM.y"
};
var timeFormats9={
full:"H:mm:ss zzzz",
long:"H:mm:ss z",
medium:"H:mm:ss",
short:"H:mm"
};
var dateTimeFormats9={
any:"{{date}}, {{time}}"
};
var formatLong17={
date:buildFormatLongFn({
formats:dateFormats9,
defaultWidth:"full"
}),
time:buildFormatLongFn({
formats:timeFormats9,
defaultWidth:"full"
}),
dateTime:buildFormatLongFn({
formats:dateTimeFormats9,
defaultWidth:"any"
})
};

// lib/constants.js
var daysInWeek=7;
var daysInYear=365.2425;
var maxTime=Math.pow(10,8)*24*60*60*1000;
var minTime=-maxTime;
var millisecondsInWeek=604800000;
var millisecondsInDay=86400000;
var millisecondsInMinute=60000;
var millisecondsInHour=3600000;
var millisecondsInSecond=1000;
var minutesInYear=525600;
var minutesInMonth=43200;
var minutesInDay=1440;
var minutesInHour=60;
var monthsInQuarter=3;
var monthsInYear=12;
var quartersInYear=4;
var secondsInHour=3600;
var secondsInMinute=60;
var secondsInDay=secondsInHour*24;
var secondsInWeek=secondsInDay*7;
var secondsInYear=secondsInDay*daysInYear;
var secondsInMonth=secondsInYear/12;
var secondsInQuarter=secondsInMonth*3;
var constructFromSymbol=Symbol.for("constructDateFrom");

// lib/constructFrom.js
function constructFrom(date,value){
if(typeof date==="function")
return date(value);
if(_typeof(date)==="object"&&constructFromSymbol in date)
return date[constructFromSymbol](value);
if(date instanceof Date)
return new date.constructor(value);
return new Date(value);
}

// lib/_lib/normalizeDates.js
function normalizeDates(context){for(var _len=arguments.length,dates=new Array(_len>1?_len-1:0),_key2=1;_key2<_len;_key2++){dates[_key2-1]=arguments[_key2];}
var normalize=context||constructFrom.bind(null,dates.find(function(date){return _typeof(date)==="object";}));
return dates.map(normalize);
}

// lib/_lib/defaultOptions.js
function getDefaultOptions(){
return defaultOptions;
}
function setDefaultOptions(newOptions){
defaultOptions=newOptions;
}
var defaultOptions={};

// lib/toDate.js
function toDate(argument,context){
if(context)
return context(argument);
var argStr=Object.prototype.toString.call(argument);
if(_typeof(argument)==="object"&&constructFromSymbol in argument){
return argument[constructFromSymbol](argument);
}else if(argument instanceof Date||_typeof(argument)==="object"&&argStr==="[object Date]"){
return new argument.constructor(+argument);
}else if(typeof argument==="number"||argStr==="[object Number]"||typeof argument==="string"||argStr==="[object String]"){
return new Date(argument);
}else{
return new Date(NaN);
}
}

// lib/startOfWeek.js
function startOfWeek(date,options){var _ref,_ref2,_ref3,_options$weekStartsOn,_options$locale,_defaultOptions3$loca;
var defaultOptions3=getDefaultOptions();
var weekStartsOn=(_ref=(_ref2=(_ref3=(_options$weekStartsOn=options===null||options===void 0?void 0:options.weekStartsOn)!==null&&_options$weekStartsOn!==void 0?_options$weekStartsOn:options===null||options===void 0||(_options$locale=options.locale)===null||_options$locale===void 0||(_options$locale=_options$locale.options)===null||_options$locale===void 0?void 0:_options$locale.weekStartsOn)!==null&&_ref3!==void 0?_ref3:defaultOptions3.weekStartsOn)!==null&&_ref2!==void 0?_ref2:(_defaultOptions3$loca=defaultOptions3.locale)===null||_defaultOptions3$loca===void 0||(_defaultOptions3$loca=_defaultOptions3$loca.options)===null||_defaultOptions3$loca===void 0?void 0:_defaultOptions3$loca.weekStartsOn)!==null&&_ref!==void 0?_ref:0;
var _date=toDate(date,options===null||options===void 0?void 0:options.in);
var day=_date.getDay();
var diff=(day<weekStartsOn?7:0)+day-weekStartsOn;
_date.setDate(_date.getDate()-diff);
_date.setHours(0,0,0,0);
return _date;
}

// lib/isSameWeek.js
function isSameWeek(laterDate,earlierDate,options){
var _normalizeDates=normalizeDates(options===null||options===void 0?void 0:options.in,laterDate,earlierDate),_normalizeDates2=_slicedToArray(_normalizeDates,2),laterDate_=_normalizeDates2[0],earlierDate_=_normalizeDates2[1];
return+startOfWeek(laterDate_,options)===+startOfWeek(earlierDate_,options);
}

// lib/locale/be/_lib/formatRelative.js
function lastWeek(day){
var weekday=accusativeWeekdays[day];
switch(day){
case 0:
case 3:
case 5:
case 6:
return"'\u0443 \u043C\u0456\u043D\u0443\u043B\u0443\u044E "+weekday+" \u0430' p";
case 1:
case 2:
case 4:
return"'\u0443 \u043C\u0456\u043D\u0443\u043B\u044B "+weekday+" \u0430' p";
}
}
function thisWeek(day){
var weekday=accusativeWeekdays[day];
return"'\u0443 "+weekday+" \u0430' p";
}
function nextWeek(day){
var weekday=accusativeWeekdays[day];
switch(day){
case 0:
case 3:
case 5:
case 6:
return"'\u0443 \u043D\u0430\u0441\u0442\u0443\u043F\u043D\u0443\u044E "+weekday+" \u0430' p";
case 1:
case 2:
case 4:
return"'\u0443 \u043D\u0430\u0441\u0442\u0443\u043F\u043D\u044B "+weekday+" \u0430' p";
}
}
var accusativeWeekdays=[
"\u043D\u044F\u0434\u0437\u0435\u043B\u044E",
"\u043F\u0430\u043D\u044F\u0434\u0437\u0435\u043B\u0430\u043A",
"\u0430\u045E\u0442\u043E\u0440\u0430\u043A",
"\u0441\u0435\u0440\u0430\u0434\u0443",
"\u0447\u0430\u0446\u0432\u0435\u0440",
"\u043F\u044F\u0442\u043D\u0456\u0446\u0443",
"\u0441\u0443\u0431\u043E\u0442\u0443"];

var lastWeekFormat=function lastWeekFormat(dirtyDate,baseDate,options){
var date=toDate(dirtyDate);
var day=date.getDay();
if(isSameWeek(date,baseDate,options)){
return thisWeek(day);
}else{
return lastWeek(day);
}
};
var nextWeekFormat=function nextWeekFormat(dirtyDate,baseDate,options){
var date=toDate(dirtyDate);
var day=date.getDay();
if(isSameWeek(date,baseDate,options)){
return thisWeek(day);
}else{
return nextWeek(day);
}
};
var formatRelativeLocale9={
lastWeek:lastWeekFormat,
yesterday:"'\u0443\u0447\u043E\u0440\u0430 \u0430' p",
today:"'\u0441\u0451\u043D\u043D\u044F \u0430' p",
tomorrow:"'\u0437\u0430\u045E\u0442\u0440\u0430 \u0430' p",
nextWeek:nextWeekFormat,
other:"P"
};
var formatRelative17=function formatRelative17(token,date,baseDate,options){
var format=formatRelativeLocale9[token];
if(typeof format==="function"){
return format(date,baseDate,options);
}
return format;
};

// lib/locale/be/_lib/localize.js
var eraValues9={
narrow:["\u0434\u0430 \u043D.\u044D.","\u043D.\u044D."],
abbreviated:["\u0434\u0430 \u043D. \u044D.","\u043D. \u044D."],
wide:["\u0434\u0430 \u043D\u0430\u0448\u0430\u0439 \u044D\u0440\u044B","\u043D\u0430\u0448\u0430\u0439 \u044D\u0440\u044B"]
};
var quarterValues9={
narrow:["1","2","3","4"],
abbreviated:["1-\u044B \u043A\u0432.","2-\u0456 \u043A\u0432.","3-\u0456 \u043A\u0432.","4-\u044B \u043A\u0432."],
wide:["1-\u044B \u043A\u0432\u0430\u0440\u0442\u0430\u043B","2-\u0456 \u043A\u0432\u0430\u0440\u0442\u0430\u043B","3-\u0456 \u043A\u0432\u0430\u0440\u0442\u0430\u043B","4-\u044B \u043A\u0432\u0430\u0440\u0442\u0430\u043B"]
};
var monthValues9={
narrow:["\u0421","\u041B","\u0421","\u041A","\u041C","\u0427","\u041B","\u0416","\u0412","\u041A","\u041B","\u0421"],
abbreviated:[
"\u0441\u0442\u0443\u0434\u0437.",
"\u043B\u044E\u0442.",
"\u0441\u0430\u043A.",
"\u043A\u0440\u0430\u0441.",
"\u043C\u0430\u0439",
"\u0447\u044D\u0440\u0432.",
"\u043B\u0456\u043F.",
"\u0436\u043D.",
"\u0432\u0435\u0440.",
"\u043A\u0430\u0441\u0442\u0440.",
"\u043B\u0456\u0441\u0442.",
"\u0441\u043D\u0435\u0436."],

wide:[
"\u0441\u0442\u0443\u0434\u0437\u0435\u043D\u044C",
"\u043B\u044E\u0442\u044B",
"\u0441\u0430\u043A\u0430\u0432\u0456\u043A",
"\u043A\u0440\u0430\u0441\u0430\u0432\u0456\u043A",
"\u043C\u0430\u0439",
"\u0447\u044D\u0440\u0432\u0435\u043D\u044C",
"\u043B\u0456\u043F\u0435\u043D\u044C",
"\u0436\u043D\u0456\u0432\u0435\u043D\u044C",
"\u0432\u0435\u0440\u0430\u0441\u0435\u043D\u044C",
"\u043A\u0430\u0441\u0442\u0440\u044B\u0447\u043D\u0456\u043A",
"\u043B\u0456\u0441\u0442\u0430\u043F\u0430\u0434",
"\u0441\u043D\u0435\u0436\u0430\u043D\u044C"]

};
var formattingMonthValues={
narrow:["\u0421","\u041B","\u0421","\u041A","\u041C","\u0427","\u041B","\u0416","\u0412","\u041A","\u041B","\u0421"],
abbreviated:[
"\u0441\u0442\u0443\u0434\u0437.",
"\u043B\u044E\u0442.",
"\u0441\u0430\u043A.",
"\u043A\u0440\u0430\u0441.",
"\u043C\u0430\u044F",
"\u0447\u044D\u0440\u0432.",
"\u043B\u0456\u043F.",
"\u0436\u043D.",
"\u0432\u0435\u0440.",
"\u043A\u0430\u0441\u0442\u0440.",
"\u043B\u0456\u0441\u0442.",
"\u0441\u043D\u0435\u0436."],

wide:[
"\u0441\u0442\u0443\u0434\u0437\u0435\u043D\u044F",
"\u043B\u044E\u0442\u0430\u0433\u0430",
"\u0441\u0430\u043A\u0430\u0432\u0456\u043A\u0430",
"\u043A\u0440\u0430\u0441\u0430\u0432\u0456\u043A\u0430",
"\u043C\u0430\u044F",
"\u0447\u044D\u0440\u0432\u0435\u043D\u044F",
"\u043B\u0456\u043F\u0435\u043D\u044F",
"\u0436\u043D\u0456\u045E\u043D\u044F",
"\u0432\u0435\u0440\u0430\u0441\u043D\u044F",
"\u043A\u0430\u0441\u0442\u0440\u044B\u0447\u043D\u0456\u043A\u0430",
"\u043B\u0456\u0441\u0442\u0430\u043F\u0430\u0434\u0430",
"\u0441\u043D\u0435\u0436\u043D\u044F"]

};
var dayValues9={
narrow:["\u041D","\u041F","\u0410","\u0421","\u0427","\u041F","\u0421"],
short:["\u043D\u0434","\u043F\u043D","\u0430\u045E","\u0441\u0440","\u0447\u0446","\u043F\u0442","\u0441\u0431"],
abbreviated:["\u043D\u044F\u0434\u0437","\u043F\u0430\u043D","\u0430\u045E\u0442","\u0441\u0435\u0440","\u0447\u0430\u0446","\u043F\u044F\u0442","\u0441\u0443\u0431"],
wide:[
"\u043D\u044F\u0434\u0437\u0435\u043B\u044F",
"\u043F\u0430\u043D\u044F\u0434\u0437\u0435\u043B\u0430\u043A",
"\u0430\u045E\u0442\u043E\u0440\u0430\u043A",
"\u0441\u0435\u0440\u0430\u0434\u0430",
"\u0447\u0430\u0446\u0432\u0435\u0440",
"\u043F\u044F\u0442\u043D\u0456\u0446\u0430",
"\u0441\u0443\u0431\u043E\u0442\u0430"]

};
var dayPeriodValues9={
narrow:{
am:"\u0414\u041F",
pm:"\u041F\u041F",
midnight:"\u043F\u043E\u045E\u043D.",
noon:"\u043F\u043E\u045E\u0434.",
morning:"\u0440\u0430\u043D.",
afternoon:"\u0434\u0437\u0435\u043D\u044C",
evening:"\u0432\u0435\u0447.",
night:"\u043D\u043E\u0447"
},
abbreviated:{
am:"\u0414\u041F",
pm:"\u041F\u041F",
midnight:"\u043F\u043E\u045E\u043D.",
noon:"\u043F\u043E\u045E\u0434.",
morning:"\u0440\u0430\u043D.",
afternoon:"\u0434\u0437\u0435\u043D\u044C",
evening:"\u0432\u0435\u0447.",
night:"\u043D\u043E\u0447"
},
wide:{
am:"\u0414\u041F",
pm:"\u041F\u041F",
midnight:"\u043F\u043E\u045E\u043D\u0430\u0447",
noon:"\u043F\u043E\u045E\u0434\u0437\u0435\u043D\u044C",
morning:"\u0440\u0430\u043D\u0456\u0446\u0430",
afternoon:"\u0434\u0437\u0435\u043D\u044C",
evening:"\u0432\u0435\u0447\u0430\u0440",
night:"\u043D\u043E\u0447"
}
};
var formattingDayPeriodValues9={
narrow:{
am:"\u0414\u041F",
pm:"\u041F\u041F",
midnight:"\u043F\u043E\u045E\u043D.",
noon:"\u043F\u043E\u045E\u0434.",
morning:"\u0440\u0430\u043D.",
afternoon:"\u0434\u043D\u044F",
evening:"\u0432\u0435\u0447.",
night:"\u043D\u043E\u0447\u044B"
},
abbreviated:{
am:"\u0414\u041F",
pm:"\u041F\u041F",
midnight:"\u043F\u043E\u045E\u043D.",
noon:"\u043F\u043E\u045E\u0434.",
morning:"\u0440\u0430\u043D.",
afternoon:"\u0434\u043D\u044F",
evening:"\u0432\u0435\u0447.",
night:"\u043D\u043E\u0447\u044B"
},
wide:{
am:"\u0414\u041F",
pm:"\u041F\u041F",
midnight:"\u043F\u043E\u045E\u043D\u0430\u0447",
noon:"\u043F\u043E\u045E\u0434\u0437\u0435\u043D\u044C",
morning:"\u0440\u0430\u043D\u0456\u0446\u044B",
afternoon:"\u0434\u043D\u044F",
evening:"\u0432\u0435\u0447\u0430\u0440\u0430",
night:"\u043D\u043E\u0447\u044B"
}
};
var ordinalNumber9=function ordinalNumber9(dirtyNumber,options){
var unit=String(options===null||options===void 0?void 0:options.unit);
var number=Number(dirtyNumber);
var suffix;
if(unit==="date"){
suffix="-\u0433\u0430";
}else if(unit==="hour"||unit==="minute"||unit==="second"){
suffix="-\u044F";
}else{
suffix=(number%10===2||number%10===3)&&number%100!==12&&number%100!==13?"-\u0456":"-\u044B";
}
return number+suffix;
};
var localize17={
ordinalNumber:ordinalNumber9,
era:buildLocalizeFn({
values:eraValues9,
defaultWidth:"wide"
}),
quarter:buildLocalizeFn({
values:quarterValues9,
defaultWidth:"wide",
argumentCallback:function argumentCallback(quarter){return quarter-1;}
}),
month:buildLocalizeFn({
values:monthValues9,
defaultWidth:"wide",
formattingValues:formattingMonthValues,
defaultFormattingWidth:"wide"
}),
day:buildLocalizeFn({
values:dayValues9,
defaultWidth:"wide"
}),
dayPeriod:buildLocalizeFn({
values:dayPeriodValues9,
defaultWidth:"any",
formattingValues:formattingDayPeriodValues9,
defaultFormattingWidth:"wide"
})
};

// lib/locale/be/_lib/match.js
var matchOrdinalNumberPattern9=/^(\d+)(-?(е|я|га|і|ы|ае|ая|яя|шы|гі|ці|ты|мы))?/i;
var parseOrdinalNumberPattern9=/\d+/i;
var matchEraPatterns9={
narrow:/^((да )?н\.?\s?э\.?)/i,
abbreviated:/^((да )?н\.?\s?э\.?)/i,
wide:/^(да нашай эры|нашай эры|наша эра)/i
};
var parseEraPatterns9={
any:[/^д/i,/^н/i]
};
var matchQuarterPatterns9={
narrow:/^[1234]/i,
abbreviated:/^[1234](-?[ыі]?)? кв.?/i,
wide:/^[1234](-?[ыі]?)? квартал/i
};
var parseQuarterPatterns9={
any:[/1/i,/2/i,/3/i,/4/i]
};
var matchMonthPatterns9={
narrow:/^[слкмчжв]/i,
abbreviated:/^(студз|лют|сак|крас|ма[йя]|чэрв|ліп|жн|вер|кастр|ліст|снеж)\.?/i,
wide:/^(студзен[ья]|лют(ы|ага)|сакавіка?|красавіка?|ма[йя]|чэрвен[ья]|ліпен[ья]|жні(вень|ўня)|верас(ень|ня)|кастрычніка?|лістапада?|снеж(ань|ня))/i
};
var parseMonthPatterns9={
narrow:[
/^с/i,
/^л/i,
/^с/i,
/^к/i,
/^м/i,
/^ч/i,
/^л/i,
/^ж/i,
/^в/i,
/^к/i,
/^л/i,
/^с/i],

any:[
/^ст/i,
/^лю/i,
/^са/i,
/^кр/i,
/^ма/i,
/^ч/i,
/^ліп/i,
/^ж/i,
/^в/i,
/^ка/i,
/^ліс/i,
/^сн/i]

};
var matchDayPatterns9={
narrow:/^[нпасч]/i,
short:/^(нд|ня|пн|па|аў|ат|ср|се|чц|ча|пт|пя|сб|су)\.?/i,
abbreviated:/^(нядз?|ндз|пнд|пан|аўт|срд|сер|чцв|чац|птн|пят|суб).?/i,
wide:/^(нядзел[яі]|панядзел(ак|ка)|аўтор(ак|ка)|серад[аы]|чацв(ер|ярга)|пятніц[аы]|субот[аы])/i
};
var parseDayPatterns9={
narrow:[/^н/i,/^п/i,/^а/i,/^с/i,/^ч/i,/^п/i,/^с/i],
any:[/^н/i,/^п[ан]/i,/^а/i,/^с[ер]/i,/^ч/i,/^п[ят]/i,/^с[уб]/i]
};
var matchDayPeriodPatterns9={
narrow:/^([дп]п|поўн\.?|поўд\.?|ран\.?|дзень|дня|веч\.?|ночы?)/i,
abbreviated:/^([дп]п|поўн\.?|поўд\.?|ран\.?|дзень|дня|веч\.?|ночы?)/i,
wide:/^([дп]п|поўнач|поўдзень|раніц[аы]|дзень|дня|вечара?|ночы?)/i
};
var parseDayPeriodPatterns9={
any:{
am:/^дп/i,
pm:/^пп/i,
midnight:/^поўн/i,
noon:/^поўд/i,
morning:/^р/i,
afternoon:/^д[зн]/i,
evening:/^в/i,
night:/^н/i
}
};
var match17={
ordinalNumber:buildMatchPatternFn({
matchPattern:matchOrdinalNumberPattern9,
parsePattern:parseOrdinalNumberPattern9,
valueCallback:function valueCallback(value){return parseInt(value,10);}
}),
era:buildMatchFn({
matchPatterns:matchEraPatterns9,
defaultMatchWidth:"wide",
parsePatterns:parseEraPatterns9,
defaultParseWidth:"any"
}),
quarter:buildMatchFn({
matchPatterns:matchQuarterPatterns9,
defaultMatchWidth:"wide",
parsePatterns:parseQuarterPatterns9,
defaultParseWidth:"any",
valueCallback:function valueCallback(index){return index+1;}
}),
month:buildMatchFn({
matchPatterns:matchMonthPatterns9,
defaultMatchWidth:"wide",
parsePatterns:parseMonthPatterns9,
defaultParseWidth:"any"
}),
day:buildMatchFn({
matchPatterns:matchDayPatterns9,
defaultMatchWidth:"wide",
parsePatterns:parseDayPatterns9,
defaultParseWidth:"any"
}),
dayPeriod:buildMatchFn({
matchPatterns:matchDayPeriodPatterns9,
defaultMatchWidth:"wide",
parsePatterns:parseDayPeriodPatterns9,
defaultParseWidth:"any"
})
};

// lib/locale/be.js
var _be={
code:"be",
formatDistance:formatDistance17,
formatLong:formatLong17,
formatRelative:formatRelative17,
localize:localize17,
match:match17,
options:{
weekStartsOn:1,
firstWeekContainsDate:1
}
};
// lib/locale/be-tarask/_lib/formatDistance.js
function declension2(scheme,count){
if(scheme.one!==undefined&&count===1){
return scheme.one;
}
var rem10=count%10;
var rem100=count%100;
if(rem10===1&&rem100!==11){
return scheme.singularNominative.replace("{{count}}",String(count));
}else if(rem10>=2&&rem10<=4&&(rem100<10||rem100>20)){
return scheme.singularGenitive.replace("{{count}}",String(count));
}else{
return scheme.pluralGenitive.replace("{{count}}",String(count));
}
}
function buildLocalizeTokenFn2(scheme){
return function(count,options){
if(options&&options.addSuffix){
if(options.comparison&&options.comparison>0){
if(scheme.future){
return declension2(scheme.future,count);
}else{
return"\u043F\u0440\u0430\u0437 "+declension2(scheme.regular,count);
}
}else{
if(scheme.past){
return declension2(scheme.past,count);
}else{
return declension2(scheme.regular,count)+" \u0442\u0430\u043C\u0443";
}
}
}else{
return declension2(scheme.regular,count);
}
};
}
var halfAMinute2=function halfAMinute2(_,options){
if(options&&options.addSuffix){
if(options.comparison&&options.comparison>0){
return"\u043F\u0440\u0430\u0437 \u043F\u0430\u045E\u0445\u0432\u0456\u043B\u0456\u043D\u044B";
}else{
return"\u043F\u0430\u045E\u0445\u0432\u0456\u043B\u0456\u043D\u044B \u0442\u0430\u043C\u0443";
}
}
return"\u043F\u0430\u045E\u0445\u0432\u0456\u043B\u0456\u043D\u044B";
};
var formatDistanceLocale10={
lessThanXSeconds:buildLocalizeTokenFn2({
regular:{
one:"\u043C\u0435\u043D\u0448 \u0437\u0430 \u0441\u0435\u043A\u0443\u043D\u0434\u0443",
singularNominative:"\u043C\u0435\u043D\u0448 \u0437\u0430 {{count}} \u0441\u0435\u043A\u0443\u043D\u0434\u0443",
singularGenitive:"\u043C\u0435\u043D\u0448 \u0437\u0430 {{count}} \u0441\u0435\u043A\u0443\u043D\u0434\u044B",
pluralGenitive:"\u043C\u0435\u043D\u0448 \u0437\u0430 {{count}} \u0441\u0435\u043A\u0443\u043D\u0434"
},
future:{
one:"\u043C\u0435\u043D\u0448, \u0447\u044B\u043C \u043F\u0440\u0430\u0437 \u0441\u0435\u043A\u0443\u043D\u0434\u0443",
singularNominative:"\u043C\u0435\u043D\u0448, \u0447\u044B\u043C \u043F\u0440\u0430\u0437 {{count}} \u0441\u0435\u043A\u0443\u043D\u0434\u0443",
singularGenitive:"\u043C\u0435\u043D\u0448, \u0447\u044B\u043C \u043F\u0440\u0430\u0437 {{count}} \u0441\u0435\u043A\u0443\u043D\u0434\u044B",
pluralGenitive:"\u043C\u0435\u043D\u0448, \u0447\u044B\u043C \u043F\u0440\u0430\u0437 {{count}} \u0441\u0435\u043A\u0443\u043D\u0434"
}
}),
xSeconds:buildLocalizeTokenFn2({
regular:{
singularNominative:"{{count}} \u0441\u0435\u043A\u0443\u043D\u0434\u0430",
singularGenitive:"{{count}} \u0441\u0435\u043A\u0443\u043D\u0434\u044B",
pluralGenitive:"{{count}} \u0441\u0435\u043A\u0443\u043D\u0434"
},
past:{
singularNominative:"{{count}} \u0441\u0435\u043A\u0443\u043D\u0434\u0443 \u0442\u0430\u043C\u0443",
singularGenitive:"{{count}} \u0441\u0435\u043A\u0443\u043D\u0434\u044B \u0442\u0430\u043C\u0443",
pluralGenitive:"{{count}} \u0441\u0435\u043A\u0443\u043D\u0434 \u0442\u0430\u043C\u0443"
},
future:{
singularNominative:"\u043F\u0440\u0430\u0437 {{count}} \u0441\u0435\u043A\u0443\u043D\u0434\u0443",
singularGenitive:"\u043F\u0440\u0430\u0437 {{count}} \u0441\u0435\u043A\u0443\u043D\u0434\u044B",
pluralGenitive:"\u043F\u0440\u0430\u0437 {{count}} \u0441\u0435\u043A\u0443\u043D\u0434"
}
}),
halfAMinute:halfAMinute2,
lessThanXMinutes:buildLocalizeTokenFn2({
regular:{
one:"\u043C\u0435\u043D\u0448 \u0437\u0430 \u0445\u0432\u0456\u043B\u0456\u043D\u0443",
singularNominative:"\u043C\u0435\u043D\u0448 \u0437\u0430 {{count}} \u0445\u0432\u0456\u043B\u0456\u043D\u0443",
singularGenitive:"\u043C\u0435\u043D\u0448 \u0437\u0430 {{count}} \u0445\u0432\u0456\u043B\u0456\u043D\u044B",
pluralGenitive:"\u043C\u0435\u043D\u0448 \u0437\u0430 {{count}} \u0445\u0432\u0456\u043B\u0456\u043D"
},
future:{
one:"\u043C\u0435\u043D\u0448, \u0447\u044B\u043C \u043F\u0440\u0430\u0437 \u0445\u0432\u0456\u043B\u0456\u043D\u0443",
singularNominative:"\u043C\u0435\u043D\u0448, \u0447\u044B\u043C \u043F\u0440\u0430\u0437 {{count}} \u0445\u0432\u0456\u043B\u0456\u043D\u0443",
singularGenitive:"\u043C\u0435\u043D\u0448, \u0447\u044B\u043C \u043F\u0440\u0430\u0437 {{count}} \u0445\u0432\u0456\u043B\u0456\u043D\u044B",
pluralGenitive:"\u043C\u0435\u043D\u0448, \u0447\u044B\u043C \u043F\u0440\u0430\u0437 {{count}} \u0445\u0432\u0456\u043B\u0456\u043D"
}
}),
xMinutes:buildLocalizeTokenFn2({
regular:{
singularNominative:"{{count}} \u0445\u0432\u0456\u043B\u0456\u043D\u0430",
singularGenitive:"{{count}} \u0445\u0432\u0456\u043B\u0456\u043D\u044B",
pluralGenitive:"{{count}} \u0445\u0432\u0456\u043B\u0456\u043D"
},
past:{
singularNominative:"{{count}} \u0445\u0432\u0456\u043B\u0456\u043D\u0443 \u0442\u0430\u043C\u0443",
singularGenitive:"{{count}} \u0445\u0432\u0456\u043B\u0456\u043D\u044B \u0442\u0430\u043C\u0443",
pluralGenitive:"{{count}} \u0445\u0432\u0456\u043B\u0456\u043D \u0442\u0430\u043C\u0443"
},
future:{
singularNominative:"\u043F\u0440\u0430\u0437 {{count}} \u0445\u0432\u0456\u043B\u0456\u043D\u0443",
singularGenitive:"\u043F\u0440\u0430\u0437 {{count}} \u0445\u0432\u0456\u043B\u0456\u043D\u044B",
pluralGenitive:"\u043F\u0440\u0430\u0437 {{count}} \u0445\u0432\u0456\u043B\u0456\u043D"
}
}),
aboutXHours:buildLocalizeTokenFn2({
regular:{
singularNominative:"\u043A\u0430\u043B\u044F {{count}} \u0433\u0430\u0434\u0437\u0456\u043D\u044B",
singularGenitive:"\u043A\u0430\u043B\u044F {{count}} \u0433\u0430\u0434\u0437\u0456\u043D",
pluralGenitive:"\u043A\u0430\u043B\u044F {{count}} \u0433\u0430\u0434\u0437\u0456\u043D"
},
future:{
singularNominative:"\u043F\u0440\u044B\u0431\u043B\u0456\u0437\u043D\u0430 \u043F\u0440\u0430\u0437 {{count}} \u0433\u0430\u0434\u0437\u0456\u043D\u0443",
singularGenitive:"\u043F\u0440\u044B\u0431\u043B\u0456\u0437\u043D\u0430 \u043F\u0440\u0430\u0437 {{count}} \u0433\u0430\u0434\u0437\u0456\u043D\u044B",
pluralGenitive:"\u043F\u0440\u044B\u0431\u043B\u0456\u0437\u043D\u0430 \u043F\u0440\u0430\u0437 {{count}} \u0433\u0430\u0434\u0437\u0456\u043D"
}
}),
xHours:buildLocalizeTokenFn2({
regular:{
singularNominative:"{{count}} \u0433\u0430\u0434\u0437\u0456\u043D\u0430",
singularGenitive:"{{count}} \u0433\u0430\u0434\u0437\u0456\u043D\u044B",
pluralGenitive:"{{count}} \u0433\u0430\u0434\u0437\u0456\u043D"
},
past:{
singularNominative:"{{count}} \u0433\u0430\u0434\u0437\u0456\u043D\u0443 \u0442\u0430\u043C\u0443",
singularGenitive:"{{count}} \u0433\u0430\u0434\u0437\u0456\u043D\u044B \u0442\u0430\u043C\u0443",
pluralGenitive:"{{count}} \u0433\u0430\u0434\u0437\u0456\u043D \u0442\u0430\u043C\u0443"
},
future:{
singularNominative:"\u043F\u0440\u0430\u0437 {{count}} \u0433\u0430\u0434\u0437\u0456\u043D\u0443",
singularGenitive:"\u043F\u0440\u0430\u0437 {{count}} \u0433\u0430\u0434\u0437\u0456\u043D\u044B",
pluralGenitive:"\u043F\u0440\u0430\u0437 {{count}} \u0433\u0430\u0434\u0437\u0456\u043D"
}
}),
xDays:buildLocalizeTokenFn2({
regular:{
singularNominative:"{{count}} \u0434\u0437\u0435\u043D\u044C",
singularGenitive:"{{count}} \u0434\u043D\u0456",
pluralGenitive:"{{count}} \u0434\u0437\u0451\u043D"
}
}),
aboutXWeeks:buildLocalizeTokenFn2({
regular:{
singularNominative:"\u043A\u0430\u043B\u044F {{count}} \u0442\u044B\u0434\u043D\u0456",
singularGenitive:"\u043A\u0430\u043B\u044F {{count}} \u0442\u044B\u0434\u043D\u044F\u045E",
pluralGenitive:"\u043A\u0430\u043B\u044F {{count}} \u0442\u044B\u0434\u043D\u044F\u045E"
},
future:{
singularNominative:"\u043F\u0440\u044B\u0431\u043B\u0456\u0437\u043D\u0430 \u043F\u0440\u0430\u0437 {{count}} \u0442\u044B\u0434\u0437\u0435\u043D\u044C",
singularGenitive:"\u043F\u0440\u044B\u0431\u043B\u0456\u0437\u043D\u0430 \u043F\u0440\u0430\u0437 {{count}} \u0442\u044B\u0434\u043D\u0456",
pluralGenitive:"\u043F\u0440\u044B\u0431\u043B\u0456\u0437\u043D\u0430 \u043F\u0440\u0430\u0437 {{count}} \u0442\u044B\u0434\u043D\u044F\u045E"
}
}),
xWeeks:buildLocalizeTokenFn2({
regular:{
singularNominative:"{{count}} \u0442\u044B\u0434\u0437\u0435\u043D\u044C",
singularGenitive:"{{count}} \u0442\u044B\u0434\u043D\u0456",
pluralGenitive:"{{count}} \u0442\u044B\u0434\u043D\u044F\u045E"
}
}),
aboutXMonths:buildLocalizeTokenFn2({
regular:{
singularNominative:"\u043A\u0430\u043B\u044F {{count}} \u043C\u0435\u0441\u044F\u0446\u0430",
singularGenitive:"\u043A\u0430\u043B\u044F {{count}} \u043C\u0435\u0441\u044F\u0446\u0430\u045E",
pluralGenitive:"\u043A\u0430\u043B\u044F {{count}} \u043C\u0435\u0441\u044F\u0446\u0430\u045E"
},
future:{
singularNominative:"\u043F\u0440\u044B\u0431\u043B\u0456\u0437\u043D\u0430 \u043F\u0440\u0430\u0437 {{count}} \u043C\u0435\u0441\u044F\u0446",
singularGenitive:"\u043F\u0440\u044B\u0431\u043B\u0456\u0437\u043D\u0430 \u043F\u0440\u0430\u0437 {{count}} \u043C\u0435\u0441\u044F\u0446\u044B",
pluralGenitive:"\u043F\u0440\u044B\u0431\u043B\u0456\u0437\u043D\u0430 \u043F\u0440\u0430\u0437 {{count}} \u043C\u0435\u0441\u044F\u0446\u0430\u045E"
}
}),
xMonths:buildLocalizeTokenFn2({
regular:{
singularNominative:"{{count}} \u043C\u0435\u0441\u044F\u0446",
singularGenitive:"{{count}} \u043C\u0435\u0441\u044F\u0446\u044B",
pluralGenitive:"{{count}} \u043C\u0435\u0441\u044F\u0446\u0430\u045E"
}
}),
aboutXYears:buildLocalizeTokenFn2({
regular:{
singularNominative:"\u043A\u0430\u043B\u044F {{count}} \u0433\u043E\u0434\u0430",
singularGenitive:"\u043A\u0430\u043B\u044F {{count}} \u0433\u0430\u0434\u043E\u045E",
pluralGenitive:"\u043A\u0430\u043B\u044F {{count}} \u0433\u0430\u0434\u043E\u045E"
},
future:{
singularNominative:"\u043F\u0440\u044B\u0431\u043B\u0456\u0437\u043D\u0430 \u043F\u0440\u0430\u0437 {{count}} \u0433\u043E\u0434",
singularGenitive:"\u043F\u0440\u044B\u0431\u043B\u0456\u0437\u043D\u0430 \u043F\u0440\u0430\u0437 {{count}} \u0433\u0430\u0434\u044B",
pluralGenitive:"\u043F\u0440\u044B\u0431\u043B\u0456\u0437\u043D\u0430 \u043F\u0440\u0430\u0437 {{count}} \u0433\u0430\u0434\u043E\u045E"
}
}),
xYears:buildLocalizeTokenFn2({
regular:{
singularNominative:"{{count}} \u0433\u043E\u0434",
singularGenitive:"{{count}} \u0433\u0430\u0434\u044B",
pluralGenitive:"{{count}} \u0433\u0430\u0434\u043E\u045E"
}
}),
overXYears:buildLocalizeTokenFn2({
regular:{
singularNominative:"\u0431\u043E\u043B\u044C\u0448 \u0437\u0430 {{count}} \u0433\u043E\u0434",
singularGenitive:"\u0431\u043E\u043B\u044C\u0448 \u0437\u0430 {{count}} \u0433\u0430\u0434\u044B",
pluralGenitive:"\u0431\u043E\u043B\u044C\u0448 \u0437\u0430 {{count}} \u0433\u0430\u0434\u043E\u045E"
},
future:{
singularNominative:"\u0431\u043E\u043B\u044C\u0448, \u0447\u044B\u043C \u043F\u0440\u0430\u0437 {{count}} \u0433\u043E\u0434",
singularGenitive:"\u0431\u043E\u043B\u044C\u0448, \u0447\u044B\u043C \u043F\u0440\u0430\u0437 {{count}} \u0433\u0430\u0434\u044B",
pluralGenitive:"\u0431\u043E\u043B\u044C\u0448, \u0447\u044B\u043C \u043F\u0440\u0430\u0437 {{count}} \u0433\u0430\u0434\u043E\u045E"
}
}),
almostXYears:buildLocalizeTokenFn2({
regular:{
singularNominative:"\u0430\u043C\u0430\u043B\u044C {{count}} \u0433\u043E\u0434",
singularGenitive:"\u0430\u043C\u0430\u043B\u044C {{count}} \u0433\u0430\u0434\u044B",
pluralGenitive:"\u0430\u043C\u0430\u043B\u044C {{count}} \u0433\u0430\u0434\u043E\u045E"
},
future:{
singularNominative:"\u0430\u043C\u0430\u043B\u044C \u043F\u0440\u0430\u0437 {{count}} \u0433\u043E\u0434",
singularGenitive:"\u0430\u043C\u0430\u043B\u044C \u043F\u0440\u0430\u0437 {{count}} \u0433\u0430\u0434\u044B",
pluralGenitive:"\u0430\u043C\u0430\u043B\u044C \u043F\u0440\u0430\u0437 {{count}} \u0433\u0430\u0434\u043E\u045E"
}
})
};
var formatDistance19=function formatDistance19(token,count,options){
options=options||{};
return formatDistanceLocale10[token](count,options);
};

// lib/locale/be-tarask/_lib/formatLong.js
var dateFormats10={
full:"EEEE, d MMMM y '\u0433.'",
long:"d MMMM y '\u0433.'",
medium:"d MMM y '\u0433.'",
short:"dd.MM.y"
};
var timeFormats10={
full:"H:mm:ss zzzz",
long:"H:mm:ss z",
medium:"H:mm:ss",
short:"H:mm"
};
var dateTimeFormats10={
any:"{{date}}, {{time}}"
};
var formatLong19={
date:buildFormatLongFn({
formats:dateFormats10,
defaultWidth:"full"
}),
time:buildFormatLongFn({
formats:timeFormats10,
defaultWidth:"full"
}),
dateTime:buildFormatLongFn({
formats:dateTimeFormats10,
defaultWidth:"any"
})
};

// lib/locale/be-tarask/_lib/formatRelative.js
function lastWeek2(day){
var weekday=accusativeWeekdays2[day];
switch(day){
case 0:
case 3:
case 5:
case 6:
return"'\u0443 \u043C\u0456\u043D\u0443\u043B\u0443\u044E "+weekday+" \u0430' p";
case 1:
case 2:
case 4:
return"'\u0443 \u043C\u0456\u043D\u0443\u043B\u044B "+weekday+" \u0430' p";
}
}
function thisWeek2(day){
var weekday=accusativeWeekdays2[day];
return"'\u0443 "+weekday+" \u0430' p";
}
function nextWeek2(day){
var weekday=accusativeWeekdays2[day];
switch(day){
case 0:
case 3:
case 5:
case 6:
return"'\u0443 \u043D\u0430\u0441\u0442\u0443\u043F\u043D\u0443\u044E "+weekday+" \u0430' p";
case 1:
case 2:
case 4:
return"'\u0443 \u043D\u0430\u0441\u0442\u0443\u043F\u043D\u044B "+weekday+" \u0430' p";
}
}
var accusativeWeekdays2=[
"\u043D\u044F\u0434\u0437\u0435\u043B\u044E",
"\u043F\u0430\u043D\u044F\u0434\u0437\u0435\u043B\u0430\u043A",
"\u0430\u045E\u0442\u043E\u0440\u0430\u043A",
"\u0441\u0435\u0440\u0430\u0434\u0443",
"\u0447\u0430\u0446\u044C\u0432\u0435\u0440",
"\u043F\u044F\u0442\u043D\u0456\u0446\u0443",
"\u0441\u0443\u0431\u043E\u0442\u0443"];

var lastWeekFormat2=function lastWeekFormat2(dirtyDate,baseDate,options){
var date=toDate(dirtyDate);
var day=date.getDay();
if(isSameWeek(date,baseDate,options)){
return thisWeek2(day);
}else{
return lastWeek2(day);
}
};
var nextWeekFormat2=function nextWeekFormat2(dirtyDate,baseDate,options){
var date=toDate(dirtyDate);
var day=date.getDay();
if(isSameWeek(date,baseDate,options)){
return thisWeek2(day);
}else{
return nextWeek2(day);
}
};
var formatRelativeLocale10={
lastWeek:lastWeekFormat2,
yesterday:"'\u0443\u0447\u043E\u0440\u0430 \u0430' p",
today:"'\u0441\u0451\u043D\u044C\u043D\u044F \u0430' p",
tomorrow:"'\u0437\u0430\u045E\u0442\u0440\u0430 \u0430' p",
nextWeek:nextWeekFormat2,
other:"P"
};
var formatRelative19=function formatRelative19(token,date,baseDate,options){
var format=formatRelativeLocale10[token];
if(typeof format==="function"){
return format(date,baseDate,options);
}
return format;
};

// lib/locale/be-tarask/_lib/localize.js
var eraValues10={
narrow:["\u0434\u0430 \u043D.\u044D.","\u043D.\u044D."],
abbreviated:["\u0434\u0430 \u043D. \u044D.","\u043D. \u044D."],
wide:["\u0434\u0430 \u043D\u0430\u0448\u0430\u0439 \u044D\u0440\u044B","\u043D\u0430\u0448\u0430\u0439 \u044D\u0440\u044B"]
};
var quarterValues10={
narrow:["1","2","3","4"],
abbreviated:["1-\u044B \u043A\u0432.","2-\u0456 \u043A\u0432.","3-\u0456 \u043A\u0432.","4-\u044B \u043A\u0432."],
wide:["1-\u044B \u043A\u0432\u0430\u0440\u0442\u0430\u043B","2-\u0456 \u043A\u0432\u0430\u0440\u0442\u0430\u043B","3-\u0456 \u043A\u0432\u0430\u0440\u0442\u0430\u043B","4-\u044B \u043A\u0432\u0430\u0440\u0442\u0430\u043B"]
};
var monthValues10={
narrow:["\u0421","\u041B","\u0421","\u041A","\u0422","\u0427","\u041B","\u0416","\u0412","\u041A","\u041B","\u0421"],
abbreviated:[
"\u0441\u0442\u0443\u0434\u0437.",
"\u043B\u044E\u0442.",
"\u0441\u0430\u043A.",
"\u043A\u0440\u0430\u0441.",
"\u0442\u0440\u0430\u0432.",
"\u0447\u044D\u0440\u0432.",
"\u043B\u0456\u043F.",
"\u0436\u043D.",
"\u0432\u0435\u0440.",
"\u043A\u0430\u0441\u0442\u0440.",
"\u043B\u0456\u0441\u0442.",
"\u0441\u044C\u043D\u0435\u0436."],

wide:[
"\u0441\u0442\u0443\u0434\u0437\u0435\u043D\u044C",
"\u043B\u044E\u0442\u044B",
"\u0441\u0430\u043A\u0430\u0432\u0456\u043A",
"\u043A\u0440\u0430\u0441\u0430\u0432\u0456\u043A",
"\u0442\u0440\u0430\u0432\u0435\u043D\u044C",
"\u0447\u044D\u0440\u0432\u0435\u043D\u044C",
"\u043B\u0456\u043F\u0435\u043D\u044C",
"\u0436\u043D\u0456\u0432\u0435\u043D\u044C",
"\u0432\u0435\u0440\u0430\u0441\u0435\u043D\u044C",
"\u043A\u0430\u0441\u0442\u0440\u044B\u0447\u043D\u0456\u043A",
"\u043B\u0456\u0441\u0442\u0430\u043F\u0430\u0434",
"\u0441\u044C\u043D\u0435\u0436\u0430\u043D\u044C"]

};
var formattingMonthValues2={
narrow:["\u0421","\u041B","\u0421","\u041A","\u0422","\u0427","\u041B","\u0416","\u0412","\u041A","\u041B","\u0421"],
abbreviated:[
"\u0441\u0442\u0443\u0434\u0437.",
"\u043B\u044E\u0442.",
"\u0441\u0430\u043A.",
"\u043A\u0440\u0430\u0441.",
"\u0442\u0440\u0430\u0432.",
"\u0447\u044D\u0440\u0432.",
"\u043B\u0456\u043F.",
"\u0436\u043D.",
"\u0432\u0435\u0440.",
"\u043A\u0430\u0441\u0442\u0440.",
"\u043B\u0456\u0441\u0442.",
"\u0441\u044C\u043D\u0435\u0436."],

wide:[
"\u0441\u0442\u0443\u0434\u0437\u0435\u043D\u044F",
"\u043B\u044E\u0442\u0430\u0433\u0430",
"\u0441\u0430\u043A\u0430\u0432\u0456\u043A\u0430",
"\u043A\u0440\u0430\u0441\u0430\u0432\u0456\u043A\u0430",
"\u0442\u0440\u0430\u045E\u043D\u044F",
"\u0447\u044D\u0440\u0432\u0435\u043D\u044F",
"\u043B\u0456\u043F\u0435\u043D\u044F",
"\u0436\u043D\u0456\u045E\u043D\u044F",
"\u0432\u0435\u0440\u0430\u0441\u043D\u044F",
"\u043A\u0430\u0441\u0442\u0440\u044B\u0447\u043D\u0456\u043A\u0430",
"\u043B\u0456\u0441\u0442\u0430\u043F\u0430\u0434\u0430",
"\u0441\u044C\u043D\u0435\u0436\u043D\u044F"]

};
var dayValues10={
narrow:["\u041D","\u041F","\u0410","\u0421","\u0427","\u041F","\u0421"],
short:["\u043D\u0434","\u043F\u043D","\u0430\u045E","\u0441\u0440","\u0447\u0446","\u043F\u0442","\u0441\u0431"],
abbreviated:["\u043D\u044F\u0434\u0437","\u043F\u0430\u043D","\u0430\u045E\u0442","\u0441\u0435\u0440","\u0447\u0430\u0446\u044C","\u043F\u044F\u0442","\u0441\u0443\u0431"],
wide:[
"\u043D\u044F\u0434\u0437\u0435\u043B\u044F",
"\u043F\u0430\u043D\u044F\u0434\u0437\u0435\u043B\u0430\u043A",
"\u0430\u045E\u0442\u043E\u0440\u0430\u043A",
"\u0441\u0435\u0440\u0430\u0434\u0430",
"\u0447\u0430\u0446\u044C\u0432\u0435\u0440",
"\u043F\u044F\u0442\u043D\u0456\u0446\u0430",
"\u0441\u0443\u0431\u043E\u0442\u0430"]

};
var dayPeriodValues10={
narrow:{
am:"\u0414\u041F",
pm:"\u041F\u041F",
midnight:"\u043F\u043E\u045E\u043D.",
noon:"\u043F\u043E\u045E\u0434.",
morning:"\u0440\u0430\u043D.",
afternoon:"\u0434\u0437\u0435\u043D\u044C",
evening:"\u0432\u0435\u0447.",
night:"\u043D\u043E\u0447"
},
abbreviated:{
am:"\u0414\u041F",
pm:"\u041F\u041F",
midnight:"\u043F\u043E\u045E\u043D.",
noon:"\u043F\u043E\u045E\u0434.",
morning:"\u0440\u0430\u043D.",
afternoon:"\u0434\u0437\u0435\u043D\u044C",
evening:"\u0432\u0435\u0447.",
night:"\u043D\u043E\u0447"
},
wide:{
am:"\u0414\u041F",
pm:"\u041F\u041F",
midnight:"\u043F\u043E\u045E\u043D\u0430\u0447",
noon:"\u043F\u043E\u045E\u0434\u0437\u0435\u043D\u044C",
morning:"\u0440\u0430\u043D\u0456\u0446\u0430",
afternoon:"\u0434\u0437\u0435\u043D\u044C",
evening:"\u0432\u0435\u0447\u0430\u0440",
night:"\u043D\u043E\u0447"
}
};
var formattingDayPeriodValues10={
narrow:{
am:"\u0414\u041F",
pm:"\u041F\u041F",
midnight:"\u043F\u043E\u045E\u043D.",
noon:"\u043F\u043E\u045E\u0434.",
morning:"\u0440\u0430\u043D.",
afternoon:"\u0434\u043D\u044F",
evening:"\u0432\u0435\u0447.",
night:"\u043D\u043E\u0447\u044B"
},
abbreviated:{
am:"\u0414\u041F",
pm:"\u041F\u041F",
midnight:"\u043F\u043E\u045E\u043D.",
noon:"\u043F\u043E\u045E\u0434.",
morning:"\u0440\u0430\u043D.",
afternoon:"\u0434\u043D\u044F",
evening:"\u0432\u0435\u0447.",
night:"\u043D\u043E\u0447\u044B"
},
wide:{
am:"\u0414\u041F",
pm:"\u041F\u041F",
midnight:"\u043F\u043E\u045E\u043D\u0430\u0447",
noon:"\u043F\u043E\u045E\u0434\u0437\u0435\u043D\u044C",
morning:"\u0440\u0430\u043D\u0456\u0446\u044B",
afternoon:"\u0434\u043D\u044F",
evening:"\u0432\u0435\u0447\u0430\u0440\u0430",
night:"\u043D\u043E\u0447\u044B"
}
};
var ordinalNumber10=function ordinalNumber10(dirtyNumber,options){
var unit=String(options===null||options===void 0?void 0:options.unit);
var number=Number(dirtyNumber);
var suffix;
if(unit==="date"){
suffix="-\u0433\u0430";
}else if(unit==="hour"||unit==="minute"||unit==="second"){
suffix="-\u044F";
}else{
suffix=(number%10===2||number%10===3)&&number%100!==12&&number%100!==13?"-\u0456":"-\u044B";
}
return number+suffix;
};
var localize19={
ordinalNumber:ordinalNumber10,
era:buildLocalizeFn({
values:eraValues10,
defaultWidth:"wide"
}),
quarter:buildLocalizeFn({
values:quarterValues10,
defaultWidth:"wide",
argumentCallback:function argumentCallback(quarter){return quarter-1;}
}),
month:buildLocalizeFn({
values:monthValues10,
defaultWidth:"wide",
formattingValues:formattingMonthValues2,
defaultFormattingWidth:"wide"
}),
day:buildLocalizeFn({
values:dayValues10,
defaultWidth:"wide"
}),
dayPeriod:buildLocalizeFn({
values:dayPeriodValues10,
defaultWidth:"any",
formattingValues:formattingDayPeriodValues10,
defaultFormattingWidth:"wide"
})
};

// lib/locale/be-tarask/_lib/match.js
var matchOrdinalNumberPattern10=/^(\d+)(-?(е|я|га|і|ы|ае|ая|яя|шы|гі|ці|ты|мы))?/i;
var parseOrdinalNumberPattern10=/\d+/i;
var matchEraPatterns10={
narrow:/^((да )?н\.?\s?э\.?)/i,
abbreviated:/^((да )?н\.?\s?э\.?)/i,
wide:/^(да нашай эры|нашай эры|наша эра)/i
};
var parseEraPatterns10={
any:[/^д/i,/^н/i]
};
var matchQuarterPatterns10={
narrow:/^[1234]/i,
abbreviated:/^[1234](-?[ыі]?)? кв.?/i,
wide:/^[1234](-?[ыі]?)? квартал/i
};
var parseQuarterPatterns10={
any:[/1/i,/2/i,/3/i,/4/i]
};
var matchMonthPatterns10={
narrow:/^[слкмчжв]/i,
abbreviated:/^(студз|лют|сак|крас|тр(ав)?|чэрв|ліп|жн|вер|кастр|ліст|сьнеж)\.?/i,
wide:/^(студзен[ья]|лют(ы|ага)|сакавіка?|красавіка?|тра(вень|ўня)|чэрвен[ья]|ліпен[ья]|жні(вень|ўня)|верас(ень|ня)|кастрычніка?|лістапада?|сьнеж(ань|ня))/i
};
var parseMonthPatterns10={
narrow:[
/^с/i,
/^л/i,
/^с/i,
/^к/i,
/^т/i,
/^ч/i,
/^л/i,
/^ж/i,
/^в/i,
/^к/i,
/^л/i,
/^с/i],

any:[
/^ст/i,
/^лю/i,
/^са/i,
/^кр/i,
/^тр/i,
/^ч/i,
/^ліп/i,
/^ж/i,
/^в/i,
/^ка/i,
/^ліс/i,
/^сн/i]

};
var matchDayPatterns10={
narrow:/^[нпасч]/i,
short:/^(нд|ня|пн|па|аў|ат|ср|се|чц|ча|пт|пя|сб|су)\.?/i,
abbreviated:/^(нядз?|ндз|пнд|пан|аўт|срд|сер|чцьв|чаць|птн|пят|суб).?/i,
wide:/^(нядзел[яі]|панядзел(ак|ка)|аўтор(ак|ка)|серад[аы]|чацьв(ер|ярга)|пятніц[аы]|субот[аы])/i
};
var parseDayPatterns10={
narrow:[/^н/i,/^п/i,/^а/i,/^с/i,/^ч/i,/^п/i,/^с/i],
any:[/^н/i,/^п[ан]/i,/^а/i,/^с[ер]/i,/^ч/i,/^п[ят]/i,/^с[уб]/i]
};
var matchDayPeriodPatterns10={
narrow:/^([дп]п|поўн\.?|поўд\.?|ран\.?|дзень|дня|веч\.?|ночы?)/i,
abbreviated:/^([дп]п|поўн\.?|поўд\.?|ран\.?|дзень|дня|веч\.?|ночы?)/i,
wide:/^([дп]п|поўнач|поўдзень|раніц[аы]|дзень|дня|вечара?|ночы?)/i
};
var parseDayPeriodPatterns10={
any:{
am:/^дп/i,
pm:/^пп/i,
midnight:/^поўн/i,
noon:/^поўд/i,
morning:/^р/i,
afternoon:/^д[зн]/i,
evening:/^в/i,
night:/^н/i
}
};
var match19={
ordinalNumber:buildMatchPatternFn({
matchPattern:matchOrdinalNumberPattern10,
parsePattern:parseOrdinalNumberPattern10,
valueCallback:function valueCallback(value){return parseInt(value,10);}
}),
era:buildMatchFn({
matchPatterns:matchEraPatterns10,
defaultMatchWidth:"wide",
parsePatterns:parseEraPatterns10,
defaultParseWidth:"any"
}),
quarter:buildMatchFn({
matchPatterns:matchQuarterPatterns10,
defaultMatchWidth:"wide",
parsePatterns:parseQuarterPatterns10,
defaultParseWidth:"any",
valueCallback:function valueCallback(index){return index+1;}
}),
month:buildMatchFn({
matchPatterns:matchMonthPatterns10,
defaultMatchWidth:"wide",
parsePatterns:parseMonthPatterns10,
defaultParseWidth:"any"
}),
day:buildMatchFn({
matchPatterns:matchDayPatterns10,
defaultMatchWidth:"wide",
parsePatterns:parseDayPatterns10,
defaultParseWidth:"any"
}),
dayPeriod:buildMatchFn({
matchPatterns:matchDayPeriodPatterns10,
defaultMatchWidth:"wide",
parsePatterns:parseDayPeriodPatterns10,
defaultParseWidth:"any"
})
};

// lib/locale/be-tarask.js
var _beTarask={
code:"be-tarask",
formatDistance:formatDistance19,
formatLong:formatLong19,
formatRelative:formatRelative19,
localize:localize19,
match:match19,
options:{
weekStartsOn:1,
firstWeekContainsDate:1
}
};
// lib/locale/bg/_lib/formatDistance.js
var formatDistanceLocale11={
lessThanXSeconds:{
one:"\u043F\u043E-\u043C\u0430\u043B\u043A\u043E \u043E\u0442 \u0441\u0435\u043A\u0443\u043D\u0434\u0430",
other:"\u043F\u043E-\u043C\u0430\u043B\u043A\u043E \u043E\u0442 {{count}} \u0441\u0435\u043A\u0443\u043D\u0434\u0438"
},
xSeconds:{
one:"1 \u0441\u0435\u043A\u0443\u043D\u0434\u0430",
other:"{{count}} \u0441\u0435\u043A\u0443\u043D\u0434\u0438"
},
halfAMinute:"\u043F\u043E\u043B\u043E\u0432\u0438\u043D \u043C\u0438\u043D\u0443\u0442\u0430",
lessThanXMinutes:{
one:"\u043F\u043E-\u043C\u0430\u043B\u043A\u043E \u043E\u0442 \u043C\u0438\u043D\u0443\u0442\u0430",
other:"\u043F\u043E-\u043C\u0430\u043B\u043A\u043E \u043E\u0442 {{count}} \u043C\u0438\u043D\u0443\u0442\u0438"
},
xMinutes:{
one:"1 \u043C\u0438\u043D\u0443\u0442\u0430",
other:"{{count}} \u043C\u0438\u043D\u0443\u0442\u0438"
},
aboutXHours:{
one:"\u043E\u043A\u043E\u043B\u043E \u0447\u0430\u0441",
other:"\u043E\u043A\u043E\u043B\u043E {{count}} \u0447\u0430\u0441\u0430"
},
xHours:{
one:"1 \u0447\u0430\u0441",
other:"{{count}} \u0447\u0430\u0441\u0430"
},
xDays:{
one:"1 \u0434\u0435\u043D",
other:"{{count}} \u0434\u043D\u0438"
},
aboutXWeeks:{
one:"\u043E\u043A\u043E\u043B\u043E \u0441\u0435\u0434\u043C\u0438\u0446\u0430",
other:"\u043E\u043A\u043E\u043B\u043E {{count}} \u0441\u0435\u0434\u043C\u0438\u0446\u0438"
},
xWeeks:{
one:"1 \u0441\u0435\u0434\u043C\u0438\u0446\u0430",
other:"{{count}} \u0441\u0435\u0434\u043C\u0438\u0446\u0438"
},
aboutXMonths:{
one:"\u043E\u043A\u043E\u043B\u043E \u043C\u0435\u0441\u0435\u0446",
other:"\u043E\u043A\u043E\u043B\u043E {{count}} \u043C\u0435\u0441\u0435\u0446\u0430"
},
xMonths:{
one:"1 \u043C\u0435\u0441\u0435\u0446",
other:"{{count}} \u043C\u0435\u0441\u0435\u0446\u0430"
},
aboutXYears:{
one:"\u043E\u043A\u043E\u043B\u043E \u0433\u043E\u0434\u0438\u043D\u0430",
other:"\u043E\u043A\u043E\u043B\u043E {{count}} \u0433\u043E\u0434\u0438\u043D\u0438"
},
xYears:{
one:"1 \u0433\u043E\u0434\u0438\u043D\u0430",
other:"{{count}} \u0433\u043E\u0434\u0438\u043D\u0438"
},
overXYears:{
one:"\u043D\u0430\u0434 \u0433\u043E\u0434\u0438\u043D\u0430",
other:"\u043D\u0430\u0434 {{count}} \u0433\u043E\u0434\u0438\u043D\u0438"
},
almostXYears:{
one:"\u043F\u043E\u0447\u0442\u0438 \u0433\u043E\u0434\u0438\u043D\u0430",
other:"\u043F\u043E\u0447\u0442\u0438 {{count}} \u0433\u043E\u0434\u0438\u043D\u0438"
}
};
var formatDistance21=function formatDistance21(token,count,options){
var result;
var tokenValue=formatDistanceLocale11[token];
if(typeof tokenValue==="string"){
result=tokenValue;
}else if(count===1){
result=tokenValue.one;
}else{
result=tokenValue.other.replace("{{count}}",String(count));
}
if(options!==null&&options!==void 0&&options.addSuffix){
if(options.comparison&&options.comparison>0){
return"\u0441\u043B\u0435\u0434 "+result;
}else{
return"\u043F\u0440\u0435\u0434\u0438 "+result;
}
}
return result;
};

// lib/locale/bg/_lib/formatLong.js
var dateFormats11={
full:"EEEE, dd MMMM yyyy",
long:"dd MMMM yyyy",
medium:"dd MMM yyyy",
short:"dd.MM.yyyy"
};
var timeFormats11={
full:"HH:mm:ss zzzz",
long:"HH:mm:ss z",
medium:"HH:mm:ss",
short:"H:mm"
};
var dateTimeFormats11={
any:"{{date}} {{time}}"
};
var formatLong21={
date:buildFormatLongFn({
formats:dateFormats11,
defaultWidth:"full"
}),
time:buildFormatLongFn({
formats:timeFormats11,
defaultWidth:"full"
}),
dateTime:buildFormatLongFn({
formats:dateTimeFormats11,
defaultWidth:"any"
})
};

// lib/locale/bg/_lib/formatRelative.js
function lastWeek3(day){
var weekday=weekdays[day];
switch(day){
case 0:
case 3:
case 6:
return"'\u043C\u0438\u043D\u0430\u043B\u0430\u0442\u0430 "+weekday+" \u0432' p";
case 1:
case 2:
case 4:
case 5:
return"'\u043C\u0438\u043D\u0430\u043B\u0438\u044F "+weekday+" \u0432' p";
}
}
function thisWeek3(day){
var weekday=weekdays[day];
if(day===2){
return"'\u0432\u044A\u0432 "+weekday+" \u0432' p";
}else{
return"'\u0432 "+weekday+" \u0432' p";
}
}
function nextWeek3(day){
var weekday=weekdays[day];
switch(day){
case 0:
case 3:
case 6:
return"'\u0441\u043B\u0435\u0434\u0432\u0430\u0449\u0430\u0442\u0430 "+weekday+" \u0432' p";
case 1:
case 2:
case 4:
case 5:
return"'\u0441\u043B\u0435\u0434\u0432\u0430\u0449\u0438\u044F "+weekday+" \u0432' p";
}
}
var weekdays=[
"\u043D\u0435\u0434\u0435\u043B\u044F",
"\u043F\u043E\u043D\u0435\u0434\u0435\u043B\u043D\u0438\u043A",
"\u0432\u0442\u043E\u0440\u043D\u0438\u043A",
"\u0441\u0440\u044F\u0434\u0430",
"\u0447\u0435\u0442\u0432\u044A\u0440\u0442\u044A\u043A",
"\u043F\u0435\u0442\u044A\u043A",
"\u0441\u044A\u0431\u043E\u0442\u0430"];

var lastWeekFormatToken=function lastWeekFormatToken(dirtyDate,baseDate,options){
var date=toDate(dirtyDate);
var day=date.getDay();
if(isSameWeek(date,baseDate,options)){
return thisWeek3(day);
}else{
return lastWeek3(day);
}
};
var nextWeekFormatToken=function nextWeekFormatToken(dirtyDate,baseDate,options){
var date=toDate(dirtyDate);
var day=date.getDay();
if(isSameWeek(date,baseDate,options)){
return thisWeek3(day);
}else{
return nextWeek3(day);
}
};
var formatRelativeLocale11={
lastWeek:lastWeekFormatToken,
yesterday:"'\u0432\u0447\u0435\u0440\u0430 \u0432' p",
today:"'\u0434\u043D\u0435\u0441 \u0432' p",
tomorrow:"'\u0443\u0442\u0440\u0435 \u0432' p",
nextWeek:nextWeekFormatToken,
other:"P"
};
var formatRelative21=function formatRelative21(token,date,baseDate,options){
var format=formatRelativeLocale11[token];
if(typeof format==="function"){
return format(date,baseDate,options);
}
return format;
};

// lib/locale/bg/_lib/localize.js
function isFeminine(unit){
return unit==="year"||unit==="week"||unit==="minute"||unit==="second";
}
function isNeuter(unit){
return unit==="quarter";
}
function numberWithSuffix(number,unit,masculine,feminine,neuter){
var suffix=isNeuter(unit)?neuter:isFeminine(unit)?feminine:masculine;
return number+"-"+suffix;
}
var eraValues11={
narrow:["\u043F\u0440.\u043D.\u0435.","\u043D.\u0435."],
abbreviated:["\u043F\u0440\u0435\u0434\u0438 \u043D. \u0435.","\u043D. \u0435."],
wide:["\u043F\u0440\u0435\u0434\u0438 \u043D\u043E\u0432\u0430\u0442\u0430 \u0435\u0440\u0430","\u043D\u043E\u0432\u0430\u0442\u0430 \u0435\u0440\u0430"]
};
var quarterValues11={
narrow:["1","2","3","4"],
abbreviated:["1-\u0432\u043E \u0442\u0440\u0438\u043C\u0435\u0441.","2-\u0440\u043E \u0442\u0440\u0438\u043C\u0435\u0441.","3-\u0442\u043E \u0442\u0440\u0438\u043C\u0435\u0441.","4-\u0442\u043E \u0442\u0440\u0438\u043C\u0435\u0441."],
wide:[
"1-\u0432\u043E \u0442\u0440\u0438\u043C\u0435\u0441\u0435\u0447\u0438\u0435",
"2-\u0440\u043E \u0442\u0440\u0438\u043C\u0435\u0441\u0435\u0447\u0438\u0435",
"3-\u0442\u043E \u0442\u0440\u0438\u043C\u0435\u0441\u0435\u0447\u0438\u0435",
"4-\u0442\u043E \u0442\u0440\u0438\u043C\u0435\u0441\u0435\u0447\u0438\u0435"]

};
var monthValues11={
abbreviated:[
"\u044F\u043D\u0443",
"\u0444\u0435\u0432",
"\u043C\u0430\u0440",
"\u0430\u043F\u0440",
"\u043C\u0430\u0439",
"\u044E\u043D\u0438",
"\u044E\u043B\u0438",
"\u0430\u0432\u0433",
"\u0441\u0435\u043F",
"\u043E\u043A\u0442",
"\u043D\u043E\u0435",
"\u0434\u0435\u043A"],

wide:[
"\u044F\u043D\u0443\u0430\u0440\u0438",
"\u0444\u0435\u0432\u0440\u0443\u0430\u0440\u0438",
"\u043C\u0430\u0440\u0442",
"\u0430\u043F\u0440\u0438\u043B",
"\u043C\u0430\u0439",
"\u044E\u043D\u0438",
"\u044E\u043B\u0438",
"\u0430\u0432\u0433\u0443\u0441\u0442",
"\u0441\u0435\u043F\u0442\u0435\u043C\u0432\u0440\u0438",
"\u043E\u043A\u0442\u043E\u043C\u0432\u0440\u0438",
"\u043D\u043E\u0435\u043C\u0432\u0440\u0438",
"\u0434\u0435\u043A\u0435\u043C\u0432\u0440\u0438"]

};
var dayValues11={
narrow:["\u041D","\u041F","\u0412","\u0421","\u0427","\u041F","\u0421"],
short:["\u043D\u0434","\u043F\u043D","\u0432\u0442","\u0441\u0440","\u0447\u0442","\u043F\u0442","\u0441\u0431"],
abbreviated:["\u043D\u0435\u0434","\u043F\u043E\u043D","\u0432\u0442\u043E","\u0441\u0440\u044F","\u0447\u0435\u0442","\u043F\u0435\u0442","\u0441\u044A\u0431"],
wide:[
"\u043D\u0435\u0434\u0435\u043B\u044F",
"\u043F\u043E\u043D\u0435\u0434\u0435\u043B\u043D\u0438\u043A",
"\u0432\u0442\u043E\u0440\u043D\u0438\u043A",
"\u0441\u0440\u044F\u0434\u0430",
"\u0447\u0435\u0442\u0432\u044A\u0440\u0442\u044A\u043A",
"\u043F\u0435\u0442\u044A\u043A",
"\u0441\u044A\u0431\u043E\u0442\u0430"]

};
var dayPeriodValues11={
wide:{
am:"\u043F\u0440\u0435\u0434\u0438 \u043E\u0431\u044F\u0434",
pm:"\u0441\u043B\u0435\u0434 \u043E\u0431\u044F\u0434",
midnight:"\u0432 \u043F\u043E\u043B\u0443\u043D\u043E\u0449",
noon:"\u043D\u0430 \u043E\u0431\u044F\u0434",
morning:"\u0441\u0443\u0442\u0440\u0438\u043D\u0442\u0430",
afternoon:"\u0441\u043B\u0435\u0434\u043E\u0431\u0435\u0434",
evening:"\u0432\u0435\u0447\u0435\u0440\u0442\u0430",
night:"\u043F\u0440\u0435\u0437 \u043D\u043E\u0449\u0442\u0430"
}
};
var ordinalNumber11=function ordinalNumber11(dirtyNumber,options){
var number=Number(dirtyNumber);
var unit=options===null||options===void 0?void 0:options.unit;
if(number===0){
return numberWithSuffix(0,unit,"\u0435\u0432","\u0435\u0432\u0430","\u0435\u0432\u043E");
}else if(number%1000===0){
return numberWithSuffix(number,unit,"\u0435\u043D","\u043D\u0430","\u043D\u043E");
}else if(number%100===0){
return numberWithSuffix(number,unit,"\u0442\u0435\u043D","\u0442\u043D\u0430","\u0442\u043D\u043E");
}
var rem100=number%100;
if(rem100>20||rem100<10){
switch(rem100%10){
case 1:
return numberWithSuffix(number,unit,"\u0432\u0438","\u0432\u0430","\u0432\u043E");
case 2:
return numberWithSuffix(number,unit,"\u0440\u0438","\u0440\u0430","\u0440\u043E");
case 7:
case 8:
return numberWithSuffix(number,unit,"\u043C\u0438","\u043C\u0430","\u043C\u043E");
}
}
return numberWithSuffix(number,unit,"\u0442\u0438","\u0442\u0430","\u0442\u043E");
};
var localize21={
ordinalNumber:ordinalNumber11,
era:buildLocalizeFn({
values:eraValues11,
defaultWidth:"wide"
}),
quarter:buildLocalizeFn({
values:quarterValues11,
defaultWidth:"wide",
argumentCallback:function argumentCallback(quarter){return quarter-1;}
}),
month:buildLocalizeFn({
values:monthValues11,
defaultWidth:"wide"
}),
day:buildLocalizeFn({
values:dayValues11,
defaultWidth:"wide"
}),
dayPeriod:buildLocalizeFn({
values:dayPeriodValues11,
defaultWidth:"wide"
})
};

// lib/locale/bg/_lib/match.js
var matchOrdinalNumberPattern11=/^(\d+)(-?[врмт][аи]|-?т?(ен|на)|-?(ев|ева))?/i;
var parseOrdinalNumberPattern11=/\d+/i;
var matchEraPatterns11={
narrow:/^((пр)?н\.?\s?е\.?)/i,
abbreviated:/^((пр)?н\.?\s?е\.?)/i,
wide:/^(преди новата ера|новата ера|нова ера)/i
};
var parseEraPatterns11={
any:[/^п/i,/^н/i]
};
var matchQuarterPatterns11={
narrow:/^[1234]/i,
abbreviated:/^[1234](-?[врт]?o?)? тримес.?/i,
wide:/^[1234](-?[врт]?о?)? тримесечие/i
};
var parseQuarterPatterns11={
any:[/1/i,/2/i,/3/i,/4/i]
};
var matchDayPatterns11={
narrow:/^[нпвсч]/i,
short:/^(нд|пн|вт|ср|чт|пт|сб)/i,
abbreviated:/^(нед|пон|вто|сря|чет|пет|съб)/i,
wide:/^(неделя|понеделник|вторник|сряда|четвъртък|петък|събота)/i
};
var parseDayPatterns11={
narrow:[/^н/i,/^п/i,/^в/i,/^с/i,/^ч/i,/^п/i,/^с/i],
any:[/^н[ед]/i,/^п[он]/i,/^вт/i,/^ср/i,/^ч[ет]/i,/^п[ет]/i,/^с[ъб]/i]
};
var matchMonthPatterns11={
abbreviated:/^(яну|фев|мар|апр|май|юни|юли|авг|сеп|окт|ное|дек)/i,
wide:/^(януари|февруари|март|април|май|юни|юли|август|септември|октомври|ноември|декември)/i
};
var parseMonthPatterns11={
any:[
/^я/i,
/^ф/i,
/^мар/i,
/^ап/i,
/^май/i,
/^юн/i,
/^юл/i,
/^ав/i,
/^се/i,
/^окт/i,
/^но/i,
/^де/i]

};
var matchDayPeriodPatterns11={
any:/^(преди о|след о|в по|на о|през|веч|сут|следо)/i
};
var parseDayPeriodPatterns11={
any:{
am:/^преди о/i,
pm:/^след о/i,
midnight:/^в пол/i,
noon:/^на об/i,
morning:/^сут/i,
afternoon:/^следо/i,
evening:/^веч/i,
night:/^през н/i
}
};
var match21={
ordinalNumber:buildMatchPatternFn({
matchPattern:matchOrdinalNumberPattern11,
parsePattern:parseOrdinalNumberPattern11,
valueCallback:function valueCallback(value){return parseInt(value,10);}
}),
era:buildMatchFn({
matchPatterns:matchEraPatterns11,
defaultMatchWidth:"wide",
parsePatterns:parseEraPatterns11,
defaultParseWidth:"any"
}),
quarter:buildMatchFn({
matchPatterns:matchQuarterPatterns11,
defaultMatchWidth:"wide",
parsePatterns:parseQuarterPatterns11,
defaultParseWidth:"any",
valueCallback:function valueCallback(index){return index+1;}
}),
month:buildMatchFn({
matchPatterns:matchMonthPatterns11,
defaultMatchWidth:"wide",
parsePatterns:parseMonthPatterns11,
defaultParseWidth:"any"
}),
day:buildMatchFn({
matchPatterns:matchDayPatterns11,
defaultMatchWidth:"wide",
parsePatterns:parseDayPatterns11,
defaultParseWidth:"any"
}),
dayPeriod:buildMatchFn({
matchPatterns:matchDayPeriodPatterns11,
defaultMatchWidth:"any",
parsePatterns:parseDayPeriodPatterns11,
defaultParseWidth:"any"
})
};

// lib/locale/bg.js
var _bg={
code:"bg",
formatDistance:formatDistance21,
formatLong:formatLong21,
formatRelative:formatRelative21,
localize:localize21,
match:match21,
options:{
weekStartsOn:1,
firstWeekContainsDate:1
}
};
// lib/locale/bn/_lib/localize.js
function dateOrdinalNumber(number,localeNumber){
if(number>18&&number<=31){
return localeNumber+"\u09B6\u09C7";
}else{
switch(number){
case 1:
return localeNumber+"\u09B2\u09BE";
case 2:
case 3:
return localeNumber+"\u09B0\u09BE";
case 4:
return localeNumber+"\u09A0\u09BE";
default:
return localeNumber+"\u0987";
}
}
}
function numberToLocale(enNumber){
return enNumber.toString().replace(/\d/g,function(match23){
return numberValues.locale[match23];
});
}
var numberValues={
locale:{
1:"\u09E7",
2:"\u09E8",
3:"\u09E9",
4:"\u09EA",
5:"\u09EB",
6:"\u09EC",
7:"\u09ED",
8:"\u09EE",
9:"\u09EF",
0:"\u09E6"
},
number:{
"\u09E7":"1",
"\u09E8":"2",
"\u09E9":"3",
"\u09EA":"4",
"\u09EB":"5",
"\u09EC":"6",
"\u09ED":"7",
"\u09EE":"8",
"\u09EF":"9",
"\u09E6":"0"
}
};
var eraValues12={
narrow:["\u0996\u09CD\u09B0\u09BF\u0983\u09AA\u09C2\u0983","\u0996\u09CD\u09B0\u09BF\u0983"],
abbreviated:["\u0996\u09CD\u09B0\u09BF\u0983\u09AA\u09C2\u09B0\u09CD\u09AC","\u0996\u09CD\u09B0\u09BF\u0983"],
wide:["\u0996\u09CD\u09B0\u09BF\u09B8\u09CD\u099F\u09AA\u09C2\u09B0\u09CD\u09AC","\u0996\u09CD\u09B0\u09BF\u09B8\u09CD\u099F\u09BE\u09AC\u09CD\u09A6"]
};
var quarterValues12={
narrow:["\u09E7","\u09E8","\u09E9","\u09EA"],
abbreviated:["\u09E7\u09A4\u09CD\u09B0\u09C8","\u09E8\u09A4\u09CD\u09B0\u09C8","\u09E9\u09A4\u09CD\u09B0\u09C8","\u09EA\u09A4\u09CD\u09B0\u09C8"],
wide:["\u09E7\u09AE \u09A4\u09CD\u09B0\u09C8\u09AE\u09BE\u09B8\u09BF\u0995","\u09E8\u09DF \u09A4\u09CD\u09B0\u09C8\u09AE\u09BE\u09B8\u09BF\u0995","\u09E9\u09DF \u09A4\u09CD\u09B0\u09C8\u09AE\u09BE\u09B8\u09BF\u0995","\u09EA\u09B0\u09CD\u09A5 \u09A4\u09CD\u09B0\u09C8\u09AE\u09BE\u09B8\u09BF\u0995"]
};
var monthValues12={
narrow:[
"\u099C\u09BE\u09A8\u09C1",
"\u09AB\u09C7\u09AC\u09CD\u09B0\u09C1",
"\u09AE\u09BE\u09B0\u09CD\u099A",
"\u098F\u09AA\u09CD\u09B0\u09BF\u09B2",
"\u09AE\u09C7",
"\u099C\u09C1\u09A8",
"\u099C\u09C1\u09B2\u09BE\u0987",
"\u0986\u0997\u09B8\u09CD\u099F",
"\u09B8\u09C7\u09AA\u09CD\u099F",
"\u0985\u0995\u09CD\u099F\u09CB",
"\u09A8\u09AD\u09C7",
"\u09A1\u09BF\u09B8\u09C7"],

abbreviated:[
"\u099C\u09BE\u09A8\u09C1",
"\u09AB\u09C7\u09AC\u09CD\u09B0\u09C1",
"\u09AE\u09BE\u09B0\u09CD\u099A",
"\u098F\u09AA\u09CD\u09B0\u09BF\u09B2",
"\u09AE\u09C7",
"\u099C\u09C1\u09A8",
"\u099C\u09C1\u09B2\u09BE\u0987",
"\u0986\u0997\u09B8\u09CD\u099F",
"\u09B8\u09C7\u09AA\u09CD\u099F",
"\u0985\u0995\u09CD\u099F\u09CB",
"\u09A8\u09AD\u09C7",
"\u09A1\u09BF\u09B8\u09C7"],

wide:[
"\u099C\u09BE\u09A8\u09C1\u09DF\u09BE\u09B0\u09BF",
"\u09AB\u09C7\u09AC\u09CD\u09B0\u09C1\u09DF\u09BE\u09B0\u09BF",
"\u09AE\u09BE\u09B0\u09CD\u099A",
"\u098F\u09AA\u09CD\u09B0\u09BF\u09B2",
"\u09AE\u09C7",
"\u099C\u09C1\u09A8",
"\u099C\u09C1\u09B2\u09BE\u0987",
"\u0986\u0997\u09B8\u09CD\u099F",
"\u09B8\u09C7\u09AA\u09CD\u099F\u09C7\u09AE\u09CD\u09AC\u09B0",
"\u0985\u0995\u09CD\u099F\u09CB\u09AC\u09B0",
"\u09A8\u09AD\u09C7\u09AE\u09CD\u09AC\u09B0",
"\u09A1\u09BF\u09B8\u09C7\u09AE\u09CD\u09AC\u09B0"]

};
var dayValues12={
narrow:["\u09B0","\u09B8\u09CB","\u09AE","\u09AC\u09C1","\u09AC\u09C3","\u09B6\u09C1","\u09B6"],
short:["\u09B0\u09AC\u09BF","\u09B8\u09CB\u09AE","\u09AE\u0999\u09CD\u0997\u09B2","\u09AC\u09C1\u09A7","\u09AC\u09C3\u09B9","\u09B6\u09C1\u0995\u09CD\u09B0","\u09B6\u09A8\u09BF"],
abbreviated:["\u09B0\u09AC\u09BF","\u09B8\u09CB\u09AE","\u09AE\u0999\u09CD\u0997\u09B2","\u09AC\u09C1\u09A7","\u09AC\u09C3\u09B9","\u09B6\u09C1\u0995\u09CD\u09B0","\u09B6\u09A8\u09BF"],
wide:[
"\u09B0\u09AC\u09BF\u09AC\u09BE\u09B0",
"\u09B8\u09CB\u09AE\u09AC\u09BE\u09B0",
"\u09AE\u0999\u09CD\u0997\u09B2\u09AC\u09BE\u09B0",
"\u09AC\u09C1\u09A7\u09AC\u09BE\u09B0",
"\u09AC\u09C3\u09B9\u09B8\u09CD\u09AA\u09A4\u09BF\u09AC\u09BE\u09B0 ",
"\u09B6\u09C1\u0995\u09CD\u09B0\u09AC\u09BE\u09B0",
"\u09B6\u09A8\u09BF\u09AC\u09BE\u09B0"]

};
var dayPeriodValues12={
narrow:{
am:"\u09AA\u09C2",
pm:"\u0985\u09AA",
midnight:"\u09AE\u09A7\u09CD\u09AF\u09B0\u09BE\u09A4",
noon:"\u09AE\u09A7\u09CD\u09AF\u09BE\u09B9\u09CD\u09A8",
morning:"\u09B8\u0995\u09BE\u09B2",
afternoon:"\u09AC\u09BF\u0995\u09BE\u09B2",
evening:"\u09B8\u09A8\u09CD\u09A7\u09CD\u09AF\u09BE",
night:"\u09B0\u09BE\u09A4"
},
abbreviated:{
am:"\u09AA\u09C2\u09B0\u09CD\u09AC\u09BE\u09B9\u09CD\u09A8",
pm:"\u0985\u09AA\u09B0\u09BE\u09B9\u09CD\u09A8",
midnight:"\u09AE\u09A7\u09CD\u09AF\u09B0\u09BE\u09A4",
noon:"\u09AE\u09A7\u09CD\u09AF\u09BE\u09B9\u09CD\u09A8",
morning:"\u09B8\u0995\u09BE\u09B2",
afternoon:"\u09AC\u09BF\u0995\u09BE\u09B2",
evening:"\u09B8\u09A8\u09CD\u09A7\u09CD\u09AF\u09BE",
night:"\u09B0\u09BE\u09A4"
},
wide:{
am:"\u09AA\u09C2\u09B0\u09CD\u09AC\u09BE\u09B9\u09CD\u09A8",
pm:"\u0985\u09AA\u09B0\u09BE\u09B9\u09CD\u09A8",
midnight:"\u09AE\u09A7\u09CD\u09AF\u09B0\u09BE\u09A4",
noon:"\u09AE\u09A7\u09CD\u09AF\u09BE\u09B9\u09CD\u09A8",
morning:"\u09B8\u0995\u09BE\u09B2",
afternoon:"\u09AC\u09BF\u0995\u09BE\u09B2",
evening:"\u09B8\u09A8\u09CD\u09A7\u09CD\u09AF\u09BE",
night:"\u09B0\u09BE\u09A4"
}
};
var formattingDayPeriodValues11={
narrow:{
am:"\u09AA\u09C2",
pm:"\u0985\u09AA",
midnight:"\u09AE\u09A7\u09CD\u09AF\u09B0\u09BE\u09A4",
noon:"\u09AE\u09A7\u09CD\u09AF\u09BE\u09B9\u09CD\u09A8",
morning:"\u09B8\u0995\u09BE\u09B2",
afternoon:"\u09AC\u09BF\u0995\u09BE\u09B2",
evening:"\u09B8\u09A8\u09CD\u09A7\u09CD\u09AF\u09BE",
night:"\u09B0\u09BE\u09A4"
},
abbreviated:{
am:"\u09AA\u09C2\u09B0\u09CD\u09AC\u09BE\u09B9\u09CD\u09A8",
pm:"\u0985\u09AA\u09B0\u09BE\u09B9\u09CD\u09A8",
midnight:"\u09AE\u09A7\u09CD\u09AF\u09B0\u09BE\u09A4",
noon:"\u09AE\u09A7\u09CD\u09AF\u09BE\u09B9\u09CD\u09A8",
morning:"\u09B8\u0995\u09BE\u09B2",
afternoon:"\u09AC\u09BF\u0995\u09BE\u09B2",
evening:"\u09B8\u09A8\u09CD\u09A7\u09CD\u09AF\u09BE",
night:"\u09B0\u09BE\u09A4"
},
wide:{
am:"\u09AA\u09C2\u09B0\u09CD\u09AC\u09BE\u09B9\u09CD\u09A8",
pm:"\u0985\u09AA\u09B0\u09BE\u09B9\u09CD\u09A8",
midnight:"\u09AE\u09A7\u09CD\u09AF\u09B0\u09BE\u09A4",
noon:"\u09AE\u09A7\u09CD\u09AF\u09BE\u09B9\u09CD\u09A8",
morning:"\u09B8\u0995\u09BE\u09B2",
afternoon:"\u09AC\u09BF\u0995\u09BE\u09B2",
evening:"\u09B8\u09A8\u09CD\u09A7\u09CD\u09AF\u09BE",
night:"\u09B0\u09BE\u09A4"
}
};
var ordinalNumber12=function ordinalNumber12(dirtyNumber,options){
var number=Number(dirtyNumber);
var localeNumber=numberToLocale(number);
var unit=options===null||options===void 0?void 0:options.unit;
if(unit==="date"){
return dateOrdinalNumber(number,localeNumber);
}
if(number>10||number===0)
return localeNumber+"\u09A4\u09AE";
var rem10=number%10;
switch(rem10){
case 2:
case 3:
return localeNumber+"\u09DF";
case 4:
return localeNumber+"\u09B0\u09CD\u09A5";
case 6:
return localeNumber+"\u09B7\u09CD\u09A0";
default:
return localeNumber+"\u09AE";
}
};
var localize23={
ordinalNumber:ordinalNumber12,
era:buildLocalizeFn({
values:eraValues12,
defaultWidth:"wide"
}),
quarter:buildLocalizeFn({
values:quarterValues12,
defaultWidth:"wide",
argumentCallback:function argumentCallback(quarter){return quarter-1;}
}),
month:buildLocalizeFn({
values:monthValues12,
defaultWidth:"wide"
}),
day:buildLocalizeFn({
values:dayValues12,
defaultWidth:"wide"
}),
dayPeriod:buildLocalizeFn({
values:dayPeriodValues12,
defaultWidth:"wide",
formattingValues:formattingDayPeriodValues11,
defaultFormattingWidth:"wide"
})
};

// lib/locale/bn/_lib/formatDistance.js
var formatDistanceLocale12={
lessThanXSeconds:{
one:"\u09AA\u09CD\u09B0\u09BE\u09DF \u09E7 \u09B8\u09C7\u0995\u09C7\u09A8\u09CD\u09A1",
other:"\u09AA\u09CD\u09B0\u09BE\u09DF {{count}} \u09B8\u09C7\u0995\u09C7\u09A8\u09CD\u09A1"
},
xSeconds:{
one:"\u09E7 \u09B8\u09C7\u0995\u09C7\u09A8\u09CD\u09A1",
other:"{{count}} \u09B8\u09C7\u0995\u09C7\u09A8\u09CD\u09A1"
},
halfAMinute:"\u0986\u09A7 \u09AE\u09BF\u09A8\u09BF\u099F",
lessThanXMinutes:{
one:"\u09AA\u09CD\u09B0\u09BE\u09DF \u09E7 \u09AE\u09BF\u09A8\u09BF\u099F",
other:"\u09AA\u09CD\u09B0\u09BE\u09DF {{count}} \u09AE\u09BF\u09A8\u09BF\u099F"
},
xMinutes:{
one:"\u09E7 \u09AE\u09BF\u09A8\u09BF\u099F",
other:"{{count}} \u09AE\u09BF\u09A8\u09BF\u099F"
},
aboutXHours:{
one:"\u09AA\u09CD\u09B0\u09BE\u09DF \u09E7 \u0998\u09A8\u09CD\u099F\u09BE",
other:"\u09AA\u09CD\u09B0\u09BE\u09DF {{count}} \u0998\u09A8\u09CD\u099F\u09BE"
},
xHours:{
one:"\u09E7 \u0998\u09A8\u09CD\u099F\u09BE",
other:"{{count}} \u0998\u09A8\u09CD\u099F\u09BE"
},
xDays:{
one:"\u09E7 \u09A6\u09BF\u09A8",
other:"{{count}} \u09A6\u09BF\u09A8"
},
aboutXWeeks:{
one:"\u09AA\u09CD\u09B0\u09BE\u09DF \u09E7 \u09B8\u09AA\u09CD\u09A4\u09BE\u09B9",
other:"\u09AA\u09CD\u09B0\u09BE\u09DF {{count}} \u09B8\u09AA\u09CD\u09A4\u09BE\u09B9"
},
xWeeks:{
one:"\u09E7 \u09B8\u09AA\u09CD\u09A4\u09BE\u09B9",
other:"{{count}} \u09B8\u09AA\u09CD\u09A4\u09BE\u09B9"
},
aboutXMonths:{
one:"\u09AA\u09CD\u09B0\u09BE\u09DF \u09E7 \u09AE\u09BE\u09B8",
other:"\u09AA\u09CD\u09B0\u09BE\u09DF {{count}} \u09AE\u09BE\u09B8"
},
xMonths:{
one:"\u09E7 \u09AE\u09BE\u09B8",
other:"{{count}} \u09AE\u09BE\u09B8"
},
aboutXYears:{
one:"\u09AA\u09CD\u09B0\u09BE\u09DF \u09E7 \u09AC\u099B\u09B0",
other:"\u09AA\u09CD\u09B0\u09BE\u09DF {{count}} \u09AC\u099B\u09B0"
},
xYears:{
one:"\u09E7 \u09AC\u099B\u09B0",
other:"{{count}} \u09AC\u099B\u09B0"
},
overXYears:{
one:"\u09E7 \u09AC\u099B\u09B0\u09C7\u09B0 \u09AC\u09C7\u09B6\u09BF",
other:"{{count}} \u09AC\u099B\u09B0\u09C7\u09B0 \u09AC\u09C7\u09B6\u09BF"
},
almostXYears:{
one:"\u09AA\u09CD\u09B0\u09BE\u09DF \u09E7 \u09AC\u099B\u09B0",
other:"\u09AA\u09CD\u09B0\u09BE\u09DF {{count}} \u09AC\u099B\u09B0"
}
};
var formatDistance23=function formatDistance23(token,count,options){
var result;
var tokenValue=formatDistanceLocale12[token];
if(typeof tokenValue==="string"){
result=tokenValue;
}else if(count===1){
result=tokenValue.one;
}else{
result=tokenValue.other.replace("{{count}}",numberToLocale(count));
}
if(options!==null&&options!==void 0&&options.addSuffix){
if(options.comparison&&options.comparison>0){
return result+" \u098F\u09B0 \u09AE\u09A7\u09CD\u09AF\u09C7";
}else{
return result+" \u0986\u0997\u09C7";
}
}
return result;
};

// lib/locale/bn/_lib/formatLong.js
var dateFormats12={
full:"EEEE, MMMM do, y",
long:"MMMM do, y",
medium:"MMM d, y",
short:"MM/dd/yyyy"
};
var timeFormats12={
full:"h:mm:ss a zzzz",
long:"h:mm:ss a z",
medium:"h:mm:ss a",
short:"h:mm a"
};
var dateTimeFormats12={
full:"{{date}} {{time}} '\u09B8\u09AE\u09DF'",
long:"{{date}} {{time}} '\u09B8\u09AE\u09DF'",
medium:"{{date}}, {{time}}",
short:"{{date}}, {{time}}"
};
var formatLong23={
date:buildFormatLongFn({
formats:dateFormats12,
defaultWidth:"full"
}),
time:buildFormatLongFn({
formats:timeFormats12,
defaultWidth:"full"
}),
dateTime:buildFormatLongFn({
formats:dateTimeFormats12,
defaultWidth:"full"
})
};

// lib/locale/bn/_lib/formatRelative.js
var formatRelativeLocale12={
lastWeek:"'\u0997\u09A4' eeee '\u09B8\u09AE\u09DF' p",
yesterday:"'\u0997\u09A4\u0995\u09BE\u09B2' '\u09B8\u09AE\u09DF' p",
today:"'\u0986\u099C' '\u09B8\u09AE\u09DF' p",
tomorrow:"'\u0986\u0997\u09BE\u09AE\u09C0\u0995\u09BE\u09B2' '\u09B8\u09AE\u09DF' p",
nextWeek:"eeee '\u09B8\u09AE\u09DF' p",
other:"P"
};
var formatRelative23=function formatRelative23(token,_date,_baseDate,_options){return formatRelativeLocale12[token];};

// lib/locale/bn/_lib/match.js
var matchOrdinalNumberPattern12=/^(\d+)(ম|য়|র্থ|ষ্ঠ|শে|ই|তম)?/i;
var parseOrdinalNumberPattern12=/\d+/i;
var matchEraPatterns12={
narrow:/^(খ্রিঃপূঃ|খ্রিঃ)/i,
abbreviated:/^(খ্রিঃপূর্ব|খ্রিঃ)/i,
wide:/^(খ্রিস্টপূর্ব|খ্রিস্টাব্দ)/i
};
var parseEraPatterns12={
narrow:[/^খ্রিঃপূঃ/i,/^খ্রিঃ/i],
abbreviated:[/^খ্রিঃপূর্ব/i,/^খ্রিঃ/i],
wide:[/^খ্রিস্টপূর্ব/i,/^খ্রিস্টাব্দ/i]
};
var matchQuarterPatterns12={
narrow:/^[১২৩৪]/i,
abbreviated:/^[১২৩৪]ত্রৈ/i,
wide:/^[১২৩৪](ম|য়|র্থ)? ত্রৈমাসিক/i
};
var parseQuarterPatterns12={
any:[/১/i,/২/i,/৩/i,/৪/i]
};
var matchMonthPatterns12={
narrow:/^(জানু|ফেব্রু|মার্চ|এপ্রিল|মে|জুন|জুলাই|আগস্ট|সেপ্ট|অক্টো|নভে|ডিসে)/i,
abbreviated:/^(জানু|ফেব্রু|মার্চ|এপ্রিল|মে|জুন|জুলাই|আগস্ট|সেপ্ট|অক্টো|নভে|ডিসে)/i,
wide:/^(জানুয়ারি|ফেব্রুয়ারি|মার্চ|এপ্রিল|মে|জুন|জুলাই|আগস্ট|সেপ্টেম্বর|অক্টোবর|নভেম্বর|ডিসেম্বর)/i
};
var parseMonthPatterns12={
any:[
/^জানু/i,
/^ফেব্রু/i,
/^মার্চ/i,
/^এপ্রিল/i,
/^মে/i,
/^জুন/i,
/^জুলাই/i,
/^আগস্ট/i,
/^সেপ্ট/i,
/^অক্টো/i,
/^নভে/i,
/^ডিসে/i]

};
var matchDayPatterns12={
narrow:/^(র|সো|ম|বু|বৃ|শু|শ)+/i,
short:/^(রবি|সোম|মঙ্গল|বুধ|বৃহ|শুক্র|শনি)+/i,
abbreviated:/^(রবি|সোম|মঙ্গল|বুধ|বৃহ|শুক্র|শনি)+/i,
wide:/^(রবিবার|সোমবার|মঙ্গলবার|বুধবার|বৃহস্পতিবার |শুক্রবার|শনিবার)+/i
};
var parseDayPatterns12={
narrow:[/^র/i,/^সো/i,/^ম/i,/^বু/i,/^বৃ/i,/^শু/i,/^শ/i],
short:[/^রবি/i,/^সোম/i,/^মঙ্গল/i,/^বুধ/i,/^বৃহ/i,/^শুক্র/i,/^শনি/i],
abbreviated:[
/^রবি/i,
/^সোম/i,
/^মঙ্গল/i,
/^বুধ/i,
/^বৃহ/i,
/^শুক্র/i,
/^শনি/i],

wide:[
/^রবিবার/i,
/^সোমবার/i,
/^মঙ্গলবার/i,
/^বুধবার/i,
/^বৃহস্পতিবার /i,
/^শুক্রবার/i,
/^শনিবার/i]

};
var matchDayPeriodPatterns12={
narrow:/^(পূ|অপ|মধ্যরাত|মধ্যাহ্ন|সকাল|বিকাল|সন্ধ্যা|রাত)/i,
abbreviated:/^(পূর্বাহ্ন|অপরাহ্ন|মধ্যরাত|মধ্যাহ্ন|সকাল|বিকাল|সন্ধ্যা|রাত)/i,
wide:/^(পূর্বাহ্ন|অপরাহ্ন|মধ্যরাত|মধ্যাহ্ন|সকাল|বিকাল|সন্ধ্যা|রাত)/i
};
var parseDayPeriodPatterns12={
any:{
am:/^পূ/i,
pm:/^অপ/i,
midnight:/^মধ্যরাত/i,
noon:/^মধ্যাহ্ন/i,
morning:/সকাল/i,
afternoon:/বিকাল/i,
evening:/সন্ধ্যা/i,
night:/রাত/i
}
};
var match23={
ordinalNumber:buildMatchPatternFn({
matchPattern:matchOrdinalNumberPattern12,
parsePattern:parseOrdinalNumberPattern12,
valueCallback:function valueCallback(value){return parseInt(value,10);}
}),
era:buildMatchFn({
matchPatterns:matchEraPatterns12,
defaultMatchWidth:"wide",
parsePatterns:parseEraPatterns12,
defaultParseWidth:"wide"
}),
quarter:buildMatchFn({
matchPatterns:matchQuarterPatterns12,
defaultMatchWidth:"wide",
parsePatterns:parseQuarterPatterns12,
defaultParseWidth:"any",
valueCallback:function valueCallback(index){return index+1;}
}),
month:buildMatchFn({
matchPatterns:matchMonthPatterns12,
defaultMatchWidth:"wide",
parsePatterns:parseMonthPatterns12,
defaultParseWidth:"any"
}),
day:buildMatchFn({
matchPatterns:matchDayPatterns12,
defaultMatchWidth:"wide",
parsePatterns:parseDayPatterns12,
defaultParseWidth:"wide"
}),
dayPeriod:buildMatchFn({
matchPatterns:matchDayPeriodPatterns12,
defaultMatchWidth:"wide",
parsePatterns:parseDayPeriodPatterns12,
defaultParseWidth:"any"
})
};

// lib/locale/bn.js
var _bn={
code:"bn",
formatDistance:formatDistance23,
formatLong:formatLong23,
formatRelative:formatRelative23,
localize:localize23,
match:match23,
options:{
weekStartsOn:0,
firstWeekContainsDate:1
}
};
// lib/locale/bs/_lib/formatDistance.js
var formatDistanceLocale13={
lessThanXSeconds:{
one:{
standalone:"manje od 1 sekunde",
withPrepositionAgo:"manje od 1 sekunde",
withPrepositionIn:"manje od 1 sekundu"
},
dual:"manje od {{count}} sekunde",
other:"manje od {{count}} sekundi"
},
xSeconds:{
one:{
standalone:"1 sekunda",
withPrepositionAgo:"1 sekunde",
withPrepositionIn:"1 sekundu"
},
dual:"{{count}} sekunde",
other:"{{count}} sekundi"
},
halfAMinute:"pola minute",
lessThanXMinutes:{
one:{
standalone:"manje od 1 minute",
withPrepositionAgo:"manje od 1 minute",
withPrepositionIn:"manje od 1 minutu"
},
dual:"manje od {{count}} minute",
other:"manje od {{count}} minuta"
},
xMinutes:{
one:{
standalone:"1 minuta",
withPrepositionAgo:"1 minute",
withPrepositionIn:"1 minutu"
},
dual:"{{count}} minute",
other:"{{count}} minuta"
},
aboutXHours:{
one:{
standalone:"oko 1 sat",
withPrepositionAgo:"oko 1 sat",
withPrepositionIn:"oko 1 sat"
},
dual:"oko {{count}} sata",
other:"oko {{count}} sati"
},
xHours:{
one:{
standalone:"1 sat",
withPrepositionAgo:"1 sat",
withPrepositionIn:"1 sat"
},
dual:"{{count}} sata",
other:"{{count}} sati"
},
xDays:{
one:{
standalone:"1 dan",
withPrepositionAgo:"1 dan",
withPrepositionIn:"1 dan"
},
dual:"{{count}} dana",
other:"{{count}} dana"
},
aboutXWeeks:{
one:{
standalone:"oko 1 sedmicu",
withPrepositionAgo:"oko 1 sedmicu",
withPrepositionIn:"oko 1 sedmicu"
},
dual:"oko {{count}} sedmice",
other:"oko {{count}} sedmice"
},
xWeeks:{
one:{
standalone:"1 sedmicu",
withPrepositionAgo:"1 sedmicu",
withPrepositionIn:"1 sedmicu"
},
dual:"{{count}} sedmice",
other:"{{count}} sedmice"
},
aboutXMonths:{
one:{
standalone:"oko 1 mjesec",
withPrepositionAgo:"oko 1 mjesec",
withPrepositionIn:"oko 1 mjesec"
},
dual:"oko {{count}} mjeseca",
other:"oko {{count}} mjeseci"
},
xMonths:{
one:{
standalone:"1 mjesec",
withPrepositionAgo:"1 mjesec",
withPrepositionIn:"1 mjesec"
},
dual:"{{count}} mjeseca",
other:"{{count}} mjeseci"
},
aboutXYears:{
one:{
standalone:"oko 1 godinu",
withPrepositionAgo:"oko 1 godinu",
withPrepositionIn:"oko 1 godinu"
},
dual:"oko {{count}} godine",
other:"oko {{count}} godina"
},
xYears:{
one:{
standalone:"1 godina",
withPrepositionAgo:"1 godine",
withPrepositionIn:"1 godinu"
},
dual:"{{count}} godine",
other:"{{count}} godina"
},
overXYears:{
one:{
standalone:"preko 1 godinu",
withPrepositionAgo:"preko 1 godinu",
withPrepositionIn:"preko 1 godinu"
},
dual:"preko {{count}} godine",
other:"preko {{count}} godina"
},
almostXYears:{
one:{
standalone:"gotovo 1 godinu",
withPrepositionAgo:"gotovo 1 godinu",
withPrepositionIn:"gotovo 1 godinu"
},
dual:"gotovo {{count}} godine",
other:"gotovo {{count}} godina"
}
};
var formatDistance25=function formatDistance25(token,count,options){
var result;
var tokenValue=formatDistanceLocale13[token];
if(typeof tokenValue==="string"){
result=tokenValue;
}else if(count===1){
if(options!==null&&options!==void 0&&options.addSuffix){
if(options.comparison&&options.comparison>0){
result=tokenValue.one.withPrepositionIn;
}else{
result=tokenValue.one.withPrepositionAgo;
}
}else{
result=tokenValue.one.standalone;
}
}else if(count%10>1&&count%10<5&&String(count).substr(-2,1)!=="1"){
result=tokenValue.dual.replace("{{count}}",String(count));
}else{
result=tokenValue.other.replace("{{count}}",String(count));
}
if(options!==null&&options!==void 0&&options.addSuffix){
if(options.comparison&&options.comparison>0){
return"za "+result;
}else{
return"prije "+result;
}
}
return result;
};

// lib/locale/bs/_lib/formatLong.js
var dateFormats13={
full:"EEEE, d. MMMM yyyy.",
long:"d. MMMM yyyy.",
medium:"d. MMM yy.",
short:"dd. MM. yy."
};
var timeFormats13={
full:"HH:mm:ss (zzzz)",
long:"HH:mm:ss z",
medium:"HH:mm:ss",
short:"HH:mm"
};
var dateTimeFormats13={
full:"{{date}} 'u' {{time}}",
long:"{{date}} 'u' {{time}}",
medium:"{{date}} {{time}}",
short:"{{date}} {{time}}"
};
var formatLong25={
date:buildFormatLongFn({
formats:dateFormats13,
defaultWidth:"full"
}),
time:buildFormatLongFn({
formats:timeFormats13,
defaultWidth:"full"
}),
dateTime:buildFormatLongFn({
formats:dateTimeFormats13,
defaultWidth:"full"
})
};

// lib/locale/bs/_lib/formatRelative.js
var formatRelativeLocale13={
lastWeek:function lastWeek(date){
switch(date.getDay()){
case 0:
return"'pro\u0161le nedjelje u' p";
case 3:
return"'pro\u0161le srijede u' p";
case 6:
return"'pro\u0161le subote u' p";
default:
return"'pro\u0161li' EEEE 'u' p";
}
},
yesterday:"'ju\u010De u' p",
today:"'danas u' p",
tomorrow:"'sutra u' p",
nextWeek:function nextWeek(date){
switch(date.getDay()){
case 0:
return"'sljede\u0107e nedjelje u' p";
case 3:
return"'sljede\u0107u srijedu u' p";
case 6:
return"'sljede\u0107u subotu u' p";
default:
return"'sljede\u0107i' EEEE 'u' p";
}
},
other:"P"
};
var formatRelative25=function formatRelative25(token,date,_baseDate,_options){
var format=formatRelativeLocale13[token];
if(typeof format==="function"){
return format(date);
}
return format;
};

// lib/locale/bs/_lib/localize.js
var eraValues13={
narrow:["pr.n.e.","AD"],
abbreviated:["pr. Hr.","po. Hr."],
wide:["Prije Hrista","Poslije Hrista"]
};
var quarterValues13={
narrow:["1.","2.","3.","4."],
abbreviated:["1. kv.","2. kv.","3. kv.","4. kv."],
wide:["1. kvartal","2. kvartal","3. kvartal","4. kvartal"]
};
var monthValues13={
narrow:[
"1.",
"2.",
"3.",
"4.",
"5.",
"6.",
"7.",
"8.",
"9.",
"10.",
"11.",
"12."],

abbreviated:[
"jan",
"feb",
"mar",
"apr",
"maj",
"jun",
"jul",
"avg",
"sep",
"okt",
"nov",
"dec"],

wide:[
"januar",
"februar",
"mart",
"april",
"maj",
"juni",
"juli",
"avgust",
"septembar",
"oktobar",
"novembar",
"decembar"]

};
var formattingMonthValues3={
narrow:[
"1.",
"2.",
"3.",
"4.",
"5.",
"6.",
"7.",
"8.",
"9.",
"10.",
"11.",
"12."],

abbreviated:[
"jan",
"feb",
"mar",
"apr",
"maj",
"jun",
"jul",
"avg",
"sep",
"okt",
"nov",
"dec"],

wide:[
"januar",
"februar",
"mart",
"april",
"maj",
"juni",
"juli",
"avgust",
"septembar",
"oktobar",
"novembar",
"decembar"]

};
var dayValues13={
narrow:["N","P","U","S","\u010C","P","S"],
short:["ned","pon","uto","sre","\u010Det","pet","sub"],
abbreviated:["ned","pon","uto","sre","\u010Det","pet","sub"],
wide:[
"nedjelja",
"ponedjeljak",
"utorak",
"srijeda",
"\u010Detvrtak",
"petak",
"subota"]

};
var dayPeriodValues13={
narrow:{
am:"AM",
pm:"PM",
midnight:"pono\u0107",
noon:"podne",
morning:"ujutru",
afternoon:"popodne",
evening:"uve\u010De",
night:"no\u0107u"
},
abbreviated:{
am:"AM",
pm:"PM",
midnight:"pono\u0107",
noon:"podne",
morning:"ujutru",
afternoon:"popodne",
evening:"uve\u010De",
night:"no\u0107u"
},
wide:{
am:"AM",
pm:"PM",
midnight:"pono\u0107",
noon:"podne",
morning:"ujutru",
afternoon:"poslije podne",
evening:"uve\u010De",
night:"no\u0107u"
}
};
var formattingDayPeriodValues12={
narrow:{
am:"AM",
pm:"PM",
midnight:"pono\u0107",
noon:"podne",
morning:"ujutru",
afternoon:"popodne",
evening:"uve\u010De",
night:"no\u0107u"
},
abbreviated:{
am:"AM",
pm:"PM",
midnight:"pono\u0107",
noon:"podne",
morning:"ujutru",
afternoon:"popodne",
evening:"uve\u010De",
night:"no\u0107u"
},
wide:{
am:"AM",
pm:"PM",
midnight:"pono\u0107",
noon:"podne",
morning:"ujutru",
afternoon:"poslije podne",
evening:"uve\u010De",
night:"no\u0107u"
}
};
var ordinalNumber13=function ordinalNumber13(dirtyNumber,_options){
var number=Number(dirtyNumber);
return String(number)+".";
};
var localize26={
ordinalNumber:ordinalNumber13,
era:buildLocalizeFn({
values:eraValues13,
defaultWidth:"wide"
}),
quarter:buildLocalizeFn({
values:quarterValues13,
defaultWidth:"wide",
argumentCallback:function argumentCallback(quarter){return quarter-1;}
}),
month:buildLocalizeFn({
values:monthValues13,
defaultWidth:"wide",
formattingValues:formattingMonthValues3,
defaultFormattingWidth:"wide"
}),
day:buildLocalizeFn({
values:dayValues13,
defaultWidth:"wide"
}),
dayPeriod:buildLocalizeFn({
values:dayPeriodValues13,
defaultWidth:"wide",
formattingValues:formattingDayPeriodValues12,
defaultFormattingWidth:"wide"
})
};

// lib/locale/bs/_lib/match.js
var matchOrdinalNumberPattern13=/^(\d+)\./i;
var parseOrdinalNumberPattern13=/\d+/i;
var matchEraPatterns13={
narrow:/^(pr\.n\.e\.|AD)/i,
abbreviated:/^(pr\.\s?Hr\.|po\.\s?Hr\.)/i,
wide:/^(Prije Hrista|prije nove ere|Poslije Hrista|nova era)/i
};
var parseEraPatterns13={
any:[/^pr/i,/^(po|nova)/i]
};
var matchQuarterPatterns13={
narrow:/^[1234]/i,
abbreviated:/^[1234]\.\s?kv\.?/i,
wide:/^[1234]\. kvartal/i
};
var parseQuarterPatterns13={
any:[/1/i,/2/i,/3/i,/4/i]
};
var matchMonthPatterns13={
narrow:/^(10|11|12|[123456789])\./i,
abbreviated:/^(jan|feb|mar|apr|maj|jun|jul|avg|sep|okt|nov|dec)/i,
wide:/^((januar|januara)|(februar|februara)|(mart|marta)|(april|aprila)|(maj|maja)|(juni|juna)|(juli|jula)|(avgust|avgusta)|(septembar|septembra)|(oktobar|oktobra)|(novembar|novembra)|(decembar|decembra))/i
};
var parseMonthPatterns13={
narrow:[
/^1/i,
/^2/i,
/^3/i,
/^4/i,
/^5/i,
/^6/i,
/^7/i,
/^8/i,
/^9/i,
/^10/i,
/^11/i,
/^12/i],

any:[
/^ja/i,
/^f/i,
/^mar/i,
/^ap/i,
/^maj/i,
/^jun/i,
/^jul/i,
/^avg/i,
/^s/i,
/^o/i,
/^n/i,
/^d/i]

};
var matchDayPatterns13={
narrow:/^[npusčc]/i,
short:/^(ned|pon|uto|sre|(čet|cet)|pet|sub)/i,
abbreviated:/^(ned|pon|uto|sre|(čet|cet)|pet|sub)/i,
wide:/^(nedjelja|ponedjeljak|utorak|srijeda|(četvrtak|cetvrtak)|petak|subota)/i
};
var parseDayPatterns13={
narrow:[/^s/i,/^m/i,/^t/i,/^w/i,/^t/i,/^f/i,/^s/i],
any:[/^su/i,/^m/i,/^tu/i,/^w/i,/^th/i,/^f/i,/^sa/i]
};
var matchDayPeriodPatterns13={
any:/^(am|pm|ponoc|ponoć|(po)?podne|uvece|uveče|noću|poslije podne|ujutru)/i
};
var parseDayPeriodPatterns13={
any:{
am:/^a/i,
pm:/^p/i,
midnight:/^pono/i,
noon:/^pod/i,
morning:/jutro/i,
afternoon:/(poslije\s|po)+podne/i,
evening:/(uvece|uveče)/i,
night:/(nocu|noću)/i
}
};
var match25={
ordinalNumber:buildMatchPatternFn({
matchPattern:matchOrdinalNumberPattern13,
parsePattern:parseOrdinalNumberPattern13,
valueCallback:function valueCallback(value){return parseInt(value,10);}
}),
era:buildMatchFn({
matchPatterns:matchEraPatterns13,
defaultMatchWidth:"wide",
parsePatterns:parseEraPatterns13,
defaultParseWidth:"any"
}),
quarter:buildMatchFn({
matchPatterns:matchQuarterPatterns13,
defaultMatchWidth:"wide",
parsePatterns:parseQuarterPatterns13,
defaultParseWidth:"any",
valueCallback:function valueCallback(index){return index+1;}
}),
month:buildMatchFn({
matchPatterns:matchMonthPatterns13,
defaultMatchWidth:"wide",
parsePatterns:parseMonthPatterns13,
defaultParseWidth:"any"
}),
day:buildMatchFn({
matchPatterns:matchDayPatterns13,
defaultMatchWidth:"wide",
parsePatterns:parseDayPatterns13,
defaultParseWidth:"any"
}),
dayPeriod:buildMatchFn({
matchPatterns:matchDayPeriodPatterns13,
defaultMatchWidth:"any",
parsePatterns:parseDayPeriodPatterns13,
defaultParseWidth:"any"
})
};

// lib/locale/bs.js
var _bs={
code:"bs",
formatDistance:formatDistance25,
formatLong:formatLong25,
formatRelative:formatRelative25,
localize:localize26,
match:match25,
options:{
weekStartsOn:1,
firstWeekContainsDate:4
}
};
// lib/locale/ca/_lib/formatDistance.js
var formatDistanceLocale14={
lessThanXSeconds:{
one:"menys d'un segon",
eleven:"menys d'onze segons",
other:"menys de {{count}} segons"
},
xSeconds:{
one:"1 segon",
other:"{{count}} segons"
},
halfAMinute:"mig minut",
lessThanXMinutes:{
one:"menys d'un minut",
eleven:"menys d'onze minuts",
other:"menys de {{count}} minuts"
},
xMinutes:{
one:"1 minut",
other:"{{count}} minuts"
},
aboutXHours:{
one:"aproximadament una hora",
other:"aproximadament {{count}} hores"
},
xHours:{
one:"1 hora",
other:"{{count}} hores"
},
xDays:{
one:"1 dia",
other:"{{count}} dies"
},
aboutXWeeks:{
one:"aproximadament una setmana",
other:"aproximadament {{count}} setmanes"
},
xWeeks:{
one:"1 setmana",
other:"{{count}} setmanes"
},
aboutXMonths:{
one:"aproximadament un mes",
other:"aproximadament {{count}} mesos"
},
xMonths:{
one:"1 mes",
other:"{{count}} mesos"
},
aboutXYears:{
one:"aproximadament un any",
other:"aproximadament {{count}} anys"
},
xYears:{
one:"1 any",
other:"{{count}} anys"
},
overXYears:{
one:"m\xE9s d'un any",
eleven:"m\xE9s d'onze anys",
other:"m\xE9s de {{count}} anys"
},
almostXYears:{
one:"gaireb\xE9 un any",
other:"gaireb\xE9 {{count}} anys"
}
};
var formatDistance27=function formatDistance27(token,count,options){
var result;
var tokenValue=formatDistanceLocale14[token];
if(typeof tokenValue==="string"){
result=tokenValue;
}else if(count===1){
result=tokenValue.one;
}else if(count===11&&tokenValue.eleven){
result=tokenValue.eleven;
}else{
result=tokenValue.other.replace("{{count}}",String(count));
}
if(options!==null&&options!==void 0&&options.addSuffix){
if(options.comparison&&options.comparison>0){
return"en "+result;
}else{
return"fa "+result;
}
}
return result;
};

// lib/locale/ca/_lib/formatLong.js
var dateFormats14={
full:"EEEE, d 'de' MMMM y",
long:"d 'de' MMMM y",
medium:"d MMM y",
short:"dd/MM/y"
};
var timeFormats14={
full:"HH:mm:ss zzzz",
long:"HH:mm:ss z",
medium:"HH:mm:ss",
short:"HH:mm"
};
var dateTimeFormats14={
full:"{{date}} 'a les' {{time}}",
long:"{{date}} 'a les' {{time}}",
medium:"{{date}}, {{time}}",
short:"{{date}}, {{time}}"
};
var formatLong27={
date:buildFormatLongFn({
formats:dateFormats14,
defaultWidth:"full"
}),
time:buildFormatLongFn({
formats:timeFormats14,
defaultWidth:"full"
}),
dateTime:buildFormatLongFn({
formats:dateTimeFormats14,
defaultWidth:"full"
})
};

// lib/locale/ca/_lib/formatRelative.js
var formatRelativeLocale14={
lastWeek:"'el' eeee 'passat a la' LT",
yesterday:"'ahir a la' p",
today:"'avui a la' p",
tomorrow:"'dem\xE0 a la' p",
nextWeek:"eeee 'a la' p",
other:"P"
};
var formatRelativeLocalePlural={
lastWeek:"'el' eeee 'passat a les' p",
yesterday:"'ahir a les' p",
today:"'avui a les' p",
tomorrow:"'dem\xE0 a les' p",
nextWeek:"eeee 'a les' p",
other:"P"
};
var formatRelative27=function formatRelative27(token,date,_baseDate,_options){
if(date.getHours()!==1){
return formatRelativeLocalePlural[token];
}
return formatRelativeLocale14[token];
};

// lib/locale/ca/_lib/localize.js
var eraValues14={
narrow:["aC","dC"],
abbreviated:["a. de C.","d. de C."],
wide:["abans de Crist","despr\xE9s de Crist"]
};
var quarterValues14={
narrow:["1","2","3","4"],
abbreviated:["T1","T2","T3","T4"],
wide:["1r trimestre","2n trimestre","3r trimestre","4t trimestre"]
};
var monthValues14={
narrow:[
"GN",
"FB",
"M\xC7",
"AB",
"MG",
"JN",
"JL",
"AG",
"ST",
"OC",
"NV",
"DS"],

abbreviated:[
"gen.",
"febr.",
"mar\xE7",
"abr.",
"maig",
"juny",
"jul.",
"ag.",
"set.",
"oct.",
"nov.",
"des."],

wide:[
"gener",
"febrer",
"mar\xE7",
"abril",
"maig",
"juny",
"juliol",
"agost",
"setembre",
"octubre",
"novembre",
"desembre"]

};
var dayValues14={
narrow:["dg.","dl.","dt.","dm.","dj.","dv.","ds."],
short:["dg.","dl.","dt.","dm.","dj.","dv.","ds."],
abbreviated:["dg.","dl.","dt.","dm.","dj.","dv.","ds."],
wide:[
"diumenge",
"dilluns",
"dimarts",
"dimecres",
"dijous",
"divendres",
"dissabte"]

};
var dayPeriodValues14={
narrow:{
am:"am",
pm:"pm",
midnight:"mitjanit",
noon:"migdia",
morning:"mat\xED",
afternoon:"tarda",
evening:"vespre",
night:"nit"
},
abbreviated:{
am:"a.m.",
pm:"p.m.",
midnight:"mitjanit",
noon:"migdia",
morning:"mat\xED",
afternoon:"tarda",
evening:"vespre",
night:"nit"
},
wide:{
am:"ante meridiem",
pm:"post meridiem",
midnight:"mitjanit",
noon:"migdia",
morning:"mat\xED",
afternoon:"tarda",
evening:"vespre",
night:"nit"
}
};
var formattingDayPeriodValues13={
narrow:{
am:"am",
pm:"pm",
midnight:"de la mitjanit",
noon:"del migdia",
morning:"del mat\xED",
afternoon:"de la tarda",
evening:"del vespre",
night:"de la nit"
},
abbreviated:{
am:"AM",
pm:"PM",
midnight:"de la mitjanit",
noon:"del migdia",
morning:"del mat\xED",
afternoon:"de la tarda",
evening:"del vespre",
night:"de la nit"
},
wide:{
am:"ante meridiem",
pm:"post meridiem",
midnight:"de la mitjanit",
noon:"del migdia",
morning:"del mat\xED",
afternoon:"de la tarda",
evening:"del vespre",
night:"de la nit"
}
};
var ordinalNumber14=function ordinalNumber14(dirtyNumber,_options){
var number=Number(dirtyNumber);
var rem100=number%100;
if(rem100>20||rem100<10){
switch(rem100%10){
case 1:
return number+"r";
case 2:
return number+"n";
case 3:
return number+"r";
case 4:
return number+"t";
}
}
return number+"\xE8";
};
var localize28={
ordinalNumber:ordinalNumber14,
era:buildLocalizeFn({
values:eraValues14,
defaultWidth:"wide"
}),
quarter:buildLocalizeFn({
values:quarterValues14,
defaultWidth:"wide",
argumentCallback:function argumentCallback(quarter){return quarter-1;}
}),
month:buildLocalizeFn({
values:monthValues14,
defaultWidth:"wide"
}),
day:buildLocalizeFn({
values:dayValues14,
defaultWidth:"wide"
}),
dayPeriod:buildLocalizeFn({
values:dayPeriodValues14,
defaultWidth:"wide",
formattingValues:formattingDayPeriodValues13,
defaultFormattingWidth:"wide"
})
};

// lib/locale/ca/_lib/match.js
var matchOrdinalNumberPattern14=/^(\d+)(è|r|n|r|t)?/i;
var parseOrdinalNumberPattern14=/\d+/i;
var matchEraPatterns14={
narrow:/^(aC|dC)/i,
abbreviated:/^(a. de C.|d. de C.)/i,
wide:/^(abans de Crist|despr[eé]s de Crist)/i
};
var parseEraPatterns14={
narrow:[/^aC/i,/^dC/i],
abbreviated:[/^(a. de C.)/i,/^(d. de C.)/i],
wide:[/^(abans de Crist)/i,/^(despr[eé]s de Crist)/i]
};
var matchQuarterPatterns14={
narrow:/^[1234]/i,
abbreviated:/^T[1234]/i,
wide:/^[1234](è|r|n|r|t)? trimestre/i
};
var parseQuarterPatterns14={
any:[/1/i,/2/i,/3/i,/4/i]
};
var matchMonthPatterns14={
narrow:/^(GN|FB|MÇ|AB|MG|JN|JL|AG|ST|OC|NV|DS)/i,
abbreviated:/^(gen.|febr.|març|abr.|maig|juny|jul.|ag.|set.|oct.|nov.|des.)/i,
wide:/^(gener|febrer|març|abril|maig|juny|juliol|agost|setembre|octubre|novembre|desembre)/i
};
var parseMonthPatterns14={
narrow:[
/^GN/i,
/^FB/i,
/^MÇ/i,
/^AB/i,
/^MG/i,
/^JN/i,
/^JL/i,
/^AG/i,
/^ST/i,
/^OC/i,
/^NV/i,
/^DS/i],

abbreviated:[
/^gen./i,
/^febr./i,
/^març/i,
/^abr./i,
/^maig/i,
/^juny/i,
/^jul./i,
/^ag./i,
/^set./i,
/^oct./i,
/^nov./i,
/^des./i],

wide:[
/^gener/i,
/^febrer/i,
/^març/i,
/^abril/i,
/^maig/i,
/^juny/i,
/^juliol/i,
/^agost/i,
/^setembre/i,
/^octubre/i,
/^novembre/i,
/^desembre/i]

};
var matchDayPatterns14={
narrow:/^(dg\.|dl\.|dt\.|dm\.|dj\.|dv\.|ds\.)/i,
short:/^(dg\.|dl\.|dt\.|dm\.|dj\.|dv\.|ds\.)/i,
abbreviated:/^(dg\.|dl\.|dt\.|dm\.|dj\.|dv\.|ds\.)/i,
wide:/^(diumenge|dilluns|dimarts|dimecres|dijous|divendres|dissabte)/i
};
var parseDayPatterns14={
narrow:[/^dg./i,/^dl./i,/^dt./i,/^dm./i,/^dj./i,/^dv./i,/^ds./i],
abbreviated:[/^dg./i,/^dl./i,/^dt./i,/^dm./i,/^dj./i,/^dv./i,/^ds./i],
wide:[
/^diumenge/i,
/^dilluns/i,
/^dimarts/i,
/^dimecres/i,
/^dijous/i,
/^divendres/i,
/^disssabte/i]

};
var matchDayPeriodPatterns14={
narrow:/^(a|p|mn|md|(del|de la) (matí|tarda|vespre|nit))/i,
abbreviated:/^([ap]\.?\s?m\.?|mitjanit|migdia|(del|de la) (matí|tarda|vespre|nit))/i,
wide:/^(ante meridiem|post meridiem|mitjanit|migdia|(del|de la) (matí|tarda|vespre|nit))/i
};
var parseDayPeriodPatterns14={
any:{
am:/^a/i,
pm:/^p/i,
midnight:/^mitjanit/i,
noon:/^migdia/i,
morning:/matí/i,
afternoon:/tarda/i,
evening:/vespre/i,
night:/nit/i
}
};
var match27={
ordinalNumber:buildMatchPatternFn({
matchPattern:matchOrdinalNumberPattern14,
parsePattern:parseOrdinalNumberPattern14,
valueCallback:function valueCallback(value){return parseInt(value,10);}
}),
era:buildMatchFn({
matchPatterns:matchEraPatterns14,
defaultMatchWidth:"wide",
parsePatterns:parseEraPatterns14,
defaultParseWidth:"wide"
}),
quarter:buildMatchFn({
matchPatterns:matchQuarterPatterns14,
defaultMatchWidth:"wide",
parsePatterns:parseQuarterPatterns14,
defaultParseWidth:"any",
valueCallback:function valueCallback(index){return index+1;}
}),
month:buildMatchFn({
matchPatterns:matchMonthPatterns14,
defaultMatchWidth:"wide",
parsePatterns:parseMonthPatterns14,
defaultParseWidth:"wide"
}),
day:buildMatchFn({
matchPatterns:matchDayPatterns14,
defaultMatchWidth:"wide",
parsePatterns:parseDayPatterns14,
defaultParseWidth:"wide"
}),
dayPeriod:buildMatchFn({
matchPatterns:matchDayPeriodPatterns14,
defaultMatchWidth:"wide",
parsePatterns:parseDayPeriodPatterns14,
defaultParseWidth:"any"
})
};

// lib/locale/ca.js
var _ca={
code:"ca",
formatDistance:formatDistance27,
formatLong:formatLong27,
formatRelative:formatRelative27,
localize:localize28,
match:match27,
options:{
weekStartsOn:1,
firstWeekContainsDate:4
}
};
// lib/locale/ckb/_lib/formatDistance.js
var formatDistanceLocale15={
lessThanXSeconds:{
one:"\u06A9\u06D5\u0645\u062A\u0631 \u0644\u06D5 \u06CC\u06D5\u06A9 \u0686\u0631\u06A9\u06D5",
other:"\u06A9\u06D5\u0645\u062A\u0631 \u0644\u06D5 {{count}} \u0686\u0631\u06A9\u06D5"
},
xSeconds:{
one:"1 \u0686\u0631\u06A9\u06D5",
other:"{{count}} \u0686\u0631\u06A9\u06D5"
},
halfAMinute:"\u0646\u06CC\u0648 \u06A9\u0627\u062A\u0698\u0645\u06CE\u0631",
lessThanXMinutes:{
one:"\u06A9\u06D5\u0645\u062A\u0631 \u0644\u06D5 \u06CC\u06D5\u06A9 \u062E\u0648\u0644\u06D5\u06A9",
other:"\u06A9\u06D5\u0645\u062A\u0631 \u0644\u06D5 {{count}} \u062E\u0648\u0644\u06D5\u06A9"
},
xMinutes:{
one:"1 \u062E\u0648\u0644\u06D5\u06A9",
other:"{{count}} \u062E\u0648\u0644\u06D5\u06A9"
},
aboutXHours:{
one:"\u062F\u06D5\u0648\u0631\u0648\u0628\u06D5\u0631\u06CC 1 \u06A9\u0627\u062A\u0698\u0645\u06CE\u0631",
other:"\u062F\u06D5\u0648\u0631\u0648\u0628\u06D5\u0631\u06CC {{count}} \u06A9\u0627\u062A\u0698\u0645\u06CE\u0631"
},
xHours:{
one:"1 \u06A9\u0627\u062A\u0698\u0645\u06CE\u0631",
other:"{{count}} \u06A9\u0627\u062A\u0698\u0645\u06CE\u0631"
},
xDays:{
one:"1 \u0695\u06C6\u0698",
other:"{{count}} \u0698\u06C6\u0698"
},
aboutXWeeks:{
one:"\u062F\u06D5\u0648\u0631\u0648\u0628\u06D5\u0631\u06CC 1 \u0647\u06D5\u0641\u062A\u06D5",
other:"\u062F\u0648\u0631\u0648\u0628\u06D5\u0631\u06CC {{count}} \u0647\u06D5\u0641\u062A\u06D5"
},
xWeeks:{
one:"1 \u0647\u06D5\u0641\u062A\u06D5",
other:"{{count}} \u0647\u06D5\u0641\u062A\u06D5"
},
aboutXMonths:{
one:"\u062F\u0627\u0648\u0631\u0648\u0628\u06D5\u0631\u06CC 1 \u0645\u0627\u0646\u06AF",
other:"\u062F\u06D5\u0648\u0631\u0648\u0628\u06D5\u0631\u06CC {{count}} \u0645\u0627\u0646\u06AF"
},
xMonths:{
one:"1 \u0645\u0627\u0646\u06AF",
other:"{{count}} \u0645\u0627\u0646\u06AF"
},
aboutXYears:{
one:"\u062F\u06D5\u0648\u0631\u0648\u0628\u06D5\u0631\u06CC  1 \u0633\u0627\u06B5",
other:"\u062F\u06D5\u0648\u0631\u0648\u0628\u06D5\u0631\u06CC {{count}} \u0633\u0627\u06B5"
},
xYears:{
one:"1 \u0633\u0627\u06B5",
other:"{{count}} \u0633\u0627\u06B5"
},
overXYears:{
one:"\u0632\u06CC\u0627\u062A\u0631 \u0644\u06D5 \u0633\u0627\u06B5\u06CE\u06A9",
other:"\u0632\u06CC\u0627\u062A\u0631 \u0644\u06D5 {{count}} \u0633\u0627\u06B5"
},
almostXYears:{
one:"\u0628\u06D5\u0646\u0632\u06CC\u06A9\u06D5\u06CC\u06CC \u0633\u0627\u06B5\u06CE\u06A9  ",
other:"\u0628\u06D5\u0646\u0632\u06CC\u06A9\u06D5\u06CC\u06CC {{count}} \u0633\u0627\u06B5"
}
};
var formatDistance29=function formatDistance29(token,count,options){
var result;
var tokenValue=formatDistanceLocale15[token];
if(typeof tokenValue==="string"){
result=tokenValue;
}else if(count===1){
result=tokenValue.one;
}else{
result=tokenValue.other.replace("{{count}}",count.toString());
}
if(options!==null&&options!==void 0&&options.addSuffix){
if(options.comparison&&options.comparison>0){
return"\u0644\u06D5 \u0645\u0627\u0648\u06D5\u06CC "+result+"\u062F\u0627";
}else{
return result+"\u067E\u06CE\u0634 \u0626\u06CE\u0633\u062A\u0627";
}
}
return result;
};

// lib/locale/ckb/_lib/formatLong.js
var dateFormats15={
full:"EEEE, MMMM do, y",
long:"MMMM do, y",
medium:"MMM d, y",
short:"MM/dd/yyyy"
};
var timeFormats15={
full:"h:mm:ss a zzzz",
long:"h:mm:ss a z",
medium:"h:mm:ss a",
short:"h:mm a"
};
var dateTimeFormats15={
full:"{{date}} '\u06A9\u0627\u062A\u0698\u0645\u06CE\u0631' {{time}}",
long:"{{date}} '\u06A9\u0627\u062A\u0698\u0645\u06CE\u0631' {{time}}",
medium:"{{date}}, {{time}}",
short:"{{date}}, {{time}}"
};
var formatLong29={
date:buildFormatLongFn({
formats:dateFormats15,
defaultWidth:"full"
}),
time:buildFormatLongFn({
formats:timeFormats15,
defaultWidth:"full"
}),
dateTime:buildFormatLongFn({
formats:dateTimeFormats15,
defaultWidth:"full"
})
};

// lib/locale/ckb/_lib/formatRelative.js
var formatRelativeLocale15={
lastWeek:"'\u0647\u06D5\u0641\u062A\u06D5\u06CC \u0695\u0627\u0628\u0631\u062F\u0648\u0648' eeee '\u06A9\u0627\u062A\u0698\u0645\u06CE\u0631' p",
yesterday:"'\u062F\u0648\u06CE\u0646\u06CE \u06A9\u0627\u062A\u0698\u0645\u06CE\u0631' p",
today:"'\u0626\u06D5\u0645\u0695\u06C6 \u06A9\u0627\u062A\u0698\u0645\u06CE\u0631' p",
tomorrow:"'\u0628\u06D5\u06CC\u0627\u0646\u06CC \u06A9\u0627\u062A\u0698\u0645\u06CE\u0631' p",
nextWeek:"eeee '\u06A9\u0627\u062A\u0698\u0645\u06CE\u0631' p",
other:"P"
};
var formatRelative29=function formatRelative29(token,_date,_baseDate,_options){return formatRelativeLocale15[token];};

// lib/locale/ckb/_lib/localize.js
var eraValues15={
narrow:["\u067E","\u062F"],
abbreviated:["\u067E-\u0632","\u062F-\u0632"],
wide:["\u067E\u06CE\u0634 \u0632\u0627\u06CC\u0646","\u062F\u0648\u0627\u06CC \u0632\u0627\u06CC\u0646"]
};
var quarterValues15={
narrow:["1","2","3","4"],
abbreviated:["\u06861\u0645","\u06862\u0645","\u06863\u0645","\u06864\u0645"],
wide:["\u0686\u0627\u0631\u06D5\u06AF\u06CC \u06CC\u06D5\u06A9\u06D5\u0645","\u0686\u0627\u0631\u06D5\u06AF\u06CC \u062F\u0648\u0648\u06D5\u0645","\u0686\u0627\u0631\u06D5\u06AF\u06CC \u0633\u06CE\u06CC\u06D5\u0645","\u0686\u0627\u0631\u06D5\u06AF\u06CC \u0686\u0648\u0627\u0631\u06D5\u0645"]
};
var monthValues15={
narrow:[
"\u06A9-\u062F",
"\u0634",
"\u0626\u0627",
"\u0646",
"\u0645",
"\u062D",
"\u062A",
"\u0626\u0627",
"\u0626\u06D5",
"\u062A\u0634-\u06CC",
"\u062A\u0634-\u062F",
"\u06A9-\u06CC"],

abbreviated:[
"\u06A9\u0627\u0646-\u062F\u0648\u0648",
"\u0634\u0648\u0628",
"\u0626\u0627\u062F",
"\u0646\u06CC\u0633",
"\u0645\u0627\u06CC\u0633",
"\u062D\u0648\u0632",
"\u062A\u06D5\u0645",
"\u0626\u0627\u0628",
"\u0626\u06D5\u0644",
"\u062A\u0634-\u06CC\u06D5\u06A9",
"\u062A\u0634-\u062F\u0648\u0648",
"\u06A9\u0627\u0646-\u06CC\u06D5\u06A9"],

wide:[
"\u06A9\u0627\u0646\u0648\u0648\u0646\u06CC \u062F\u0648\u0648\u06D5\u0645",
"\u0634\u0648\u0628\u0627\u062A",
"\u0626\u0627\u062F\u0627\u0631",
"\u0646\u06CC\u0633\u0627\u0646",
"\u0645\u0627\u06CC\u0633",
"\u062D\u0648\u0632\u06D5\u06CC\u0631\u0627\u0646",
"\u062A\u06D5\u0645\u0645\u0648\u0632",
"\u0626\u0627\u0628",
"\u0626\u06D5\u06CC\u0644\u0648\u0644",
"\u062A\u0634\u0631\u06CC\u0646\u06CC \u06CC\u06D5\u06A9\u06D5\u0645",
"\u062A\u0634\u0631\u06CC\u0646\u06CC \u062F\u0648\u0648\u06D5\u0645",
"\u06A9\u0627\u0646\u0648\u0648\u0646\u06CC \u06CC\u06D5\u06A9\u06D5\u0645"]

};
var dayValues15={
narrow:["\u06CC-\u0634","\u062F-\u0634","\u0633-\u0634","\u0686-\u0634","\u067E-\u0634","\u0647\u06D5","\u0634"],
short:["\u06CC\u06D5-\u0634\u06D5","\u062F\u0648\u0648-\u0634\u06D5","\u0633\u06CE-\u0634\u06D5","\u0686\u0648-\u0634\u06D5","\u067E\u06CE-\u0634\u06D5","\u0647\u06D5\u06CC","\u0634\u06D5"],
abbreviated:[
"\u06CC\u06D5\u06A9-\u0634\u06D5\u0645",
"\u062F\u0648\u0648-\u0634\u06D5\u0645",
"\u0633\u06CE-\u0634\u06D5\u0645",
"\u0686\u0648\u0627\u0631-\u0634\u06D5\u0645",
"\u067E\u06CE\u0646\u062C-\u0634\u06D5\u0645",
"\u0647\u06D5\u06CC\u0646\u06CC",
"\u0634\u06D5\u0645\u06D5"],

wide:[
"\u06CC\u06D5\u06A9 \u0634\u06D5\u0645\u06D5",
"\u062F\u0648\u0648 \u0634\u06D5\u0645\u06D5",
"\u0633\u06CE \u0634\u06D5\u0645\u06D5",
"\u0686\u0648\u0627\u0631 \u0634\u06D5\u0645\u06D5",
"\u067E\u06CE\u0646\u062C \u0634\u06D5\u0645\u06D5",
"\u0647\u06D5\u06CC\u0646\u06CC",
"\u0634\u06D5\u0645\u06D5"]

};
var dayPeriodValues15={
narrow:{
am:"\u067E",
pm:"\u062F",
midnight:"\u0646-\u0634",
noon:"\u0646",
morning:"\u0628\u06D5\u06CC\u0627\u0646\u06CC",
afternoon:"\u062F\u0648\u0627\u06CC \u0646\u06CC\u0648\u06D5\u0695\u06C6",
evening:"\u0626\u06CE\u0648\u0627\u0631\u06D5",
night:"\u0634\u06D5\u0648"
},
abbreviated:{
am:"\u067E-\u0646",
pm:"\u062F-\u0646",
midnight:"\u0646\u06CC\u0648\u06D5 \u0634\u06D5\u0648",
noon:"\u0646\u06CC\u0648\u06D5\u0695\u06C6",
morning:"\u0628\u06D5\u06CC\u0627\u0646\u06CC",
afternoon:"\u062F\u0648\u0627\u06CC \u0646\u06CC\u0648\u06D5\u0695\u06C6",
evening:"\u0626\u06CE\u0648\u0627\u0631\u06D5",
night:"\u0634\u06D5\u0648"
},
wide:{
am:"\u067E\u06CE\u0634 \u0646\u06CC\u0648\u06D5\u0695\u06C6",
pm:"\u062F\u0648\u0627\u06CC \u0646\u06CC\u0648\u06D5\u0695\u06C6",
midnight:"\u0646\u06CC\u0648\u06D5 \u0634\u06D5\u0648",
noon:"\u0646\u06CC\u0648\u06D5\u0695\u06C6",
morning:"\u0628\u06D5\u06CC\u0627\u0646\u06CC",
afternoon:"\u062F\u0648\u0627\u06CC \u0646\u06CC\u0648\u06D5\u0695\u06C6",
evening:"\u0626\u06CE\u0648\u0627\u0631\u06D5",
night:"\u0634\u06D5\u0648"
}
};
var formattingDayPeriodValues14={
narrow:{
am:"\u067E",
pm:"\u062F",
midnight:"\u0646-\u0634",
noon:"\u0646",
morning:"\u0644\u06D5 \u0628\u06D5\u06CC\u0627\u0646\u06CC\u062F\u0627",
afternoon:"\u0644\u06D5 \u062F\u0648\u0627\u06CC \u0646\u06CC\u0648\u06D5\u0695\u06C6\u062F\u0627",
evening:"\u0644\u06D5 \u0626\u06CE\u0648\u0627\u0631\u06D5\u062F\u0627",
night:"\u0644\u06D5 \u0634\u06D5\u0648\u062F\u0627"
},
abbreviated:{
am:"\u067E-\u0646",
pm:"\u062F-\u0646",
midnight:"\u0646\u06CC\u0648\u06D5 \u0634\u06D5\u0648",
noon:"\u0646\u06CC\u0648\u06D5\u0695\u06C6",
morning:"\u0644\u06D5 \u0628\u06D5\u06CC\u0627\u0646\u06CC\u062F\u0627",
afternoon:"\u0644\u06D5 \u062F\u0648\u0627\u06CC \u0646\u06CC\u0648\u06D5\u0695\u06C6\u062F\u0627",
evening:"\u0644\u06D5 \u0626\u06CE\u0648\u0627\u0631\u06D5\u062F\u0627",
night:"\u0644\u06D5 \u0634\u06D5\u0648\u062F\u0627"
},
wide:{
am:"\u067E\u06CE\u0634 \u0646\u06CC\u0648\u06D5\u0695\u06C6",
pm:"\u062F\u0648\u0627\u06CC \u0646\u06CC\u0648\u06D5\u0695\u06C6",
midnight:"\u0646\u06CC\u0648\u06D5 \u0634\u06D5\u0648",
noon:"\u0646\u06CC\u0648\u06D5\u0695\u06C6",
morning:"\u0644\u06D5 \u0628\u06D5\u06CC\u0627\u0646\u06CC\u062F\u0627",
afternoon:"\u0644\u06D5 \u062F\u0648\u0627\u06CC \u0646\u06CC\u0648\u06D5\u0695\u06C6\u062F\u0627",
evening:"\u0644\u06D5 \u0626\u06CE\u0648\u0627\u0631\u06D5\u062F\u0627",
night:"\u0644\u06D5 \u0634\u06D5\u0648\u062F\u0627"
}
};
var ordinalNumber15=function ordinalNumber15(dirtyNumber,_options){
return String(dirtyNumber);
};
var localize30={
ordinalNumber:ordinalNumber15,
era:buildLocalizeFn({
values:eraValues15,
defaultWidth:"wide"
}),
quarter:buildLocalizeFn({
values:quarterValues15,
defaultWidth:"wide",
argumentCallback:function argumentCallback(quarter){return quarter-1;}
}),
month:buildLocalizeFn({
values:monthValues15,
defaultWidth:"wide"
}),
day:buildLocalizeFn({
values:dayValues15,
defaultWidth:"wide"
}),
dayPeriod:buildLocalizeFn({
values:dayPeriodValues15,
defaultWidth:"wide",
formattingValues:formattingDayPeriodValues14,
defaultFormattingWidth:"wide"
})
};

// lib/locale/ckb/_lib/match.js
var matchOrdinalNumberPattern15=/^(\d+)(th|st|nd|rd)?/i;
var parseOrdinalNumberPattern15=/\d+/i;
var matchEraPatterns15={
narrow:/^(پ|د)/i,
abbreviated:/^(پ-ز|د.ز)/i,
wide:/^(پێش زاین| دوای زاین)/i
};
var parseEraPatterns15={
any:[/^د/g,/^پ/g]
};
var matchQuarterPatterns15={
narrow:/^[1234]/i,
abbreviated:/^م[1234]چ/i,
wide:/^(یەکەم|دووەم|سێیەم| چوارەم) (چارەگی)? quarter/i
};
var parseQuarterPatterns15={
wide:[/چارەگی یەکەم/,/چارەگی دووەم/,/چارەگی سيیەم/,/چارەگی چوارەم/],
any:[/1/i,/2/i,/3/i,/4/i]
};
var matchMonthPatterns15={
narrow:/^(ک-د|ش|ئا|ن|م|ح|ت|ئە|تش-ی|تش-د|ک-ی)/i,
abbreviated:/^(کان-دوو|شوب|ئاد|نیس|مایس|حوز|تەم|ئاب|ئەل|تش-یەک|تش-دوو|کان-یەک)/i,
wide:/^(کانوونی دووەم|شوبات|ئادار|نیسان|مایس|حوزەیران|تەمموز|ئاب|ئەیلول|تشرینی یەکەم|تشرینی دووەم|کانوونی یەکەم)/i
};
var parseMonthPatterns15={
narrow:[
/^ک-د/i,
/^ش/i,
/^ئا/i,
/^ن/i,
/^م/i,
/^ح/i,
/^ت/i,
/^ئا/i,
/^ئە/i,
/^تش-ی/i,
/^تش-د/i,
/^ک-ی/i],

any:[
/^کان-دوو/i,
/^شوب/i,
/^ئاد/i,
/^نیس/i,
/^مایس/i,
/^حوز/i,
/^تەم/i,
/^ئاب/i,
/^ئەل/i,
/^تش-یەک/i,
/^تش-دوو/i,
/^|کان-یەک/i]

};
var matchDayPatterns15={
narrow:/^(ش|ی|د|س|چ|پ|هە)/i,
short:/^(یە-شە|دوو-شە|سێ-شە|چو-شە|پێ-شە|هە|شە)/i,
abbreviated:/^(یەک-شەم|دوو-شەم|سێ-شەم|چوار-شەم|پێنخ-شەم|هەینی|شەمە)/i,
wide:/^(یەک شەمە|دوو شەمە|سێ شەمە|چوار شەمە|پێنج شەمە|هەینی|شەمە)/i
};
var parseDayPatterns15={
narrow:[/^s/i,/^m/i,/^t/i,/^w/i,/^t/i,/^f/i,/^s/i],
any:[/^su/i,/^m/i,/^tu/i,/^w/i,/^th/i,/^f/i,/^sa/i]
};
var matchDayPeriodPatterns15={
narrow:/^(پ|د|ن-ش|ن| (بەیانی|دوای نیوەڕۆ|ئێوارە|شەو))/i,
abbreviated:/^(پ-ن|د-ن|نیوە شەو|نیوەڕۆ|بەیانی|دوای نیوەڕۆ|ئێوارە|شەو)/,
wide:/^(پێش نیوەڕۆ|دوای نیوەڕۆ|نیوەڕۆ|نیوە شەو|لەبەیانیدا|لەدواینیوەڕۆدا|لە ئێوارەدا|لە شەودا)/,
any:/^(پ|د|بەیانی|نیوەڕۆ|ئێوارە|شەو)/
};
var parseDayPeriodPatterns15={
any:{
am:/^د/i,
pm:/^پ/i,
midnight:/^ن-ش/i,
noon:/^ن/i,
morning:/بەیانی/i,
afternoon:/دواینیوەڕۆ/i,
evening:/ئێوارە/i,
night:/شەو/i
}
};
var match29={
ordinalNumber:buildMatchPatternFn({
matchPattern:matchOrdinalNumberPattern15,
parsePattern:parseOrdinalNumberPattern15,
valueCallback:function valueCallback(value){return parseInt(value,10);}
}),
era:buildMatchFn({
matchPatterns:matchEraPatterns15,
defaultMatchWidth:"wide",
parsePatterns:parseEraPatterns15,
defaultParseWidth:"any"
}),
quarter:buildMatchFn({
matchPatterns:matchQuarterPatterns15,
defaultMatchWidth:"wide",
parsePatterns:parseQuarterPatterns15,
defaultParseWidth:"any",
valueCallback:function valueCallback(index){return index+1;}
}),
month:buildMatchFn({
matchPatterns:matchMonthPatterns15,
defaultMatchWidth:"wide",
parsePatterns:parseMonthPatterns15,
defaultParseWidth:"any"
}),
day:buildMatchFn({
matchPatterns:matchDayPatterns15,
defaultMatchWidth:"wide",
parsePatterns:parseDayPatterns15,
defaultParseWidth:"any"
}),
dayPeriod:buildMatchFn({
matchPatterns:matchDayPeriodPatterns15,
defaultMatchWidth:"any",
parsePatterns:parseDayPeriodPatterns15,
defaultParseWidth:"any"
})
};

// lib/locale/ckb.js
var _ckb={
code:"ckb",
formatDistance:formatDistance29,
formatLong:formatLong29,
formatRelative:formatRelative29,
localize:localize30,
match:match29,
options:{
weekStartsOn:0,
firstWeekContainsDate:1
}
};
// lib/locale/cs/_lib/formatDistance.js
var formatDistanceLocale16={
lessThanXSeconds:{
one:{
regular:"m\xE9n\u011B ne\u017E 1 sekunda",
past:"p\u0159ed m\xE9n\u011B ne\u017E 1 sekundou",
future:"za m\xE9n\u011B ne\u017E 1 sekundu"
},
few:{
regular:"m\xE9n\u011B ne\u017E {{count}} sekundy",
past:"p\u0159ed m\xE9n\u011B ne\u017E {{count}} sekundami",
future:"za m\xE9n\u011B ne\u017E {{count}} sekundy"
},
many:{
regular:"m\xE9n\u011B ne\u017E {{count}} sekund",
past:"p\u0159ed m\xE9n\u011B ne\u017E {{count}} sekundami",
future:"za m\xE9n\u011B ne\u017E {{count}} sekund"
}
},
xSeconds:{
one:{
regular:"1 sekunda",
past:"p\u0159ed 1 sekundou",
future:"za 1 sekundu"
},
few:{
regular:"{{count}} sekundy",
past:"p\u0159ed {{count}} sekundami",
future:"za {{count}} sekundy"
},
many:{
regular:"{{count}} sekund",
past:"p\u0159ed {{count}} sekundami",
future:"za {{count}} sekund"
}
},
halfAMinute:{
type:"other",
other:{
regular:"p\u016Fl minuty",
past:"p\u0159ed p\u016Fl minutou",
future:"za p\u016Fl minuty"
}
},
lessThanXMinutes:{
one:{
regular:"m\xE9n\u011B ne\u017E 1 minuta",
past:"p\u0159ed m\xE9n\u011B ne\u017E 1 minutou",
future:"za m\xE9n\u011B ne\u017E 1 minutu"
},
few:{
regular:"m\xE9n\u011B ne\u017E {{count}} minuty",
past:"p\u0159ed m\xE9n\u011B ne\u017E {{count}} minutami",
future:"za m\xE9n\u011B ne\u017E {{count}} minuty"
},
many:{
regular:"m\xE9n\u011B ne\u017E {{count}} minut",
past:"p\u0159ed m\xE9n\u011B ne\u017E {{count}} minutami",
future:"za m\xE9n\u011B ne\u017E {{count}} minut"
}
},
xMinutes:{
one:{
regular:"1 minuta",
past:"p\u0159ed 1 minutou",
future:"za 1 minutu"
},
few:{
regular:"{{count}} minuty",
past:"p\u0159ed {{count}} minutami",
future:"za {{count}} minuty"
},
many:{
regular:"{{count}} minut",
past:"p\u0159ed {{count}} minutami",
future:"za {{count}} minut"
}
},
aboutXHours:{
one:{
regular:"p\u0159ibli\u017En\u011B 1 hodina",
past:"p\u0159ibli\u017En\u011B p\u0159ed 1 hodinou",
future:"p\u0159ibli\u017En\u011B za 1 hodinu"
},
few:{
regular:"p\u0159ibli\u017En\u011B {{count}} hodiny",
past:"p\u0159ibli\u017En\u011B p\u0159ed {{count}} hodinami",
future:"p\u0159ibli\u017En\u011B za {{count}} hodiny"
},
many:{
regular:"p\u0159ibli\u017En\u011B {{count}} hodin",
past:"p\u0159ibli\u017En\u011B p\u0159ed {{count}} hodinami",
future:"p\u0159ibli\u017En\u011B za {{count}} hodin"
}
},
xHours:{
one:{
regular:"1 hodina",
past:"p\u0159ed 1 hodinou",
future:"za 1 hodinu"
},
few:{
regular:"{{count}} hodiny",
past:"p\u0159ed {{count}} hodinami",
future:"za {{count}} hodiny"
},
many:{
regular:"{{count}} hodin",
past:"p\u0159ed {{count}} hodinami",
future:"za {{count}} hodin"
}
},
xDays:{
one:{
regular:"1 den",
past:"p\u0159ed 1 dnem",
future:"za 1 den"
},
few:{
regular:"{{count}} dny",
past:"p\u0159ed {{count}} dny",
future:"za {{count}} dny"
},
many:{
regular:"{{count}} dn\xED",
past:"p\u0159ed {{count}} dny",
future:"za {{count}} dn\xED"
}
},
aboutXWeeks:{
one:{
regular:"p\u0159ibli\u017En\u011B 1 t\xFDden",
past:"p\u0159ibli\u017En\u011B p\u0159ed 1 t\xFDdnem",
future:"p\u0159ibli\u017En\u011B za 1 t\xFDden"
},
few:{
regular:"p\u0159ibli\u017En\u011B {{count}} t\xFDdny",
past:"p\u0159ibli\u017En\u011B p\u0159ed {{count}} t\xFDdny",
future:"p\u0159ibli\u017En\u011B za {{count}} t\xFDdny"
},
many:{
regular:"p\u0159ibli\u017En\u011B {{count}} t\xFDdn\u016F",
past:"p\u0159ibli\u017En\u011B p\u0159ed {{count}} t\xFDdny",
future:"p\u0159ibli\u017En\u011B za {{count}} t\xFDdn\u016F"
}
},
xWeeks:{
one:{
regular:"1 t\xFDden",
past:"p\u0159ed 1 t\xFDdnem",
future:"za 1 t\xFDden"
},
few:{
regular:"{{count}} t\xFDdny",
past:"p\u0159ed {{count}} t\xFDdny",
future:"za {{count}} t\xFDdny"
},
many:{
regular:"{{count}} t\xFDdn\u016F",
past:"p\u0159ed {{count}} t\xFDdny",
future:"za {{count}} t\xFDdn\u016F"
}
},
aboutXMonths:{
one:{
regular:"p\u0159ibli\u017En\u011B 1 m\u011Bs\xEDc",
past:"p\u0159ibli\u017En\u011B p\u0159ed 1 m\u011Bs\xEDcem",
future:"p\u0159ibli\u017En\u011B za 1 m\u011Bs\xEDc"
},
few:{
regular:"p\u0159ibli\u017En\u011B {{count}} m\u011Bs\xEDce",
past:"p\u0159ibli\u017En\u011B p\u0159ed {{count}} m\u011Bs\xEDci",
future:"p\u0159ibli\u017En\u011B za {{count}} m\u011Bs\xEDce"
},
many:{
regular:"p\u0159ibli\u017En\u011B {{count}} m\u011Bs\xEDc\u016F",
past:"p\u0159ibli\u017En\u011B p\u0159ed {{count}} m\u011Bs\xEDci",
future:"p\u0159ibli\u017En\u011B za {{count}} m\u011Bs\xEDc\u016F"
}
},
xMonths:{
one:{
regular:"1 m\u011Bs\xEDc",
past:"p\u0159ed 1 m\u011Bs\xEDcem",
future:"za 1 m\u011Bs\xEDc"
},
few:{
regular:"{{count}} m\u011Bs\xEDce",
past:"p\u0159ed {{count}} m\u011Bs\xEDci",
future:"za {{count}} m\u011Bs\xEDce"
},
many:{
regular:"{{count}} m\u011Bs\xEDc\u016F",
past:"p\u0159ed {{count}} m\u011Bs\xEDci",
future:"za {{count}} m\u011Bs\xEDc\u016F"
}
},
aboutXYears:{
one:{
regular:"p\u0159ibli\u017En\u011B 1 rok",
past:"p\u0159ibli\u017En\u011B p\u0159ed 1 rokem",
future:"p\u0159ibli\u017En\u011B za 1 rok"
},
few:{
regular:"p\u0159ibli\u017En\u011B {{count}} roky",
past:"p\u0159ibli\u017En\u011B p\u0159ed {{count}} roky",
future:"p\u0159ibli\u017En\u011B za {{count}} roky"
},
many:{
regular:"p\u0159ibli\u017En\u011B {{count}} rok\u016F",
past:"p\u0159ibli\u017En\u011B p\u0159ed {{count}} roky",
future:"p\u0159ibli\u017En\u011B za {{count}} rok\u016F"
}
},
xYears:{
one:{
regular:"1 rok",
past:"p\u0159ed 1 rokem",
future:"za 1 rok"
},
few:{
regular:"{{count}} roky",
past:"p\u0159ed {{count}} roky",
future:"za {{count}} roky"
},
many:{
regular:"{{count}} rok\u016F",
past:"p\u0159ed {{count}} roky",
future:"za {{count}} rok\u016F"
}
},
overXYears:{
one:{
regular:"v\xEDce ne\u017E 1 rok",
past:"p\u0159ed v\xEDce ne\u017E 1 rokem",
future:"za v\xEDce ne\u017E 1 rok"
},
few:{
regular:"v\xEDce ne\u017E {{count}} roky",
past:"p\u0159ed v\xEDce ne\u017E {{count}} roky",
future:"za v\xEDce ne\u017E {{count}} roky"
},
many:{
regular:"v\xEDce ne\u017E {{count}} rok\u016F",
past:"p\u0159ed v\xEDce ne\u017E {{count}} roky",
future:"za v\xEDce ne\u017E {{count}} rok\u016F"
}
},
almostXYears:{
one:{
regular:"skoro 1 rok",
past:"skoro p\u0159ed 1 rokem",
future:"skoro za 1 rok"
},
few:{
regular:"skoro {{count}} roky",
past:"skoro p\u0159ed {{count}} roky",
future:"skoro za {{count}} roky"
},
many:{
regular:"skoro {{count}} rok\u016F",
past:"skoro p\u0159ed {{count}} roky",
future:"skoro za {{count}} rok\u016F"
}
}
};
var formatDistance31=function formatDistance31(token,count,options){
var pluralResult;
var tokenValue=formatDistanceLocale16[token];
if(tokenValue.type==="other"){
pluralResult=tokenValue.other;
}else if(count===1){
pluralResult=tokenValue.one;
}else if(count>1&&count<5){
pluralResult=tokenValue.few;
}else{
pluralResult=tokenValue.many;
}
var suffixExist=(options===null||options===void 0?void 0:options.addSuffix)===true;
var comparison=options===null||options===void 0?void 0:options.comparison;
var timeResult;
if(suffixExist&&comparison===-1){
timeResult=pluralResult.past;
}else if(suffixExist&&comparison===1){
timeResult=pluralResult.future;
}else{
timeResult=pluralResult.regular;
}
return timeResult.replace("{{count}}",String(count));
};

// lib/locale/cs/_lib/formatLong.js
var dateFormats16={
full:"EEEE, d. MMMM yyyy",
long:"d. MMMM yyyy",
medium:"d. M. yyyy",
short:"dd.MM.yyyy"
};
var timeFormats16={
full:"H:mm:ss zzzz",
long:"H:mm:ss z",
medium:"H:mm:ss",
short:"H:mm"
};
var dateTimeFormats16={
full:"{{date}} 'v' {{time}}",
long:"{{date}} 'v' {{time}}",
medium:"{{date}}, {{time}}",
short:"{{date}}, {{time}}"
};
var formatLong31={
date:buildFormatLongFn({
formats:dateFormats16,
defaultWidth:"full"
}),
time:buildFormatLongFn({
formats:timeFormats16,
defaultWidth:"full"
}),
dateTime:buildFormatLongFn({
formats:dateTimeFormats16,
defaultWidth:"full"
})
};

// lib/locale/cs/_lib/formatRelative.js
var accusativeWeekdays3=[
"ned\u011Bli",
"pond\u011Bl\xED",
"\xFAter\xFD",
"st\u0159edu",
"\u010Dtvrtek",
"p\xE1tek",
"sobotu"];

var formatRelativeLocale16={
lastWeek:"'posledn\xED' eeee 've' p",
yesterday:"'v\u010Dera v' p",
today:"'dnes v' p",
tomorrow:"'z\xEDtra v' p",
nextWeek:function nextWeek(date){
var day=date.getDay();
return"'v "+accusativeWeekdays3[day]+" o' p";
},
other:"P"
};
var formatRelative31=function formatRelative31(token,date){
var format=formatRelativeLocale16[token];
if(typeof format==="function"){
return format(date);
}
return format;
};

// lib/locale/cs/_lib/localize.js
var eraValues16={
narrow:["p\u0159. n. l.","n. l."],
abbreviated:["p\u0159. n. l.","n. l."],
wide:["p\u0159ed na\u0161\xEDm letopo\u010Dtem","na\u0161eho letopo\u010Dtu"]
};
var quarterValues16={
narrow:["1","2","3","4"],
abbreviated:["1. \u010Dtvrtlet\xED","2. \u010Dtvrtlet\xED","3. \u010Dtvrtlet\xED","4. \u010Dtvrtlet\xED"],
wide:["1. \u010Dtvrtlet\xED","2. \u010Dtvrtlet\xED","3. \u010Dtvrtlet\xED","4. \u010Dtvrtlet\xED"]
};
var monthValues16={
narrow:["L","\xDA","B","D","K","\u010C","\u010C","S","Z","\u0158","L","P"],
abbreviated:[
"led",
"\xFAno",
"b\u0159e",
"dub",
"kv\u011B",
"\u010Dvn",
"\u010Dvc",
"srp",
"z\xE1\u0159",
"\u0159\xEDj",
"lis",
"pro"],

wide:[
"leden",
"\xFAnor",
"b\u0159ezen",
"duben",
"kv\u011Bten",
"\u010Derven",
"\u010Dervenec",
"srpen",
"z\xE1\u0159\xED",
"\u0159\xEDjen",
"listopad",
"prosinec"]

};
var formattingMonthValues4={
narrow:["L","\xDA","B","D","K","\u010C","\u010C","S","Z","\u0158","L","P"],
abbreviated:[
"led",
"\xFAno",
"b\u0159e",
"dub",
"kv\u011B",
"\u010Dvn",
"\u010Dvc",
"srp",
"z\xE1\u0159",
"\u0159\xEDj",
"lis",
"pro"],

wide:[
"ledna",
"\xFAnora",
"b\u0159ezna",
"dubna",
"kv\u011Btna",
"\u010Dervna",
"\u010Dervence",
"srpna",
"z\xE1\u0159\xED",
"\u0159\xEDjna",
"listopadu",
"prosince"]

};
var dayValues16={
narrow:["ne","po","\xFAt","st","\u010Dt","p\xE1","so"],
short:["ne","po","\xFAt","st","\u010Dt","p\xE1","so"],
abbreviated:["ned","pon","\xFAte","st\u0159","\u010Dtv","p\xE1t","sob"],
wide:["ned\u011Ble","pond\u011Bl\xED","\xFAter\xFD","st\u0159eda","\u010Dtvrtek","p\xE1tek","sobota"]
};
var dayPeriodValues16={
narrow:{
am:"dop.",
pm:"odp.",
midnight:"p\u016Flnoc",
noon:"poledne",
morning:"r\xE1no",
afternoon:"odpoledne",
evening:"ve\u010Der",
night:"noc"
},
abbreviated:{
am:"dop.",
pm:"odp.",
midnight:"p\u016Flnoc",
noon:"poledne",
morning:"r\xE1no",
afternoon:"odpoledne",
evening:"ve\u010Der",
night:"noc"
},
wide:{
am:"dopoledne",
pm:"odpoledne",
midnight:"p\u016Flnoc",
noon:"poledne",
morning:"r\xE1no",
afternoon:"odpoledne",
evening:"ve\u010Der",
night:"noc"
}
};
var formattingDayPeriodValues15={
narrow:{
am:"dop.",
pm:"odp.",
midnight:"p\u016Flnoc",
noon:"poledne",
morning:"r\xE1no",
afternoon:"odpoledne",
evening:"ve\u010Der",
night:"noc"
},
abbreviated:{
am:"dop.",
pm:"odp.",
midnight:"p\u016Flnoc",
noon:"poledne",
morning:"r\xE1no",
afternoon:"odpoledne",
evening:"ve\u010Der",
night:"noc"
},
wide:{
am:"dopoledne",
pm:"odpoledne",
midnight:"p\u016Flnoc",
noon:"poledne",
morning:"r\xE1no",
afternoon:"odpoledne",
evening:"ve\u010Der",
night:"noc"
}
};
var ordinalNumber16=function ordinalNumber16(dirtyNumber,_options){
var number=Number(dirtyNumber);
return number+".";
};
var localize32={
ordinalNumber:ordinalNumber16,
era:buildLocalizeFn({
values:eraValues16,
defaultWidth:"wide"
}),
quarter:buildLocalizeFn({
values:quarterValues16,
defaultWidth:"wide",
argumentCallback:function argumentCallback(quarter){return quarter-1;}
}),
month:buildLocalizeFn({
values:monthValues16,
defaultWidth:"wide",
formattingValues:formattingMonthValues4,
defaultFormattingWidth:"wide"
}),
day:buildLocalizeFn({
values:dayValues16,
defaultWidth:"wide"
}),
dayPeriod:buildLocalizeFn({
values:dayPeriodValues16,
defaultWidth:"wide",
formattingValues:formattingDayPeriodValues15,
defaultFormattingWidth:"wide"
})
};

// lib/locale/cs/_lib/match.js
var matchOrdinalNumberPattern16=/^(\d+)\.?/i;
var parseOrdinalNumberPattern16=/\d+/i;
var matchEraPatterns16={
narrow:/^(p[řr](\.|ed) Kr\.|p[řr](\.|ed) n\. l\.|po Kr\.|n\. l\.)/i,
abbreviated:/^(p[řr](\.|ed) Kr\.|p[řr](\.|ed) n\. l\.|po Kr\.|n\. l\.)/i,
wide:/^(p[řr](\.|ed) Kristem|p[řr](\.|ed) na[šs][íi]m letopo[čc]tem|po Kristu|na[šs]eho letopo[čc]tu)/i
};
var parseEraPatterns16={
any:[/^p[řr]/i,/^(po|n)/i]
};
var matchQuarterPatterns16={
narrow:/^[1234]/i,
abbreviated:/^[1234]\. [čc]tvrtlet[íi]/i,
wide:/^[1234]\. [čc]tvrtlet[íi]/i
};
var parseQuarterPatterns16={
any:[/1/i,/2/i,/3/i,/4/i]
};
var matchMonthPatterns16={
narrow:/^[lúubdkčcszřrlp]/i,
abbreviated:/^(led|[úu]no|b[řr]e|dub|kv[ěe]|[čc]vn|[čc]vc|srp|z[áa][řr]|[řr][íi]j|lis|pro)/i,
wide:/^(leden|ledna|[úu]nora?|b[řr]ezen|b[řr]ezna|duben|dubna|kv[ěe]ten|kv[ěe]tna|[čc]erven(ec|ce)?|[čc]ervna|srpen|srpna|z[áa][řr][íi]|[řr][íi]jen|[řr][íi]jna|listopad(a|u)?|prosinec|prosince)/i
};
var parseMonthPatterns16={
narrow:[
/^l/i,
/^[úu]/i,
/^b/i,
/^d/i,
/^k/i,
/^[čc]/i,
/^[čc]/i,
/^s/i,
/^z/i,
/^[řr]/i,
/^l/i,
/^p/i],

any:[
/^led/i,
/^[úu]n/i,
/^b[řr]e/i,
/^dub/i,
/^kv[ěe]/i,
/^[čc]vn|[čc]erven(?!\w)|[čc]ervna/i,
/^[čc]vc|[čc]erven(ec|ce)/i,
/^srp/i,
/^z[áa][řr]/i,
/^[řr][íi]j/i,
/^lis/i,
/^pro/i]

};
var matchDayPatterns16={
narrow:/^[npuúsčps]/i,
short:/^(ne|po|[úu]t|st|[čc]t|p[áa]|so)/i,
abbreviated:/^(ned|pon|[úu]te|st[rř]|[čc]tv|p[áa]t|sob)/i,
wide:/^(ned[ěe]le|pond[ěe]l[íi]|[úu]ter[ýy]|st[řr]eda|[čc]tvrtek|p[áa]tek|sobota)/i
};
var parseDayPatterns16={
narrow:[/^n/i,/^p/i,/^[úu]/i,/^s/i,/^[čc]/i,/^p/i,/^s/i],
any:[/^ne/i,/^po/i,/^[úu]t/i,/^st/i,/^[čc]t/i,/^p[áa]/i,/^so/i]
};
var matchDayPeriodPatterns16={
any:/^dopoledne|dop\.?|odpoledne|odp\.?|p[ůu]lnoc|poledne|r[áa]no|odpoledne|ve[čc]er|(v )?noci?/i
};
var parseDayPeriodPatterns16={
any:{
am:/^dop/i,
pm:/^odp/i,
midnight:/^p[ůu]lnoc/i,
noon:/^poledne/i,
morning:/r[áa]no/i,
afternoon:/odpoledne/i,
evening:/ve[čc]er/i,
night:/noc/i
}
};
var match31={
ordinalNumber:buildMatchPatternFn({
matchPattern:matchOrdinalNumberPattern16,
parsePattern:parseOrdinalNumberPattern16,
valueCallback:function valueCallback(value){return parseInt(value,10);}
}),
era:buildMatchFn({
matchPatterns:matchEraPatterns16,
defaultMatchWidth:"wide",
parsePatterns:parseEraPatterns16,
defaultParseWidth:"any"
}),
quarter:buildMatchFn({
matchPatterns:matchQuarterPatterns16,
defaultMatchWidth:"wide",
parsePatterns:parseQuarterPatterns16,
defaultParseWidth:"any",
valueCallback:function valueCallback(index){return index+1;}
}),
month:buildMatchFn({
matchPatterns:matchMonthPatterns16,
defaultMatchWidth:"wide",
parsePatterns:parseMonthPatterns16,
defaultParseWidth:"any"
}),
day:buildMatchFn({
matchPatterns:matchDayPatterns16,
defaultMatchWidth:"wide",
parsePatterns:parseDayPatterns16,
defaultParseWidth:"any"
}),
dayPeriod:buildMatchFn({
matchPatterns:matchDayPeriodPatterns16,
defaultMatchWidth:"any",
parsePatterns:parseDayPeriodPatterns16,
defaultParseWidth:"any"
})
};

// lib/locale/cs.js
var _cs={
code:"cs",
formatDistance:formatDistance31,
formatLong:formatLong31,
formatRelative:formatRelative31,
localize:localize32,
match:match31,
options:{
weekStartsOn:1,
firstWeekContainsDate:4
}
};
// lib/locale/cy/_lib/formatDistance.js
var formatDistanceLocale17={
lessThanXSeconds:{
one:"llai na eiliad",
other:"llai na {{count}} eiliad"
},
xSeconds:{
one:"1 eiliad",
other:"{{count}} eiliad"
},
halfAMinute:"hanner munud",
lessThanXMinutes:{
one:"llai na munud",
two:"llai na 2 funud",
other:"llai na {{count}} munud"
},
xMinutes:{
one:"1 munud",
two:"2 funud",
other:"{{count}} munud"
},
aboutXHours:{
one:"tua 1 awr",
other:"tua {{count}} awr"
},
xHours:{
one:"1 awr",
other:"{{count}} awr"
},
xDays:{
one:"1 diwrnod",
two:"2 ddiwrnod",
other:"{{count}} diwrnod"
},
aboutXWeeks:{
one:"tua 1 wythnos",
two:"tua pythefnos",
other:"tua {{count}} wythnos"
},
xWeeks:{
one:"1 wythnos",
two:"pythefnos",
other:"{{count}} wythnos"
},
aboutXMonths:{
one:"tua 1 mis",
two:"tua 2 fis",
other:"tua {{count}} mis"
},
xMonths:{
one:"1 mis",
two:"2 fis",
other:"{{count}} mis"
},
aboutXYears:{
one:"tua 1 flwyddyn",
two:"tua 2 flynedd",
other:"tua {{count}} mlynedd"
},
xYears:{
one:"1 flwyddyn",
two:"2 flynedd",
other:"{{count}} mlynedd"
},
overXYears:{
one:"dros 1 flwyddyn",
two:"dros 2 flynedd",
other:"dros {{count}} mlynedd"
},
almostXYears:{
one:"bron 1 flwyddyn",
two:"bron 2 flynedd",
other:"bron {{count}} mlynedd"
}
};
var formatDistance33=function formatDistance33(token,count,options){
var result;
var tokenValue=formatDistanceLocale17[token];
if(typeof tokenValue==="string"){
result=tokenValue;
}else if(count===1){
result=tokenValue.one;
}else if(count===2&&!!tokenValue.two){
result=tokenValue.two;
}else{
result=tokenValue.other.replace("{{count}}",String(count));
}
if(options!==null&&options!==void 0&&options.addSuffix){
if(options.comparison&&options.comparison>0){
return"mewn "+result;
}else{
return result+" yn \xF4l";
}
}
return result;
};

// lib/locale/cy/_lib/formatLong.js
var dateFormats17={
full:"EEEE, d MMMM yyyy",
long:"d MMMM yyyy",
medium:"d MMM yyyy",
short:"dd/MM/yyyy"
};
var timeFormats17={
full:"h:mm:ss a zzzz",
long:"h:mm:ss a z",
medium:"h:mm:ss a",
short:"h:mm a"
};
var dateTimeFormats17={
full:"{{date}} 'am' {{time}}",
long:"{{date}} 'am' {{time}}",
medium:"{{date}}, {{time}}",
short:"{{date}}, {{time}}"
};
var formatLong33={
date:buildFormatLongFn({
formats:dateFormats17,
defaultWidth:"full"
}),
time:buildFormatLongFn({
formats:timeFormats17,
defaultWidth:"full"
}),
dateTime:buildFormatLongFn({
formats:dateTimeFormats17,
defaultWidth:"full"
})
};

// lib/locale/cy/_lib/formatRelative.js
var formatRelativeLocale17={
lastWeek:"eeee 'diwethaf am' p",
yesterday:"'ddoe am' p",
today:"'heddiw am' p",
tomorrow:"'yfory am' p",
nextWeek:"eeee 'am' p",
other:"P"
};
var formatRelative33=function formatRelative33(token,_date,_baseDate,_options){return formatRelativeLocale17[token];};

// lib/locale/cy/_lib/localize.js
var eraValues17={
narrow:["C","O"],
abbreviated:["CC","OC"],
wide:["Cyn Crist","Ar \xF4l Crist"]
};
var quarterValues17={
narrow:["1","2","3","4"],
abbreviated:["Ch1","Ch2","Ch3","Ch4"],
wide:["Chwarter 1af","2ail chwarter","3ydd chwarter","4ydd chwarter"]
};
var monthValues17={
narrow:["I","Ch","Ma","E","Mi","Me","G","A","Md","H","T","Rh"],
abbreviated:[
"Ion",
"Chwe",
"Maw",
"Ebr",
"Mai",
"Meh",
"Gor",
"Aws",
"Med",
"Hyd",
"Tach",
"Rhag"],

wide:[
"Ionawr",
"Chwefror",
"Mawrth",
"Ebrill",
"Mai",
"Mehefin",
"Gorffennaf",
"Awst",
"Medi",
"Hydref",
"Tachwedd",
"Rhagfyr"]

};
var dayValues17={
narrow:["S","Ll","M","M","I","G","S"],
short:["Su","Ll","Ma","Me","Ia","Gw","Sa"],
abbreviated:["Sul","Llun","Maw","Mer","Iau","Gwe","Sad"],
wide:[
"dydd Sul",
"dydd Llun",
"dydd Mawrth",
"dydd Mercher",
"dydd Iau",
"dydd Gwener",
"dydd Sadwrn"]

};
var dayPeriodValues17={
narrow:{
am:"b",
pm:"h",
midnight:"hn",
noon:"hd",
morning:"bore",
afternoon:"prynhawn",
evening:"gyda'r nos",
night:"nos"
},
abbreviated:{
am:"yb",
pm:"yh",
midnight:"hanner nos",
noon:"hanner dydd",
morning:"bore",
afternoon:"prynhawn",
evening:"gyda'r nos",
night:"nos"
},
wide:{
am:"y.b.",
pm:"y.h.",
midnight:"hanner nos",
noon:"hanner dydd",
morning:"bore",
afternoon:"prynhawn",
evening:"gyda'r nos",
night:"nos"
}
};
var formattingDayPeriodValues16={
narrow:{
am:"b",
pm:"h",
midnight:"hn",
noon:"hd",
morning:"yn y bore",
afternoon:"yn y prynhawn",
evening:"gyda'r nos",
night:"yn y nos"
},
abbreviated:{
am:"yb",
pm:"yh",
midnight:"hanner nos",
noon:"hanner dydd",
morning:"yn y bore",
afternoon:"yn y prynhawn",
evening:"gyda'r nos",
night:"yn y nos"
},
wide:{
am:"y.b.",
pm:"y.h.",
midnight:"hanner nos",
noon:"hanner dydd",
morning:"yn y bore",
afternoon:"yn y prynhawn",
evening:"gyda'r nos",
night:"yn y nos"
}
};
var ordinalNumber17=function ordinalNumber17(dirtyNumber,_options){
var number=Number(dirtyNumber);
if(number<20){
switch(number){
case 0:
return number+"fed";
case 1:
return number+"af";
case 2:
return number+"ail";
case 3:
case 4:
return number+"ydd";
case 5:
case 6:
return number+"ed";
case 7:
case 8:
case 9:
case 10:
case 12:
case 15:
case 18:
return number+"fed";
case 11:
case 13:
case 14:
case 16:
case 17:
case 19:
return number+"eg";
}
}else if(number>=50&&number<=60||number===80||number>=100){
return number+"fed";
}
return number+"ain";
};
var localize34={
ordinalNumber:ordinalNumber17,
era:buildLocalizeFn({
values:eraValues17,
defaultWidth:"wide"
}),
quarter:buildLocalizeFn({
values:quarterValues17,
defaultWidth:"wide",
argumentCallback:function argumentCallback(quarter){return quarter-1;}
}),
month:buildLocalizeFn({
values:monthValues17,
defaultWidth:"wide"
}),
day:buildLocalizeFn({
values:dayValues17,
defaultWidth:"wide"
}),
dayPeriod:buildLocalizeFn({
values:dayPeriodValues17,
defaultWidth:"wide",
formattingValues:formattingDayPeriodValues16,
defaultFormattingWidth:"wide"
})
};

// lib/locale/cy/_lib/match.js
var matchOrdinalNumberPattern17=/^(\d+)(af|ail|ydd|ed|fed|eg|ain)?/i;
var parseOrdinalNumberPattern17=/\d+/i;
var matchEraPatterns17={
narrow:/^(c|o)/i,
abbreviated:/^(c\.?\s?c\.?|o\.?\s?c\.?)/i,
wide:/^(cyn christ|ar ôl crist|ar ol crist)/i
};
var parseEraPatterns17={
wide:[/^c/i,/^(ar ôl crist|ar ol crist)/i],
any:[/^c/i,/^o/i]
};
var matchQuarterPatterns17={
narrow:/^[1234]/i,
abbreviated:/^ch[1234]/i,
wide:/^(chwarter 1af)|([234](ail|ydd)? chwarter)/i
};
var parseQuarterPatterns17={
any:[/1/i,/2/i,/3/i,/4/i]
};
var matchMonthPatterns17={
narrow:/^(i|ch|m|e|g|a|h|t|rh)/i,
abbreviated:/^(ion|chwe|maw|ebr|mai|meh|gor|aws|med|hyd|tach|rhag)/i,
wide:/^(ionawr|chwefror|mawrth|ebrill|mai|mehefin|gorffennaf|awst|medi|hydref|tachwedd|rhagfyr)/i
};
var parseMonthPatterns17={
narrow:[
/^i/i,
/^ch/i,
/^m/i,
/^e/i,
/^m/i,
/^m/i,
/^g/i,
/^a/i,
/^m/i,
/^h/i,
/^t/i,
/^rh/i],

any:[
/^io/i,
/^ch/i,
/^maw/i,
/^e/i,
/^mai/i,
/^meh/i,
/^g/i,
/^a/i,
/^med/i,
/^h/i,
/^t/i,
/^rh/i]

};
var matchDayPatterns17={
narrow:/^(s|ll|m|i|g)/i,
short:/^(su|ll|ma|me|ia|gw|sa)/i,
abbreviated:/^(sul|llun|maw|mer|iau|gwe|sad)/i,
wide:/^dydd (sul|llun|mawrth|mercher|iau|gwener|sadwrn)/i
};
var parseDayPatterns17={
narrow:[/^s/i,/^ll/i,/^m/i,/^m/i,/^i/i,/^g/i,/^s/i],
wide:[
/^dydd su/i,
/^dydd ll/i,
/^dydd ma/i,
/^dydd me/i,
/^dydd i/i,
/^dydd g/i,
/^dydd sa/i],

any:[/^su/i,/^ll/i,/^ma/i,/^me/i,/^i/i,/^g/i,/^sa/i]
};
var matchDayPeriodPatterns17={
narrow:/^(b|h|hn|hd|(yn y|y|yr|gyda'r) (bore|prynhawn|nos|hwyr))/i,
any:/^(y\.?\s?[bh]\.?|hanner nos|hanner dydd|(yn y|y|yr|gyda'r) (bore|prynhawn|nos|hwyr))/i
};
var parseDayPeriodPatterns17={
any:{
am:/^b|(y\.?\s?b\.?)/i,
pm:/^h|(y\.?\s?h\.?)|(yr hwyr)/i,
midnight:/^hn|hanner nos/i,
noon:/^hd|hanner dydd/i,
morning:/bore/i,
afternoon:/prynhawn/i,
evening:/^gyda'r nos$/i,
night:/blah/i
}
};
var match33={
ordinalNumber:buildMatchPatternFn({
matchPattern:matchOrdinalNumberPattern17,
parsePattern:parseOrdinalNumberPattern17,
valueCallback:function valueCallback(value){return parseInt(value,10);}
}),
era:buildMatchFn({
matchPatterns:matchEraPatterns17,
defaultMatchWidth:"wide",
parsePatterns:parseEraPatterns17,
defaultParseWidth:"any"
}),
quarter:buildMatchFn({
matchPatterns:matchQuarterPatterns17,
defaultMatchWidth:"wide",
parsePatterns:parseQuarterPatterns17,
defaultParseWidth:"any",
valueCallback:function valueCallback(index){return index+1;}
}),
month:buildMatchFn({
matchPatterns:matchMonthPatterns17,
defaultMatchWidth:"wide",
parsePatterns:parseMonthPatterns17,
defaultParseWidth:"any"
}),
day:buildMatchFn({
matchPatterns:matchDayPatterns17,
defaultMatchWidth:"wide",
parsePatterns:parseDayPatterns17,
defaultParseWidth:"any"
}),
dayPeriod:buildMatchFn({
matchPatterns:matchDayPeriodPatterns17,
defaultMatchWidth:"any",
parsePatterns:parseDayPeriodPatterns17,
defaultParseWidth:"any"
})
};

// lib/locale/cy.js
var _cy={
code:"cy",
formatDistance:formatDistance33,
formatLong:formatLong33,
formatRelative:formatRelative33,
localize:localize34,
match:match33,
options:{
weekStartsOn:0,
firstWeekContainsDate:1
}
};
// lib/locale/da/_lib/formatDistance.js
var formatDistanceLocale18={
lessThanXSeconds:{
one:"mindre end \xE9t sekund",
other:"mindre end {{count}} sekunder"
},
xSeconds:{
one:"1 sekund",
other:"{{count}} sekunder"
},
halfAMinute:"\xE9t halvt minut",
lessThanXMinutes:{
one:"mindre end \xE9t minut",
other:"mindre end {{count}} minutter"
},
xMinutes:{
one:"1 minut",
other:"{{count}} minutter"
},
aboutXHours:{
one:"cirka 1 time",
other:"cirka {{count}} timer"
},
xHours:{
one:"1 time",
other:"{{count}} timer"
},
xDays:{
one:"1 dag",
other:"{{count}} dage"
},
aboutXWeeks:{
one:"cirka 1 uge",
other:"cirka {{count}} uger"
},
xWeeks:{
one:"1 uge",
other:"{{count}} uger"
},
aboutXMonths:{
one:"cirka 1 m\xE5ned",
other:"cirka {{count}} m\xE5neder"
},
xMonths:{
one:"1 m\xE5ned",
other:"{{count}} m\xE5neder"
},
aboutXYears:{
one:"cirka 1 \xE5r",
other:"cirka {{count}} \xE5r"
},
xYears:{
one:"1 \xE5r",
other:"{{count}} \xE5r"
},
overXYears:{
one:"over 1 \xE5r",
other:"over {{count}} \xE5r"
},
almostXYears:{
one:"n\xE6sten 1 \xE5r",
other:"n\xE6sten {{count}} \xE5r"
}
};
var formatDistance35=function formatDistance35(token,count,options){
var result;
var tokenValue=formatDistanceLocale18[token];
if(typeof tokenValue==="string"){
result=tokenValue;
}else if(count===1){
result=tokenValue.one;
}else{
result=tokenValue.other.replace("{{count}}",String(count));
}
if(options!==null&&options!==void 0&&options.addSuffix){
if(options.comparison&&options.comparison>0){
return"om "+result;
}else{
return result+" siden";
}
}
return result;
};

// lib/locale/da/_lib/formatLong.js
var dateFormats18={
full:"EEEE 'den' d. MMMM y",
long:"d. MMMM y",
medium:"d. MMM y",
short:"dd/MM/y"
};
var timeFormats18={
full:"HH:mm:ss zzzz",
long:"HH:mm:ss z",
medium:"HH:mm:ss",
short:"HH:mm"
};
var dateTimeFormats18={
full:"{{date}} 'kl'. {{time}}",
long:"{{date}} 'kl'. {{time}}",
medium:"{{date}} {{time}}",
short:"{{date}} {{time}}"
};
var formatLong35={
date:buildFormatLongFn({
formats:dateFormats18,
defaultWidth:"full"
}),
time:buildFormatLongFn({
formats:timeFormats18,
defaultWidth:"full"
}),
dateTime:buildFormatLongFn({
formats:dateTimeFormats18,
defaultWidth:"full"
})
};

// lib/locale/da/_lib/formatRelative.js
var formatRelativeLocale18={
lastWeek:"'sidste' eeee 'kl.' p",
yesterday:"'i g\xE5r kl.' p",
today:"'i dag kl.' p",
tomorrow:"'i morgen kl.' p",
nextWeek:"'p\xE5' eeee 'kl.' p",
other:"P"
};
var formatRelative35=function formatRelative35(token,_date,_baseDate,_options){return formatRelativeLocale18[token];};

// lib/locale/da/_lib/localize.js
var eraValues18={
narrow:["fvt","vt"],
abbreviated:["f.v.t.","v.t."],
wide:["f\xF8r vesterlandsk tidsregning","vesterlandsk tidsregning"]
};
var quarterValues18={
narrow:["1","2","3","4"],
abbreviated:["1. kvt.","2. kvt.","3. kvt.","4. kvt."],
wide:["1. kvartal","2. kvartal","3. kvartal","4. kvartal"]
};
var monthValues18={
narrow:["J","F","M","A","M","J","J","A","S","O","N","D"],
abbreviated:[
"jan.",
"feb.",
"mar.",
"apr.",
"maj",
"jun.",
"jul.",
"aug.",
"sep.",
"okt.",
"nov.",
"dec."],

wide:[
"januar",
"februar",
"marts",
"april",
"maj",
"juni",
"juli",
"august",
"september",
"oktober",
"november",
"december"]

};
var dayValues18={
narrow:["S","M","T","O","T","F","L"],
short:["s\xF8","ma","ti","on","to","fr","l\xF8"],
abbreviated:["s\xF8n.","man.","tir.","ons.","tor.","fre.","l\xF8r."],
wide:[
"s\xF8ndag",
"mandag",
"tirsdag",
"onsdag",
"torsdag",
"fredag",
"l\xF8rdag"]

};
var dayPeriodValues18={
narrow:{
am:"a",
pm:"p",
midnight:"midnat",
noon:"middag",
morning:"morgen",
afternoon:"eftermiddag",
evening:"aften",
night:"nat"
},
abbreviated:{
am:"AM",
pm:"PM",
midnight:"midnat",
noon:"middag",
morning:"morgen",
afternoon:"eftermiddag",
evening:"aften",
night:"nat"
},
wide:{
am:"a.m.",
pm:"p.m.",
midnight:"midnat",
noon:"middag",
morning:"morgen",
afternoon:"eftermiddag",
evening:"aften",
night:"nat"
}
};
var formattingDayPeriodValues17={
narrow:{
am:"a",
pm:"p",
midnight:"midnat",
noon:"middag",
morning:"om morgenen",
afternoon:"om eftermiddagen",
evening:"om aftenen",
night:"om natten"
},
abbreviated:{
am:"AM",
pm:"PM",
midnight:"midnat",
noon:"middag",
morning:"om morgenen",
afternoon:"om eftermiddagen",
evening:"om aftenen",
night:"om natten"
},
wide:{
am:"a.m.",
pm:"p.m.",
midnight:"midnat",
noon:"middag",
morning:"om morgenen",
afternoon:"om eftermiddagen",
evening:"om aftenen",
night:"om natten"
}
};
var ordinalNumber18=function ordinalNumber18(dirtyNumber,_options){
var number=Number(dirtyNumber);
return number+".";
};
var localize36={
ordinalNumber:ordinalNumber18,
era:buildLocalizeFn({
values:eraValues18,
defaultWidth:"wide"
}),
quarter:buildLocalizeFn({
values:quarterValues18,
defaultWidth:"wide",
argumentCallback:function argumentCallback(quarter){return quarter-1;}
}),
month:buildLocalizeFn({
values:monthValues18,
defaultWidth:"wide"
}),
day:buildLocalizeFn({
values:dayValues18,
defaultWidth:"wide"
}),
dayPeriod:buildLocalizeFn({
values:dayPeriodValues18,
defaultWidth:"wide",
formattingValues:formattingDayPeriodValues17,
defaultFormattingWidth:"wide"
})
};

// lib/locale/da/_lib/match.js
var matchOrdinalNumberPattern18=/^(\d+)(\.)?/i;
var parseOrdinalNumberPattern18=/\d+/i;
var matchEraPatterns18={
narrow:/^(fKr|fvt|eKr|vt)/i,
abbreviated:/^(f\.Kr\.?|f\.v\.t\.?|e\.Kr\.?|v\.t\.)/i,
wide:/^(f.Kr.|før vesterlandsk tidsregning|e.Kr.|vesterlandsk tidsregning)/i
};
var parseEraPatterns18={
any:[/^f/i,/^(v|e)/i]
};
var matchQuarterPatterns18={
narrow:/^[1234]/i,
abbreviated:/^[1234]. kvt\./i,
wide:/^[1234]\.? kvartal/i
};
var parseQuarterPatterns18={
any:[/1/i,/2/i,/3/i,/4/i]
};
var matchMonthPatterns18={
narrow:/^[jfmasond]/i,
abbreviated:/^(jan.|feb.|mar.|apr.|maj|jun.|jul.|aug.|sep.|okt.|nov.|dec.)/i,
wide:/^(januar|februar|marts|april|maj|juni|juli|august|september|oktober|november|december)/i
};
var parseMonthPatterns18={
narrow:[
/^j/i,
/^f/i,
/^m/i,
/^a/i,
/^m/i,
/^j/i,
/^j/i,
/^a/i,
/^s/i,
/^o/i,
/^n/i,
/^d/i],

any:[
/^ja/i,
/^f/i,
/^mar/i,
/^ap/i,
/^maj/i,
/^jun/i,
/^jul/i,
/^au/i,
/^s/i,
/^o/i,
/^n/i,
/^d/i]

};
var matchDayPatterns18={
narrow:/^[smtofl]/i,
short:/^(søn.|man.|tir.|ons.|tor.|fre.|lør.)/i,
abbreviated:/^(søn|man|tir|ons|tor|fre|lør)/i,
wide:/^(søndag|mandag|tirsdag|onsdag|torsdag|fredag|lørdag)/i
};
var parseDayPatterns18={
narrow:[/^s/i,/^m/i,/^t/i,/^o/i,/^t/i,/^f/i,/^l/i],
any:[/^s/i,/^m/i,/^ti/i,/^o/i,/^to/i,/^f/i,/^l/i]
};
var matchDayPeriodPatterns18={
narrow:/^(a|p|midnat|middag|(om) (morgenen|eftermiddagen|aftenen|natten))/i,
any:/^([ap]\.?\s?m\.?|midnat|middag|(om) (morgenen|eftermiddagen|aftenen|natten))/i
};
var parseDayPeriodPatterns18={
any:{
am:/^a/i,
pm:/^p/i,
midnight:/midnat/i,
noon:/middag/i,
morning:/morgen/i,
afternoon:/eftermiddag/i,
evening:/aften/i,
night:/nat/i
}
};
var match35={
ordinalNumber:buildMatchPatternFn({
matchPattern:matchOrdinalNumberPattern18,
parsePattern:parseOrdinalNumberPattern18,
valueCallback:function valueCallback(value){return parseInt(value,10);}
}),
era:buildMatchFn({
matchPatterns:matchEraPatterns18,
defaultMatchWidth:"wide",
parsePatterns:parseEraPatterns18,
defaultParseWidth:"any"
}),
quarter:buildMatchFn({
matchPatterns:matchQuarterPatterns18,
defaultMatchWidth:"wide",
parsePatterns:parseQuarterPatterns18,
defaultParseWidth:"any",
valueCallback:function valueCallback(index){return index+1;}
}),
month:buildMatchFn({
matchPatterns:matchMonthPatterns18,
defaultMatchWidth:"wide",
parsePatterns:parseMonthPatterns18,
defaultParseWidth:"any"
}),
day:buildMatchFn({
matchPatterns:matchDayPatterns18,
defaultMatchWidth:"wide",
parsePatterns:parseDayPatterns18,
defaultParseWidth:"any"
}),
dayPeriod:buildMatchFn({
matchPatterns:matchDayPeriodPatterns18,
defaultMatchWidth:"any",
parsePatterns:parseDayPeriodPatterns18,
defaultParseWidth:"any"
})
};

// lib/locale/da.js
var _da={
code:"da",
formatDistance:formatDistance35,
formatLong:formatLong35,
formatRelative:formatRelative35,
localize:localize36,
match:match35,
options:{
weekStartsOn:1,
firstWeekContainsDate:4
}
};
// lib/locale/de/_lib/formatDistance.js
var formatDistanceLocale19={
lessThanXSeconds:{
standalone:{
one:"weniger als 1 Sekunde",
other:"weniger als {{count}} Sekunden"
},
withPreposition:{
one:"weniger als 1 Sekunde",
other:"weniger als {{count}} Sekunden"
}
},
xSeconds:{
standalone:{
one:"1 Sekunde",
other:"{{count}} Sekunden"
},
withPreposition:{
one:"1 Sekunde",
other:"{{count}} Sekunden"
}
},
halfAMinute:{
standalone:"eine halbe Minute",
withPreposition:"einer halben Minute"
},
lessThanXMinutes:{
standalone:{
one:"weniger als 1 Minute",
other:"weniger als {{count}} Minuten"
},
withPreposition:{
one:"weniger als 1 Minute",
other:"weniger als {{count}} Minuten"
}
},
xMinutes:{
standalone:{
one:"1 Minute",
other:"{{count}} Minuten"
},
withPreposition:{
one:"1 Minute",
other:"{{count}} Minuten"
}
},
aboutXHours:{
standalone:{
one:"etwa 1 Stunde",
other:"etwa {{count}} Stunden"
},
withPreposition:{
one:"etwa 1 Stunde",
other:"etwa {{count}} Stunden"
}
},
xHours:{
standalone:{
one:"1 Stunde",
other:"{{count}} Stunden"
},
withPreposition:{
one:"1 Stunde",
other:"{{count}} Stunden"
}
},
xDays:{
standalone:{
one:"1 Tag",
other:"{{count}} Tage"
},
withPreposition:{
one:"1 Tag",
other:"{{count}} Tagen"
}
},
aboutXWeeks:{
standalone:{
one:"etwa 1 Woche",
other:"etwa {{count}} Wochen"
},
withPreposition:{
one:"etwa 1 Woche",
other:"etwa {{count}} Wochen"
}
},
xWeeks:{
standalone:{
one:"1 Woche",
other:"{{count}} Wochen"
},
withPreposition:{
one:"1 Woche",
other:"{{count}} Wochen"
}
},
aboutXMonths:{
standalone:{
one:"etwa 1 Monat",
other:"etwa {{count}} Monate"
},
withPreposition:{
one:"etwa 1 Monat",
other:"etwa {{count}} Monaten"
}
},
xMonths:{
standalone:{
one:"1 Monat",
other:"{{count}} Monate"
},
withPreposition:{
one:"1 Monat",
other:"{{count}} Monaten"
}
},
aboutXYears:{
standalone:{
one:"etwa 1 Jahr",
other:"etwa {{count}} Jahre"
},
withPreposition:{
one:"etwa 1 Jahr",
other:"etwa {{count}} Jahren"
}
},
xYears:{
standalone:{
one:"1 Jahr",
other:"{{count}} Jahre"
},
withPreposition:{
one:"1 Jahr",
other:"{{count}} Jahren"
}
},
overXYears:{
standalone:{
one:"mehr als 1 Jahr",
other:"mehr als {{count}} Jahre"
},
withPreposition:{
one:"mehr als 1 Jahr",
other:"mehr als {{count}} Jahren"
}
},
almostXYears:{
standalone:{
one:"fast 1 Jahr",
other:"fast {{count}} Jahre"
},
withPreposition:{
one:"fast 1 Jahr",
other:"fast {{count}} Jahren"
}
}
};
var formatDistance37=function formatDistance37(token,count,options){
var result;
var tokenValue=options!==null&&options!==void 0&&options.addSuffix?formatDistanceLocale19[token].withPreposition:formatDistanceLocale19[token].standalone;
if(typeof tokenValue==="string"){
result=tokenValue;
}else if(count===1){
result=tokenValue.one;
}else{
result=tokenValue.other.replace("{{count}}",String(count));
}
if(options!==null&&options!==void 0&&options.addSuffix){
if(options.comparison&&options.comparison>0){
return"in "+result;
}else{
return"vor "+result;
}
}
return result;
};

// lib/locale/de/_lib/formatLong.js
var dateFormats19={
full:"EEEE, do MMMM y",
long:"do MMMM y",
medium:"do MMM y",
short:"dd.MM.y"
};
var timeFormats19={
full:"HH:mm:ss zzzz",
long:"HH:mm:ss z",
medium:"HH:mm:ss",
short:"HH:mm"
};
var dateTimeFormats19={
full:"{{date}} 'um' {{time}}",
long:"{{date}} 'um' {{time}}",
medium:"{{date}} {{time}}",
short:"{{date}} {{time}}"
};
var formatLong37={
date:buildFormatLongFn({
formats:dateFormats19,
defaultWidth:"full"
}),
time:buildFormatLongFn({
formats:timeFormats19,
defaultWidth:"full"
}),
dateTime:buildFormatLongFn({
formats:dateTimeFormats19,
defaultWidth:"full"
})
};

// lib/locale/de/_lib/formatRelative.js
var formatRelativeLocale19={
lastWeek:"'letzten' eeee 'um' p",
yesterday:"'gestern um' p",
today:"'heute um' p",
tomorrow:"'morgen um' p",
nextWeek:"eeee 'um' p",
other:"P"
};
var formatRelative37=function formatRelative37(token,_date,_baseDate,_options){return formatRelativeLocale19[token];};

// lib/locale/de/_lib/localize.js
var eraValues19={
narrow:["v.Chr.","n.Chr."],
abbreviated:["v.Chr.","n.Chr."],
wide:["vor Christus","nach Christus"]
};
var quarterValues19={
narrow:["1","2","3","4"],
abbreviated:["Q1","Q2","Q3","Q4"],
wide:["1. Quartal","2. Quartal","3. Quartal","4. Quartal"]
};
var monthValues19={
narrow:["J","F","M","A","M","J","J","A","S","O","N","D"],
abbreviated:[
"Jan",
"Feb",
"M\xE4r",
"Apr",
"Mai",
"Jun",
"Jul",
"Aug",
"Sep",
"Okt",
"Nov",
"Dez"],

wide:[
"Januar",
"Februar",
"M\xE4rz",
"April",
"Mai",
"Juni",
"Juli",
"August",
"September",
"Oktober",
"November",
"Dezember"]

};
var formattingMonthValues5={
narrow:monthValues19.narrow,
abbreviated:[
"Jan.",
"Feb.",
"M\xE4rz",
"Apr.",
"Mai",
"Juni",
"Juli",
"Aug.",
"Sep.",
"Okt.",
"Nov.",
"Dez."],

wide:monthValues19.wide
};
var dayValues19={
narrow:["S","M","D","M","D","F","S"],
short:["So","Mo","Di","Mi","Do","Fr","Sa"],
abbreviated:["So.","Mo.","Di.","Mi.","Do.","Fr.","Sa."],
wide:[
"Sonntag",
"Montag",
"Dienstag",
"Mittwoch",
"Donnerstag",
"Freitag",
"Samstag"]

};
var dayPeriodValues19={
narrow:{
am:"vm.",
pm:"nm.",
midnight:"Mitternacht",
noon:"Mittag",
morning:"Morgen",
afternoon:"Nachm.",
evening:"Abend",
night:"Nacht"
},
abbreviated:{
am:"vorm.",
pm:"nachm.",
midnight:"Mitternacht",
noon:"Mittag",
morning:"Morgen",
afternoon:"Nachmittag",
evening:"Abend",
night:"Nacht"
},
wide:{
am:"vormittags",
pm:"nachmittags",
midnight:"Mitternacht",
noon:"Mittag",
morning:"Morgen",
afternoon:"Nachmittag",
evening:"Abend",
night:"Nacht"
}
};
var formattingDayPeriodValues18={
narrow:{
am:"vm.",
pm:"nm.",
midnight:"Mitternacht",
noon:"Mittag",
morning:"morgens",
afternoon:"nachm.",
evening:"abends",
night:"nachts"
},
abbreviated:{
am:"vorm.",
pm:"nachm.",
midnight:"Mitternacht",
noon:"Mittag",
morning:"morgens",
afternoon:"nachmittags",
evening:"abends",
night:"nachts"
},
wide:{
am:"vormittags",
pm:"nachmittags",
midnight:"Mitternacht",
noon:"Mittag",
morning:"morgens",
afternoon:"nachmittags",
evening:"abends",
night:"nachts"
}
};
var ordinalNumber19=function ordinalNumber19(dirtyNumber){
var number=Number(dirtyNumber);
return number+".";
};
var localize38={
ordinalNumber:ordinalNumber19,
era:buildLocalizeFn({
values:eraValues19,
defaultWidth:"wide"
}),
quarter:buildLocalizeFn({
values:quarterValues19,
defaultWidth:"wide",
argumentCallback:function argumentCallback(quarter){return quarter-1;}
}),
month:buildLocalizeFn({
values:monthValues19,
formattingValues:formattingMonthValues5,
defaultWidth:"wide"
}),
day:buildLocalizeFn({
values:dayValues19,
defaultWidth:"wide"
}),
dayPeriod:buildLocalizeFn({
values:dayPeriodValues19,
defaultWidth:"wide",
formattingValues:formattingDayPeriodValues18,
defaultFormattingWidth:"wide"
})
};

// lib/locale/de/_lib/match.js
var matchOrdinalNumberPattern19=/^(\d+)(\.)?/i;
var parseOrdinalNumberPattern19=/\d+/i;
var matchEraPatterns19={
narrow:/^(v\.? ?Chr\.?|n\.? ?Chr\.?)/i,
abbreviated:/^(v\.? ?Chr\.?|n\.? ?Chr\.?)/i,
wide:/^(vor Christus|vor unserer Zeitrechnung|nach Christus|unserer Zeitrechnung)/i
};
var parseEraPatterns19={
any:[/^v/i,/^n/i]
};
var matchQuarterPatterns19={
narrow:/^[1234]/i,
abbreviated:/^q[1234]/i,
wide:/^[1234](\.)? Quartal/i
};
var parseQuarterPatterns19={
any:[/1/i,/2/i,/3/i,/4/i]
};
var matchMonthPatterns19={
narrow:/^[jfmasond]/i,
abbreviated:/^(j[aä]n|feb|mär[z]?|apr|mai|jun[i]?|jul[i]?|aug|sep|okt|nov|dez)\.?/i,
wide:/^(januar|februar|märz|april|mai|juni|juli|august|september|oktober|november|dezember)/i
};
var parseMonthPatterns19={
narrow:[
/^j/i,
/^f/i,
/^m/i,
/^a/i,
/^m/i,
/^j/i,
/^j/i,
/^a/i,
/^s/i,
/^o/i,
/^n/i,
/^d/i],

any:[
/^j[aä]/i,
/^f/i,
/^mär/i,
/^ap/i,
/^mai/i,
/^jun/i,
/^jul/i,
/^au/i,
/^s/i,
/^o/i,
/^n/i,
/^d/i]

};
var matchDayPatterns19={
narrow:/^[smdmf]/i,
short:/^(so|mo|di|mi|do|fr|sa)/i,
abbreviated:/^(son?|mon?|die?|mit?|don?|fre?|sam?)\.?/i,
wide:/^(sonntag|montag|dienstag|mittwoch|donnerstag|freitag|samstag)/i
};
var parseDayPatterns19={
any:[/^so/i,/^mo/i,/^di/i,/^mi/i,/^do/i,/^f/i,/^sa/i]
};
var matchDayPeriodPatterns19={
narrow:/^(vm\.?|nm\.?|Mitternacht|Mittag|morgens|nachm\.?|abends|nachts)/i,
abbreviated:/^(vorm\.?|nachm\.?|Mitternacht|Mittag|morgens|nachm\.?|abends|nachts)/i,
wide:/^(vormittags|nachmittags|Mitternacht|Mittag|morgens|nachmittags|abends|nachts)/i
};
var parseDayPeriodPatterns19={
any:{
am:/^v/i,
pm:/^n/i,
midnight:/^Mitte/i,
noon:/^Mitta/i,
morning:/morgens/i,
afternoon:/nachmittags/i,
evening:/abends/i,
night:/nachts/i
}
};
var match37={
ordinalNumber:buildMatchPatternFn({
matchPattern:matchOrdinalNumberPattern19,
parsePattern:parseOrdinalNumberPattern19,
valueCallback:function valueCallback(value){return parseInt(value);}
}),
era:buildMatchFn({
matchPatterns:matchEraPatterns19,
defaultMatchWidth:"wide",
parsePatterns:parseEraPatterns19,
defaultParseWidth:"any"
}),
quarter:buildMatchFn({
matchPatterns:matchQuarterPatterns19,
defaultMatchWidth:"wide",
parsePatterns:parseQuarterPatterns19,
defaultParseWidth:"any",
valueCallback:function valueCallback(index){return index+1;}
}),
month:buildMatchFn({
matchPatterns:matchMonthPatterns19,
defaultMatchWidth:"wide",
parsePatterns:parseMonthPatterns19,
defaultParseWidth:"any"
}),
day:buildMatchFn({
matchPatterns:matchDayPatterns19,
defaultMatchWidth:"wide",
parsePatterns:parseDayPatterns19,
defaultParseWidth:"any"
}),
dayPeriod:buildMatchFn({
matchPatterns:matchDayPeriodPatterns19,
defaultMatchWidth:"wide",
parsePatterns:parseDayPeriodPatterns19,
defaultParseWidth:"any"
})
};

// lib/locale/de.js
var _de={
code:"de",
formatDistance:formatDistance37,
formatLong:formatLong37,
formatRelative:formatRelative37,
localize:localize38,
match:match37,
options:{
weekStartsOn:1,
firstWeekContainsDate:4
}
};
// lib/locale/de-AT/_lib/localize.js
var eraValues20={
narrow:["v.Chr.","n.Chr."],
abbreviated:["v.Chr.","n.Chr."],
wide:["vor Christus","nach Christus"]
};
var quarterValues20={
narrow:["1","2","3","4"],
abbreviated:["Q1","Q2","Q3","Q4"],
wide:["1. Quartal","2. Quartal","3. Quartal","4. Quartal"]
};
var monthValues20={
narrow:["J","F","M","A","M","J","J","A","S","O","N","D"],
abbreviated:[
"J\xE4n",
"Feb",
"M\xE4r",
"Apr",
"Mai",
"Jun",
"Jul",
"Aug",
"Sep",
"Okt",
"Nov",
"Dez"],

wide:[
"J\xE4nner",
"Februar",
"M\xE4rz",
"April",
"Mai",
"Juni",
"Juli",
"August",
"September",
"Oktober",
"November",
"Dezember"]

};
var formattingMonthValues6={
narrow:monthValues20.narrow,
abbreviated:[
"J\xE4n.",
"Feb.",
"M\xE4rz",
"Apr.",
"Mai",
"Juni",
"Juli",
"Aug.",
"Sep.",
"Okt.",
"Nov.",
"Dez."],

wide:monthValues20.wide
};
var dayValues20={
narrow:["S","M","D","M","D","F","S"],
short:["So","Mo","Di","Mi","Do","Fr","Sa"],
abbreviated:["So.","Mo.","Di.","Mi.","Do.","Fr.","Sa."],
wide:[
"Sonntag",
"Montag",
"Dienstag",
"Mittwoch",
"Donnerstag",
"Freitag",
"Samstag"]

};
var dayPeriodValues20={
narrow:{
am:"vm.",
pm:"nm.",
midnight:"Mitternacht",
noon:"Mittag",
morning:"Morgen",
afternoon:"Nachm.",
evening:"Abend",
night:"Nacht"
},
abbreviated:{
am:"vorm.",
pm:"nachm.",
midnight:"Mitternacht",
noon:"Mittag",
morning:"Morgen",
afternoon:"Nachmittag",
evening:"Abend",
night:"Nacht"
},
wide:{
am:"vormittags",
pm:"nachmittags",
midnight:"Mitternacht",
noon:"Mittag",
morning:"Morgen",
afternoon:"Nachmittag",
evening:"Abend",
night:"Nacht"
}
};
var formattingDayPeriodValues19={
narrow:{
am:"vm.",
pm:"nm.",
midnight:"Mitternacht",
noon:"Mittag",
morning:"morgens",
afternoon:"nachm.",
evening:"abends",
night:"nachts"
},
abbreviated:{
am:"vorm.",
pm:"nachm.",
midnight:"Mitternacht",
noon:"Mittag",
morning:"morgens",
afternoon:"nachmittags",
evening:"abends",
night:"nachts"
},
wide:{
am:"vormittags",
pm:"nachmittags",
midnight:"Mitternacht",
noon:"Mittag",
morning:"morgens",
afternoon:"nachmittags",
evening:"abends",
night:"nachts"
}
};
var ordinalNumber20=function ordinalNumber20(dirtyNumber){
var number=Number(dirtyNumber);
return number+".";
};
var localize40={
ordinalNumber:ordinalNumber20,
era:buildLocalizeFn({
values:eraValues20,
defaultWidth:"wide"
}),
quarter:buildLocalizeFn({
values:quarterValues20,
defaultWidth:"wide",
argumentCallback:function argumentCallback(quarter){return quarter-1;}
}),
month:buildLocalizeFn({
values:monthValues20,
formattingValues:formattingMonthValues6,
defaultWidth:"wide"
}),
day:buildLocalizeFn({
values:dayValues20,
defaultWidth:"wide"
}),
dayPeriod:buildLocalizeFn({
values:dayPeriodValues20,
defaultWidth:"wide",
formattingValues:formattingDayPeriodValues19,
defaultFormattingWidth:"wide"
})
};

// lib/locale/de-AT.js
var _deAT={
code:"de-AT",
formatDistance:formatDistance37,
formatLong:formatLong37,
formatRelative:formatRelative37,
localize:localize40,
match:match37,
options:{
weekStartsOn:1,
firstWeekContainsDate:4
}
};
// lib/locale/el/_lib/formatDistance.js
var formatDistanceLocale20={
lessThanXSeconds:{
one:"\u03BB\u03B9\u03B3\u03CC\u03C4\u03B5\u03C1\u03BF \u03B1\u03C0\u03CC \u03AD\u03BD\u03B1 \u03B4\u03B5\u03C5\u03C4\u03B5\u03C1\u03CC\u03BB\u03B5\u03C0\u03C4\u03BF",
other:"\u03BB\u03B9\u03B3\u03CC\u03C4\u03B5\u03C1\u03BF \u03B1\u03C0\u03CC {{count}} \u03B4\u03B5\u03C5\u03C4\u03B5\u03C1\u03CC\u03BB\u03B5\u03C0\u03C4\u03B1"
},
xSeconds:{
one:"1 \u03B4\u03B5\u03C5\u03C4\u03B5\u03C1\u03CC\u03BB\u03B5\u03C0\u03C4\u03BF",
other:"{{count}} \u03B4\u03B5\u03C5\u03C4\u03B5\u03C1\u03CC\u03BB\u03B5\u03C0\u03C4\u03B1"
},
halfAMinute:"\u03BC\u03B9\u03C3\u03CC \u03BB\u03B5\u03C0\u03C4\u03CC",
lessThanXMinutes:{
one:"\u03BB\u03B9\u03B3\u03CC\u03C4\u03B5\u03C1\u03BF \u03B1\u03C0\u03CC \u03AD\u03BD\u03B1 \u03BB\u03B5\u03C0\u03C4\u03CC",
other:"\u03BB\u03B9\u03B3\u03CC\u03C4\u03B5\u03C1\u03BF \u03B1\u03C0\u03CC {{count}} \u03BB\u03B5\u03C0\u03C4\u03AC"
},
xMinutes:{
one:"1 \u03BB\u03B5\u03C0\u03C4\u03CC",
other:"{{count}} \u03BB\u03B5\u03C0\u03C4\u03AC"
},
aboutXHours:{
one:"\u03C0\u03B5\u03C1\u03AF\u03C0\u03BF\u03C5 1 \u03CE\u03C1\u03B1",
other:"\u03C0\u03B5\u03C1\u03AF\u03C0\u03BF\u03C5 {{count}} \u03CE\u03C1\u03B5\u03C2"
},
xHours:{
one:"1 \u03CE\u03C1\u03B1",
other:"{{count}} \u03CE\u03C1\u03B5\u03C2"
},
xDays:{
one:"1 \u03B7\u03BC\u03AD\u03C1\u03B1",
other:"{{count}} \u03B7\u03BC\u03AD\u03C1\u03B5\u03C2"
},
aboutXWeeks:{
one:"\u03C0\u03B5\u03C1\u03AF\u03C0\u03BF\u03C5 1 \u03B5\u03B2\u03B4\u03BF\u03BC\u03AC\u03B4\u03B1",
other:"\u03C0\u03B5\u03C1\u03AF\u03C0\u03BF\u03C5 {{count}} \u03B5\u03B2\u03B4\u03BF\u03BC\u03AC\u03B4\u03B5\u03C2"
},
xWeeks:{
one:"1 \u03B5\u03B2\u03B4\u03BF\u03BC\u03AC\u03B4\u03B1",
other:"{{count}} \u03B5\u03B2\u03B4\u03BF\u03BC\u03AC\u03B4\u03B5\u03C2"
},
aboutXMonths:{
one:"\u03C0\u03B5\u03C1\u03AF\u03C0\u03BF\u03C5 1 \u03BC\u03AE\u03BD\u03B1\u03C2",
other:"\u03C0\u03B5\u03C1\u03AF\u03C0\u03BF\u03C5 {{count}} \u03BC\u03AE\u03BD\u03B5\u03C2"
},
xMonths:{
one:"1 \u03BC\u03AE\u03BD\u03B1\u03C2",
other:"{{count}} \u03BC\u03AE\u03BD\u03B5\u03C2"
},
aboutXYears:{
one:"\u03C0\u03B5\u03C1\u03AF\u03C0\u03BF\u03C5 1 \u03C7\u03C1\u03CC\u03BD\u03BF",
other:"\u03C0\u03B5\u03C1\u03AF\u03C0\u03BF\u03C5 {{count}} \u03C7\u03C1\u03CC\u03BD\u03B9\u03B1"
},
xYears:{
one:"1 \u03C7\u03C1\u03CC\u03BD\u03BF",
other:"{{count}} \u03C7\u03C1\u03CC\u03BD\u03B9\u03B1"
},
overXYears:{
one:"\u03C0\u03AC\u03BD\u03C9 \u03B1\u03C0\u03CC 1 \u03C7\u03C1\u03CC\u03BD\u03BF",
other:"\u03C0\u03AC\u03BD\u03C9 \u03B1\u03C0\u03CC {{count}} \u03C7\u03C1\u03CC\u03BD\u03B9\u03B1"
},
almostXYears:{
one:"\u03C0\u03B5\u03C1\u03AF\u03C0\u03BF\u03C5 1 \u03C7\u03C1\u03CC\u03BD\u03BF",
other:"\u03C0\u03B5\u03C1\u03AF\u03C0\u03BF\u03C5 {{count}} \u03C7\u03C1\u03CC\u03BD\u03B9\u03B1"
}
};
var formatDistance40=function formatDistance40(token,count,options){
var result;
var tokenValue=formatDistanceLocale20[token];
if(typeof tokenValue==="string"){
result=tokenValue;
}else if(count===1){
result=tokenValue.one;
}else{
result=tokenValue.other.replace("{{count}}",String(count));
}
if(options!==null&&options!==void 0&&options.addSuffix){
if(options.comparison&&options.comparison>0){
return"\u03C3\u03B5 "+result;
}else{
return result+" \u03C0\u03C1\u03B9\u03BD";
}
}
return result;
};

// lib/locale/el/_lib/formatLong.js
var dateFormats20={
full:"EEEE, d MMMM y",
long:"d MMMM y",
medium:"d MMM y",
short:"d/M/yy"
};
var timeFormats20={
full:"h:mm:ss a zzzz",
long:"h:mm:ss a z",
medium:"h:mm:ss a",
short:"h:mm a"
};
var dateTimeFormats20={
full:"{{date}} - {{time}}",
long:"{{date}} - {{time}}",
medium:"{{date}}, {{time}}",
short:"{{date}}, {{time}}"
};
var formatLong40={
date:buildFormatLongFn({
formats:dateFormats20,
defaultWidth:"full"
}),
time:buildFormatLongFn({
formats:timeFormats20,
defaultWidth:"full"
}),
dateTime:buildFormatLongFn({
formats:dateTimeFormats20,
defaultWidth:"full"
})
};

// lib/locale/el/_lib/formatRelative.js
var formatRelativeLocale20={
lastWeek:function lastWeek(date){
switch(date.getDay()){
case 6:
return"'\u03C4\u03BF \u03C0\u03C1\u03BF\u03B7\u03B3\u03BF\u03CD\u03BC\u03B5\u03BD\u03BF' eeee '\u03C3\u03C4\u03B9\u03C2' p";
default:
return"'\u03C4\u03B7\u03BD \u03C0\u03C1\u03BF\u03B7\u03B3\u03BF\u03CD\u03BC\u03B5\u03BD\u03B7' eeee '\u03C3\u03C4\u03B9\u03C2' p";
}
},
yesterday:"'\u03C7\u03B8\u03B5\u03C2 \u03C3\u03C4\u03B9\u03C2' p",
today:"'\u03C3\u03AE\u03BC\u03B5\u03C1\u03B1 \u03C3\u03C4\u03B9\u03C2' p",
tomorrow:"'\u03B1\u03CD\u03C1\u03B9\u03BF \u03C3\u03C4\u03B9\u03C2' p",
nextWeek:"eeee '\u03C3\u03C4\u03B9\u03C2' p",
other:"P"
};
var formatRelative40=function formatRelative40(token,date){
var format=formatRelativeLocale20[token];
if(typeof format==="function")
return format(date);
return format;
};

// lib/locale/el/_lib/localize.js
var eraValues21={
narrow:["\u03C0\u03A7","\u03BC\u03A7"],
abbreviated:["\u03C0.\u03A7.","\u03BC.\u03A7."],
wide:["\u03C0\u03C1\u03BF \u03A7\u03C1\u03B9\u03C3\u03C4\u03BF\u03CD","\u03BC\u03B5\u03C4\u03AC \u03A7\u03C1\u03B9\u03C3\u03C4\u03CC\u03BD"]
};
var quarterValues21={
narrow:["1","2","3","4"],
abbreviated:["\u03A41","\u03A42","\u03A43","\u03A44"],
wide:["1\u03BF \u03C4\u03C1\u03AF\u03BC\u03B7\u03BD\u03BF","2\u03BF \u03C4\u03C1\u03AF\u03BC\u03B7\u03BD\u03BF","3\u03BF \u03C4\u03C1\u03AF\u03BC\u03B7\u03BD\u03BF","4\u03BF \u03C4\u03C1\u03AF\u03BC\u03B7\u03BD\u03BF"]
};
var monthValues21={
narrow:["\u0399","\u03A6","\u039C","\u0391","\u039C","\u0399","\u0399","\u0391","\u03A3","\u039F","\u039D","\u0394"],
abbreviated:[
"\u0399\u03B1\u03BD",
"\u03A6\u03B5\u03B2",
"\u039C\u03AC\u03C1",
"\u0391\u03C0\u03C1",
"\u039C\u03AC\u03B9",
"\u0399\u03BF\u03CD\u03BD",
"\u0399\u03BF\u03CD\u03BB",
"\u0391\u03CD\u03B3",
"\u03A3\u03B5\u03C0",
"\u039F\u03BA\u03C4",
"\u039D\u03BF\u03AD",
"\u0394\u03B5\u03BA"],

wide:[
"\u0399\u03B1\u03BD\u03BF\u03C5\u03AC\u03C1\u03B9\u03BF\u03C2",
"\u03A6\u03B5\u03B2\u03C1\u03BF\u03C5\u03AC\u03C1\u03B9\u03BF\u03C2",
"\u039C\u03AC\u03C1\u03C4\u03B9\u03BF\u03C2",
"\u0391\u03C0\u03C1\u03AF\u03BB\u03B9\u03BF\u03C2",
"\u039C\u03AC\u03B9\u03BF\u03C2",
"\u0399\u03BF\u03CD\u03BD\u03B9\u03BF\u03C2",
"\u0399\u03BF\u03CD\u03BB\u03B9\u03BF\u03C2",
"\u0391\u03CD\u03B3\u03BF\u03C5\u03C3\u03C4\u03BF\u03C2",
"\u03A3\u03B5\u03C0\u03C4\u03AD\u03BC\u03B2\u03C1\u03B9\u03BF\u03C2",
"\u039F\u03BA\u03C4\u03CE\u03B2\u03C1\u03B9\u03BF\u03C2",
"\u039D\u03BF\u03AD\u03BC\u03B2\u03C1\u03B9\u03BF\u03C2",
"\u0394\u03B5\u03BA\u03AD\u03BC\u03B2\u03C1\u03B9\u03BF\u03C2"]

};
var formattingMonthValues7={
narrow:["\u0399","\u03A6","\u039C","\u0391","\u039C","\u0399","\u0399","\u0391","\u03A3","\u039F","\u039D","\u0394"],
abbreviated:[
"\u0399\u03B1\u03BD",
"\u03A6\u03B5\u03B2",
"\u039C\u03B1\u03C1",
"\u0391\u03C0\u03C1",
"\u039C\u03B1\u0390",
"\u0399\u03BF\u03C5\u03BD",
"\u0399\u03BF\u03C5\u03BB",
"\u0391\u03C5\u03B3",
"\u03A3\u03B5\u03C0",
"\u039F\u03BA\u03C4",
"\u039D\u03BF\u03B5",
"\u0394\u03B5\u03BA"],

wide:[
"\u0399\u03B1\u03BD\u03BF\u03C5\u03B1\u03C1\u03AF\u03BF\u03C5",
"\u03A6\u03B5\u03B2\u03C1\u03BF\u03C5\u03B1\u03C1\u03AF\u03BF\u03C5",
"\u039C\u03B1\u03C1\u03C4\u03AF\u03BF\u03C5",
"\u0391\u03C0\u03C1\u03B9\u03BB\u03AF\u03BF\u03C5",
"\u039C\u03B1\u0390\u03BF\u03C5",
"\u0399\u03BF\u03C5\u03BD\u03AF\u03BF\u03C5",
"\u0399\u03BF\u03C5\u03BB\u03AF\u03BF\u03C5",
"\u0391\u03C5\u03B3\u03BF\u03CD\u03C3\u03C4\u03BF\u03C5",
"\u03A3\u03B5\u03C0\u03C4\u03B5\u03BC\u03B2\u03C1\u03AF\u03BF\u03C5",
"\u039F\u03BA\u03C4\u03C9\u03B2\u03C1\u03AF\u03BF\u03C5",
"\u039D\u03BF\u03B5\u03BC\u03B2\u03C1\u03AF\u03BF\u03C5",
"\u0394\u03B5\u03BA\u03B5\u03BC\u03B2\u03C1\u03AF\u03BF\u03C5"]

};
var dayValues21={
narrow:["\u039A","\u0394","T","\u03A4","\u03A0","\u03A0","\u03A3"],
short:["\u039A\u03C5","\u0394\u03B5","\u03A4\u03C1","\u03A4\u03B5","\u03A0\u03AD","\u03A0\u03B1","\u03A3\u03AC"],
abbreviated:["\u039A\u03C5\u03C1","\u0394\u03B5\u03C5","\u03A4\u03C1\u03AF","\u03A4\u03B5\u03C4","\u03A0\u03AD\u03BC","\u03A0\u03B1\u03C1","\u03A3\u03AC\u03B2"],
wide:[
"\u039A\u03C5\u03C1\u03B9\u03B1\u03BA\u03AE",
"\u0394\u03B5\u03C5\u03C4\u03AD\u03C1\u03B1",
"\u03A4\u03C1\u03AF\u03C4\u03B7",
"\u03A4\u03B5\u03C4\u03AC\u03C1\u03C4\u03B7",
"\u03A0\u03AD\u03BC\u03C0\u03C4\u03B7",
"\u03A0\u03B1\u03C1\u03B1\u03C3\u03BA\u03B5\u03C5\u03AE",
"\u03A3\u03AC\u03B2\u03B2\u03B1\u03C4\u03BF"]

};
var dayPeriodValues21={
narrow:{
am:"\u03C0\u03BC",
pm:"\u03BC\u03BC",
midnight:"\u03BC\u03B5\u03C3\u03AC\u03BD\u03C5\u03C7\u03C4\u03B1",
noon:"\u03BC\u03B5\u03C3\u03B7\u03BC\u03AD\u03C1\u03B9",
morning:"\u03C0\u03C1\u03C9\u03AF",
afternoon:"\u03B1\u03C0\u03CC\u03B3\u03B5\u03C5\u03BC\u03B1",
evening:"\u03B2\u03C1\u03AC\u03B4\u03C5",
night:"\u03BD\u03CD\u03C7\u03C4\u03B1"
},
abbreviated:{
am:"\u03C0.\u03BC.",
pm:"\u03BC.\u03BC.",
midnight:"\u03BC\u03B5\u03C3\u03AC\u03BD\u03C5\u03C7\u03C4\u03B1",
noon:"\u03BC\u03B5\u03C3\u03B7\u03BC\u03AD\u03C1\u03B9",
morning:"\u03C0\u03C1\u03C9\u03AF",
afternoon:"\u03B1\u03C0\u03CC\u03B3\u03B5\u03C5\u03BC\u03B1",
evening:"\u03B2\u03C1\u03AC\u03B4\u03C5",
night:"\u03BD\u03CD\u03C7\u03C4\u03B1"
},
wide:{
am:"\u03C0.\u03BC.",
pm:"\u03BC.\u03BC.",
midnight:"\u03BC\u03B5\u03C3\u03AC\u03BD\u03C5\u03C7\u03C4\u03B1",
noon:"\u03BC\u03B5\u03C3\u03B7\u03BC\u03AD\u03C1\u03B9",
morning:"\u03C0\u03C1\u03C9\u03AF",
afternoon:"\u03B1\u03C0\u03CC\u03B3\u03B5\u03C5\u03BC\u03B1",
evening:"\u03B2\u03C1\u03AC\u03B4\u03C5",
night:"\u03BD\u03CD\u03C7\u03C4\u03B1"
}
};
var ordinalNumber21=function ordinalNumber21(dirtyNumber,options){
var number=Number(dirtyNumber);
var unit=options===null||options===void 0?void 0:options.unit;
var suffix;
if(unit==="year"||unit==="month"){
suffix="\u03BF\u03C2";
}else if(unit==="week"||unit==="dayOfYear"||unit==="day"||unit==="hour"||unit==="date"){
suffix="\u03B7";
}else{
suffix="\u03BF";
}
return number+suffix;
};
var localize42={
ordinalNumber:ordinalNumber21,
era:buildLocalizeFn({
values:eraValues21,
defaultWidth:"wide"
}),
quarter:buildLocalizeFn({
values:quarterValues21,
defaultWidth:"wide",
argumentCallback:function argumentCallback(quarter){return quarter-1;}
}),
month:buildLocalizeFn({
values:monthValues21,
defaultWidth:"wide",
formattingValues:formattingMonthValues7,
defaultFormattingWidth:"wide"
}),
day:buildLocalizeFn({
values:dayValues21,
defaultWidth:"wide"
}),
dayPeriod:buildLocalizeFn({
values:dayPeriodValues21,
defaultWidth:"wide"
})
};

// lib/locale/el/_lib/match.js
var matchOrdinalNumberPattern20=/^(\d+)(ος|η|ο)?/i;
var parseOrdinalNumberPattern20=/\d+/i;
var matchEraPatterns20={
narrow:/^(πΧ|μΧ)/i,
abbreviated:/^(π\.?\s?χ\.?|π\.?\s?κ\.?\s?χ\.?|μ\.?\s?χ\.?|κ\.?\s?χ\.?)/i,
wide:/^(προ Χριστο(ύ|υ)|πριν απ(ό|ο) την Κοιν(ή|η) Χρονολογ(ί|ι)α|μετ(ά|α) Χριστ(ό|ο)ν|Κοιν(ή|η) Χρονολογ(ί|ι)α)/i
};
var parseEraPatterns20={
any:[/^π/i,/^(μ|κ)/i]
};
var matchQuarterPatterns20={
narrow:/^[1234]/i,
abbreviated:/^τ[1234]/i,
wide:/^[1234]ο? τρ(ί|ι)μηνο/i
};
var parseQuarterPatterns20={
any:[/1/i,/2/i,/3/i,/4/i]
};
var matchMonthPatterns20={
narrow:/^[ιφμαμιιασονδ]/i,
abbreviated:/^(ιαν|φεβ|μ[άα]ρ|απρ|μ[άα][ιΐ]|ιο[ύυ]ν|ιο[ύυ]λ|α[ύυ]γ|σεπ|οκτ|νο[έε]|δεκ)/i,
wide:/^(μ[άα][ιΐ]|α[ύυ]γο[υύ]στ)(ος|ου)|(ιανου[άα]ρ|φεβρου[άα]ρ|μ[άα]ρτ|απρ[ίι]λ|ιο[ύυ]ν|ιο[ύυ]λ|σεπτ[έε]μβρ|οκτ[ώω]βρ|νο[έε]μβρ|δεκ[έε]μβρ)(ιος|ίου)/i
};
var parseMonthPatterns20={
narrow:[
/^ι/i,
/^φ/i,
/^μ/i,
/^α/i,
/^μ/i,
/^ι/i,
/^ι/i,
/^α/i,
/^σ/i,
/^ο/i,
/^ν/i,
/^δ/i],

any:[
/^ια/i,
/^φ/i,
/^μ[άα]ρ/i,
/^απ/i,
/^μ[άα][ιΐ]/i,
/^ιο[ύυ]ν/i,
/^ιο[ύυ]λ/i,
/^α[ύυ]/i,
/^σ/i,
/^ο/i,
/^ν/i,
/^δ/i]

};
var matchDayPatterns20={
narrow:/^[κδτπσ]/i,
short:/^(κυ|δε|τρ|τε|π[εέ]|π[αά]|σ[αά])/i,
abbreviated:/^(κυρ|δευ|τρι|τετ|πεμ|παρ|σαβ)/i,
wide:/^(κυριακ(ή|η)|δευτ(έ|ε)ρα|τρ(ί|ι)τη|τετ(ά|α)ρτη|π(έ|ε)μπτη|παρασκευ(ή|η)|σ(ά|α)ββατο)/i
};
var parseDayPatterns20={
narrow:[/^κ/i,/^δ/i,/^τ/i,/^τ/i,/^π/i,/^π/i,/^σ/i],
any:[/^κ/i,/^δ/i,/^τρ/i,/^τε/i,/^π[εέ]/i,/^π[αά]/i,/^σ/i]
};
var matchDayPeriodPatterns20={
narrow:/^(πμ|μμ|μεσ(ά|α)νυχτα|μεσημ(έ|ε)ρι|πρω(ί|ι)|απ(ό|ο)γευμα|βρ(ά|α)δυ|ν(ύ|υ)χτα)/i,
any:/^([πμ]\.?\s?μ\.?|μεσ(ά|α)νυχτα|μεσημ(έ|ε)ρι|πρω(ί|ι)|απ(ό|ο)γευμα|βρ(ά|α)δυ|ν(ύ|υ)χτα)/i
};
var parseDayPeriodPatterns20={
any:{
am:/^πμ|π\.\s?μ\./i,
pm:/^μμ|μ\.\s?μ\./i,
midnight:/^μεσάν/i,
noon:/^μεσημ(έ|ε)/i,
morning:/πρω(ί|ι)/i,
afternoon:/απ(ό|ο)γευμα/i,
evening:/βρ(ά|α)δυ/i,
night:/ν(ύ|υ)χτα/i
}
};
var match40={
ordinalNumber:buildMatchPatternFn({
matchPattern:matchOrdinalNumberPattern20,
parsePattern:parseOrdinalNumberPattern20,
valueCallback:function valueCallback(value){return parseInt(value,10);}
}),
era:buildMatchFn({
matchPatterns:matchEraPatterns20,
defaultMatchWidth:"wide",
parsePatterns:parseEraPatterns20,
defaultParseWidth:"any"
}),
quarter:buildMatchFn({
matchPatterns:matchQuarterPatterns20,
defaultMatchWidth:"wide",
parsePatterns:parseQuarterPatterns20,
defaultParseWidth:"any",
valueCallback:function valueCallback(index){return index+1;}
}),
month:buildMatchFn({
matchPatterns:matchMonthPatterns20,
defaultMatchWidth:"wide",
parsePatterns:parseMonthPatterns20,
defaultParseWidth:"any"
}),
day:buildMatchFn({
matchPatterns:matchDayPatterns20,
defaultMatchWidth:"wide",
parsePatterns:parseDayPatterns20,
defaultParseWidth:"any"
}),
dayPeriod:buildMatchFn({
matchPatterns:matchDayPeriodPatterns20,
defaultMatchWidth:"any",
parsePatterns:parseDayPeriodPatterns20,
defaultParseWidth:"any"
})
};

// lib/locale/el.js
var _el={
code:"el",
formatDistance:formatDistance40,
formatLong:formatLong40,
formatRelative:formatRelative40,
localize:localize42,
match:match40,
options:{
weekStartsOn:1,
firstWeekContainsDate:4
}
};
// lib/locale/en-US/_lib/formatDistance.js
var formatDistanceLocale21={
lessThanXSeconds:{
one:"less than a second",
other:"less than {{count}} seconds"
},
xSeconds:{
one:"1 second",
other:"{{count}} seconds"
},
halfAMinute:"half a minute",
lessThanXMinutes:{
one:"less than a minute",
other:"less than {{count}} minutes"
},
xMinutes:{
one:"1 minute",
other:"{{count}} minutes"
},
aboutXHours:{
one:"about 1 hour",
other:"about {{count}} hours"
},
xHours:{
one:"1 hour",
other:"{{count}} hours"
},
xDays:{
one:"1 day",
other:"{{count}} days"
},
aboutXWeeks:{
one:"about 1 week",
other:"about {{count}} weeks"
},
xWeeks:{
one:"1 week",
other:"{{count}} weeks"
},
aboutXMonths:{
one:"about 1 month",
other:"about {{count}} months"
},
xMonths:{
one:"1 month",
other:"{{count}} months"
},
aboutXYears:{
one:"about 1 year",
other:"about {{count}} years"
},
xYears:{
one:"1 year",
other:"{{count}} years"
},
overXYears:{
one:"over 1 year",
other:"over {{count}} years"
},
almostXYears:{
one:"almost 1 year",
other:"almost {{count}} years"
}
};
var formatDistance42=function formatDistance42(token,count,options){
var result;
var tokenValue=formatDistanceLocale21[token];
if(typeof tokenValue==="string"){
result=tokenValue;
}else if(count===1){
result=tokenValue.one;
}else{
result=tokenValue.other.replace("{{count}}",count.toString());
}
if(options!==null&&options!==void 0&&options.addSuffix){
if(options.comparison&&options.comparison>0){
return"in "+result;
}else{
return result+" ago";
}
}
return result;
};

// lib/locale/en-AU/_lib/formatLong.js
var dateFormats21={
full:"EEEE, d MMMM yyyy",
long:"d MMMM yyyy",
medium:"d MMM yyyy",
short:"dd/MM/yyyy"
};
var timeFormats21={
full:"h:mm:ss a zzzz",
long:"h:mm:ss a z",
medium:"h:mm:ss a",
short:"h:mm a"
};
var dateTimeFormats21={
full:"{{date}} 'at' {{time}}",
long:"{{date}} 'at' {{time}}",
medium:"{{date}}, {{time}}",
short:"{{date}}, {{time}}"
};
var formatLong42={
date:buildFormatLongFn({
formats:dateFormats21,
defaultWidth:"full"
}),
time:buildFormatLongFn({
formats:timeFormats21,
defaultWidth:"full"
}),
dateTime:buildFormatLongFn({
formats:dateTimeFormats21,
defaultWidth:"full"
})
};

// lib/locale/en-US/_lib/formatRelative.js
var formatRelativeLocale21={
lastWeek:"'last' eeee 'at' p",
yesterday:"'yesterday at' p",
today:"'today at' p",
tomorrow:"'tomorrow at' p",
nextWeek:"eeee 'at' p",
other:"P"
};
var formatRelative42=function formatRelative42(token,_date,_baseDate,_options){return formatRelativeLocale21[token];};

// lib/locale/en-US/_lib/localize.js
var eraValues22={
narrow:["B","A"],
abbreviated:["BC","AD"],
wide:["Before Christ","Anno Domini"]
};
var quarterValues22={
narrow:["1","2","3","4"],
abbreviated:["Q1","Q2","Q3","Q4"],
wide:["1st quarter","2nd quarter","3rd quarter","4th quarter"]
};
var monthValues22={
narrow:["J","F","M","A","M","J","J","A","S","O","N","D"],
abbreviated:[
"Jan",
"Feb",
"Mar",
"Apr",
"May",
"Jun",
"Jul",
"Aug",
"Sep",
"Oct",
"Nov",
"Dec"],

wide:[
"January",
"February",
"March",
"April",
"May",
"June",
"July",
"August",
"September",
"October",
"November",
"December"]

};
var dayValues22={
narrow:["S","M","T","W","T","F","S"],
short:["Su","Mo","Tu","We","Th","Fr","Sa"],
abbreviated:["Sun","Mon","Tue","Wed","Thu","Fri","Sat"],
wide:[
"Sunday",
"Monday",
"Tuesday",
"Wednesday",
"Thursday",
"Friday",
"Saturday"]

};
var dayPeriodValues22={
narrow:{
am:"a",
pm:"p",
midnight:"mi",
noon:"n",
morning:"morning",
afternoon:"afternoon",
evening:"evening",
night:"night"
},
abbreviated:{
am:"AM",
pm:"PM",
midnight:"midnight",
noon:"noon",
morning:"morning",
afternoon:"afternoon",
evening:"evening",
night:"night"
},
wide:{
am:"a.m.",
pm:"p.m.",
midnight:"midnight",
noon:"noon",
morning:"morning",
afternoon:"afternoon",
evening:"evening",
night:"night"
}
};
var formattingDayPeriodValues20={
narrow:{
am:"a",
pm:"p",
midnight:"mi",
noon:"n",
morning:"in the morning",
afternoon:"in the afternoon",
evening:"in the evening",
night:"at night"
},
abbreviated:{
am:"AM",
pm:"PM",
midnight:"midnight",
noon:"noon",
morning:"in the morning",
afternoon:"in the afternoon",
evening:"in the evening",
night:"at night"
},
wide:{
am:"a.m.",
pm:"p.m.",
midnight:"midnight",
noon:"noon",
morning:"in the morning",
afternoon:"in the afternoon",
evening:"in the evening",
night:"at night"
}
};
var ordinalNumber22=function ordinalNumber22(dirtyNumber,_options){
var number=Number(dirtyNumber);
var rem100=number%100;
if(rem100>20||rem100<10){
switch(rem100%10){
case 1:
return number+"st";
case 2:
return number+"nd";
case 3:
return number+"rd";
}
}
return number+"th";
};
var localize44={
ordinalNumber:ordinalNumber22,
era:buildLocalizeFn({
values:eraValues22,
defaultWidth:"wide"
}),
quarter:buildLocalizeFn({
values:quarterValues22,
defaultWidth:"wide",
argumentCallback:function argumentCallback(quarter){return quarter-1;}
}),
month:buildLocalizeFn({
values:monthValues22,
defaultWidth:"wide"
}),
day:buildLocalizeFn({
values:dayValues22,
defaultWidth:"wide"
}),
dayPeriod:buildLocalizeFn({
values:dayPeriodValues22,
defaultWidth:"wide",
formattingValues:formattingDayPeriodValues20,
defaultFormattingWidth:"wide"
})
};

// lib/locale/en-US/_lib/match.js
var matchOrdinalNumberPattern21=/^(\d+)(th|st|nd|rd)?/i;
var parseOrdinalNumberPattern21=/\d+/i;
var matchEraPatterns21={
narrow:/^(b|a)/i,
abbreviated:/^(b\.?\s?c\.?|b\.?\s?c\.?\s?e\.?|a\.?\s?d\.?|c\.?\s?e\.?)/i,
wide:/^(before christ|before common era|anno domini|common era)/i
};
var parseEraPatterns21={
any:[/^b/i,/^(a|c)/i]
};
var matchQuarterPatterns21={
narrow:/^[1234]/i,
abbreviated:/^q[1234]/i,
wide:/^[1234](th|st|nd|rd)? quarter/i
};
var parseQuarterPatterns21={
any:[/1/i,/2/i,/3/i,/4/i]
};
var matchMonthPatterns21={
narrow:/^[jfmasond]/i,
abbreviated:/^(jan|feb|mar|apr|may|jun|jul|aug|sep|oct|nov|dec)/i,
wide:/^(january|february|march|april|may|june|july|august|september|october|november|december)/i
};
var parseMonthPatterns21={
narrow:[
/^j/i,
/^f/i,
/^m/i,
/^a/i,
/^m/i,
/^j/i,
/^j/i,
/^a/i,
/^s/i,
/^o/i,
/^n/i,
/^d/i],

any:[
/^ja/i,
/^f/i,
/^mar/i,
/^ap/i,
/^may/i,
/^jun/i,
/^jul/i,
/^au/i,
/^s/i,
/^o/i,
/^n/i,
/^d/i]

};
var matchDayPatterns21={
narrow:/^[smtwf]/i,
short:/^(su|mo|tu|we|th|fr|sa)/i,
abbreviated:/^(sun|mon|tue|wed|thu|fri|sat)/i,
wide:/^(sunday|monday|tuesday|wednesday|thursday|friday|saturday)/i
};
var parseDayPatterns21={
narrow:[/^s/i,/^m/i,/^t/i,/^w/i,/^t/i,/^f/i,/^s/i],
any:[/^su/i,/^m/i,/^tu/i,/^w/i,/^th/i,/^f/i,/^sa/i]
};
var matchDayPeriodPatterns21={
narrow:/^(a|p|mi|n|(in the|at) (morning|afternoon|evening|night))/i,
any:/^([ap]\.?\s?m\.?|midnight|noon|(in the|at) (morning|afternoon|evening|night))/i
};
var parseDayPeriodPatterns21={
any:{
am:/^a/i,
pm:/^p/i,
midnight:/^mi/i,
noon:/^no/i,
morning:/morning/i,
afternoon:/afternoon/i,
evening:/evening/i,
night:/night/i
}
};
var match42={
ordinalNumber:buildMatchPatternFn({
matchPattern:matchOrdinalNumberPattern21,
parsePattern:parseOrdinalNumberPattern21,
valueCallback:function valueCallback(value){return parseInt(value,10);}
}),
era:buildMatchFn({
matchPatterns:matchEraPatterns21,
defaultMatchWidth:"wide",
parsePatterns:parseEraPatterns21,
defaultParseWidth:"any"
}),
quarter:buildMatchFn({
matchPatterns:matchQuarterPatterns21,
defaultMatchWidth:"wide",
parsePatterns:parseQuarterPatterns21,
defaultParseWidth:"any",
valueCallback:function valueCallback(index){return index+1;}
}),
month:buildMatchFn({
matchPatterns:matchMonthPatterns21,
defaultMatchWidth:"wide",
parsePatterns:parseMonthPatterns21,
defaultParseWidth:"any"
}),
day:buildMatchFn({
matchPatterns:matchDayPatterns21,
defaultMatchWidth:"wide",
parsePatterns:parseDayPatterns21,
defaultParseWidth:"any"
}),
dayPeriod:buildMatchFn({
matchPatterns:matchDayPeriodPatterns21,
defaultMatchWidth:"any",
parsePatterns:parseDayPeriodPatterns21,
defaultParseWidth:"any"
})
};

// lib/locale/en-AU.js
var _enAU={
code:"en-AU",
formatDistance:formatDistance42,
formatLong:formatLong42,
formatRelative:formatRelative42,
localize:localize44,
match:match42,
options:{
weekStartsOn:1,
firstWeekContainsDate:4
}
};
// lib/locale/en-CA/_lib/formatDistance.js
var formatDistanceLocale22={
lessThanXSeconds:{
one:"less than a second",
other:"less than {{count}} seconds"
},
xSeconds:{
one:"a second",
other:"{{count}} seconds"
},
halfAMinute:"half a minute",
lessThanXMinutes:{
one:"less than a minute",
other:"less than {{count}} minutes"
},
xMinutes:{
one:"a minute",
other:"{{count}} minutes"
},
aboutXHours:{
one:"about an hour",
other:"about {{count}} hours"
},
xHours:{
one:"an hour",
other:"{{count}} hours"
},
xDays:{
one:"a day",
other:"{{count}} days"
},
aboutXWeeks:{
one:"about a week",
other:"about {{count}} weeks"
},
xWeeks:{
one:"a week",
other:"{{count}} weeks"
},
aboutXMonths:{
one:"about a month",
other:"about {{count}} months"
},
xMonths:{
one:"a month",
other:"{{count}} months"
},
aboutXYears:{
one:"about a year",
other:"about {{count}} years"
},
xYears:{
one:"a year",
other:"{{count}} years"
},
overXYears:{
one:"over a year",
other:"over {{count}} years"
},
almostXYears:{
one:"almost a year",
other:"almost {{count}} years"
}
};
var formatDistance44=function formatDistance44(token,count,options){
var result;
var tokenValue=formatDistanceLocale22[token];
if(typeof tokenValue==="string"){
result=tokenValue;
}else if(count===1){
result=tokenValue.one;
}else{
result=tokenValue.other.replace("{{count}}",count.toString());
}
if(options!==null&&options!==void 0&&options.addSuffix){
if(options.comparison&&options.comparison>0){
return"in "+result;
}else{
return result+" ago";
}
}
return result;
};

// lib/locale/en-CA/_lib/formatLong.js
var dateFormats22={
full:"EEEE, MMMM do, yyyy",
long:"MMMM do, yyyy",
medium:"MMM d, yyyy",
short:"yyyy-MM-dd"
};
var timeFormats22={
full:"h:mm:ss a zzzz",
long:"h:mm:ss a z",
medium:"h:mm:ss a",
short:"h:mm a"
};
var dateTimeFormats22={
full:"{{date}} 'at' {{time}}",
long:"{{date}} 'at' {{time}}",
medium:"{{date}}, {{time}}",
short:"{{date}}, {{time}}"
};
var formatLong44={
date:buildFormatLongFn({
formats:dateFormats22,
defaultWidth:"full"
}),
time:buildFormatLongFn({
formats:timeFormats22,
defaultWidth:"full"
}),
dateTime:buildFormatLongFn({
formats:dateTimeFormats22,
defaultWidth:"full"
})
};

// lib/locale/en-CA.js
var _enCA={
code:"en-CA",
formatDistance:formatDistance44,
formatLong:formatLong44,
formatRelative:formatRelative42,
localize:localize44,
match:match42,
options:{
weekStartsOn:0,
firstWeekContainsDate:1
}
};
// lib/locale/en-GB/_lib/formatLong.js
var dateFormats23={
full:"EEEE, d MMMM yyyy",
long:"d MMMM yyyy",
medium:"d MMM yyyy",
short:"dd/MM/yyyy"
};
var timeFormats23={
full:"HH:mm:ss zzzz",
long:"HH:mm:ss z",
medium:"HH:mm:ss",
short:"HH:mm"
};
var dateTimeFormats23={
full:"{{date}} 'at' {{time}}",
long:"{{date}} 'at' {{time}}",
medium:"{{date}}, {{time}}",
short:"{{date}}, {{time}}"
};
var formatLong46={
date:buildFormatLongFn({
formats:dateFormats23,
defaultWidth:"full"
}),
time:buildFormatLongFn({
formats:timeFormats23,
defaultWidth:"full"
}),
dateTime:buildFormatLongFn({
formats:dateTimeFormats23,
defaultWidth:"full"
})
};

// lib/locale/en-GB.js
var _enGB={
code:"en-GB",
formatDistance:formatDistance42,
formatLong:formatLong46,
formatRelative:formatRelative42,
localize:localize44,
match:match42,
options:{
weekStartsOn:1,
firstWeekContainsDate:4
}
};
// lib/locale/en-IE.js
var _enIE={
code:"en-IE",
formatDistance:formatDistance42,
formatLong:formatLong46,
formatRelative:formatRelative42,
localize:localize44,
match:match42,
options:{
weekStartsOn:1,
firstWeekContainsDate:4
}
};
// lib/locale/en-IN/_lib/formatLong.js
var dateFormats24={
full:"EEEE, d MMMM yyyy",
long:"d MMMM, yyyy",
medium:"d MMM, yyyy",
short:"dd/MM/yyyy"
};
var timeFormats24={
full:"h:mm:ss a zzzz",
long:"h:mm:ss a z",
medium:"h:mm:ss a",
short:"h:mm a"
};
var dateTimeFormats24={
full:"{{date}} 'at' {{time}}",
long:"{{date}} 'at' {{time}}",
medium:"{{date}}, {{time}}",
short:"{{date}}, {{time}}"
};
var formatLong49={
date:buildFormatLongFn({
formats:dateFormats24,
defaultWidth:"full"
}),
time:buildFormatLongFn({
formats:timeFormats24,
defaultWidth:"full"
}),
dateTime:buildFormatLongFn({
formats:dateTimeFormats24,
defaultWidth:"full"
})
};

// lib/locale/en-IN.js
var _enIN={
code:"en-IN",
formatDistance:formatDistance42,
formatLong:formatLong49,
formatRelative:formatRelative42,
localize:localize44,
match:match42,
options:{
weekStartsOn:1,
firstWeekContainsDate:4
}
};
// lib/locale/en-NZ/_lib/formatLong.js
var dateFormats25={
full:"EEEE, d MMMM yyyy",
long:"d MMMM yyyy",
medium:"d MMM yyyy",
short:"dd/MM/yyyy"
};
var timeFormats25={
full:"h:mm:ss a zzzz",
long:"h:mm:ss a z",
medium:"h:mm:ss a",
short:"h:mm a"
};
var dateTimeFormats25={
full:"{{date}} 'at' {{time}}",
long:"{{date}} 'at' {{time}}",
medium:"{{date}}, {{time}}",
short:"{{date}}, {{time}}"
};
var formatLong51={
date:buildFormatLongFn({
formats:dateFormats25,
defaultWidth:"full"
}),
time:buildFormatLongFn({
formats:timeFormats25,
defaultWidth:"full"
}),
dateTime:buildFormatLongFn({
formats:dateTimeFormats25,
defaultWidth:"full"
})
};

// lib/locale/en-NZ.js
var _enNZ={
code:"en-NZ",
formatDistance:formatDistance42,
formatLong:formatLong51,
formatRelative:formatRelative42,
localize:localize44,
match:match42,
options:{
weekStartsOn:1,
firstWeekContainsDate:4
}
};
// lib/locale/en-US/_lib/formatLong.js
var dateFormats26={
full:"EEEE, MMMM do, y",
long:"MMMM do, y",
medium:"MMM d, y",
short:"MM/dd/yyyy"
};
var timeFormats26={
full:"h:mm:ss a zzzz",
long:"h:mm:ss a z",
medium:"h:mm:ss a",
short:"h:mm a"
};
var dateTimeFormats26={
full:"{{date}} 'at' {{time}}",
long:"{{date}} 'at' {{time}}",
medium:"{{date}}, {{time}}",
short:"{{date}}, {{time}}"
};
var formatLong53={
date:buildFormatLongFn({
formats:dateFormats26,
defaultWidth:"full"
}),
time:buildFormatLongFn({
formats:timeFormats26,
defaultWidth:"full"
}),
dateTime:buildFormatLongFn({
formats:dateTimeFormats26,
defaultWidth:"full"
})
};

// lib/locale/en-US.js
var _enUS={
code:"en-US",
formatDistance:formatDistance42,
formatLong:formatLong53,
formatRelative:formatRelative42,
localize:localize44,
match:match42,
options:{
weekStartsOn:0,
firstWeekContainsDate:1
}
};
// lib/locale/en-ZA/_lib/formatLong.js
var dateFormats27={
full:"EEEE, dd MMMM yyyy",
long:"dd MMMM yyyy",
medium:"dd MMM yyyy",
short:"yyyy/MM/dd"
};
var timeFormats27={
full:"HH:mm:ss zzzz",
long:"HH:mm:ss z",
medium:"HH:mm:ss",
short:"HH:mm"
};
var dateTimeFormats27={
full:"{{date}} 'at' {{time}}",
long:"{{date}} 'at' {{time}}",
medium:"{{date}}, {{time}}",
short:"{{date}}, {{time}}"
};
var formatLong55={
date:buildFormatLongFn({
formats:dateFormats27,
defaultWidth:"full"
}),
time:buildFormatLongFn({
formats:timeFormats27,
defaultWidth:"full"
}),
dateTime:buildFormatLongFn({
formats:dateTimeFormats27,
defaultWidth:"full"
})
};

// lib/locale/en-ZA.js
var _enZA={
code:"en-ZA",
formatDistance:formatDistance42,
formatLong:formatLong55,
formatRelative:formatRelative42,
localize:localize44,
match:match42,
options:{
weekStartsOn:0,
firstWeekContainsDate:1
}
};
// lib/locale/eo/_lib/formatDistance.js
var formatDistanceLocale23={
lessThanXSeconds:{
one:"malpli ol sekundo",
other:"malpli ol {{count}} sekundoj"
},
xSeconds:{
one:"1 sekundo",
other:"{{count}} sekundoj"
},
halfAMinute:"duonminuto",
lessThanXMinutes:{
one:"malpli ol minuto",
other:"malpli ol {{count}} minutoj"
},
xMinutes:{
one:"1 minuto",
other:"{{count}} minutoj"
},
aboutXHours:{
one:"proksimume 1 horo",
other:"proksimume {{count}} horoj"
},
xHours:{
one:"1 horo",
other:"{{count}} horoj"
},
xDays:{
one:"1 tago",
other:"{{count}} tagoj"
},
aboutXMonths:{
one:"proksimume 1 monato",
other:"proksimume {{count}} monatoj"
},
xWeeks:{
one:"1 semajno",
other:"{{count}} semajnoj"
},
aboutXWeeks:{
one:"proksimume 1 semajno",
other:"proksimume {{count}} semajnoj"
},
xMonths:{
one:"1 monato",
other:"{{count}} monatoj"
},
aboutXYears:{
one:"proksimume 1 jaro",
other:"proksimume {{count}} jaroj"
},
xYears:{
one:"1 jaro",
other:"{{count}} jaroj"
},
overXYears:{
one:"pli ol 1 jaro",
other:"pli ol {{count}} jaroj"
},
almostXYears:{
one:"preska\u016D 1 jaro",
other:"preska\u016D {{count}} jaroj"
}
};
var formatDistance52=function formatDistance52(token,count,options){
var result;
var tokenValue=formatDistanceLocale23[token];
if(typeof tokenValue==="string"){
result=tokenValue;
}else if(count===1){
result=tokenValue.one;
}else{
result=tokenValue.other.replace("{{count}}",String(count));
}
if(options!==null&&options!==void 0&&options.addSuffix){
if(options!==null&&options!==void 0&&options.comparison&&options.comparison>0){
return"post "+result;
}else{
return"anta\u016D "+result;
}
}
return result;
};

// lib/locale/eo/_lib/formatLong.js
var dateFormats28={
full:"EEEE, do 'de' MMMM y",
long:"y-MMMM-dd",
medium:"y-MMM-dd",
short:"yyyy-MM-dd"
};
var timeFormats28={
full:"Ho 'horo kaj' m:ss zzzz",
long:"HH:mm:ss z",
medium:"HH:mm:ss",
short:"HH:mm"
};
var dateTimeFormats28={
any:"{{date}} {{time}}"
};
var formatLong57={
date:buildFormatLongFn({
formats:dateFormats28,
defaultWidth:"full"
}),
time:buildFormatLongFn({
formats:timeFormats28,
defaultWidth:"full"
}),
dateTime:buildFormatLongFn({
formats:dateTimeFormats28,
defaultWidth:"any"
})
};

// lib/locale/eo/_lib/formatRelative.js
var formatRelativeLocale22={
lastWeek:"'pasinta' eeee 'je' p",
yesterday:"'hiera\u016D je' p",
today:"'hodia\u016D je' p",
tomorrow:"'morga\u016D je' p",
nextWeek:"eeee 'je' p",
other:"P"
};
var formatRelative51=function formatRelative51(token,_date,_baseDate,_options){return formatRelativeLocale22[token];};

// lib/locale/eo/_lib/localize.js
var eraValues23={
narrow:["aK","pK"],
abbreviated:["a.K.E.","p.K.E."],
wide:["anta\u016D Komuna Erao","Komuna Erao"]
};
var quarterValues23={
narrow:["1","2","3","4"],
abbreviated:["K1","K2","K3","K4"],
wide:[
"1-a kvaronjaro",
"2-a kvaronjaro",
"3-a kvaronjaro",
"4-a kvaronjaro"]

};
var monthValues23={
narrow:["J","F","M","A","M","J","J","A","S","O","N","D"],
abbreviated:[
"jan",
"feb",
"mar",
"apr",
"maj",
"jun",
"jul",
"a\u016Dg",
"sep",
"okt",
"nov",
"dec"],

wide:[
"januaro",
"februaro",
"marto",
"aprilo",
"majo",
"junio",
"julio",
"a\u016Dgusto",
"septembro",
"oktobro",
"novembro",
"decembro"]

};
var dayValues23={
narrow:["D","L","M","M","\u0134","V","S"],
short:["di","lu","ma","me","\u0135a","ve","sa"],
abbreviated:["dim","lun","mar","mer","\u0135a\u016D","ven","sab"],
wide:[
"diman\u0109o",
"lundo",
"mardo",
"merkredo",
"\u0135a\u016Ddo",
"vendredo",
"sabato"]

};
var dayPeriodValues23={
narrow:{
am:"a",
pm:"p",
midnight:"noktomezo",
noon:"tagmezo",
morning:"matene",
afternoon:"posttagmeze",
evening:"vespere",
night:"nokte"
},
abbreviated:{
am:"a.t.m.",
pm:"p.t.m.",
midnight:"noktomezo",
noon:"tagmezo",
morning:"matene",
afternoon:"posttagmeze",
evening:"vespere",
night:"nokte"
},
wide:{
am:"anta\u016Dtagmeze",
pm:"posttagmeze",
midnight:"noktomezo",
noon:"tagmezo",
morning:"matene",
afternoon:"posttagmeze",
evening:"vespere",
night:"nokte"
}
};
var ordinalNumber23=function ordinalNumber23(dirtyNumber){
var number=Number(dirtyNumber);
return number+"-a";
};
var localize53={
ordinalNumber:ordinalNumber23,
era:buildLocalizeFn({
values:eraValues23,
defaultWidth:"wide"
}),
quarter:buildLocalizeFn({
values:quarterValues23,
defaultWidth:"wide",
argumentCallback:function argumentCallback(quarter){
return Number(quarter)-1;
}
}),
month:buildLocalizeFn({
values:monthValues23,
defaultWidth:"wide"
}),
day:buildLocalizeFn({
values:dayValues23,
defaultWidth:"wide"
}),
dayPeriod:buildLocalizeFn({
values:dayPeriodValues23,
defaultWidth:"wide"
})
};

// lib/locale/eo/_lib/match.js
var matchOrdinalNumberPattern22=/^(\d+)(-?a)?/i;
var parseOrdinalNumberPattern22=/\d+/i;
var matchEraPatterns22={
narrow:/^([ap]k)/i,
abbreviated:/^([ap]\.?\s?k\.?\s?e\.?)/i,
wide:/^((antaǔ |post )?komuna erao)/i
};
var parseEraPatterns22={
any:[/^a/i,/^[kp]/i]
};
var matchQuarterPatterns22={
narrow:/^[1234]/i,
abbreviated:/^k[1234]/i,
wide:/^[1234](-?a)? kvaronjaro/i
};
var parseQuarterPatterns22={
any:[/1/i,/2/i,/3/i,/4/i]
};
var matchMonthPatterns22={
narrow:/^[jfmasond]/i,
abbreviated:/^(jan|feb|mar|apr|maj|jun|jul|a(ŭ|ux|uh|u)g|sep|okt|nov|dec)/i,
wide:/^(januaro|februaro|marto|aprilo|majo|junio|julio|a(ŭ|ux|uh|u)gusto|septembro|oktobro|novembro|decembro)/i
};
var parseMonthPatterns22={
narrow:[
/^j/i,
/^f/i,
/^m/i,
/^a/i,
/^m/i,
/^j/i,
/^j/i,
/^a/i,
/^s/i,
/^o/i,
/^n/i,
/^d/i],

any:[
/^ja/i,
/^f/i,
/^mar/i,
/^ap/i,
/^maj/i,
/^jun/i,
/^jul/i,
/^a(u|ŭ)/i,
/^s/i,
/^o/i,
/^n/i,
/^d/i]

};
var matchDayPatterns22={
narrow:/^[dlmĵjvs]/i,
short:/^(di|lu|ma|me|(ĵ|jx|jh|j)a|ve|sa)/i,
abbreviated:/^(dim|lun|mar|mer|(ĵ|jx|jh|j)a(ŭ|ux|uh|u)|ven|sab)/i,
wide:/^(diman(ĉ|cx|ch|c)o|lundo|mardo|merkredo|(ĵ|jx|jh|j)a(ŭ|ux|uh|u)do|vendredo|sabato)/i
};
var parseDayPatterns22={
narrow:[/^d/i,/^l/i,/^m/i,/^m/i,/^(j|ĵ)/i,/^v/i,/^s/i],
any:[/^d/i,/^l/i,/^ma/i,/^me/i,/^(j|ĵ)/i,/^v/i,/^s/i]
};
var matchDayPeriodPatterns22={
narrow:/^([ap]|(posttagmez|noktomez|tagmez|maten|vesper|nokt)[eo])/i,
abbreviated:/^([ap][.\s]?t[.\s]?m[.\s]?|(posttagmez|noktomez|tagmez|maten|vesper|nokt)[eo])/i,
wide:/^(anta(ŭ|ux)tagmez|posttagmez|noktomez|tagmez|maten|vesper|nokt)[eo]/i
};
var parseDayPeriodPatterns22={
any:{
am:/^a/i,
pm:/^p/i,
midnight:/^noktom/i,
noon:/^t/i,
morning:/^m/i,
afternoon:/^posttagmeze/i,
evening:/^v/i,
night:/^n/i
}
};
var match51={
ordinalNumber:buildMatchPatternFn({
matchPattern:matchOrdinalNumberPattern22,
parsePattern:parseOrdinalNumberPattern22,
valueCallback:function valueCallback(value){
return parseInt(value,10);
}
}),
era:buildMatchFn({
matchPatterns:matchEraPatterns22,
defaultMatchWidth:"wide",
parsePatterns:parseEraPatterns22,
defaultParseWidth:"any"
}),
quarter:buildMatchFn({
matchPatterns:matchQuarterPatterns22,
defaultMatchWidth:"wide",
parsePatterns:parseQuarterPatterns22,
defaultParseWidth:"any",
valueCallback:function valueCallback(index){
return index+1;
}
}),
month:buildMatchFn({
matchPatterns:matchMonthPatterns22,
defaultMatchWidth:"wide",
parsePatterns:parseMonthPatterns22,
defaultParseWidth:"any"
}),
day:buildMatchFn({
matchPatterns:matchDayPatterns22,
defaultMatchWidth:"wide",
parsePatterns:parseDayPatterns22,
defaultParseWidth:"any"
}),
dayPeriod:buildMatchFn({
matchPatterns:matchDayPeriodPatterns22,
defaultMatchWidth:"wide",
parsePatterns:parseDayPeriodPatterns22,
defaultParseWidth:"any"
})
};

// lib/locale/eo.js
var _eo={
code:"eo",
formatDistance:formatDistance52,
formatLong:formatLong57,
formatRelative:formatRelative51,
localize:localize53,
match:match51,
options:{
weekStartsOn:1,
firstWeekContainsDate:4
}
};
// lib/locale/es/_lib/formatDistance.js
var formatDistanceLocale24={
lessThanXSeconds:{
one:"menos de un segundo",
other:"menos de {{count}} segundos"
},
xSeconds:{
one:"1 segundo",
other:"{{count}} segundos"
},
halfAMinute:"medio minuto",
lessThanXMinutes:{
one:"menos de un minuto",
other:"menos de {{count}} minutos"
},
xMinutes:{
one:"1 minuto",
other:"{{count}} minutos"
},
aboutXHours:{
one:"alrededor de 1 hora",
other:"alrededor de {{count}} horas"
},
xHours:{
one:"1 hora",
other:"{{count}} horas"
},
xDays:{
one:"1 d\xEDa",
other:"{{count}} d\xEDas"
},
aboutXWeeks:{
one:"alrededor de 1 semana",
other:"alrededor de {{count}} semanas"
},
xWeeks:{
one:"1 semana",
other:"{{count}} semanas"
},
aboutXMonths:{
one:"alrededor de 1 mes",
other:"alrededor de {{count}} meses"
},
xMonths:{
one:"1 mes",
other:"{{count}} meses"
},
aboutXYears:{
one:"alrededor de 1 a\xF1o",
other:"alrededor de {{count}} a\xF1os"
},
xYears:{
one:"1 a\xF1o",
other:"{{count}} a\xF1os"
},
overXYears:{
one:"m\xE1s de 1 a\xF1o",
other:"m\xE1s de {{count}} a\xF1os"
},
almostXYears:{
one:"casi 1 a\xF1o",
other:"casi {{count}} a\xF1os"
}
};
var formatDistance54=function formatDistance54(token,count,options){
var result;
var tokenValue=formatDistanceLocale24[token];
if(typeof tokenValue==="string"){
result=tokenValue;
}else if(count===1){
result=tokenValue.one;
}else{
result=tokenValue.other.replace("{{count}}",count.toString());
}
if(options!==null&&options!==void 0&&options.addSuffix){
if(options.comparison&&options.comparison>0){
return"en "+result;
}else{
return"hace "+result;
}
}
return result;
};

// lib/locale/es/_lib/formatLong.js
var dateFormats29={
full:"EEEE, d 'de' MMMM 'de' y",
long:"d 'de' MMMM 'de' y",
medium:"d MMM y",
short:"dd/MM/y"
};
var timeFormats29={
full:"HH:mm:ss zzzz",
long:"HH:mm:ss z",
medium:"HH:mm:ss",
short:"HH:mm"
};
var dateTimeFormats29={
full:"{{date}} 'a las' {{time}}",
long:"{{date}} 'a las' {{time}}",
medium:"{{date}}, {{time}}",
short:"{{date}}, {{time}}"
};
var formatLong59={
date:buildFormatLongFn({
formats:dateFormats29,
defaultWidth:"full"
}),
time:buildFormatLongFn({
formats:timeFormats29,
defaultWidth:"full"
}),
dateTime:buildFormatLongFn({
formats:dateTimeFormats29,
defaultWidth:"full"
})
};

// lib/locale/es/_lib/formatRelative.js
var formatRelativeLocale23={
lastWeek:"'el' eeee 'pasado a la' p",
yesterday:"'ayer a la' p",
today:"'hoy a la' p",
tomorrow:"'ma\xF1ana a la' p",
nextWeek:"eeee 'a la' p",
other:"P"
};
var formatRelativeLocalePlural2={
lastWeek:"'el' eeee 'pasado a las' p",
yesterday:"'ayer a las' p",
today:"'hoy a las' p",
tomorrow:"'ma\xF1ana a las' p",
nextWeek:"eeee 'a las' p",
other:"P"
};
var formatRelative53=function formatRelative53(token,date,_baseDate,_options){
if(date.getHours()!==1){
return formatRelativeLocalePlural2[token];
}else{
return formatRelativeLocale23[token];
}
};

// lib/locale/es/_lib/localize.js
var eraValues24={
narrow:["AC","DC"],
abbreviated:["AC","DC"],
wide:["antes de cristo","despu\xE9s de cristo"]
};
var quarterValues24={
narrow:["1","2","3","4"],
abbreviated:["T1","T2","T3","T4"],
wide:["1\xBA trimestre","2\xBA trimestre","3\xBA trimestre","4\xBA trimestre"]
};
var monthValues24={
narrow:["e","f","m","a","m","j","j","a","s","o","n","d"],
abbreviated:[
"ene",
"feb",
"mar",
"abr",
"may",
"jun",
"jul",
"ago",
"sep",
"oct",
"nov",
"dic"],

wide:[
"enero",
"febrero",
"marzo",
"abril",
"mayo",
"junio",
"julio",
"agosto",
"septiembre",
"octubre",
"noviembre",
"diciembre"]

};
var dayValues24={
narrow:["d","l","m","m","j","v","s"],
short:["do","lu","ma","mi","ju","vi","s\xE1"],
abbreviated:["dom","lun","mar","mi\xE9","jue","vie","s\xE1b"],
wide:[
"domingo",
"lunes",
"martes",
"mi\xE9rcoles",
"jueves",
"viernes",
"s\xE1bado"]

};
var dayPeriodValues24={
narrow:{
am:"a",
pm:"p",
midnight:"mn",
noon:"md",
morning:"ma\xF1ana",
afternoon:"tarde",
evening:"tarde",
night:"noche"
},
abbreviated:{
am:"AM",
pm:"PM",
midnight:"medianoche",
noon:"mediodia",
morning:"ma\xF1ana",
afternoon:"tarde",
evening:"tarde",
night:"noche"
},
wide:{
am:"a.m.",
pm:"p.m.",
midnight:"medianoche",
noon:"mediodia",
morning:"ma\xF1ana",
afternoon:"tarde",
evening:"tarde",
night:"noche"
}
};
var formattingDayPeriodValues21={
narrow:{
am:"a",
pm:"p",
midnight:"mn",
noon:"md",
morning:"de la ma\xF1ana",
afternoon:"de la tarde",
evening:"de la tarde",
night:"de la noche"
},
abbreviated:{
am:"AM",
pm:"PM",
midnight:"medianoche",
noon:"mediodia",
morning:"de la ma\xF1ana",
afternoon:"de la tarde",
evening:"de la tarde",
night:"de la noche"
},
wide:{
am:"a.m.",
pm:"p.m.",
midnight:"medianoche",
noon:"mediodia",
morning:"de la ma\xF1ana",
afternoon:"de la tarde",
evening:"de la tarde",
night:"de la noche"
}
};
var ordinalNumber24=function ordinalNumber24(dirtyNumber,_options){
var number=Number(dirtyNumber);
return number+"\xBA";
};
var localize55={
ordinalNumber:ordinalNumber24,
era:buildLocalizeFn({
values:eraValues24,
defaultWidth:"wide"
}),
quarter:buildLocalizeFn({
values:quarterValues24,
defaultWidth:"wide",
argumentCallback:function argumentCallback(quarter){return Number(quarter)-1;}
}),
month:buildLocalizeFn({
values:monthValues24,
defaultWidth:"wide"
}),
day:buildLocalizeFn({
values:dayValues24,
defaultWidth:"wide"
}),
dayPeriod:buildLocalizeFn({
values:dayPeriodValues24,
defaultWidth:"wide",
formattingValues:formattingDayPeriodValues21,
defaultFormattingWidth:"wide"
})
};

// lib/locale/es/_lib/match.js
var matchOrdinalNumberPattern23=/^(\d+)(º)?/i;
var parseOrdinalNumberPattern23=/\d+/i;
var matchEraPatterns23={
narrow:/^(ac|dc|a|d)/i,
abbreviated:/^(a\.?\s?c\.?|a\.?\s?e\.?\s?c\.?|d\.?\s?c\.?|e\.?\s?c\.?)/i,
wide:/^(antes de cristo|antes de la era com[uú]n|despu[eé]s de cristo|era com[uú]n)/i
};
var parseEraPatterns23={
any:[/^ac/i,/^dc/i],
wide:[
/^(antes de cristo|antes de la era com[uú]n)/i,
/^(despu[eé]s de cristo|era com[uú]n)/i]

};
var matchQuarterPatterns23={
narrow:/^[1234]/i,
abbreviated:/^T[1234]/i,
wide:/^[1234](º)? trimestre/i
};
var parseQuarterPatterns23={
any:[/1/i,/2/i,/3/i,/4/i]
};
var matchMonthPatterns23={
narrow:/^[efmajsond]/i,
abbreviated:/^(ene|feb|mar|abr|may|jun|jul|ago|sep|oct|nov|dic)/i,
wide:/^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre)/i
};
var parseMonthPatterns23={
narrow:[
/^e/i,
/^f/i,
/^m/i,
/^a/i,
/^m/i,
/^j/i,
/^j/i,
/^a/i,
/^s/i,
/^o/i,
/^n/i,
/^d/i],

any:[
/^en/i,
/^feb/i,
/^mar/i,
/^abr/i,
/^may/i,
/^jun/i,
/^jul/i,
/^ago/i,
/^sep/i,
/^oct/i,
/^nov/i,
/^dic/i]

};
var matchDayPatterns23={
narrow:/^[dlmjvs]/i,
short:/^(do|lu|ma|mi|ju|vi|s[áa])/i,
abbreviated:/^(dom|lun|mar|mi[ée]|jue|vie|s[áa]b)/i,
wide:/^(domingo|lunes|martes|mi[ée]rcoles|jueves|viernes|s[áa]bado)/i
};
var parseDayPatterns23={
narrow:[/^d/i,/^l/i,/^m/i,/^m/i,/^j/i,/^v/i,/^s/i],
any:[/^do/i,/^lu/i,/^ma/i,/^mi/i,/^ju/i,/^vi/i,/^sa/i]
};
var matchDayPeriodPatterns23={
narrow:/^(a|p|mn|md|(de la|a las) (mañana|tarde|noche))/i,
any:/^([ap]\.?\s?m\.?|medianoche|mediodia|(de la|a las) (mañana|tarde|noche))/i
};
var parseDayPeriodPatterns23={
any:{
am:/^a/i,
pm:/^p/i,
midnight:/^mn/i,
noon:/^md/i,
morning:/mañana/i,
afternoon:/tarde/i,
evening:/tarde/i,
night:/noche/i
}
};
var match53={
ordinalNumber:buildMatchPatternFn({
matchPattern:matchOrdinalNumberPattern23,
parsePattern:parseOrdinalNumberPattern23,
valueCallback:function valueCallback(value){
return parseInt(value,10);
}
}),
era:buildMatchFn({
matchPatterns:matchEraPatterns23,
defaultMatchWidth:"wide",
parsePatterns:parseEraPatterns23,
defaultParseWidth:"any"
}),
quarter:buildMatchFn({
matchPatterns:matchQuarterPatterns23,
defaultMatchWidth:"wide",
parsePatterns:parseQuarterPatterns23,
defaultParseWidth:"any",
valueCallback:function valueCallback(index){return index+1;}
}),
month:buildMatchFn({
matchPatterns:matchMonthPatterns23,
defaultMatchWidth:"wide",
parsePatterns:parseMonthPatterns23,
defaultParseWidth:"any"
}),
day:buildMatchFn({
matchPatterns:matchDayPatterns23,
defaultMatchWidth:"wide",
parsePatterns:parseDayPatterns23,
defaultParseWidth:"any"
}),
dayPeriod:buildMatchFn({
matchPatterns:matchDayPeriodPatterns23,
defaultMatchWidth:"any",
parsePatterns:parseDayPeriodPatterns23,
defaultParseWidth:"any"
})
};

// lib/locale/es.js
var _es={
code:"es",
formatDistance:formatDistance54,
formatLong:formatLong59,
formatRelative:formatRelative53,
localize:localize55,
match:match53,
options:{
weekStartsOn:1,
firstWeekContainsDate:1
}
};
// lib/locale/et/_lib/formatDistance.js
var formatDistanceLocale25={
lessThanXSeconds:{
standalone:{
one:"v\xE4hem kui \xFCks sekund",
other:"v\xE4hem kui {{count}} sekundit"
},
withPreposition:{
one:"v\xE4hem kui \xFChe sekundi",
other:"v\xE4hem kui {{count}} sekundi"
}
},
xSeconds:{
standalone:{
one:"\xFCks sekund",
other:"{{count}} sekundit"
},
withPreposition:{
one:"\xFChe sekundi",
other:"{{count}} sekundi"
}
},
halfAMinute:{
standalone:"pool minutit",
withPreposition:"poole minuti"
},
lessThanXMinutes:{
standalone:{
one:"v\xE4hem kui \xFCks minut",
other:"v\xE4hem kui {{count}} minutit"
},
withPreposition:{
one:"v\xE4hem kui \xFChe minuti",
other:"v\xE4hem kui {{count}} minuti"
}
},
xMinutes:{
standalone:{
one:"\xFCks minut",
other:"{{count}} minutit"
},
withPreposition:{
one:"\xFChe minuti",
other:"{{count}} minuti"
}
},
aboutXHours:{
standalone:{
one:"umbes \xFCks tund",
other:"umbes {{count}} tundi"
},
withPreposition:{
one:"umbes \xFChe tunni",
other:"umbes {{count}} tunni"
}
},
xHours:{
standalone:{
one:"\xFCks tund",
other:"{{count}} tundi"
},
withPreposition:{
one:"\xFChe tunni",
other:"{{count}} tunni"
}
},
xDays:{
standalone:{
one:"\xFCks p\xE4ev",
other:"{{count}} p\xE4eva"
},
withPreposition:{
one:"\xFChe p\xE4eva",
other:"{{count}} p\xE4eva"
}
},
aboutXWeeks:{
standalone:{
one:"umbes \xFCks n\xE4dal",
other:"umbes {{count}} n\xE4dalat"
},
withPreposition:{
one:"umbes \xFChe n\xE4dala",
other:"umbes {{count}} n\xE4dala"
}
},
xWeeks:{
standalone:{
one:"\xFCks n\xE4dal",
other:"{{count}} n\xE4dalat"
},
withPreposition:{
one:"\xFChe n\xE4dala",
other:"{{count}} n\xE4dala"
}
},
aboutXMonths:{
standalone:{
one:"umbes \xFCks kuu",
other:"umbes {{count}} kuud"
},
withPreposition:{
one:"umbes \xFChe kuu",
other:"umbes {{count}} kuu"
}
},
xMonths:{
standalone:{
one:"\xFCks kuu",
other:"{{count}} kuud"
},
withPreposition:{
one:"\xFChe kuu",
other:"{{count}} kuu"
}
},
aboutXYears:{
standalone:{
one:"umbes \xFCks aasta",
other:"umbes {{count}} aastat"
},
withPreposition:{
one:"umbes \xFChe aasta",
other:"umbes {{count}} aasta"
}
},
xYears:{
standalone:{
one:"\xFCks aasta",
other:"{{count}} aastat"
},
withPreposition:{
one:"\xFChe aasta",
other:"{{count}} aasta"
}
},
overXYears:{
standalone:{
one:"rohkem kui \xFCks aasta",
other:"rohkem kui {{count}} aastat"
},
withPreposition:{
one:"rohkem kui \xFChe aasta",
other:"rohkem kui {{count}} aasta"
}
},
almostXYears:{
standalone:{
one:"peaaegu \xFCks aasta",
other:"peaaegu {{count}} aastat"
},
withPreposition:{
one:"peaaegu \xFChe aasta",
other:"peaaegu {{count}} aasta"
}
}
};
var formatDistance56=function formatDistance56(token,count,options){
var usageGroup=options!==null&&options!==void 0&&options.addSuffix?formatDistanceLocale25[token].withPreposition:formatDistanceLocale25[token].standalone;
var result;
if(typeof usageGroup==="string"){
result=usageGroup;
}else if(count===1){
result=usageGroup.one;
}else{
result=usageGroup.other.replace("{{count}}",String(count));
}
if(options!==null&&options!==void 0&&options.addSuffix){
if(options.comparison&&options.comparison>0){
return result+" p\xE4rast";
}else{
return result+" eest";
}
}
return result;
};

// lib/locale/et/_lib/formatLong.js
var dateFormats30={
full:"EEEE, d. MMMM y",
long:"d. MMMM y",
medium:"d. MMM y",
short:"dd.MM.y"
};
var timeFormats30={
full:"HH:mm:ss zzzz",
long:"HH:mm:ss z",
medium:"HH:mm:ss",
short:"HH:mm"
};
var dateTimeFormats30={
full:"{{date}} 'kell' {{time}}",
long:"{{date}} 'kell' {{time}}",
medium:"{{date}}. {{time}}",
short:"{{date}}. {{time}}"
};
var formatLong61={
date:buildFormatLongFn({
formats:dateFormats30,
defaultWidth:"full"
}),
time:buildFormatLongFn({
formats:timeFormats30,
defaultWidth:"full"
}),
dateTime:buildFormatLongFn({
formats:dateTimeFormats30,
defaultWidth:"full"
})
};

// lib/locale/et/_lib/formatRelative.js
var formatRelativeLocale24={
lastWeek:"'eelmine' eeee 'kell' p",
yesterday:"'eile kell' p",
today:"'t\xE4na kell' p",
tomorrow:"'homme kell' p",
nextWeek:"'j\xE4rgmine' eeee 'kell' p",
other:"P"
};
var formatRelative55=function formatRelative55(token,_date,_baseDate,_options){return formatRelativeLocale24[token];};

// lib/locale/et/_lib/localize.js
var eraValues25={
narrow:["e.m.a","m.a.j"],
abbreviated:["e.m.a","m.a.j"],
wide:["enne meie ajaarvamist","meie ajaarvamise j\xE4rgi"]
};
var quarterValues25={
narrow:["1","2","3","4"],
abbreviated:["K1","K2","K3","K4"],
wide:["1. kvartal","2. kvartal","3. kvartal","4. kvartal"]
};
var monthValues25={
narrow:["J","V","M","A","M","J","J","A","S","O","N","D"],
abbreviated:[
"jaan",
"veebr",
"m\xE4rts",
"apr",
"mai",
"juuni",
"juuli",
"aug",
"sept",
"okt",
"nov",
"dets"],

wide:[
"jaanuar",
"veebruar",
"m\xE4rts",
"aprill",
"mai",
"juuni",
"juuli",
"august",
"september",
"oktoober",
"november",
"detsember"]

};
var dayValues25={
narrow:["P","E","T","K","N","R","L"],
short:["P","E","T","K","N","R","L"],
abbreviated:[
"p\xFChap.",
"esmasp.",
"teisip.",
"kolmap.",
"neljap.",
"reede.",
"laup."],

wide:[
"p\xFChap\xE4ev",
"esmasp\xE4ev",
"teisip\xE4ev",
"kolmap\xE4ev",
"neljap\xE4ev",
"reede",
"laup\xE4ev"]

};
var dayPeriodValues25={
narrow:{
am:"AM",
pm:"PM",
midnight:"kesk\xF6\xF6",
noon:"keskp\xE4ev",
morning:"hommik",
afternoon:"p\xE4rastl\xF5una",
evening:"\xF5htu",
night:"\xF6\xF6"
},
abbreviated:{
am:"AM",
pm:"PM",
midnight:"kesk\xF6\xF6",
noon:"keskp\xE4ev",
morning:"hommik",
afternoon:"p\xE4rastl\xF5una",
evening:"\xF5htu",
night:"\xF6\xF6"
},
wide:{
am:"AM",
pm:"PM",
midnight:"kesk\xF6\xF6",
noon:"keskp\xE4ev",
morning:"hommik",
afternoon:"p\xE4rastl\xF5una",
evening:"\xF5htu",
night:"\xF6\xF6"
}
};
var formattingDayPeriodValues22={
narrow:{
am:"AM",
pm:"PM",
midnight:"kesk\xF6\xF6l",
noon:"keskp\xE4eval",
morning:"hommikul",
afternoon:"p\xE4rastl\xF5unal",
evening:"\xF5htul",
night:"\xF6\xF6sel"
},
abbreviated:{
am:"AM",
pm:"PM",
midnight:"kesk\xF6\xF6l",
noon:"keskp\xE4eval",
morning:"hommikul",
afternoon:"p\xE4rastl\xF5unal",
evening:"\xF5htul",
night:"\xF6\xF6sel"
},
wide:{
am:"AM",
pm:"PM",
midnight:"kesk\xF6\xF6l",
noon:"keskp\xE4eval",
morning:"hommikul",
afternoon:"p\xE4rastl\xF5unal",
evening:"\xF5htul",
night:"\xF6\xF6sel"
}
};
var ordinalNumber25=function ordinalNumber25(dirtyNumber,_options){
var number=Number(dirtyNumber);
return number+".";
};
var localize57={
ordinalNumber:ordinalNumber25,
era:buildLocalizeFn({
values:eraValues25,
defaultWidth:"wide"
}),
quarter:buildLocalizeFn({
values:quarterValues25,
defaultWidth:"wide",
argumentCallback:function argumentCallback(quarter){return quarter-1;}
}),
month:buildLocalizeFn({
values:monthValues25,
defaultWidth:"wide",
formattingValues:monthValues25,
defaultFormattingWidth:"wide"
}),
day:buildLocalizeFn({
values:dayValues25,
defaultWidth:"wide",
formattingValues:dayValues25,
defaultFormattingWidth:"wide"
}),
dayPeriod:buildLocalizeFn({
values:dayPeriodValues25,
defaultWidth:"wide",
formattingValues:formattingDayPeriodValues22,
defaultFormattingWidth:"wide"
})
};

// lib/locale/et/_lib/match.js
var matchOrdinalNumberPattern24=/^\d+\./i;
var parseOrdinalNumberPattern24=/\d+/i;
var matchEraPatterns24={
narrow:/^(e\.m\.a|m\.a\.j|eKr|pKr)/i,
abbreviated:/^(e\.m\.a|m\.a\.j|eKr|pKr)/i,
wide:/^(enne meie ajaarvamist|meie ajaarvamise järgi|enne Kristust|pärast Kristust)/i
};
var parseEraPatterns24={
any:[/^e/i,/^(m|p)/i]
};
var matchQuarterPatterns24={
narrow:/^[1234]/i,
abbreviated:/^K[1234]/i,
wide:/^[1234](\.)? kvartal/i
};
var parseQuarterPatterns24={
any:[/1/i,/2/i,/3/i,/4/i]
};
var matchMonthPatterns24={
narrow:/^[jvmasond]/i,
abbreviated:/^(jaan|veebr|märts|apr|mai|juuni|juuli|aug|sept|okt|nov|dets)/i,
wide:/^(jaanuar|veebruar|märts|aprill|mai|juuni|juuli|august|september|oktoober|november|detsember)/i
};
var parseMonthPatterns24={
narrow:[
/^j/i,
/^v/i,
/^m/i,
/^a/i,
/^m/i,
/^j/i,
/^j/i,
/^a/i,
/^s/i,
/^o/i,
/^n/i,
/^d/i],

any:[
/^ja/i,
/^v/i,
/^mär/i,
/^ap/i,
/^mai/i,
/^juun/i,
/^juul/i,
/^au/i,
/^s/i,
/^o/i,
/^n/i,
/^d/i]

};
var matchDayPatterns24={
narrow:/^[petknrl]/i,
short:/^[petknrl]/i,
abbreviated:/^(püh?|esm?|tei?|kolm?|nel?|ree?|laup?)\.?/i,
wide:/^(pühapäev|esmaspäev|teisipäev|kolmapäev|neljapäev|reede|laupäev)/i
};
var parseDayPatterns24={
any:[/^p/i,/^e/i,/^t/i,/^k/i,/^n/i,/^r/i,/^l/i]
};
var matchDayPeriodPatterns24={
any:/^(am|pm|keskööl?|keskpäev(al)?|hommik(ul)?|pärastlõunal?|õhtul?|öö(sel)?)/i
};
var parseDayPeriodPatterns24={
any:{
am:/^a/i,
pm:/^p/i,
midnight:/^keskö/i,
noon:/^keskp/i,
morning:/hommik/i,
afternoon:/pärastlõuna/i,
evening:/õhtu/i,
night:/öö/i
}
};
var match55={
ordinalNumber:buildMatchPatternFn({
matchPattern:matchOrdinalNumberPattern24,
parsePattern:parseOrdinalNumberPattern24,
valueCallback:function valueCallback(value){return parseInt(value,10);}
}),
era:buildMatchFn({
matchPatterns:matchEraPatterns24,
defaultMatchWidth:"wide",
parsePatterns:parseEraPatterns24,
defaultParseWidth:"any"
}),
quarter:buildMatchFn({
matchPatterns:matchQuarterPatterns24,
defaultMatchWidth:"wide",
parsePatterns:parseQuarterPatterns24,
defaultParseWidth:"any",
valueCallback:function valueCallback(index){return index+1;}
}),
month:buildMatchFn({
matchPatterns:matchMonthPatterns24,
defaultMatchWidth:"wide",
parsePatterns:parseMonthPatterns24,
defaultParseWidth:"any"
}),
day:buildMatchFn({
matchPatterns:matchDayPatterns24,
defaultMatchWidth:"wide",
parsePatterns:parseDayPatterns24,
defaultParseWidth:"any"
}),
dayPeriod:buildMatchFn({
matchPatterns:matchDayPeriodPatterns24,
defaultMatchWidth:"any",
parsePatterns:parseDayPeriodPatterns24,
defaultParseWidth:"any"
})
};

// lib/locale/et.js
var _et={
code:"et",
formatDistance:formatDistance56,
formatLong:formatLong61,
formatRelative:formatRelative55,
localize:localize57,
match:match55,
options:{
weekStartsOn:1,
firstWeekContainsDate:4
}
};
// lib/locale/eu/_lib/formatDistance.js
var formatDistanceLocale26={
lessThanXSeconds:{
one:"segundo bat baino gutxiago",
other:"{{count}} segundo baino gutxiago"
},
xSeconds:{
one:"1 segundo",
other:"{{count}} segundo"
},
halfAMinute:"minutu erdi",
lessThanXMinutes:{
one:"minutu bat baino gutxiago",
other:"{{count}} minutu baino gutxiago"
},
xMinutes:{
one:"1 minutu",
other:"{{count}} minutu"
},
aboutXHours:{
one:"1 ordu gutxi gorabehera",
other:"{{count}} ordu gutxi gorabehera"
},
xHours:{
one:"1 ordu",
other:"{{count}} ordu"
},
xDays:{
one:"1 egun",
other:"{{count}} egun"
},
aboutXWeeks:{
one:"aste 1 inguru",
other:"{{count}} aste inguru"
},
xWeeks:{
one:"1 aste",
other:"{{count}} astean"
},
aboutXMonths:{
one:"1 hilabete gutxi gorabehera",
other:"{{count}} hilabete gutxi gorabehera"
},
xMonths:{
one:"1 hilabete",
other:"{{count}} hilabete"
},
aboutXYears:{
one:"1 urte gutxi gorabehera",
other:"{{count}} urte gutxi gorabehera"
},
xYears:{
one:"1 urte",
other:"{{count}} urte"
},
overXYears:{
one:"1 urte baino gehiago",
other:"{{count}} urte baino gehiago"
},
almostXYears:{
one:"ia 1 urte",
other:"ia {{count}} urte"
}
};
var formatDistance58=function formatDistance58(token,count,options){
var result;
var tokenValue=formatDistanceLocale26[token];
if(typeof tokenValue==="string"){
result=tokenValue;
}else if(count===1){
result=tokenValue.one;
}else{
result=tokenValue.other.replace("{{count}}",String(count));
}
if(options!==null&&options!==void 0&&options.addSuffix){
if(options.comparison&&options.comparison>0){
return"en "+result;
}else{
return"duela "+result;
}
}
return result;
};

// lib/locale/eu/_lib/formatLong.js
var dateFormats31={
full:"EEEE, y'ko' MMMM'ren' d'a' y'ren'",
long:"y'ko' MMMM'ren' d'a'",
medium:"y MMM d",
short:"yy/MM/dd"
};
var timeFormats31={
full:"HH:mm:ss zzzz",
long:"HH:mm:ss z",
medium:"HH:mm:ss",
short:"HH:mm"
};
var dateTimeFormats31={
full:"{{date}} 'tan' {{time}}",
long:"{{date}} 'tan' {{time}}",
medium:"{{date}}, {{time}}",
short:"{{date}}, {{time}}"
};
var formatLong63={
date:buildFormatLongFn({
formats:dateFormats31,
defaultWidth:"full"
}),
time:buildFormatLongFn({
formats:timeFormats31,
defaultWidth:"full"
}),
dateTime:buildFormatLongFn({
formats:dateTimeFormats31,
defaultWidth:"full"
})
};

// lib/locale/eu/_lib/formatRelative.js
var formatRelativeLocale25={
lastWeek:"'joan den' eeee, LT",
yesterday:"'atzo,' p",
today:"'gaur,' p",
tomorrow:"'bihar,' p",
nextWeek:"eeee, p",
other:"P"
};
var formatRelativeLocalePlural3={
lastWeek:"'joan den' eeee, p",
yesterday:"'atzo,' p",
today:"'gaur,' p",
tomorrow:"'bihar,' p",
nextWeek:"eeee, p",
other:"P"
};
var formatRelative57=function formatRelative57(token,date){
if(date.getHours()!==1){
return formatRelativeLocalePlural3[token];
}
return formatRelativeLocale25[token];
};

// lib/locale/eu/_lib/localize.js
var eraValues26={
narrow:["k.a.","k.o."],
abbreviated:["k.a.","k.o."],
wide:["kristo aurretik","kristo ondoren"]
};
var quarterValues26={
narrow:["1","2","3","4"],
abbreviated:["1H","2H","3H","4H"],
wide:[
"1. hiruhilekoa",
"2. hiruhilekoa",
"3. hiruhilekoa",
"4. hiruhilekoa"]

};
var monthValues26={
narrow:["u","o","m","a","m","e","u","a","i","u","a","a"],
abbreviated:[
"urt",
"ots",
"mar",
"api",
"mai",
"eka",
"uzt",
"abu",
"ira",
"urr",
"aza",
"abe"],

wide:[
"urtarrila",
"otsaila",
"martxoa",
"apirila",
"maiatza",
"ekaina",
"uztaila",
"abuztua",
"iraila",
"urria",
"azaroa",
"abendua"]

};
var dayValues26={
narrow:["i","a","a","a","o","o","l"],
short:["ig","al","as","az","og","or","lr"],
abbreviated:["iga","ast","ast","ast","ost","ost","lar"],
wide:[
"igandea",
"astelehena",
"asteartea",
"asteazkena",
"osteguna",
"ostirala",
"larunbata"]

};
var dayPeriodValues26={
narrow:{
am:"a",
pm:"p",
midnight:"ge",
noon:"eg",
morning:"goiza",
afternoon:"arratsaldea",
evening:"arratsaldea",
night:"gaua"
},
abbreviated:{
am:"AM",
pm:"PM",
midnight:"gauerdia",
noon:"eguerdia",
morning:"goiza",
afternoon:"arratsaldea",
evening:"arratsaldea",
night:"gaua"
},
wide:{
am:"a.m.",
pm:"p.m.",
midnight:"gauerdia",
noon:"eguerdia",
morning:"goiza",
afternoon:"arratsaldea",
evening:"arratsaldea",
night:"gaua"
}
};
var formattingDayPeriodValues23={
narrow:{
am:"a",
pm:"p",
midnight:"ge",
noon:"eg",
morning:"goizean",
afternoon:"arratsaldean",
evening:"arratsaldean",
night:"gauean"
},
abbreviated:{
am:"AM",
pm:"PM",
midnight:"gauerdia",
noon:"eguerdia",
morning:"goizean",
afternoon:"arratsaldean",
evening:"arratsaldean",
night:"gauean"
},
wide:{
am:"a.m.",
pm:"p.m.",
midnight:"gauerdia",
noon:"eguerdia",
morning:"goizean",
afternoon:"arratsaldean",
evening:"arratsaldean",
night:"gauean"
}
};
var ordinalNumber26=function ordinalNumber26(dirtyNumber,_options){
var number=Number(dirtyNumber);
return number+".";
};
var localize59={
ordinalNumber:ordinalNumber26,
era:buildLocalizeFn({
values:eraValues26,
defaultWidth:"wide"
}),
quarter:buildLocalizeFn({
values:quarterValues26,
defaultWidth:"wide",
argumentCallback:function argumentCallback(quarter){return quarter-1;}
}),
month:buildLocalizeFn({
values:monthValues26,
defaultWidth:"wide"
}),
day:buildLocalizeFn({
values:dayValues26,
defaultWidth:"wide"
}),
dayPeriod:buildLocalizeFn({
values:dayPeriodValues26,
defaultWidth:"wide",
formattingValues:formattingDayPeriodValues23,
defaultFormattingWidth:"wide"
})
};

// lib/locale/eu/_lib/match.js
var matchOrdinalNumberPattern25=/^(\d+)(.)?/i;
var parseOrdinalNumberPattern25=/\d+/i;
var matchEraPatterns25={
narrow:/^(k.a.|k.o.)/i,
abbreviated:/^(k.a.|k.o.)/i,
wide:/^(kristo aurretik|kristo ondoren)/i
};
var parseEraPatterns25={
narrow:[/^k.a./i,/^k.o./i],
abbreviated:[/^(k.a.)/i,/^(k.o.)/i],
wide:[/^(kristo aurretik)/i,/^(kristo ondoren)/i]
};
var matchQuarterPatterns25={
narrow:/^[1234]/i,
abbreviated:/^[1234]H/i,
wide:/^[1234](.)? hiruhilekoa/i
};
var parseQuarterPatterns25={
any:[/1/i,/2/i,/3/i,/4/i]
};
var matchMonthPatterns25={
narrow:/^[uomaei]/i,
abbreviated:/^(urt|ots|mar|api|mai|eka|uzt|abu|ira|urr|aza|abe)/i,
wide:/^(urtarrila|otsaila|martxoa|apirila|maiatza|ekaina|uztaila|abuztua|iraila|urria|azaroa|abendua)/i
};
var parseMonthPatterns25={
narrow:[
/^u/i,
/^o/i,
/^m/i,
/^a/i,
/^m/i,
/^e/i,
/^u/i,
/^a/i,
/^i/i,
/^u/i,
/^a/i,
/^a/i],

any:[
/^urt/i,
/^ots/i,
/^mar/i,
/^api/i,
/^mai/i,
/^eka/i,
/^uzt/i,
/^abu/i,
/^ira/i,
/^urr/i,
/^aza/i,
/^abe/i]

};
var matchDayPatterns25={
narrow:/^[iaol]/i,
short:/^(ig|al|as|az|og|or|lr)/i,
abbreviated:/^(iga|ast|ast|ast|ost|ost|lar)/i,
wide:/^(igandea|astelehena|asteartea|asteazkena|osteguna|ostirala|larunbata)/i
};
var parseDayPatterns25={
narrow:[/^i/i,/^a/i,/^a/i,/^a/i,/^o/i,/^o/i,/^l/i],
short:[/^ig/i,/^al/i,/^as/i,/^az/i,/^og/i,/^or/i,/^lr/i],
abbreviated:[/^iga/i,/^ast/i,/^ast/i,/^ast/i,/^ost/i,/^ost/i,/^lar/i],
wide:[
/^igandea/i,
/^astelehena/i,
/^asteartea/i,
/^asteazkena/i,
/^osteguna/i,
/^ostirala/i,
/^larunbata/i]

};
var matchDayPeriodPatterns25={
narrow:/^(a|p|ge|eg|((goiza|goizean)|arratsaldea|(gaua|gauean)))/i,
any:/^([ap]\.?\s?m\.?|gauerdia|eguerdia|((goiza|goizean)|arratsaldea|(gaua|gauean)))/i
};
var parseDayPeriodPatterns25={
narrow:{
am:/^a/i,
pm:/^p/i,
midnight:/^ge/i,
noon:/^eg/i,
morning:/goiz/i,
afternoon:/arratsaldea/i,
evening:/arratsaldea/i,
night:/gau/i
},
any:{
am:/^a/i,
pm:/^p/i,
midnight:/^gauerdia/i,
noon:/^eguerdia/i,
morning:/goiz/i,
afternoon:/arratsaldea/i,
evening:/arratsaldea/i,
night:/gau/i
}
};
var match57={
ordinalNumber:buildMatchPatternFn({
matchPattern:matchOrdinalNumberPattern25,
parsePattern:parseOrdinalNumberPattern25,
valueCallback:function valueCallback(value){return parseInt(value,10);}
}),
era:buildMatchFn({
matchPatterns:matchEraPatterns25,
defaultMatchWidth:"wide",
parsePatterns:parseEraPatterns25,
defaultParseWidth:"wide"
}),
quarter:buildMatchFn({
matchPatterns:matchQuarterPatterns25,
defaultMatchWidth:"wide",
parsePatterns:parseQuarterPatterns25,
defaultParseWidth:"any",
valueCallback:function valueCallback(index){return index+1;}
}),
month:buildMatchFn({
matchPatterns:matchMonthPatterns25,
defaultMatchWidth:"wide",
parsePatterns:parseMonthPatterns25,
defaultParseWidth:"any"
}),
day:buildMatchFn({
matchPatterns:matchDayPatterns25,
defaultMatchWidth:"wide",
parsePatterns:parseDayPatterns25,
defaultParseWidth:"wide"
}),
dayPeriod:buildMatchFn({
matchPatterns:matchDayPeriodPatterns25,
defaultMatchWidth:"any",
parsePatterns:parseDayPeriodPatterns25,
defaultParseWidth:"any"
})
};

// lib/locale/eu.js
var _eu={
code:"eu",
formatDistance:formatDistance58,
formatLong:formatLong63,
formatRelative:formatRelative57,
localize:localize59,
match:match57,
options:{
weekStartsOn:1,
firstWeekContainsDate:1
}
};
// lib/locale/fa-IR/_lib/formatDistance.js
var formatDistanceLocale27={
lessThanXSeconds:{
one:"\u06A9\u0645\u062A\u0631 \u0627\u0632 \u06CC\u06A9 \u062B\u0627\u0646\u06CC\u0647",
other:"\u06A9\u0645\u062A\u0631 \u0627\u0632 {{count}} \u062B\u0627\u0646\u06CC\u0647"
},
xSeconds:{
one:"1 \u062B\u0627\u0646\u06CC\u0647",
other:"{{count}} \u062B\u0627\u0646\u06CC\u0647"
},
halfAMinute:"\u0646\u06CC\u0645 \u062F\u0642\u06CC\u0642\u0647",
lessThanXMinutes:{
one:"\u06A9\u0645\u062A\u0631 \u0627\u0632 \u06CC\u06A9 \u062F\u0642\u06CC\u0642\u0647",
other:"\u06A9\u0645\u062A\u0631 \u0627\u0632 {{count}} \u062F\u0642\u06CC\u0642\u0647"
},
xMinutes:{
one:"1 \u062F\u0642\u06CC\u0642\u0647",
other:"{{count}} \u062F\u0642\u06CC\u0642\u0647"
},
aboutXHours:{
one:"\u062D\u062F\u0648\u062F 1 \u0633\u0627\u0639\u062A",
other:"\u062D\u062F\u0648\u062F {{count}} \u0633\u0627\u0639\u062A"
},
xHours:{
one:"1 \u0633\u0627\u0639\u062A",
other:"{{count}} \u0633\u0627\u0639\u062A"
},
xDays:{
one:"1 \u0631\u0648\u0632",
other:"{{count}} \u0631\u0648\u0632"
},
aboutXWeeks:{
one:"\u062D\u062F\u0648\u062F 1 \u0647\u0641\u062A\u0647",
other:"\u062D\u062F\u0648\u062F {{count}} \u0647\u0641\u062A\u0647"
},
xWeeks:{
one:"1 \u0647\u0641\u062A\u0647",
other:"{{count}} \u0647\u0641\u062A\u0647"
},
aboutXMonths:{
one:"\u062D\u062F\u0648\u062F 1 \u0645\u0627\u0647",
other:"\u062D\u062F\u0648\u062F {{count}} \u0645\u0627\u0647"
},
xMonths:{
one:"1 \u0645\u0627\u0647",
other:"{{count}} \u0645\u0627\u0647"
},
aboutXYears:{
one:"\u062D\u062F\u0648\u062F 1 \u0633\u0627\u0644",
other:"\u062D\u062F\u0648\u062F {{count}} \u0633\u0627\u0644"
},
xYears:{
one:"1 \u0633\u0627\u0644",
other:"{{count}} \u0633\u0627\u0644"
},
overXYears:{
one:"\u0628\u06CC\u0634\u062A\u0631 \u0627\u0632 1 \u0633\u0627\u0644",
other:"\u0628\u06CC\u0634\u062A\u0631 \u0627\u0632 {{count}} \u0633\u0627\u0644"
},
almostXYears:{
one:"\u0646\u0632\u062F\u06CC\u06A9 1 \u0633\u0627\u0644",
other:"\u0646\u0632\u062F\u06CC\u06A9 {{count}} \u0633\u0627\u0644"
}
};
var formatDistance60=function formatDistance60(token,count,options){
var result;
var tokenValue=formatDistanceLocale27[token];
if(typeof tokenValue==="string"){
result=tokenValue;
}else if(count===1){
result=tokenValue.one;
}else{
result=tokenValue.other.replace("{{count}}",String(count));
}
if(options!==null&&options!==void 0&&options.addSuffix){
if(options.comparison&&options.comparison>0){
return"\u062F\u0631 "+result;
}else{
return result+" \u0642\u0628\u0644";
}
}
return result;
};

// lib/locale/fa-IR/_lib/formatLong.js
var dateFormats32={
full:"EEEE do MMMM y",
long:"do MMMM y",
medium:"d MMM y",
short:"yyyy/MM/dd"
};
var timeFormats32={
full:"h:mm:ss a zzzz",
long:"h:mm:ss a z",
medium:"h:mm:ss a",
short:"h:mm a"
};
var dateTimeFormats32={
full:"{{date}} '\u062F\u0631' {{time}}",
long:"{{date}} '\u062F\u0631' {{time}}",
medium:"{{date}}, {{time}}",
short:"{{date}}, {{time}}"
};
var formatLong65={
date:buildFormatLongFn({
formats:dateFormats32,
defaultWidth:"full"
}),
time:buildFormatLongFn({
formats:timeFormats32,
defaultWidth:"full"
}),
dateTime:buildFormatLongFn({
formats:dateTimeFormats32,
defaultWidth:"full"
})
};

// lib/locale/fa-IR/_lib/formatRelative.js
var formatRelativeLocale26={
lastWeek:"eeee '\u06AF\u0630\u0634\u062A\u0647 \u062F\u0631' p",
yesterday:"'\u062F\u06CC\u0631\u0648\u0632 \u062F\u0631' p",
today:"'\u0627\u0645\u0631\u0648\u0632 \u062F\u0631' p",
tomorrow:"'\u0641\u0631\u062F\u0627 \u062F\u0631' p",
nextWeek:"eeee '\u062F\u0631' p",
other:"P"
};
var formatRelative59=function formatRelative59(token,_date,_baseDate,_options){return formatRelativeLocale26[token];};

// lib/locale/fa-IR/_lib/localize.js
var eraValues27={
narrow:["\u0642","\u0628"],
abbreviated:["\u0642.\u0645.","\u0628.\u0645."],
wide:["\u0642\u0628\u0644 \u0627\u0632 \u0645\u06CC\u0644\u0627\u062F","\u0628\u0639\u062F \u0627\u0632 \u0645\u06CC\u0644\u0627\u062F"]
};
var quarterValues27={
narrow:["1","2","3","4"],
abbreviated:["\u0633\u200C\u06451","\u0633\u200C\u06452","\u0633\u200C\u06453","\u0633\u200C\u06454"],
wide:["\u0633\u0647\u200C\u0645\u0627\u0647\u0647 1","\u0633\u0647\u200C\u0645\u0627\u0647\u0647 2","\u0633\u0647\u200C\u0645\u0627\u0647\u0647 3","\u0633\u0647\u200C\u0645\u0627\u0647\u0647 4"]
};
var monthValues27={
narrow:["\u0698","\u0641","\u0645","\u0622","\u0645","\u062C","\u062C","\u0622","\u0633","\u0627","\u0646","\u062F"],
abbreviated:[
"\u0698\u0627\u0646\u0640",
"\u0641\u0648\u0631",
"\u0645\u0627\u0631\u0633",
"\u0622\u067E\u0631",
"\u0645\u06CC",
"\u062C\u0648\u0646",
"\u062C\u0648\u0644\u0640",
"\u0622\u06AF\u0648",
"\u0633\u067E\u062A\u0640",
"\u0627\u06A9\u062A\u0640",
"\u0646\u0648\u0627\u0645\u0640",
"\u062F\u0633\u0627\u0645\u0640"],

wide:[
"\u0698\u0627\u0646\u0648\u06CC\u0647",
"\u0641\u0648\u0631\u06CC\u0647",
"\u0645\u0627\u0631\u0633",
"\u0622\u067E\u0631\u06CC\u0644",
"\u0645\u06CC",
"\u062C\u0648\u0646",
"\u062C\u0648\u0644\u0627\u06CC",
"\u0622\u06AF\u0648\u0633\u062A",
"\u0633\u067E\u062A\u0627\u0645\u0628\u0631",
"\u0627\u06A9\u062A\u0628\u0631",
"\u0646\u0648\u0627\u0645\u0628\u0631",
"\u062F\u0633\u0627\u0645\u0628\u0631"]

};
var dayValues27={
narrow:["\u06CC","\u062F","\u0633","\u0686","\u067E","\u062C","\u0634"],
short:["1\u0634","2\u0634","3\u0634","4\u0634","5\u0634","\u062C","\u0634"],
abbreviated:[
"\u06CC\u06A9\u0634\u0646\u0628\u0647",
"\u062F\u0648\u0634\u0646\u0628\u0647",
"\u0633\u0647\u200C\u0634\u0646\u0628\u0647",
"\u0686\u0647\u0627\u0631\u0634\u0646\u0628\u0647",
"\u067E\u0646\u062C\u0634\u0646\u0628\u0647",
"\u062C\u0645\u0639\u0647",
"\u0634\u0646\u0628\u0647"],

wide:["\u06CC\u06A9\u0634\u0646\u0628\u0647","\u062F\u0648\u0634\u0646\u0628\u0647","\u0633\u0647\u200C\u0634\u0646\u0628\u0647","\u0686\u0647\u0627\u0631\u0634\u0646\u0628\u0647","\u067E\u0646\u062C\u0634\u0646\u0628\u0647","\u062C\u0645\u0639\u0647","\u0634\u0646\u0628\u0647"]
};
var dayPeriodValues27={
narrow:{
am:"\u0642",
pm:"\u0628",
midnight:"\u0646",
noon:"\u0638",
morning:"\u0635",
afternoon:"\u0628.\u0638.",
evening:"\u0639",
night:"\u0634"
},
abbreviated:{
am:"\u0642.\u0638.",
pm:"\u0628.\u0638.",
midnight:"\u0646\u06CC\u0645\u0647\u200C\u0634\u0628",
noon:"\u0638\u0647\u0631",
morning:"\u0635\u0628\u062D",
afternoon:"\u0628\u0639\u062F\u0627\u0632\u0638\u0647\u0631",
evening:"\u0639\u0635\u0631",
night:"\u0634\u0628"
},
wide:{
am:"\u0642\u0628\u0644\u200C\u0627\u0632\u0638\u0647\u0631",
pm:"\u0628\u0639\u062F\u0627\u0632\u0638\u0647\u0631",
midnight:"\u0646\u06CC\u0645\u0647\u200C\u0634\u0628",
noon:"\u0638\u0647\u0631",
morning:"\u0635\u0628\u062D",
afternoon:"\u0628\u0639\u062F\u0627\u0632\u0638\u0647\u0631",
evening:"\u0639\u0635\u0631",
night:"\u0634\u0628"
}
};
var formattingDayPeriodValues24={
narrow:{
am:"\u0642",
pm:"\u0628",
midnight:"\u0646",
noon:"\u0638",
morning:"\u0635",
afternoon:"\u0628.\u0638.",
evening:"\u0639",
night:"\u0634"
},
abbreviated:{
am:"\u0642.\u0638.",
pm:"\u0628.\u0638.",
midnight:"\u0646\u06CC\u0645\u0647\u200C\u0634\u0628",
noon:"\u0638\u0647\u0631",
morning:"\u0635\u0628\u062D",
afternoon:"\u0628\u0639\u062F\u0627\u0632\u0638\u0647\u0631",
evening:"\u0639\u0635\u0631",
night:"\u0634\u0628"
},
wide:{
am:"\u0642\u0628\u0644\u200C\u0627\u0632\u0638\u0647\u0631",
pm:"\u0628\u0639\u062F\u0627\u0632\u0638\u0647\u0631",
midnight:"\u0646\u06CC\u0645\u0647\u200C\u0634\u0628",
noon:"\u0638\u0647\u0631",
morning:"\u0635\u0628\u062D",
afternoon:"\u0628\u0639\u062F\u0627\u0632\u0638\u0647\u0631",
evening:"\u0639\u0635\u0631",
night:"\u0634\u0628"
}
};
var ordinalNumber27=function ordinalNumber27(dirtyNumber,_options){
return String(dirtyNumber);
};
var localize61={
ordinalNumber:ordinalNumber27,
era:buildLocalizeFn({
values:eraValues27,
defaultWidth:"wide"
}),
quarter:buildLocalizeFn({
values:quarterValues27,
defaultWidth:"wide",
argumentCallback:function argumentCallback(quarter){return quarter-1;}
}),
month:buildLocalizeFn({
values:monthValues27,
defaultWidth:"wide"
}),
day:buildLocalizeFn({
values:dayValues27,
defaultWidth:"wide"
}),
dayPeriod:buildLocalizeFn({
values:dayPeriodValues27,
defaultWidth:"wide",
formattingValues:formattingDayPeriodValues24,
defaultFormattingWidth:"wide"
})
};

// lib/locale/fa-IR/_lib/match.js
var matchOrdinalNumberPattern26=/^(\d+)(th|st|nd|rd)?/i;
var parseOrdinalNumberPattern26=/\d+/i;
var matchEraPatterns26={
narrow:/^(ق|ب)/i,
abbreviated:/^(ق\.?\s?م\.?|ق\.?\s?د\.?\s?م\.?|م\.?\s?|د\.?\s?م\.?)/i,
wide:/^(قبل از میلاد|قبل از دوران مشترک|میلادی|دوران مشترک|بعد از میلاد)/i
};
var parseEraPatterns26={
any:[/^قبل/i,/^بعد/i]
};
var matchQuarterPatterns26={
narrow:/^[1234]/i,
abbreviated:/^س‌م[1234]/i,
wide:/^سه‌ماهه [1234]/i
};
var parseQuarterPatterns26={
any:[/1/i,/2/i,/3/i,/4/i]
};
var matchMonthPatterns26={
narrow:/^[جژفمآاماسند]/i,
abbreviated:/^(جنو|ژانـ|ژانویه|فوریه|فور|مارس|آوریل|آپر|مه|می|ژوئن|جون|جول|جولـ|ژوئیه|اوت|آگو|سپتمبر|سپتامبر|اکتبر|اکتوبر|نوامبر|نوامـ|دسامبر|دسامـ|دسم)/i,
wide:/^(ژانویه|جنوری|فبروری|فوریه|مارچ|مارس|آپریل|اپریل|ایپریل|آوریل|مه|می|ژوئن|جون|جولای|ژوئیه|آگست|اگست|آگوست|اوت|سپتمبر|سپتامبر|اکتبر|اکتوبر|نوامبر|نومبر|دسامبر|دسمبر)/i
};
var parseMonthPatterns26={
narrow:[
/^(ژ|ج)/i,
/^ف/i,
/^م/i,
/^(آ|ا)/i,
/^م/i,
/^(ژ|ج)/i,
/^(ج|ژ)/i,
/^(آ|ا)/i,
/^س/i,
/^ا/i,
/^ن/i,
/^د/i],

any:[
/^ژا/i,
/^ف/i,
/^ما/i,
/^آپ/i,
/^(می|مه)/i,
/^(ژوئن|جون)/i,
/^(ژوئی|جول)/i,
/^(اوت|آگ)/i,
/^س/i,
/^(اوک|اک)/i,
/^ن/i,
/^د/i]

};
var matchDayPatterns26={
narrow:/^[شیدسچپج]/i,
short:/^(ش|ج|1ش|2ش|3ش|4ش|5ش)/i,
abbreviated:/^(یکشنبه|دوشنبه|سه‌شنبه|چهارشنبه|پنج‌شنبه|جمعه|شنبه)/i,
wide:/^(یکشنبه|دوشنبه|سه‌شنبه|چهارشنبه|پنج‌شنبه|جمعه|شنبه)/i
};
var parseDayPatterns26={
narrow:[/^ی/i,/^دو/i,/^س/i,/^چ/i,/^پ/i,/^ج/i,/^ش/i],
any:[
/^(ی|1ش|یکشنبه)/i,
/^(د|2ش|دوشنبه)/i,
/^(س|3ش|سه‌شنبه)/i,
/^(چ|4ش|چهارشنبه)/i,
/^(پ|5ش|پنجشنبه)/i,
/^(ج|جمعه)/i,
/^(ش|شنبه)/i]

};
var matchDayPeriodPatterns26={
narrow:/^(ب|ق|ن|ظ|ص|ب.ظ.|ع|ش)/i,
abbreviated:/^(ق.ظ.|ب.ظ.|نیمه‌شب|ظهر|صبح|بعدازظهر|عصر|شب)/i,
wide:/^(قبل‌ازظهر|نیمه‌شب|ظهر|صبح|بعدازظهر|عصر|شب)/i
};
var parseDayPeriodPatterns26={
any:{
am:/^(ق|ق.ظ.|قبل‌ازظهر)/i,
pm:/^(ب|ب.ظ.|بعدازظهر)/i,
midnight:/^(‌نیمه‌شب|ن)/i,
noon:/^(ظ|ظهر)/i,
morning:/(ص|صبح)/i,
afternoon:/(ب|ب.ظ.|بعدازظهر)/i,
evening:/(ع|عصر)/i,
night:/(ش|شب)/i
}
};
var match59={
ordinalNumber:buildMatchPatternFn({
matchPattern:matchOrdinalNumberPattern26,
parsePattern:parseOrdinalNumberPattern26,
valueCallback:function valueCallback(value){return parseInt(value,10);}
}),
era:buildMatchFn({
matchPatterns:matchEraPatterns26,
defaultMatchWidth:"wide",
parsePatterns:parseEraPatterns26,
defaultParseWidth:"any"
}),
quarter:buildMatchFn({
matchPatterns:matchQuarterPatterns26,
defaultMatchWidth:"wide",
parsePatterns:parseQuarterPatterns26,
defaultParseWidth:"any",
valueCallback:function valueCallback(index){return index+1;}
}),
month:buildMatchFn({
matchPatterns:matchMonthPatterns26,
defaultMatchWidth:"wide",
parsePatterns:parseMonthPatterns26,
defaultParseWidth:"any"
}),
day:buildMatchFn({
matchPatterns:matchDayPatterns26,
defaultMatchWidth:"wide",
parsePatterns:parseDayPatterns26,
defaultParseWidth:"any"
}),
dayPeriod:buildMatchFn({
matchPatterns:matchDayPeriodPatterns26,
defaultMatchWidth:"wide",
parsePatterns:parseDayPeriodPatterns26,
defaultParseWidth:"any"
})
};

// lib/locale/fa-IR.js
var _faIR={
code:"fa-IR",
formatDistance:formatDistance60,
formatLong:formatLong65,
formatRelative:formatRelative59,
localize:localize61,
match:match59,
options:{
weekStartsOn:6,
firstWeekContainsDate:1
}
};
// lib/locale/fi/_lib/formatDistance.js
function futureSeconds(text){
return text.replace(/sekuntia?/,"sekunnin");
}
function futureMinutes(text){
return text.replace(/minuuttia?/,"minuutin");
}
function futureHours(text){
return text.replace(/tuntia?/,"tunnin");
}
function futureDays(text){
return text.replace(/päivää?/,"p\xE4iv\xE4n");
}
function futureWeeks(text){
return text.replace(/(viikko|viikkoa)/,"viikon");
}
function futureMonths(text){
return text.replace(/(kuukausi|kuukautta)/,"kuukauden");
}
function futureYears(text){
return text.replace(/(vuosi|vuotta)/,"vuoden");
}
var formatDistanceLocale28={
lessThanXSeconds:{
one:"alle sekunti",
other:"alle {{count}} sekuntia",
futureTense:futureSeconds
},
xSeconds:{
one:"sekunti",
other:"{{count}} sekuntia",
futureTense:futureSeconds
},
halfAMinute:{
one:"puoli minuuttia",
other:"puoli minuuttia",
futureTense:function futureTense(_text){return"puolen minuutin";}
},
lessThanXMinutes:{
one:"alle minuutti",
other:"alle {{count}} minuuttia",
futureTense:futureMinutes
},
xMinutes:{
one:"minuutti",
other:"{{count}} minuuttia",
futureTense:futureMinutes
},
aboutXHours:{
one:"noin tunti",
other:"noin {{count}} tuntia",
futureTense:futureHours
},
xHours:{
one:"tunti",
other:"{{count}} tuntia",
futureTense:futureHours
},
xDays:{
one:"p\xE4iv\xE4",
other:"{{count}} p\xE4iv\xE4\xE4",
futureTense:futureDays
},
aboutXWeeks:{
one:"noin viikko",
other:"noin {{count}} viikkoa",
futureTense:futureWeeks
},
xWeeks:{
one:"viikko",
other:"{{count}} viikkoa",
futureTense:futureWeeks
},
aboutXMonths:{
one:"noin kuukausi",
other:"noin {{count}} kuukautta",
futureTense:futureMonths
},
xMonths:{
one:"kuukausi",
other:"{{count}} kuukautta",
futureTense:futureMonths
},
aboutXYears:{
one:"noin vuosi",
other:"noin {{count}} vuotta",
futureTense:futureYears
},
xYears:{
one:"vuosi",
other:"{{count}} vuotta",
futureTense:futureYears
},
overXYears:{
one:"yli vuosi",
other:"yli {{count}} vuotta",
futureTense:futureYears
},
almostXYears:{
one:"l\xE4hes vuosi",
other:"l\xE4hes {{count}} vuotta",
futureTense:futureYears
}
};
var formatDistance62=function formatDistance62(token,count,options){
var tokenValue=formatDistanceLocale28[token];
var result=count===1?tokenValue.one:tokenValue.other.replace("{{count}}",String(count));
if(options!==null&&options!==void 0&&options.addSuffix){
if(options.comparison&&options.comparison>0){
return tokenValue.futureTense(result)+" kuluttua";
}else{
return result+" sitten";
}
}
return result;
};

// lib/locale/fi/_lib/formatLong.js
var dateFormats33={
full:"eeee d. MMMM y",
long:"d. MMMM y",
medium:"d. MMM y",
short:"d.M.y"
};
var timeFormats33={
full:"HH.mm.ss zzzz",
long:"HH.mm.ss z",
medium:"HH.mm.ss",
short:"HH.mm"
};
var dateTimeFormats33={
full:"{{date}} 'klo' {{time}}",
long:"{{date}} 'klo' {{time}}",
medium:"{{date}} {{time}}",
short:"{{date}} {{time}}"
};
var formatLong67={
date:buildFormatLongFn({
formats:dateFormats33,
defaultWidth:"full"
}),
time:buildFormatLongFn({
formats:timeFormats33,
defaultWidth:"full"
}),
dateTime:buildFormatLongFn({
formats:dateTimeFormats33,
defaultWidth:"full"
})
};

// lib/locale/fi/_lib/formatRelative.js
var formatRelativeLocale27={
lastWeek:"'viime' eeee 'klo' p",
yesterday:"'eilen klo' p",
today:"'t\xE4n\xE4\xE4n klo' p",
tomorrow:"'huomenna klo' p",
nextWeek:"'ensi' eeee 'klo' p",
other:"P"
};
var formatRelative61=function formatRelative61(token,_date,_baseDate,_options){return formatRelativeLocale27[token];};

// lib/locale/fi/_lib/localize.js
var eraValues28={
narrow:["eaa.","jaa."],
abbreviated:["eaa.","jaa."],
wide:["ennen ajanlaskun alkua","j\xE4lkeen ajanlaskun alun"]
};
var quarterValues28={
narrow:["1","2","3","4"],
abbreviated:["Q1","Q2","Q3","Q4"],
wide:["1. kvartaali","2. kvartaali","3. kvartaali","4. kvartaali"]
};
var monthValues28={
narrow:["T","H","M","H","T","K","H","E","S","L","M","J"],
abbreviated:[
"tammi",
"helmi",
"maalis",
"huhti",
"touko",
"kes\xE4",
"hein\xE4",
"elo",
"syys",
"loka",
"marras",
"joulu"],

wide:[
"tammikuu",
"helmikuu",
"maaliskuu",
"huhtikuu",
"toukokuu",
"kes\xE4kuu",
"hein\xE4kuu",
"elokuu",
"syyskuu",
"lokakuu",
"marraskuu",
"joulukuu"]

};
var formattingMonthValues8={
narrow:monthValues28.narrow,
abbreviated:monthValues28.abbreviated,
wide:[
"tammikuuta",
"helmikuuta",
"maaliskuuta",
"huhtikuuta",
"toukokuuta",
"kes\xE4kuuta",
"hein\xE4kuuta",
"elokuuta",
"syyskuuta",
"lokakuuta",
"marraskuuta",
"joulukuuta"]

};
var dayValues28={
narrow:["S","M","T","K","T","P","L"],
short:["su","ma","ti","ke","to","pe","la"],
abbreviated:["sunn.","maan.","tiis.","kesk.","torst.","perj.","la"],
wide:[
"sunnuntai",
"maanantai",
"tiistai",
"keskiviikko",
"torstai",
"perjantai",
"lauantai"]

};
var formattingDayValues={
narrow:dayValues28.narrow,
short:dayValues28.short,
abbreviated:dayValues28.abbreviated,
wide:[
"sunnuntaina",
"maanantaina",
"tiistaina",
"keskiviikkona",
"torstaina",
"perjantaina",
"lauantaina"]

};
var dayPeriodValues28={
narrow:{
am:"ap",
pm:"ip",
midnight:"keskiy\xF6",
noon:"keskip\xE4iv\xE4",
morning:"ap",
afternoon:"ip",
evening:"illalla",
night:"y\xF6ll\xE4"
},
abbreviated:{
am:"ap",
pm:"ip",
midnight:"keskiy\xF6",
noon:"keskip\xE4iv\xE4",
morning:"ap",
afternoon:"ip",
evening:"illalla",
night:"y\xF6ll\xE4"
},
wide:{
am:"ap",
pm:"ip",
midnight:"keskiy\xF6ll\xE4",
noon:"keskip\xE4iv\xE4ll\xE4",
morning:"aamup\xE4iv\xE4ll\xE4",
afternoon:"iltap\xE4iv\xE4ll\xE4",
evening:"illalla",
night:"y\xF6ll\xE4"
}
};
var ordinalNumber28=function ordinalNumber28(dirtyNumber,_options){
var number=Number(dirtyNumber);
return number+".";
};
var localize63={
ordinalNumber:ordinalNumber28,
era:buildLocalizeFn({
values:eraValues28,
defaultWidth:"wide"
}),
quarter:buildLocalizeFn({
values:quarterValues28,
defaultWidth:"wide",
argumentCallback:function argumentCallback(quarter){return quarter-1;}
}),
month:buildLocalizeFn({
values:monthValues28,
defaultWidth:"wide",
formattingValues:formattingMonthValues8,
defaultFormattingWidth:"wide"
}),
day:buildLocalizeFn({
values:dayValues28,
defaultWidth:"wide",
formattingValues:formattingDayValues,
defaultFormattingWidth:"wide"
}),
dayPeriod:buildLocalizeFn({
values:dayPeriodValues28,
defaultWidth:"wide"
})
};

// lib/locale/fi/_lib/match.js
var matchOrdinalNumberPattern27=/^(\d+)(\.)/i;
var parseOrdinalNumberPattern27=/\d+/i;
var matchEraPatterns27={
narrow:/^(e|j)/i,
abbreviated:/^(eaa.|jaa.)/i,
wide:/^(ennen ajanlaskun alkua|jälkeen ajanlaskun alun)/i
};
var parseEraPatterns27={
any:[/^e/i,/^j/i]
};
var matchQuarterPatterns27={
narrow:/^[1234]/i,
abbreviated:/^q[1234]/i,
wide:/^[1234]\.? kvartaali/i
};
var parseQuarterPatterns27={
any:[/1/i,/2/i,/3/i,/4/i]
};
var matchMonthPatterns27={
narrow:/^[thmkeslj]/i,
abbreviated:/^(tammi|helmi|maalis|huhti|touko|kesä|heinä|elo|syys|loka|marras|joulu)/i,
wide:/^(tammikuu|helmikuu|maaliskuu|huhtikuu|toukokuu|kesäkuu|heinäkuu|elokuu|syyskuu|lokakuu|marraskuu|joulukuu)(ta)?/i
};
var parseMonthPatterns27={
narrow:[
/^t/i,
/^h/i,
/^m/i,
/^h/i,
/^t/i,
/^k/i,
/^h/i,
/^e/i,
/^s/i,
/^l/i,
/^m/i,
/^j/i],

any:[
/^ta/i,
/^hel/i,
/^maa/i,
/^hu/i,
/^to/i,
/^k/i,
/^hei/i,
/^e/i,
/^s/i,
/^l/i,
/^mar/i,
/^j/i]

};
var matchDayPatterns27={
narrow:/^[smtkpl]/i,
short:/^(su|ma|ti|ke|to|pe|la)/i,
abbreviated:/^(sunn.|maan.|tiis.|kesk.|torst.|perj.|la)/i,
wide:/^(sunnuntai|maanantai|tiistai|keskiviikko|torstai|perjantai|lauantai)(na)?/i
};
var parseDayPatterns27={
narrow:[/^s/i,/^m/i,/^t/i,/^k/i,/^t/i,/^p/i,/^l/i],
any:[/^s/i,/^m/i,/^ti/i,/^k/i,/^to/i,/^p/i,/^l/i]
};
var matchDayPeriodPatterns27={
narrow:/^(ap|ip|keskiyö|keskipäivä|aamupäivällä|iltapäivällä|illalla|yöllä)/i,
any:/^(ap|ip|keskiyöllä|keskipäivällä|aamupäivällä|iltapäivällä|illalla|yöllä)/i
};
var parseDayPeriodPatterns27={
any:{
am:/^ap/i,
pm:/^ip/i,
midnight:/^keskiyö/i,
noon:/^keskipäivä/i,
morning:/aamupäivällä/i,
afternoon:/iltapäivällä/i,
evening:/illalla/i,
night:/yöllä/i
}
};
var match61={
ordinalNumber:buildMatchPatternFn({
matchPattern:matchOrdinalNumberPattern27,
parsePattern:parseOrdinalNumberPattern27,
valueCallback:function valueCallback(value){return parseInt(value,10);}
}),
era:buildMatchFn({
matchPatterns:matchEraPatterns27,
defaultMatchWidth:"wide",
parsePatterns:parseEraPatterns27,
defaultParseWidth:"any"
}),
quarter:buildMatchFn({
matchPatterns:matchQuarterPatterns27,
defaultMatchWidth:"wide",
parsePatterns:parseQuarterPatterns27,
defaultParseWidth:"any",
valueCallback:function valueCallback(index){return index+1;}
}),
month:buildMatchFn({
matchPatterns:matchMonthPatterns27,
defaultMatchWidth:"wide",
parsePatterns:parseMonthPatterns27,
defaultParseWidth:"any"
}),
day:buildMatchFn({
matchPatterns:matchDayPatterns27,
defaultMatchWidth:"wide",
parsePatterns:parseDayPatterns27,
defaultParseWidth:"any"
}),
dayPeriod:buildMatchFn({
matchPatterns:matchDayPeriodPatterns27,
defaultMatchWidth:"any",
parsePatterns:parseDayPeriodPatterns27,
defaultParseWidth:"any"
})
};

// lib/locale/fi.js
var _fi={
code:"fi",
formatDistance:formatDistance62,
formatLong:formatLong67,
formatRelative:formatRelative61,
localize:localize63,
match:match61,
options:{
weekStartsOn:1,
firstWeekContainsDate:4
}
};
// lib/locale/fr/_lib/formatDistance.js
var formatDistanceLocale29={
lessThanXSeconds:{
one:"moins d\u2019une seconde",
other:"moins de {{count}} secondes"
},
xSeconds:{
one:"1 seconde",
other:"{{count}} secondes"
},
halfAMinute:"30 secondes",
lessThanXMinutes:{
one:"moins d\u2019une minute",
other:"moins de {{count}} minutes"
},
xMinutes:{
one:"1 minute",
other:"{{count}} minutes"
},
aboutXHours:{
one:"environ 1 heure",
other:"environ {{count}} heures"
},
xHours:{
one:"1 heure",
other:"{{count}} heures"
},
xDays:{
one:"1 jour",
other:"{{count}} jours"
},
aboutXWeeks:{
one:"environ 1 semaine",
other:"environ {{count}} semaines"
},
xWeeks:{
one:"1 semaine",
other:"{{count}} semaines"
},
aboutXMonths:{
one:"environ 1 mois",
other:"environ {{count}} mois"
},
xMonths:{
one:"1 mois",
other:"{{count}} mois"
},
aboutXYears:{
one:"environ 1 an",
other:"environ {{count}} ans"
},
xYears:{
one:"1 an",
other:"{{count}} ans"
},
overXYears:{
one:"plus d\u2019un an",
other:"plus de {{count}} ans"
},
almostXYears:{
one:"presqu\u2019un an",
other:"presque {{count}} ans"
}
};
var formatDistance64=function formatDistance64(token,count,options){
var result;
var form=formatDistanceLocale29[token];
if(typeof form==="string"){
result=form;
}else if(count===1){
result=form.one;
}else{
result=form.other.replace("{{count}}",String(count));
}
if(options!==null&&options!==void 0&&options.addSuffix){
if(options.comparison&&options.comparison>0){
return"dans "+result;
}else{
return"il y a "+result;
}
}
return result;
};

// lib/locale/fr/_lib/formatLong.js
var dateFormats34={
full:"EEEE d MMMM y",
long:"d MMMM y",
medium:"d MMM y",
short:"dd/MM/y"
};
var timeFormats34={
full:"HH:mm:ss zzzz",
long:"HH:mm:ss z",
medium:"HH:mm:ss",
short:"HH:mm"
};
var dateTimeFormats34={
full:"{{date}} '\xE0' {{time}}",
long:"{{date}} '\xE0' {{time}}",
medium:"{{date}}, {{time}}",
short:"{{date}}, {{time}}"
};
var formatLong69={
date:buildFormatLongFn({
formats:dateFormats34,
defaultWidth:"full"
}),
time:buildFormatLongFn({
formats:timeFormats34,
defaultWidth:"full"
}),
dateTime:buildFormatLongFn({
formats:dateTimeFormats34,
defaultWidth:"full"
})
};

// lib/locale/fr/_lib/formatRelative.js
var formatRelativeLocale28={
lastWeek:"eeee 'dernier \xE0' p",
yesterday:"'hier \xE0' p",
today:"'aujourd\u2019hui \xE0' p",
tomorrow:"'demain \xE0' p'",
nextWeek:"eeee 'prochain \xE0' p",
other:"P"
};
var formatRelative63=function formatRelative63(token,_date,_baseDate,_options){return formatRelativeLocale28[token];};

// lib/locale/fr/_lib/localize.js
var eraValues29={
narrow:["av. J.-C","ap. J.-C"],
abbreviated:["av. J.-C","ap. J.-C"],
wide:["avant J\xE9sus-Christ","apr\xE8s J\xE9sus-Christ"]
};
var quarterValues29={
narrow:["T1","T2","T3","T4"],
abbreviated:["1er trim.","2\xE8me trim.","3\xE8me trim.","4\xE8me trim."],
wide:["1er trimestre","2\xE8me trimestre","3\xE8me trimestre","4\xE8me trimestre"]
};
var monthValues29={
narrow:["J","F","M","A","M","J","J","A","S","O","N","D"],
abbreviated:[
"janv.",
"f\xE9vr.",
"mars",
"avr.",
"mai",
"juin",
"juil.",
"ao\xFBt",
"sept.",
"oct.",
"nov.",
"d\xE9c."],

wide:[
"janvier",
"f\xE9vrier",
"mars",
"avril",
"mai",
"juin",
"juillet",
"ao\xFBt",
"septembre",
"octobre",
"novembre",
"d\xE9cembre"]

};
var dayValues29={
narrow:["D","L","M","M","J","V","S"],
short:["di","lu","ma","me","je","ve","sa"],
abbreviated:["dim.","lun.","mar.","mer.","jeu.","ven.","sam."],
wide:[
"dimanche",
"lundi",
"mardi",
"mercredi",
"jeudi",
"vendredi",
"samedi"]

};
var dayPeriodValues29={
narrow:{
am:"AM",
pm:"PM",
midnight:"minuit",
noon:"midi",
morning:"mat.",
afternoon:"ap.m.",
evening:"soir",
night:"mat."
},
abbreviated:{
am:"AM",
pm:"PM",
midnight:"minuit",
noon:"midi",
morning:"matin",
afternoon:"apr\xE8s-midi",
evening:"soir",
night:"matin"
},
wide:{
am:"AM",
pm:"PM",
midnight:"minuit",
noon:"midi",
morning:"du matin",
afternoon:"de l\u2019apr\xE8s-midi",
evening:"du soir",
night:"du matin"
}
};
var ordinalNumber29=function ordinalNumber29(dirtyNumber,options){
var number=Number(dirtyNumber);
var unit=options===null||options===void 0?void 0:options.unit;
if(number===0)
return"0";
var feminineUnits=["year","week","hour","minute","second"];
var suffix;
if(number===1){
suffix=unit&&feminineUnits.includes(unit)?"\xE8re":"er";
}else{
suffix="\xE8me";
}
return number+suffix;
};
var LONG_MONTHS_TOKENS=["MMM","MMMM"];
var localize65={
preprocessor:function preprocessor(date,parts){
if(date.getDate()===1)
return parts;
var hasLongMonthToken=parts.some(function(part){return part.isToken&&LONG_MONTHS_TOKENS.includes(part.value);});
if(!hasLongMonthToken)
return parts;
return parts.map(function(part){return part.isToken&&part.value==="do"?{isToken:true,value:"d"}:part;});
},
ordinalNumber:ordinalNumber29,
era:buildLocalizeFn({
values:eraValues29,
defaultWidth:"wide"
}),
quarter:buildLocalizeFn({
values:quarterValues29,
defaultWidth:"wide",
argumentCallback:function argumentCallback(quarter){return quarter-1;}
}),
month:buildLocalizeFn({
values:monthValues29,
defaultWidth:"wide"
}),
day:buildLocalizeFn({
values:dayValues29,
defaultWidth:"wide"
}),
dayPeriod:buildLocalizeFn({
values:dayPeriodValues29,
defaultWidth:"wide"
})
};

// lib/locale/fr/_lib/match.js
var matchOrdinalNumberPattern28=/^(\d+)(ième|ère|ème|er|e)?/i;
var parseOrdinalNumberPattern28=/\d+/i;
var matchEraPatterns28={
narrow:/^(av\.J\.C|ap\.J\.C|ap\.J\.-C)/i,
abbreviated:/^(av\.J\.-C|av\.J-C|apr\.J\.-C|apr\.J-C|ap\.J-C)/i,
wide:/^(avant Jésus-Christ|après Jésus-Christ)/i
};
var parseEraPatterns28={
any:[/^av/i,/^ap/i]
};
var matchQuarterPatterns28={
narrow:/^T?[1234]/i,
abbreviated:/^[1234](er|ème|e)? trim\.?/i,
wide:/^[1234](er|ème|e)? trimestre/i
};
var parseQuarterPatterns28={
any:[/1/i,/2/i,/3/i,/4/i]
};
var matchMonthPatterns28={
narrow:/^[jfmasond]/i,
abbreviated:/^(janv|févr|mars|avr|mai|juin|juill|juil|août|sept|oct|nov|déc)\.?/i,
wide:/^(janvier|février|mars|avril|mai|juin|juillet|août|septembre|octobre|novembre|décembre)/i
};
var parseMonthPatterns28={
narrow:[
/^j/i,
/^f/i,
/^m/i,
/^a/i,
/^m/i,
/^j/i,
/^j/i,
/^a/i,
/^s/i,
/^o/i,
/^n/i,
/^d/i],

any:[
/^ja/i,
/^f/i,
/^mar/i,
/^av/i,
/^ma/i,
/^juin/i,
/^juil/i,
/^ao/i,
/^s/i,
/^o/i,
/^n/i,
/^d/i]

};
var matchDayPatterns28={
narrow:/^[lmjvsd]/i,
short:/^(di|lu|ma|me|je|ve|sa)/i,
abbreviated:/^(dim|lun|mar|mer|jeu|ven|sam)\.?/i,
wide:/^(dimanche|lundi|mardi|mercredi|jeudi|vendredi|samedi)/i
};
var parseDayPatterns28={
narrow:[/^d/i,/^l/i,/^m/i,/^m/i,/^j/i,/^v/i,/^s/i],
any:[/^di/i,/^lu/i,/^ma/i,/^me/i,/^je/i,/^ve/i,/^sa/i]
};
var matchDayPeriodPatterns28={
narrow:/^(a|p|minuit|midi|mat\.?|ap\.?m\.?|soir|nuit)/i,
any:/^([ap]\.?\s?m\.?|du matin|de l'après[-\s]midi|du soir|de la nuit)/i
};
var parseDayPeriodPatterns28={
any:{
am:/^a/i,
pm:/^p/i,
midnight:/^min/i,
noon:/^mid/i,
morning:/mat/i,
afternoon:/ap/i,
evening:/soir/i,
night:/nuit/i
}
};
var match63={
ordinalNumber:buildMatchPatternFn({
matchPattern:matchOrdinalNumberPattern28,
parsePattern:parseOrdinalNumberPattern28,
valueCallback:function valueCallback(value){return parseInt(value);}
}),
era:buildMatchFn({
matchPatterns:matchEraPatterns28,
defaultMatchWidth:"wide",
parsePatterns:parseEraPatterns28,
defaultParseWidth:"any"
}),
quarter:buildMatchFn({
matchPatterns:matchQuarterPatterns28,
defaultMatchWidth:"wide",
parsePatterns:parseQuarterPatterns28,
defaultParseWidth:"any",
valueCallback:function valueCallback(index){return index+1;}
}),
month:buildMatchFn({
matchPatterns:matchMonthPatterns28,
defaultMatchWidth:"wide",
parsePatterns:parseMonthPatterns28,
defaultParseWidth:"any"
}),
day:buildMatchFn({
matchPatterns:matchDayPatterns28,
defaultMatchWidth:"wide",
parsePatterns:parseDayPatterns28,
defaultParseWidth:"any"
}),
dayPeriod:buildMatchFn({
matchPatterns:matchDayPeriodPatterns28,
defaultMatchWidth:"any",
parsePatterns:parseDayPeriodPatterns28,
defaultParseWidth:"any"
})
};

// lib/locale/fr.js
var _fr={
code:"fr",
formatDistance:formatDistance64,
formatLong:formatLong69,
formatRelative:formatRelative63,
localize:localize65,
match:match63,
options:{
weekStartsOn:1,
firstWeekContainsDate:4
}
};
// lib/locale/fr-CA/_lib/formatLong.js
var dateFormats35={
full:"EEEE d MMMM y",
long:"d MMMM y",
medium:"d MMM y",
short:"yy-MM-dd"
};
var timeFormats35={
full:"HH:mm:ss zzzz",
long:"HH:mm:ss z",
medium:"HH:mm:ss",
short:"HH:mm"
};
var dateTimeFormats35={
full:"{{date}} '\xE0' {{time}}",
long:"{{date}} '\xE0' {{time}}",
medium:"{{date}}, {{time}}",
short:"{{date}}, {{time}}"
};
var formatLong71={
date:buildFormatLongFn({
formats:dateFormats35,
defaultWidth:"full"
}),
time:buildFormatLongFn({
formats:timeFormats35,
defaultWidth:"full"
}),
dateTime:buildFormatLongFn({
formats:dateTimeFormats35,
defaultWidth:"full"
})
};

// lib/locale/fr-CA.js
var _frCA={
code:"fr-CA",
formatDistance:formatDistance64,
formatLong:formatLong71,
formatRelative:formatRelative63,
localize:localize65,
match:match63,
options:{
weekStartsOn:0,
firstWeekContainsDate:1
}
};
// lib/locale/fr-CH/_lib/formatLong.js
var dateFormats36={
full:"EEEE d MMMM y",
long:"d MMMM y",
medium:"d MMM y",
short:"dd.MM.y"
};
var timeFormats36={
full:"HH:mm:ss zzzz",
long:"HH:mm:ss z",
medium:"HH:mm:ss",
short:"HH:mm"
};
var dateTimeFormats36={
full:"{{date}} '\xE0' {{time}}",
long:"{{date}} '\xE0' {{time}}",
medium:"{{date}}, {{time}}",
short:"{{date}}, {{time}}"
};
var formatLong73={
date:buildFormatLongFn({
formats:dateFormats36,
defaultWidth:"full"
}),
time:buildFormatLongFn({
formats:timeFormats36,
defaultWidth:"full"
}),
dateTime:buildFormatLongFn({
formats:dateTimeFormats36,
defaultWidth:"full"
})
};

// lib/locale/fr-CH/_lib/formatRelative.js
var formatRelativeLocale29={
lastWeek:"eeee 'la semaine derni\xE8re \xE0' p",
yesterday:"'hier \xE0' p",
today:"'aujourd\u2019hui \xE0' p",
tomorrow:"'demain \xE0' p'",
nextWeek:"eeee 'la semaine prochaine \xE0' p",
other:"P"
};
var formatRelative66=function formatRelative66(token,_date,_baseDate,_options){return formatRelativeLocale29[token];};

// lib/locale/fr-CH.js
var _frCH={
code:"fr-CH",
formatDistance:formatDistance64,
formatLong:formatLong73,
formatRelative:formatRelative66,
localize:localize65,
match:match63,
options:{
weekStartsOn:1,
firstWeekContainsDate:4
}
};
// lib/locale/fy/_lib/formatDistance.js
var formatDistanceLocale30={
lessThanXSeconds:{
one:"minder as 1 sekonde",
other:"minder as {{count}} sekonden"
},
xSeconds:{
one:"1 sekonde",
other:"{{count}} sekonden"
},
halfAMinute:"oardel min\xFAt",
lessThanXMinutes:{
one:"minder as 1 min\xFAt",
other:"minder as {{count}} minuten"
},
xMinutes:{
one:"1 min\xFAt",
other:"{{count}} minuten"
},
aboutXHours:{
one:"sawat 1 oere",
other:"sawat {{count}} oere"
},
xHours:{
one:"1 oere",
other:"{{count}} oere"
},
xDays:{
one:"1 dei",
other:"{{count}} dagen"
},
aboutXWeeks:{
one:"sawat 1 wike",
other:"sawat {{count}} wiken"
},
xWeeks:{
one:"1 wike",
other:"{{count}} wiken"
},
aboutXMonths:{
one:"sawat 1 moanne",
other:"sawat {{count}} moannen"
},
xMonths:{
one:"1 moanne",
other:"{{count}} moannen"
},
aboutXYears:{
one:"sawat 1 jier",
other:"sawat {{count}} jier"
},
xYears:{
one:"1 jier",
other:"{{count}} jier"
},
overXYears:{
one:"mear as 1 jier",
other:"mear as {{count}}s jier"
},
almostXYears:{
one:"hast 1 jier",
other:"hast {{count}} jier"
}
};
var formatDistance68=function formatDistance68(token,count,options){
var result;
var tokenValue=formatDistanceLocale30[token];
if(typeof tokenValue==="string"){
result=tokenValue;
}else if(count===1){
result=tokenValue.one;
}else{
result=tokenValue.other.replace("{{count}}",String(count));
}
if(options!==null&&options!==void 0&&options.addSuffix){
if(options.comparison&&options.comparison>0){
return"oer "+result;
}else{
return result+" lyn";
}
}
return result;
};

// lib/locale/fy/_lib/formatLong.js
var dateFormats37={
full:"EEEE d MMMM y",
long:"d MMMM y",
medium:"d MMM y",
short:"dd-MM-y"
};
var timeFormats37={
full:"HH:mm:ss zzzz",
long:"HH:mm:ss z",
medium:"HH:mm:ss",
short:"HH:mm"
};
var dateTimeFormats37={
full:"{{date}} 'om' {{time}}",
long:"{{date}} 'om' {{time}}",
medium:"{{date}}, {{time}}",
short:"{{date}}, {{time}}"
};
var formatLong75={
date:buildFormatLongFn({
formats:dateFormats37,
defaultWidth:"full"
}),
time:buildFormatLongFn({
formats:timeFormats37,
defaultWidth:"full"
}),
dateTime:buildFormatLongFn({
formats:dateTimeFormats37,
defaultWidth:"full"
})
};

// lib/locale/fy/_lib/formatRelative.js
var formatRelativeLocale30={
lastWeek:"'\xF4fr\xFBne' eeee 'om' p",
yesterday:"'juster om' p",
today:"'hjoed om' p",
tomorrow:"'moarn om' p",
nextWeek:"eeee 'om' p",
other:"P"
};
var formatRelative68=function formatRelative68(token,_date,_baseDate,_options){return formatRelativeLocale30[token];};

// lib/locale/fy/_lib/localize.js
var eraValues30={
narrow:["f.K.","n.K."],
abbreviated:["f.Kr.","n.Kr."],
wide:["foar Kristus","nei Kristus"]
};
var quarterValues30={
narrow:["1","2","3","4"],
abbreviated:["K1","K2","K3","K4"],
wide:["1e fearnsjier","2e fearnsjier","3e fearnsjier","4e fearnsjier"]
};
var monthValues30={
narrow:["j","f","m","a","m","j","j","a","s","o","n","d"],
abbreviated:[
"jan.",
"feb.",
"mrt.",
"apr.",
"mai.",
"jun.",
"jul.",
"aug.",
"sep.",
"okt.",
"nov.",
"des."],

wide:[
"jannewaris",
"febrewaris",
"maart",
"april",
"maaie",
"juny",
"july",
"augustus",
"septimber",
"oktober",
"novimber",
"desimber"]

};
var dayValues30={
narrow:["s","m","t","w","t","f","s"],
short:["si","mo","ti","wo","to","fr","so"],
abbreviated:["snein","moa","tii","woa","ton","fre","sneon"],
wide:[
"snein",
"moandei",
"tiisdei",
"woansdei",
"tongersdei",
"freed",
"sneon"]

};
var dayPeriodValues30={
narrow:{
am:"AM",
pm:"PM",
midnight:"middernacht",
noon:"middei",
morning:"moarns",
afternoon:"middeis",
evening:"j\xFBns",
night:"nachts"
},
abbreviated:{
am:"AM",
pm:"PM",
midnight:"middernacht",
noon:"middei",
morning:"moarns",
afternoon:"middeis",
evening:"j\xFBns",
night:"nachts"
},
wide:{
am:"AM",
pm:"PM",
midnight:"middernacht",
noon:"middei",
morning:"moarns",
afternoon:"middeis",
evening:"j\xFBns",
night:"nachts"
}
};
var ordinalNumber30=function ordinalNumber30(dirtyNumber,_options){
var number=Number(dirtyNumber);
return number+"e";
};
var localize69={
ordinalNumber:ordinalNumber30,
era:buildLocalizeFn({
values:eraValues30,
defaultWidth:"wide"
}),
quarter:buildLocalizeFn({
values:quarterValues30,
defaultWidth:"wide",
argumentCallback:function argumentCallback(quarter){return quarter-1;}
}),
month:buildLocalizeFn({
values:monthValues30,
defaultWidth:"wide"
}),
day:buildLocalizeFn({
values:dayValues30,
defaultWidth:"wide"
}),
dayPeriod:buildLocalizeFn({
values:dayPeriodValues30,
defaultWidth:"wide"
})
};

// lib/locale/fy/_lib/match.js
var matchOrdinalNumberPattern29=/^(\d+)e?/i;
var parseOrdinalNumberPattern29=/\d+/i;
var matchEraPatterns29={
narrow:/^([fn]\.? ?K\.?)/,
abbreviated:/^([fn]\. ?Kr\.?)/,
wide:/^((foar|nei) Kristus)/
};
var parseEraPatterns29={
any:[/^f/,/^n/]
};
var matchQuarterPatterns29={
narrow:/^[1234]/i,
abbreviated:/^K[1234]/i,
wide:/^[1234]e fearnsjier/i
};
var parseQuarterPatterns29={
any:[/1/i,/2/i,/3/i,/4/i]
};
var matchMonthPatterns29={
narrow:/^[jfmasond]/i,
abbreviated:/^(jan.|feb.|mrt.|apr.|mai.|jun.|jul.|aug.|sep.|okt.|nov.|des.)/i,
wide:/^(jannewaris|febrewaris|maart|april|maaie|juny|july|augustus|septimber|oktober|novimber|desimber)/i
};
var parseMonthPatterns29={
narrow:[
/^j/i,
/^f/i,
/^m/i,
/^a/i,
/^m/i,
/^j/i,
/^j/i,
/^a/i,
/^s/i,
/^o/i,
/^n/i,
/^d/i],

any:[
/^jan/i,
/^feb/i,
/^m(r|a)/i,
/^apr/i,
/^mai/i,
/^jun/i,
/^jul/i,
/^aug/i,
/^sep/i,
/^okt/i,
/^nov/i,
/^des/i]

};
var matchDayPatterns29={
narrow:/^[smtwf]/i,
short:/^(si|mo|ti|wo|to|fr|so)/i,
abbreviated:/^(snein|moa|tii|woa|ton|fre|sneon)/i,
wide:/^(snein|moandei|tiisdei|woansdei|tongersdei|freed|sneon)/i
};
var parseDayPatterns29={
narrow:[/^s/i,/^m/i,/^t/i,/^w/i,/^t/i,/^f/i,/^s/i],
any:[/^sn/i,/^mo/i,/^ti/i,/^wo/i,/^to/i,/^fr/i,/^sn/i]
};
var matchDayPeriodPatterns29={
any:/^(am|pm|middernacht|middeis|moarns|middei|jûns|nachts)/i
};
var parseDayPeriodPatterns29={
any:{
am:/^am/i,
pm:/^pm/i,
midnight:/^middernacht/i,
noon:/^middei/i,
morning:/moarns/i,
afternoon:/^middeis/i,
evening:/jûns/i,
night:/nachts/i
}
};
var match67={
ordinalNumber:buildMatchPatternFn({
matchPattern:matchOrdinalNumberPattern29,
parsePattern:parseOrdinalNumberPattern29,
valueCallback:function valueCallback(value){return parseInt(value,10);}
}),
era:buildMatchFn({
matchPatterns:matchEraPatterns29,
defaultMatchWidth:"wide",
parsePatterns:parseEraPatterns29,
defaultParseWidth:"any"
}),
quarter:buildMatchFn({
matchPatterns:matchQuarterPatterns29,
defaultMatchWidth:"wide",
parsePatterns:parseQuarterPatterns29,
defaultParseWidth:"any",
valueCallback:function valueCallback(index){return index+1;}
}),
month:buildMatchFn({
matchPatterns:matchMonthPatterns29,
defaultMatchWidth:"wide",
parsePatterns:parseMonthPatterns29,
defaultParseWidth:"any"
}),
day:buildMatchFn({
matchPatterns:matchDayPatterns29,
defaultMatchWidth:"wide",
parsePatterns:parseDayPatterns29,
defaultParseWidth:"any"
}),
dayPeriod:buildMatchFn({
matchPatterns:matchDayPeriodPatterns29,
defaultMatchWidth:"any",
parsePatterns:parseDayPeriodPatterns29,
defaultParseWidth:"any"
})
};

// lib/locale/fy.js
var _fy={
code:"fy",
formatDistance:formatDistance68,
formatLong:formatLong75,
formatRelative:formatRelative68,
localize:localize69,
match:match67,
options:{
weekStartsOn:1,
firstWeekContainsDate:4
}
};
// lib/locale/gd/_lib/formatDistance.js
var formatDistanceLocale31={
lessThanXSeconds:{
one:"nas lugha na diog",
other:"nas lugha na {{count}} diogan"
},
xSeconds:{
one:"1 diog",
two:"2 dhiog",
twenty:"20 diog",
other:"{{count}} diogan"
},
halfAMinute:"leth mhionaid",
lessThanXMinutes:{
one:"nas lugha na mionaid",
other:"nas lugha na {{count}} mionaidean"
},
xMinutes:{
one:"1 mionaid",
two:"2 mhionaid",
twenty:"20 mionaid",
other:"{{count}} mionaidean"
},
aboutXHours:{
one:"mu uair de th\xECde",
other:"mu {{count}} uairean de th\xECde"
},
xHours:{
one:"1 uair de th\xECde",
two:"2 uair de th\xECde",
twenty:"20 uair de th\xECde",
other:"{{count}} uairean de th\xECde"
},
xDays:{
one:"1 l\xE0",
other:"{{count}} l\xE0"
},
aboutXWeeks:{
one:"mu 1 seachdain",
other:"mu {{count}} seachdainean"
},
xWeeks:{
one:"1 seachdain",
other:"{{count}} seachdainean"
},
aboutXMonths:{
one:"mu mh\xECos",
other:"mu {{count}} m\xECosan"
},
xMonths:{
one:"1 m\xECos",
other:"{{count}} m\xECosan"
},
aboutXYears:{
one:"mu bhliadhna",
other:"mu {{count}} bliadhnaichean"
},
xYears:{
one:"1 bhliadhna",
other:"{{count}} bliadhna"
},
overXYears:{
one:"c\xF2rr is bliadhna",
other:"c\xF2rr is {{count}} bliadhnaichean"
},
almostXYears:{
one:"cha mh\xF2r bliadhna",
other:"cha mh\xF2r {{count}} bliadhnaichean"
}
};
var formatDistance70=function formatDistance70(token,count,options){
var result;
var tokenValue=formatDistanceLocale31[token];
if(typeof tokenValue==="string"){
result=tokenValue;
}else if(count===1){
result=tokenValue.one;
}else if(count===2&&!!tokenValue.two){
result=tokenValue.two;
}else if(count===20&&!!tokenValue.twenty){
result=tokenValue.twenty;
}else{
result=tokenValue.other.replace("{{count}}",String(count));
}
if(options!==null&&options!==void 0&&options.addSuffix){
if(options.comparison&&options.comparison>0){
return"ann an "+result;
}else{
return"o chionn "+result;
}
}
return result;
};

// lib/locale/gd/_lib/formatLong.js
var dateFormats38={
full:"EEEE, MMMM do, y",
long:"MMMM do, y",
medium:"MMM d, y",
short:"MM/dd/yyyy"
};
var timeFormats38={
full:"h:mm:ss a zzzz",
long:"h:mm:ss a z",
medium:"h:mm:ss a",
short:"h:mm a"
};
var dateTimeFormats38={
full:"{{date}} 'aig' {{time}}",
long:"{{date}} 'aig' {{time}}",
medium:"{{date}}, {{time}}",
short:"{{date}}, {{time}}"
};
var formatLong77={
date:buildFormatLongFn({
formats:dateFormats38,
defaultWidth:"full"
}),
time:buildFormatLongFn({
formats:timeFormats38,
defaultWidth:"full"
}),
dateTime:buildFormatLongFn({
formats:dateTimeFormats38,
defaultWidth:"full"
})
};

// lib/locale/gd/_lib/formatRelative.js
var formatRelativeLocale31={
lastWeek:"'mu dheireadh' eeee 'aig' p",
yesterday:"'an-d\xE8 aig' p",
today:"'an-diugh aig' p",
tomorrow:"'a-m\xE0ireach aig' p",
nextWeek:"eeee 'aig' p",
other:"P"
};
var formatRelative70=function formatRelative70(token,_date,_baseDate,_options){return formatRelativeLocale31[token];};

// lib/locale/gd/_lib/localize.js
var eraValues31={
narrow:["R","A"],
abbreviated:["RC","AD"],
wide:["ro Chr\xECosta","anno domini"]
};
var quarterValues31={
narrow:["1","2","3","4"],
abbreviated:["C1","C2","C3","C4"],
wide:[
"a' chiad chairteal",
"an d\xE0rna cairteal",
"an treas cairteal",
"an ceathramh cairteal"]

};
var monthValues31={
narrow:["F","G","M","G","C","\xD2","I","L","S","D","S","D"],
abbreviated:[
"Faoi",
"Gear",
"M\xE0rt",
"Gibl",
"C\xE8it",
"\xD2gmh",
"Iuch",
"L\xF9n",
"Sult",
"D\xE0mh",
"Samh",
"D\xF9bh"],

wide:[
"Am Faoilleach",
"An Gearran",
"Am M\xE0rt",
"An Giblean",
"An C\xE8itean",
"An t-\xD2gmhios",
"An t-Iuchar",
"An L\xF9nastal",
"An t-Sultain",
"An D\xE0mhair",
"An t-Samhain",
"An D\xF9bhlachd"]

};
var dayValues31={
narrow:["D","L","M","C","A","H","S"],
short:["D\xF2","Lu","M\xE0","Ci","Ar","Ha","Sa"],
abbreviated:["Did","Dil","Dim","Dic","Dia","Dih","Dis"],
wide:[
"Did\xF2mhnaich",
"Diluain",
"Dim\xE0irt",
"Diciadain",
"Diardaoin",
"Dihaoine",
"Disathairne"]

};
var dayPeriodValues31={
narrow:{
am:"m",
pm:"f",
midnight:"m.o.",
noon:"m.l.",
morning:"madainn",
afternoon:"feasgar",
evening:"feasgar",
night:"oidhche"
},
abbreviated:{
am:"M.",
pm:"F.",
midnight:"meadhan oidhche",
noon:"meadhan l\xE0",
morning:"madainn",
afternoon:"feasgar",
evening:"feasgar",
night:"oidhche"
},
wide:{
am:"m.",
pm:"f.",
midnight:"meadhan oidhche",
noon:"meadhan l\xE0",
morning:"madainn",
afternoon:"feasgar",
evening:"feasgar",
night:"oidhche"
}
};
var formattingDayPeriodValues25={
narrow:{
am:"m",
pm:"f",
midnight:"m.o.",
noon:"m.l.",
morning:"sa mhadainn",
afternoon:"feasgar",
evening:"feasgar",
night:"air an oidhche"
},
abbreviated:{
am:"M.",
pm:"F.",
midnight:"meadhan oidhche",
noon:"meadhan l\xE0",
morning:"sa mhadainn",
afternoon:"feasgar",
evening:"feasgar",
night:"air an oidhche"
},
wide:{
am:"m.",
pm:"f.",
midnight:"meadhan oidhche",
noon:"meadhan l\xE0",
morning:"sa mhadainn",
afternoon:"feasgar",
evening:"feasgar",
night:"air an oidhche"
}
};
var ordinalNumber31=function ordinalNumber31(dirtyNumber){
var number=Number(dirtyNumber);
var rem100=number%100;
if(rem100>20||rem100<10){
switch(rem100%10){
case 1:
return number+"d";
case 2:
return number+"na";
}
}
if(rem100===12){
return number+"na";
}
return number+"mh";
};
var localize71={
ordinalNumber:ordinalNumber31,
era:buildLocalizeFn({
values:eraValues31,
defaultWidth:"wide"
}),
quarter:buildLocalizeFn({
values:quarterValues31,
defaultWidth:"wide",
argumentCallback:function argumentCallback(quarter){return quarter-1;}
}),
month:buildLocalizeFn({
values:monthValues31,
defaultWidth:"wide"
}),
day:buildLocalizeFn({
values:dayValues31,
defaultWidth:"wide"
}),
dayPeriod:buildLocalizeFn({
values:dayPeriodValues31,
defaultWidth:"wide",
formattingValues:formattingDayPeriodValues25,
defaultFormattingWidth:"wide"
})
};

// lib/locale/gd/_lib/match.js
var matchOrdinalNumberPattern30=/^(\d+)(d|na|tr|mh)?/i;
var parseOrdinalNumberPattern30=/\d+/i;
var matchEraPatterns30={
narrow:/^(r|a)/i,
abbreviated:/^(r\.?\s?c\.?|r\.?\s?a\.?\s?c\.?|a\.?\s?d\.?|a\.?\s?c\.?)/i,
wide:/^(ro Chrìosta|ron aois choitchinn|anno domini|aois choitcheann)/i
};
var parseEraPatterns30={
any:[/^b/i,/^(a|c)/i]
};
var matchQuarterPatterns30={
narrow:/^[1234]/i,
abbreviated:/^c[1234]/i,
wide:/^[1234](cd|na|tr|mh)? cairteal/i
};
var parseQuarterPatterns30={
any:[/1/i,/2/i,/3/i,/4/i]
};
var matchMonthPatterns30={
narrow:/^[fgmcòilsd]/i,
abbreviated:/^(faoi|gear|màrt|gibl|cèit|ògmh|iuch|lùn|sult|dàmh|samh|dùbh)/i,
wide:/^(am faoilleach|an gearran|am màrt|an giblean|an cèitean|an t-Ògmhios|an t-Iuchar|an lùnastal|an t-Sultain|an dàmhair|an t-Samhain|an dùbhlachd)/i
};
var parseMonthPatterns30={
narrow:[
/^f/i,
/^g/i,
/^m/i,
/^g/i,
/^c/i,
/^ò/i,
/^i/i,
/^l/i,
/^s/i,
/^d/i,
/^s/i,
/^d/i],

any:[
/^fa/i,
/^ge/i,
/^mà/i,
/^gi/i,
/^c/i,
/^ò/i,
/^i/i,
/^l/i,
/^su/i,
/^d/i,
/^sa/i,
/^d/i]

};
var matchDayPatterns30={
narrow:/^[dlmcahs]/i,
short:/^(dò|lu|mà|ci|ar|ha|sa)/i,
abbreviated:/^(did|dil|dim|dic|dia|dih|dis)/i,
wide:/^(didòmhnaich|diluain|dimàirt|diciadain|diardaoin|dihaoine|disathairne)/i
};
var parseDayPatterns30={
narrow:[/^d/i,/^l/i,/^m/i,/^c/i,/^a/i,/^h/i,/^s/i],
any:[/^d/i,/^l/i,/^m/i,/^c/i,/^a/i,/^h/i,/^s/i]
};
var matchDayPeriodPatterns30={
narrow:/^(a|p|mi|n|(san|aig) (madainn|feasgar|feasgar|oidhche))/i,
any:/^([ap]\.?\s?m\.?|meadhan oidhche|meadhan là|(san|aig) (madainn|feasgar|feasgar|oidhche))/i
};
var parseDayPeriodPatterns30={
any:{
am:/^m/i,
pm:/^f/i,
midnight:/^meadhan oidhche/i,
noon:/^meadhan là/i,
morning:/sa mhadainn/i,
afternoon:/feasgar/i,
evening:/feasgar/i,
night:/air an oidhche/i
}
};
var match69={
ordinalNumber:buildMatchPatternFn({
matchPattern:matchOrdinalNumberPattern30,
parsePattern:parseOrdinalNumberPattern30,
valueCallback:function valueCallback(value){return parseInt(value,10);}
}),
era:buildMatchFn({
matchPatterns:matchEraPatterns30,
defaultMatchWidth:"wide",
parsePatterns:parseEraPatterns30,
defaultParseWidth:"any"
}),
quarter:buildMatchFn({
matchPatterns:matchQuarterPatterns30,
defaultMatchWidth:"wide",
parsePatterns:parseQuarterPatterns30,
defaultParseWidth:"any",
valueCallback:function valueCallback(index){return index+1;}
}),
month:buildMatchFn({
matchPatterns:matchMonthPatterns30,
defaultMatchWidth:"wide",
parsePatterns:parseMonthPatterns30,
defaultParseWidth:"any"
}),
day:buildMatchFn({
matchPatterns:matchDayPatterns30,
defaultMatchWidth:"wide",
parsePatterns:parseDayPatterns30,
defaultParseWidth:"any"
}),
dayPeriod:buildMatchFn({
matchPatterns:matchDayPeriodPatterns30,
defaultMatchWidth:"any",
parsePatterns:parseDayPeriodPatterns30,
defaultParseWidth:"any"
})
};

// lib/locale/gd.js
var _gd={
code:"gd",
formatDistance:formatDistance70,
formatLong:formatLong77,
formatRelative:formatRelative70,
localize:localize71,
match:match69,
options:{
weekStartsOn:0,
firstWeekContainsDate:1
}
};
// lib/locale/gl/_lib/formatDistance.js
var formatDistanceLocale32={
lessThanXSeconds:{
one:"menos dun segundo",
other:"menos de {{count}} segundos"
},
xSeconds:{
one:"1 segundo",
other:"{{count}} segundos"
},
halfAMinute:"medio minuto",
lessThanXMinutes:{
one:"menos dun minuto",
other:"menos de {{count}} minutos"
},
xMinutes:{
one:"1 minuto",
other:"{{count}} minutos"
},
aboutXHours:{
one:"arredor dunha hora",
other:"arredor de {{count}} horas"
},
xHours:{
one:"1 hora",
other:"{{count}} horas"
},
xDays:{
one:"1 d\xEDa",
other:"{{count}} d\xEDas"
},
aboutXWeeks:{
one:"arredor dunha semana",
other:"arredor de {{count}} semanas"
},
xWeeks:{
one:"1 semana",
other:"{{count}} semanas"
},
aboutXMonths:{
one:"arredor de 1 mes",
other:"arredor de {{count}} meses"
},
xMonths:{
one:"1 mes",
other:"{{count}} meses"
},
aboutXYears:{
one:"arredor dun ano",
other:"arredor de {{count}} anos"
},
xYears:{
one:"1 ano",
other:"{{count}} anos"
},
overXYears:{
one:"m\xE1is dun ano",
other:"m\xE1is de {{count}} anos"
},
almostXYears:{
one:"case un ano",
other:"case {{count}} anos"
}
};
var formatDistance72=function formatDistance72(token,count,options){
var result;
var tokenValue=formatDistanceLocale32[token];
if(typeof tokenValue==="string"){
result=tokenValue;
}else if(count===1){
result=tokenValue.one;
}else{
result=tokenValue.other.replace("{{count}}",String(count));
}
if(options!==null&&options!==void 0&&options.addSuffix){
if(options.comparison&&options.comparison>0){
return"en "+result;
}else{
return"hai "+result;
}
}
return result;
};

// lib/locale/gl/_lib/formatLong.js
var dateFormats39={
full:"EEEE, d 'de' MMMM y",
long:"d 'de' MMMM y",
medium:"d MMM y",
short:"dd/MM/y"
};
var timeFormats39={
full:"HH:mm:ss zzzz",
long:"HH:mm:ss z",
medium:"HH:mm:ss",
short:"HH:mm"
};
var dateTimeFormats39={
full:"{{date}} '\xE1s' {{time}}",
long:"{{date}} '\xE1s' {{time}}",
medium:"{{date}}, {{time}}",
short:"{{date}}, {{time}}"
};
var formatLong79={
date:buildFormatLongFn({
formats:dateFormats39,
defaultWidth:"full"
}),
time:buildFormatLongFn({
formats:timeFormats39,
defaultWidth:"full"
}),
dateTime:buildFormatLongFn({
formats:dateTimeFormats39,
defaultWidth:"full"
})
};

// lib/locale/gl/_lib/formatRelative.js
var formatRelativeLocale32={
lastWeek:"'o' eeee 'pasado \xE1' LT",
yesterday:"'onte \xE1' p",
today:"'hoxe \xE1' p",
tomorrow:"'ma\xF1\xE1 \xE1' p",
nextWeek:"eeee '\xE1' p",
other:"P"
};
var formatRelativeLocalePlural4={
lastWeek:"'o' eeee 'pasado \xE1s' p",
yesterday:"'onte \xE1s' p",
today:"'hoxe \xE1s' p",
tomorrow:"'ma\xF1\xE1 \xE1s' p",
nextWeek:"eeee '\xE1s' p",
other:"P"
};
var formatRelative72=function formatRelative72(token,date,_baseDate,_options){
if(date.getHours()!==1){
return formatRelativeLocalePlural4[token];
}
return formatRelativeLocale32[token];
};

// lib/locale/gl/_lib/localize.js
var eraValues32={
narrow:["AC","DC"],
abbreviated:["AC","DC"],
wide:["antes de cristo","despois de cristo"]
};
var quarterValues32={
narrow:["1","2","3","4"],
abbreviated:["T1","T2","T3","T4"],
wide:["1\xBA trimestre","2\xBA trimestre","3\xBA trimestre","4\xBA trimestre"]
};
var monthValues32={
narrow:["e","f","m","a","m","j","j","a","s","o","n","d"],
abbreviated:[
"xan",
"feb",
"mar",
"abr",
"mai",
"xun",
"xul",
"ago",
"set",
"out",
"nov",
"dec"],

wide:[
"xaneiro",
"febreiro",
"marzo",
"abril",
"maio",
"xu\xF1o",
"xullo",
"agosto",
"setembro",
"outubro",
"novembro",
"decembro"]

};
var dayValues32={
narrow:["d","l","m","m","j","v","s"],
short:["do","lu","ma","me","xo","ve","sa"],
abbreviated:["dom","lun","mar","mer","xov","ven","sab"],
wide:["domingo","luns","martes","m\xE9rcores","xoves","venres","s\xE1bado"]
};
var dayPeriodValues32={
narrow:{
am:"a",
pm:"p",
midnight:"mn",
noon:"md",
morning:"ma\xF1\xE1",
afternoon:"tarde",
evening:"tarde",
night:"noite"
},
abbreviated:{
am:"AM",
pm:"PM",
midnight:"medianoite",
noon:"mediod\xEDa",
morning:"ma\xF1\xE1",
afternoon:"tarde",
evening:"tardi\xF1a",
night:"noite"
},
wide:{
am:"a.m.",
pm:"p.m.",
midnight:"medianoite",
noon:"mediod\xEDa",
morning:"ma\xF1\xE1",
afternoon:"tarde",
evening:"tardi\xF1a",
night:"noite"
}
};
var formattingDayPeriodValues26={
narrow:{
am:"a",
pm:"p",
midnight:"mn",
noon:"md",
morning:"da ma\xF1\xE1",
afternoon:"da tarde",
evening:"da tardi\xF1a",
night:"da noite"
},
abbreviated:{
am:"AM",
pm:"PM",
midnight:"medianoite",
noon:"mediod\xEDa",
morning:"da ma\xF1\xE1",
afternoon:"da tarde",
evening:"da tardi\xF1a",
night:"da noite"
},
wide:{
am:"a.m.",
pm:"p.m.",
midnight:"medianoite",
noon:"mediod\xEDa",
morning:"da ma\xF1\xE1",
afternoon:"da tarde",
evening:"da tardi\xF1a",
night:"da noite"
}
};
var ordinalNumber32=function ordinalNumber32(dirtyNumber,_options){
var number=Number(dirtyNumber);
return number+"\xBA";
};
var localize73={
ordinalNumber:ordinalNumber32,
era:buildLocalizeFn({
values:eraValues32,
defaultWidth:"wide"
}),
quarter:buildLocalizeFn({
values:quarterValues32,
defaultWidth:"wide",
argumentCallback:function argumentCallback(quarter){return quarter-1;}
}),
month:buildLocalizeFn({
values:monthValues32,
defaultWidth:"wide"
}),
day:buildLocalizeFn({
values:dayValues32,
defaultWidth:"wide"
}),
dayPeriod:buildLocalizeFn({
values:dayPeriodValues32,
defaultWidth:"wide",
formattingValues:formattingDayPeriodValues26,
defaultFormattingWidth:"wide"
})
};

// lib/locale/gl/_lib/match.js
var matchOrdinalNumberPattern31=/^(\d+)(º)?/i;
var parseOrdinalNumberPattern31=/\d+/i;
var matchEraPatterns31={
narrow:/^(ac|dc|a|d)/i,
abbreviated:/^(a\.?\s?c\.?|a\.?\s?e\.?\s?c\.?|d\.?\s?c\.?|e\.?\s?c\.?)/i,
wide:/^(antes de cristo|antes da era com[uú]n|despois de cristo|era com[uú]n)/i
};
var parseEraPatterns31={
any:[/^ac/i,/^dc/i],
wide:[
/^(antes de cristo|antes da era com[uú]n)/i,
/^(despois de cristo|era com[uú]n)/i]

};
var matchQuarterPatterns31={
narrow:/^[1234]/i,
abbreviated:/^T[1234]/i,
wide:/^[1234](º)? trimestre/i
};
var parseQuarterPatterns31={
any:[/1/i,/2/i,/3/i,/4/i]
};
var matchMonthPatterns31={
narrow:/^[xfmasond]/i,
abbreviated:/^(xan|feb|mar|abr|mai|xun|xul|ago|set|out|nov|dec)/i,
wide:/^(xaneiro|febreiro|marzo|abril|maio|xuño|xullo|agosto|setembro|outubro|novembro|decembro)/i
};
var parseMonthPatterns31={
narrow:[
/^x/i,
/^f/i,
/^m/i,
/^a/i,
/^m/i,
/^x/i,
/^x/i,
/^a/i,
/^s/i,
/^o/i,
/^n/i,
/^d/i],

any:[
/^xan/i,
/^feb/i,
/^mar/i,
/^abr/i,
/^mai/i,
/^xun/i,
/^xul/i,
/^ago/i,
/^set/i,
/^out/i,
/^nov/i,
/^dec/i]

};
var matchDayPatterns31={
narrow:/^[dlmxvs]/i,
short:/^(do|lu|ma|me|xo|ve|sa)/i,
abbreviated:/^(dom|lun|mar|mer|xov|ven|sab)/i,
wide:/^(domingo|luns|martes|m[eé]rcores|xoves|venres|s[áa]bado)/i
};
var parseDayPatterns31={
narrow:[/^d/i,/^l/i,/^m/i,/^m/i,/^x/i,/^v/i,/^s/i],
any:[/^do/i,/^lu/i,/^ma/i,/^me/i,/^xo/i,/^ve/i,/^sa/i]
};
var matchDayPeriodPatterns31={
narrow:/^(a|p|mn|md|(da|[aá]s) (mañ[aá]|tarde|noite))/i,
any:/^([ap]\.?\s?m\.?|medianoite|mediod[ií]a|(da|[aá]s) (mañ[aá]|tarde|noite))/i
};
var parseDayPeriodPatterns31={
any:{
am:/^a/i,
pm:/^p/i,
midnight:/^mn/i,
noon:/^md/i,
morning:/mañ[aá]/i,
afternoon:/tarde/i,
evening:/tardiña/i,
night:/noite/i
}
};
var match71={
ordinalNumber:buildMatchPatternFn({
matchPattern:matchOrdinalNumberPattern31,
parsePattern:parseOrdinalNumberPattern31,
valueCallback:function valueCallback(value){return parseInt(value,10);}
}),
era:buildMatchFn({
matchPatterns:matchEraPatterns31,
defaultMatchWidth:"wide",
parsePatterns:parseEraPatterns31,
defaultParseWidth:"any"
}),
quarter:buildMatchFn({
matchPatterns:matchQuarterPatterns31,
defaultMatchWidth:"wide",
parsePatterns:parseQuarterPatterns31,
defaultParseWidth:"any",
valueCallback:function valueCallback(index){return index+1;}
}),
month:buildMatchFn({
matchPatterns:matchMonthPatterns31,
defaultMatchWidth:"wide",
parsePatterns:parseMonthPatterns31,
defaultParseWidth:"any"
}),
day:buildMatchFn({
matchPatterns:matchDayPatterns31,
defaultMatchWidth:"wide",
parsePatterns:parseDayPatterns31,
defaultParseWidth:"any"
}),
dayPeriod:buildMatchFn({
matchPatterns:matchDayPeriodPatterns31,
defaultMatchWidth:"any",
parsePatterns:parseDayPeriodPatterns31,
defaultParseWidth:"any"
})
};

// lib/locale/gl.js
var _gl={
code:"gl",
formatDistance:formatDistance72,
formatLong:formatLong79,
formatRelative:formatRelative72,
localize:localize73,
match:match71,
options:{
weekStartsOn:1,
firstWeekContainsDate:1
}
};
// lib/locale/gu/_lib/formatDistance.js
var formatDistanceLocale33={
lessThanXSeconds:{
one:"\u0AB9\u0AAE\u0AA3\u0ABE\u0A82",
other:"\u200B\u0A86\u0AB6\u0AB0\u0AC7 {{count}} \u0AB8\u0AC7\u0A95\u0A82\u0AA1"
},
xSeconds:{
one:"1 \u0AB8\u0AC7\u0A95\u0A82\u0AA1",
other:"{{count}} \u0AB8\u0AC7\u0A95\u0A82\u0AA1"
},
halfAMinute:"\u0A85\u0AA1\u0AA7\u0AC0 \u0AAE\u0ABF\u0AA8\u0ABF\u0A9F",
lessThanXMinutes:{
one:"\u0A86 \u0AAE\u0ABF\u0AA8\u0ABF\u0A9F",
other:"\u200B\u0A86\u0AB6\u0AB0\u0AC7 {{count}} \u0AAE\u0ABF\u0AA8\u0ABF\u0A9F"
},
xMinutes:{
one:"1 \u0AAE\u0ABF\u0AA8\u0ABF\u0A9F",
other:"{{count}} \u0AAE\u0ABF\u0AA8\u0ABF\u0A9F"
},
aboutXHours:{
one:"\u200B\u0A86\u0AB6\u0AB0\u0AC7 1 \u0A95\u0AB2\u0ABE\u0A95",
other:"\u200B\u0A86\u0AB6\u0AB0\u0AC7 {{count}} \u0A95\u0AB2\u0ABE\u0A95"
},
xHours:{
one:"1 \u0A95\u0AB2\u0ABE\u0A95",
other:"{{count}} \u0A95\u0AB2\u0ABE\u0A95"
},
xDays:{
one:"1 \u0AA6\u0ABF\u0AB5\u0AB8",
other:"{{count}} \u0AA6\u0ABF\u0AB5\u0AB8"
},
aboutXWeeks:{
one:"\u0A86\u0AB6\u0AB0\u0AC7 1 \u0A85\u0AA0\u0AB5\u0ABE\u0AA1\u0ABF\u0AAF\u0AC1\u0A82",
other:"\u0A86\u0AB6\u0AB0\u0AC7 {{count}} \u0A85\u0AA0\u0AB5\u0ABE\u0AA1\u0ABF\u0AAF\u0ABE"
},
xWeeks:{
one:"1 \u0A85\u0AA0\u0AB5\u0ABE\u0AA1\u0ABF\u0AAF\u0AC1\u0A82",
other:"{{count}} \u0A85\u0AA0\u0AB5\u0ABE\u0AA1\u0ABF\u0AAF\u0ABE"
},
aboutXMonths:{
one:"\u0A86\u0AB6\u0AB0\u0AC7 1 \u0AAE\u0AB9\u0ABF\u0AA8\u0ACB",
other:"\u0A86\u0AB6\u0AB0\u0AC7 {{count}} \u0AAE\u0AB9\u0ABF\u0AA8\u0ABE"
},
xMonths:{
one:"1 \u0AAE\u0AB9\u0ABF\u0AA8\u0ACB",
other:"{{count}} \u0AAE\u0AB9\u0ABF\u0AA8\u0ABE"
},
aboutXYears:{
one:"\u0A86\u0AB6\u0AB0\u0AC7 1 \u0AB5\u0AB0\u0ACD\u0AB7",
other:"\u0A86\u0AB6\u0AB0\u0AC7 {{count}} \u0AB5\u0AB0\u0ACD\u0AB7"
},
xYears:{
one:"1 \u0AB5\u0AB0\u0ACD\u0AB7",
other:"{{count}} \u0AB5\u0AB0\u0ACD\u0AB7"
},
overXYears:{
one:"1 \u0AB5\u0AB0\u0ACD\u0AB7\u0AA5\u0AC0 \u0AB5\u0AA7\u0AC1",
other:"{{count}} \u0AB5\u0AB0\u0ACD\u0AB7\u0AA5\u0AC0 \u0AB5\u0AA7\u0AC1"
},
almostXYears:{
one:"\u0AB2\u0A97\u0AAD\u0A97 1 \u0AB5\u0AB0\u0ACD\u0AB7",
other:"\u0AB2\u0A97\u0AAD\u0A97 {{count}} \u0AB5\u0AB0\u0ACD\u0AB7"
}
};
var formatDistance74=function formatDistance74(token,count,options){
var result;
var tokenValue=formatDistanceLocale33[token];
if(typeof tokenValue==="string"){
result=tokenValue;
}else if(count===1){
result=tokenValue.one;
}else{
result=tokenValue.other.replace("{{count}}",String(count));
}
if(options!==null&&options!==void 0&&options.addSuffix){
if(options.comparison&&options.comparison>0){
return result+"\u0AAE\u0ABE\u0A82";
}else{
return result+" \u0AAA\u0AB9\u0AC7\u0AB2\u0ABE\u0A82";
}
}
return result;
};

// lib/locale/gu/_lib/formatLong.js
var dateFormats40={
full:"EEEE, d MMMM, y",
long:"d MMMM, y",
medium:"d MMM, y",
short:"d/M/yy"
};
var timeFormats40={
full:"hh:mm:ss a zzzz",
long:"hh:mm:ss a z",
medium:"hh:mm:ss a",
short:"hh:mm a"
};
var dateTimeFormats40={
full:"{{date}} {{time}}",
long:"{{date}} {{time}}",
medium:"{{date}} {{time}}",
short:"{{date}} {{time}}"
};
var formatLong81={
date:buildFormatLongFn({
formats:dateFormats40,
defaultWidth:"full"
}),
time:buildFormatLongFn({
formats:timeFormats40,
defaultWidth:"full"
}),
dateTime:buildFormatLongFn({
formats:dateTimeFormats40,
defaultWidth:"full"
})
};

// lib/locale/gu/_lib/formatRelative.js
var formatRelativeLocale33={
lastWeek:"'\u0AAA\u0ABE\u0A9B\u0AB2\u0ABE' eeee p",
yesterday:"'\u0A97\u0A88\u0A95\u0ABE\u0AB2\u0AC7' p",
today:"'\u0A86\u0A9C\u0AC7' p",
tomorrow:"'\u0A86\u0AB5\u0AA4\u0AC0\u0A95\u0ABE\u0AB2\u0AC7' p",
nextWeek:"eeee p",
other:"P"
};
var formatRelative74=function formatRelative74(token,_date,_baseDate,_options){return formatRelativeLocale33[token];};

// lib/locale/gu/_lib/localize.js
var eraValues33={
narrow:["\u0A88\u0AB8\u0AAA\u0AC2","\u0A88\u0AB8"],
abbreviated:["\u0A88.\u0AB8.\u0AAA\u0AC2\u0AB0\u0ACD\u0AB5\u0AC7","\u0A88.\u0AB8."],
wide:["\u0A88\u0AB8\u0AB5\u0AC0\u0AB8\u0AA8 \u0AAA\u0AC2\u0AB0\u0ACD\u0AB5\u0AC7","\u0A88\u0AB8\u0AB5\u0AC0\u0AB8\u0AA8"]
};
var quarterValues33={
narrow:["1","2","3","4"],
abbreviated:["Q1","Q2","Q3","Q4"],
wide:["1\u0AB2\u0ACB \u0AA4\u0ACD\u0AB0\u0ABF\u0AAE\u0ABE\u0AB8","2\u0A9C\u0ACB \u0AA4\u0ACD\u0AB0\u0ABF\u0AAE\u0ABE\u0AB8","3\u0A9C\u0ACB \u0AA4\u0ACD\u0AB0\u0ABF\u0AAE\u0ABE\u0AB8","4\u0AA5\u0ACB \u0AA4\u0ACD\u0AB0\u0ABF\u0AAE\u0ABE\u0AB8"]
};
var monthValues33={
narrow:["\u0A9C\u0ABE","\u0AAB\u0AC7","\u0AAE\u0ABE","\u0A8F","\u0AAE\u0AC7","\u0A9C\u0AC2","\u0A9C\u0AC1","\u0A93","\u0AB8","\u0A93","\u0AA8","\u0AA1\u0ABF"],
abbreviated:[
"\u0A9C\u0ABE\u0AA8\u0ACD\u0AAF\u0AC1",
"\u0AAB\u0AC7\u0AAC\u0ACD\u0AB0\u0AC1",
"\u0AAE\u0ABE\u0AB0\u0ACD\u0A9A",
"\u0A8F\u0AAA\u0ACD\u0AB0\u0ABF\u0AB2",
"\u0AAE\u0AC7",
"\u0A9C\u0AC2\u0AA8",
"\u0A9C\u0AC1\u0AB2\u0ABE\u0A88",
"\u0A91\u0A97\u0AB8\u0ACD\u0A9F",
"\u0AB8\u0AAA\u0ACD\u0A9F\u0AC7",
"\u0A93\u0A95\u0ACD\u0A9F\u0ACB",
"\u0AA8\u0AB5\u0AC7",
"\u0AA1\u0ABF\u0AB8\u0AC7"],

wide:[
"\u0A9C\u0ABE\u0AA8\u0ACD\u0AAF\u0AC1\u0A86\u0AB0\u0AC0",
"\u0AAB\u0AC7\u0AAC\u0ACD\u0AB0\u0AC1\u0A86\u0AB0\u0AC0",
"\u0AAE\u0ABE\u0AB0\u0ACD\u0A9A",
"\u0A8F\u0AAA\u0ACD\u0AB0\u0ABF\u0AB2",
"\u0AAE\u0AC7",
"\u0A9C\u0AC2\u0AA8",
"\u0A9C\u0AC1\u0AB2\u0ABE\u0A87",
"\u0A93\u0A97\u0AB8\u0ACD\u0A9F",
"\u0AB8\u0AAA\u0ACD\u0A9F\u0AC7\u0AAE\u0ACD\u0AAC\u0AB0",
"\u0A93\u0A95\u0ACD\u0A9F\u0ACB\u0AAC\u0AB0",
"\u0AA8\u0AB5\u0AC7\u0AAE\u0ACD\u0AAC\u0AB0",
"\u0AA1\u0ABF\u0AB8\u0AC7\u0AAE\u0ACD\u0AAC\u0AB0"]

};
var dayValues33={
narrow:["\u0AB0","\u0AB8\u0ACB","\u0AAE\u0A82","\u0AAC\u0AC1","\u0A97\u0AC1","\u0AB6\u0AC1","\u0AB6"],
short:["\u0AB0","\u0AB8\u0ACB","\u0AAE\u0A82","\u0AAC\u0AC1","\u0A97\u0AC1","\u0AB6\u0AC1","\u0AB6"],
abbreviated:["\u0AB0\u0AB5\u0ABF","\u0AB8\u0ACB\u0AAE","\u0AAE\u0A82\u0A97\u0AB3","\u0AAC\u0AC1\u0AA7","\u0A97\u0AC1\u0AB0\u0AC1","\u0AB6\u0AC1\u0A95\u0ACD\u0AB0","\u0AB6\u0AA8\u0ABF"],
wide:[
"\u0AB0\u0AB5\u0ABF\u0AB5\u0ABE\u0AB0",
"\u0AB8\u0ACB\u0AAE\u0AB5\u0ABE\u0AB0",
"\u0AAE\u0A82\u0A97\u0AB3\u0AB5\u0ABE\u0AB0",
"\u0AAC\u0AC1\u0AA7\u0AB5\u0ABE\u0AB0",
"\u0A97\u0AC1\u0AB0\u0AC1\u0AB5\u0ABE\u0AB0",
"\u0AB6\u0AC1\u0A95\u0ACD\u0AB0\u0AB5\u0ABE\u0AB0",
"\u0AB6\u0AA8\u0ABF\u0AB5\u0ABE\u0AB0"]

};
var dayPeriodValues33={
narrow:{
am:"AM",
pm:"PM",
midnight:"\u0AAE.\u0AB0\u0ABE\u0AA4\u0ACD\u0AB0\u0ABF",
noon:"\u0AAC.",
morning:"\u0AB8\u0AB5\u0ABE\u0AB0\u0AC7",
afternoon:"\u0AAC\u0AAA\u0ACB\u0AB0\u0AC7",
evening:"\u0AB8\u0ABE\u0A82\u0A9C\u0AC7",
night:"\u0AB0\u0ABE\u0AA4\u0ACD\u0AB0\u0AC7"
},
abbreviated:{
am:"AM",
pm:"PM",
midnight:"\u200B\u0AAE\u0AA7\u0ACD\u0AAF\u0AB0\u0ABE\u0AA4\u0ACD\u0AB0\u0ABF",
noon:"\u0AAC\u0AAA\u0ACB\u0AB0\u0AC7",
morning:"\u0AB8\u0AB5\u0ABE\u0AB0\u0AC7",
afternoon:"\u0AAC\u0AAA\u0ACB\u0AB0\u0AC7",
evening:"\u0AB8\u0ABE\u0A82\u0A9C\u0AC7",
night:"\u0AB0\u0ABE\u0AA4\u0ACD\u0AB0\u0AC7"
},
wide:{
am:"AM",
pm:"PM",
midnight:"\u200B\u0AAE\u0AA7\u0ACD\u0AAF\u0AB0\u0ABE\u0AA4\u0ACD\u0AB0\u0ABF",
noon:"\u0AAC\u0AAA\u0ACB\u0AB0\u0AC7",
morning:"\u0AB8\u0AB5\u0ABE\u0AB0\u0AC7",
afternoon:"\u0AAC\u0AAA\u0ACB\u0AB0\u0AC7",
evening:"\u0AB8\u0ABE\u0A82\u0A9C\u0AC7",
night:"\u0AB0\u0ABE\u0AA4\u0ACD\u0AB0\u0AC7"
}
};
var formattingDayPeriodValues27={
narrow:{
am:"AM",
pm:"PM",
midnight:"\u0AAE.\u0AB0\u0ABE\u0AA4\u0ACD\u0AB0\u0ABF",
noon:"\u0AAC\u0AAA\u0ACB\u0AB0\u0AC7",
morning:"\u0AB8\u0AB5\u0ABE\u0AB0\u0AC7",
afternoon:"\u0AAC\u0AAA\u0ACB\u0AB0\u0AC7",
evening:"\u0AB8\u0ABE\u0A82\u0A9C\u0AC7",
night:"\u0AB0\u0ABE\u0AA4\u0ACD\u0AB0\u0AC7"
},
abbreviated:{
am:"AM",
pm:"PM",
midnight:"\u0AAE\u0AA7\u0ACD\u0AAF\u0AB0\u0ABE\u0AA4\u0ACD\u0AB0\u0ABF",
noon:"\u0AAC\u0AAA\u0ACB\u0AB0\u0AC7",
morning:"\u0AB8\u0AB5\u0ABE\u0AB0\u0AC7",
afternoon:"\u0AAC\u0AAA\u0ACB\u0AB0\u0AC7",
evening:"\u0AB8\u0ABE\u0A82\u0A9C\u0AC7",
night:"\u0AB0\u0ABE\u0AA4\u0ACD\u0AB0\u0AC7"
},
wide:{
am:"AM",
pm:"PM",
midnight:"\u200B\u0AAE\u0AA7\u0ACD\u0AAF\u0AB0\u0ABE\u0AA4\u0ACD\u0AB0\u0ABF",
noon:"\u0AAC\u0AAA\u0ACB\u0AB0\u0AC7",
morning:"\u0AB8\u0AB5\u0ABE\u0AB0\u0AC7",
afternoon:"\u0AAC\u0AAA\u0ACB\u0AB0\u0AC7",
evening:"\u0AB8\u0ABE\u0A82\u0A9C\u0AC7",
night:"\u0AB0\u0ABE\u0AA4\u0ACD\u0AB0\u0AC7"
}
};
var ordinalNumber33=function ordinalNumber33(dirtyNumber,_options){
return String(dirtyNumber);
};
var localize75={
ordinalNumber:ordinalNumber33,
era:buildLocalizeFn({
values:eraValues33,
defaultWidth:"wide"
}),
quarter:buildLocalizeFn({
values:quarterValues33,
defaultWidth:"wide",
argumentCallback:function argumentCallback(quarter){return quarter-1;}
}),
month:buildLocalizeFn({
values:monthValues33,
defaultWidth:"wide"
}),
day:buildLocalizeFn({
values:dayValues33,
defaultWidth:"wide"
}),
dayPeriod:buildLocalizeFn({
values:dayPeriodValues33,
defaultWidth:"wide",
formattingValues:formattingDayPeriodValues27,
defaultFormattingWidth:"wide"
})
};

// lib/locale/gu/_lib/match.js
var matchOrdinalNumberPattern32=/^(\d+)(લ|જ|થ|ઠ્ઠ|મ)?/i;
var parseOrdinalNumberPattern32=/\d+/i;
var matchEraPatterns32={
narrow:/^(ઈસપૂ|ઈસ)/i,
abbreviated:/^(ઈ\.સ\.પૂર્વે|ઈ\.સ\.)/i,
wide:/^(ઈસવીસન\sપૂર્વે|ઈસવીસન)/i
};
var parseEraPatterns32={
any:[/^ઈસપૂ/i,/^ઈસ/i]
};
var matchQuarterPatterns32={
narrow:/^[1234]/i,
abbreviated:/^q[1234]/i,
wide:/^[1234](લો|જો|થો)? ત્રિમાસ/i
};
var parseQuarterPatterns32={
any:[/1/i,/2/i,/3/i,/4/i]
};
var matchMonthPatterns32={
narrow:/^[જાફેમાએમેજૂજુઓસઓનડિ]/i,
abbreviated:/^(જાન્યુ|ફેબ્રુ|માર્ચ|એપ્રિલ|મે|જૂન|જુલાઈ|ઑગસ્ટ|સપ્ટે|ઓક્ટો|નવે|ડિસે)/i,
wide:/^(જાન્યુઆરી|ફેબ્રુઆરી|માર્ચ|એપ્રિલ|મે|જૂન|જુલાઇ|ઓગસ્ટ|સપ્ટેમ્બર|ઓક્ટોબર|નવેમ્બર|ડિસેમ્બર)/i
};
var parseMonthPatterns32={
narrow:[
/^જા/i,
/^ફે/i,
/^મા/i,
/^એ/i,
/^મે/i,
/^જૂ/i,
/^જુ/i,
/^ઑગ/i,
/^સ/i,
/^ઓક્ટો/i,
/^ન/i,
/^ડિ/i],

any:[
/^જા/i,
/^ફે/i,
/^મા/i,
/^એ/i,
/^મે/i,
/^જૂ/i,
/^જુ/i,
/^ઑગ/i,
/^સ/i,
/^ઓક્ટો/i,
/^ન/i,
/^ડિ/i]

};
var matchDayPatterns32={
narrow:/^(ર|સો|મં|બુ|ગુ|શુ|શ)/i,
short:/^(ર|સો|મં|બુ|ગુ|શુ|શ)/i,
abbreviated:/^(રવિ|સોમ|મંગળ|બુધ|ગુરુ|શુક્ર|શનિ)/i,
wide:/^(રવિવાર|સોમવાર|મંગળવાર|બુધવાર|ગુરુવાર|શુક્રવાર|શનિવાર)/i
};
var parseDayPatterns32={
narrow:[/^ર/i,/^સો/i,/^મં/i,/^બુ/i,/^ગુ/i,/^શુ/i,/^શ/i],
any:[/^ર/i,/^સો/i,/^મં/i,/^બુ/i,/^ગુ/i,/^શુ/i,/^શ/i]
};
var matchDayPeriodPatterns32={
narrow:/^(a|p|મ\.?|સ|બ|સાં|રા)/i,
any:/^(a|p|મ\.?|સ|બ|સાં|રા)/i
};
var parseDayPeriodPatterns32={
any:{
am:/^a/i,
pm:/^p/i,
midnight:/^મ\.?/i,
noon:/^બ/i,
morning:/સ/i,
afternoon:/બ/i,
evening:/સાં/i,
night:/રા/i
}
};
var match73={
ordinalNumber:buildMatchPatternFn({
matchPattern:matchOrdinalNumberPattern32,
parsePattern:parseOrdinalNumberPattern32,
valueCallback:function valueCallback(value){return parseInt(value,10);}
}),
era:buildMatchFn({
matchPatterns:matchEraPatterns32,
defaultMatchWidth:"wide",
parsePatterns:parseEraPatterns32,
defaultParseWidth:"any"
}),
quarter:buildMatchFn({
matchPatterns:matchQuarterPatterns32,
defaultMatchWidth:"wide",
parsePatterns:parseQuarterPatterns32,
defaultParseWidth:"any",
valueCallback:function valueCallback(index){return index+1;}
}),
month:buildMatchFn({
matchPatterns:matchMonthPatterns32,
defaultMatchWidth:"wide",
parsePatterns:parseMonthPatterns32,
defaultParseWidth:"any"
}),
day:buildMatchFn({
matchPatterns:matchDayPatterns32,
defaultMatchWidth:"wide",
parsePatterns:parseDayPatterns32,
defaultParseWidth:"any"
}),
dayPeriod:buildMatchFn({
matchPatterns:matchDayPeriodPatterns32,
defaultMatchWidth:"any",
parsePatterns:parseDayPeriodPatterns32,
defaultParseWidth:"any"
})
};

// lib/locale/gu.js
var _gu={
code:"gu",
formatDistance:formatDistance74,
formatLong:formatLong81,
formatRelative:formatRelative74,
localize:localize75,
match:match73,
options:{
weekStartsOn:1,
firstWeekContainsDate:4
}
};
// lib/locale/he/_lib/formatDistance.js
var formatDistanceLocale34={
lessThanXSeconds:{
one:"\u05E4\u05D7\u05D5\u05EA \u05DE\u05E9\u05E0\u05D9\u05D9\u05D4",
two:"\u05E4\u05D7\u05D5\u05EA \u05DE\u05E9\u05EA\u05D9 \u05E9\u05E0\u05D9\u05D5\u05EA",
other:"\u05E4\u05D7\u05D5\u05EA \u05DE\u05BE{{count}} \u05E9\u05E0\u05D9\u05D5\u05EA"
},
xSeconds:{
one:"\u05E9\u05E0\u05D9\u05D9\u05D4",
two:"\u05E9\u05EA\u05D9 \u05E9\u05E0\u05D9\u05D5\u05EA",
other:"{{count}} \u05E9\u05E0\u05D9\u05D5\u05EA"
},
halfAMinute:"\u05D7\u05E6\u05D9 \u05D3\u05E7\u05D4",
lessThanXMinutes:{
one:"\u05E4\u05D7\u05D5\u05EA \u05DE\u05D3\u05E7\u05D4",
two:"\u05E4\u05D7\u05D5\u05EA \u05DE\u05E9\u05EA\u05D9 \u05D3\u05E7\u05D5\u05EA",
other:"\u05E4\u05D7\u05D5\u05EA \u05DE\u05BE{{count}} \u05D3\u05E7\u05D5\u05EA"
},
xMinutes:{
one:"\u05D3\u05E7\u05D4",
two:"\u05E9\u05EA\u05D9 \u05D3\u05E7\u05D5\u05EA",
other:"{{count}} \u05D3\u05E7\u05D5\u05EA"
},
aboutXHours:{
one:"\u05DB\u05E9\u05E2\u05D4",
two:"\u05DB\u05E9\u05E2\u05EA\u05D9\u05D9\u05DD",
other:"\u05DB\u05BE{{count}} \u05E9\u05E2\u05D5\u05EA"
},
xHours:{
one:"\u05E9\u05E2\u05D4",
two:"\u05E9\u05E2\u05EA\u05D9\u05D9\u05DD",
other:"{{count}} \u05E9\u05E2\u05D5\u05EA"
},
xDays:{
one:"\u05D9\u05D5\u05DD",
two:"\u05D9\u05D5\u05DE\u05D9\u05D9\u05DD",
other:"{{count}} \u05D9\u05DE\u05D9\u05DD"
},
aboutXWeeks:{
one:"\u05DB\u05E9\u05D1\u05D5\u05E2",
two:"\u05DB\u05E9\u05D1\u05D5\u05E2\u05D9\u05D9\u05DD",
other:"\u05DB\u05BE{{count}} \u05E9\u05D1\u05D5\u05E2\u05D5\u05EA"
},
xWeeks:{
one:"\u05E9\u05D1\u05D5\u05E2",
two:"\u05E9\u05D1\u05D5\u05E2\u05D9\u05D9\u05DD",
other:"{{count}} \u05E9\u05D1\u05D5\u05E2\u05D5\u05EA"
},
aboutXMonths:{
one:"\u05DB\u05D7\u05D5\u05D3\u05E9",
two:"\u05DB\u05D7\u05D5\u05D3\u05E9\u05D9\u05D9\u05DD",
other:"\u05DB\u05BE{{count}} \u05D7\u05D5\u05D3\u05E9\u05D9\u05DD"
},
xMonths:{
one:"\u05D7\u05D5\u05D3\u05E9",
two:"\u05D7\u05D5\u05D3\u05E9\u05D9\u05D9\u05DD",
other:"{{count}} \u05D7\u05D5\u05D3\u05E9\u05D9\u05DD"
},
aboutXYears:{
one:"\u05DB\u05E9\u05E0\u05D4",
two:"\u05DB\u05E9\u05E0\u05EA\u05D9\u05D9\u05DD",
other:"\u05DB\u05BE{{count}} \u05E9\u05E0\u05D9\u05DD"
},
xYears:{
one:"\u05E9\u05E0\u05D4",
two:"\u05E9\u05E0\u05EA\u05D9\u05D9\u05DD",
other:"{{count}} \u05E9\u05E0\u05D9\u05DD"
},
overXYears:{
one:"\u05D9\u05D5\u05EA\u05E8 \u05DE\u05E9\u05E0\u05D4",
two:"\u05D9\u05D5\u05EA\u05E8 \u05DE\u05E9\u05E0\u05EA\u05D9\u05D9\u05DD",
other:"\u05D9\u05D5\u05EA\u05E8 \u05DE\u05BE{{count}} \u05E9\u05E0\u05D9\u05DD"
},
almostXYears:{
one:"\u05DB\u05DE\u05E2\u05D8 \u05E9\u05E0\u05D4",
two:"\u05DB\u05DE\u05E2\u05D8 \u05E9\u05E0\u05EA\u05D9\u05D9\u05DD",
other:"\u05DB\u05DE\u05E2\u05D8 {{count}} \u05E9\u05E0\u05D9\u05DD"
}
};
var formatDistance76=function formatDistance76(token,count,options){
if(token==="xDays"&&options!==null&&options!==void 0&&options.addSuffix&&count<=2){
if(options.comparison&&options.comparison>0){
return count===1?"\u05DE\u05D7\u05E8":"\u05DE\u05D7\u05E8\u05EA\u05D9\u05D9\u05DD";
}
return count===1?"\u05D0\u05EA\u05DE\u05D5\u05DC":"\u05E9\u05DC\u05E9\u05D5\u05DD";
}
var result;
var tokenValue=formatDistanceLocale34[token];
if(typeof tokenValue==="string"){
result=tokenValue;
}else if(count===1){
result=tokenValue.one;
}else if(count===2){
result=tokenValue.two;
}else{
result=tokenValue.other.replace("{{count}}",String(count));
}
if(options!==null&&options!==void 0&&options.addSuffix){
if(options.comparison&&options.comparison>0){
return"\u05D1\u05E2\u05D5\u05D3 "+result;
}else{
return"\u05DC\u05E4\u05E0\u05D9 "+result;
}
}
return result;
};

// lib/locale/he/_lib/formatLong.js
var dateFormats41={
full:"EEEE, d \u05D1MMMM y",
long:"d \u05D1MMMM y",
medium:"d \u05D1MMM y",
short:"d.M.y"
};
var timeFormats41={
full:"H:mm:ss zzzz",
long:"H:mm:ss z",
medium:"H:mm:ss",
short:"H:mm"
};
var dateTimeFormats41={
full:"{{date}} '\u05D1\u05E9\u05E2\u05D4' {{time}}",
long:"{{date}} '\u05D1\u05E9\u05E2\u05D4' {{time}}",
medium:"{{date}}, {{time}}",
short:"{{date}}, {{time}}"
};
var formatLong83={
date:buildFormatLongFn({
formats:dateFormats41,
defaultWidth:"full"
}),
time:buildFormatLongFn({
formats:timeFormats41,
defaultWidth:"full"
}),
dateTime:buildFormatLongFn({
formats:dateTimeFormats41,
defaultWidth:"full"
})
};

// lib/locale/he/_lib/formatRelative.js
var formatRelativeLocale34={
lastWeek:"eeee '\u05E9\u05E2\u05D1\u05E8 \u05D1\u05E9\u05E2\u05D4' p",
yesterday:"'\u05D0\u05EA\u05DE\u05D5\u05DC \u05D1\u05E9\u05E2\u05D4' p",
today:"'\u05D4\u05D9\u05D5\u05DD \u05D1\u05E9\u05E2\u05D4' p",
tomorrow:"'\u05DE\u05D7\u05E8 \u05D1\u05E9\u05E2\u05D4' p",
nextWeek:"eeee '\u05D1\u05E9\u05E2\u05D4' p",
other:"P"
};
var formatRelative76=function formatRelative76(token,_date,_baseDate,_options){return formatRelativeLocale34[token];};

// lib/locale/he/_lib/localize.js
var eraValues34={
narrow:["\u05DC\u05E4\u05E0\u05D4\u05F4\u05E1","\u05DC\u05E1\u05E4\u05D9\u05E8\u05D4"],
abbreviated:["\u05DC\u05E4\u05E0\u05D4\u05F4\u05E1","\u05DC\u05E1\u05E4\u05D9\u05E8\u05D4"],
wide:["\u05DC\u05E4\u05E0\u05D9 \u05D4\u05E1\u05E4\u05D9\u05E8\u05D4","\u05DC\u05E1\u05E4\u05D9\u05E8\u05D4"]
};
var quarterValues34={
narrow:["1","2","3","4"],
abbreviated:["Q1","Q2","Q3","Q4"],
wide:["\u05E8\u05D1\u05E2\u05D5\u05DF 1","\u05E8\u05D1\u05E2\u05D5\u05DF 2","\u05E8\u05D1\u05E2\u05D5\u05DF 3","\u05E8\u05D1\u05E2\u05D5\u05DF 4"]
};
var monthValues34={
narrow:["1","2","3","4","5","6","7","8","9","10","11","12"],
abbreviated:[
"\u05D9\u05E0\u05D5\u05F3",
"\u05E4\u05D1\u05E8\u05F3",
"\u05DE\u05E8\u05E5",
"\u05D0\u05E4\u05E8\u05F3",
"\u05DE\u05D0\u05D9",
"\u05D9\u05D5\u05E0\u05D9",
"\u05D9\u05D5\u05DC\u05D9",
"\u05D0\u05D5\u05D2\u05F3",
"\u05E1\u05E4\u05D8\u05F3",
"\u05D0\u05D5\u05E7\u05F3",
"\u05E0\u05D5\u05D1\u05F3",
"\u05D3\u05E6\u05DE\u05F3"],

wide:[
"\u05D9\u05E0\u05D5\u05D0\u05E8",
"\u05E4\u05D1\u05E8\u05D5\u05D0\u05E8",
"\u05DE\u05E8\u05E5",
"\u05D0\u05E4\u05E8\u05D9\u05DC",
"\u05DE\u05D0\u05D9",
"\u05D9\u05D5\u05E0\u05D9",
"\u05D9\u05D5\u05DC\u05D9",
"\u05D0\u05D5\u05D2\u05D5\u05E1\u05D8",
"\u05E1\u05E4\u05D8\u05DE\u05D1\u05E8",
"\u05D0\u05D5\u05E7\u05D8\u05D5\u05D1\u05E8",
"\u05E0\u05D5\u05D1\u05DE\u05D1\u05E8",
"\u05D3\u05E6\u05DE\u05D1\u05E8"]

};
var dayValues34={
narrow:["\u05D0\u05F3","\u05D1\u05F3","\u05D2\u05F3","\u05D3\u05F3","\u05D4\u05F3","\u05D5\u05F3","\u05E9\u05F3"],
short:["\u05D0\u05F3","\u05D1\u05F3","\u05D2\u05F3","\u05D3\u05F3","\u05D4\u05F3","\u05D5\u05F3","\u05E9\u05F3"],
abbreviated:[
"\u05D9\u05D5\u05DD \u05D0\u05F3",
"\u05D9\u05D5\u05DD \u05D1\u05F3",
"\u05D9\u05D5\u05DD \u05D2\u05F3",
"\u05D9\u05D5\u05DD \u05D3\u05F3",
"\u05D9\u05D5\u05DD \u05D4\u05F3",
"\u05D9\u05D5\u05DD \u05D5\u05F3",
"\u05E9\u05D1\u05EA"],

wide:[
"\u05D9\u05D5\u05DD \u05E8\u05D0\u05E9\u05D5\u05DF",
"\u05D9\u05D5\u05DD \u05E9\u05E0\u05D9",
"\u05D9\u05D5\u05DD \u05E9\u05DC\u05D9\u05E9\u05D9",
"\u05D9\u05D5\u05DD \u05E8\u05D1\u05D9\u05E2\u05D9",
"\u05D9\u05D5\u05DD \u05D7\u05DE\u05D9\u05E9\u05D9",
"\u05D9\u05D5\u05DD \u05E9\u05D9\u05E9\u05D9",
"\u05D9\u05D5\u05DD \u05E9\u05D1\u05EA"]

};
var dayPeriodValues34={
narrow:{
am:"\u05DC\u05E4\u05E0\u05D4\u05F4\u05E6",
pm:"\u05D0\u05D7\u05D4\u05F4\u05E6",
midnight:"\u05D7\u05E6\u05D5\u05EA",
noon:"\u05E6\u05D4\u05E8\u05D9\u05D9\u05DD",
morning:"\u05D1\u05D5\u05E7\u05E8",
afternoon:"\u05D0\u05D7\u05E8 \u05D4\u05E6\u05D4\u05E8\u05D9\u05D9\u05DD",
evening:"\u05E2\u05E8\u05D1",
night:"\u05DC\u05D9\u05DC\u05D4"
},
abbreviated:{
am:"\u05DC\u05E4\u05E0\u05D4\u05F4\u05E6",
pm:"\u05D0\u05D7\u05D4\u05F4\u05E6",
midnight:"\u05D7\u05E6\u05D5\u05EA",
noon:"\u05E6\u05D4\u05E8\u05D9\u05D9\u05DD",
morning:"\u05D1\u05D5\u05E7\u05E8",
afternoon:"\u05D0\u05D7\u05E8 \u05D4\u05E6\u05D4\u05E8\u05D9\u05D9\u05DD",
evening:"\u05E2\u05E8\u05D1",
night:"\u05DC\u05D9\u05DC\u05D4"
},
wide:{
am:"\u05DC\u05E4\u05E0\u05D4\u05F4\u05E6",
pm:"\u05D0\u05D7\u05D4\u05F4\u05E6",
midnight:"\u05D7\u05E6\u05D5\u05EA",
noon:"\u05E6\u05D4\u05E8\u05D9\u05D9\u05DD",
morning:"\u05D1\u05D5\u05E7\u05E8",
afternoon:"\u05D0\u05D7\u05E8 \u05D4\u05E6\u05D4\u05E8\u05D9\u05D9\u05DD",
evening:"\u05E2\u05E8\u05D1",
night:"\u05DC\u05D9\u05DC\u05D4"
}
};
var formattingDayPeriodValues28={
narrow:{
am:"\u05DC\u05E4\u05E0\u05D4\u05F4\u05E6",
pm:"\u05D0\u05D7\u05D4\u05F4\u05E6",
midnight:"\u05D7\u05E6\u05D5\u05EA",
noon:"\u05E6\u05D4\u05E8\u05D9\u05D9\u05DD",
morning:"\u05D1\u05D1\u05D5\u05E7\u05E8",
afternoon:"\u05D1\u05E6\u05D4\u05E8\u05D9\u05D9\u05DD",
evening:"\u05D1\u05E2\u05E8\u05D1",
night:"\u05D1\u05DC\u05D9\u05DC\u05D4"
},
abbreviated:{
am:"\u05DC\u05E4\u05E0\u05D4\u05F4\u05E6",
pm:"\u05D0\u05D7\u05D4\u05F4\u05E6",
midnight:"\u05D7\u05E6\u05D5\u05EA",
noon:"\u05E6\u05D4\u05E8\u05D9\u05D9\u05DD",
morning:"\u05D1\u05D1\u05D5\u05E7\u05E8",
afternoon:"\u05D0\u05D7\u05E8 \u05D4\u05E6\u05D4\u05E8\u05D9\u05D9\u05DD",
evening:"\u05D1\u05E2\u05E8\u05D1",
night:"\u05D1\u05DC\u05D9\u05DC\u05D4"
},
wide:{
am:"\u05DC\u05E4\u05E0\u05D4\u05F4\u05E6",
pm:"\u05D0\u05D7\u05D4\u05F4\u05E6",
midnight:"\u05D7\u05E6\u05D5\u05EA",
noon:"\u05E6\u05D4\u05E8\u05D9\u05D9\u05DD",
morning:"\u05D1\u05D1\u05D5\u05E7\u05E8",
afternoon:"\u05D0\u05D7\u05E8 \u05D4\u05E6\u05D4\u05E8\u05D9\u05D9\u05DD",
evening:"\u05D1\u05E2\u05E8\u05D1",
night:"\u05D1\u05DC\u05D9\u05DC\u05D4"
}
};
var ordinalNumber34=function ordinalNumber34(dirtyNumber,options){
var number=Number(dirtyNumber);
if(number<=0||number>10)
return String(number);
var unit=String(options===null||options===void 0?void 0:options.unit);
var isFemale=["year","hour","minute","second"].indexOf(unit)>=0;
var male=[
"\u05E8\u05D0\u05E9\u05D5\u05DF",
"\u05E9\u05E0\u05D9",
"\u05E9\u05DC\u05D9\u05E9\u05D9",
"\u05E8\u05D1\u05D9\u05E2\u05D9",
"\u05D7\u05DE\u05D9\u05E9\u05D9",
"\u05E9\u05D9\u05E9\u05D9",
"\u05E9\u05D1\u05D9\u05E2\u05D9",
"\u05E9\u05DE\u05D9\u05E0\u05D9",
"\u05EA\u05E9\u05D9\u05E2\u05D9",
"\u05E2\u05E9\u05D9\u05E8\u05D9"];

var female=[
"\u05E8\u05D0\u05E9\u05D5\u05E0\u05D4",
"\u05E9\u05E0\u05D9\u05D9\u05D4",
"\u05E9\u05DC\u05D9\u05E9\u05D9\u05EA",
"\u05E8\u05D1\u05D9\u05E2\u05D9\u05EA",
"\u05D7\u05DE\u05D9\u05E9\u05D9\u05EA",
"\u05E9\u05D9\u05E9\u05D9\u05EA",
"\u05E9\u05D1\u05D9\u05E2\u05D9\u05EA",
"\u05E9\u05DE\u05D9\u05E0\u05D9\u05EA",
"\u05EA\u05E9\u05D9\u05E2\u05D9\u05EA",
"\u05E2\u05E9\u05D9\u05E8\u05D9\u05EA"];

var index=number-1;
return isFemale?female[index]:male[index];
};
var localize77={
ordinalNumber:ordinalNumber34,
era:buildLocalizeFn({
values:eraValues34,
defaultWidth:"wide"
}),
quarter:buildLocalizeFn({
values:quarterValues34,
defaultWidth:"wide",
argumentCallback:function argumentCallback(quarter){return quarter-1;}
}),
month:buildLocalizeFn({
values:monthValues34,
defaultWidth:"wide"
}),
day:buildLocalizeFn({
values:dayValues34,
defaultWidth:"wide"
}),
dayPeriod:buildLocalizeFn({
values:dayPeriodValues34,
defaultWidth:"wide",
formattingValues:formattingDayPeriodValues28,
defaultFormattingWidth:"wide"
})
};

// lib/locale/he/_lib/match.js
var matchOrdinalNumberPattern33=/^(\d+|(ראשון|שני|שלישי|רביעי|חמישי|שישי|שביעי|שמיני|תשיעי|עשירי|ראשונה|שנייה|שלישית|רביעית|חמישית|שישית|שביעית|שמינית|תשיעית|עשירית))/i;
var parseOrdinalNumberPattern33=/^(\d+|רא|שנ|של|רב|ח|שי|שב|שמ|ת|ע)/i;
var matchEraPatterns33={
narrow:/^ל(ספירה|פנה״ס)/i,
abbreviated:/^ל(ספירה|פנה״ס)/i,
wide:/^ל(פני ה)?ספירה/i
};
var parseEraPatterns33={
any:[/^לפ/i,/^לס/i]
};
var matchQuarterPatterns33={
narrow:/^[1234]/i,
abbreviated:/^q[1234]/i,
wide:/^רבעון [1234]/i
};
var parseQuarterPatterns33={
any:[/1/i,/2/i,/3/i,/4/i]
};
var matchMonthPatterns33={
narrow:/^\d+/i,
abbreviated:/^(ינו|פבר|מרץ|אפר|מאי|יוני|יולי|אוג|ספט|אוק|נוב|דצמ)׳?/i,
wide:/^(ינואר|פברואר|מרץ|אפריל|מאי|יוני|יולי|אוגוסט|ספטמבר|אוקטובר|נובמבר|דצמבר)/i
};
var parseMonthPatterns33={
narrow:[
/^1$/i,
/^2/i,
/^3/i,
/^4/i,
/^5/i,
/^6/i,
/^7/i,
/^8/i,
/^9/i,
/^10/i,
/^11/i,
/^12/i],

any:[
/^ינ/i,
/^פ/i,
/^מר/i,
/^אפ/i,
/^מא/i,
/^יונ/i,
/^יול/i,
/^אוג/i,
/^ס/i,
/^אוק/i,
/^נ/i,
/^ד/i]

};
var matchDayPatterns33={
narrow:/^[אבגדהוש]׳/i,
short:/^[אבגדהוש]׳/i,
abbreviated:/^(שבת|יום (א|ב|ג|ד|ה|ו)׳)/i,
wide:/^יום (ראשון|שני|שלישי|רביעי|חמישי|שישי|שבת)/i
};
var parseDayPatterns33={
abbreviated:[/א׳$/i,/ב׳$/i,/ג׳$/i,/ד׳$/i,/ה׳$/i,/ו׳$/i,/^ש/i],
wide:[/ן$/i,/ני$/i,/לישי$/i,/עי$/i,/מישי$/i,/שישי$/i,/ת$/i],
any:[/^א/i,/^ב/i,/^ג/i,/^ד/i,/^ה/i,/^ו/i,/^ש/i]
};
var matchDayPeriodPatterns33={
any:/^(אחר ה|ב)?(חצות|צהריים|בוקר|ערב|לילה|אחה״צ|לפנה״צ)/i
};
var parseDayPeriodPatterns33={
any:{
am:/^לפ/i,
pm:/^אחה/i,
midnight:/^ח/i,
noon:/^צ/i,
morning:/בוקר/i,
afternoon:/בצ|אחר/i,
evening:/ערב/i,
night:/לילה/i
}
};
var ordinalName=["\u05E8\u05D0","\u05E9\u05E0","\u05E9\u05DC","\u05E8\u05D1","\u05D7","\u05E9\u05D9","\u05E9\u05D1","\u05E9\u05DE","\u05EA","\u05E2"];
var match75={
ordinalNumber:buildMatchPatternFn({
matchPattern:matchOrdinalNumberPattern33,
parsePattern:parseOrdinalNumberPattern33,
valueCallback:function valueCallback(value){
var number=parseInt(value,10);
return isNaN(number)?ordinalName.indexOf(value)+1:number;
}
}),
era:buildMatchFn({
matchPatterns:matchEraPatterns33,
defaultMatchWidth:"wide",
parsePatterns:parseEraPatterns33,
defaultParseWidth:"any"
}),
quarter:buildMatchFn({
matchPatterns:matchQuarterPatterns33,
defaultMatchWidth:"wide",
parsePatterns:parseQuarterPatterns33,
defaultParseWidth:"any",
valueCallback:function valueCallback(index){return index+1;}
}),
month:buildMatchFn({
matchPatterns:matchMonthPatterns33,
defaultMatchWidth:"wide",
parsePatterns:parseMonthPatterns33,
defaultParseWidth:"any"
}),
day:buildMatchFn({
matchPatterns:matchDayPatterns33,
defaultMatchWidth:"wide",
parsePatterns:parseDayPatterns33,
defaultParseWidth:"any"
}),
dayPeriod:buildMatchFn({
matchPatterns:matchDayPeriodPatterns33,
defaultMatchWidth:"any",
parsePatterns:parseDayPeriodPatterns33,
defaultParseWidth:"any"
})
};

// lib/locale/he.js
var _he={
code:"he",
formatDistance:formatDistance76,
formatLong:formatLong83,
formatRelative:formatRelative76,
localize:localize77,
match:match75,
options:{
weekStartsOn:0,
firstWeekContainsDate:1
}
};
// lib/locale/hi/_lib/localize.js
function localeToNumber(locale){
var enNumber=locale.toString().replace(/[१२३४५६७८९०]/g,function(match77){
return numberValues2.number[match77];
});
return Number(enNumber);
}
function numberToLocale2(enNumber){
return enNumber.toString().replace(/\d/g,function(match77){
return numberValues2.locale[match77];
});
}
var numberValues2={
locale:{
1:"\u0967",
2:"\u0968",
3:"\u0969",
4:"\u096A",
5:"\u096B",
6:"\u096C",
7:"\u096D",
8:"\u096E",
9:"\u096F",
0:"\u0966"
},
number:{
"\u0967":"1",
"\u0968":"2",
"\u0969":"3",
"\u096A":"4",
"\u096B":"5",
"\u096C":"6",
"\u096D":"7",
"\u096E":"8",
"\u096F":"9",
"\u0966":"0"
}
};
var eraValues35={
narrow:["\u0908\u0938\u093E-\u092A\u0942\u0930\u094D\u0935","\u0908\u0938\u094D\u0935\u0940"],
abbreviated:["\u0908\u0938\u093E-\u092A\u0942\u0930\u094D\u0935","\u0908\u0938\u094D\u0935\u0940"],
wide:["\u0908\u0938\u093E-\u092A\u0942\u0930\u094D\u0935","\u0908\u0938\u0935\u0940 \u0938\u0928"]
};
var quarterValues35={
narrow:["1","2","3","4"],
abbreviated:["\u0924\u093F1","\u0924\u093F2","\u0924\u093F3","\u0924\u093F4"],
wide:["\u092A\u0939\u0932\u0940 \u0924\u093F\u092E\u093E\u0939\u0940","\u0926\u0942\u0938\u0930\u0940 \u0924\u093F\u092E\u093E\u0939\u0940","\u0924\u0940\u0938\u0930\u0940 \u0924\u093F\u092E\u093E\u0939\u0940","\u091A\u094C\u0925\u0940 \u0924\u093F\u092E\u093E\u0939\u0940"]
};
var monthValues35={
narrow:[
"\u091C",
"\u092B\u093C",
"\u092E\u093E",
"\u0905",
"\u092E\u0908",
"\u091C\u0942",
"\u091C\u0941",
"\u0905\u0917",
"\u0938\u093F",
"\u0905\u0915\u094D\u091F\u0942",
"\u0928",
"\u0926\u093F"],

abbreviated:[
"\u091C\u0928",
"\u092B\u093C\u0930",
"\u092E\u093E\u0930\u094D\u091A",
"\u0905\u092A\u094D\u0930\u0948\u0932",
"\u092E\u0908",
"\u091C\u0942\u0928",
"\u091C\u0941\u0932",
"\u0905\u0917",
"\u0938\u093F\u0924",
"\u0905\u0915\u094D\u091F\u0942",
"\u0928\u0935",
"\u0926\u093F\u0938"],

wide:[
"\u091C\u0928\u0935\u0930\u0940",
"\u092B\u093C\u0930\u0935\u0930\u0940",
"\u092E\u093E\u0930\u094D\u091A",
"\u0905\u092A\u094D\u0930\u0948\u0932",
"\u092E\u0908",
"\u091C\u0942\u0928",
"\u091C\u0941\u0932\u093E\u0908",
"\u0905\u0917\u0938\u094D\u0924",
"\u0938\u093F\u0924\u0902\u092C\u0930",
"\u0905\u0915\u094D\u091F\u0942\u092C\u0930",
"\u0928\u0935\u0902\u092C\u0930",
"\u0926\u093F\u0938\u0902\u092C\u0930"]

};
var dayValues35={
narrow:["\u0930","\u0938\u094B","\u092E\u0902","\u092C\u0941","\u0917\u0941","\u0936\u0941","\u0936"],
short:["\u0930","\u0938\u094B","\u092E\u0902","\u092C\u0941","\u0917\u0941","\u0936\u0941","\u0936"],
abbreviated:["\u0930\u0935\u093F","\u0938\u094B\u092E","\u092E\u0902\u0917\u0932","\u092C\u0941\u0927","\u0917\u0941\u0930\u0941","\u0936\u0941\u0915\u094D\u0930","\u0936\u0928\u093F"],
wide:[
"\u0930\u0935\u093F\u0935\u093E\u0930",
"\u0938\u094B\u092E\u0935\u093E\u0930",
"\u092E\u0902\u0917\u0932\u0935\u093E\u0930",
"\u092C\u0941\u0927\u0935\u093E\u0930",
"\u0917\u0941\u0930\u0941\u0935\u093E\u0930",
"\u0936\u0941\u0915\u094D\u0930\u0935\u093E\u0930",
"\u0936\u0928\u093F\u0935\u093E\u0930"]

};
var dayPeriodValues35={
narrow:{
am:"\u092A\u0942\u0930\u094D\u0935\u093E\u0939\u094D\u0928",
pm:"\u0905\u092A\u0930\u093E\u0939\u094D\u0928",
midnight:"\u092E\u0927\u094D\u092F\u0930\u093E\u0924\u094D\u0930\u093F",
noon:"\u0926\u094B\u092A\u0939\u0930",
morning:"\u0938\u0941\u092C\u0939",
afternoon:"\u0926\u094B\u092A\u0939\u0930",
evening:"\u0936\u093E\u092E",
night:"\u0930\u093E\u0924"
},
abbreviated:{
am:"\u092A\u0942\u0930\u094D\u0935\u093E\u0939\u094D\u0928",
pm:"\u0905\u092A\u0930\u093E\u0939\u094D\u0928",
midnight:"\u092E\u0927\u094D\u092F\u0930\u093E\u0924\u094D\u0930\u093F",
noon:"\u0926\u094B\u092A\u0939\u0930",
morning:"\u0938\u0941\u092C\u0939",
afternoon:"\u0926\u094B\u092A\u0939\u0930",
evening:"\u0936\u093E\u092E",
night:"\u0930\u093E\u0924"
},
wide:{
am:"\u092A\u0942\u0930\u094D\u0935\u093E\u0939\u094D\u0928",
pm:"\u0905\u092A\u0930\u093E\u0939\u094D\u0928",
midnight:"\u092E\u0927\u094D\u092F\u0930\u093E\u0924\u094D\u0930\u093F",
noon:"\u0926\u094B\u092A\u0939\u0930",
morning:"\u0938\u0941\u092C\u0939",
afternoon:"\u0926\u094B\u092A\u0939\u0930",
evening:"\u0936\u093E\u092E",
night:"\u0930\u093E\u0924"
}
};
var formattingDayPeriodValues29={
narrow:{
am:"\u092A\u0942\u0930\u094D\u0935\u093E\u0939\u094D\u0928",
pm:"\u0905\u092A\u0930\u093E\u0939\u094D\u0928",
midnight:"\u092E\u0927\u094D\u092F\u0930\u093E\u0924\u094D\u0930\u093F",
noon:"\u0926\u094B\u092A\u0939\u0930",
morning:"\u0938\u0941\u092C\u0939",
afternoon:"\u0926\u094B\u092A\u0939\u0930",
evening:"\u0936\u093E\u092E",
night:"\u0930\u093E\u0924"
},
abbreviated:{
am:"\u092A\u0942\u0930\u094D\u0935\u093E\u0939\u094D\u0928",
pm:"\u0905\u092A\u0930\u093E\u0939\u094D\u0928",
midnight:"\u092E\u0927\u094D\u092F\u0930\u093E\u0924\u094D\u0930\u093F",
noon:"\u0926\u094B\u092A\u0939\u0930",
morning:"\u0938\u0941\u092C\u0939",
afternoon:"\u0926\u094B\u092A\u0939\u0930",
evening:"\u0936\u093E\u092E",
night:"\u0930\u093E\u0924"
},
wide:{
am:"\u092A\u0942\u0930\u094D\u0935\u093E\u0939\u094D\u0928",
pm:"\u0905\u092A\u0930\u093E\u0939\u094D\u0928",
midnight:"\u092E\u0927\u094D\u092F\u0930\u093E\u0924\u094D\u0930\u093F",
noon:"\u0926\u094B\u092A\u0939\u0930",
morning:"\u0938\u0941\u092C\u0939",
afternoon:"\u0926\u094B\u092A\u0939\u0930",
evening:"\u0936\u093E\u092E",
night:"\u0930\u093E\u0924"
}
};
var ordinalNumber35=function ordinalNumber35(dirtyNumber,_options){
var number=Number(dirtyNumber);
return numberToLocale2(number);
};
var localize79={
ordinalNumber:ordinalNumber35,
era:buildLocalizeFn({
values:eraValues35,
defaultWidth:"wide"
}),
quarter:buildLocalizeFn({
values:quarterValues35,
defaultWidth:"wide",
argumentCallback:function argumentCallback(quarter){return quarter-1;}
}),
month:buildLocalizeFn({
values:monthValues35,
defaultWidth:"wide"
}),
day:buildLocalizeFn({
values:dayValues35,
defaultWidth:"wide"
}),
dayPeriod:buildLocalizeFn({
values:dayPeriodValues35,
defaultWidth:"wide",
formattingValues:formattingDayPeriodValues29,
defaultFormattingWidth:"wide"
})
};

// lib/locale/hi/_lib/formatDistance.js
var formatDistanceLocale35={
lessThanXSeconds:{
one:"\u0967 \u0938\u0947\u0915\u0902\u0921 \u0938\u0947 \u0915\u092E",
other:"{{count}} \u0938\u0947\u0915\u0902\u0921 \u0938\u0947 \u0915\u092E"
},
xSeconds:{
one:"\u0967 \u0938\u0947\u0915\u0902\u0921",
other:"{{count}} \u0938\u0947\u0915\u0902\u0921"
},
halfAMinute:"\u0906\u0927\u093E \u092E\u093F\u0928\u091F",
lessThanXMinutes:{
one:"\u0967 \u092E\u093F\u0928\u091F \u0938\u0947 \u0915\u092E",
other:"{{count}} \u092E\u093F\u0928\u091F \u0938\u0947 \u0915\u092E"
},
xMinutes:{
one:"\u0967 \u092E\u093F\u0928\u091F",
other:"{{count}} \u092E\u093F\u0928\u091F"
},
aboutXHours:{
one:"\u0932\u0917\u092D\u0917 \u0967 \u0918\u0902\u091F\u093E",
other:"\u0932\u0917\u092D\u0917 {{count}} \u0918\u0902\u091F\u0947"
},
xHours:{
one:"\u0967 \u0918\u0902\u091F\u093E",
other:"{{count}} \u0918\u0902\u091F\u0947"
},
xDays:{
one:"\u0967 \u0926\u093F\u0928",
other:"{{count}} \u0926\u093F\u0928"
},
aboutXWeeks:{
one:"\u0932\u0917\u092D\u0917 \u0967 \u0938\u092A\u094D\u0924\u093E\u0939",
other:"\u0932\u0917\u092D\u0917 {{count}} \u0938\u092A\u094D\u0924\u093E\u0939"
},
xWeeks:{
one:"\u0967 \u0938\u092A\u094D\u0924\u093E\u0939",
other:"{{count}} \u0938\u092A\u094D\u0924\u093E\u0939"
},
aboutXMonths:{
one:"\u0932\u0917\u092D\u0917 \u0967 \u092E\u0939\u0940\u0928\u093E",
other:"\u0932\u0917\u092D\u0917 {{count}} \u092E\u0939\u0940\u0928\u0947"
},
xMonths:{
one:"\u0967 \u092E\u0939\u0940\u0928\u093E",
other:"{{count}} \u092E\u0939\u0940\u0928\u0947"
},
aboutXYears:{
one:"\u0932\u0917\u092D\u0917 \u0967 \u0935\u0930\u094D\u0937",
other:"\u0932\u0917\u092D\u0917 {{count}} \u0935\u0930\u094D\u0937"
},
xYears:{
one:"\u0967 \u0935\u0930\u094D\u0937",
other:"{{count}} \u0935\u0930\u094D\u0937"
},
overXYears:{
one:"\u0967 \u0935\u0930\u094D\u0937 \u0938\u0947 \u0905\u0927\u093F\u0915",
other:"{{count}} \u0935\u0930\u094D\u0937 \u0938\u0947 \u0905\u0927\u093F\u0915"
},
almostXYears:{
one:"\u0932\u0917\u092D\u0917 \u0967 \u0935\u0930\u094D\u0937",
other:"\u0932\u0917\u092D\u0917 {{count}} \u0935\u0930\u094D\u0937"
}
};
var formatDistance78=function formatDistance78(token,count,options){
var result;
var tokenValue=formatDistanceLocale35[token];
if(typeof tokenValue==="string"){
result=tokenValue;
}else if(count===1){
result=tokenValue.one;
}else{
result=tokenValue.other.replace("{{count}}",numberToLocale2(count));
}
if(options!==null&&options!==void 0&&options.addSuffix){
if(options.comparison&&options.comparison>0){
return result+"\u092E\u0947 ";
}else{
return result+" \u092A\u0939\u0932\u0947";
}
}
return result;
};

// lib/locale/hi/_lib/formatLong.js
var dateFormats42={
full:"EEEE, do MMMM, y",
long:"do MMMM, y",
medium:"d MMM, y",
short:"dd/MM/yyyy"
};
var timeFormats42={
full:"h:mm:ss a zzzz",
long:"h:mm:ss a z",
medium:"h:mm:ss a",
short:"h:mm a"
};
var dateTimeFormats42={
full:"{{date}} '\u0915\u094B' {{time}}",
long:"{{date}} '\u0915\u094B' {{time}}",
medium:"{{date}}, {{time}}",
short:"{{date}}, {{time}}"
};
var formatLong85={
date:buildFormatLongFn({
formats:dateFormats42,
defaultWidth:"full"
}),
time:buildFormatLongFn({
formats:timeFormats42,
defaultWidth:"full"
}),
dateTime:buildFormatLongFn({
formats:dateTimeFormats42,
defaultWidth:"full"
})
};

// lib/locale/hi/_lib/formatRelative.js
var formatRelativeLocale35={
lastWeek:"'\u092A\u093F\u091B\u0932\u0947' eeee p",
yesterday:"'\u0915\u0932' p",
today:"'\u0906\u091C' p",
tomorrow:"'\u0915\u0932' p",
nextWeek:"eeee '\u0915\u094B' p",
other:"P"
};
var formatRelative78=function formatRelative78(token,_date,_baseDate,_options){return formatRelativeLocale35[token];};

// lib/locale/hi/_lib/match.js
var matchOrdinalNumberPattern34=/^[०१२३४५६७८९]+/i;
var parseOrdinalNumberPattern34=/^[०१२३४५६७८९]+/i;
var matchEraPatterns34={
narrow:/^(ईसा-पूर्व|ईस्वी)/i,
abbreviated:/^(ईसा\.?\s?पूर्व\.?|ईसा\.?)/i,
wide:/^(ईसा-पूर्व|ईसवी पूर्व|ईसवी सन|ईसवी)/i
};
var parseEraPatterns34={
any:[/^b/i,/^(a|c)/i]
};
var matchQuarterPatterns34={
narrow:/^[1234]/i,
abbreviated:/^ति[1234]/i,
wide:/^[1234](पहली|दूसरी|तीसरी|चौथी)? तिमाही/i
};
var parseQuarterPatterns34={
any:[/1/i,/2/i,/3/i,/4/i]
};
var matchMonthPatterns34={
narrow:/^[जफ़माअप्मईजूनजुअगसिअक्तनदि]/i,
abbreviated:/^(जन|फ़र|मार्च|अप्|मई|जून|जुल|अग|सित|अक्तू|नव|दिस)/i,
wide:/^(जनवरी|फ़रवरी|मार्च|अप्रैल|मई|जून|जुलाई|अगस्त|सितंबर|अक्तूबर|नवंबर|दिसंबर)/i
};
var parseMonthPatterns34={
narrow:[
/^ज/i,
/^फ़/i,
/^मा/i,
/^अप्/i,
/^मई/i,
/^जू/i,
/^जु/i,
/^अग/i,
/^सि/i,
/^अक्तू/i,
/^न/i,
/^दि/i],

any:[
/^जन/i,
/^फ़/i,
/^मा/i,
/^अप्/i,
/^मई/i,
/^जू/i,
/^जु/i,
/^अग/i,
/^सि/i,
/^अक्तू/i,
/^नव/i,
/^दिस/i]

};
var matchDayPatterns34={
narrow:/^[रविसोममंगलबुधगुरुशुक्रशनि]/i,
short:/^(रवि|सोम|मंगल|बुध|गुरु|शुक्र|शनि)/i,
abbreviated:/^(रवि|सोम|मंगल|बुध|गुरु|शुक्र|शनि)/i,
wide:/^(रविवार|सोमवार|मंगलवार|बुधवार|गुरुवार|शुक्रवार|शनिवार)/i
};
var parseDayPatterns34={
narrow:[/^रवि/i,/^सोम/i,/^मंगल/i,/^बुध/i,/^गुरु/i,/^शुक्र/i,/^शनि/i],
any:[/^रवि/i,/^सोम/i,/^मंगल/i,/^बुध/i,/^गुरु/i,/^शुक्र/i,/^शनि/i]
};
var matchDayPeriodPatterns34={
narrow:/^(पू|अ|म|द.\?|सु|दो|शा|रा)/i,
any:/^(पूर्वाह्न|अपराह्न|म|द.\?|सु|दो|शा|रा)/i
};
var parseDayPeriodPatterns34={
any:{
am:/^पूर्वाह्न/i,
pm:/^अपराह्न/i,
midnight:/^मध्य/i,
noon:/^दो/i,
morning:/सु/i,
afternoon:/दो/i,
evening:/शा/i,
night:/रा/i
}
};
var match77={
ordinalNumber:buildMatchPatternFn({
matchPattern:matchOrdinalNumberPattern34,
parsePattern:parseOrdinalNumberPattern34,
valueCallback:localeToNumber
}),
era:buildMatchFn({
matchPatterns:matchEraPatterns34,
defaultMatchWidth:"wide",
parsePatterns:parseEraPatterns34,
defaultParseWidth:"any"
}),
quarter:buildMatchFn({
matchPatterns:matchQuarterPatterns34,
defaultMatchWidth:"wide",
parsePatterns:parseQuarterPatterns34,
defaultParseWidth:"any",
valueCallback:function valueCallback(index){return index+1;}
}),
month:buildMatchFn({
matchPatterns:matchMonthPatterns34,
defaultMatchWidth:"wide",
parsePatterns:parseMonthPatterns34,
defaultParseWidth:"any"
}),
day:buildMatchFn({
matchPatterns:matchDayPatterns34,
defaultMatchWidth:"wide",
parsePatterns:parseDayPatterns34,
defaultParseWidth:"any"
}),
dayPeriod:buildMatchFn({
matchPatterns:matchDayPeriodPatterns34,
defaultMatchWidth:"any",
parsePatterns:parseDayPeriodPatterns34,
defaultParseWidth:"any"
})
};

// lib/locale/hi.js
var _hi={
code:"hi",
formatDistance:formatDistance78,
formatLong:formatLong85,
formatRelative:formatRelative78,
localize:localize79,
match:match77,
options:{
weekStartsOn:0,
firstWeekContainsDate:4
}
};
// lib/locale/hr/_lib/formatDistance.js
var formatDistanceLocale36={
lessThanXSeconds:{
one:{
standalone:"manje od 1 sekunde",
withPrepositionAgo:"manje od 1 sekunde",
withPrepositionIn:"manje od 1 sekundu"
},
dual:"manje od {{count}} sekunde",
other:"manje od {{count}} sekundi"
},
xSeconds:{
one:{
standalone:"1 sekunda",
withPrepositionAgo:"1 sekunde",
withPrepositionIn:"1 sekundu"
},
dual:"{{count}} sekunde",
other:"{{count}} sekundi"
},
halfAMinute:"pola minute",
lessThanXMinutes:{
one:{
standalone:"manje od 1 minute",
withPrepositionAgo:"manje od 1 minute",
withPrepositionIn:"manje od 1 minutu"
},
dual:"manje od {{count}} minute",
other:"manje od {{count}} minuta"
},
xMinutes:{
one:{
standalone:"1 minuta",
withPrepositionAgo:"1 minute",
withPrepositionIn:"1 minutu"
},
dual:"{{count}} minute",
other:"{{count}} minuta"
},
aboutXHours:{
one:{
standalone:"oko 1 sat",
withPrepositionAgo:"oko 1 sat",
withPrepositionIn:"oko 1 sat"
},
dual:"oko {{count}} sata",
other:"oko {{count}} sati"
},
xHours:{
one:{
standalone:"1 sat",
withPrepositionAgo:"1 sat",
withPrepositionIn:"1 sat"
},
dual:"{{count}} sata",
other:"{{count}} sati"
},
xDays:{
one:{
standalone:"1 dan",
withPrepositionAgo:"1 dan",
withPrepositionIn:"1 dan"
},
dual:"{{count}} dana",
other:"{{count}} dana"
},
aboutXWeeks:{
one:{
standalone:"oko 1 tjedan",
withPrepositionAgo:"oko 1 tjedan",
withPrepositionIn:"oko 1 tjedan"
},
dual:"oko {{count}} tjedna",
other:"oko {{count}} tjedana"
},
xWeeks:{
one:{
standalone:"1 tjedan",
withPrepositionAgo:"1 tjedan",
withPrepositionIn:"1 tjedan"
},
dual:"{{count}} tjedna",
other:"{{count}} tjedana"
},
aboutXMonths:{
one:{
standalone:"oko 1 mjesec",
withPrepositionAgo:"oko 1 mjesec",
withPrepositionIn:"oko 1 mjesec"
},
dual:"oko {{count}} mjeseca",
other:"oko {{count}} mjeseci"
},
xMonths:{
one:{
standalone:"1 mjesec",
withPrepositionAgo:"1 mjesec",
withPrepositionIn:"1 mjesec"
},
dual:"{{count}} mjeseca",
other:"{{count}} mjeseci"
},
aboutXYears:{
one:{
standalone:"oko 1 godinu",
withPrepositionAgo:"oko 1 godinu",
withPrepositionIn:"oko 1 godinu"
},
dual:"oko {{count}} godine",
other:"oko {{count}} godina"
},
xYears:{
one:{
standalone:"1 godina",
withPrepositionAgo:"1 godine",
withPrepositionIn:"1 godinu"
},
dual:"{{count}} godine",
other:"{{count}} godina"
},
overXYears:{
one:{
standalone:"preko 1 godinu",
withPrepositionAgo:"preko 1 godinu",
withPrepositionIn:"preko 1 godinu"
},
dual:"preko {{count}} godine",
other:"preko {{count}} godina"
},
almostXYears:{
one:{
standalone:"gotovo 1 godinu",
withPrepositionAgo:"gotovo 1 godinu",
withPrepositionIn:"gotovo 1 godinu"
},
dual:"gotovo {{count}} godine",
other:"gotovo {{count}} godina"
}
};
var formatDistance80=function formatDistance80(token,count,options){
var result;
var tokenValue=formatDistanceLocale36[token];
if(typeof tokenValue==="string"){
result=tokenValue;
}else if(count===1){
if(options!==null&&options!==void 0&&options.addSuffix){
if(options.comparison&&options.comparison>0){
result=tokenValue.one.withPrepositionIn;
}else{
result=tokenValue.one.withPrepositionAgo;
}
}else{
result=tokenValue.one.standalone;
}
}else if(count%10>1&&count%10<5&&String(count).substr(-2,1)!=="1"){
result=tokenValue.dual.replace("{{count}}",String(count));
}else{
result=tokenValue.other.replace("{{count}}",String(count));
}
if(options!==null&&options!==void 0&&options.addSuffix){
if(options.comparison&&options.comparison>0){
return"za "+result;
}else{
return"prije "+result;
}
}
return result;
};

// lib/locale/hr/_lib/formatLong.js
var dateFormats43={
full:"EEEE, d. MMMM y.",
long:"d. MMMM y.",
medium:"d. MMM y.",
short:"dd. MM. y."
};
var timeFormats43={
full:"HH:mm:ss (zzzz)",
long:"HH:mm:ss z",
medium:"HH:mm:ss",
short:"HH:mm"
};
var dateTimeFormats43={
full:"{{date}} 'u' {{time}}",
long:"{{date}} 'u' {{time}}",
medium:"{{date}} {{time}}",
short:"{{date}} {{time}}"
};
var formatLong87={
date:buildFormatLongFn({
formats:dateFormats43,
defaultWidth:"full"
}),
time:buildFormatLongFn({
formats:timeFormats43,
defaultWidth:"full"
}),
dateTime:buildFormatLongFn({
formats:dateTimeFormats43,
defaultWidth:"full"
})
};

// lib/locale/hr/_lib/formatRelative.js
var formatRelativeLocale36={
lastWeek:function lastWeek(date){
switch(date.getDay()){
case 0:
return"'pro\u0161lu nedjelju u' p";
case 3:
return"'pro\u0161lu srijedu u' p";
case 6:
return"'pro\u0161lu subotu u' p";
default:
return"'pro\u0161li' EEEE 'u' p";
}
},
yesterday:"'ju\u010Der u' p",
today:"'danas u' p",
tomorrow:"'sutra u' p",
nextWeek:function nextWeek(date){
switch(date.getDay()){
case 0:
return"'idu\u0107u nedjelju u' p";
case 3:
return"'idu\u0107u srijedu u' p";
case 6:
return"'idu\u0107u subotu u' p";
default:
return"'pro\u0161li' EEEE 'u' p";
}
},
other:"P"
};
var formatRelative80=function formatRelative80(token,date,_baseDate,_options){
var format=formatRelativeLocale36[token];
if(typeof format==="function"){
return format(date);
}
return format;
};

// lib/locale/hr/_lib/localize.js
var eraValues36={
narrow:["pr.n.e.","AD"],
abbreviated:["pr. Kr.","po. Kr."],
wide:["Prije Krista","Poslije Krista"]
};
var quarterValues36={
narrow:["1.","2.","3.","4."],
abbreviated:["1. kv.","2. kv.","3. kv.","4. kv."],
wide:["1. kvartal","2. kvartal","3. kvartal","4. kvartal"]
};
var monthValues36={
narrow:[
"1.",
"2.",
"3.",
"4.",
"5.",
"6.",
"7.",
"8.",
"9.",
"10.",
"11.",
"12."],

abbreviated:[
"sij",
"velj",
"o\u017Eu",
"tra",
"svi",
"lip",
"srp",
"kol",
"ruj",
"lis",
"stu",
"pro"],

wide:[
"sije\u010Danj",
"velja\u010Da",
"o\u017Eujak",
"travanj",
"svibanj",
"lipanj",
"srpanj",
"kolovoz",
"rujan",
"listopad",
"studeni",
"prosinac"]

};
var formattingMonthValues9={
narrow:[
"1.",
"2.",
"3.",
"4.",
"5.",
"6.",
"7.",
"8.",
"9.",
"10.",
"11.",
"12."],

abbreviated:[
"sij",
"velj",
"o\u017Eu",
"tra",
"svi",
"lip",
"srp",
"kol",
"ruj",
"lis",
"stu",
"pro"],

wide:[
"sije\u010Dnja",
"velja\u010De",
"o\u017Eujka",
"travnja",
"svibnja",
"lipnja",
"srpnja",
"kolovoza",
"rujna",
"listopada",
"studenog",
"prosinca"]

};
var dayValues36={
narrow:["N","P","U","S","\u010C","P","S"],
short:["ned","pon","uto","sri","\u010Det","pet","sub"],
abbreviated:["ned","pon","uto","sri","\u010Det","pet","sub"],
wide:[
"nedjelja",
"ponedjeljak",
"utorak",
"srijeda",
"\u010Detvrtak",
"petak",
"subota"]

};
var formattingDayPeriodValues30={
narrow:{
am:"AM",
pm:"PM",
midnight:"pono\u0107",
noon:"podne",
morning:"ujutro",
afternoon:"popodne",
evening:"nave\u010Der",
night:"no\u0107u"
},
abbreviated:{
am:"AM",
pm:"PM",
midnight:"pono\u0107",
noon:"podne",
morning:"ujutro",
afternoon:"popodne",
evening:"nave\u010Der",
night:"no\u0107u"
},
wide:{
am:"AM",
pm:"PM",
midnight:"pono\u0107",
noon:"podne",
morning:"ujutro",
afternoon:"poslije podne",
evening:"nave\u010Der",
night:"no\u0107u"
}
};
var dayPeriodValues36={
narrow:{
am:"AM",
pm:"PM",
midnight:"pono\u0107",
noon:"podne",
morning:"ujutro",
afternoon:"popodne",
evening:"nave\u010Der",
night:"no\u0107u"
},
abbreviated:{
am:"AM",
pm:"PM",
midnight:"pono\u0107",
noon:"podne",
morning:"ujutro",
afternoon:"popodne",
evening:"nave\u010Der",
night:"no\u0107u"
},
wide:{
am:"AM",
pm:"PM",
midnight:"pono\u0107",
noon:"podne",
morning:"ujutro",
afternoon:"poslije podne",
evening:"nave\u010Der",
night:"no\u0107u"
}
};
var ordinalNumber36=function ordinalNumber36(dirtyNumber,_options){
var number=Number(dirtyNumber);
return number+".";
};
var localize83={
ordinalNumber:ordinalNumber36,
era:buildLocalizeFn({
values:eraValues36,
defaultWidth:"wide"
}),
quarter:buildLocalizeFn({
values:quarterValues36,
defaultWidth:"wide",
argumentCallback:function argumentCallback(quarter){return quarter-1;}
}),
month:buildLocalizeFn({
values:monthValues36,
defaultWidth:"wide",
formattingValues:formattingMonthValues9,
defaultFormattingWidth:"wide"
}),
day:buildLocalizeFn({
values:dayValues36,
defaultWidth:"wide"
}),
dayPeriod:buildLocalizeFn({
values:dayPeriodValues36,
defaultWidth:"wide",
formattingValues:formattingDayPeriodValues30,
defaultFormattingWidth:"wide"
})
};

// lib/locale/hr/_lib/match.js
var matchOrdinalNumberPattern35=/^(\d+)\./i;
var parseOrdinalNumberPattern35=/\d+/i;
var matchEraPatterns35={
narrow:/^(pr\.n\.e\.|AD)/i,
abbreviated:/^(pr\.\s?Kr\.|po\.\s?Kr\.)/i,
wide:/^(Prije Krista|prije nove ere|Poslije Krista|nova era)/i
};
var parseEraPatterns35={
any:[/^pr/i,/^(po|nova)/i]
};
var matchQuarterPatterns35={
narrow:/^[1234]/i,
abbreviated:/^[1234]\.\s?kv\.?/i,
wide:/^[1234]\. kvartal/i
};
var parseQuarterPatterns35={
any:[/1/i,/2/i,/3/i,/4/i]
};
var matchMonthPatterns35={
narrow:/^(10|11|12|[123456789])\./i,
abbreviated:/^(sij|velj|(ožu|ozu)|tra|svi|lip|srp|kol|ruj|lis|stu|pro)/i,
wide:/^((siječanj|siječnja|sijecanj|sijecnja)|(veljača|veljače|veljaca|veljace)|(ožujak|ožujka|ozujak|ozujka)|(travanj|travnja)|(svibanj|svibnja)|(lipanj|lipnja)|(srpanj|srpnja)|(kolovoz|kolovoza)|(rujan|rujna)|(listopad|listopada)|(studeni|studenog)|(prosinac|prosinca))/i
};
var parseMonthPatterns35={
narrow:[
/1/i,
/2/i,
/3/i,
/4/i,
/5/i,
/6/i,
/7/i,
/8/i,
/9/i,
/10/i,
/11/i,
/12/i],

abbreviated:[
/^sij/i,
/^velj/i,
/^(ožu|ozu)/i,
/^tra/i,
/^svi/i,
/^lip/i,
/^srp/i,
/^kol/i,
/^ruj/i,
/^lis/i,
/^stu/i,
/^pro/i],

wide:[
/^sij/i,
/^velj/i,
/^(ožu|ozu)/i,
/^tra/i,
/^svi/i,
/^lip/i,
/^srp/i,
/^kol/i,
/^ruj/i,
/^lis/i,
/^stu/i,
/^pro/i]

};
var matchDayPatterns35={
narrow:/^[npusčc]/i,
short:/^(ned|pon|uto|sri|(čet|cet)|pet|sub)/i,
abbreviated:/^(ned|pon|uto|sri|(čet|cet)|pet|sub)/i,
wide:/^(nedjelja|ponedjeljak|utorak|srijeda|(četvrtak|cetvrtak)|petak|subota)/i
};
var parseDayPatterns35={
narrow:[/^s/i,/^m/i,/^t/i,/^w/i,/^t/i,/^f/i,/^s/i],
any:[/^su/i,/^m/i,/^tu/i,/^w/i,/^th/i,/^f/i,/^sa/i]
};
var matchDayPeriodPatterns35={
any:/^(am|pm|ponoc|ponoć|(po)?podne|navecer|navečer|noću|poslije podne|ujutro)/i
};
var parseDayPeriodPatterns35={
any:{
am:/^a/i,
pm:/^p/i,
midnight:/^pono/i,
noon:/^pod/i,
morning:/jutro/i,
afternoon:/(poslije\s|po)+podne/i,
evening:/(navece|naveče)/i,
night:/(nocu|noću)/i
}
};
var match79={
ordinalNumber:buildMatchPatternFn({
matchPattern:matchOrdinalNumberPattern35,
parsePattern:parseOrdinalNumberPattern35,
valueCallback:function valueCallback(value){return parseInt(value,10);}
}),
era:buildMatchFn({
matchPatterns:matchEraPatterns35,
defaultMatchWidth:"wide",
parsePatterns:parseEraPatterns35,
defaultParseWidth:"any"
}),
quarter:buildMatchFn({
matchPatterns:matchQuarterPatterns35,
defaultMatchWidth:"wide",
parsePatterns:parseQuarterPatterns35,
defaultParseWidth:"any",
valueCallback:function valueCallback(index){return index+1;}
}),
month:buildMatchFn({
matchPatterns:matchMonthPatterns35,
defaultMatchWidth:"wide",
parsePatterns:parseMonthPatterns35,
defaultParseWidth:"wide"
}),
day:buildMatchFn({
matchPatterns:matchDayPatterns35,
defaultMatchWidth:"wide",
parsePatterns:parseDayPatterns35,
defaultParseWidth:"any"
}),
dayPeriod:buildMatchFn({
matchPatterns:matchDayPeriodPatterns35,
defaultMatchWidth:"any",
parsePatterns:parseDayPeriodPatterns35,
defaultParseWidth:"any"
})
};

// lib/locale/hr.js
var _hr={
code:"hr",
formatDistance:formatDistance80,
formatLong:formatLong87,
formatRelative:formatRelative80,
localize:localize83,
match:match79,
options:{
weekStartsOn:1,
firstWeekContainsDate:1
}
};
// lib/locale/ht/_lib/formatDistance.js
var formatDistanceLocale37={
lessThanXSeconds:{
one:"mwens pase yon segond",
other:"mwens pase {{count}} segond"
},
xSeconds:{
one:"1 segond",
other:"{{count}} segond"
},
halfAMinute:"30 segond",
lessThanXMinutes:{
one:"mwens pase yon minit",
other:"mwens pase {{count}} minit"
},
xMinutes:{
one:"1 minit",
other:"{{count}} minit"
},
aboutXHours:{
one:"anviwon in\xE8",
other:"anviwon {{count}} \xE8"
},
xHours:{
one:"1 l\xE8",
other:"{{count}} l\xE8"
},
xDays:{
one:"1 jou",
other:"{{count}} jou"
},
aboutXWeeks:{
one:"anviwon 1 sem\xE8n",
other:"anviwon {{count}} sem\xE8n"
},
xWeeks:{
one:"1 sem\xE8n",
other:"{{count}} sem\xE8n"
},
aboutXMonths:{
one:"anviwon 1 mwa",
other:"anviwon {{count}} mwa"
},
xMonths:{
one:"1 mwa",
other:"{{count}} mwa"
},
aboutXYears:{
one:"anviwon 1 an",
other:"anviwon {{count}} an"
},
xYears:{
one:"1 an",
other:"{{count}} an"
},
overXYears:{
one:"plis pase 1 an",
other:"plis pase {{count}} an"
},
almostXYears:{
one:"pr\xE8ske 1 an",
other:"pr\xE8ske {{count}} an"
}
};
var formatDistance82=function formatDistance82(token,count,options){
var result;
var tokenValue=formatDistanceLocale37[token];
if(typeof tokenValue==="string"){
result=tokenValue;
}else if(count===1){
result=tokenValue.one;
}else{
result=tokenValue.other.replace("{{count}}",String(count));
}
if(options!==null&&options!==void 0&&options.addSuffix){
if(options.comparison&&options.comparison>0){
return"nan "+result;
}else{
return"sa f\xE8 "+result;
}
}
return result;
};

// lib/locale/ht/_lib/formatLong.js
var dateFormats44={
full:"EEEE d MMMM y",
long:"d MMMM y",
medium:"d MMM y",
short:"dd/MM/y"
};
var timeFormats44={
full:"HH:mm:ss zzzz",
long:"HH:mm:ss z",
medium:"HH:mm:ss",
short:"HH:mm"
};
var dateTimeFormats44={
full:"{{date}} 'nan l\xE8' {{time}}",
long:"{{date}} 'nan l\xE8' {{time}}",
medium:"{{date}}, {{time}}",
short:"{{date}}, {{time}}"
};
var formatLong89={
date:buildFormatLongFn({
formats:dateFormats44,
defaultWidth:"full"
}),
time:buildFormatLongFn({
formats:timeFormats44,
defaultWidth:"full"
}),
dateTime:buildFormatLongFn({
formats:dateTimeFormats44,
defaultWidth:"full"
})
};

// lib/locale/ht/_lib/formatRelative.js
var formatRelativeLocale37={
lastWeek:"eeee 'pase nan l\xE8' p",
yesterday:"'y\xE8 nan l\xE8' p",
today:"'jodi a' p",
tomorrow:"'demen nan l\xE8' p'",
nextWeek:"eeee 'pwochen nan l\xE8' p",
other:"P"
};
var formatRelative82=function formatRelative82(token,_date,_baseDate,_options){return formatRelativeLocale37[token];};

// lib/locale/ht/_lib/localize.js
var eraValues37={
narrow:["av. J.-K","ap. J.-K"],
abbreviated:["av. J.-K","ap. J.-K"],
wide:["anvan Jezi Kris","apre Jezi Kris"]
};
var quarterValues37={
narrow:["T1","T2","T3","T4"],
abbreviated:["1ye trim.","2y\xE8m trim.","3y\xE8m trim.","4y\xE8m trim."],
wide:["1ye trim\xE8s","2y\xE8m trim\xE8s","3y\xE8m trim\xE8s","4y\xE8m trim\xE8s"]
};
var monthValues37={
narrow:["J","F","M","A","M","J","J","O","S","O","N","D"],
abbreviated:[
"janv.",
"fevr.",
"mas",
"avr.",
"me",
"jen",
"jiy\xE8",
"out",
"sept.",
"okt.",
"nov.",
"des."],

wide:[
"janvye",
"fevrye",
"mas",
"avril",
"me",
"jen",
"jiy\xE8",
"out",
"septanm",
"okt\xF2b",
"novanm",
"desanm"]

};
var dayValues37={
narrow:["D","L","M","M","J","V","S"],
short:["di","le","ma","m\xE8","je","va","sa"],
abbreviated:["dim.","len.","mad.","m\xE8k.","jed.","van.","sam."],
wide:["dimanch","lendi","madi","m\xE8kredi","jedi","vandredi","samdi"]
};
var dayPeriodValues37={
narrow:{
am:"AM",
pm:"PM",
midnight:"minwit",
noon:"midi",
morning:"mat.",
afternoon:"ap.m.",
evening:"swa",
night:"mat."
},
abbreviated:{
am:"AM",
pm:"PM",
midnight:"minwit",
noon:"midi",
morning:"maten",
afternoon:"apr\xE8midi",
evening:"swa",
night:"maten"
},
wide:{
am:"AM",
pm:"PM",
midnight:"minwit",
noon:"midi",
morning:"nan maten",
afternoon:"nan apr\xE8midi",
evening:"nan asw\xE8",
night:"nan maten"
}
};
var ordinalNumber37=function ordinalNumber37(dirtyNumber,_options){
var number=Number(dirtyNumber);
if(number===0)
return String(number);
var suffix=number===1?"ye":"y\xE8m";
return number+suffix;
};
var localize85={
ordinalNumber:ordinalNumber37,
era:buildLocalizeFn({
values:eraValues37,
defaultWidth:"wide"
}),
quarter:buildLocalizeFn({
values:quarterValues37,
defaultWidth:"wide",
argumentCallback:function argumentCallback(quarter){return quarter-1;}
}),
month:buildLocalizeFn({
values:monthValues37,
defaultWidth:"wide"
}),
day:buildLocalizeFn({
values:dayValues37,
defaultWidth:"wide"
}),
dayPeriod:buildLocalizeFn({
values:dayPeriodValues37,
defaultWidth:"wide"
})
};

// lib/locale/ht/_lib/match.js
var matchOrdinalNumberPattern36=/^(\d+)(ye|yèm)?/i;
var parseOrdinalNumberPattern36=/\d+/i;
var matchEraPatterns36={
narrow:/^(av\.J\.K|ap\.J\.K|ap\.J\.-K)/i,
abbreviated:/^(av\.J\.-K|av\.J-K|apr\.J\.-K|apr\.J-K|ap\.J-K)/i,
wide:/^(avan Jezi Kris|apre Jezi Kris)/i
};
var parseEraPatterns36={
any:[/^av/i,/^ap/i]
};
var matchQuarterPatterns36={
narrow:/^[1234]/i,
abbreviated:/^t[1234]/i,
wide:/^[1234](ye|yèm)? trimès/i
};
var parseQuarterPatterns36={
any:[/1/i,/2/i,/3/i,/4/i]
};
var matchMonthPatterns36={
narrow:/^[jfmasond]/i,
abbreviated:/^(janv|fevr|mas|avr|me|jen|jiyè|out|sept|okt|nov|des)\.?/i,
wide:/^(janvye|fevrye|mas|avril|me|jen|jiyè|out|septanm|oktòb|novanm|desanm)/i
};
var parseMonthPatterns36={
narrow:[
/^j/i,
/^f/i,
/^m/i,
/^a/i,
/^m/i,
/^j/i,
/^j/i,
/^o/i,
/^s/i,
/^o/i,
/^n/i,
/^d/i],

any:[
/^ja/i,
/^f/i,
/^ma/i,
/^av/i,
/^me/i,
/^je/i,
/^ji/i,
/^ou/i,
/^s/i,
/^ok/i,
/^n/i,
/^d/i]

};
var matchDayPatterns36={
narrow:/^[lmjvsd]/i,
short:/^(di|le|ma|me|je|va|sa)/i,
abbreviated:/^(dim|len|mad|mèk|jed|van|sam)\.?/i,
wide:/^(dimanch|lendi|madi|mèkredi|jedi|vandredi|samdi)/i
};
var parseDayPatterns36={
narrow:[/^d/i,/^l/i,/^m/i,/^m/i,/^j/i,/^v/i,/^s/i],
any:[/^di/i,/^le/i,/^ma/i,/^mè/i,/^je/i,/^va/i,/^sa/i]
};
var matchDayPeriodPatterns36={
narrow:/^(a|p|minwit|midi|mat\.?|ap\.?m\.?|swa)/i,
any:/^([ap]\.?\s?m\.?|nan maten|nan aprèmidi|nan aswè)/i
};
var parseDayPeriodPatterns36={
any:{
am:/^a/i,
pm:/^p/i,
midnight:/^min/i,
noon:/^mid/i,
morning:/mat/i,
afternoon:/ap/i,
evening:/sw/i,
night:/nwit/i
}
};
var match81={
ordinalNumber:buildMatchPatternFn({
matchPattern:matchOrdinalNumberPattern36,
parsePattern:parseOrdinalNumberPattern36,
valueCallback:function valueCallback(value){return parseInt(value,10);}
}),
era:buildMatchFn({
matchPatterns:matchEraPatterns36,
defaultMatchWidth:"wide",
parsePatterns:parseEraPatterns36,
defaultParseWidth:"any"
}),
quarter:buildMatchFn({
matchPatterns:matchQuarterPatterns36,
defaultMatchWidth:"wide",
parsePatterns:parseQuarterPatterns36,
defaultParseWidth:"any",
valueCallback:function valueCallback(index){return index+1;}
}),
month:buildMatchFn({
matchPatterns:matchMonthPatterns36,
defaultMatchWidth:"wide",
parsePatterns:parseMonthPatterns36,
defaultParseWidth:"any"
}),
day:buildMatchFn({
matchPatterns:matchDayPatterns36,
defaultMatchWidth:"wide",
parsePatterns:parseDayPatterns36,
defaultParseWidth:"any"
}),
dayPeriod:buildMatchFn({
matchPatterns:matchDayPeriodPatterns36,
defaultMatchWidth:"any",
parsePatterns:parseDayPeriodPatterns36,
defaultParseWidth:"any"
})
};

// lib/locale/ht.js
var _ht={
code:"ht",
formatDistance:formatDistance82,
formatLong:formatLong89,
formatRelative:formatRelative82,
localize:localize85,
match:match81,
options:{
weekStartsOn:1,
firstWeekContainsDate:4
}
};
// lib/locale/hu/_lib/formatDistance.js
var translations={
about:"k\xF6r\xFClbel\xFCl",
over:"t\xF6bb mint",
almost:"majdnem",
lessthan:"kevesebb mint"
};
var withoutSuffixes={
xseconds:" m\xE1sodperc",
halfaminute:"f\xE9l perc",
xminutes:" perc",
xhours:" \xF3ra",
xdays:" nap",
xweeks:" h\xE9t",
xmonths:" h\xF3nap",
xyears:" \xE9v"
};
var withSuffixes={
xseconds:{
"-1":" m\xE1sodperccel ezel\u0151tt",
1:" m\xE1sodperc m\xFAlva",
0:" m\xE1sodperce"
},
halfaminute:{
"-1":"f\xE9l perccel ezel\u0151tt",
1:"f\xE9l perc m\xFAlva",
0:"f\xE9l perce"
},
xminutes:{
"-1":" perccel ezel\u0151tt",
1:" perc m\xFAlva",
0:" perce"
},
xhours:{
"-1":" \xF3r\xE1val ezel\u0151tt",
1:" \xF3ra m\xFAlva",
0:" \xF3r\xE1ja"
},
xdays:{
"-1":" nappal ezel\u0151tt",
1:" nap m\xFAlva",
0:" napja"
},
xweeks:{
"-1":" h\xE9ttel ezel\u0151tt",
1:" h\xE9t m\xFAlva",
0:" hete"
},
xmonths:{
"-1":" h\xF3nappal ezel\u0151tt",
1:" h\xF3nap m\xFAlva",
0:" h\xF3napja"
},
xyears:{
"-1":" \xE9vvel ezel\u0151tt",
1:" \xE9v m\xFAlva",
0:" \xE9ve"
}
};
var formatDistance84=function formatDistance84(token,count,options){
var adverb=token.match(/about|over|almost|lessthan/i);
var unit=adverb?token.replace(adverb[0],""):token;
var addSuffix=(options===null||options===void 0?void 0:options.addSuffix)===true;
var key=unit.toLowerCase();
var comparison=(options===null||options===void 0?void 0:options.comparison)||0;
var translated=addSuffix?withSuffixes[key][comparison]:withoutSuffixes[key];
var result=key==="halfaminute"?translated:count+translated;
if(adverb){
var adv=adverb[0].toLowerCase();
result=translations[adv]+" "+result;
}
return result;
};

// lib/locale/hu/_lib/formatLong.js
var dateFormats45={
full:"y. MMMM d., EEEE",
long:"y. MMMM d.",
medium:"y. MMM d.",
short:"y. MM. dd."
};
var timeFormats45={
full:"H:mm:ss zzzz",
long:"H:mm:ss z",
medium:"H:mm:ss",
short:"H:mm"
};
var dateTimeFormats45={
full:"{{date}} {{time}}",
long:"{{date}} {{time}}",
medium:"{{date}} {{time}}",
short:"{{date}} {{time}}"
};
var formatLong91={
date:buildFormatLongFn({
formats:dateFormats45,
defaultWidth:"full"
}),
time:buildFormatLongFn({
formats:timeFormats45,
defaultWidth:"full"
}),
dateTime:buildFormatLongFn({
formats:dateTimeFormats45,
defaultWidth:"full"
})
};

// lib/locale/hu/_lib/formatRelative.js
function week(isFuture){
return function(date){
var weekday=accusativeWeekdays4[date.getDay()];
var prefix=isFuture?"":"'m\xFAlt' ";
return"".concat(prefix,"'").concat(weekday,"' p'-kor'");
};
}
var accusativeWeekdays4=[
"vas\xE1rnap",
"h\xE9tf\u0151n",
"kedden",
"szerd\xE1n",
"cs\xFCt\xF6rt\xF6k\xF6n",
"p\xE9nteken",
"szombaton"];

var formatRelativeLocale38={
lastWeek:week(false),
yesterday:"'tegnap' p'-kor'",
today:"'ma' p'-kor'",
tomorrow:"'holnap' p'-kor'",
nextWeek:week(true),
other:"P"
};
var formatRelative84=function formatRelative84(token,date){
var format=formatRelativeLocale38[token];
if(typeof format==="function"){
return format(date);
}
return format;
};

// lib/locale/hu/_lib/localize.js
var eraValues38={
narrow:["ie.","isz."],
abbreviated:["i. e.","i. sz."],
wide:["Krisztus el\u0151tt","id\u0151sz\xE1m\xEDt\xE1sunk szerint"]
};
var quarterValues38={
narrow:["1.","2.","3.","4."],
abbreviated:["1. n.\xE9v","2. n.\xE9v","3. n.\xE9v","4. n.\xE9v"],
wide:["1. negyed\xE9v","2. negyed\xE9v","3. negyed\xE9v","4. negyed\xE9v"]
};
var formattingQuarterValues={
narrow:["I.","II.","III.","IV."],
abbreviated:["I. n.\xE9v","II. n.\xE9v","III. n.\xE9v","IV. n.\xE9v"],
wide:["I. negyed\xE9v","II. negyed\xE9v","III. negyed\xE9v","IV. negyed\xE9v"]
};
var monthValues38={
narrow:["J","F","M","\xC1","M","J","J","A","Sz","O","N","D"],
abbreviated:[
"jan.",
"febr.",
"m\xE1rc.",
"\xE1pr.",
"m\xE1j.",
"j\xFAn.",
"j\xFAl.",
"aug.",
"szept.",
"okt.",
"nov.",
"dec."],

wide:[
"janu\xE1r",
"febru\xE1r",
"m\xE1rcius",
"\xE1prilis",
"m\xE1jus",
"j\xFAnius",
"j\xFAlius",
"augusztus",
"szeptember",
"okt\xF3ber",
"november",
"december"]

};
var dayValues38={
narrow:["V","H","K","Sz","Cs","P","Sz"],
short:["V","H","K","Sze","Cs","P","Szo"],
abbreviated:["V","H","K","Sze","Cs","P","Szo"],
wide:[
"vas\xE1rnap",
"h\xE9tf\u0151",
"kedd",
"szerda",
"cs\xFCt\xF6rt\xF6k",
"p\xE9ntek",
"szombat"]

};
var dayPeriodValues38={
narrow:{
am:"de.",
pm:"du.",
midnight:"\xE9jf\xE9l",
noon:"d\xE9l",
morning:"reggel",
afternoon:"du.",
evening:"este",
night:"\xE9jjel"
},
abbreviated:{
am:"de.",
pm:"du.",
midnight:"\xE9jf\xE9l",
noon:"d\xE9l",
morning:"reggel",
afternoon:"du.",
evening:"este",
night:"\xE9jjel"
},
wide:{
am:"de.",
pm:"du.",
midnight:"\xE9jf\xE9l",
noon:"d\xE9l",
morning:"reggel",
afternoon:"d\xE9lut\xE1n",
evening:"este",
night:"\xE9jjel"
}
};
var ordinalNumber38=function ordinalNumber38(dirtyNumber,_options){
var number=Number(dirtyNumber);
return number+".";
};
var localize87={
ordinalNumber:ordinalNumber38,
era:buildLocalizeFn({
values:eraValues38,
defaultWidth:"wide"
}),
quarter:buildLocalizeFn({
values:quarterValues38,
defaultWidth:"wide",
argumentCallback:function argumentCallback(quarter){return quarter-1;},
formattingValues:formattingQuarterValues,
defaultFormattingWidth:"wide"
}),
month:buildLocalizeFn({
values:monthValues38,
defaultWidth:"wide"
}),
day:buildLocalizeFn({
values:dayValues38,
defaultWidth:"wide"
}),
dayPeriod:buildLocalizeFn({
values:dayPeriodValues38,
defaultWidth:"wide"
})
};

// lib/locale/hu/_lib/match.js
var matchOrdinalNumberPattern37=/^(\d+)\.?/i;
var parseOrdinalNumberPattern37=/\d+/i;
var matchEraPatterns37={
narrow:/^(ie\.|isz\.)/i,
abbreviated:/^(i\.\s?e\.?|b?\s?c\s?e|i\.\s?sz\.?)/i,
wide:/^(Krisztus előtt|időszámításunk előtt|időszámításunk szerint|i\. sz\.)/i
};
var parseEraPatterns37={
narrow:[/ie/i,/isz/i],
abbreviated:[/^(i\.?\s?e\.?|b\s?ce)/i,/^(i\.?\s?sz\.?|c\s?e)/i],
any:[/előtt/i,/(szerint|i. sz.)/i]
};
var matchQuarterPatterns37={
narrow:/^[1234]\.?/i,
abbreviated:/^[1234]?\.?\s?n\.év/i,
wide:/^([1234]|I|II|III|IV)?\.?\s?negyedév/i
};
var parseQuarterPatterns37={
any:[/1|I$/i,/2|II$/i,/3|III/i,/4|IV/i]
};
var matchMonthPatterns37={
narrow:/^[jfmaásond]|sz/i,
abbreviated:/^(jan\.?|febr\.?|márc\.?|ápr\.?|máj\.?|jún\.?|júl\.?|aug\.?|szept\.?|okt\.?|nov\.?|dec\.?)/i,
wide:/^(január|február|március|április|május|június|július|augusztus|szeptember|október|november|december)/i
};
var parseMonthPatterns37={
narrow:[
/^j/i,
/^f/i,
/^m/i,
/^a|á/i,
/^m/i,
/^j/i,
/^j/i,
/^a/i,
/^s|sz/i,
/^o/i,
/^n/i,
/^d/i],

any:[
/^ja/i,
/^f/i,
/^már/i,
/^áp/i,
/^máj/i,
/^jún/i,
/^júl/i,
/^au/i,
/^s/i,
/^o/i,
/^n/i,
/^d/i]

};
var matchDayPatterns37={
narrow:/^([vhkpc]|sz|cs|sz)/i,
short:/^([vhkp]|sze|cs|szo)/i,
abbreviated:/^([vhkp]|sze|cs|szo)/i,
wide:/^(vasárnap|hétfő|kedd|szerda|csütörtök|péntek|szombat)/i
};
var parseDayPatterns37={
narrow:[/^v/i,/^h/i,/^k/i,/^sz/i,/^c/i,/^p/i,/^sz/i],
any:[/^v/i,/^h/i,/^k/i,/^sze/i,/^c/i,/^p/i,/^szo/i]
};
var matchDayPeriodPatterns37={
any:/^((de|du)\.?|éjfél|délután|dél|reggel|este|éjjel)/i
};
var parseDayPeriodPatterns37={
any:{
am:/^de\.?/i,
pm:/^du\.?/i,
midnight:/^éjf/i,
noon:/^dé/i,
morning:/reg/i,
afternoon:/^délu\.?/i,
evening:/es/i,
night:/éjj/i
}
};
var match83={
ordinalNumber:buildMatchPatternFn({
matchPattern:matchOrdinalNumberPattern37,
parsePattern:parseOrdinalNumberPattern37,
valueCallback:function valueCallback(value){return parseInt(value,10);}
}),
era:buildMatchFn({
matchPatterns:matchEraPatterns37,
defaultMatchWidth:"wide",
parsePatterns:parseEraPatterns37,
defaultParseWidth:"any"
}),
quarter:buildMatchFn({
matchPatterns:matchQuarterPatterns37,
defaultMatchWidth:"wide",
parsePatterns:parseQuarterPatterns37,
defaultParseWidth:"any",
valueCallback:function valueCallback(index){return index+1;}
}),
month:buildMatchFn({
matchPatterns:matchMonthPatterns37,
defaultMatchWidth:"wide",
parsePatterns:parseMonthPatterns37,
defaultParseWidth:"any"
}),
day:buildMatchFn({
matchPatterns:matchDayPatterns37,
defaultMatchWidth:"wide",
parsePatterns:parseDayPatterns37,
defaultParseWidth:"any"
}),
dayPeriod:buildMatchFn({
matchPatterns:matchDayPeriodPatterns37,
defaultMatchWidth:"any",
parsePatterns:parseDayPeriodPatterns37,
defaultParseWidth:"any"
})
};

// lib/locale/hu.js
var _hu={
code:"hu",
formatDistance:formatDistance84,
formatLong:formatLong91,
formatRelative:formatRelative84,
localize:localize87,
match:match83,
options:{
weekStartsOn:1,
firstWeekContainsDate:4
}
};
// lib/locale/hy/_lib/formatDistance.js
var formatDistanceLocale38={
lessThanXSeconds:{
one:"\u0561\u057E\u0565\u056C\u056B \u0584\u056B\u0579 \u0584\u0561\u0576 1 \u057E\u0561\u0575\u0580\u056F\u0575\u0561\u0576",
other:"\u0561\u057E\u0565\u056C\u056B \u0584\u056B\u0579 \u0584\u0561\u0576 {{count}} \u057E\u0561\u0575\u0580\u056F\u0575\u0561\u0576"
},
xSeconds:{
one:"1 \u057E\u0561\u0575\u0580\u056F\u0575\u0561\u0576",
other:"{{count}} \u057E\u0561\u0575\u0580\u056F\u0575\u0561\u0576"
},
halfAMinute:"\u056F\u0565\u057D \u0580\u0578\u057A\u0565",
lessThanXMinutes:{
one:"\u0561\u057E\u0565\u056C\u056B \u0584\u056B\u0579 \u0584\u0561\u0576 1 \u0580\u0578\u057A\u0565",
other:"\u0561\u057E\u0565\u056C\u056B \u0584\u056B\u0579 \u0584\u0561\u0576 {{count}} \u0580\u0578\u057A\u0565"
},
xMinutes:{
one:"1 \u0580\u0578\u057A\u0565",
other:"{{count}} \u0580\u0578\u057A\u0565"
},
aboutXHours:{
one:"\u0574\u0578\u057F 1 \u056A\u0561\u0574",
other:"\u0574\u0578\u057F {{count}} \u056A\u0561\u0574"
},
xHours:{
one:"1 \u056A\u0561\u0574",
other:"{{count}} \u056A\u0561\u0574"
},
xDays:{
one:"1 \u0585\u0580",
other:"{{count}} \u0585\u0580"
},
aboutXWeeks:{
one:"\u0574\u0578\u057F 1 \u0577\u0561\u0562\u0561\u0569",
other:"\u0574\u0578\u057F {{count}} \u0577\u0561\u0562\u0561\u0569"
},
xWeeks:{
one:"1 \u0577\u0561\u0562\u0561\u0569",
other:"{{count}} \u0577\u0561\u0562\u0561\u0569"
},
aboutXMonths:{
one:"\u0574\u0578\u057F 1 \u0561\u0574\u056B\u057D",
other:"\u0574\u0578\u057F {{count}} \u0561\u0574\u056B\u057D"
},
xMonths:{
one:"1 \u0561\u0574\u056B\u057D",
other:"{{count}} \u0561\u0574\u056B\u057D"
},
aboutXYears:{
one:"\u0574\u0578\u057F 1 \u057F\u0561\u0580\u056B",
other:"\u0574\u0578\u057F {{count}} \u057F\u0561\u0580\u056B"
},
xYears:{
one:"1 \u057F\u0561\u0580\u056B",
other:"{{count}} \u057F\u0561\u0580\u056B"
},
overXYears:{
one:"\u0561\u057E\u0565\u056C\u056B \u0584\u0561\u0576 1 \u057F\u0561\u0580\u056B",
other:"\u0561\u057E\u0565\u056C\u056B \u0584\u0561\u0576 {{count}} \u057F\u0561\u0580\u056B"
},
almostXYears:{
one:"\u0570\u0561\u0574\u0561\u0580\u0575\u0561 1 \u057F\u0561\u0580\u056B",
other:"\u0570\u0561\u0574\u0561\u0580\u0575\u0561 {{count}} \u057F\u0561\u0580\u056B"
}
};
var formatDistance86=function formatDistance86(token,count,options){
var result;
var tokenValue=formatDistanceLocale38[token];
if(typeof tokenValue==="string"){
result=tokenValue;
}else if(count===1){
result=tokenValue.one;
}else{
result=tokenValue.other.replace("{{count}}",String(count));
}
if(options!==null&&options!==void 0&&options.addSuffix){
if(options.comparison&&options.comparison>0){
return result+" \u0570\u0565\u057F\u0578";
}else{
return result+" \u0561\u057C\u0561\u057B";
}
}
return result;
};

// lib/locale/hy/_lib/formatLong.js
var dateFormats46={
full:"d MMMM, y, EEEE",
long:"d MMMM, y",
medium:"d MMM, y",
short:"dd.MM.yyyy"
};
var timeFormats46={
full:"HH:mm:ss zzzz",
long:"HH:mm:ss z",
medium:"HH:mm:ss",
short:"HH:mm"
};
var dateTimeFormats46={
full:"{{date}} '\u056A\u2024'{{time}}",
long:"{{date}} '\u056A\u2024'{{time}}",
medium:"{{date}}, {{time}}",
short:"{{date}}, {{time}}"
};
var formatLong93={
date:buildFormatLongFn({
formats:dateFormats46,
defaultWidth:"full"
}),
time:buildFormatLongFn({
formats:timeFormats46,
defaultWidth:"full"
}),
dateTime:buildFormatLongFn({
formats:dateTimeFormats46,
defaultWidth:"full"
})
};

// lib/locale/hy/_lib/formatRelative.js
var formatRelativeLocale39={
lastWeek:"'\u0576\u0561\u056D\u0578\u0580\u0564' eeee p'\u058A\u056B\u0576'",
yesterday:"'\u0565\u0580\u0565\u056F' p'\u058A\u056B\u0576'",
today:"'\u0561\u0575\u057D\u0585\u0580' p'\u058A\u056B\u0576'",
tomorrow:"'\u057E\u0561\u0572\u0568' p'\u058A\u056B\u0576'",
nextWeek:"'\u0570\u0561\u057B\u0578\u0580\u0564' eeee p'\u058A\u056B\u0576'",
other:"P"
};
var formatRelative86=function formatRelative86(token,_date,_baseDate,_options){return formatRelativeLocale39[token];};

// lib/locale/hy/_lib/localize.js
var eraValues39={
narrow:["\u0554","\u0544"],
abbreviated:["\u0554\u0531","\u0544\u0539"],
wide:["\u0554\u0580\u056B\u057D\u057F\u0578\u057D\u056B\u0581 \u0561\u057C\u0561\u057B","\u0544\u0565\u0580 \u0569\u057E\u0561\u0580\u056F\u0578\u0582\u0569\u0575\u0561\u0576"]
};
var quarterValues39={
narrow:["1","2","3","4"],
abbreviated:["\u05541","\u05542","\u05543","\u05544"],
wide:["1\u058A\u056B\u0576 \u0584\u0561\u057C\u0578\u0580\u0564","2\u058A\u0580\u0564 \u0584\u0561\u057C\u0578\u0580\u0564","3\u058A\u0580\u0564 \u0584\u0561\u057C\u0578\u0580\u0564","4\u058A\u0580\u0564 \u0584\u0561\u057C\u0578\u0580\u0564"]
};
var monthValues39={
narrow:["\u0540","\u0553","\u0544","\u0531","\u0544","\u0540","\u0540","\u0555","\u054D","\u0540","\u0546","\u0534"],
abbreviated:[
"\u0570\u0578\u0582\u0576",
"\u0583\u0565\u057F",
"\u0574\u0561\u0580",
"\u0561\u057A\u0580",
"\u0574\u0561\u0575",
"\u0570\u0578\u0582\u0576",
"\u0570\u0578\u0582\u056C",
"\u0585\u0563\u057D",
"\u057D\u0565\u057A",
"\u0570\u0578\u056F",
"\u0576\u0578\u0575",
"\u0564\u0565\u056F"],

wide:[
"\u0570\u0578\u0582\u0576\u057E\u0561\u0580",
"\u0583\u0565\u057F\u0580\u057E\u0561\u0580",
"\u0574\u0561\u0580\u057F",
"\u0561\u057A\u0580\u056B\u056C",
"\u0574\u0561\u0575\u056B\u057D",
"\u0570\u0578\u0582\u0576\u056B\u057D",
"\u0570\u0578\u0582\u056C\u056B\u057D",
"\u0585\u0563\u0578\u057D\u057F\u0578\u057D",
"\u057D\u0565\u057A\u057F\u0565\u0574\u0562\u0565\u0580",
"\u0570\u0578\u056F\u057F\u0565\u0574\u0562\u0565\u0580",
"\u0576\u0578\u0575\u0565\u0574\u0562\u0565\u0580",
"\u0564\u0565\u056F\u057F\u0565\u0574\u0562\u0565\u0580"]

};
var dayValues39={
narrow:["\u053F","\u0535","\u0535","\u0549","\u0540","\u0548","\u0547"],
short:["\u056F\u0580","\u0565\u0580","\u0565\u0584","\u0579\u0584","\u0570\u0563","\u0578\u0582\u0580","\u0577\u0562"],
abbreviated:["\u056F\u056B\u0580","\u0565\u0580\u056F","\u0565\u0580\u0584","\u0579\u0578\u0580","\u0570\u0576\u0563","\u0578\u0582\u0580\u0562","\u0577\u0561\u0562"],
wide:[
"\u056F\u056B\u0580\u0561\u056F\u056B",
"\u0565\u0580\u056F\u0578\u0582\u0577\u0561\u0562\u0569\u056B",
"\u0565\u0580\u0565\u0584\u0577\u0561\u0562\u0569\u056B",
"\u0579\u0578\u0580\u0565\u0584\u0577\u0561\u0562\u0569\u056B",
"\u0570\u056B\u0576\u0563\u0577\u0561\u0562\u0569\u056B",
"\u0578\u0582\u0580\u0562\u0561\u0569",
"\u0577\u0561\u0562\u0561\u0569"]

};
var dayPeriodValues39={
narrow:{
am:"a",
pm:"p",
midnight:"\u056F\u0565\u057D\u0563\u0577",
noon:"\u056F\u0565\u057D\u0585\u0580",
morning:"\u0561\u057C\u0561\u057E\u0578\u057F",
afternoon:"\u0581\u0565\u0580\u0565\u056F",
evening:"\u0565\u0580\u0565\u056F\u0578",
night:"\u0563\u056B\u0577\u0565\u0580"
},
abbreviated:{
am:"AM",
pm:"PM",
midnight:"\u056F\u0565\u057D\u0563\u056B\u0577\u0565\u0580",
noon:"\u056F\u0565\u057D\u0585\u0580",
morning:"\u0561\u057C\u0561\u057E\u0578\u057F",
afternoon:"\u0581\u0565\u0580\u0565\u056F",
evening:"\u0565\u0580\u0565\u056F\u0578",
night:"\u0563\u056B\u0577\u0565\u0580"
},
wide:{
am:"a.m.",
pm:"p.m.",
midnight:"\u056F\u0565\u057D\u0563\u056B\u0577\u0565\u0580",
noon:"\u056F\u0565\u057D\u0585\u0580",
morning:"\u0561\u057C\u0561\u057E\u0578\u057F",
afternoon:"\u0581\u0565\u0580\u0565\u056F",
evening:"\u0565\u0580\u0565\u056F\u0578",
night:"\u0563\u056B\u0577\u0565\u0580"
}
};
var formattingDayPeriodValues31={
narrow:{
am:"a",
pm:"p",
midnight:"\u056F\u0565\u057D\u0563\u0577",
noon:"\u056F\u0565\u057D\u0585\u0580",
morning:"\u0561\u057C\u0561\u057E\u0578\u057F\u0568",
afternoon:"\u0581\u0565\u0580\u0565\u056F\u0568",
evening:"\u0565\u0580\u0565\u056F\u0578\u0575\u0561\u0576",
night:"\u0563\u056B\u0577\u0565\u0580\u0568"
},
abbreviated:{
am:"AM",
pm:"PM",
midnight:"\u056F\u0565\u057D\u0563\u056B\u0577\u0565\u0580\u056B\u0576",
noon:"\u056F\u0565\u057D\u0585\u0580\u056B\u0576",
morning:"\u0561\u057C\u0561\u057E\u0578\u057F\u0568",
afternoon:"\u0581\u0565\u0580\u0565\u056F\u0568",
evening:"\u0565\u0580\u0565\u056F\u0578\u0575\u0561\u0576",
night:"\u0563\u056B\u0577\u0565\u0580\u0568"
},
wide:{
am:"a.m.",
pm:"p.m.",
midnight:"\u056F\u0565\u057D\u0563\u056B\u0577\u0565\u0580\u056B\u0576",
noon:"\u056F\u0565\u057D\u0585\u0580\u056B\u0576",
morning:"\u0561\u057C\u0561\u057E\u0578\u057F\u0568",
afternoon:"\u0581\u0565\u0580\u0565\u056F\u0568",
evening:"\u0565\u0580\u0565\u056F\u0578\u0575\u0561\u0576",
night:"\u0563\u056B\u0577\u0565\u0580\u0568"
}
};
var ordinalNumber39=function ordinalNumber39(dirtyNumber,_options){
var number=Number(dirtyNumber);
var rem100=number%100;
if(rem100<10){
if(rem100%10===1){
return number+"\u058A\u056B\u0576";
}
}
return number+"\u058A\u0580\u0564";
};
var localize89={
ordinalNumber:ordinalNumber39,
era:buildLocalizeFn({
values:eraValues39,
defaultWidth:"wide"
}),
quarter:buildLocalizeFn({
values:quarterValues39,
defaultWidth:"wide",
argumentCallback:function argumentCallback(quarter){return quarter-1;}
}),
month:buildLocalizeFn({
values:monthValues39,
defaultWidth:"wide"
}),
day:buildLocalizeFn({
values:dayValues39,
defaultWidth:"wide"
}),
dayPeriod:buildLocalizeFn({
values:dayPeriodValues39,
defaultWidth:"wide",
formattingValues:formattingDayPeriodValues31,
defaultFormattingWidth:"wide"
})
};

// lib/locale/hy/_lib/match.js
var matchOrdinalNumberPattern38=/^(\d+)((-|֊)?(ին|րդ))?/i;
var parseOrdinalNumberPattern38=/\d+/i;
var matchEraPatterns38={
narrow:/^(Ք|Մ)/i,
abbreviated:/^(Ք\.?\s?Ա\.?|Մ\.?\s?Թ\.?\s?Ա\.?|Մ\.?\s?Թ\.?|Ք\.?\s?Հ\.?)/i,
wide:/^(քրիստոսից առաջ|մեր թվարկությունից առաջ|մեր թվարկության|քրիստոսից հետո)/i
};
var parseEraPatterns38={
any:[/^ք/i,/^մ/i]
};
var matchQuarterPatterns38={
narrow:/^[1234]/i,
abbreviated:/^ք[1234]/i,
wide:/^[1234]((-|֊)?(ին|րդ)) քառորդ/i
};
var parseQuarterPatterns38={
any:[/1/i,/2/i,/3/i,/4/i]
};
var matchMonthPatterns38={
narrow:/^[հփմաօսնդ]/i,
abbreviated:/^(հուն|փետ|մար|ապր|մայ|հուն|հուլ|օգս|սեպ|հոկ|նոյ|դեկ)/i,
wide:/^(հունվար|փետրվար|մարտ|ապրիլ|մայիս|հունիս|հուլիս|օգոստոս|սեպտեմբեր|հոկտեմբեր|նոյեմբեր|դեկտեմբեր)/i
};
var parseMonthPatterns38={
narrow:[
/^հ/i,
/^փ/i,
/^մ/i,
/^ա/i,
/^մ/i,
/^հ/i,
/^հ/i,
/^օ/i,
/^ս/i,
/^հ/i,
/^ն/i,
/^դ/i],

any:[
/^հու/i,
/^փ/i,
/^մար/i,
/^ա/i,
/^մայ/i,
/^հուն/i,
/^հուլ/i,
/^օ/i,
/^ս/i,
/^հոկ/i,
/^ն/i,
/^դ/i]

};
var matchDayPatterns38={
narrow:/^[եչհոշկ]/i,
short:/^(կր|եր|եք|չք|հգ|ուր|շբ)/i,
abbreviated:/^(կիր|երկ|երք|չոր|հնգ|ուրբ|շաբ)/i,
wide:/^(կիրակի|երկուշաբթի|երեքշաբթի|չորեքշաբթի|հինգշաբթի|ուրբաթ|շաբաթ)/i
};
var parseDayPatterns38={
narrow:[/^կ/i,/^ե/i,/^ե/i,/^չ/i,/^հ/i,/^(ո|Ո)/,/^շ/i],
short:[/^կ/i,/^եր/i,/^եք/i,/^չ/i,/^հ/i,/^(ո|Ո)/,/^շ/i],
abbreviated:[/^կ/i,/^երկ/i,/^երք/i,/^չ/i,/^հ/i,/^(ո|Ո)/,/^շ/i],
wide:[/^կ/i,/^երկ/i,/^երե/i,/^չ/i,/^հ/i,/^(ո|Ո)/,/^շ/i]
};
var matchDayPeriodPatterns38={
narrow:/^([ap]|կեսգշ|կեսօր|(առավոտը?|ցերեկը?|երեկո(յան)?|գիշերը?))/i,
any:/^([ap]\.?\s?m\.?|կեսգիշեր(ին)?|կեսօր(ին)?|(առավոտը?|ցերեկը?|երեկո(յան)?|գիշերը?))/i
};
var parseDayPeriodPatterns38={
any:{
am:/^a/i,
pm:/^p/i,
midnight:/կեսգիշեր/i,
noon:/կեսօր/i,
morning:/առավոտ/i,
afternoon:/ցերեկ/i,
evening:/երեկո/i,
night:/գիշեր/i
}
};
var match85={
ordinalNumber:buildMatchPatternFn({
matchPattern:matchOrdinalNumberPattern38,
parsePattern:parseOrdinalNumberPattern38,
valueCallback:function valueCallback(value){return parseInt(value,10);}
}),
era:buildMatchFn({
matchPatterns:matchEraPatterns38,
defaultMatchWidth:"wide",
parsePatterns:parseEraPatterns38,
defaultParseWidth:"any"
}),
quarter:buildMatchFn({
matchPatterns:matchQuarterPatterns38,
defaultMatchWidth:"wide",
parsePatterns:parseQuarterPatterns38,
defaultParseWidth:"any",
valueCallback:function valueCallback(index){return index+1;}
}),
month:buildMatchFn({
matchPatterns:matchMonthPatterns38,
defaultMatchWidth:"wide",
parsePatterns:parseMonthPatterns38,
defaultParseWidth:"any"
}),
day:buildMatchFn({
matchPatterns:matchDayPatterns38,
defaultMatchWidth:"wide",
parsePatterns:parseDayPatterns38,
defaultParseWidth:"wide"
}),
dayPeriod:buildMatchFn({
matchPatterns:matchDayPeriodPatterns38,
defaultMatchWidth:"any",
parsePatterns:parseDayPeriodPatterns38,
defaultParseWidth:"any"
})
};

// lib/locale/hy.js
var _hy={
code:"hy",
formatDistance:formatDistance86,
formatLong:formatLong93,
formatRelative:formatRelative86,
localize:localize89,
match:match85,
options:{
weekStartsOn:1,
firstWeekContainsDate:1
}
};
// lib/locale/id/_lib/formatDistance.js
var formatDistanceLocale39={
lessThanXSeconds:{
one:"kurang dari 1 detik",
other:"kurang dari {{count}} detik"
},
xSeconds:{
one:"1 detik",
other:"{{count}} detik"
},
halfAMinute:"setengah menit",
lessThanXMinutes:{
one:"kurang dari 1 menit",
other:"kurang dari {{count}} menit"
},
xMinutes:{
one:"1 menit",
other:"{{count}} menit"
},
aboutXHours:{
one:"sekitar 1 jam",
other:"sekitar {{count}} jam"
},
xHours:{
one:"1 jam",
other:"{{count}} jam"
},
xDays:{
one:"1 hari",
other:"{{count}} hari"
},
aboutXWeeks:{
one:"sekitar 1 minggu",
other:"sekitar {{count}} minggu"
},
xWeeks:{
one:"1 minggu",
other:"{{count}} minggu"
},
aboutXMonths:{
one:"sekitar 1 bulan",
other:"sekitar {{count}} bulan"
},
xMonths:{
one:"1 bulan",
other:"{{count}} bulan"
},
aboutXYears:{
one:"sekitar 1 tahun",
other:"sekitar {{count}} tahun"
},
xYears:{
one:"1 tahun",
other:"{{count}} tahun"
},
overXYears:{
one:"lebih dari 1 tahun",
other:"lebih dari {{count}} tahun"
},
almostXYears:{
one:"hampir 1 tahun",
other:"hampir {{count}} tahun"
}
};
var formatDistance88=function formatDistance88(token,count,options){
var result;
var tokenValue=formatDistanceLocale39[token];
if(typeof tokenValue==="string"){
result=tokenValue;
}else if(count===1){
result=tokenValue.one;
}else{
result=tokenValue.other.replace("{{count}}",count.toString());
}
if(options!==null&&options!==void 0&&options.addSuffix){
if(options.comparison&&options.comparison>0){
return"dalam waktu "+result;
}else{
return result+" yang lalu";
}
}
return result;
};

// lib/locale/id/_lib/formatLong.js
var dateFormats47={
full:"EEEE, d MMMM yyyy",
long:"d MMMM yyyy",
medium:"d MMM yyyy",
short:"d/M/yyyy"
};
var timeFormats47={
full:"HH.mm.ss",
long:"HH.mm.ss",
medium:"HH.mm",
short:"HH.mm"
};
var dateTimeFormats47={
full:"{{date}} 'pukul' {{time}}",
long:"{{date}} 'pukul' {{time}}",
medium:"{{date}}, {{time}}",
short:"{{date}}, {{time}}"
};
var formatLong95={
date:buildFormatLongFn({
formats:dateFormats47,
defaultWidth:"full"
}),
time:buildFormatLongFn({
formats:timeFormats47,
defaultWidth:"full"
}),
dateTime:buildFormatLongFn({
formats:dateTimeFormats47,
defaultWidth:"full"
})
};

// lib/locale/id/_lib/formatRelative.js
var formatRelativeLocale40={
lastWeek:"eeee 'lalu pukul' p",
yesterday:"'Kemarin pukul' p",
today:"'Hari ini pukul' p",
tomorrow:"'Besok pukul' p",
nextWeek:"eeee 'pukul' p",
other:"P"
};
var formatRelative88=function formatRelative88(token,_date,_baseDate,_options){return formatRelativeLocale40[token];};

// lib/locale/id/_lib/localize.js
var eraValues40={
narrow:["SM","M"],
abbreviated:["SM","M"],
wide:["Sebelum Masehi","Masehi"]
};
var quarterValues40={
narrow:["1","2","3","4"],
abbreviated:["K1","K2","K3","K4"],
wide:["Kuartal ke-1","Kuartal ke-2","Kuartal ke-3","Kuartal ke-4"]
};
var monthValues40={
narrow:["J","F","M","A","M","J","J","A","S","O","N","D"],
abbreviated:[
"Jan",
"Feb",
"Mar",
"Apr",
"Mei",
"Jun",
"Jul",
"Agt",
"Sep",
"Okt",
"Nov",
"Des"],

wide:[
"Januari",
"Februari",
"Maret",
"April",
"Mei",
"Juni",
"Juli",
"Agustus",
"September",
"Oktober",
"November",
"Desember"]

};
var dayValues40={
narrow:["M","S","S","R","K","J","S"],
short:["Min","Sen","Sel","Rab","Kam","Jum","Sab"],
abbreviated:["Min","Sen","Sel","Rab","Kam","Jum","Sab"],
wide:["Minggu","Senin","Selasa","Rabu","Kamis","Jumat","Sabtu"]
};
var dayPeriodValues40={
narrow:{
am:"AM",
pm:"PM",
midnight:"tengah malam",
noon:"tengah hari",
morning:"pagi",
afternoon:"siang",
evening:"sore",
night:"malam"
},
abbreviated:{
am:"AM",
pm:"PM",
midnight:"tengah malam",
noon:"tengah hari",
morning:"pagi",
afternoon:"siang",
evening:"sore",
night:"malam"
},
wide:{
am:"AM",
pm:"PM",
midnight:"tengah malam",
noon:"tengah hari",
morning:"pagi",
afternoon:"siang",
evening:"sore",
night:"malam"
}
};
var formattingDayPeriodValues32={
narrow:{
am:"AM",
pm:"PM",
midnight:"tengah malam",
noon:"tengah hari",
morning:"pagi",
afternoon:"siang",
evening:"sore",
night:"malam"
},
abbreviated:{
am:"AM",
pm:"PM",
midnight:"tengah malam",
noon:"tengah hari",
morning:"pagi",
afternoon:"siang",
evening:"sore",
night:"malam"
},
wide:{
am:"AM",
pm:"PM",
midnight:"tengah malam",
noon:"tengah hari",
morning:"pagi",
afternoon:"siang",
evening:"sore",
night:"malam"
}
};
var ordinalNumber40=function ordinalNumber40(dirtyNumber,_options){
var number=Number(dirtyNumber);
return"ke-"+number;
};
var localize91={
ordinalNumber:ordinalNumber40,
era:buildLocalizeFn({
values:eraValues40,
defaultWidth:"wide"
}),
quarter:buildLocalizeFn({
values:quarterValues40,
defaultWidth:"wide",
argumentCallback:function argumentCallback(quarter){return quarter-1;}
}),
month:buildLocalizeFn({
values:monthValues40,
defaultWidth:"wide"
}),
day:buildLocalizeFn({
values:dayValues40,
defaultWidth:"wide"
}),
dayPeriod:buildLocalizeFn({
values:dayPeriodValues40,
defaultWidth:"wide",
formattingValues:formattingDayPeriodValues32,
defaultFormattingWidth:"wide"
})
};

// lib/locale/id/_lib/match.js
var matchOrdinalNumberPattern39=/^ke-(\d+)?/i;
var parseOrdinalNumberPattern39=/\d+/i;
var matchEraPatterns39={
narrow:/^(sm|m)/i,
abbreviated:/^(s\.?\s?m\.?|s\.?\s?e\.?\s?u\.?|m\.?|e\.?\s?u\.?)/i,
wide:/^(sebelum masehi|sebelum era umum|masehi|era umum)/i
};
var parseEraPatterns39={
any:[/^s/i,/^(m|e)/i]
};
var matchQuarterPatterns39={
narrow:/^[1234]/i,
abbreviated:/^K-?\s[1234]/i,
wide:/^Kuartal ke-?\s?[1234]/i
};
var parseQuarterPatterns39={
any:[/1/i,/2/i,/3/i,/4/i]
};
var matchMonthPatterns39={
narrow:/^[jfmasond]/i,
abbreviated:/^(jan|feb|mar|apr|mei|jun|jul|agt|sep|okt|nov|des)/i,
wide:/^(januari|februari|maret|april|mei|juni|juli|agustus|september|oktober|november|desember)/i
};
var parseMonthPatterns39={
narrow:[
/^j/i,
/^f/i,
/^m/i,
/^a/i,
/^m/i,
/^j/i,
/^j/i,
/^a/i,
/^s/i,
/^o/i,
/^n/i,
/^d/i],

any:[
/^ja/i,
/^f/i,
/^ma/i,
/^ap/i,
/^me/i,
/^jun/i,
/^jul/i,
/^ag/i,
/^s/i,
/^o/i,
/^n/i,
/^d/i]

};
var matchDayPatterns39={
narrow:/^[srkjm]/i,
short:/^(min|sen|sel|rab|kam|jum|sab)/i,
abbreviated:/^(min|sen|sel|rab|kam|jum|sab)/i,
wide:/^(minggu|senin|selasa|rabu|kamis|jumat|sabtu)/i
};
var parseDayPatterns39={
narrow:[/^m/i,/^s/i,/^s/i,/^r/i,/^k/i,/^j/i,/^s/i],
any:[/^m/i,/^sen/i,/^sel/i,/^r/i,/^k/i,/^j/i,/^sa/i]
};
var matchDayPeriodPatterns39={
narrow:/^(a|p|tengah m|tengah h|(di(\swaktu)?) (pagi|siang|sore|malam))/i,
any:/^([ap]\.?\s?m\.?|tengah malam|tengah hari|(di(\swaktu)?) (pagi|siang|sore|malam))/i
};
var parseDayPeriodPatterns39={
any:{
am:/^a/i,
pm:/^pm/i,
midnight:/^tengah m/i,
noon:/^tengah h/i,
morning:/pagi/i,
afternoon:/siang/i,
evening:/sore/i,
night:/malam/i
}
};
var match87={
ordinalNumber:buildMatchPatternFn({
matchPattern:matchOrdinalNumberPattern39,
parsePattern:parseOrdinalNumberPattern39,
valueCallback:function valueCallback(value){return parseInt(value,10);}
}),
era:buildMatchFn({
matchPatterns:matchEraPatterns39,
defaultMatchWidth:"wide",
parsePatterns:parseEraPatterns39,
defaultParseWidth:"any"
}),
quarter:buildMatchFn({
matchPatterns:matchQuarterPatterns39,
defaultMatchWidth:"wide",
parsePatterns:parseQuarterPatterns39,
defaultParseWidth:"any",
valueCallback:function valueCallback(index){return index+1;}
}),
month:buildMatchFn({
matchPatterns:matchMonthPatterns39,
defaultMatchWidth:"wide",
parsePatterns:parseMonthPatterns39,
defaultParseWidth:"any"
}),
day:buildMatchFn({
matchPatterns:matchDayPatterns39,
defaultMatchWidth:"wide",
parsePatterns:parseDayPatterns39,
defaultParseWidth:"any"
}),
dayPeriod:buildMatchFn({
matchPatterns:matchDayPeriodPatterns39,
defaultMatchWidth:"any",
parsePatterns:parseDayPeriodPatterns39,
defaultParseWidth:"any"
})
};

// lib/locale/id.js
var _id={
code:"id",
formatDistance:formatDistance88,
formatLong:formatLong95,
formatRelative:formatRelative88,
localize:localize91,
match:match87,
options:{
weekStartsOn:1,
firstWeekContainsDate:1
}
};
// lib/locale/is/_lib/formatDistance.js
var formatDistanceLocale40={
lessThanXSeconds:{
one:"minna en 1 sek\xFAnda",
other:"minna en {{count}} sek\xFAndur"
},
xSeconds:{
one:"1 sek\xFAnda",
other:"{{count}} sek\xFAndur"
},
halfAMinute:"h\xE1lf m\xEDn\xFAta",
lessThanXMinutes:{
one:"minna en 1 m\xEDn\xFAta",
other:"minna en {{count}} m\xEDn\xFAtur"
},
xMinutes:{
one:"1 m\xEDn\xFAta",
other:"{{count}} m\xEDn\xFAtur"
},
aboutXHours:{
one:"u.\xFE.b. 1 klukkustund",
other:"u.\xFE.b. {{count}} klukkustundir"
},
xHours:{
one:"1 klukkustund",
other:"{{count}} klukkustundir"
},
xDays:{
one:"1 dagur",
other:"{{count}} dagar"
},
aboutXWeeks:{
one:"um viku",
other:"um {{count}} vikur"
},
xWeeks:{
one:"1 viku",
other:"{{count}} vikur"
},
aboutXMonths:{
one:"u.\xFE.b. 1 m\xE1nu\xF0ur",
other:"u.\xFE.b. {{count}} m\xE1nu\xF0ir"
},
xMonths:{
one:"1 m\xE1nu\xF0ur",
other:"{{count}} m\xE1nu\xF0ir"
},
aboutXYears:{
one:"u.\xFE.b. 1 \xE1r",
other:"u.\xFE.b. {{count}} \xE1r"
},
xYears:{
one:"1 \xE1r",
other:"{{count}} \xE1r"
},
overXYears:{
one:"meira en 1 \xE1r",
other:"meira en {{count}} \xE1r"
},
almostXYears:{
one:"n\xE6stum 1 \xE1r",
other:"n\xE6stum {{count}} \xE1r"
}
};
var formatDistance90=function formatDistance90(token,count,options){
var result;
var tokenValue=formatDistanceLocale40[token];
if(typeof tokenValue==="string"){
result=tokenValue;
}else if(count===1){
result=tokenValue.one;
}else{
result=tokenValue.other.replace("{{count}}",count.toString());
}
if(options!==null&&options!==void 0&&options.addSuffix){
if(options.comparison&&options.comparison>0){
return"\xED "+result;
}else{
return result+" s\xED\xF0an";
}
}
return result;
};

// lib/locale/is/_lib/formatLong.js
var dateFormats48={
full:"EEEE, do MMMM y",
long:"do MMMM y",
medium:"do MMM y",
short:"d.MM.y"
};
var timeFormats48={
full:"'kl'. HH:mm:ss zzzz",
long:"HH:mm:ss z",
medium:"HH:mm:ss",
short:"HH:mm"
};
var dateTimeFormats48={
full:"{{date}} 'kl.' {{time}}",
long:"{{date}} 'kl.' {{time}}",
medium:"{{date}} {{time}}",
short:"{{date}} {{time}}"
};
var formatLong97={
date:buildFormatLongFn({
formats:dateFormats48,
defaultWidth:"full"
}),
time:buildFormatLongFn({
formats:timeFormats48,
defaultWidth:"full"
}),
dateTime:buildFormatLongFn({
formats:dateTimeFormats48,
defaultWidth:"full"
})
};

// lib/locale/is/_lib/formatRelative.js
var formatRelativeLocale41={
lastWeek:"'s\xED\xF0asta' dddd 'kl.' p",
yesterday:"'\xED g\xE6r kl.' p",
today:"'\xED dag kl.' p",
tomorrow:"'\xE1 morgun kl.' p",
nextWeek:"dddd 'kl.' p",
other:"P"
};
var formatRelative90=function formatRelative90(token,_date,_baseDate,_options){return formatRelativeLocale41[token];};

// lib/locale/is/_lib/localize.js
var eraValues41={
narrow:["f.Kr.","e.Kr."],
abbreviated:["f.Kr.","e.Kr."],
wide:["fyrir Krist","eftir Krist"]
};
var quarterValues41={
narrow:["1","2","3","4"],
abbreviated:["1F","2F","3F","4F"],
wide:["1. fj\xF3r\xF0ungur","2. fj\xF3r\xF0ungur","3. fj\xF3r\xF0ungur","4. fj\xF3r\xF0ungur"]
};
var monthValues41={
narrow:["J","F","M","A","M","J","J","\xC1","S","\xD3","N","D"],
abbreviated:[
"jan.",
"feb.",
"mars",
"apr\xEDl",
"ma\xED",
"j\xFAn\xED",
"j\xFAl\xED",
"\xE1g\xFAst",
"sept.",
"okt.",
"n\xF3v.",
"des."],

wide:[
"jan\xFAar",
"febr\xFAar",
"mars",
"apr\xEDl",
"ma\xED",
"j\xFAn\xED",
"j\xFAl\xED",
"\xE1g\xFAst",
"september",
"okt\xF3ber",
"n\xF3vember",
"desember"]

};
var dayValues41={
narrow:["S","M","\xDE","M","F","F","L"],
short:["Su","M\xE1","\xDEr","Mi","Fi","F\xF6","La"],
abbreviated:["sun.","m\xE1n.","\xFEri.","mi\xF0.","fim.","f\xF6s.","lau."],
wide:[
"sunnudagur",
"m\xE1nudagur",
"\xFEri\xF0judagur",
"mi\xF0vikudagur",
"fimmtudagur",
"f\xF6studagur",
"laugardagur"]

};
var dayPeriodValues41={
narrow:{
am:"f",
pm:"e",
midnight:"mi\xF0n\xE6tti",
noon:"h\xE1degi",
morning:"morgunn",
afternoon:"s\xED\xF0degi",
evening:"kv\xF6ld",
night:"n\xF3tt"
},
abbreviated:{
am:"f.h.",
pm:"e.h.",
midnight:"mi\xF0n\xE6tti",
noon:"h\xE1degi",
morning:"morgunn",
afternoon:"s\xED\xF0degi",
evening:"kv\xF6ld",
night:"n\xF3tt"
},
wide:{
am:"fyrir h\xE1degi",
pm:"eftir h\xE1degi",
midnight:"mi\xF0n\xE6tti",
noon:"h\xE1degi",
morning:"morgunn",
afternoon:"s\xED\xF0degi",
evening:"kv\xF6ld",
night:"n\xF3tt"
}
};
var formattingDayPeriodValues33={
narrow:{
am:"f",
pm:"e",
midnight:"\xE1 mi\xF0n\xE6tti",
noon:"\xE1 h\xE1degi",
morning:"a\xF0 morgni",
afternoon:"s\xED\xF0degis",
evening:"um kv\xF6ld",
night:"um n\xF3tt"
},
abbreviated:{
am:"f.h.",
pm:"e.h.",
midnight:"\xE1 mi\xF0n\xE6tti",
noon:"\xE1 h\xE1degi",
morning:"a\xF0 morgni",
afternoon:"s\xED\xF0degis",
evening:"um kv\xF6ld",
night:"um n\xF3tt"
},
wide:{
am:"fyrir h\xE1degi",
pm:"eftir h\xE1degi",
midnight:"\xE1 mi\xF0n\xE6tti",
noon:"\xE1 h\xE1degi",
morning:"a\xF0 morgni",
afternoon:"s\xED\xF0degis",
evening:"um kv\xF6ld",
night:"um n\xF3tt"
}
};
var ordinalNumber41=function ordinalNumber41(dirtyNumber,_options){
var number=Number(dirtyNumber);
return number+".";
};
var localize93={
ordinalNumber:ordinalNumber41,
era:buildLocalizeFn({
values:eraValues41,
defaultWidth:"wide"
}),
quarter:buildLocalizeFn({
values:quarterValues41,
defaultWidth:"wide",
argumentCallback:function argumentCallback(quarter){return quarter-1;}
}),
month:buildLocalizeFn({
values:monthValues41,
defaultWidth:"wide"
}),
day:buildLocalizeFn({
values:dayValues41,
defaultWidth:"wide"
}),
dayPeriod:buildLocalizeFn({
values:dayPeriodValues41,
defaultWidth:"wide",
formattingValues:formattingDayPeriodValues33,
defaultFormattingWidth:"wide"
})
};

// lib/locale/is/_lib/match.js
var matchOrdinalNumberPattern40=/^(\d+)(\.)?/i;
var parseOrdinalNumberPattern40=/\d+(\.)?/i;
var matchEraPatterns40={
narrow:/^(f\.Kr\.|e\.Kr\.)/i,
abbreviated:/^(f\.Kr\.|e\.Kr\.)/i,
wide:/^(fyrir Krist|eftir Krist)/i
};
var parseEraPatterns40={
any:[/^(f\.Kr\.)/i,/^(e\.Kr\.)/i]
};
var matchQuarterPatterns40={
narrow:/^[1234]\.?/i,
abbreviated:/^q[1234]\.?/i,
wide:/^[1234]\.? fjórðungur/i
};
var parseQuarterPatterns40={
any:[/1\.?/i,/2\.?/i,/3\.?/i,/4\.?/i]
};
var matchMonthPatterns40={
narrow:/^[jfmásónd]/i,
abbreviated:/^(jan\.|feb\.|mars\.|apríl\.|maí|júní|júlí|águst|sep\.|oct\.|nov\.|dec\.)/i,
wide:/^(januar|febrúar|mars|apríl|maí|júní|júlí|águst|september|október|nóvember|desember)/i
};
var parseMonthPatterns40={
narrow:[
/^j/i,
/^f/i,
/^m/i,
/^a/i,
/^m/i,
/^j/i,
/^j/i,
/^á/i,
/^s/i,
/^ó/i,
/^n/i,
/^d/i],

any:[
/^ja/i,
/^f/i,
/^mar/i,
/^ap/i,
/^maí/i,
/^jún/i,
/^júl/i,
/^áu/i,
/^s/i,
/^ó/i,
/^n/i,
/^d/i]

};
var matchDayPatterns40={
narrow:/^[smtwf]/i,
short:/^(su|má|þr|mi|fi|fö|la)/i,
abbreviated:/^(sun|mán|þri|mið|fim|fös|lau)\.?/i,
wide:/^(sunnudagur|mánudagur|þriðjudagur|miðvikudagur|fimmtudagur|föstudagur|laugardagur)/i
};
var parseDayPatterns40={
narrow:[/^s/i,/^m/i,/^þ/i,/^m/i,/^f/i,/^f/i,/^l/i],
any:[/^su/i,/^má/i,/^þr/i,/^mi/i,/^fi/i,/^fö/i,/^la/i]
};
var matchDayPeriodPatterns40={
narrow:/^(f|e|síðdegis|(á|að|um) (morgni|kvöld|nótt|miðnætti))/i,
any:/^(fyrir hádegi|eftir hádegi|[ef]\.?h\.?|síðdegis|morgunn|(á|að|um) (morgni|kvöld|nótt|miðnætti))/i
};
var parseDayPeriodPatterns40={
any:{
am:/^f/i,
pm:/^e/i,
midnight:/^mi/i,
noon:/^há/i,
morning:/morgunn/i,
afternoon:/síðdegi/i,
evening:/kvöld/i,
night:/nótt/i
}
};
var match89={
ordinalNumber:buildMatchPatternFn({
matchPattern:matchOrdinalNumberPattern40,
parsePattern:parseOrdinalNumberPattern40,
valueCallback:function valueCallback(value){return parseInt(value,10);}
}),
era:buildMatchFn({
matchPatterns:matchEraPatterns40,
defaultMatchWidth:"wide",
parsePatterns:parseEraPatterns40,
defaultParseWidth:"any"
}),
quarter:buildMatchFn({
matchPatterns:matchQuarterPatterns40,
defaultMatchWidth:"wide",
parsePatterns:parseQuarterPatterns40,
defaultParseWidth:"any",
valueCallback:function valueCallback(index){return index+1;}
}),
month:buildMatchFn({
matchPatterns:matchMonthPatterns40,
defaultMatchWidth:"wide",
parsePatterns:parseMonthPatterns40,
defaultParseWidth:"any"
}),
day:buildMatchFn({
matchPatterns:matchDayPatterns40,
defaultMatchWidth:"wide",
parsePatterns:parseDayPatterns40,
defaultParseWidth:"any"
}),
dayPeriod:buildMatchFn({
matchPatterns:matchDayPeriodPatterns40,
defaultMatchWidth:"any",
parsePatterns:parseDayPeriodPatterns40,
defaultParseWidth:"any"
})
};

// lib/locale/is.js
var _is={
code:"is",
formatDistance:formatDistance90,
formatLong:formatLong97,
formatRelative:formatRelative90,
localize:localize93,
match:match89,
options:{
weekStartsOn:1,
firstWeekContainsDate:4
}
};
// lib/locale/it/_lib/formatDistance.js
var formatDistanceLocale41={
lessThanXSeconds:{
one:"meno di un secondo",
other:"meno di {{count}} secondi"
},
xSeconds:{
one:"un secondo",
other:"{{count}} secondi"
},
halfAMinute:"alcuni secondi",
lessThanXMinutes:{
one:"meno di un minuto",
other:"meno di {{count}} minuti"
},
xMinutes:{
one:"un minuto",
other:"{{count}} minuti"
},
aboutXHours:{
one:"circa un'ora",
other:"circa {{count}} ore"
},
xHours:{
one:"un'ora",
other:"{{count}} ore"
},
xDays:{
one:"un giorno",
other:"{{count}} giorni"
},
aboutXWeeks:{
one:"circa una settimana",
other:"circa {{count}} settimane"
},
xWeeks:{
one:"una settimana",
other:"{{count}} settimane"
},
aboutXMonths:{
one:"circa un mese",
other:"circa {{count}} mesi"
},
xMonths:{
one:"un mese",
other:"{{count}} mesi"
},
aboutXYears:{
one:"circa un anno",
other:"circa {{count}} anni"
},
xYears:{
one:"un anno",
other:"{{count}} anni"
},
overXYears:{
one:"pi\xF9 di un anno",
other:"pi\xF9 di {{count}} anni"
},
almostXYears:{
one:"quasi un anno",
other:"quasi {{count}} anni"
}
};
var formatDistance92=function formatDistance92(token,count,options){
var result;
var tokenValue=formatDistanceLocale41[token];
if(typeof tokenValue==="string"){
result=tokenValue;
}else if(count===1){
result=tokenValue.one;
}else{
result=tokenValue.other.replace("{{count}}",count.toString());
}
if(options!==null&&options!==void 0&&options.addSuffix){
if(options.comparison&&options.comparison>0){
return"tra "+result;
}else{
return result+" fa";
}
}
return result;
};

// lib/locale/it/_lib/formatLong.js
var dateFormats49={
full:"EEEE d MMMM y",
long:"d MMMM y",
medium:"d MMM y",
short:"dd/MM/y"
};
var timeFormats49={
full:"HH:mm:ss zzzz",
long:"HH:mm:ss z",
medium:"HH:mm:ss",
short:"HH:mm"
};
var dateTimeFormats49={
full:"{{date}} {{time}}",
long:"{{date}} {{time}}",
medium:"{{date}} {{time}}",
short:"{{date}} {{time}}"
};
var formatLong99={
date:buildFormatLongFn({
formats:dateFormats49,
defaultWidth:"full"
}),
time:buildFormatLongFn({
formats:timeFormats49,
defaultWidth:"full"
}),
dateTime:buildFormatLongFn({
formats:dateTimeFormats49,
defaultWidth:"full"
})
};

// lib/locale/it/_lib/formatRelative.js
function lastWeek4(day){
switch(day){
case 0:
return"'domenica scorsa alle' p";
default:
return"'"+weekdays2[day]+" scorso alle' p";
}
}
function thisWeek4(day){
return"'"+weekdays2[day]+" alle' p";
}
function nextWeek4(day){
switch(day){
case 0:
return"'domenica prossima alle' p";
default:
return"'"+weekdays2[day]+" prossimo alle' p";
}
}
var weekdays2=[
"domenica",
"luned\xEC",
"marted\xEC",
"mercoled\xEC",
"gioved\xEC",
"venerd\xEC",
"sabato"];

var formatRelativeLocale42={
lastWeek:function lastWeek(date,baseDate,options){
var day=date.getDay();
if(isSameWeek(date,baseDate,options)){
return thisWeek4(day);
}else{
return lastWeek4(day);
}
},
yesterday:"'ieri alle' p",
today:"'oggi alle' p",
tomorrow:"'domani alle' p",
nextWeek:function nextWeek(date,baseDate,options){
var day=date.getDay();
if(isSameWeek(date,baseDate,options)){
return thisWeek4(day);
}else{
return nextWeek4(day);
}
},
other:"P"
};
var formatRelative92=function formatRelative92(token,date,baseDate,options){
var format=formatRelativeLocale42[token];
if(typeof format==="function"){
return format(date,baseDate,options);
}
return format;
};

// lib/locale/it/_lib/localize.js
var eraValues42={
narrow:["aC","dC"],
abbreviated:["a.C.","d.C."],
wide:["avanti Cristo","dopo Cristo"]
};
var quarterValues42={
narrow:["1","2","3","4"],
abbreviated:["T1","T2","T3","T4"],
wide:["1\xBA trimestre","2\xBA trimestre","3\xBA trimestre","4\xBA trimestre"]
};
var monthValues42={
narrow:["G","F","M","A","M","G","L","A","S","O","N","D"],
abbreviated:[
"gen",
"feb",
"mar",
"apr",
"mag",
"giu",
"lug",
"ago",
"set",
"ott",
"nov",
"dic"],

wide:[
"gennaio",
"febbraio",
"marzo",
"aprile",
"maggio",
"giugno",
"luglio",
"agosto",
"settembre",
"ottobre",
"novembre",
"dicembre"]

};
var dayValues42={
narrow:["D","L","M","M","G","V","S"],
short:["dom","lun","mar","mer","gio","ven","sab"],
abbreviated:["dom","lun","mar","mer","gio","ven","sab"],
wide:[
"domenica",
"luned\xEC",
"marted\xEC",
"mercoled\xEC",
"gioved\xEC",
"venerd\xEC",
"sabato"]

};
var dayPeriodValues42={
narrow:{
am:"m.",
pm:"p.",
midnight:"mezzanotte",
noon:"mezzogiorno",
morning:"mattina",
afternoon:"pomeriggio",
evening:"sera",
night:"notte"
},
abbreviated:{
am:"AM",
pm:"PM",
midnight:"mezzanotte",
noon:"mezzogiorno",
morning:"mattina",
afternoon:"pomeriggio",
evening:"sera",
night:"notte"
},
wide:{
am:"AM",
pm:"PM",
midnight:"mezzanotte",
noon:"mezzogiorno",
morning:"mattina",
afternoon:"pomeriggio",
evening:"sera",
night:"notte"
}
};
var formattingDayPeriodValues34={
narrow:{
am:"m.",
pm:"p.",
midnight:"mezzanotte",
noon:"mezzogiorno",
morning:"di mattina",
afternoon:"del pomeriggio",
evening:"di sera",
night:"di notte"
},
abbreviated:{
am:"AM",
pm:"PM",
midnight:"mezzanotte",
noon:"mezzogiorno",
morning:"di mattina",
afternoon:"del pomeriggio",
evening:"di sera",
night:"di notte"
},
wide:{
am:"AM",
pm:"PM",
midnight:"mezzanotte",
noon:"mezzogiorno",
morning:"di mattina",
afternoon:"del pomeriggio",
evening:"di sera",
night:"di notte"
}
};
var ordinalNumber42=function ordinalNumber42(dirtyNumber,_options){
var number=Number(dirtyNumber);
return String(number);
};
var localize95={
ordinalNumber:ordinalNumber42,
era:buildLocalizeFn({
values:eraValues42,
defaultWidth:"wide"
}),
quarter:buildLocalizeFn({
values:quarterValues42,
defaultWidth:"wide",
argumentCallback:function argumentCallback(quarter){return quarter-1;}
}),
month:buildLocalizeFn({
values:monthValues42,
defaultWidth:"wide"
}),
day:buildLocalizeFn({
values:dayValues42,
defaultWidth:"wide"
}),
dayPeriod:buildLocalizeFn({
values:dayPeriodValues42,
defaultWidth:"wide",
formattingValues:formattingDayPeriodValues34,
defaultFormattingWidth:"wide"
})
};

// lib/locale/it/_lib/match.js
var matchOrdinalNumberPattern41=/^(\d+)(º)?/i;
var parseOrdinalNumberPattern41=/\d+/i;
var matchEraPatterns41={
narrow:/^(aC|dC)/i,
abbreviated:/^(a\.?\s?C\.?|a\.?\s?e\.?\s?v\.?|d\.?\s?C\.?|e\.?\s?v\.?)/i,
wide:/^(avanti Cristo|avanti Era Volgare|dopo Cristo|Era Volgare)/i
};
var parseEraPatterns41={
any:[/^a/i,/^(d|e)/i]
};
var matchQuarterPatterns41={
narrow:/^[1234]/i,
abbreviated:/^t[1234]/i,
wide:/^[1234](º)? trimestre/i
};
var parseQuarterPatterns41={
any:[/1/i,/2/i,/3/i,/4/i]
};
var matchMonthPatterns41={
narrow:/^[gfmalsond]/i,
abbreviated:/^(gen|feb|mar|apr|mag|giu|lug|ago|set|ott|nov|dic)/i,
wide:/^(gennaio|febbraio|marzo|aprile|maggio|giugno|luglio|agosto|settembre|ottobre|novembre|dicembre)/i
};
var parseMonthPatterns41={
narrow:[
/^g/i,
/^f/i,
/^m/i,
/^a/i,
/^m/i,
/^g/i,
/^l/i,
/^a/i,
/^s/i,
/^o/i,
/^n/i,
/^d/i],

any:[
/^ge/i,
/^f/i,
/^mar/i,
/^ap/i,
/^mag/i,
/^gi/i,
/^l/i,
/^ag/i,
/^s/i,
/^o/i,
/^n/i,
/^d/i]

};
var matchDayPatterns41={
narrow:/^[dlmgvs]/i,
short:/^(do|lu|ma|me|gi|ve|sa)/i,
abbreviated:/^(dom|lun|mar|mer|gio|ven|sab)/i,
wide:/^(domenica|luned[i|ì]|marted[i|ì]|mercoled[i|ì]|gioved[i|ì]|venerd[i|ì]|sabato)/i
};
var parseDayPatterns41={
narrow:[/^d/i,/^l/i,/^m/i,/^m/i,/^g/i,/^v/i,/^s/i],
any:[/^d/i,/^l/i,/^ma/i,/^me/i,/^g/i,/^v/i,/^s/i]
};
var matchDayPeriodPatterns41={
narrow:/^(a|m\.|p|mezzanotte|mezzogiorno|(di|del) (mattina|pomeriggio|sera|notte))/i,
any:/^([ap]\.?\s?m\.?|mezzanotte|mezzogiorno|(di|del) (mattina|pomeriggio|sera|notte))/i
};
var parseDayPeriodPatterns41={
any:{
am:/^a/i,
pm:/^p/i,
midnight:/^mezza/i,
noon:/^mezzo/i,
morning:/mattina/i,
afternoon:/pomeriggio/i,
evening:/sera/i,
night:/notte/i
}
};
var match91={
ordinalNumber:buildMatchPatternFn({
matchPattern:matchOrdinalNumberPattern41,
parsePattern:parseOrdinalNumberPattern41,
valueCallback:function valueCallback(value){return parseInt(value,10);}
}),
era:buildMatchFn({
matchPatterns:matchEraPatterns41,
defaultMatchWidth:"wide",
parsePatterns:parseEraPatterns41,
defaultParseWidth:"any"
}),
quarter:buildMatchFn({
matchPatterns:matchQuarterPatterns41,
defaultMatchWidth:"wide",
parsePatterns:parseQuarterPatterns41,
defaultParseWidth:"any",
valueCallback:function valueCallback(index){return index+1;}
}),
month:buildMatchFn({
matchPatterns:matchMonthPatterns41,
defaultMatchWidth:"wide",
parsePatterns:parseMonthPatterns41,
defaultParseWidth:"any"
}),
day:buildMatchFn({
matchPatterns:matchDayPatterns41,
defaultMatchWidth:"wide",
parsePatterns:parseDayPatterns41,
defaultParseWidth:"any"
}),
dayPeriod:buildMatchFn({
matchPatterns:matchDayPeriodPatterns41,
defaultMatchWidth:"any",
parsePatterns:parseDayPeriodPatterns41,
defaultParseWidth:"any"
})
};

// lib/locale/it.js
var _it={
code:"it",
formatDistance:formatDistance92,
formatLong:formatLong99,
formatRelative:formatRelative92,
localize:localize95,
match:match91,
options:{
weekStartsOn:1,
firstWeekContainsDate:4
}
};
// lib/locale/it-CH/_lib/formatLong.js
var dateFormats50={
full:"EEEE d MMMM y",
long:"d MMMM y",
medium:"d MMM y",
short:"dd.MM.y"
};
var timeFormats50={
full:"HH:mm:ss zzzz",
long:"HH:mm:ss z",
medium:"HH:mm:ss",
short:"HH:mm"
};
var dateTimeFormats50={
full:"{{date}} {{time}}",
long:"{{date}} {{time}}",
medium:"{{date}} {{time}}",
short:"{{date}} {{time}}"
};
var formatLong101={
date:buildFormatLongFn({
formats:dateFormats50,
defaultWidth:"full"
}),
time:buildFormatLongFn({
formats:timeFormats50,
defaultWidth:"full"
}),
dateTime:buildFormatLongFn({
formats:dateTimeFormats50,
defaultWidth:"full"
})
};

// lib/locale/it-CH.js
var _itCH={
code:"it-CH",
formatDistance:formatDistance92,
formatLong:formatLong101,
formatRelative:formatRelative92,
localize:localize95,
match:match91,
options:{
weekStartsOn:1,
firstWeekContainsDate:4
}
};
// lib/locale/ja/_lib/formatDistance.js
var formatDistanceLocale42={
lessThanXSeconds:{
one:"1\u79D2\u672A\u6E80",
other:"{{count}}\u79D2\u672A\u6E80",
oneWithSuffix:"\u7D041\u79D2",
otherWithSuffix:"\u7D04{{count}}\u79D2"
},
xSeconds:{
one:"1\u79D2",
other:"{{count}}\u79D2"
},
halfAMinute:"30\u79D2",
lessThanXMinutes:{
one:"1\u5206\u672A\u6E80",
other:"{{count}}\u5206\u672A\u6E80",
oneWithSuffix:"\u7D041\u5206",
otherWithSuffix:"\u7D04{{count}}\u5206"
},
xMinutes:{
one:"1\u5206",
other:"{{count}}\u5206"
},
aboutXHours:{
one:"\u7D041\u6642\u9593",
other:"\u7D04{{count}}\u6642\u9593"
},
xHours:{
one:"1\u6642\u9593",
other:"{{count}}\u6642\u9593"
},
xDays:{
one:"1\u65E5",
other:"{{count}}\u65E5"
},
aboutXWeeks:{
one:"\u7D041\u9031\u9593",
other:"\u7D04{{count}}\u9031\u9593"
},
xWeeks:{
one:"1\u9031\u9593",
other:"{{count}}\u9031\u9593"
},
aboutXMonths:{
one:"\u7D041\u304B\u6708",
other:"\u7D04{{count}}\u304B\u6708"
},
xMonths:{
one:"1\u304B\u6708",
other:"{{count}}\u304B\u6708"
},
aboutXYears:{
one:"\u7D041\u5E74",
other:"\u7D04{{count}}\u5E74"
},
xYears:{
one:"1\u5E74",
other:"{{count}}\u5E74"
},
overXYears:{
one:"1\u5E74\u4EE5\u4E0A",
other:"{{count}}\u5E74\u4EE5\u4E0A"
},
almostXYears:{
one:"1\u5E74\u8FD1\u304F",
other:"{{count}}\u5E74\u8FD1\u304F"
}
};
var formatDistance95=function formatDistance95(token,count,options){
options=options||{};
var result;
var tokenValue=formatDistanceLocale42[token];
if(typeof tokenValue==="string"){
result=tokenValue;
}else if(count===1){
if(options.addSuffix&&tokenValue.oneWithSuffix){
result=tokenValue.oneWithSuffix;
}else{
result=tokenValue.one;
}
}else{
if(options.addSuffix&&tokenValue.otherWithSuffix){
result=tokenValue.otherWithSuffix.replace("{{count}}",String(count));
}else{
result=tokenValue.other.replace("{{count}}",String(count));
}
}
if(options.addSuffix){
if(options.comparison&&options.comparison>0){
return result+"\u5F8C";
}else{
return result+"\u524D";
}
}
return result;
};

// lib/locale/ja/_lib/formatLong.js
var dateFormats51={
full:"y\u5E74M\u6708d\u65E5EEEE",
long:"y\u5E74M\u6708d\u65E5",
medium:"y/MM/dd",
short:"y/MM/dd"
};
var timeFormats51={
full:"H\u6642mm\u5206ss\u79D2 zzzz",
long:"H:mm:ss z",
medium:"H:mm:ss",
short:"H:mm"
};
var dateTimeFormats51={
full:"{{date}} {{time}}",
long:"{{date}} {{time}}",
medium:"{{date}} {{time}}",
short:"{{date}} {{time}}"
};
var formatLong103={
date:buildFormatLongFn({
formats:dateFormats51,
defaultWidth:"full"
}),
time:buildFormatLongFn({
formats:timeFormats51,
defaultWidth:"full"
}),
dateTime:buildFormatLongFn({
formats:dateTimeFormats51,
defaultWidth:"full"
})
};

// lib/locale/ja/_lib/formatRelative.js
var formatRelativeLocale43={
lastWeek:"\u5148\u9031\u306Eeeee\u306Ep",
yesterday:"\u6628\u65E5\u306Ep",
today:"\u4ECA\u65E5\u306Ep",
tomorrow:"\u660E\u65E5\u306Ep",
nextWeek:"\u7FCC\u9031\u306Eeeee\u306Ep",
other:"P"
};
var formatRelative95=function formatRelative95(token,_date,_baseDate,_options){
return formatRelativeLocale43[token];
};

// lib/locale/ja/_lib/localize.js
var eraValues43={
narrow:["BC","AC"],
abbreviated:["\u7D00\u5143\u524D","\u897F\u66A6"],
wide:["\u7D00\u5143\u524D","\u897F\u66A6"]
};
var quarterValues43={
narrow:["1","2","3","4"],
abbreviated:["Q1","Q2","Q3","Q4"],
wide:["\u7B2C1\u56DB\u534A\u671F","\u7B2C2\u56DB\u534A\u671F","\u7B2C3\u56DB\u534A\u671F","\u7B2C4\u56DB\u534A\u671F"]
};
var monthValues43={
narrow:["1","2","3","4","5","6","7","8","9","10","11","12"],
abbreviated:[
"1\u6708",
"2\u6708",
"3\u6708",
"4\u6708",
"5\u6708",
"6\u6708",
"7\u6708",
"8\u6708",
"9\u6708",
"10\u6708",
"11\u6708",
"12\u6708"],

wide:[
"1\u6708",
"2\u6708",
"3\u6708",
"4\u6708",
"5\u6708",
"6\u6708",
"7\u6708",
"8\u6708",
"9\u6708",
"10\u6708",
"11\u6708",
"12\u6708"]

};
var dayValues43={
narrow:["\u65E5","\u6708","\u706B","\u6C34","\u6728","\u91D1","\u571F"],
short:["\u65E5","\u6708","\u706B","\u6C34","\u6728","\u91D1","\u571F"],
abbreviated:["\u65E5","\u6708","\u706B","\u6C34","\u6728","\u91D1","\u571F"],
wide:["\u65E5\u66DC\u65E5","\u6708\u66DC\u65E5","\u706B\u66DC\u65E5","\u6C34\u66DC\u65E5","\u6728\u66DC\u65E5","\u91D1\u66DC\u65E5","\u571F\u66DC\u65E5"]
};
var dayPeriodValues43={
narrow:{
am:"\u5348\u524D",
pm:"\u5348\u5F8C",
midnight:"\u6DF1\u591C",
noon:"\u6B63\u5348",
morning:"\u671D",
afternoon:"\u5348\u5F8C",
evening:"\u591C",
night:"\u6DF1\u591C"
},
abbreviated:{
am:"\u5348\u524D",
pm:"\u5348\u5F8C",
midnight:"\u6DF1\u591C",
noon:"\u6B63\u5348",
morning:"\u671D",
afternoon:"\u5348\u5F8C",
evening:"\u591C",
night:"\u6DF1\u591C"
},
wide:{
am:"\u5348\u524D",
pm:"\u5348\u5F8C",
midnight:"\u6DF1\u591C",
noon:"\u6B63\u5348",
morning:"\u671D",
afternoon:"\u5348\u5F8C",
evening:"\u591C",
night:"\u6DF1\u591C"
}
};
var formattingDayPeriodValues35={
narrow:{
am:"\u5348\u524D",
pm:"\u5348\u5F8C",
midnight:"\u6DF1\u591C",
noon:"\u6B63\u5348",
morning:"\u671D",
afternoon:"\u5348\u5F8C",
evening:"\u591C",
night:"\u6DF1\u591C"
},
abbreviated:{
am:"\u5348\u524D",
pm:"\u5348\u5F8C",
midnight:"\u6DF1\u591C",
noon:"\u6B63\u5348",
morning:"\u671D",
afternoon:"\u5348\u5F8C",
evening:"\u591C",
night:"\u6DF1\u591C"
},
wide:{
am:"\u5348\u524D",
pm:"\u5348\u5F8C",
midnight:"\u6DF1\u591C",
noon:"\u6B63\u5348",
morning:"\u671D",
afternoon:"\u5348\u5F8C",
evening:"\u591C",
night:"\u6DF1\u591C"
}
};
var ordinalNumber43=function ordinalNumber43(dirtyNumber,options){
var number=Number(dirtyNumber);
var unit=String(options===null||options===void 0?void 0:options.unit);
switch(unit){
case"year":
return"".concat(number,"\u5E74");
case"quarter":
return"\u7B2C".concat(number,"\u56DB\u534A\u671F");
case"month":
return"".concat(number,"\u6708");
case"week":
return"\u7B2C".concat(number,"\u9031");
case"date":
return"".concat(number,"\u65E5");
case"hour":
return"".concat(number,"\u6642");
case"minute":
return"".concat(number,"\u5206");
case"second":
return"".concat(number,"\u79D2");
default:
return"".concat(number);
}
};
var localize98={
ordinalNumber:ordinalNumber43,
era:buildLocalizeFn({
values:eraValues43,
defaultWidth:"wide"
}),
quarter:buildLocalizeFn({
values:quarterValues43,
defaultWidth:"wide",
argumentCallback:function argumentCallback(quarter){return Number(quarter)-1;}
}),
month:buildLocalizeFn({
values:monthValues43,
defaultWidth:"wide"
}),
day:buildLocalizeFn({
values:dayValues43,
defaultWidth:"wide"
}),
dayPeriod:buildLocalizeFn({
values:dayPeriodValues43,
defaultWidth:"wide",
formattingValues:formattingDayPeriodValues35,
defaultFormattingWidth:"wide"
})
};

// lib/locale/ja/_lib/match.js
var matchOrdinalNumberPattern42=/^第?\d+(年|四半期|月|週|日|時|分|秒)?/i;
var parseOrdinalNumberPattern42=/\d+/i;
var matchEraPatterns42={
narrow:/^(B\.?C\.?|A\.?D\.?)/i,
abbreviated:/^(紀元[前後]|西暦)/i,
wide:/^(紀元[前後]|西暦)/i
};
var parseEraPatterns42={
narrow:[/^B/i,/^A/i],
any:[/^(紀元前)/i,/^(西暦|紀元後)/i]
};
var matchQuarterPatterns42={
narrow:/^[1234]/i,
abbreviated:/^Q[1234]/i,
wide:/^第[1234一二三四１２３４]四半期/i
};
var parseQuarterPatterns42={
any:[/(1|一|１)/i,/(2|二|２)/i,/(3|三|３)/i,/(4|四|４)/i]
};
var matchMonthPatterns42={
narrow:/^([123456789]|1[012])/,
abbreviated:/^([123456789]|1[012])月/i,
wide:/^([123456789]|1[012])月/i
};
var parseMonthPatterns42={
any:[
/^1\D/,
/^2/,
/^3/,
/^4/,
/^5/,
/^6/,
/^7/,
/^8/,
/^9/,
/^10/,
/^11/,
/^12/]

};
var matchDayPatterns42={
narrow:/^[日月火水木金土]/,
short:/^[日月火水木金土]/,
abbreviated:/^[日月火水木金土]/,
wide:/^[日月火水木金土]曜日/
};
var parseDayPatterns42={
any:[/^日/,/^月/,/^火/,/^水/,/^木/,/^金/,/^土/]
};
var matchDayPeriodPatterns42={
any:/^(AM|PM|午前|午後|正午|深夜|真夜中|夜|朝)/i
};
var parseDayPeriodPatterns42={
any:{
am:/^(A|午前)/i,
pm:/^(P|午後)/i,
midnight:/^深夜|真夜中/i,
noon:/^正午/i,
morning:/^朝/i,
afternoon:/^午後/i,
evening:/^夜/i,
night:/^深夜/i
}
};
var match94={
ordinalNumber:buildMatchPatternFn({
matchPattern:matchOrdinalNumberPattern42,
parsePattern:parseOrdinalNumberPattern42,
valueCallback:function valueCallback(value){
return parseInt(value,10);
}
}),
era:buildMatchFn({
matchPatterns:matchEraPatterns42,
defaultMatchWidth:"wide",
parsePatterns:parseEraPatterns42,
defaultParseWidth:"any"
}),
quarter:buildMatchFn({
matchPatterns:matchQuarterPatterns42,
defaultMatchWidth:"wide",
parsePatterns:parseQuarterPatterns42,
defaultParseWidth:"any",
valueCallback:function valueCallback(index){return index+1;}
}),
month:buildMatchFn({
matchPatterns:matchMonthPatterns42,
defaultMatchWidth:"wide",
parsePatterns:parseMonthPatterns42,
defaultParseWidth:"any"
}),
day:buildMatchFn({
matchPatterns:matchDayPatterns42,
defaultMatchWidth:"wide",
parsePatterns:parseDayPatterns42,
defaultParseWidth:"any"
}),
dayPeriod:buildMatchFn({
matchPatterns:matchDayPeriodPatterns42,
defaultMatchWidth:"any",
parsePatterns:parseDayPeriodPatterns42,
defaultParseWidth:"any"
})
};

// lib/locale/ja.js
var _ja={
code:"ja",
formatDistance:formatDistance95,
formatLong:formatLong103,
formatRelative:formatRelative95,
localize:localize98,
match:match94,
options:{
weekStartsOn:0,
firstWeekContainsDate:1
}
};
// lib/locale/ja-Hira/_lib/formatDistance.js
var formatDistanceLocale43={
lessThanXSeconds:{
one:"1\u3073\u3087\u3046\u307F\u307E\u3093",
other:"{{count}}\u3073\u3087\u3046\u307F\u307E\u3093",
oneWithSuffix:"\u3084\u304F1\u3073\u3087\u3046",
otherWithSuffix:"\u3084\u304F{{count}}\u3073\u3087\u3046"
},
xSeconds:{
one:"1\u3073\u3087\u3046",
other:"{{count}}\u3073\u3087\u3046"
},
halfAMinute:"30\u3073\u3087\u3046",
lessThanXMinutes:{
one:"1\u3077\u3093\u307F\u307E\u3093",
other:"{{count}}\u3075\u3093\u307F\u307E\u3093",
oneWithSuffix:"\u3084\u304F1\u3077\u3093",
otherWithSuffix:"\u3084\u304F{{count}}\u3075\u3093"
},
xMinutes:{
one:"1\u3077\u3093",
other:"{{count}}\u3075\u3093"
},
aboutXHours:{
one:"\u3084\u304F1\u3058\u304B\u3093",
other:"\u3084\u304F{{count}}\u3058\u304B\u3093"
},
xHours:{
one:"1\u3058\u304B\u3093",
other:"{{count}}\u3058\u304B\u3093"
},
xDays:{
one:"1\u306B\u3061",
other:"{{count}}\u306B\u3061"
},
aboutXWeeks:{
one:"\u3084\u304F1\u3057\u3085\u3046\u304B\u3093",
other:"\u3084\u304F{{count}}\u3057\u3085\u3046\u304B\u3093"
},
xWeeks:{
one:"1\u3057\u3085\u3046\u304B\u3093",
other:"{{count}}\u3057\u3085\u3046\u304B\u3093"
},
aboutXMonths:{
one:"\u3084\u304F1\u304B\u3052\u3064",
other:"\u3084\u304F{{count}}\u304B\u3052\u3064"
},
xMonths:{
one:"1\u304B\u3052\u3064",
other:"{{count}}\u304B\u3052\u3064"
},
aboutXYears:{
one:"\u3084\u304F1\u306D\u3093",
other:"\u3084\u304F{{count}}\u306D\u3093"
},
xYears:{
one:"1\u306D\u3093",
other:"{{count}}\u306D\u3093"
},
overXYears:{
one:"1\u306D\u3093\u3044\u3058\u3087\u3046",
other:"{{count}}\u306D\u3093\u3044\u3058\u3087\u3046"
},
almostXYears:{
one:"1\u306D\u3093\u3061\u304B\u304F",
other:"{{count}}\u306D\u3093\u3061\u304B\u304F"
}
};
var formatDistance97=function formatDistance97(token,count,options){
options=options||{};
var result;
var tokenValue=formatDistanceLocale43[token];
if(typeof tokenValue==="string"){
result=tokenValue;
}else if(count===1){
if(options.addSuffix&&tokenValue.oneWithSuffix){
result=tokenValue.oneWithSuffix;
}else{
result=tokenValue.one;
}
}else{
if(options.addSuffix&&tokenValue.otherWithSuffix){
result=tokenValue.otherWithSuffix.replace("{{count}}",String(count));
}else{
result=tokenValue.other.replace("{{count}}",String(count));
}
}
if(options.addSuffix){
if(options.comparison&&options.comparison>0){
return result+"\u3042\u3068";
}else{
return result+"\u307E\u3048";
}
}
return result;
};

// lib/locale/ja-Hira/_lib/formatLong.js
var dateFormats52={
full:"y\u306D\u3093M\u304C\u3064d\u306B\u3061EEEE",
long:"y\u306D\u3093M\u304C\u3064d\u306B\u3061",
medium:"y/MM/dd",
short:"y/MM/dd"
};
var timeFormats52={
full:"H\u3058mm\u3075\u3093ss\u3073\u3087\u3046 zzzz",
long:"H:mm:ss z",
medium:"H:mm:ss",
short:"H:mm"
};
var dateTimeFormats52={
full:"{{date}} {{time}}",
long:"{{date}} {{time}}",
medium:"{{date}} {{time}}",
short:"{{date}} {{time}}"
};
var formatLong105={
date:buildFormatLongFn({
formats:dateFormats52,
defaultWidth:"full"
}),
time:buildFormatLongFn({
formats:timeFormats52,
defaultWidth:"full"
}),
dateTime:buildFormatLongFn({
formats:dateTimeFormats52,
defaultWidth:"full"
})
};

// lib/locale/ja-Hira/_lib/formatRelative.js
var formatRelativeLocale44={
lastWeek:"\u305B\u3093\u3057\u3085\u3046\u306Eeeee\u306Ep",
yesterday:"\u304D\u306E\u3046\u306Ep",
today:"\u304D\u3087\u3046\u306Ep",
tomorrow:"\u3042\u3057\u305F\u306Ep",
nextWeek:"\u3088\u304F\u3057\u3085\u3046\u306Eeeee\u306Ep",
other:"P"
};
var formatRelative97=function formatRelative97(token,_date,_baseDate,_options){
return formatRelativeLocale44[token];
};

// lib/locale/ja-Hira/_lib/localize.js
var eraValues44={
narrow:["BC","AC"],
abbreviated:["\u304D\u3052\u3093\u305C\u3093","\u305B\u3044\u308C\u304D"],
wide:["\u304D\u3052\u3093\u305C\u3093","\u305B\u3044\u308C\u304D"]
};
var quarterValues44={
narrow:["1","2","3","4"],
abbreviated:["Q1","Q2","Q3","Q4"],
wide:["\u3060\u30441\u3057\u306F\u3093\u304D","\u3060\u30442\u3057\u306F\u3093\u304D","\u3060\u30443\u3057\u306F\u3093\u304D","\u3060\u30444\u3057\u306F\u3093\u304D"]
};
var monthValues44={
narrow:["1","2","3","4","5","6","7","8","9","10","11","12"],
abbreviated:[
"1\u304C\u3064",
"2\u304C\u3064",
"3\u304C\u3064",
"4\u304C\u3064",
"5\u304C\u3064",
"6\u304C\u3064",
"7\u304C\u3064",
"8\u304C\u3064",
"9\u304C\u3064",
"10\u304C\u3064",
"11\u304C\u3064",
"12\u304C\u3064"],

wide:[
"1\u304C\u3064",
"2\u304C\u3064",
"3\u304C\u3064",
"4\u304C\u3064",
"5\u304C\u3064",
"6\u304C\u3064",
"7\u304C\u3064",
"8\u304C\u3064",
"9\u304C\u3064",
"10\u304C\u3064",
"11\u304C\u3064",
"12\u304C\u3064"]

};
var dayValues44={
narrow:["\u306B\u3061","\u3052\u3064","\u304B","\u3059\u3044","\u3082\u304F","\u304D\u3093","\u3069"],
short:["\u306B\u3061","\u3052\u3064","\u304B","\u3059\u3044","\u3082\u304F","\u304D\u3093","\u3069"],
abbreviated:["\u306B\u3061","\u3052\u3064","\u304B","\u3059\u3044","\u3082\u304F","\u304D\u3093","\u3069"],
wide:[
"\u306B\u3061\u3088\u3046\u3073",
"\u3052\u3064\u3088\u3046\u3073",
"\u304B\u3088\u3046\u3073",
"\u3059\u3044\u3088\u3046\u3073",
"\u3082\u304F\u3088\u3046\u3073",
"\u304D\u3093\u3088\u3046\u3073",
"\u3069\u3088\u3046\u3073"]

};
var dayPeriodValues44={
narrow:{
am:"\u3054\u305C\u3093",
pm:"\u3054\u3054",
midnight:"\u3057\u3093\u3084",
noon:"\u3057\u3087\u3046\u3054",
morning:"\u3042\u3055",
afternoon:"\u3054\u3054",
evening:"\u3088\u308B",
night:"\u3057\u3093\u3084"
},
abbreviated:{
am:"\u3054\u305C\u3093",
pm:"\u3054\u3054",
midnight:"\u3057\u3093\u3084",
noon:"\u3057\u3087\u3046\u3054",
morning:"\u3042\u3055",
afternoon:"\u3054\u3054",
evening:"\u3088\u308B",
night:"\u3057\u3093\u3084"
},
wide:{
am:"\u3054\u305C\u3093",
pm:"\u3054\u3054",
midnight:"\u3057\u3093\u3084",
noon:"\u3057\u3087\u3046\u3054",
morning:"\u3042\u3055",
afternoon:"\u3054\u3054",
evening:"\u3088\u308B",
night:"\u3057\u3093\u3084"
}
};
var formattingDayPeriodValues36={
narrow:{
am:"\u3054\u305C\u3093",
pm:"\u3054\u3054",
midnight:"\u3057\u3093\u3084",
noon:"\u3057\u3087\u3046\u3054",
morning:"\u3042\u3055",
afternoon:"\u3054\u3054",
evening:"\u3088\u308B",
night:"\u3057\u3093\u3084"
},
abbreviated:{
am:"\u3054\u305C\u3093",
pm:"\u3054\u3054",
midnight:"\u3057\u3093\u3084",
noon:"\u3057\u3087\u3046\u3054",
morning:"\u3042\u3055",
afternoon:"\u3054\u3054",
evening:"\u3088\u308B",
night:"\u3057\u3093\u3084"
},
wide:{
am:"\u3054\u305C\u3093",
pm:"\u3054\u3054",
midnight:"\u3057\u3093\u3084",
noon:"\u3057\u3087\u3046\u3054",
morning:"\u3042\u3055",
afternoon:"\u3054\u3054",
evening:"\u3088\u308B",
night:"\u3057\u3093\u3084"
}
};
var ordinalNumber44=function ordinalNumber44(dirtyNumber,options){
var number=Number(dirtyNumber);
var unit=String(options===null||options===void 0?void 0:options.unit);
switch(unit){
case"year":
return"".concat(number,"\u306D\u3093");
case"quarter":
return"\u3060\u3044".concat(number,"\u3057\u306F\u3093\u304D");
case"month":
return"".concat(number,"\u304C\u3064");
case"week":
return"\u3060\u3044".concat(number,"\u3057\u3085\u3046");
case"date":
return"".concat(number,"\u306B\u3061");
case"hour":
return"".concat(number,"\u3058");
case"minute":
return"".concat(number,"\u3075\u3093");
case"second":
return"".concat(number,"\u3073\u3087\u3046");
default:
return"".concat(number);
}
};
var localize100={
ordinalNumber:ordinalNumber44,
era:buildLocalizeFn({
values:eraValues44,
defaultWidth:"wide"
}),
quarter:buildLocalizeFn({
values:quarterValues44,
defaultWidth:"wide",
argumentCallback:function argumentCallback(quarter){return Number(quarter)-1;}
}),
month:buildLocalizeFn({
values:monthValues44,
defaultWidth:"wide"
}),
day:buildLocalizeFn({
values:dayValues44,
defaultWidth:"wide"
}),
dayPeriod:buildLocalizeFn({
values:dayPeriodValues44,
defaultWidth:"wide",
formattingValues:formattingDayPeriodValues36,
defaultFormattingWidth:"wide"
})
};

// lib/locale/ja-Hira/_lib/match.js
var matchOrdinalNumberPattern43=/^だ?い?\d+(ねん|しはんき|がつ|しゅう|にち|じ|ふん|びょう)?/i;
var parseOrdinalNumberPattern43=/\d+/i;
var matchEraPatterns43={
narrow:/^(B\.?C\.?|A\.?D\.?)/i,
abbreviated:/^(きげん[前後]|せいれき)/i,
wide:/^(きげん[前後]|せいれき)/i
};
var parseEraPatterns43={
narrow:[/^B/i,/^A/i],
any:[/^(きげんぜん)/i,/^(せいれき|きげんご)/i]
};
var matchQuarterPatterns43={
narrow:/^[1234]/i,
abbreviated:/^Q[1234]/i,
wide:/^だい[1234一二三四１２３４]しはんき/i
};
var parseQuarterPatterns43={
any:[/(1|一|１)/i,/(2|二|２)/i,/(3|三|３)/i,/(4|四|４)/i]
};
var matchMonthPatterns43={
narrow:/^([123456789]|1[012])/,
abbreviated:/^([123456789]|1[012])がつ/i,
wide:/^([123456789]|1[012])がつ/i
};
var parseMonthPatterns43={
any:[
/^1\D/,
/^2/,
/^3/,
/^4/,
/^5/,
/^6/,
/^7/,
/^8/,
/^9/,
/^10/,
/^11/,
/^12/]

};
var matchDayPatterns43={
narrow:/^(にち|げつ|か|すい|もく|きん|ど)/,
short:/^(にち|げつ|か|すい|もく|きん|ど)/,
abbreviated:/^(にち|げつ|か|すい|もく|きん|ど)/,
wide:/^(にち|げつ|か|すい|もく|きん|ど)ようび/
};
var parseDayPatterns43={
any:[/^にち/,/^げつ/,/^か/,/^すい/,/^もく/,/^きん/,/^ど/]
};
var matchDayPeriodPatterns43={
any:/^(AM|PM|ごぜん|ごご|しょうご|しんや|まよなか|よる|あさ)/i
};
var parseDayPeriodPatterns43={
any:{
am:/^(A|ごぜん)/i,
pm:/^(P|ごご)/i,
midnight:/^しんや|まよなか/i,
noon:/^しょうご/i,
morning:/^あさ/i,
afternoon:/^ごご/i,
evening:/^よる/i,
night:/^しんや/i
}
};
var match96={
ordinalNumber:buildMatchPatternFn({
matchPattern:matchOrdinalNumberPattern43,
parsePattern:parseOrdinalNumberPattern43,
valueCallback:function valueCallback(value){
return parseInt(value,10);
}
}),
era:buildMatchFn({
matchPatterns:matchEraPatterns43,
defaultMatchWidth:"wide",
parsePatterns:parseEraPatterns43,
defaultParseWidth:"any"
}),
quarter:buildMatchFn({
matchPatterns:matchQuarterPatterns43,
defaultMatchWidth:"wide",
parsePatterns:parseQuarterPatterns43,
defaultParseWidth:"any",
valueCallback:function valueCallback(index){return index+1;}
}),
month:buildMatchFn({
matchPatterns:matchMonthPatterns43,
defaultMatchWidth:"wide",
parsePatterns:parseMonthPatterns43,
defaultParseWidth:"any"
}),
day:buildMatchFn({
matchPatterns:matchDayPatterns43,
defaultMatchWidth:"wide",
parsePatterns:parseDayPatterns43,
defaultParseWidth:"any"
}),
dayPeriod:buildMatchFn({
matchPatterns:matchDayPeriodPatterns43,
defaultMatchWidth:"any",
parsePatterns:parseDayPeriodPatterns43,
defaultParseWidth:"any"
})
};

// lib/locale/ja-Hira.js
var _jaHira={
code:"ja-Hira",
formatDistance:formatDistance97,
formatLong:formatLong105,
formatRelative:formatRelative97,
localize:localize100,
match:match96,
options:{
weekStartsOn:0,
firstWeekContainsDate:1
}
};
// lib/locale/ka/_lib/formatDistance.js
var formatDistanceLocale44={
lessThanXSeconds:{
past:"{{count}} \u10EC\u10D0\u10DB\u10D6\u10D4 \u10DC\u10D0\u10D9\u10DA\u10D4\u10D1\u10D8 \u10EE\u10DC\u10D8\u10E1 \u10EC\u10D8\u10DC",
present:"{{count}} \u10EC\u10D0\u10DB\u10D6\u10D4 \u10DC\u10D0\u10D9\u10DA\u10D4\u10D1\u10D8",
future:"{{count}} \u10EC\u10D0\u10DB\u10D6\u10D4 \u10DC\u10D0\u10D9\u10DA\u10D4\u10D1\u10E8\u10D8"
},
xSeconds:{
past:"{{count}} \u10EC\u10D0\u10DB\u10D8\u10E1 \u10EC\u10D8\u10DC",
present:"{{count}} \u10EC\u10D0\u10DB\u10D8",
future:"{{count}} \u10EC\u10D0\u10DB\u10E8\u10D8"
},
halfAMinute:{
past:"\u10DC\u10D0\u10EE\u10D4\u10D5\u10D0\u10E0\u10D8 \u10EC\u10E3\u10D7\u10D8\u10E1 \u10EC\u10D8\u10DC",
present:"\u10DC\u10D0\u10EE\u10D4\u10D5\u10D0\u10E0\u10D8 \u10EC\u10E3\u10D7\u10D8",
future:"\u10DC\u10D0\u10EE\u10D4\u10D5\u10D0\u10E0\u10D8 \u10EC\u10E3\u10D7\u10E8\u10D8"
},
lessThanXMinutes:{
past:"{{count}} \u10EC\u10E3\u10D7\u10D6\u10D4 \u10DC\u10D0\u10D9\u10DA\u10D4\u10D1\u10D8 \u10EE\u10DC\u10D8\u10E1 \u10EC\u10D8\u10DC",
present:"{{count}} \u10EC\u10E3\u10D7\u10D6\u10D4 \u10DC\u10D0\u10D9\u10DA\u10D4\u10D1\u10D8",
future:"{{count}} \u10EC\u10E3\u10D7\u10D6\u10D4 \u10DC\u10D0\u10D9\u10DA\u10D4\u10D1\u10E8\u10D8"
},
xMinutes:{
past:"{{count}} \u10EC\u10E3\u10D7\u10D8\u10E1 \u10EC\u10D8\u10DC",
present:"{{count}} \u10EC\u10E3\u10D7\u10D8",
future:"{{count}} \u10EC\u10E3\u10D7\u10E8\u10D8"
},
aboutXHours:{
past:"\u10D3\u10D0\u10D0\u10EE\u10DA\u10DD\u10D4\u10D1\u10D8\u10D7 {{count}} \u10E1\u10D0\u10D0\u10D7\u10D8\u10E1 \u10EC\u10D8\u10DC",
present:"\u10D3\u10D0\u10D0\u10EE\u10DA\u10DD\u10D4\u10D1\u10D8\u10D7 {{count}} \u10E1\u10D0\u10D0\u10D7\u10D8",
future:"\u10D3\u10D0\u10D0\u10EE\u10DA\u10DD\u10D4\u10D1\u10D8\u10D7 {{count}} \u10E1\u10D0\u10D0\u10D7\u10E8\u10D8"
},
xHours:{
past:"{{count}} \u10E1\u10D0\u10D0\u10D7\u10D8\u10E1 \u10EC\u10D8\u10DC",
present:"{{count}} \u10E1\u10D0\u10D0\u10D7\u10D8",
future:"{{count}} \u10E1\u10D0\u10D0\u10D7\u10E8\u10D8"
},
xDays:{
past:"{{count}} \u10D3\u10E6\u10D8\u10E1 \u10EC\u10D8\u10DC",
present:"{{count}} \u10D3\u10E6\u10D4",
future:"{{count}} \u10D3\u10E6\u10D4\u10E8\u10D8"
},
aboutXWeeks:{
past:"\u10D3\u10D0\u10D0\u10EE\u10DA\u10DD\u10D4\u10D1\u10D8\u10D7 {{count}} \u10D9\u10D5\u10D8\u10E0\u10D0\u10E1 \u10EC\u10D8\u10DC",
present:"\u10D3\u10D0\u10D0\u10EE\u10DA\u10DD\u10D4\u10D1\u10D8\u10D7 {{count}} \u10D9\u10D5\u10D8\u10E0\u10D0",
future:"\u10D3\u10D0\u10D0\u10EE\u10DA\u10DD\u10D4\u10D1\u10D8\u10D7 {{count}} \u10D9\u10D5\u10D8\u10E0\u10D0\u10E8\u10D8"
},
xWeeks:{
past:"{{count}} \u10D9\u10D5\u10D8\u10E0\u10D0\u10E1 \u10D9\u10D5\u10D8\u10E0\u10D0",
present:"{{count}} \u10D9\u10D5\u10D8\u10E0\u10D0",
future:"{{count}} \u10D9\u10D5\u10D8\u10E0\u10D0\u10E8\u10D8"
},
aboutXMonths:{
past:"\u10D3\u10D0\u10D0\u10EE\u10DA\u10DD\u10D4\u10D1\u10D8\u10D7 {{count}} \u10D7\u10D5\u10D8\u10E1 \u10EC\u10D8\u10DC",
present:"\u10D3\u10D0\u10D0\u10EE\u10DA\u10DD\u10D4\u10D1\u10D8\u10D7 {{count}} \u10D7\u10D5\u10D4",
future:"\u10D3\u10D0\u10D0\u10EE\u10DA\u10DD\u10D4\u10D1\u10D8\u10D7 {{count}} \u10D7\u10D5\u10D4\u10E8\u10D8"
},
xMonths:{
past:"{{count}} \u10D7\u10D5\u10D8\u10E1 \u10EC\u10D8\u10DC",
present:"{{count}} \u10D7\u10D5\u10D4",
future:"{{count}} \u10D7\u10D5\u10D4\u10E8\u10D8"
},
aboutXYears:{
past:"\u10D3\u10D0\u10D0\u10EE\u10DA\u10DD\u10D4\u10D1\u10D8\u10D7 {{count}} \u10EC\u10DA\u10D8\u10E1 \u10EC\u10D8\u10DC",
present:"\u10D3\u10D0\u10D0\u10EE\u10DA\u10DD\u10D4\u10D1\u10D8\u10D7 {{count}} \u10EC\u10D4\u10DA\u10D8",
future:"\u10D3\u10D0\u10D0\u10EE\u10DA\u10DD\u10D4\u10D1\u10D8\u10D7 {{count}} \u10EC\u10D4\u10DA\u10E8\u10D8"
},
xYears:{
past:"{{count}} \u10EC\u10DA\u10D8\u10E1 \u10EC\u10D8\u10DC",
present:"{{count}} \u10EC\u10D4\u10DA\u10D8",
future:"{{count}} \u10EC\u10D4\u10DA\u10E8\u10D8"
},
overXYears:{
past:"{{count}} \u10EC\u10D4\u10DA\u10D6\u10D4 \u10DB\u10D4\u10E2\u10D8 \u10EE\u10DC\u10D8\u10E1 \u10EC\u10D8\u10DC",
present:"{{count}} \u10EC\u10D4\u10DA\u10D6\u10D4 \u10DB\u10D4\u10E2\u10D8",
future:"{{count}} \u10EC\u10D4\u10DA\u10D6\u10D4 \u10DB\u10D4\u10E2\u10D8 \u10EE\u10DC\u10D8\u10E1 \u10E8\u10D4\u10DB\u10D3\u10D4\u10D2"
},
almostXYears:{
past:"\u10D7\u10D8\u10D7\u10E5\u10DB\u10D8\u10E1 {{count}} \u10EC\u10DA\u10D8\u10E1 \u10EC\u10D8\u10DC",
present:"\u10D7\u10D8\u10D7\u10E5\u10DB\u10D8\u10E1 {{count}} \u10EC\u10D4\u10DA\u10D8",
future:"\u10D7\u10D8\u10D7\u10E5\u10DB\u10D8\u10E1 {{count}} \u10EC\u10D4\u10DA\u10E8\u10D8"
}
};
var formatDistance99=function formatDistance99(token,count,options){
var result;
var tokenValue=formatDistanceLocale44[token];
if(typeof tokenValue==="string"){
result=tokenValue;
}else if(options!==null&&options!==void 0&&options.addSuffix&&options.comparison&&options.comparison>0){
result=tokenValue.future.replace("{{count}}",String(count));
}else if(options!==null&&options!==void 0&&options.addSuffix){
result=tokenValue.past.replace("{{count}}",String(count));
}else{
result=tokenValue.present.replace("{{count}}",String(count));
}
return result;
};

// lib/locale/ka/_lib/formatLong.js
var dateFormats53={
full:"EEEE, do MMMM, y",
long:"do, MMMM, y",
medium:"d, MMM, y",
short:"dd/MM/yyyy"
};
var timeFormats53={
full:"h:mm:ss a zzzz",
long:"h:mm:ss a z",
medium:"h:mm:ss a",
short:"h:mm a"
};
var dateTimeFormats53={
full:"{{date}} {{time}}'-\u10D6\u10D4'",
long:"{{date}} {{time}}'-\u10D6\u10D4'",
medium:"{{date}}, {{time}}",
short:"{{date}}, {{time}}"
};
var formatLong107={
date:buildFormatLongFn({
formats:dateFormats53,
defaultWidth:"full"
}),
time:buildFormatLongFn({
formats:timeFormats53,
defaultWidth:"full"
}),
dateTime:buildFormatLongFn({
formats:dateTimeFormats53,
defaultWidth:"full"
})
};

// lib/locale/ka/_lib/formatRelative.js
var formatRelativeLocale45={
lastWeek:"'\u10EC\u10D8\u10DC\u10D0' eeee p'-\u10D6\u10D4'",
yesterday:"'\u10D2\u10E3\u10E8\u10D8\u10DC' p'-\u10D6\u10D4'",
today:"'\u10D3\u10E6\u10D4\u10E1' p'-\u10D6\u10D4'",
tomorrow:"'\u10EE\u10D5\u10D0\u10DA' p'-\u10D6\u10D4'",
nextWeek:"'\u10E8\u10D4\u10DB\u10D3\u10D4\u10D2\u10D8' eeee p'-\u10D6\u10D4'",
other:"P"
};
var formatRelative99=function formatRelative99(token,_date,_baseDate,_options){return formatRelativeLocale45[token];};

// lib/locale/ka/_lib/localize.js
var eraValues45={
narrow:["\u10E9.\u10EC-\u10DB\u10D3\u10D4","\u10E9.\u10EC"],
abbreviated:["\u10E9\u10D5.\u10EC-\u10DB\u10D3\u10D4","\u10E9\u10D5.\u10EC"],
wide:["\u10E9\u10D5\u10D4\u10DC\u10E1 \u10EC\u10D4\u10DA\u10D7\u10D0\u10E6\u10E0\u10D8\u10EA\u10EE\u10D5\u10D0\u10DB\u10D3\u10D4","\u10E9\u10D5\u10D4\u10DC\u10D8 \u10EC\u10D4\u10DA\u10D7\u10D0\u10E6\u10E0\u10D8\u10EA\u10EE\u10D5\u10D8\u10D7"]
};
var quarterValues45={
narrow:["1","2","3","4"],
abbreviated:["1-\u10DA\u10D8 \u10D9\u10D5","2-\u10D4 \u10D9\u10D5","3-\u10D4 \u10D9\u10D5","4-\u10D4 \u10D9\u10D5"],
wide:["1-\u10DA\u10D8 \u10D9\u10D5\u10D0\u10E0\u10E2\u10D0\u10DA\u10D8","2-\u10D4 \u10D9\u10D5\u10D0\u10E0\u10E2\u10D0\u10DA\u10D8","3-\u10D4 \u10D9\u10D5\u10D0\u10E0\u10E2\u10D0\u10DA\u10D8","4-\u10D4 \u10D9\u10D5\u10D0\u10E0\u10E2\u10D0\u10DA\u10D8"]
};
var monthValues45={
narrow:[
"\u10D8\u10D0",
"\u10D7\u10D4",
"\u10DB\u10D0",
"\u10D0\u10DE",
"\u10DB\u10E1",
"\u10D5\u10DC",
"\u10D5\u10DA",
"\u10D0\u10D2",
"\u10E1\u10D4",
"\u10DD\u10E5",
"\u10DC\u10DD",
"\u10D3\u10D4"],

abbreviated:[
"\u10D8\u10D0\u10DC",
"\u10D7\u10D4\u10D1",
"\u10DB\u10D0\u10E0",
"\u10D0\u10DE\u10E0",
"\u10DB\u10D0\u10D8",
"\u10D8\u10D5\u10DC",
"\u10D8\u10D5\u10DA",
"\u10D0\u10D2\u10D5",
"\u10E1\u10D4\u10E5",
"\u10DD\u10E5\u10E2",
"\u10DC\u10DD\u10D4",
"\u10D3\u10D4\u10D9"],

wide:[
"\u10D8\u10D0\u10DC\u10D5\u10D0\u10E0\u10D8",
"\u10D7\u10D4\u10D1\u10D4\u10E0\u10D5\u10D0\u10DA\u10D8",
"\u10DB\u10D0\u10E0\u10E2\u10D8",
"\u10D0\u10DE\u10E0\u10D8\u10DA\u10D8",
"\u10DB\u10D0\u10D8\u10E1\u10D8",
"\u10D8\u10D5\u10DC\u10D8\u10E1\u10D8",
"\u10D8\u10D5\u10DA\u10D8\u10E1\u10D8",
"\u10D0\u10D2\u10D5\u10D8\u10E1\u10E2\u10DD",
"\u10E1\u10D4\u10E5\u10E2\u10D4\u10DB\u10D1\u10D4\u10E0\u10D8",
"\u10DD\u10E5\u10E2\u10DD\u10DB\u10D1\u10D4\u10E0\u10D8",
"\u10DC\u10DD\u10D4\u10DB\u10D1\u10D4\u10E0\u10D8",
"\u10D3\u10D4\u10D9\u10D4\u10DB\u10D1\u10D4\u10E0\u10D8"]

};
var dayValues45={
narrow:["\u10D9\u10D5","\u10DD\u10E0","\u10E1\u10D0","\u10DD\u10D7","\u10EE\u10E3","\u10DE\u10D0","\u10E8\u10D0"],
short:["\u10D9\u10D5\u10D8","\u10DD\u10E0\u10E8","\u10E1\u10D0\u10DB","\u10DD\u10D7\u10EE","\u10EE\u10E3\u10D7","\u10DE\u10D0\u10E0","\u10E8\u10D0\u10D1"],
abbreviated:["\u10D9\u10D5\u10D8","\u10DD\u10E0\u10E8","\u10E1\u10D0\u10DB","\u10DD\u10D7\u10EE","\u10EE\u10E3\u10D7","\u10DE\u10D0\u10E0","\u10E8\u10D0\u10D1"],
wide:[
"\u10D9\u10D5\u10D8\u10E0\u10D0",
"\u10DD\u10E0\u10E8\u10D0\u10D1\u10D0\u10D7\u10D8",
"\u10E1\u10D0\u10DB\u10E8\u10D0\u10D1\u10D0\u10D7\u10D8",
"\u10DD\u10D7\u10EE\u10E8\u10D0\u10D1\u10D0\u10D7\u10D8",
"\u10EE\u10E3\u10D7\u10E8\u10D0\u10D1\u10D0\u10D7\u10D8",
"\u10DE\u10D0\u10E0\u10D0\u10E1\u10D9\u10D4\u10D5\u10D8",
"\u10E8\u10D0\u10D1\u10D0\u10D7\u10D8"]

};
var dayPeriodValues45={
narrow:{
am:"a",
pm:"p",
midnight:"\u10E8\u10E3\u10D0\u10E6\u10D0\u10DB\u10D4",
noon:"\u10E8\u10E3\u10D0\u10D3\u10E6\u10D4",
morning:"\u10D3\u10D8\u10DA\u10D0",
afternoon:"\u10E1\u10D0\u10E6\u10D0\u10DB\u10DD",
evening:"\u10E1\u10D0\u10E6\u10D0\u10DB\u10DD",
night:"\u10E6\u10D0\u10DB\u10D4"
},
abbreviated:{
am:"AM",
pm:"PM",
midnight:"\u10E8\u10E3\u10D0\u10E6\u10D0\u10DB\u10D4",
noon:"\u10E8\u10E3\u10D0\u10D3\u10E6\u10D4",
morning:"\u10D3\u10D8\u10DA\u10D0",
afternoon:"\u10E1\u10D0\u10E6\u10D0\u10DB\u10DD",
evening:"\u10E1\u10D0\u10E6\u10D0\u10DB\u10DD",
night:"\u10E6\u10D0\u10DB\u10D4"
},
wide:{
am:"a.m.",
pm:"p.m.",
midnight:"\u10E8\u10E3\u10D0\u10E6\u10D0\u10DB\u10D4",
noon:"\u10E8\u10E3\u10D0\u10D3\u10E6\u10D4",
morning:"\u10D3\u10D8\u10DA\u10D0",
afternoon:"\u10E1\u10D0\u10E6\u10D0\u10DB\u10DD",
evening:"\u10E1\u10D0\u10E6\u10D0\u10DB\u10DD",
night:"\u10E6\u10D0\u10DB\u10D4"
}
};
var formattingDayPeriodValues37={
narrow:{
am:"a",
pm:"p",
midnight:"\u10E8\u10E3\u10D0\u10E6\u10D0\u10DB\u10D8\u10D7",
noon:"\u10E8\u10E3\u10D0\u10D3\u10E6\u10D8\u10E1\u10D0\u10E1",
morning:"\u10D3\u10D8\u10DA\u10D8\u10D7",
afternoon:"\u10DC\u10D0\u10E8\u10E3\u10D0\u10D3\u10E6\u10D4\u10D5\u10E1",
evening:"\u10E1\u10D0\u10E6\u10D0\u10DB\u10DD\u10E1",
night:"\u10E6\u10D0\u10DB\u10D8\u10D7"
},
abbreviated:{
am:"AM",
pm:"PM",
midnight:"\u10E8\u10E3\u10D0\u10E6\u10D0\u10DB\u10D8\u10D7",
noon:"\u10E8\u10E3\u10D0\u10D3\u10E6\u10D8\u10E1\u10D0\u10E1",
morning:"\u10D3\u10D8\u10DA\u10D8\u10D7",
afternoon:"\u10DC\u10D0\u10E8\u10E3\u10D0\u10D3\u10E6\u10D4\u10D5\u10E1",
evening:"\u10E1\u10D0\u10E6\u10D0\u10DB\u10DD\u10E1",
night:"\u10E6\u10D0\u10DB\u10D8\u10D7"
},
wide:{
am:"a.m.",
pm:"p.m.",
midnight:"\u10E8\u10E3\u10D0\u10E6\u10D0\u10DB\u10D8\u10D7",
noon:"\u10E8\u10E3\u10D0\u10D3\u10E6\u10D8\u10E1\u10D0\u10E1",
morning:"\u10D3\u10D8\u10DA\u10D8\u10D7",
afternoon:"\u10DC\u10D0\u10E8\u10E3\u10D0\u10D3\u10E6\u10D4\u10D5\u10E1",
evening:"\u10E1\u10D0\u10E6\u10D0\u10DB\u10DD\u10E1",
night:"\u10E6\u10D0\u10DB\u10D8\u10D7"
}
};
var ordinalNumber45=function ordinalNumber45(dirtyNumber){
var number=Number(dirtyNumber);
if(number===1){
return number+"-\u10DA\u10D8";
}
return number+"-\u10D4";
};
var localize102={
ordinalNumber:ordinalNumber45,
era:buildLocalizeFn({
values:eraValues45,
defaultWidth:"wide"
}),
quarter:buildLocalizeFn({
values:quarterValues45,
defaultWidth:"wide",
argumentCallback:function argumentCallback(quarter){return quarter-1;}
}),
month:buildLocalizeFn({
values:monthValues45,
defaultWidth:"wide"
}),
day:buildLocalizeFn({
values:dayValues45,
defaultWidth:"wide"
}),
dayPeriod:buildLocalizeFn({
values:dayPeriodValues45,
defaultWidth:"wide",
formattingValues:formattingDayPeriodValues37,
defaultFormattingWidth:"wide"
})
};

// lib/locale/ka/_lib/match.js
var matchOrdinalNumberPattern44=/^(\d+)(-ლი|-ე)?/i;
var parseOrdinalNumberPattern44=/\d+/i;
var matchEraPatterns44={
narrow:/^(ჩვ?\.წ)/i,
abbreviated:/^(ჩვ?\.წ)/i,
wide:/^(ჩვენს წელთაღრიცხვამდე|ქრისტეშობამდე|ჩვენი წელთაღრიცხვით|ქრისტეშობიდან)/i
};
var parseEraPatterns44={
any:[
/^(ჩვენს წელთაღრიცხვამდე|ქრისტეშობამდე)/i,
/^(ჩვენი წელთაღრიცხვით|ქრისტეშობიდან)/i]

};
var matchQuarterPatterns44={
narrow:/^[1234]/i,
abbreviated:/^[1234]-(ლი|ე)? კვ/i,
wide:/^[1234]-(ლი|ე)? კვარტალი/i
};
var parseQuarterPatterns44={
any:[/1/i,/2/i,/3/i,/4/i]
};
var matchMonthPatterns44={
any:/^(ია|თე|მა|აპ|მს|ვნ|ვლ|აგ|სე|ოქ|ნო|დე)/i
};
var parseMonthPatterns44={
any:[
/^ია/i,
/^თ/i,
/^მარ/i,
/^აპ/i,
/^მაი/i,
/^ი?ვნ/i,
/^ი?ვლ/i,
/^აგ/i,
/^ს/i,
/^ო/i,
/^ნ/i,
/^დ/i]

};
var matchDayPatterns44={
narrow:/^(კვ|ორ|სა|ოთ|ხუ|პა|შა)/i,
short:/^(კვი|ორშ|სამ|ოთხ|ხუთ|პარ|შაბ)/i,
wide:/^(კვირა|ორშაბათი|სამშაბათი|ოთხშაბათი|ხუთშაბათი|პარასკევი|შაბათი)/i
};
var parseDayPatterns44={
any:[/^კვ/i,/^ორ/i,/^სა/i,/^ოთ/i,/^ხუ/i,/^პა/i,/^შა/i]
};
var matchDayPeriodPatterns44={
any:/^([ap]\.?\s?m\.?|შუაღ|დილ)/i
};
var parseDayPeriodPatterns44={
any:{
am:/^a/i,
pm:/^p/i,
midnight:/^შუაღ/i,
noon:/^შუადღ/i,
morning:/^დილ/i,
afternoon:/ნაშუადღევს/i,
evening:/საღამო/i,
night:/ღამ/i
}
};
var match98={
ordinalNumber:buildMatchPatternFn({
matchPattern:matchOrdinalNumberPattern44,
parsePattern:parseOrdinalNumberPattern44,
valueCallback:function valueCallback(value){return parseInt(value,10);}
}),
era:buildMatchFn({
matchPatterns:matchEraPatterns44,
defaultMatchWidth:"wide",
parsePatterns:parseEraPatterns44,
defaultParseWidth:"any"
}),
quarter:buildMatchFn({
matchPatterns:matchQuarterPatterns44,
defaultMatchWidth:"wide",
parsePatterns:parseQuarterPatterns44,
defaultParseWidth:"any",
valueCallback:function valueCallback(index){return index+1;}
}),
month:buildMatchFn({
matchPatterns:matchMonthPatterns44,
defaultMatchWidth:"any",
parsePatterns:parseMonthPatterns44,
defaultParseWidth:"any"
}),
day:buildMatchFn({
matchPatterns:matchDayPatterns44,
defaultMatchWidth:"wide",
parsePatterns:parseDayPatterns44,
defaultParseWidth:"any"
}),
dayPeriod:buildMatchFn({
matchPatterns:matchDayPeriodPatterns44,
defaultMatchWidth:"any",
parsePatterns:parseDayPeriodPatterns44,
defaultParseWidth:"any"
})
};

// lib/locale/ka.js
var _ka={
code:"ka",
formatDistance:formatDistance99,
formatLong:formatLong107,
formatRelative:formatRelative99,
localize:localize102,
match:match98,
options:{
weekStartsOn:1,
firstWeekContainsDate:1
}
};
// lib/locale/kk/_lib/formatDistance.js
function declension3(scheme,count){
if(scheme.one&&count===1)
return scheme.one;
var rem10=count%10;
var rem100=count%100;
if(rem10===1&&rem100!==11){
return scheme.singularNominative.replace("{{count}}",String(count));
}else if(rem10>=2&&rem10<=4&&(rem100<10||rem100>20)){
return scheme.singularGenitive.replace("{{count}}",String(count));
}else{
return scheme.pluralGenitive.replace("{{count}}",String(count));
}
}
var formatDistanceLocale45={
lessThanXSeconds:{
regular:{
one:"1 \u0441\u0435\u043A\u0443\u043D\u0434\u0442\u0430\u043D \u0430\u0437",
singularNominative:"{{count}} \u0441\u0435\u043A\u0443\u043D\u0434\u0442\u0430\u043D \u0430\u0437",
singularGenitive:"{{count}} \u0441\u0435\u043A\u0443\u043D\u0434\u0442\u0430\u043D \u0430\u0437",
pluralGenitive:"{{count}} \u0441\u0435\u043A\u0443\u043D\u0434\u0442\u0430\u043D \u0430\u0437"
},
future:{
one:"\u0431\u0456\u0440 \u0441\u0435\u043A\u0443\u043D\u0434\u0442\u0430\u043D \u043A\u0435\u0439\u0456\u043D",
singularNominative:"{{count}} \u0441\u0435\u043A\u0443\u043D\u0434\u0442\u0430\u043D \u043A\u0435\u0439\u0456\u043D",
singularGenitive:"{{count}} \u0441\u0435\u043A\u0443\u043D\u0434\u0442\u0430\u043D \u043A\u0435\u0439\u0456\u043D",
pluralGenitive:"{{count}} \u0441\u0435\u043A\u0443\u043D\u0434\u0442\u0430\u043D \u043A\u0435\u0439\u0456\u043D"
}
},
xSeconds:{
regular:{
singularNominative:"{{count}} \u0441\u0435\u043A\u0443\u043D\u0434",
singularGenitive:"{{count}} \u0441\u0435\u043A\u0443\u043D\u0434",
pluralGenitive:"{{count}} \u0441\u0435\u043A\u0443\u043D\u0434"
},
past:{
singularNominative:"{{count}} \u0441\u0435\u043A\u0443\u043D\u0434 \u0431\u04B1\u0440\u044B\u043D",
singularGenitive:"{{count}} \u0441\u0435\u043A\u0443\u043D\u0434 \u0431\u04B1\u0440\u044B\u043D",
pluralGenitive:"{{count}} \u0441\u0435\u043A\u0443\u043D\u0434 \u0431\u04B1\u0440\u044B\u043D"
},
future:{
singularNominative:"{{count}} \u0441\u0435\u043A\u0443\u043D\u0434\u0442\u0430\u043D \u043A\u0435\u0439\u0456\u043D",
singularGenitive:"{{count}} \u0441\u0435\u043A\u0443\u043D\u0434\u0442\u0430\u043D \u043A\u0435\u0439\u0456\u043D",
pluralGenitive:"{{count}} \u0441\u0435\u043A\u0443\u043D\u0434\u0442\u0430\u043D \u043A\u0435\u0439\u0456\u043D"
}
},
halfAMinute:function halfAMinute(options){
if(options!==null&&options!==void 0&&options.addSuffix){
if(options.comparison&&options.comparison>0){
return"\u0436\u0430\u0440\u0442\u044B \u043C\u0438\u043D\u0443\u0442 \u0456\u0448\u0456\u043D\u0434\u0435";
}else{
return"\u0436\u0430\u0440\u0442\u044B \u043C\u0438\u043D\u0443\u0442 \u0431\u04B1\u0440\u044B\u043D";
}
}
return"\u0436\u0430\u0440\u0442\u044B \u043C\u0438\u043D\u0443\u0442";
},
lessThanXMinutes:{
regular:{
one:"1 \u043C\u0438\u043D\u0443\u0442\u0442\u0430\u043D \u0430\u0437",
singularNominative:"{{count}} \u043C\u0438\u043D\u0443\u0442\u0442\u0430\u043D \u0430\u0437",
singularGenitive:"{{count}} \u043C\u0438\u043D\u0443\u0442\u0442\u0430\u043D \u0430\u0437",
pluralGenitive:"{{count}} \u043C\u0438\u043D\u0443\u0442\u0442\u0430\u043D \u0430\u0437"
},
future:{
one:"\u043C\u0438\u043D\u0443\u0442\u0442\u0430\u043D \u043A\u0435\u043C ",
singularNominative:"{{count}} \u043C\u0438\u043D\u0443\u0442\u0442\u0430\u043D \u043A\u0435\u043C",
singularGenitive:"{{count}} \u043C\u0438\u043D\u0443\u0442\u0442\u0430\u043D \u043A\u0435\u043C",
pluralGenitive:"{{count}} \u043C\u0438\u043D\u0443\u0442\u0442\u0430\u043D \u043A\u0435\u043C"
}
},
xMinutes:{
regular:{
singularNominative:"{{count}} \u043C\u0438\u043D\u0443\u0442",
singularGenitive:"{{count}} \u043C\u0438\u043D\u0443\u0442",
pluralGenitive:"{{count}} \u043C\u0438\u043D\u0443\u0442"
},
past:{
singularNominative:"{{count}} \u043C\u0438\u043D\u0443\u0442 \u0431\u04B1\u0440\u044B\u043D",
singularGenitive:"{{count}} \u043C\u0438\u043D\u0443\u0442 \u0431\u04B1\u0440\u044B\u043D",
pluralGenitive:"{{count}} \u043C\u0438\u043D\u0443\u0442 \u0431\u04B1\u0440\u044B\u043D"
},
future:{
singularNominative:"{{count}} \u043C\u0438\u043D\u0443\u0442\u0442\u0430\u043D \u043A\u0435\u0439\u0456\u043D",
singularGenitive:"{{count}} \u043C\u0438\u043D\u0443\u0442\u0442\u0430\u043D \u043A\u0435\u0439\u0456\u043D",
pluralGenitive:"{{count}} \u043C\u0438\u043D\u0443\u0442\u0442\u0430\u043D \u043A\u0435\u0439\u0456\u043D"
}
},
aboutXHours:{
regular:{
singularNominative:"\u0448\u0430\u043C\u0430\u043C\u0435\u043D {{count}} \u0441\u0430\u0493\u0430\u0442",
singularGenitive:"\u0448\u0430\u043C\u0430\u043C\u0435\u043D {{count}} \u0441\u0430\u0493\u0430\u0442",
pluralGenitive:"\u0448\u0430\u043C\u0430\u043C\u0435\u043D {{count}} \u0441\u0430\u0493\u0430\u0442"
},
future:{
singularNominative:"\u0448\u0430\u043C\u0430\u043C\u0435\u043D {{count}} \u0441\u0430\u0493\u0430\u0442\u0442\u0430\u043D \u043A\u0435\u0439\u0456\u043D",
singularGenitive:"\u0448\u0430\u043C\u0430\u043C\u0435\u043D {{count}} \u0441\u0430\u0493\u0430\u0442\u0442\u0430\u043D \u043A\u0435\u0439\u0456\u043D",
pluralGenitive:"\u0448\u0430\u043C\u0430\u043C\u0435\u043D {{count}} \u0441\u0430\u0493\u0430\u0442\u0442\u0430\u043D \u043A\u0435\u0439\u0456\u043D"
}
},
xHours:{
regular:{
singularNominative:"{{count}} \u0441\u0430\u0493\u0430\u0442",
singularGenitive:"{{count}} \u0441\u0430\u0493\u0430\u0442",
pluralGenitive:"{{count}} \u0441\u0430\u0493\u0430\u0442"
}
},
xDays:{
regular:{
singularNominative:"{{count}} \u043A\u04AF\u043D",
singularGenitive:"{{count}} \u043A\u04AF\u043D",
pluralGenitive:"{{count}} \u043A\u04AF\u043D"
},
future:{
singularNominative:"{{count}} \u043A\u04AF\u043D\u043D\u0435\u043D \u043A\u0435\u0439\u0456\u043D",
singularGenitive:"{{count}} \u043A\u04AF\u043D\u043D\u0435\u043D \u043A\u0435\u0439\u0456\u043D",
pluralGenitive:"{{count}} \u043A\u04AF\u043D\u043D\u0435\u043D \u043A\u0435\u0439\u0456\u043D"
}
},
aboutXWeeks:{
type:"weeks",
one:"\u0448\u0430\u043C\u0430\u043C\u0435\u043D 1 \u0430\u043F\u0442\u0430",
other:"\u0448\u0430\u043C\u0430\u043C\u0435\u043D {{count}} \u0430\u043F\u0442\u0430"
},
xWeeks:{
type:"weeks",
one:"1 \u0430\u043F\u0442\u0430",
other:"{{count}} \u0430\u043F\u0442\u0430"
},
aboutXMonths:{
regular:{
singularNominative:"\u0448\u0430\u043C\u0430\u043C\u0435\u043D {{count}} \u0430\u0439",
singularGenitive:"\u0448\u0430\u043C\u0430\u043C\u0435\u043D {{count}} \u0430\u0439",
pluralGenitive:"\u0448\u0430\u043C\u0430\u043C\u0435\u043D {{count}} \u0430\u0439"
},
future:{
singularNominative:"\u0448\u0430\u043C\u0430\u043C\u0435\u043D {{count}} \u0430\u0439\u0434\u0430\u043D \u043A\u0435\u0439\u0456\u043D",
singularGenitive:"\u0448\u0430\u043C\u0430\u043C\u0435\u043D {{count}} \u0430\u0439\u0434\u0430\u043D \u043A\u0435\u0439\u0456\u043D",
pluralGenitive:"\u0448\u0430\u043C\u0430\u043C\u0435\u043D {{count}} \u0430\u0439\u0434\u0430\u043D \u043A\u0435\u0439\u0456\u043D"
}
},
xMonths:{
regular:{
singularNominative:"{{count}} \u0430\u0439",
singularGenitive:"{{count}} \u0430\u0439",
pluralGenitive:"{{count}} \u0430\u0439"
}
},
aboutXYears:{
regular:{
singularNominative:"\u0448\u0430\u043C\u0430\u043C\u0435\u043D {{count}} \u0436\u044B\u043B",
singularGenitive:"\u0448\u0430\u043C\u0430\u043C\u0435\u043D {{count}} \u0436\u044B\u043B",
pluralGenitive:"\u0448\u0430\u043C\u0430\u043C\u0435\u043D {{count}} \u0436\u044B\u043B"
},
future:{
singularNominative:"\u0448\u0430\u043C\u0430\u043C\u0435\u043D {{count}} \u0436\u044B\u043B\u0434\u0430\u043D \u043A\u0435\u0439\u0456\u043D",
singularGenitive:"\u0448\u0430\u043C\u0430\u043C\u0435\u043D {{count}} \u0436\u044B\u043B\u0434\u0430\u043D \u043A\u0435\u0439\u0456\u043D",
pluralGenitive:"\u0448\u0430\u043C\u0430\u043C\u0435\u043D {{count}} \u0436\u044B\u043B\u0434\u0430\u043D \u043A\u0435\u0439\u0456\u043D"
}
},
xYears:{
regular:{
singularNominative:"{{count}} \u0436\u044B\u043B",
singularGenitive:"{{count}} \u0436\u044B\u043B",
pluralGenitive:"{{count}} \u0436\u044B\u043B"
},
future:{
singularNominative:"{{count}} \u0436\u044B\u043B\u0434\u0430\u043D \u043A\u0435\u0439\u0456\u043D",
singularGenitive:"{{count}} \u0436\u044B\u043B\u0434\u0430\u043D \u043A\u0435\u0439\u0456\u043D",
pluralGenitive:"{{count}} \u0436\u044B\u043B\u0434\u0430\u043D \u043A\u0435\u0439\u0456\u043D"
}
},
overXYears:{
regular:{
singularNominative:"{{count}} \u0436\u044B\u043B\u0434\u0430\u043D \u0430\u0441\u0442\u0430\u043C",
singularGenitive:"{{count}} \u0436\u044B\u043B\u0434\u0430\u043D \u0430\u0441\u0442\u0430\u043C",
pluralGenitive:"{{count}} \u0436\u044B\u043B\u0434\u0430\u043D \u0430\u0441\u0442\u0430\u043C"
},
future:{
singularNominative:"{{count}} \u0436\u044B\u043B\u0434\u0430\u043D \u0430\u0441\u0442\u0430\u043C",
singularGenitive:"{{count}} \u0436\u044B\u043B\u0434\u0430\u043D \u0430\u0441\u0442\u0430\u043C",
pluralGenitive:"{{count}} \u0436\u044B\u043B\u0434\u0430\u043D \u0430\u0441\u0442\u0430\u043C"
}
},
almostXYears:{
regular:{
singularNominative:"{{count}} \u0436\u044B\u043B\u0493\u0430 \u0436\u0430\u049B\u044B\u043D",
singularGenitive:"{{count}} \u0436\u044B\u043B\u0493\u0430 \u0436\u0430\u049B\u044B\u043D",
pluralGenitive:"{{count}} \u0436\u044B\u043B\u0493\u0430 \u0436\u0430\u049B\u044B\u043D"
},
future:{
singularNominative:"{{count}} \u0436\u044B\u043B\u0434\u0430\u043D \u043A\u0435\u0439\u0456\u043D",
singularGenitive:"{{count}} \u0436\u044B\u043B\u0434\u0430\u043D \u043A\u0435\u0439\u0456\u043D",
pluralGenitive:"{{count}} \u0436\u044B\u043B\u0434\u0430\u043D \u043A\u0435\u0439\u0456\u043D"
}
}
};
var formatDistance101=function formatDistance101(token,count,options){
var tokenValue=formatDistanceLocale45[token];
if(typeof tokenValue==="function")
return tokenValue(options);
if(tokenValue.type==="weeks"){
return count===1?tokenValue.one:tokenValue.other.replace("{{count}}",String(count));
}
if(options!==null&&options!==void 0&&options.addSuffix){
if(options.comparison&&options.comparison>0){
if(tokenValue.future){
return declension3(tokenValue.future,count);
}else{
return declension3(tokenValue.regular,count)+" \u043A\u0435\u0439\u0456\u043D";
}
}else{
if(tokenValue.past){
return declension3(tokenValue.past,count);
}else{
return declension3(tokenValue.regular,count)+" \u0431\u04B1\u0440\u044B\u043D";
}
}
}else{
return declension3(tokenValue.regular,count);
}
};

// lib/locale/kk/_lib/formatLong.js
var dateFormats54={
full:"EEEE, do MMMM y '\u0436.'",
long:"do MMMM y '\u0436.'",
medium:"d MMM y '\u0436.'",
short:"dd.MM.yyyy"
};
var timeFormats54={
full:"H:mm:ss zzzz",
long:"H:mm:ss z",
medium:"H:mm:ss",
short:"H:mm"
};
var dateTimeFormats54={
any:"{{date}}, {{time}}"
};
var formatLong109={
date:buildFormatLongFn({
formats:dateFormats54,
defaultWidth:"full"
}),
time:buildFormatLongFn({
formats:timeFormats54,
defaultWidth:"full"
}),
dateTime:buildFormatLongFn({
formats:dateTimeFormats54,
defaultWidth:"any"
})
};

// lib/locale/kk/_lib/formatRelative.js
function lastWeek5(day){
var weekday=accusativeWeekdays5[day];
return"'\u04E9\u0442\u043A\u0435\u043D "+weekday+" \u0441\u0430\u0493\u0430\u0442' p'-\u0434\u0435'";
}
function thisWeek5(day){
var weekday=accusativeWeekdays5[day];
return"'"+weekday+" \u0441\u0430\u0493\u0430\u0442' p'-\u0434\u0435'";
}
function nextWeek5(day){
var weekday=accusativeWeekdays5[day];
return"'\u043A\u0435\u043B\u0435\u0441\u0456 "+weekday+" \u0441\u0430\u0493\u0430\u0442' p'-\u0434\u0435'";
}
var accusativeWeekdays5=[
"\u0436\u0435\u043A\u0441\u0435\u043D\u0431\u0456\u0434\u0435",
"\u0434\u04AF\u0439\u0441\u0435\u043D\u0431\u0456\u0434\u0435",
"\u0441\u0435\u0439\u0441\u0435\u043D\u0431\u0456\u0434\u0435",
"\u0441\u04D9\u0440\u0441\u0435\u043D\u0431\u0456\u0434\u0435",
"\u0431\u0435\u0439\u0441\u0435\u043D\u0431\u0456\u0434\u0435",
"\u0436\u04B1\u043C\u0430\u0434\u0430",
"\u0441\u0435\u043D\u0431\u0456\u0434\u0435"];

var formatRelativeLocale46={
lastWeek:function lastWeek(date,baseDate,options){
var day=date.getDay();
if(isSameWeek(date,baseDate,options)){
return thisWeek5(day);
}else{
return lastWeek5(day);
}
},
yesterday:"'\u043A\u0435\u0448\u0435 \u0441\u0430\u0493\u0430\u0442' p'-\u0434\u0435'",
today:"'\u0431\u04AF\u0433\u0456\u043D \u0441\u0430\u0493\u0430\u0442' p'-\u0434\u0435'",
tomorrow:"'\u0435\u0440\u0442\u0435\u04A3 \u0441\u0430\u0493\u0430\u0442' p'-\u0434\u0435'",
nextWeek:function nextWeek(date,baseDate,options){
var day=date.getDay();
if(isSameWeek(date,baseDate,options)){
return thisWeek5(day);
}else{
return nextWeek5(day);
}
},
other:"P"
};
var formatRelative101=function formatRelative101(token,date,baseDate,options){
var format=formatRelativeLocale46[token];
if(typeof format==="function"){
return format(date,baseDate,options);
}
return format;
};

// lib/locale/kk/_lib/localize.js
var eraValues46={
narrow:["\u0431.\u0437.\u0434.","\u0431.\u0437."],
abbreviated:["\u0431.\u0437.\u0434.","\u0431.\u0437."],
wide:["\u0431\u0456\u0437\u0434\u0456\u04A3 \u0437\u0430\u043C\u0430\u043D\u044B\u043C\u044B\u0437\u0493\u0430 \u0434\u0435\u0439\u0456\u043D","\u0431\u0456\u0437\u0434\u0456\u04A3 \u0437\u0430\u043C\u0430\u043D\u044B\u043C\u044B\u0437"]
};
var quarterValues46={
narrow:["1","2","3","4"],
abbreviated:["1-\u0448\u0456 \u0442\u043E\u049B.","2-\u0448\u0456 \u0442\u043E\u049B.","3-\u0448\u0456 \u0442\u043E\u049B.","4-\u0448\u0456 \u0442\u043E\u049B."],
wide:["1-\u0448\u0456 \u0442\u043E\u049B\u0441\u0430\u043D","2-\u0448\u0456 \u0442\u043E\u049B\u0441\u0430\u043D","3-\u0448\u0456 \u0442\u043E\u049B\u0441\u0430\u043D","4-\u0448\u0456 \u0442\u043E\u049B\u0441\u0430\u043D"]
};
var monthValues46={
narrow:["\u049A","\u0410","\u041D","\u0421","\u041C","\u041C","\u0428","\u0422","\u049A","\u049A","\u049A","\u0416"],
abbreviated:[
"\u049B\u0430\u04A3",
"\u0430\u049B\u043F",
"\u043D\u0430\u0443",
"\u0441\u04D9\u0443",
"\u043C\u0430\u043C",
"\u043C\u0430\u0443",
"\u0448\u0456\u043B",
"\u0442\u0430\u043C",
"\u049B\u044B\u0440",
"\u049B\u0430\u0437",
"\u049B\u0430\u0440",
"\u0436\u0435\u043B"],

wide:[
"\u049B\u0430\u04A3\u0442\u0430\u0440",
"\u0430\u049B\u043F\u0430\u043D",
"\u043D\u0430\u0443\u0440\u044B\u0437",
"\u0441\u04D9\u0443\u0456\u0440",
"\u043C\u0430\u043C\u044B\u0440",
"\u043C\u0430\u0443\u0441\u044B\u043C",
"\u0448\u0456\u043B\u0434\u0435",
"\u0442\u0430\u043C\u044B\u0437",
"\u049B\u044B\u0440\u043A\u04AF\u0439\u0435\u043A",
"\u049B\u0430\u0437\u0430\u043D",
"\u049B\u0430\u0440\u0430\u0448\u0430",
"\u0436\u0435\u043B\u0442\u043E\u049B\u0441\u0430\u043D"]

};
var formattingMonthValues10={
narrow:["\u049A","\u0410","\u041D","\u0421","\u041C","\u041C","\u0428","\u0422","\u049A","\u049A","\u049A","\u0416"],
abbreviated:[
"\u049B\u0430\u04A3",
"\u0430\u049B\u043F",
"\u043D\u0430\u0443",
"\u0441\u04D9\u0443",
"\u043C\u0430\u043C",
"\u043C\u0430\u0443",
"\u0448\u0456\u043B",
"\u0442\u0430\u043C",
"\u049B\u044B\u0440",
"\u049B\u0430\u0437",
"\u049B\u0430\u0440",
"\u0436\u0435\u043B"],

wide:[
"\u049B\u0430\u04A3\u0442\u0430\u0440",
"\u0430\u049B\u043F\u0430\u043D",
"\u043D\u0430\u0443\u0440\u044B\u0437",
"\u0441\u04D9\u0443\u0456\u0440",
"\u043C\u0430\u043C\u044B\u0440",
"\u043C\u0430\u0443\u0441\u044B\u043C",
"\u0448\u0456\u043B\u0434\u0435",
"\u0442\u0430\u043C\u044B\u0437",
"\u049B\u044B\u0440\u043A\u04AF\u0439\u0435\u043A",
"\u049B\u0430\u0437\u0430\u043D",
"\u049B\u0430\u0440\u0430\u0448\u0430",
"\u0436\u0435\u043B\u0442\u043E\u049B\u0441\u0430\u043D"]

};
var dayValues46={
narrow:["\u0416","\u0414","\u0421","\u0421","\u0411","\u0416","\u0421"],
short:["\u0436\u0441","\u0434\u0441","\u0441\u0441","\u0441\u0440","\u0431\u0441","\u0436\u043C","\u0441\u0431"],
abbreviated:["\u0436\u0441","\u0434\u0441","\u0441\u0441","\u0441\u0440","\u0431\u0441","\u0436\u043C","\u0441\u0431"],
wide:[
"\u0436\u0435\u043A\u0441\u0435\u043D\u0431\u0456",
"\u0434\u04AF\u0439\u0441\u0435\u043D\u0431\u0456",
"\u0441\u0435\u0439\u0441\u0435\u043D\u0431\u0456",
"\u0441\u04D9\u0440\u0441\u0435\u043D\u0431\u0456",
"\u0431\u0435\u0439\u0441\u0435\u043D\u0431\u0456",
"\u0436\u04B1\u043C\u0430",
"\u0441\u0435\u043D\u0431\u0456"]

};
var dayPeriodValues46={
narrow:{
am:"\u0422\u0414",
pm:"\u0422\u041A",
midnight:"\u0442\u04AF\u043D \u043E\u0440\u0442\u0430\u0441\u044B",
noon:"\u0442\u04AF\u0441",
morning:"\u0442\u0430\u04A3",
afternoon:"\u043A\u04AF\u043D\u0434\u0456\u0437",
evening:"\u043A\u0435\u0448",
night:"\u0442\u04AF\u043D"
},
wide:{
am:"\u0422\u0414",
pm:"\u0422\u041A",
midnight:"\u0442\u04AF\u043D \u043E\u0440\u0442\u0430\u0441\u044B",
noon:"\u0442\u04AF\u0441",
morning:"\u0442\u0430\u04A3",
afternoon:"\u043A\u04AF\u043D\u0434\u0456\u0437",
evening:"\u043A\u0435\u0448",
night:"\u0442\u04AF\u043D"
}
};
var formattingDayPeriodValues38={
narrow:{
am:"\u0422\u0414",
pm:"\u0422\u041A",
midnight:"\u0442\u04AF\u043D \u043E\u0440\u0442\u0430\u0441\u044B\u043D\u0434\u0430",
noon:"\u0442\u04AF\u0441",
morning:"\u0442\u0430\u04A3",
afternoon:"\u043A\u04AF\u043D",
evening:"\u043A\u0435\u0448",
night:"\u0442\u04AF\u043D"
},
wide:{
am:"\u0422\u0414",
pm:"\u0422\u041A",
midnight:"\u0442\u04AF\u043D \u043E\u0440\u0442\u0430\u0441\u044B\u043D\u0434\u0430",
noon:"\u0442\u04AF\u0441\u0442\u0435",
morning:"\u0442\u0430\u04A3\u0435\u0440\u0442\u0435\u04A3",
afternoon:"\u043A\u04AF\u043D\u0434\u0456\u0437",
evening:"\u043A\u0435\u0448\u0442\u0435",
night:"\u0442\u04AF\u043D\u0434\u0435"
}
};
var suffixes2={
0:"-\u0448\u0456",
1:"-\u0448\u0456",
2:"-\u0448\u0456",
3:"-\u0448\u0456",
4:"-\u0448\u0456",
5:"-\u0448\u0456",
6:"-\u0448\u044B",
7:"-\u0448\u0456",
8:"-\u0448\u0456",
9:"-\u0448\u044B",
10:"-\u0448\u044B",
20:"-\u0448\u044B",
30:"-\u0448\u044B",
40:"-\u0448\u044B",
50:"-\u0448\u0456",
60:"-\u0448\u044B",
70:"-\u0448\u0456",
80:"-\u0448\u0456",
90:"-\u0448\u044B",
100:"-\u0448\u0456"
};
var ordinalNumber46=function ordinalNumber46(dirtyNumber,_options){
var number=Number(dirtyNumber);
var mod10=number%10;
var b=number>=100?100:null;
var suffix=suffixes2[number]||suffixes2[mod10]||b&&suffixes2[b]||"";
return number+suffix;
};
var localize104={
ordinalNumber:ordinalNumber46,
era:buildLocalizeFn({
values:eraValues46,
defaultWidth:"wide"
}),
quarter:buildLocalizeFn({
values:quarterValues46,
defaultWidth:"wide",
argumentCallback:function argumentCallback(quarter){return quarter-1;}
}),
month:buildLocalizeFn({
values:monthValues46,
defaultWidth:"wide",
formattingValues:formattingMonthValues10,
defaultFormattingWidth:"wide"
}),
day:buildLocalizeFn({
values:dayValues46,
defaultWidth:"wide"
}),
dayPeriod:buildLocalizeFn({
values:dayPeriodValues46,
defaultWidth:"any",
formattingValues:formattingDayPeriodValues38,
defaultFormattingWidth:"wide"
})
};

// lib/locale/kk/_lib/match.js
var matchOrdinalNumberPattern45=/^(\d+)(-?(ші|шы))?/i;
var parseOrdinalNumberPattern45=/\d+/i;
var matchEraPatterns45={
narrow:/^((б )?з\.?\s?д\.?)/i,
abbreviated:/^((б )?з\.?\s?д\.?)/i,
wide:/^(біздің заманымызға дейін|біздің заманымыз|біздің заманымыздан)/i
};
var parseEraPatterns45={
any:[/^б/i,/^з/i]
};
var matchQuarterPatterns45={
narrow:/^[1234]/i,
abbreviated:/^[1234](-?ші)? тоқ.?/i,
wide:/^[1234](-?ші)? тоқсан/i
};
var parseQuarterPatterns45={
any:[/1/i,/2/i,/3/i,/4/i]
};
var matchMonthPatterns45={
narrow:/^(қ|а|н|с|м|мау|ш|т|қыр|қаз|қар|ж)/i,
abbreviated:/^(қаң|ақп|нау|сәу|мам|мау|шіл|там|қыр|қаз|қар|жел)/i,
wide:/^(қаңтар|ақпан|наурыз|сәуір|мамыр|маусым|шілде|тамыз|қыркүйек|қазан|қараша|желтоқсан)/i
};
var parseMonthPatterns45={
narrow:[
/^қ/i,
/^а/i,
/^н/i,
/^с/i,
/^м/i,
/^м/i,
/^ш/i,
/^т/i,
/^қ/i,
/^қ/i,
/^қ/i,
/^ж/i],

abbreviated:[
/^қаң/i,
/^ақп/i,
/^нау/i,
/^сәу/i,
/^мам/i,
/^мау/i,
/^шіл/i,
/^там/i,
/^қыр/i,
/^қаз/i,
/^қар/i,
/^жел/i],

any:[
/^қ/i,
/^а/i,
/^н/i,
/^с/i,
/^м/i,
/^м/i,
/^ш/i,
/^т/i,
/^қ/i,
/^қ/i,
/^қ/i,
/^ж/i]

};
var matchDayPatterns45={
narrow:/^(ж|д|с|с|б|ж|с)/i,
short:/^(жс|дс|сс|ср|бс|жм|сб)/i,
wide:/^(жексенбі|дүйсенбі|сейсенбі|сәрсенбі|бейсенбі|жұма|сенбі)/i
};
var parseDayPatterns45={
narrow:[/^ж/i,/^д/i,/^с/i,/^с/i,/^б/i,/^ж/i,/^с/i],
short:[/^жс/i,/^дс/i,/^сс/i,/^ср/i,/^бс/i,/^жм/i,/^сб/i],
any:[
/^ж[ек]/i,
/^д[үй]/i,
/^сe[й]/i,
/^сә[р]/i,
/^б[ей]/i,
/^ж[ұм]/i,
/^се[н]/i]

};
var matchDayPeriodPatterns45={
narrow:/^Т\.?\s?[ДК]\.?|түн ортасында|((түсте|таңертең|таңда|таңертең|таңмен|таң|күндіз|күн|кеште|кеш|түнде|түн)\.?)/i,
wide:/^Т\.?\s?[ДК]\.?|түн ортасында|((түсте|таңертең|таңда|таңертең|таңмен|таң|күндіз|күн|кеште|кеш|түнде|түн)\.?)/i,
any:/^Т\.?\s?[ДК]\.?|түн ортасында|((түсте|таңертең|таңда|таңертең|таңмен|таң|күндіз|күн|кеште|кеш|түнде|түн)\.?)/i
};
var parseDayPeriodPatterns45={
any:{
am:/^ТД/i,
pm:/^ТК/i,
midnight:/^түн орта/i,
noon:/^күндіз/i,
morning:/таң/i,
afternoon:/түс/i,
evening:/кеш/i,
night:/түн/i
}
};
var match100={
ordinalNumber:buildMatchPatternFn({
matchPattern:matchOrdinalNumberPattern45,
parsePattern:parseOrdinalNumberPattern45,
valueCallback:function valueCallback(value){return parseInt(value,10);}
}),
era:buildMatchFn({
matchPatterns:matchEraPatterns45,
defaultMatchWidth:"wide",
parsePatterns:parseEraPatterns45,
defaultParseWidth:"any"
}),
quarter:buildMatchFn({
matchPatterns:matchQuarterPatterns45,
defaultMatchWidth:"wide",
parsePatterns:parseQuarterPatterns45,
defaultParseWidth:"any",
valueCallback:function valueCallback(index){return index+1;}
}),
month:buildMatchFn({
matchPatterns:matchMonthPatterns45,
defaultMatchWidth:"wide",
parsePatterns:parseMonthPatterns45,
defaultParseWidth:"any"
}),
day:buildMatchFn({
matchPatterns:matchDayPatterns45,
defaultMatchWidth:"wide",
parsePatterns:parseDayPatterns45,
defaultParseWidth:"any"
}),
dayPeriod:buildMatchFn({
matchPatterns:matchDayPeriodPatterns45,
defaultMatchWidth:"wide",
parsePatterns:parseDayPeriodPatterns45,
defaultParseWidth:"any"
})
};

// lib/locale/kk.js
var _kk={
code:"kk",
formatDistance:formatDistance101,
formatLong:formatLong109,
formatRelative:formatRelative101,
localize:localize104,
match:match100,
options:{
weekStartsOn:1,
firstWeekContainsDate:1
}
};
// lib/locale/km/_lib/formatDistance.js
var formatDistanceLocale46={
lessThanXSeconds:"\u178F\u17B7\u1785\u1787\u17B6\u1784 {{count}} \u179C\u17B7\u1793\u17B6\u1791\u17B8",
xSeconds:"{{count}} \u179C\u17B7\u1793\u17B6\u1791\u17B8",
halfAMinute:"\u1780\u1793\u17D2\u179B\u17C7\u1793\u17B6\u1791\u17B8",
lessThanXMinutes:"\u178F\u17B7\u1785\u1787\u17B6\u1784 {{count}} \u1793\u17B6\u1791\u17B8",
xMinutes:"{{count}} \u1793\u17B6\u1791\u17B8",
aboutXHours:"\u1794\u17D2\u179A\u17A0\u17C2\u179B {{count}} \u1798\u17C9\u17C4\u1784",
xHours:"{{count}} \u1798\u17C9\u17C4\u1784",
xDays:"{{count}} \u1790\u17D2\u1784\u17C3",
aboutXWeeks:"\u1794\u17D2\u179A\u17A0\u17C2\u179B {{count}} \u179F\u1794\u17D2\u178F\u17B6\u17A0\u17CD",
xWeeks:"{{count}} \u179F\u1794\u17D2\u178F\u17B6\u17A0\u17CD",
aboutXMonths:"\u1794\u17D2\u179A\u17A0\u17C2\u179B {{count}} \u1781\u17C2",
xMonths:"{{count}} \u1781\u17C2",
aboutXYears:"\u1794\u17D2\u179A\u17A0\u17C2\u179B {{count}} \u1786\u17D2\u1793\u17B6\u17C6",
xYears:"{{count}} \u1786\u17D2\u1793\u17B6\u17C6",
overXYears:"\u1787\u17B6\u1784 {{count}} \u1786\u17D2\u1793\u17B6\u17C6",
almostXYears:"\u1787\u17B7\u178F {{count}} \u1786\u17D2\u1793\u17B6\u17C6"
};
var formatDistance103=function formatDistance103(token,count,options){
var tokenValue=formatDistanceLocale46[token];
var result=tokenValue;
if(typeof count==="number"){
result=result.replace("{{count}}",count.toString());
}
if(options!==null&&options!==void 0&&options.addSuffix){
if(options.comparison&&options.comparison>0){
return"\u1780\u17D2\u1793\u17BB\u1784\u179A\u1799\u17C8\u1796\u17C1\u179B "+result;
}else{
return result+"\u1798\u17BB\u1793";
}
}
return result;
};

// lib/locale/km/_lib/formatLong.js
var dateFormats55={
full:"EEEE do MMMM y",
long:"do MMMM y",
medium:"d MMM y",
short:"dd/MM/yyyy"
};
var timeFormats55={
full:"h:mm:ss a",
long:"h:mm:ss a",
medium:"h:mm:ss a",
short:"h:mm a"
};
var dateTimeFormats55={
full:"{{date}} '\u1798\u17C9\u17C4\u1784' {{time}}",
long:"{{date}} '\u1798\u17C9\u17C4\u1784' {{time}}",
medium:"{{date}}, {{time}}",
short:"{{date}}, {{time}}"
};
var formatLong111={
date:buildFormatLongFn({
formats:dateFormats55,
defaultWidth:"full"
}),
time:buildFormatLongFn({
formats:timeFormats55,
defaultWidth:"full"
}),
dateTime:buildFormatLongFn({
formats:dateTimeFormats55,
defaultWidth:"full"
})
};

// lib/locale/km/_lib/formatRelative.js
var formatRelativeLocale47={
lastWeek:"'\u1790\u17D2\u1784\u17C3'eeee'\u179F\u200B\u1794\u17D2\u178F\u17B6\u200B\u17A0\u17CD\u200B\u1798\u17BB\u1793\u1798\u17C9\u17C4\u1784' p",
yesterday:"'\u1798\u17D2\u179F\u17B7\u179B\u1798\u17B7\u1789\u1793\u17C5\u1798\u17C9\u17C4\u1784' p",
today:"'\u1790\u17D2\u1784\u17C3\u1793\u17C1\u17C7\u1798\u17C9\u17C4\u1784' p",
tomorrow:"'\u1790\u17D2\u1784\u17C3\u179F\u17D2\u17A2\u17C2\u1780\u1798\u17C9\u17C4\u1784' p",
nextWeek:"'\u1790\u17D2\u1784\u17C3'eeee'\u179F\u200B\u1794\u17D2\u178F\u17B6\u200B\u17A0\u17CD\u200B\u1780\u17D2\u179A\u17C4\u1799\u1798\u17C9\u17C4\u1784' p",
other:"P"
};
var formatRelative103=function formatRelative103(token,_date,_baseDate,_options){return formatRelativeLocale47[token];};

// lib/locale/km/_lib/localize.js
var eraValues47={
narrow:["\u1798.\u1782\u179F","\u1782\u179F"],
abbreviated:["\u1798\u17BB\u1793\u1782.\u179F","\u1782.\u179F"],
wide:["\u1798\u17BB\u1793\u1782\u17D2\u179A\u17B7\u179F\u17D2\u178F\u179F\u1780\u179A\u17B6\u1787","\u1793\u17C3\u1782\u17D2\u179A\u17B7\u179F\u17D2\u178F\u179F\u1780\u179A\u17B6\u1787"]
};
var quarterValues47={
narrow:["1","2","3","4"],
abbreviated:["Q1","Q2","Q3","Q4"],
wide:["\u178F\u17D2\u179A\u17B8\u1798\u17B6\u179F\u1791\u17B8 1","\u178F\u17D2\u179A\u17B8\u1798\u17B6\u179F\u1791\u17B8 2","\u178F\u17D2\u179A\u17B8\u1798\u17B6\u179F\u1791\u17B8 3","\u178F\u17D2\u179A\u17B8\u1798\u17B6\u179F\u1791\u17B8 4"]
};
var monthValues47={
narrow:[
"\u1798.\u1780",
"\u1780.\u1798",
"\u1798\u17B7",
"\u1798.\u179F",
"\u17A7.\u179F",
"\u1798.\u1790",
"\u1780.\u178A",
"\u179F\u17B8",
"\u1780\u1789",
"\u178F\u17BB",
"\u179C\u17B7",
"\u1792"],

abbreviated:[
"\u1798\u1780\u179A\u17B6",
"\u1780\u17BB\u1798\u17D2\u1797\u17C8",
"\u1798\u17B8\u1793\u17B6",
"\u1798\u17C1\u179F\u17B6",
"\u17A7\u179F\u1797\u17B6",
"\u1798\u17B7\u1790\u17BB\u1793\u17B6",
"\u1780\u1780\u17D2\u1780\u178A\u17B6",
"\u179F\u17B8\u17A0\u17B6",
"\u1780\u1789\u17D2\u1789\u17B6",
"\u178F\u17BB\u179B\u17B6",
"\u179C\u17B7\u1785\u17D2\u1786\u17B7\u1780\u17B6",
"\u1792\u17D2\u1793\u17BC"],

wide:[
"\u1798\u1780\u179A\u17B6",
"\u1780\u17BB\u1798\u17D2\u1797\u17C8",
"\u1798\u17B8\u1793\u17B6",
"\u1798\u17C1\u179F\u17B6",
"\u17A7\u179F\u1797\u17B6",
"\u1798\u17B7\u1790\u17BB\u1793\u17B6",
"\u1780\u1780\u17D2\u1780\u178A\u17B6",
"\u179F\u17B8\u17A0\u17B6",
"\u1780\u1789\u17D2\u1789\u17B6",
"\u178F\u17BB\u179B\u17B6",
"\u179C\u17B7\u1785\u17D2\u1786\u17B7\u1780\u17B6",
"\u1792\u17D2\u1793\u17BC"]

};
var dayValues47={
narrow:["\u17A2\u17B6","\u1785","\u17A2","\u1796","\u1796\u17D2\u179A","\u179F\u17BB","\u179F"],
short:["\u17A2\u17B6","\u1785","\u17A2","\u1796","\u1796\u17D2\u179A","\u179F\u17BB","\u179F"],
abbreviated:["\u17A2\u17B6","\u1785","\u17A2","\u1796","\u1796\u17D2\u179A","\u179F\u17BB","\u179F"],
wide:["\u17A2\u17B6\u1791\u17B7\u178F\u17D2\u1799","\u1785\u1793\u17D2\u1791","\u17A2\u1784\u17D2\u1782\u17B6\u179A","\u1796\u17BB\u1792","\u1796\u17D2\u179A\u17A0\u179F\u17D2\u1794\u178F\u17B7\u17CD","\u179F\u17BB\u1780\u17D2\u179A","\u179F\u17C5\u179A\u17CD"]
};
var dayPeriodValues47={
narrow:{
am:"\u1796\u17D2\u179A\u17B9\u1780",
pm:"\u179B\u17D2\u1784\u17B6\u1785",
midnight:"\u200B\u1796\u17C1\u179B\u1780\u178E\u17D2\u178A\u17B6\u179B\u17A2\u1792\u17D2\u179A\u17B6\u178F\u17D2\u179A",
noon:"\u1796\u17C1\u179B\u1790\u17D2\u1784\u17C3\u178F\u17D2\u179A\u1784\u17CB",
morning:"\u1796\u17C1\u179B\u1796\u17D2\u179A\u17B9\u1780",
afternoon:"\u1796\u17C1\u179B\u179A\u179F\u17C0\u179B",
evening:"\u1796\u17C1\u179B\u179B\u17D2\u1784\u17B6\u1785",
night:"\u1796\u17C1\u179B\u1799\u1794\u17CB"
},
abbreviated:{
am:"\u1796\u17D2\u179A\u17B9\u1780",
pm:"\u179B\u17D2\u1784\u17B6\u1785",
midnight:"\u200B\u1796\u17C1\u179B\u1780\u178E\u17D2\u178A\u17B6\u179B\u17A2\u1792\u17D2\u179A\u17B6\u178F\u17D2\u179A",
noon:"\u1796\u17C1\u179B\u1790\u17D2\u1784\u17C3\u178F\u17D2\u179A\u1784\u17CB",
morning:"\u1796\u17C1\u179B\u1796\u17D2\u179A\u17B9\u1780",
afternoon:"\u1796\u17C1\u179B\u179A\u179F\u17C0\u179B",
evening:"\u1796\u17C1\u179B\u179B\u17D2\u1784\u17B6\u1785",
night:"\u1796\u17C1\u179B\u1799\u1794\u17CB"
},
wide:{
am:"\u1796\u17D2\u179A\u17B9\u1780",
pm:"\u179B\u17D2\u1784\u17B6\u1785",
midnight:"\u200B\u1796\u17C1\u179B\u1780\u178E\u17D2\u178A\u17B6\u179B\u17A2\u1792\u17D2\u179A\u17B6\u178F\u17D2\u179A",
noon:"\u1796\u17C1\u179B\u1790\u17D2\u1784\u17C3\u178F\u17D2\u179A\u1784\u17CB",
morning:"\u1796\u17C1\u179B\u1796\u17D2\u179A\u17B9\u1780",
afternoon:"\u1796\u17C1\u179B\u179A\u179F\u17C0\u179B",
evening:"\u1796\u17C1\u179B\u179B\u17D2\u1784\u17B6\u1785",
night:"\u1796\u17C1\u179B\u1799\u1794\u17CB"
}
};
var formattingDayPeriodValues39={
narrow:{
am:"\u1796\u17D2\u179A\u17B9\u1780",
pm:"\u179B\u17D2\u1784\u17B6\u1785",
midnight:"\u200B\u1796\u17C1\u179B\u1780\u178E\u17D2\u178A\u17B6\u179B\u17A2\u1792\u17D2\u179A\u17B6\u178F\u17D2\u179A",
noon:"\u1796\u17C1\u179B\u1790\u17D2\u1784\u17C3\u178F\u17D2\u179A\u1784\u17CB",
morning:"\u1796\u17C1\u179B\u1796\u17D2\u179A\u17B9\u1780",
afternoon:"\u1796\u17C1\u179B\u179A\u179F\u17C0\u179B",
evening:"\u1796\u17C1\u179B\u179B\u17D2\u1784\u17B6\u1785",
night:"\u1796\u17C1\u179B\u1799\u1794\u17CB"
},
abbreviated:{
am:"\u1796\u17D2\u179A\u17B9\u1780",
pm:"\u179B\u17D2\u1784\u17B6\u1785",
midnight:"\u200B\u1796\u17C1\u179B\u1780\u178E\u17D2\u178A\u17B6\u179B\u17A2\u1792\u17D2\u179A\u17B6\u178F\u17D2\u179A",
noon:"\u1796\u17C1\u179B\u1790\u17D2\u1784\u17C3\u178F\u17D2\u179A\u1784\u17CB",
morning:"\u1796\u17C1\u179B\u1796\u17D2\u179A\u17B9\u1780",
afternoon:"\u1796\u17C1\u179B\u179A\u179F\u17C0\u179B",
evening:"\u1796\u17C1\u179B\u179B\u17D2\u1784\u17B6\u1785",
night:"\u1796\u17C1\u179B\u1799\u1794\u17CB"
},
wide:{
am:"\u1796\u17D2\u179A\u17B9\u1780",
pm:"\u179B\u17D2\u1784\u17B6\u1785",
midnight:"\u200B\u1796\u17C1\u179B\u1780\u178E\u17D2\u178A\u17B6\u179B\u17A2\u1792\u17D2\u179A\u17B6\u178F\u17D2\u179A",
noon:"\u1796\u17C1\u179B\u1790\u17D2\u1784\u17C3\u178F\u17D2\u179A\u1784\u17CB",
morning:"\u1796\u17C1\u179B\u1796\u17D2\u179A\u17B9\u1780",
afternoon:"\u1796\u17C1\u179B\u179A\u179F\u17C0\u179B",
evening:"\u1796\u17C1\u179B\u179B\u17D2\u1784\u17B6\u1785",
night:"\u1796\u17C1\u179B\u1799\u1794\u17CB"
}
};
var ordinalNumber47=function ordinalNumber47(dirtyNumber,_){
var number=Number(dirtyNumber);
return number.toString();
};
var localize106={
ordinalNumber:ordinalNumber47,
era:buildLocalizeFn({
values:eraValues47,
defaultWidth:"wide"
}),
quarter:buildLocalizeFn({
values:quarterValues47,
defaultWidth:"wide",
argumentCallback:function argumentCallback(quarter){return quarter-1;}
}),
month:buildLocalizeFn({
values:monthValues47,
defaultWidth:"wide"
}),
day:buildLocalizeFn({
values:dayValues47,
defaultWidth:"wide"
}),
dayPeriod:buildLocalizeFn({
values:dayPeriodValues47,
defaultWidth:"wide",
formattingValues:formattingDayPeriodValues39,
defaultFormattingWidth:"wide"
})
};

// lib/locale/km/_lib/match.js
var matchOrdinalNumberPattern46=/^(\d+)(th|st|nd|rd)?/i;
var parseOrdinalNumberPattern46=/\d+/i;
var matchEraPatterns46={
narrow:/^(ម\.)?គស/i,
abbreviated:/^(មុន)?គ\.ស/i,
wide:/^(មុន|នៃ)គ្រិស្តសករាជ/i
};
var parseEraPatterns46={
any:[/^(ម|មុន)គ\.?ស/i,/^(នៃ)?គ\.?ស/i]
};
var matchQuarterPatterns46={
narrow:/^[1234]/i,
abbreviated:/^q[1234]/i,
wide:/^(ត្រីមាស)(ទី)?\s?[1234]/i
};
var parseQuarterPatterns46={
any:[/1/i,/2/i,/3/i,/4/i]
};
var matchMonthPatterns46={
narrow:/^(ម\.ក|ក\.ម|មិ|ម\.ស|ឧ\.ស|ម\.ថ|ក\.ដ|សី|កញ|តុ|វិ|ធ)/i,
abbreviated:/^(មករា|កុម្ភៈ|មីនា|មេសា|ឧសភា|មិថុនា|កក្កដា|សីហា|កញ្ញា|តុលា|វិច្ឆិកា|ធ្នូ)/i,
wide:/^(មករា|កុម្ភៈ|មីនា|មេសា|ឧសភា|មិថុនា|កក្កដា|សីហា|កញ្ញា|តុលា|វិច្ឆិកា|ធ្នូ)/i
};
var parseMonthPatterns46={
narrow:[
/^ម\.ក/i,
/^ក\.ម/i,
/^មិ/i,
/^ម\.ស/i,
/^ឧ\.ស/i,
/^ម\.ថ/i,
/^ក\.ដ/i,
/^សី/i,
/^កញ/i,
/^តុ/i,
/^វិ/i,
/^ធ/i],

any:[
/^មក/i,
/^កុ/i,
/^មីន/i,
/^មេ/i,
/^ឧស/i,
/^មិថ/i,
/^កក/i,
/^សី/i,
/^កញ/i,
/^តុ/i,
/^វិច/i,
/^ធ/i]

};
var matchDayPatterns46={
narrow:/^(អា|ច|អ|ព|ព្រ|សុ|ស)/i,
short:/^(អា|ច|អ|ព|ព្រ|សុ|ស)/i,
abbreviated:/^(អា|ច|អ|ព|ព្រ|សុ|ស)/i,
wide:/^(អាទិត្យ|ចន្ទ|អង្គារ|ពុធ|ព្រហស្បតិ៍|សុក្រ|សៅរ៍)/i
};
var parseDayPatterns46={
narrow:[/^អា/i,/^ច/i,/^អ/i,/^ព/i,/^ព្រ/i,/^សុ/i,/^ស/i],
any:[/^អា/i,/^ច/i,/^អ/i,/^ព/i,/^ព្រ/i,/^សុ/i,/^សៅ/i]
};
var matchDayPeriodPatterns46={
narrow:/^(ព្រឹក|ល្ងាច|ពេលព្រឹក|ពេលថ្ងៃត្រង់|ពេលល្ងាច|ពេលរសៀល|ពេលយប់|ពេលកណ្ដាលអធ្រាត្រ)/i,
any:/^(ព្រឹក|ល្ងាច|ពេលព្រឹក|ពេលថ្ងៃត្រង់|ពេលល្ងាច|ពេលរសៀល|ពេលយប់|ពេលកណ្ដាលអធ្រាត្រ)/i
};
var parseDayPeriodPatterns46={
any:{
am:/^ព្រឹក/i,
pm:/^ល្ងាច/i,
midnight:/^ពេលកណ្ដាលអធ្រាត្រ/i,
noon:/^ពេលថ្ងៃត្រង់/i,
morning:/ពេលព្រឹក/i,
afternoon:/ពេលរសៀល/i,
evening:/ពេលល្ងាច/i,
night:/ពេលយប់/i
}
};
var match102={
ordinalNumber:buildMatchPatternFn({
matchPattern:matchOrdinalNumberPattern46,
parsePattern:parseOrdinalNumberPattern46,
valueCallback:function valueCallback(value){
return parseInt(value,10);
}
}),
era:buildMatchFn({
matchPatterns:matchEraPatterns46,
defaultMatchWidth:"wide",
parsePatterns:parseEraPatterns46,
defaultParseWidth:"any"
}),
quarter:buildMatchFn({
matchPatterns:matchQuarterPatterns46,
defaultMatchWidth:"wide",
parsePatterns:parseQuarterPatterns46,
defaultParseWidth:"any",
valueCallback:function valueCallback(index){return index+1;}
}),
month:buildMatchFn({
matchPatterns:matchMonthPatterns46,
defaultMatchWidth:"wide",
parsePatterns:parseMonthPatterns46,
defaultParseWidth:"any"
}),
day:buildMatchFn({
matchPatterns:matchDayPatterns46,
defaultMatchWidth:"wide",
parsePatterns:parseDayPatterns46,
defaultParseWidth:"any"
}),
dayPeriod:buildMatchFn({
matchPatterns:matchDayPeriodPatterns46,
defaultMatchWidth:"any",
parsePatterns:parseDayPeriodPatterns46,
defaultParseWidth:"any"
})
};

// lib/locale/km.js
var _km={
code:"km",
formatDistance:formatDistance103,
formatLong:formatLong111,
formatRelative:formatRelative103,
localize:localize106,
match:match102,
options:{
weekStartsOn:0,
firstWeekContainsDate:1
}
};
// lib/locale/kn/_lib/formatDistance.js
function getResultByTense(parentToken,options){
if(options!==null&&options!==void 0&&options.addSuffix){
if(options.comparison&&options.comparison>0){
return parentToken.future;
}else{
return parentToken.past;
}
}
return parentToken.default;
}
var formatDistanceLocale47={
lessThanXSeconds:{
one:{
default:"1 \u0CB8\u0CC6\u0C95\u0CC6\u0C82\u0CA1\u0CCD\u200C\u0C97\u0CBF\u0C82\u0CA4 \u0C95\u0CA1\u0CBF\u0CAE\u0CC6",
future:"1 \u0CB8\u0CC6\u0C95\u0CC6\u0C82\u0CA1\u0CCD\u200C\u0C97\u0CBF\u0C82\u0CA4 \u0C95\u0CA1\u0CBF\u0CAE\u0CC6",
past:"1 \u0CB8\u0CC6\u0C95\u0CC6\u0C82\u0CA1\u0CCD\u200C\u0C97\u0CBF\u0C82\u0CA4 \u0C95\u0CA1\u0CBF\u0CAE\u0CC6"
},
other:{
default:"{{count}} \u0CB8\u0CC6\u0C95\u0CC6\u0C82\u0CA1\u0CCD\u200C\u0C97\u0CBF\u0C82\u0CA4 \u0C95\u0CA1\u0CBF\u0CAE\u0CC6",
future:"{{count}} \u0CB8\u0CC6\u0C95\u0CC6\u0C82\u0CA1\u0CCD\u200C\u0C97\u0CBF\u0C82\u0CA4 \u0C95\u0CA1\u0CBF\u0CAE\u0CC6",
past:"{{count}} \u0CB8\u0CC6\u0C95\u0CC6\u0C82\u0CA1\u0CCD\u200C\u0C97\u0CBF\u0C82\u0CA4 \u0C95\u0CA1\u0CBF\u0CAE\u0CC6"
}
},
xSeconds:{
one:{
default:"1 \u0CB8\u0CC6\u0C95\u0CC6\u0C82\u0CA1\u0CCD",
future:"1 \u0CB8\u0CC6\u0C95\u0CC6\u0C82\u0CA1\u0CCD\u200C\u0CA8\u0CB2\u0CCD\u0CB2\u0CBF",
past:"1 \u0CB8\u0CC6\u0C95\u0CC6\u0C82\u0CA1\u0CCD \u0CB9\u0CBF\u0C82\u0CA6\u0CC6"
},
other:{
default:"{{count}} \u0CB8\u0CC6\u0C95\u0CC6\u0C82\u0CA1\u0CC1\u0C97\u0CB3\u0CC1",
future:"{{count}} \u0CB8\u0CC6\u0C95\u0CC6\u0C82\u0CA1\u0CCD\u200C\u0C97\u0CB3\u0CB2\u0CCD\u0CB2\u0CBF",
past:"{{count}} \u0CB8\u0CC6\u0C95\u0CC6\u0C82\u0CA1\u0CCD \u0CB9\u0CBF\u0C82\u0CA6\u0CC6"
}
},
halfAMinute:{
other:{
default:"\u0C85\u0CB0\u0CCD\u0CA7 \u0CA8\u0CBF\u0CAE\u0CBF\u0CB7",
future:"\u0C85\u0CB0\u0CCD\u0CA7 \u0CA8\u0CBF\u0CAE\u0CBF\u0CB7\u0CA6\u0CB2\u0CCD\u0CB2\u0CBF",
past:"\u0C85\u0CB0\u0CCD\u0CA7 \u0CA8\u0CBF\u0CAE\u0CBF\u0CB7\u0CA6 \u0CB9\u0CBF\u0C82\u0CA6\u0CC6"
}
},
lessThanXMinutes:{
one:{
default:"1 \u0CA8\u0CBF\u0CAE\u0CBF\u0CB7\u0C95\u0CCD\u0C95\u0CBF\u0C82\u0CA4 \u0C95\u0CA1\u0CBF\u0CAE\u0CC6",
future:"1 \u0CA8\u0CBF\u0CAE\u0CBF\u0CB7\u0C95\u0CCD\u0C95\u0CBF\u0C82\u0CA4 \u0C95\u0CA1\u0CBF\u0CAE\u0CC6",
past:"1 \u0CA8\u0CBF\u0CAE\u0CBF\u0CB7\u0C95\u0CCD\u0C95\u0CBF\u0C82\u0CA4 \u0C95\u0CA1\u0CBF\u0CAE\u0CC6"
},
other:{
default:"{{count}} \u0CA8\u0CBF\u0CAE\u0CBF\u0CB7\u0C95\u0CCD\u0C95\u0CBF\u0C82\u0CA4 \u0C95\u0CA1\u0CBF\u0CAE\u0CC6",
future:"{{count}} \u0CA8\u0CBF\u0CAE\u0CBF\u0CB7\u0C95\u0CCD\u0C95\u0CBF\u0C82\u0CA4 \u0C95\u0CA1\u0CBF\u0CAE\u0CC6",
past:"{{count}} \u0CA8\u0CBF\u0CAE\u0CBF\u0CB7\u0C95\u0CCD\u0C95\u0CBF\u0C82\u0CA4 \u0C95\u0CA1\u0CBF\u0CAE\u0CC6"
}
},
xMinutes:{
one:{
default:"1 \u0CA8\u0CBF\u0CAE\u0CBF\u0CB7",
future:"1 \u0CA8\u0CBF\u0CAE\u0CBF\u0CB7\u0CA6\u0CB2\u0CCD\u0CB2\u0CBF",
past:"1 \u0CA8\u0CBF\u0CAE\u0CBF\u0CB7\u0CA6 \u0CB9\u0CBF\u0C82\u0CA6\u0CC6"
},
other:{
default:"{{count}} \u0CA8\u0CBF\u0CAE\u0CBF\u0CB7\u0C97\u0CB3\u0CC1",
future:"{{count}} \u0CA8\u0CBF\u0CAE\u0CBF\u0CB7\u0C97\u0CB3\u0CB2\u0CCD\u0CB2\u0CBF",
past:"{{count}} \u0CA8\u0CBF\u0CAE\u0CBF\u0CB7\u0C97\u0CB3 \u0CB9\u0CBF\u0C82\u0CA6\u0CC6"
}
},
aboutXHours:{
one:{
default:"\u0CB8\u0CC1\u0CAE\u0CBE\u0CB0\u0CC1 1 \u0C97\u0C82\u0C9F\u0CC6",
future:"\u0CB8\u0CC1\u0CAE\u0CBE\u0CB0\u0CC1 1 \u0C97\u0C82\u0C9F\u0CC6\u0CAF\u0CB2\u0CCD\u0CB2\u0CBF",
past:"\u0CB8\u0CC1\u0CAE\u0CBE\u0CB0\u0CC1 1 \u0C97\u0C82\u0C9F\u0CC6 \u0CB9\u0CBF\u0C82\u0CA6\u0CC6"
},
other:{
default:"\u0CB8\u0CC1\u0CAE\u0CBE\u0CB0\u0CC1 {{count}} \u0C97\u0C82\u0C9F\u0CC6\u0C97\u0CB3\u0CC1",
future:"\u0CB8\u0CC1\u0CAE\u0CBE\u0CB0\u0CC1 {{count}} \u0C97\u0C82\u0C9F\u0CC6\u0C97\u0CB3\u0CB2\u0CCD\u0CB2\u0CBF",
past:"\u0CB8\u0CC1\u0CAE\u0CBE\u0CB0\u0CC1 {{count}} \u0C97\u0C82\u0C9F\u0CC6\u0C97\u0CB3 \u0CB9\u0CBF\u0C82\u0CA6\u0CC6"
}
},
xHours:{
one:{
default:"1 \u0C97\u0C82\u0C9F\u0CC6",
future:"1 \u0C97\u0C82\u0C9F\u0CC6\u0CAF\u0CB2\u0CCD\u0CB2\u0CBF",
past:"1 \u0C97\u0C82\u0C9F\u0CC6 \u0CB9\u0CBF\u0C82\u0CA6\u0CC6"
},
other:{
default:"{{count}} \u0C97\u0C82\u0C9F\u0CC6\u0C97\u0CB3\u0CC1",
future:"{{count}} \u0C97\u0C82\u0C9F\u0CC6\u0C97\u0CB3\u0CB2\u0CCD\u0CB2\u0CBF",
past:"{{count}} \u0C97\u0C82\u0C9F\u0CC6\u0C97\u0CB3 \u0CB9\u0CBF\u0C82\u0CA6\u0CC6"
}
},
xDays:{
one:{
default:"1 \u0CA6\u0CBF\u0CA8",
future:"1 \u0CA6\u0CBF\u0CA8\u0CA6\u0CB2\u0CCD\u0CB2\u0CBF",
past:"1 \u0CA6\u0CBF\u0CA8\u0CA6 \u0CB9\u0CBF\u0C82\u0CA6\u0CC6"
},
other:{
default:"{{count}} \u0CA6\u0CBF\u0CA8\u0C97\u0CB3\u0CC1",
future:"{{count}} \u0CA6\u0CBF\u0CA8\u0C97\u0CB3\u0CB2\u0CCD\u0CB2\u0CBF",
past:"{{count}} \u0CA6\u0CBF\u0CA8\u0C97\u0CB3 \u0CB9\u0CBF\u0C82\u0CA6\u0CC6"
}
},
aboutXMonths:{
one:{
default:"\u0CB8\u0CC1\u0CAE\u0CBE\u0CB0\u0CC1 1 \u0CA4\u0CBF\u0C82\u0C97\u0CB3\u0CC1",
future:"\u0CB8\u0CC1\u0CAE\u0CBE\u0CB0\u0CC1 1 \u0CA4\u0CBF\u0C82\u0C97\u0CB3\u0CB2\u0CCD\u0CB2\u0CBF",
past:"\u0CB8\u0CC1\u0CAE\u0CBE\u0CB0\u0CC1 1 \u0CA4\u0CBF\u0C82\u0C97\u0CB3 \u0CB9\u0CBF\u0C82\u0CA6\u0CC6"
},
other:{
default:"\u0CB8\u0CC1\u0CAE\u0CBE\u0CB0\u0CC1 {{count}} \u0CA4\u0CBF\u0C82\u0C97\u0CB3\u0CC1",
future:"\u0CB8\u0CC1\u0CAE\u0CBE\u0CB0\u0CC1 {{count}} \u0CA4\u0CBF\u0C82\u0C97\u0CB3\u0CC1\u0C97\u0CB3\u0CB2\u0CCD\u0CB2\u0CBF",
past:"\u0CB8\u0CC1\u0CAE\u0CBE\u0CB0\u0CC1 {{count}} \u0CA4\u0CBF\u0C82\u0C97\u0CB3\u0CC1\u0C97\u0CB3 \u0CB9\u0CBF\u0C82\u0CA6\u0CC6"
}
},
xMonths:{
one:{
default:"1 \u0CA4\u0CBF\u0C82\u0C97\u0CB3\u0CC1",
future:"1 \u0CA4\u0CBF\u0C82\u0C97\u0CB3\u0CB2\u0CCD\u0CB2\u0CBF",
past:"1 \u0CA4\u0CBF\u0C82\u0C97\u0CB3 \u0CB9\u0CBF\u0C82\u0CA6\u0CC6"
},
other:{
default:"{{count}} \u0CA4\u0CBF\u0C82\u0C97\u0CB3\u0CC1",
future:"{{count}} \u0CA4\u0CBF\u0C82\u0C97\u0CB3\u0CC1\u0C97\u0CB3\u0CB2\u0CCD\u0CB2\u0CBF",
past:"{{count}} \u0CA4\u0CBF\u0C82\u0C97\u0CB3\u0CC1\u0C97\u0CB3 \u0CB9\u0CBF\u0C82\u0CA6\u0CC6"
}
},
aboutXYears:{
one:{
default:"\u0CB8\u0CC1\u0CAE\u0CBE\u0CB0\u0CC1 1 \u0CB5\u0CB0\u0CCD\u0CB7",
future:"\u0CB8\u0CC1\u0CAE\u0CBE\u0CB0\u0CC1 1 \u0CB5\u0CB0\u0CCD\u0CB7\u0CA6\u0CB2\u0CCD\u0CB2\u0CBF",
past:"\u0CB8\u0CC1\u0CAE\u0CBE\u0CB0\u0CC1 1 \u0CB5\u0CB0\u0CCD\u0CB7\u0CA6 \u0CB9\u0CBF\u0C82\u0CA6\u0CC6"
},
other:{
default:"\u0CB8\u0CC1\u0CAE\u0CBE\u0CB0\u0CC1 {{count}} \u0CB5\u0CB0\u0CCD\u0CB7\u0C97\u0CB3\u0CC1",
future:"\u0CB8\u0CC1\u0CAE\u0CBE\u0CB0\u0CC1 {{count}} \u0CB5\u0CB0\u0CCD\u0CB7\u0C97\u0CB3\u0CB2\u0CCD\u0CB2\u0CBF",
past:"\u0CB8\u0CC1\u0CAE\u0CBE\u0CB0\u0CC1 {{count}} \u0CB5\u0CB0\u0CCD\u0CB7\u0C97\u0CB3 \u0CB9\u0CBF\u0C82\u0CA6\u0CC6"
}
},
xYears:{
one:{
default:"1 \u0CB5\u0CB0\u0CCD\u0CB7",
future:"1 \u0CB5\u0CB0\u0CCD\u0CB7\u0CA6\u0CB2\u0CCD\u0CB2\u0CBF",
past:"1 \u0CB5\u0CB0\u0CCD\u0CB7\u0CA6 \u0CB9\u0CBF\u0C82\u0CA6\u0CC6"
},
other:{
default:"{{count}} \u0CB5\u0CB0\u0CCD\u0CB7\u0C97\u0CB3\u0CC1",
future:"{{count}} \u0CB5\u0CB0\u0CCD\u0CB7\u0C97\u0CB3\u0CB2\u0CCD\u0CB2\u0CBF",
past:"{{count}} \u0CB5\u0CB0\u0CCD\u0CB7\u0C97\u0CB3 \u0CB9\u0CBF\u0C82\u0CA6\u0CC6"
}
},
overXYears:{
one:{
default:"1 \u0CB5\u0CB0\u0CCD\u0CB7\u0CA6 \u0CAE\u0CC7\u0CB2\u0CC6",
future:"1 \u0CB5\u0CB0\u0CCD\u0CB7\u0CA6 \u0CAE\u0CC7\u0CB2\u0CC6",
past:"1 \u0CB5\u0CB0\u0CCD\u0CB7\u0CA6 \u0CAE\u0CC7\u0CB2\u0CC6"
},
other:{
default:"{{count}} \u0CB5\u0CB0\u0CCD\u0CB7\u0C97\u0CB3 \u0CAE\u0CC7\u0CB2\u0CC6",
future:"{{count}} \u0CB5\u0CB0\u0CCD\u0CB7\u0C97\u0CB3 \u0CAE\u0CC7\u0CB2\u0CC6",
past:"{{count}} \u0CB5\u0CB0\u0CCD\u0CB7\u0C97\u0CB3 \u0CAE\u0CC7\u0CB2\u0CC6"
}
},
almostXYears:{
one:{
default:"\u0CAC\u0CB9\u0CC1\u0CA4\u0CC7\u0C95 1 \u0CB5\u0CB0\u0CCD\u0CB7\u0CA6\u0CB2\u0CCD\u0CB2\u0CBF",
future:"\u0CAC\u0CB9\u0CC1\u0CA4\u0CC7\u0C95 1 \u0CB5\u0CB0\u0CCD\u0CB7\u0CA6\u0CB2\u0CCD\u0CB2\u0CBF",
past:"\u0CAC\u0CB9\u0CC1\u0CA4\u0CC7\u0C95 1 \u0CB5\u0CB0\u0CCD\u0CB7\u0CA6\u0CB2\u0CCD\u0CB2\u0CBF"
},
other:{
default:"\u0CAC\u0CB9\u0CC1\u0CA4\u0CC7\u0C95 {{count}} \u0CB5\u0CB0\u0CCD\u0CB7\u0C97\u0CB3\u0CB2\u0CCD\u0CB2\u0CBF",
future:"\u0CAC\u0CB9\u0CC1\u0CA4\u0CC7\u0C95 {{count}} \u0CB5\u0CB0\u0CCD\u0CB7\u0C97\u0CB3\u0CB2\u0CCD\u0CB2\u0CBF",
past:"\u0CAC\u0CB9\u0CC1\u0CA4\u0CC7\u0C95 {{count}} \u0CB5\u0CB0\u0CCD\u0CB7\u0C97\u0CB3\u0CB2\u0CCD\u0CB2\u0CBF"
}
}
};
var formatDistance105=function formatDistance105(token,count,options){
var result;
var tokenValue=formatDistanceLocale47[token];
if(tokenValue.one&&count===1){
result=getResultByTense(tokenValue.one,options);
}else{
result=getResultByTense(tokenValue.other,options);
}
return result.replace("{{count}}",String(count));
};

// lib/locale/kn/_lib/formatLong.js
var dateFormats56={
full:"EEEE, MMMM d, y",
long:"MMMM d, y",
medium:"MMM d, y",
short:"d/M/yy"
};
var timeFormats56={
full:"hh:mm:ss a zzzz",
long:"hh:mm:ss a z",
medium:"hh:mm:ss a",
short:"hh:mm a"
};
var dateTimeFormats56={
full:"{{date}} {{time}}",
long:"{{date}} {{time}}",
medium:"{{date}} {{time}}",
short:"{{date}} {{time}}"
};
var formatLong113={
date:buildFormatLongFn({
formats:dateFormats56,
defaultWidth:"full"
}),
time:buildFormatLongFn({
formats:timeFormats56,
defaultWidth:"full"
}),
dateTime:buildFormatLongFn({
formats:dateTimeFormats56,
defaultWidth:"full"
})
};

// lib/locale/kn/_lib/formatRelative.js
var formatRelativeLocale48={
lastWeek:"'\u0C95\u0CB3\u0CC6\u0CA6' eeee p '\u0C95\u0CCD\u0C95\u0CC6'",
yesterday:"'\u0CA8\u0CBF\u0CA8\u0CCD\u0CA8\u0CC6' p '\u0C95\u0CCD\u0C95\u0CC6'",
today:"'\u0C87\u0C82\u0CA6\u0CC1' p '\u0C95\u0CCD\u0C95\u0CC6'",
tomorrow:"'\u0CA8\u0CBE\u0CB3\u0CC6' p '\u0C95\u0CCD\u0C95\u0CC6'",
nextWeek:"eeee p '\u0C95\u0CCD\u0C95\u0CC6'",
other:"P"
};
var formatRelative105=function formatRelative105(token,_date,_baseDate,_options){return formatRelativeLocale48[token];};

// lib/locale/kn/_lib/localize.js
var eraValues48={
narrow:["\u0C95\u0CCD\u0CB0\u0CBF.\u0CAA\u0CC2","\u0C95\u0CCD\u0CB0\u0CBF.\u0CB6"],
abbreviated:["\u0C95\u0CCD\u0CB0\u0CBF.\u0CAA\u0CC2","\u0C95\u0CCD\u0CB0\u0CBF.\u0CB6"],
wide:["\u0C95\u0CCD\u0CB0\u0CBF\u0CB8\u0CCD\u0CA4 \u0CAA\u0CC2\u0CB0\u0CCD\u0CB5","\u0C95\u0CCD\u0CB0\u0CBF\u0CB8\u0CCD\u0CA4 \u0CB6\u0C95"]
};
var quarterValues48={
narrow:["1","2","3","4"],
abbreviated:["\u0CA4\u0CCD\u0CB0\u0CC8 1","\u0CA4\u0CCD\u0CB0\u0CC8 2","\u0CA4\u0CCD\u0CB0\u0CC8 3","\u0CA4\u0CCD\u0CB0\u0CC8 4"],
wide:["1\u0CA8\u0CC7 \u0CA4\u0CCD\u0CB0\u0CC8\u0CAE\u0CBE\u0CB8\u0CBF\u0C95","2\u0CA8\u0CC7 \u0CA4\u0CCD\u0CB0\u0CC8\u0CAE\u0CBE\u0CB8\u0CBF\u0C95","3\u0CA8\u0CC7 \u0CA4\u0CCD\u0CB0\u0CC8\u0CAE\u0CBE\u0CB8\u0CBF\u0C95","4\u0CA8\u0CC7 \u0CA4\u0CCD\u0CB0\u0CC8\u0CAE\u0CBE\u0CB8\u0CBF\u0C95"]
};
var monthValues48={
narrow:["\u0C9C","\u0CAB\u0CC6","\u0CAE\u0CBE","\u0C8F","\u0CAE\u0CC7","\u0C9C\u0CC2","\u0C9C\u0CC1","\u0C86","\u0CB8\u0CC6","\u0C85","\u0CA8","\u0CA1\u0CBF"],
abbreviated:[
"\u0C9C\u0CA8",
"\u0CAB\u0CC6\u0CAC\u0CCD\u0CB0",
"\u0CAE\u0CBE\u0CB0\u0CCD\u0C9A\u0CCD",
"\u0C8F\u0CAA\u0CCD\u0CB0\u0CBF",
"\u0CAE\u0CC7",
"\u0C9C\u0CC2\u0CA8\u0CCD",
"\u0C9C\u0CC1\u0CB2\u0CC8",
"\u0C86\u0C97",
"\u0CB8\u0CC6\u0CAA\u0CCD\u0C9F\u0CC6\u0C82",
"\u0C85\u0C95\u0CCD\u0C9F\u0CCB",
"\u0CA8\u0CB5\u0CC6\u0C82",
"\u0CA1\u0CBF\u0CB8\u0CC6\u0C82"],

wide:[
"\u0C9C\u0CA8\u0CB5\u0CB0\u0CBF",
"\u0CAB\u0CC6\u0CAC\u0CCD\u0CB0\u0CB5\u0CB0\u0CBF",
"\u0CAE\u0CBE\u0CB0\u0CCD\u0C9A\u0CCD",
"\u0C8F\u0CAA\u0CCD\u0CB0\u0CBF\u0CB2\u0CCD",
"\u0CAE\u0CC7",
"\u0C9C\u0CC2\u0CA8\u0CCD",
"\u0C9C\u0CC1\u0CB2\u0CC8",
"\u0C86\u0C97\u0CB8\u0CCD\u0C9F\u0CCD",
"\u0CB8\u0CC6\u0CAA\u0CCD\u0C9F\u0CC6\u0C82\u0CAC\u0CB0\u0CCD",
"\u0C85\u0C95\u0CCD\u0C9F\u0CCB\u0CAC\u0CB0\u0CCD",
"\u0CA8\u0CB5\u0CC6\u0C82\u0CAC\u0CB0\u0CCD",
"\u0CA1\u0CBF\u0CB8\u0CC6\u0C82\u0CAC\u0CB0\u0CCD"]

};
var dayValues48={
narrow:["\u0CAD\u0CBE","\u0CB8\u0CCB","\u0CAE\u0C82","\u0CAC\u0CC1","\u0C97\u0CC1","\u0CB6\u0CC1","\u0CB6"],
short:["\u0CAD\u0CBE\u0CA8\u0CC1","\u0CB8\u0CCB\u0CAE","\u0CAE\u0C82\u0C97\u0CB3","\u0CAC\u0CC1\u0CA7","\u0C97\u0CC1\u0CB0\u0CC1","\u0CB6\u0CC1\u0C95\u0CCD\u0CB0","\u0CB6\u0CA8\u0CBF"],
abbreviated:["\u0CAD\u0CBE\u0CA8\u0CC1","\u0CB8\u0CCB\u0CAE","\u0CAE\u0C82\u0C97\u0CB3","\u0CAC\u0CC1\u0CA7","\u0C97\u0CC1\u0CB0\u0CC1","\u0CB6\u0CC1\u0C95\u0CCD\u0CB0","\u0CB6\u0CA8\u0CBF"],
wide:[
"\u0CAD\u0CBE\u0CA8\u0CC1\u0CB5\u0CBE\u0CB0",
"\u0CB8\u0CCB\u0CAE\u0CB5\u0CBE\u0CB0",
"\u0CAE\u0C82\u0C97\u0CB3\u0CB5\u0CBE\u0CB0",
"\u0CAC\u0CC1\u0CA7\u0CB5\u0CBE\u0CB0",
"\u0C97\u0CC1\u0CB0\u0CC1\u0CB5\u0CBE\u0CB0",
"\u0CB6\u0CC1\u0C95\u0CCD\u0CB0\u0CB5\u0CBE\u0CB0",
"\u0CB6\u0CA8\u0CBF\u0CB5\u0CBE\u0CB0"]

};
var dayPeriodValues48={
narrow:{
am:"\u0CAA\u0CC2\u0CB0\u0CCD\u0CB5\u0CBE\u0CB9\u0CCD\u0CA8",
pm:"\u0C85\u0CAA\u0CB0\u0CBE\u0CB9\u0CCD\u0CA8",
midnight:"\u0CAE\u0CA7\u0CCD\u0CAF\u0CB0\u0CBE\u0CA4\u0CCD\u0CB0\u0CBF",
noon:"\u0CAE\u0CA7\u0CCD\u0CAF\u0CBE\u0CB9\u0CCD\u0CA8",
morning:"\u0CAC\u0CC6\u0CB3\u0C97\u0CCD\u0C97\u0CC6",
afternoon:"\u0CAE\u0CA7\u0CCD\u0CAF\u0CBE\u0CB9\u0CCD\u0CA8",
evening:"\u0CB8\u0C82\u0C9C\u0CC6",
night:"\u0CB0\u0CBE\u0CA4\u0CCD\u0CB0\u0CBF"
},
abbreviated:{
am:"\u0CAA\u0CC2\u0CB0\u0CCD\u0CB5\u0CBE\u0CB9\u0CCD\u0CA8",
pm:"\u0C85\u0CAA\u0CB0\u0CBE\u0CB9\u0CCD\u0CA8",
midnight:"\u0CAE\u0CA7\u0CCD\u0CAF\u0CB0\u0CBE\u0CA4\u0CCD\u0CB0\u0CBF",
noon:"\u0CAE\u0CA7\u0CCD\u0CAF\u0CBE\u0CA8\u0CCD\u0CB9",
morning:"\u0CAC\u0CC6\u0CB3\u0C97\u0CCD\u0C97\u0CC6",
afternoon:"\u0CAE\u0CA7\u0CCD\u0CAF\u0CBE\u0CA8\u0CCD\u0CB9",
evening:"\u0CB8\u0C82\u0C9C\u0CC6",
night:"\u0CB0\u0CBE\u0CA4\u0CCD\u0CB0\u0CBF"
},
wide:{
am:"\u0CAA\u0CC2\u0CB0\u0CCD\u0CB5\u0CBE\u0CB9\u0CCD\u0CA8",
pm:"\u0C85\u0CAA\u0CB0\u0CBE\u0CB9\u0CCD\u0CA8",
midnight:"\u0CAE\u0CA7\u0CCD\u0CAF\u0CB0\u0CBE\u0CA4\u0CCD\u0CB0\u0CBF",
noon:"\u0CAE\u0CA7\u0CCD\u0CAF\u0CBE\u0CA8\u0CCD\u0CB9",
morning:"\u0CAC\u0CC6\u0CB3\u0C97\u0CCD\u0C97\u0CC6",
afternoon:"\u0CAE\u0CA7\u0CCD\u0CAF\u0CBE\u0CA8\u0CCD\u0CB9",
evening:"\u0CB8\u0C82\u0C9C\u0CC6",
night:"\u0CB0\u0CBE\u0CA4\u0CCD\u0CB0\u0CBF"
}
};
var formattingDayPeriodValues40={
narrow:{
am:"\u0CAA\u0CC2",
pm:"\u0C85",
midnight:"\u0CAE\u0CA7\u0CCD\u0CAF\u0CB0\u0CBE\u0CA4\u0CCD\u0CB0\u0CBF",
noon:"\u0CAE\u0CA7\u0CCD\u0CAF\u0CBE\u0CA8\u0CCD\u0CB9",
morning:"\u0CAC\u0CC6\u0CB3\u0C97\u0CCD\u0C97\u0CC6",
afternoon:"\u0CAE\u0CA7\u0CCD\u0CAF\u0CBE\u0CA8\u0CCD\u0CB9",
evening:"\u0CB8\u0C82\u0C9C\u0CC6",
night:"\u0CB0\u0CBE\u0CA4\u0CCD\u0CB0\u0CBF"
},
abbreviated:{
am:"\u0CAA\u0CC2\u0CB0\u0CCD\u0CB5\u0CBE\u0CB9\u0CCD\u0CA8",
pm:"\u0C85\u0CAA\u0CB0\u0CBE\u0CB9\u0CCD\u0CA8",
midnight:"\u0CAE\u0CA7\u0CCD\u0CAF \u0CB0\u0CBE\u0CA4\u0CCD\u0CB0\u0CBF",
noon:"\u0CAE\u0CA7\u0CCD\u0CAF\u0CBE\u0CA8\u0CCD\u0CB9",
morning:"\u0CAC\u0CC6\u0CB3\u0C97\u0CCD\u0C97\u0CC6",
afternoon:"\u0CAE\u0CA7\u0CCD\u0CAF\u0CBE\u0CA8\u0CCD\u0CB9",
evening:"\u0CB8\u0C82\u0C9C\u0CC6",
night:"\u0CB0\u0CBE\u0CA4\u0CCD\u0CB0\u0CBF"
},
wide:{
am:"\u0CAA\u0CC2\u0CB0\u0CCD\u0CB5\u0CBE\u0CB9\u0CCD\u0CA8",
pm:"\u0C85\u0CAA\u0CB0\u0CBE\u0CB9\u0CCD\u0CA8",
midnight:"\u0CAE\u0CA7\u0CCD\u0CAF \u0CB0\u0CBE\u0CA4\u0CCD\u0CB0\u0CBF",
noon:"\u0CAE\u0CA7\u0CCD\u0CAF\u0CBE\u0CA8\u0CCD\u0CB9",
morning:"\u0CAC\u0CC6\u0CB3\u0C97\u0CCD\u0C97\u0CC6",
afternoon:"\u0CAE\u0CA7\u0CCD\u0CAF\u0CBE\u0CA8\u0CCD\u0CB9",
evening:"\u0CB8\u0C82\u0C9C\u0CC6",
night:"\u0CB0\u0CBE\u0CA4\u0CCD\u0CB0\u0CBF"
}
};
var ordinalNumber48=function ordinalNumber48(dirtyNumber,_options){
var number=Number(dirtyNumber);
return number+"\u0CA8\u0CC7";
};
var localize108={
ordinalNumber:ordinalNumber48,
era:buildLocalizeFn({
values:eraValues48,
defaultWidth:"wide"
}),
quarter:buildLocalizeFn({
values:quarterValues48,
defaultWidth:"wide",
argumentCallback:function argumentCallback(quarter){return quarter-1;}
}),
month:buildLocalizeFn({
values:monthValues48,
defaultWidth:"wide"
}),
day:buildLocalizeFn({
values:dayValues48,
defaultWidth:"wide"
}),
dayPeriod:buildLocalizeFn({
values:dayPeriodValues48,
defaultWidth:"wide",
formattingValues:formattingDayPeriodValues40,
defaultFormattingWidth:"wide"
})
};

// lib/locale/kn/_lib/match.js
var matchOrdinalNumberPattern47=/^(\d+)(ನೇ|ನೆ)?/i;
var parseOrdinalNumberPattern47=/\d+/i;
var matchEraPatterns47={
narrow:/^(ಕ್ರಿ.ಪೂ|ಕ್ರಿ.ಶ)/i,
abbreviated:/^(ಕ್ರಿ\.?\s?ಪೂ\.?|ಕ್ರಿ\.?\s?ಶ\.?|ಪ್ರ\.?\s?ಶ\.?)/i,
wide:/^(ಕ್ರಿಸ್ತ ಪೂರ್ವ|ಕ್ರಿಸ್ತ ಶಕ|ಪ್ರಸಕ್ತ ಶಕ)/i
};
var parseEraPatterns47={
any:[/^ಪೂ/i,/^(ಶ|ಪ್ರ)/i]
};
var matchQuarterPatterns47={
narrow:/^[1234]/i,
abbreviated:/^ತ್ರೈ[1234]|ತ್ರೈ [1234]| [1234]ತ್ರೈ/i,
wide:/^[1234](ನೇ)? ತ್ರೈಮಾಸಿಕ/i
};
var parseQuarterPatterns47={
any:[/1/i,/2/i,/3/i,/4/i]
};
var matchMonthPatterns47={
narrow:/^(ಜೂ|ಜು|ಜ|ಫೆ|ಮಾ|ಏ|ಮೇ|ಆ|ಸೆ|ಅ|ನ|ಡಿ)/i,
abbreviated:/^(ಜನ|ಫೆಬ್ರ|ಮಾರ್ಚ್|ಏಪ್ರಿ|ಮೇ|ಜೂನ್|ಜುಲೈ|ಆಗ|ಸೆಪ್ಟೆಂ|ಅಕ್ಟೋ|ನವೆಂ|ಡಿಸೆಂ)/i,
wide:/^(ಜನವರಿ|ಫೆಬ್ರವರಿ|ಮಾರ್ಚ್|ಏಪ್ರಿಲ್|ಮೇ|ಜೂನ್|ಜುಲೈ|ಆಗಸ್ಟ್|ಸೆಪ್ಟೆಂಬರ್|ಅಕ್ಟೋಬರ್|ನವೆಂಬರ್|ಡಿಸೆಂಬರ್)/i
};
var parseMonthPatterns47={
narrow:[
/^ಜ$/i,
/^ಫೆ/i,
/^ಮಾ/i,
/^ಏ/i,
/^ಮೇ/i,
/^ಜೂ/i,
/^ಜು$/i,
/^ಆ/i,
/^ಸೆ/i,
/^ಅ/i,
/^ನ/i,
/^ಡಿ/i],

any:[
/^ಜನ/i,
/^ಫೆ/i,
/^ಮಾ/i,
/^ಏ/i,
/^ಮೇ/i,
/^ಜೂನ್/i,
/^ಜುಲೈ/i,
/^ಆ/i,
/^ಸೆ/i,
/^ಅ/i,
/^ನ/i,
/^ಡಿ/i]

};
var matchDayPatterns47={
narrow:/^(ಭಾ|ಸೋ|ಮ|ಬು|ಗು|ಶು|ಶ)/i,
short:/^(ಭಾನು|ಸೋಮ|ಮಂಗಳ|ಬುಧ|ಗುರು|ಶುಕ್ರ|ಶನಿ)/i,
abbreviated:/^(ಭಾನು|ಸೋಮ|ಮಂಗಳ|ಬುಧ|ಗುರು|ಶುಕ್ರ|ಶನಿ)/i,
wide:/^(ಭಾನುವಾರ|ಸೋಮವಾರ|ಮಂಗಳವಾರ|ಬುಧವಾರ|ಗುರುವಾರ|ಶುಕ್ರವಾರ|ಶನಿವಾರ)/i
};
var parseDayPatterns47={
narrow:[/^ಭಾ/i,/^ಸೋ/i,/^ಮ/i,/^ಬು/i,/^ಗು/i,/^ಶು/i,/^ಶ/i],
any:[/^ಭಾ/i,/^ಸೋ/i,/^ಮ/i,/^ಬು/i,/^ಗು/i,/^ಶು/i,/^ಶ/i]
};
var matchDayPeriodPatterns47={
narrow:/^(ಪೂ|ಅ|ಮಧ್ಯರಾತ್ರಿ|ಮಧ್ಯಾನ್ಹ|ಬೆಳಗ್ಗೆ|ಸಂಜೆ|ರಾತ್ರಿ)/i,
any:/^(ಪೂರ್ವಾಹ್ನ|ಅಪರಾಹ್ನ|ಮಧ್ಯರಾತ್ರಿ|ಮಧ್ಯಾನ್ಹ|ಬೆಳಗ್ಗೆ|ಸಂಜೆ|ರಾತ್ರಿ)/i
};
var parseDayPeriodPatterns47={
any:{
am:/^ಪೂ/i,
pm:/^ಅ/i,
midnight:/ಮಧ್ಯರಾತ್ರಿ/i,
noon:/ಮಧ್ಯಾನ್ಹ/i,
morning:/ಬೆಳಗ್ಗೆ/i,
afternoon:/ಮಧ್ಯಾನ್ಹ/i,
evening:/ಸಂಜೆ/i,
night:/ರಾತ್ರಿ/i
}
};
var match104={
ordinalNumber:buildMatchPatternFn({
matchPattern:matchOrdinalNumberPattern47,
parsePattern:parseOrdinalNumberPattern47,
valueCallback:function valueCallback(value){return parseInt(value,10);}
}),
era:buildMatchFn({
matchPatterns:matchEraPatterns47,
defaultMatchWidth:"wide",
parsePatterns:parseEraPatterns47,
defaultParseWidth:"any"
}),
quarter:buildMatchFn({
matchPatterns:matchQuarterPatterns47,
defaultMatchWidth:"wide",
parsePatterns:parseQuarterPatterns47,
defaultParseWidth:"any",
valueCallback:function valueCallback(index){return index+1;}
}),
month:buildMatchFn({
matchPatterns:matchMonthPatterns47,
defaultMatchWidth:"wide",
parsePatterns:parseMonthPatterns47,
defaultParseWidth:"any"
}),
day:buildMatchFn({
matchPatterns:matchDayPatterns47,
defaultMatchWidth:"wide",
parsePatterns:parseDayPatterns47,
defaultParseWidth:"any"
}),
dayPeriod:buildMatchFn({
matchPatterns:matchDayPeriodPatterns47,
defaultMatchWidth:"any",
parsePatterns:parseDayPeriodPatterns47,
defaultParseWidth:"any"
})
};

// lib/locale/kn.js
var _kn={
code:"kn",
formatDistance:formatDistance105,
formatLong:formatLong113,
formatRelative:formatRelative105,
localize:localize108,
match:match104,
options:{
weekStartsOn:1,
firstWeekContainsDate:1
}
};
// lib/locale/ko/_lib/formatDistance.js
var formatDistanceLocale48={
lessThanXSeconds:{
one:"1\uCD08 \uBBF8\uB9CC",
other:"{{count}}\uCD08 \uBBF8\uB9CC"
},
xSeconds:{
one:"1\uCD08",
other:"{{count}}\uCD08"
},
halfAMinute:"30\uCD08",
lessThanXMinutes:{
one:"1\uBD84 \uBBF8\uB9CC",
other:"{{count}}\uBD84 \uBBF8\uB9CC"
},
xMinutes:{
one:"1\uBD84",
other:"{{count}}\uBD84"
},
aboutXHours:{
one:"\uC57D 1\uC2DC\uAC04",
other:"\uC57D {{count}}\uC2DC\uAC04"
},
xHours:{
one:"1\uC2DC\uAC04",
other:"{{count}}\uC2DC\uAC04"
},
xDays:{
one:"1\uC77C",
other:"{{count}}\uC77C"
},
aboutXWeeks:{
one:"\uC57D 1\uC8FC",
other:"\uC57D {{count}}\uC8FC"
},
xWeeks:{
one:"1\uC8FC",
other:"{{count}}\uC8FC"
},
aboutXMonths:{
one:"\uC57D 1\uAC1C\uC6D4",
other:"\uC57D {{count}}\uAC1C\uC6D4"
},
xMonths:{
one:"1\uAC1C\uC6D4",
other:"{{count}}\uAC1C\uC6D4"
},
aboutXYears:{
one:"\uC57D 1\uB144",
other:"\uC57D {{count}}\uB144"
},
xYears:{
one:"1\uB144",
other:"{{count}}\uB144"
},
overXYears:{
one:"1\uB144 \uC774\uC0C1",
other:"{{count}}\uB144 \uC774\uC0C1"
},
almostXYears:{
one:"\uAC70\uC758 1\uB144",
other:"\uAC70\uC758 {{count}}\uB144"
}
};
var formatDistance107=function formatDistance107(token,count,options){
var result;
var tokenValue=formatDistanceLocale48[token];
if(typeof tokenValue==="string"){
result=tokenValue;
}else if(count===1){
result=tokenValue.one;
}else{
result=tokenValue.other.replace("{{count}}",count.toString());
}
if(options!==null&&options!==void 0&&options.addSuffix){
if(options.comparison&&options.comparison>0){
return result+" \uD6C4";
}else{
return result+" \uC804";
}
}
return result;
};

// lib/locale/ko/_lib/formatLong.js
var dateFormats57={
full:"y\uB144 M\uC6D4 d\uC77C EEEE",
long:"y\uB144 M\uC6D4 d\uC77C",
medium:"y.MM.dd",
short:"y.MM.dd"
};
var timeFormats57={
full:"a H\uC2DC mm\uBD84 ss\uCD08 zzzz",
long:"a H:mm:ss z",
medium:"HH:mm:ss",
short:"HH:mm"
};
var dateTimeFormats57={
full:"{{date}} {{time}}",
long:"{{date}} {{time}}",
medium:"{{date}} {{time}}",
short:"{{date}} {{time}}"
};
var formatLong115={
date:buildFormatLongFn({
formats:dateFormats57,
defaultWidth:"full"
}),
time:buildFormatLongFn({
formats:timeFormats57,
defaultWidth:"full"
}),
dateTime:buildFormatLongFn({
formats:dateTimeFormats57,
defaultWidth:"full"
})
};

// lib/locale/ko/_lib/formatRelative.js
var formatRelativeLocale49={
lastWeek:"'\uC9C0\uB09C' eeee p",
yesterday:"'\uC5B4\uC81C' p",
today:"'\uC624\uB298' p",
tomorrow:"'\uB0B4\uC77C' p",
nextWeek:"'\uB2E4\uC74C' eeee p",
other:"P"
};
var formatRelative107=function formatRelative107(token,_date,_baseDate,_options){return formatRelativeLocale49[token];};

// lib/locale/ko/_lib/localize.js
var eraValues49={
narrow:["BC","AD"],
abbreviated:["BC","AD"],
wide:["\uAE30\uC6D0\uC804","\uC11C\uAE30"]
};
var quarterValues49={
narrow:["1","2","3","4"],
abbreviated:["Q1","Q2","Q3","Q4"],
wide:["1\uBD84\uAE30","2\uBD84\uAE30","3\uBD84\uAE30","4\uBD84\uAE30"]
};
var monthValues49={
narrow:["1","2","3","4","5","6","7","8","9","10","11","12"],
abbreviated:[
"1\uC6D4",
"2\uC6D4",
"3\uC6D4",
"4\uC6D4",
"5\uC6D4",
"6\uC6D4",
"7\uC6D4",
"8\uC6D4",
"9\uC6D4",
"10\uC6D4",
"11\uC6D4",
"12\uC6D4"],

wide:[
"1\uC6D4",
"2\uC6D4",
"3\uC6D4",
"4\uC6D4",
"5\uC6D4",
"6\uC6D4",
"7\uC6D4",
"8\uC6D4",
"9\uC6D4",
"10\uC6D4",
"11\uC6D4",
"12\uC6D4"]

};
var dayValues49={
narrow:["\uC77C","\uC6D4","\uD654","\uC218","\uBAA9","\uAE08","\uD1A0"],
short:["\uC77C","\uC6D4","\uD654","\uC218","\uBAA9","\uAE08","\uD1A0"],
abbreviated:["\uC77C","\uC6D4","\uD654","\uC218","\uBAA9","\uAE08","\uD1A0"],
wide:["\uC77C\uC694\uC77C","\uC6D4\uC694\uC77C","\uD654\uC694\uC77C","\uC218\uC694\uC77C","\uBAA9\uC694\uC77C","\uAE08\uC694\uC77C","\uD1A0\uC694\uC77C"]
};
var dayPeriodValues49={
narrow:{
am:"\uC624\uC804",
pm:"\uC624\uD6C4",
midnight:"\uC790\uC815",
noon:"\uC815\uC624",
morning:"\uC544\uCE68",
afternoon:"\uC624\uD6C4",
evening:"\uC800\uB141",
night:"\uBC24"
},
abbreviated:{
am:"\uC624\uC804",
pm:"\uC624\uD6C4",
midnight:"\uC790\uC815",
noon:"\uC815\uC624",
morning:"\uC544\uCE68",
afternoon:"\uC624\uD6C4",
evening:"\uC800\uB141",
night:"\uBC24"
},
wide:{
am:"\uC624\uC804",
pm:"\uC624\uD6C4",
midnight:"\uC790\uC815",
noon:"\uC815\uC624",
morning:"\uC544\uCE68",
afternoon:"\uC624\uD6C4",
evening:"\uC800\uB141",
night:"\uBC24"
}
};
var formattingDayPeriodValues41={
narrow:{
am:"\uC624\uC804",
pm:"\uC624\uD6C4",
midnight:"\uC790\uC815",
noon:"\uC815\uC624",
morning:"\uC544\uCE68",
afternoon:"\uC624\uD6C4",
evening:"\uC800\uB141",
night:"\uBC24"
},
abbreviated:{
am:"\uC624\uC804",
pm:"\uC624\uD6C4",
midnight:"\uC790\uC815",
noon:"\uC815\uC624",
morning:"\uC544\uCE68",
afternoon:"\uC624\uD6C4",
evening:"\uC800\uB141",
night:"\uBC24"
},
wide:{
am:"\uC624\uC804",
pm:"\uC624\uD6C4",
midnight:"\uC790\uC815",
noon:"\uC815\uC624",
morning:"\uC544\uCE68",
afternoon:"\uC624\uD6C4",
evening:"\uC800\uB141",
night:"\uBC24"
}
};
var ordinalNumber49=function ordinalNumber49(dirtyNumber,options){
var number=Number(dirtyNumber);
var unit=String(options===null||options===void 0?void 0:options.unit);
switch(unit){
case"minute":
case"second":
return String(number);
case"date":
return number+"\uC77C";
default:
return number+"\uBC88\uC9F8";
}
};
var localize110={
ordinalNumber:ordinalNumber49,
era:buildLocalizeFn({
values:eraValues49,
defaultWidth:"wide"
}),
quarter:buildLocalizeFn({
values:quarterValues49,
defaultWidth:"wide",
argumentCallback:function argumentCallback(quarter){return quarter-1;}
}),
month:buildLocalizeFn({
values:monthValues49,
defaultWidth:"wide"
}),
day:buildLocalizeFn({
values:dayValues49,
defaultWidth:"wide"
}),
dayPeriod:buildLocalizeFn({
values:dayPeriodValues49,
defaultWidth:"wide",
formattingValues:formattingDayPeriodValues41,
defaultFormattingWidth:"wide"
})
};

// lib/locale/ko/_lib/match.js
var matchOrdinalNumberPattern48=/^(\d+)(일|번째)?/i;
var parseOrdinalNumberPattern48=/\d+/i;
var matchEraPatterns48={
narrow:/^(b\.?\s?c\.?|b\.?\s?c\.?\s?e\.?|a\.?\s?d\.?|c\.?\s?e\.?)/i,
abbreviated:/^(b\.?\s?c\.?|b\.?\s?c\.?\s?e\.?|a\.?\s?d\.?|c\.?\s?e\.?)/i,
wide:/^(기원전|서기)/i
};
var parseEraPatterns48={
any:[/^(bc|기원전)/i,/^(ad|서기)/i]
};
var matchQuarterPatterns48={
narrow:/^[1234]/i,
abbreviated:/^q[1234]/i,
wide:/^[1234]사?분기/i
};
var parseQuarterPatterns48={
any:[/1/i,/2/i,/3/i,/4/i]
};
var matchMonthPatterns48={
narrow:/^(1[012]|[123456789])/,
abbreviated:/^(1[012]|[123456789])월/i,
wide:/^(1[012]|[123456789])월/i
};
var parseMonthPatterns48={
any:[
/^1월?$/,
/^2/,
/^3/,
/^4/,
/^5/,
/^6/,
/^7/,
/^8/,
/^9/,
/^10/,
/^11/,
/^12/]

};
var matchDayPatterns48={
narrow:/^[일월화수목금토]/,
short:/^[일월화수목금토]/,
abbreviated:/^[일월화수목금토]/,
wide:/^[일월화수목금토]요일/
};
var parseDayPatterns48={
any:[/^일/,/^월/,/^화/,/^수/,/^목/,/^금/,/^토/]
};
var matchDayPeriodPatterns48={
any:/^(am|pm|오전|오후|자정|정오|아침|저녁|밤)/i
};
var parseDayPeriodPatterns48={
any:{
am:/^(am|오전)/i,
pm:/^(pm|오후)/i,
midnight:/^자정/i,
noon:/^정오/i,
morning:/^아침/i,
afternoon:/^오후/i,
evening:/^저녁/i,
night:/^밤/i
}
};
var match106={
ordinalNumber:buildMatchPatternFn({
matchPattern:matchOrdinalNumberPattern48,
parsePattern:parseOrdinalNumberPattern48,
valueCallback:function valueCallback(value){return parseInt(value,10);}
}),
era:buildMatchFn({
matchPatterns:matchEraPatterns48,
defaultMatchWidth:"wide",
parsePatterns:parseEraPatterns48,
defaultParseWidth:"any"
}),
quarter:buildMatchFn({
matchPatterns:matchQuarterPatterns48,
defaultMatchWidth:"wide",
parsePatterns:parseQuarterPatterns48,
defaultParseWidth:"any",
valueCallback:function valueCallback(index){return index+1;}
}),
month:buildMatchFn({
matchPatterns:matchMonthPatterns48,
defaultMatchWidth:"wide",
parsePatterns:parseMonthPatterns48,
defaultParseWidth:"any"
}),
day:buildMatchFn({
matchPatterns:matchDayPatterns48,
defaultMatchWidth:"wide",
parsePatterns:parseDayPatterns48,
defaultParseWidth:"any"
}),
dayPeriod:buildMatchFn({
matchPatterns:matchDayPeriodPatterns48,
defaultMatchWidth:"any",
parsePatterns:parseDayPeriodPatterns48,
defaultParseWidth:"any"
})
};

// lib/locale/ko.js
var _ko={
code:"ko",
formatDistance:formatDistance107,
formatLong:formatLong115,
formatRelative:formatRelative107,
localize:localize110,
match:match106,
options:{
weekStartsOn:0,
firstWeekContainsDate:1
}
};
// lib/locale/lb/_lib/formatDistance.js
function isFinalNNeeded(nextWords){
var firstLetter=nextWords.charAt(0).toLowerCase();
if(VOWELS.indexOf(firstLetter)!=-1||EXCEPTION_CONSONANTS.indexOf(firstLetter)!=-1){
return true;
}
var firstWord=nextWords.split(" ")[0];
var number=parseInt(firstWord);
if(!isNaN(number)&&DIGITS_SPOKEN_N_NEEDED.indexOf(number%10)!=-1&&FIRST_TWO_DIGITS_SPOKEN_NO_N_NEEDED.indexOf(parseInt(firstWord.substring(0,2)))==-1){
return true;
}
return false;
}
var formatDistanceLocale49={
lessThanXSeconds:{
standalone:{
one:"manner w\xE9i eng Sekonn",
other:"manner w\xE9i {{count}} Sekonnen"
},
withPreposition:{
one:"manner w\xE9i enger Sekonn",
other:"manner w\xE9i {{count}} Sekonnen"
}
},
xSeconds:{
standalone:{
one:"eng Sekonn",
other:"{{count}} Sekonnen"
},
withPreposition:{
one:"enger Sekonn",
other:"{{count}} Sekonnen"
}
},
halfAMinute:{
standalone:"eng hallef Minutt",
withPreposition:"enger hallwer Minutt"
},
lessThanXMinutes:{
standalone:{
one:"manner w\xE9i eng Minutt",
other:"manner w\xE9i {{count}} Minutten"
},
withPreposition:{
one:"manner w\xE9i enger Minutt",
other:"manner w\xE9i {{count}} Minutten"
}
},
xMinutes:{
standalone:{
one:"eng Minutt",
other:"{{count}} Minutten"
},
withPreposition:{
one:"enger Minutt",
other:"{{count}} Minutten"
}
},
aboutXHours:{
standalone:{
one:"ongef\xE9ier eng Stonn",
other:"ongef\xE9ier {{count}} Stonnen"
},
withPreposition:{
one:"ongef\xE9ier enger Stonn",
other:"ongef\xE9ier {{count}} Stonnen"
}
},
xHours:{
standalone:{
one:"eng Stonn",
other:"{{count}} Stonnen"
},
withPreposition:{
one:"enger Stonn",
other:"{{count}} Stonnen"
}
},
xDays:{
standalone:{
one:"een Dag",
other:"{{count}} Deeg"
},
withPreposition:{
one:"engem Dag",
other:"{{count}} Deeg"
}
},
aboutXWeeks:{
standalone:{
one:"ongef\xE9ier eng Woch",
other:"ongef\xE9ier {{count}} Wochen"
},
withPreposition:{
one:"ongef\xE9ier enger Woche",
other:"ongef\xE9ier {{count}} Wochen"
}
},
xWeeks:{
standalone:{
one:"eng Woch",
other:"{{count}} Wochen"
},
withPreposition:{
one:"enger Woch",
other:"{{count}} Wochen"
}
},
aboutXMonths:{
standalone:{
one:"ongef\xE9ier ee Mount",
other:"ongef\xE9ier {{count}} M\xE9int"
},
withPreposition:{
one:"ongef\xE9ier engem Mount",
other:"ongef\xE9ier {{count}} M\xE9int"
}
},
xMonths:{
standalone:{
one:"ee Mount",
other:"{{count}} M\xE9int"
},
withPreposition:{
one:"engem Mount",
other:"{{count}} M\xE9int"
}
},
aboutXYears:{
standalone:{
one:"ongef\xE9ier ee Joer",
other:"ongef\xE9ier {{count}} Joer"
},
withPreposition:{
one:"ongef\xE9ier engem Joer",
other:"ongef\xE9ier {{count}} Joer"
}
},
xYears:{
standalone:{
one:"ee Joer",
other:"{{count}} Joer"
},
withPreposition:{
one:"engem Joer",
other:"{{count}} Joer"
}
},
overXYears:{
standalone:{
one:"m\xE9i w\xE9i ee Joer",
other:"m\xE9i w\xE9i {{count}} Joer"
},
withPreposition:{
one:"m\xE9i w\xE9i engem Joer",
other:"m\xE9i w\xE9i {{count}} Joer"
}
},
almostXYears:{
standalone:{
one:"bal ee Joer",
other:"bal {{count}} Joer"
},
withPreposition:{
one:"bal engem Joer",
other:"bal {{count}} Joer"
}
}
};
var EXCEPTION_CONSONANTS=["d","h","n","t","z"];
var VOWELS=["a,","e","i","o","u"];
var DIGITS_SPOKEN_N_NEEDED=[0,1,2,3,8,9];
var FIRST_TWO_DIGITS_SPOKEN_NO_N_NEEDED=[40,50,60,70];
var formatDistance109=function formatDistance109(token,count,options){
var result;
var tokenValue=formatDistanceLocale49[token];
var usageGroup=options!==null&&options!==void 0&&options.addSuffix?tokenValue.withPreposition:tokenValue.standalone;
if(typeof usageGroup==="string"){
result=usageGroup;
}else if(count===1){
result=usageGroup.one;
}else{
result=usageGroup.other.replace("{{count}}",String(count));
}
if(options!==null&&options!==void 0&&options.addSuffix){
if(options.comparison&&options.comparison>0){
return"a"+(isFinalNNeeded(result)?"n":"")+" "+result;
}else{
return"viru"+(isFinalNNeeded(result)?"n":"")+" "+result;
}
}
return result;
};

// lib/locale/lb/_lib/formatLong.js
var dateFormats58={
full:"EEEE, do MMMM y",
long:"do MMMM y",
medium:"do MMM y",
short:"dd.MM.yy"
};
var timeFormats58={
full:"HH:mm:ss zzzz",
long:"HH:mm:ss z",
medium:"HH:mm:ss",
short:"HH:mm"
};
var dateTimeFormats58={
full:"{{date}} 'um' {{time}}",
long:"{{date}} 'um' {{time}}",
medium:"{{date}} {{time}}",
short:"{{date}} {{time}}"
};
var formatLong117={
date:buildFormatLongFn({
formats:dateFormats58,
defaultWidth:"full"
}),
time:buildFormatLongFn({
formats:timeFormats58,
defaultWidth:"full"
}),
dateTime:buildFormatLongFn({
formats:dateTimeFormats58,
defaultWidth:"full"
})
};

// lib/locale/lb/_lib/formatRelative.js
var formatRelativeLocale50={
lastWeek:function lastWeek(date){
var day=date.getDay();
var result="'l\xE4schte";
if(day===2||day===4){
result+="n";
}
result+="' eeee 'um' p";
return result;
},
yesterday:"'g\xEBschter um' p",
today:"'haut um' p",
tomorrow:"'moien um' p",
nextWeek:"eeee 'um' p",
other:"P"
};
var formatRelative109=function formatRelative109(token,date,_baseDate,_options){
var format=formatRelativeLocale50[token];
if(typeof format==="function"){
return format(date);
}
return format;
};

// lib/locale/lb/_lib/localize.js
var eraValues50={
narrow:["v.Chr.","n.Chr."],
abbreviated:["v.Chr.","n.Chr."],
wide:["viru Christus","no Christus"]
};
var quarterValues50={
narrow:["1","2","3","4"],
abbreviated:["Q1","Q2","Q3","Q4"],
wide:["1. Quartal","2. Quartal","3. Quartal","4. Quartal"]
};
var monthValues50={
narrow:["J","F","M","A","M","J","J","A","S","O","N","D"],
abbreviated:[
"Jan",
"Feb",
"M\xE4e",
"Abr",
"Mee",
"Jun",
"Jul",
"Aug",
"Sep",
"Okt",
"Nov",
"Dez"],

wide:[
"Januar",
"Februar",
"M\xE4erz",
"Abr\xEBll",
"Mee",
"Juni",
"Juli",
"August",
"September",
"Oktober",
"November",
"Dezember"]

};
var dayValues50={
narrow:["S","M","D","M","D","F","S"],
short:["So","M\xE9","D\xEB","M\xEB","Do","Fr","Sa"],
abbreviated:["So.","M\xE9.","D\xEB.","M\xEB.","Do.","Fr.","Sa."],
wide:[
"Sonndeg",
"M\xE9indeg",
"D\xEBnschdeg",
"M\xEBttwoch",
"Donneschdeg",
"Freideg",
"Samschdeg"]

};
var dayPeriodValues50={
narrow:{
am:"mo.",
pm:"nom\xEB.",
midnight:"M\xEBtternuecht",
noon:"M\xEBtteg",
morning:"Moien",
afternoon:"Nom\xEBtteg",
evening:"Owend",
night:"Nuecht"
},
abbreviated:{
am:"moies",
pm:"nom\xEBttes",
midnight:"M\xEBtternuecht",
noon:"M\xEBtteg",
morning:"Moien",
afternoon:"Nom\xEBtteg",
evening:"Owend",
night:"Nuecht"
},
wide:{
am:"moies",
pm:"nom\xEBttes",
midnight:"M\xEBtternuecht",
noon:"M\xEBtteg",
morning:"Moien",
afternoon:"Nom\xEBtteg",
evening:"Owend",
night:"Nuecht"
}
};
var formattingDayPeriodValues42={
narrow:{
am:"mo.",
pm:"nom.",
midnight:"M\xEBtternuecht",
noon:"m\xEBttes",
morning:"moies",
afternoon:"nom\xEBttes",
evening:"owes",
night:"nuets"
},
abbreviated:{
am:"moies",
pm:"nom\xEBttes",
midnight:"M\xEBtternuecht",
noon:"m\xEBttes",
morning:"moies",
afternoon:"nom\xEBttes",
evening:"owes",
night:"nuets"
},
wide:{
am:"moies",
pm:"nom\xEBttes",
midnight:"M\xEBtternuecht",
noon:"m\xEBttes",
morning:"moies",
afternoon:"nom\xEBttes",
evening:"owes",
night:"nuets"
}
};
var ordinalNumber50=function ordinalNumber50(dirtyNumber,_options){
var number=Number(dirtyNumber);
return number+".";
};
var localize112={
ordinalNumber:ordinalNumber50,
era:buildLocalizeFn({
values:eraValues50,
defaultWidth:"wide"
}),
quarter:buildLocalizeFn({
values:quarterValues50,
defaultWidth:"wide",
argumentCallback:function argumentCallback(quarter){return quarter-1;}
}),
month:buildLocalizeFn({
values:monthValues50,
defaultWidth:"wide"
}),
day:buildLocalizeFn({
values:dayValues50,
defaultWidth:"wide"
}),
dayPeriod:buildLocalizeFn({
values:dayPeriodValues50,
defaultWidth:"wide",
formattingValues:formattingDayPeriodValues42,
defaultFormattingWidth:"wide"
})
};

// lib/locale/lb/_lib/match.js
var matchOrdinalNumberPattern49=/^(\d+)(\.)?/i;
var parseOrdinalNumberPattern49=/\d+/i;
var matchEraPatterns49={
narrow:/^(v\.? ?Chr\.?|n\.? ?Chr\.?)/i,
abbreviated:/^(v\.? ?Chr\.?|n\.? ?Chr\.?)/i,
wide:/^(viru Christus|virun eiser Zäitrechnung|no Christus|eiser Zäitrechnung)/i
};
var parseEraPatterns49={
any:[/^v/i,/^n/i]
};
var matchQuarterPatterns49={
narrow:/^[1234]/i,
abbreviated:/^q[1234]/i,
wide:/^[1234](\.)? Quartal/i
};
var parseQuarterPatterns49={
any:[/1/i,/2/i,/3/i,/4/i]
};
var matchMonthPatterns49={
narrow:/^[jfmasond]/i,
abbreviated:/^(jan|feb|mäe|abr|mee|jun|jul|aug|sep|okt|nov|dez)/i,
wide:/^(januar|februar|mäerz|abrëll|mee|juni|juli|august|september|oktober|november|dezember)/i
};
var parseMonthPatterns49={
narrow:[
/^j/i,
/^f/i,
/^m/i,
/^a/i,
/^m/i,
/^j/i,
/^j/i,
/^a/i,
/^s/i,
/^o/i,
/^n/i,
/^d/i],

any:[
/^ja/i,
/^f/i,
/^mä/i,
/^ab/i,
/^me/i,
/^jun/i,
/^jul/i,
/^au/i,
/^s/i,
/^o/i,
/^n/i,
/^d/i]

};
var matchDayPatterns49={
narrow:/^[smdf]/i,
short:/^(so|mé|dë|më|do|fr|sa)/i,
abbreviated:/^(son?|méi?|dën?|mët?|don?|fre?|sam?)\.?/i,
wide:/^(sonndeg|méindeg|dënschdeg|mëttwoch|donneschdeg|freideg|samschdeg)/i
};
var parseDayPatterns49={
any:[/^so/i,/^mé/i,/^dë/i,/^më/i,/^do/i,/^f/i,/^sa/i]
};
var matchDayPeriodPatterns49={
narrow:/^(mo\.?|nomë\.?|Mëtternuecht|mëttes|moies|nomëttes|owes|nuets)/i,
abbreviated:/^(moi\.?|nomët\.?|Mëtternuecht|mëttes|moies|nomëttes|owes|nuets)/i,
wide:/^(moies|nomëttes|Mëtternuecht|mëttes|moies|nomëttes|owes|nuets)/i
};
var parseDayPeriodPatterns49={
any:{
am:/^m/i,
pm:/^n/i,
midnight:/^Mëtter/i,
noon:/^mëttes/i,
morning:/moies/i,
afternoon:/nomëttes/i,
evening:/owes/i,
night:/nuets/i
}
};
var match108={
ordinalNumber:buildMatchPatternFn({
matchPattern:matchOrdinalNumberPattern49,
parsePattern:parseOrdinalNumberPattern49,
valueCallback:function valueCallback(value){return parseInt(value,10);}
}),
era:buildMatchFn({
matchPatterns:matchEraPatterns49,
defaultMatchWidth:"wide",
parsePatterns:parseEraPatterns49,
defaultParseWidth:"any"
}),
quarter:buildMatchFn({
matchPatterns:matchQuarterPatterns49,
defaultMatchWidth:"wide",
parsePatterns:parseQuarterPatterns49,
defaultParseWidth:"any",
valueCallback:function valueCallback(index){return index+1;}
}),
month:buildMatchFn({
matchPatterns:matchMonthPatterns49,
defaultMatchWidth:"wide",
parsePatterns:parseMonthPatterns49,
defaultParseWidth:"any"
}),
day:buildMatchFn({
matchPatterns:matchDayPatterns49,
defaultMatchWidth:"wide",
parsePatterns:parseDayPatterns49,
defaultParseWidth:"any"
}),
dayPeriod:buildMatchFn({
matchPatterns:matchDayPeriodPatterns49,
defaultMatchWidth:"wide",
parsePatterns:parseDayPeriodPatterns49,
defaultParseWidth:"any"
})
};

// lib/locale/lb.js
var _lb={
code:"lb",
formatDistance:formatDistance109,
formatLong:formatLong117,
formatRelative:formatRelative109,
localize:localize112,
match:match108,
options:{
weekStartsOn:1,
firstWeekContainsDate:4
}
};
// lib/locale/lt/_lib/formatDistance.js
function special(number){
return number%10===0||number>10&&number<20;
}
function forms(key){
return translations2[key].split("_");
}
var translations2={
xseconds_other:"sekund\u0117_sekund\u017Ei\u0173_sekundes",
xminutes_one:"minut\u0117_minut\u0117s_minut\u0119",
xminutes_other:"minut\u0117s_minu\u010Di\u0173_minutes",
xhours_one:"valanda_valandos_valand\u0105",
xhours_other:"valandos_valand\u0173_valandas",
xdays_one:"diena_dienos_dien\u0105",
xdays_other:"dienos_dien\u0173_dienas",
xweeks_one:"savait\u0117_savait\u0117s_savait\u0119",
xweeks_other:"savait\u0117s_savai\u010Di\u0173_savaites",
xmonths_one:"m\u0117nuo_m\u0117nesio_m\u0117nes\u012F",
xmonths_other:"m\u0117nesiai_m\u0117nesi\u0173_m\u0117nesius",
xyears_one:"metai_met\u0173_metus",
xyears_other:"metai_met\u0173_metus",
about:"apie",
over:"daugiau nei",
almost:"beveik",
lessthan:"ma\u017Eiau nei"
};
var translateSeconds=function translateSeconds(_number,addSuffix,_key,isFuture){
if(!addSuffix){
return"kelios sekund\u0117s";
}else{
return isFuture?"keli\u0173 sekund\u017Ei\u0173":"kelias sekundes";
}
};
var translateSingular=function translateSingular(_number,addSuffix,key,isFuture){
return!addSuffix?forms(key)[0]:isFuture?forms(key)[1]:forms(key)[2];
};
var translate=function translate(number,addSuffix,key,isFuture){
var result=number+" ";
if(number===1){
return result+translateSingular(number,addSuffix,key,isFuture);
}else if(!addSuffix){
return result+(special(number)?forms(key)[1]:forms(key)[0]);
}else{
if(isFuture){
return result+forms(key)[1];
}else{
return result+(special(number)?forms(key)[1]:forms(key)[2]);
}
}
};
var formatDistanceLocale50={
lessThanXSeconds:{
one:translateSeconds,
other:translate
},
xSeconds:{
one:translateSeconds,
other:translate
},
halfAMinute:"pus\u0117 minut\u0117s",
lessThanXMinutes:{
one:translateSingular,
other:translate
},
xMinutes:{
one:translateSingular,
other:translate
},
aboutXHours:{
one:translateSingular,
other:translate
},
xHours:{
one:translateSingular,
other:translate
},
xDays:{
one:translateSingular,
other:translate
},
aboutXWeeks:{
one:translateSingular,
other:translate
},
xWeeks:{
one:translateSingular,
other:translate
},
aboutXMonths:{
one:translateSingular,
other:translate
},
xMonths:{
one:translateSingular,
other:translate
},
aboutXYears:{
one:translateSingular,
other:translate
},
xYears:{
one:translateSingular,
other:translate
},
overXYears:{
one:translateSingular,
other:translate
},
almostXYears:{
one:translateSingular,
other:translate
}
};
var formatDistance111=function formatDistance111(token,count,options){
var adverb=token.match(/about|over|almost|lessthan/i);
var unit=adverb?token.replace(adverb[0],""):token;
var isFuture=(options===null||options===void 0?void 0:options.comparison)!==undefined&&options.comparison>0;
var result;
var tokenValue=formatDistanceLocale50[token];
if(typeof tokenValue==="string"){
result=tokenValue;
}else if(count===1){
result=tokenValue.one(count,(options===null||options===void 0?void 0:options.addSuffix)===true,unit.toLowerCase()+"_one",isFuture);
}else{
result=tokenValue.other(count,(options===null||options===void 0?void 0:options.addSuffix)===true,unit.toLowerCase()+"_other",isFuture);
}
if(adverb){
var key=adverb[0].toLowerCase();
result=translations2[key]+" "+result;
}
if(options!==null&&options!==void 0&&options.addSuffix){
if(options.comparison&&options.comparison>0){
return"po "+result;
}else{
return"prie\u0161 "+result;
}
}
return result;
};

// lib/locale/lt/_lib/formatLong.js
var dateFormats59={
full:"y 'm'. MMMM d 'd'., EEEE",
long:"y 'm'. MMMM d 'd'.",
medium:"y-MM-dd",
short:"y-MM-dd"
};
var timeFormats59={
full:"HH:mm:ss zzzz",
long:"HH:mm:ss z",
medium:"HH:mm:ss",
short:"HH:mm"
};
var dateTimeFormats59={
full:"{{date}} {{time}}",
long:"{{date}} {{time}}",
medium:"{{date}} {{time}}",
short:"{{date}} {{time}}"
};
var formatLong119={
date:buildFormatLongFn({
formats:dateFormats59,
defaultWidth:"full"
}),
time:buildFormatLongFn({
formats:timeFormats59,
defaultWidth:"full"
}),
dateTime:buildFormatLongFn({
formats:dateTimeFormats59,
defaultWidth:"full"
})
};

// lib/locale/lt/_lib/formatRelative.js
var formatRelativeLocale51={
lastWeek:"'Pra\u0117jus\u012F' eeee p",
yesterday:"'Vakar' p",
today:"'\u0160iandien' p",
tomorrow:"'Rytoj' p",
nextWeek:"eeee p",
other:"P"
};
var formatRelative111=function formatRelative111(token,_date,_baseDate,_options){return formatRelativeLocale51[token];};

// lib/locale/lt/_lib/localize.js
var eraValues51={
narrow:["pr. Kr.","po Kr."],
abbreviated:["pr. Kr.","po Kr."],
wide:["prie\u0161 Krist\u0173","po Kristaus"]
};
var quarterValues51={
narrow:["1","2","3","4"],
abbreviated:["I ketv.","II ketv.","III ketv.","IV ketv."],
wide:["I ketvirtis","II ketvirtis","III ketvirtis","IV ketvirtis"]
};
var formattingQuarterValues2={
narrow:["1","2","3","4"],
abbreviated:["I k.","II k.","III k.","IV k."],
wide:["I ketvirtis","II ketvirtis","III ketvirtis","IV ketvirtis"]
};
var monthValues51={
narrow:["S","V","K","B","G","B","L","R","R","S","L","G"],
abbreviated:[
"saus.",
"vas.",
"kov.",
"bal.",
"geg.",
"bir\u017E.",
"liep.",
"rugp.",
"rugs.",
"spal.",
"lapkr.",
"gruod."],

wide:[
"sausis",
"vasaris",
"kovas",
"balandis",
"gegu\u017E\u0117",
"bir\u017Eelis",
"liepa",
"rugpj\u016Btis",
"rugs\u0117jis",
"spalis",
"lapkritis",
"gruodis"]

};
var formattingMonthValues11={
narrow:["S","V","K","B","G","B","L","R","R","S","L","G"],
abbreviated:[
"saus.",
"vas.",
"kov.",
"bal.",
"geg.",
"bir\u017E.",
"liep.",
"rugp.",
"rugs.",
"spal.",
"lapkr.",
"gruod."],

wide:[
"sausio",
"vasario",
"kovo",
"baland\u017Eio",
"gegu\u017E\u0117s",
"bir\u017Eelio",
"liepos",
"rugpj\u016B\u010Dio",
"rugs\u0117jo",
"spalio",
"lapkri\u010Dio",
"gruod\u017Eio"]

};
var dayValues51={
narrow:["S","P","A","T","K","P","\u0160"],
short:["Sk","Pr","An","Tr","Kt","Pn","\u0160t"],
abbreviated:["sk","pr","an","tr","kt","pn","\u0161t"],
wide:[
"sekmadienis",
"pirmadienis",
"antradienis",
"tre\u010Diadienis",
"ketvirtadienis",
"penktadienis",
"\u0161e\u0161tadienis"]

};
var formattingDayValues2={
narrow:["S","P","A","T","K","P","\u0160"],
short:["Sk","Pr","An","Tr","Kt","Pn","\u0160t"],
abbreviated:["sk","pr","an","tr","kt","pn","\u0161t"],
wide:[
"sekmadien\u012F",
"pirmadien\u012F",
"antradien\u012F",
"tre\u010Diadien\u012F",
"ketvirtadien\u012F",
"penktadien\u012F",
"\u0161e\u0161tadien\u012F"]

};
var dayPeriodValues51={
narrow:{
am:"pr. p.",
pm:"pop.",
midnight:"vidurnaktis",
noon:"vidurdienis",
morning:"rytas",
afternoon:"diena",
evening:"vakaras",
night:"naktis"
},
abbreviated:{
am:"prie\u0161piet",
pm:"popiet",
midnight:"vidurnaktis",
noon:"vidurdienis",
morning:"rytas",
afternoon:"diena",
evening:"vakaras",
night:"naktis"
},
wide:{
am:"prie\u0161piet",
pm:"popiet",
midnight:"vidurnaktis",
noon:"vidurdienis",
morning:"rytas",
afternoon:"diena",
evening:"vakaras",
night:"naktis"
}
};
var formattingDayPeriodValues43={
narrow:{
am:"pr. p.",
pm:"pop.",
midnight:"vidurnaktis",
noon:"perpiet",
morning:"rytas",
afternoon:"popiet\u0117",
evening:"vakaras",
night:"naktis"
},
abbreviated:{
am:"prie\u0161piet",
pm:"popiet",
midnight:"vidurnaktis",
noon:"perpiet",
morning:"rytas",
afternoon:"popiet\u0117",
evening:"vakaras",
night:"naktis"
},
wide:{
am:"prie\u0161piet",
pm:"popiet",
midnight:"vidurnaktis",
noon:"perpiet",
morning:"rytas",
afternoon:"popiet\u0117",
evening:"vakaras",
night:"naktis"
}
};
var ordinalNumber51=function ordinalNumber51(dirtyNumber,_options){
var number=Number(dirtyNumber);
return number+"-oji";
};
var localize114={
ordinalNumber:ordinalNumber51,
era:buildLocalizeFn({
values:eraValues51,
defaultWidth:"wide"
}),
quarter:buildLocalizeFn({
values:quarterValues51,
defaultWidth:"wide",
formattingValues:formattingQuarterValues2,
defaultFormattingWidth:"wide",
argumentCallback:function argumentCallback(quarter){return quarter-1;}
}),
month:buildLocalizeFn({
values:monthValues51,
defaultWidth:"wide",
formattingValues:formattingMonthValues11,
defaultFormattingWidth:"wide"
}),
day:buildLocalizeFn({
values:dayValues51,
defaultWidth:"wide",
formattingValues:formattingDayValues2,
defaultFormattingWidth:"wide"
}),
dayPeriod:buildLocalizeFn({
values:dayPeriodValues51,
defaultWidth:"wide",
formattingValues:formattingDayPeriodValues43,
defaultFormattingWidth:"wide"
})
};

// lib/locale/lt/_lib/match.js
var matchOrdinalNumberPattern50=/^(\d+)(-oji)?/i;
var parseOrdinalNumberPattern50=/\d+/i;
var matchEraPatterns50={
narrow:/^p(r|o)\.?\s?(kr\.?|me)/i,
abbreviated:/^(pr\.\s?(kr\.|m\.\s?e\.)|po\s?kr\.|mūsų eroje)/i,
wide:/^(prieš Kristų|prieš mūsų erą|po Kristaus|mūsų eroje)/i
};
var parseEraPatterns50={
wide:[/prieš/i,/(po|mūsų)/i],
any:[/^pr/i,/^(po|m)/i]
};
var matchQuarterPatterns50={
narrow:/^([1234])/i,
abbreviated:/^(I|II|III|IV)\s?ketv?\.?/i,
wide:/^(I|II|III|IV)\s?ketvirtis/i
};
var parseQuarterPatterns50={
narrow:[/1/i,/2/i,/3/i,/4/i],
any:[/I$/i,/II$/i,/III/i,/IV/i]
};
var matchMonthPatterns50={
narrow:/^[svkbglr]/i,
abbreviated:/^(saus\.|vas\.|kov\.|bal\.|geg\.|birž\.|liep\.|rugp\.|rugs\.|spal\.|lapkr\.|gruod\.)/i,
wide:/^(sausi(s|o)|vasari(s|o)|kov(a|o)s|balandž?i(s|o)|gegužės?|birželi(s|o)|liep(a|os)|rugpjū(t|č)i(s|o)|rugsėj(is|o)|spali(s|o)|lapkri(t|č)i(s|o)|gruodž?i(s|o))/i
};
var parseMonthPatterns50={
narrow:[
/^s/i,
/^v/i,
/^k/i,
/^b/i,
/^g/i,
/^b/i,
/^l/i,
/^r/i,
/^r/i,
/^s/i,
/^l/i,
/^g/i],

any:[
/^saus/i,
/^vas/i,
/^kov/i,
/^bal/i,
/^geg/i,
/^birž/i,
/^liep/i,
/^rugp/i,
/^rugs/i,
/^spal/i,
/^lapkr/i,
/^gruod/i]

};
var matchDayPatterns50={
narrow:/^[spatkš]/i,
short:/^(sk|pr|an|tr|kt|pn|št)/i,
abbreviated:/^(sk|pr|an|tr|kt|pn|št)/i,
wide:/^(sekmadien(is|į)|pirmadien(is|į)|antradien(is|į)|trečiadien(is|į)|ketvirtadien(is|į)|penktadien(is|į)|šeštadien(is|į))/i
};
var parseDayPatterns50={
narrow:[/^s/i,/^p/i,/^a/i,/^t/i,/^k/i,/^p/i,/^š/i],
wide:[/^se/i,/^pi/i,/^an/i,/^tr/i,/^ke/i,/^pe/i,/^še/i],
any:[/^sk/i,/^pr/i,/^an/i,/^tr/i,/^kt/i,/^pn/i,/^št/i]
};
var matchDayPeriodPatterns50={
narrow:/^(pr.\s?p.|pop.|vidurnaktis|(vidurdienis|perpiet)|rytas|(diena|popietė)|vakaras|naktis)/i,
any:/^(priešpiet|popiet$|vidurnaktis|(vidurdienis|perpiet)|rytas|(diena|popietė)|vakaras|naktis)/i
};
var parseDayPeriodPatterns50={
narrow:{
am:/^pr/i,
pm:/^pop./i,
midnight:/^vidurnaktis/i,
noon:/^(vidurdienis|perp)/i,
morning:/rytas/i,
afternoon:/(die|popietė)/i,
evening:/vakaras/i,
night:/naktis/i
},
any:{
am:/^pr/i,
pm:/^popiet$/i,
midnight:/^vidurnaktis/i,
noon:/^(vidurdienis|perp)/i,
morning:/rytas/i,
afternoon:/(die|popietė)/i,
evening:/vakaras/i,
night:/naktis/i
}
};
var match110={
ordinalNumber:buildMatchPatternFn({
matchPattern:matchOrdinalNumberPattern50,
parsePattern:parseOrdinalNumberPattern50,
valueCallback:function valueCallback(value){return parseInt(value,10);}
}),
era:buildMatchFn({
matchPatterns:matchEraPatterns50,
defaultMatchWidth:"wide",
parsePatterns:parseEraPatterns50,
defaultParseWidth:"any"
}),
quarter:buildMatchFn({
matchPatterns:matchQuarterPatterns50,
defaultMatchWidth:"wide",
parsePatterns:parseQuarterPatterns50,
defaultParseWidth:"any",
valueCallback:function valueCallback(index){return index+1;}
}),
month:buildMatchFn({
matchPatterns:matchMonthPatterns50,
defaultMatchWidth:"wide",
parsePatterns:parseMonthPatterns50,
defaultParseWidth:"any"
}),
day:buildMatchFn({
matchPatterns:matchDayPatterns50,
defaultMatchWidth:"wide",
parsePatterns:parseDayPatterns50,
defaultParseWidth:"any"
}),
dayPeriod:buildMatchFn({
matchPatterns:matchDayPeriodPatterns50,
defaultMatchWidth:"any",
parsePatterns:parseDayPeriodPatterns50,
defaultParseWidth:"any"
})
};

// lib/locale/lt.js
var _lt={
code:"lt",
formatDistance:formatDistance111,
formatLong:formatLong119,
formatRelative:formatRelative111,
localize:localize114,
match:match110,
options:{
weekStartsOn:1,
firstWeekContainsDate:4
}
};
// lib/locale/lv/_lib/formatDistance.js
function buildLocalizeTokenFn3(schema){
return function(count,options){
if(count===1){
if(options!==null&&options!==void 0&&options.addSuffix){
return schema.one[0].replace("{{time}}",schema.one[2]);
}else{
return schema.one[0].replace("{{time}}",schema.one[1]);
}
}else{
var rem=count%10===1&&count%100!==11;
if(options!==null&&options!==void 0&&options.addSuffix){
return schema.other[0].replace("{{time}}",rem?schema.other[3]:schema.other[4]).replace("{{count}}",String(count));
}else{
return schema.other[0].replace("{{time}}",rem?schema.other[1]:schema.other[2]).replace("{{count}}",String(count));
}
}
};
}
var formatDistanceLocale51={
lessThanXSeconds:buildLocalizeTokenFn3({
one:["maz\u0101k par {{time}}","sekundi","sekundi"],
other:[
"maz\u0101k nek\u0101 {{count}} {{time}}",
"sekunde",
"sekundes",
"sekundes",
"sekund\u0113m"]

}),
xSeconds:buildLocalizeTokenFn3({
one:["1 {{time}}","sekunde","sekundes"],
other:[
"{{count}} {{time}}",
"sekunde",
"sekundes",
"sekundes",
"sekund\u0113m"]

}),
halfAMinute:function halfAMinute(_count,options){
if(options!==null&&options!==void 0&&options.addSuffix){
return"pusmin\u016Btes";
}else{
return"pusmin\u016Bte";
}
},
lessThanXMinutes:buildLocalizeTokenFn3({
one:["maz\u0101k par {{time}}","min\u016Bti","min\u016Bti"],
other:[
"maz\u0101k nek\u0101 {{count}} {{time}}",
"min\u016Bte",
"min\u016Btes",
"min\u016Btes",
"min\u016Bt\u0113m"]

}),
xMinutes:buildLocalizeTokenFn3({
one:["1 {{time}}","min\u016Bte","min\u016Btes"],
other:["{{count}} {{time}}","min\u016Bte","min\u016Btes","min\u016Btes","min\u016Bt\u0113m"]
}),
aboutXHours:buildLocalizeTokenFn3({
one:["apm\u0113ram 1 {{time}}","stunda","stundas"],
other:[
"apm\u0113ram {{count}} {{time}}",
"stunda",
"stundas",
"stundas",
"stund\u0101m"]

}),
xHours:buildLocalizeTokenFn3({
one:["1 {{time}}","stunda","stundas"],
other:["{{count}} {{time}}","stunda","stundas","stundas","stund\u0101m"]
}),
xDays:buildLocalizeTokenFn3({
one:["1 {{time}}","diena","dienas"],
other:["{{count}} {{time}}","diena","dienas","dienas","dien\u0101m"]
}),
aboutXWeeks:buildLocalizeTokenFn3({
one:["apm\u0113ram 1 {{time}}","ned\u0113\u013Ca","ned\u0113\u013Cas"],
other:[
"apm\u0113ram {{count}} {{time}}",
"ned\u0113\u013Ca",
"ned\u0113\u013Cu",
"ned\u0113\u013Cas",
"ned\u0113\u013C\u0101m"]

}),
xWeeks:buildLocalizeTokenFn3({
one:["1 {{time}}","ned\u0113\u013Ca","ned\u0113\u013Cas"],
other:[
"{{count}} {{time}}",
"ned\u0113\u013Ca",
"ned\u0113\u013Cu",
"ned\u0113\u013Cas",
"ned\u0113\u013C\u0101m"]

}),
aboutXMonths:buildLocalizeTokenFn3({
one:["apm\u0113ram 1 {{time}}","m\u0113nesis","m\u0113ne\u0161a"],
other:[
"apm\u0113ram {{count}} {{time}}",
"m\u0113nesis",
"m\u0113ne\u0161i",
"m\u0113ne\u0161a",
"m\u0113ne\u0161iem"]

}),
xMonths:buildLocalizeTokenFn3({
one:["1 {{time}}","m\u0113nesis","m\u0113ne\u0161a"],
other:["{{count}} {{time}}","m\u0113nesis","m\u0113ne\u0161i","m\u0113ne\u0161a","m\u0113ne\u0161iem"]
}),
aboutXYears:buildLocalizeTokenFn3({
one:["apm\u0113ram 1 {{time}}","gads","gada"],
other:["apm\u0113ram {{count}} {{time}}","gads","gadi","gada","gadiem"]
}),
xYears:buildLocalizeTokenFn3({
one:["1 {{time}}","gads","gada"],
other:["{{count}} {{time}}","gads","gadi","gada","gadiem"]
}),
overXYears:buildLocalizeTokenFn3({
one:["ilg\u0101k par 1 {{time}}","gadu","gadu"],
other:["vair\u0101k nek\u0101 {{count}} {{time}}","gads","gadi","gada","gadiem"]
}),
almostXYears:buildLocalizeTokenFn3({
one:["gandr\u012Bz 1 {{time}}","gads","gada"],
other:["vair\u0101k nek\u0101 {{count}} {{time}}","gads","gadi","gada","gadiem"]
})
};
var formatDistance113=function formatDistance113(token,count,options){
var result=formatDistanceLocale51[token](count,options);
if(options!==null&&options!==void 0&&options.addSuffix){
if(options.comparison&&options.comparison>0){
return"p\u0113c "+result;
}else{
return"pirms "+result;
}
}
return result;
};

// lib/locale/lv/_lib/formatLong.js
var dateFormats60={
full:"EEEE, y. 'gada' d. MMMM",
long:"y. 'gada' d. MMMM",
medium:"dd.MM.y.",
short:"dd.MM.y."
};
var timeFormats60={
full:"HH:mm:ss zzzz",
long:"HH:mm:ss z",
medium:"HH:mm:ss",
short:"HH:mm"
};
var dateTimeFormats60={
full:"{{date}} 'plkst.' {{time}}",
long:"{{date}} 'plkst.' {{time}}",
medium:"{{date}}, {{time}}",
short:"{{date}}, {{time}}"
};
var formatLong121={
date:buildFormatLongFn({
formats:dateFormats60,
defaultWidth:"full"
}),
time:buildFormatLongFn({
formats:timeFormats60,
defaultWidth:"full"
}),
dateTime:buildFormatLongFn({
formats:dateTimeFormats60,
defaultWidth:"full"
})
};

// lib/locale/lv/_lib/formatRelative.js
var weekdays3=[
"sv\u0113tdien\u0101",
"pirmdien\u0101",
"otrdien\u0101",
"tre\u0161dien\u0101",
"ceturtdien\u0101",
"piektdien\u0101",
"sestdien\u0101"];

var formatRelativeLocale52={
lastWeek:function lastWeek(date,baseDate,options){
if(isSameWeek(date,baseDate,options)){
return"eeee 'plkst.' p";
}
var weekday=weekdays3[date.getDay()];
return"'Pag\u0101ju\u0161\u0101 "+weekday+" plkst.' p";
},
yesterday:"'Vakar plkst.' p",
today:"'\u0160odien plkst.' p",
tomorrow:"'R\u012Bt plkst.' p",
nextWeek:function nextWeek(date,baseDate,options){
if(isSameWeek(date,baseDate,options)){
return"eeee 'plkst.' p";
}
var weekday=weekdays3[date.getDay()];
return"'N\u0101kamaj\u0101 "+weekday+" plkst.' p";
},
other:"P"
};
var formatRelative113=function formatRelative113(token,date,baseDate,options){
var format=formatRelativeLocale52[token];
if(typeof format==="function"){
return format(date,baseDate,options);
}
return format;
};

// lib/locale/lv/_lib/localize.js
var eraValues52={
narrow:["p.m.\u0113","m.\u0113"],
abbreviated:["p. m. \u0113.","m. \u0113."],
wide:["pirms m\u016Bsu \u0113ras","m\u016Bsu \u0113r\u0101"]
};
var quarterValues52={
narrow:["1","2","3","4"],
abbreviated:["1. cet.","2. cet.","3. cet.","4. cet."],
wide:[
"pirmais ceturksnis",
"otrais ceturksnis",
"tre\u0161ais ceturksnis",
"ceturtais ceturksnis"]

};
var formattingQuarterValues3={
narrow:["1","2","3","4"],
abbreviated:["1. cet.","2. cet.","3. cet.","4. cet."],
wide:[
"pirmaj\u0101 ceturksn\u012B",
"otraj\u0101 ceturksn\u012B",
"tre\u0161aj\u0101 ceturksn\u012B",
"ceturtaj\u0101 ceturksn\u012B"]

};
var monthValues52={
narrow:["J","F","M","A","M","J","J","A","S","O","N","D"],
abbreviated:[
"janv.",
"febr.",
"marts",
"apr.",
"maijs",
"j\u016Bn.",
"j\u016Bl.",
"aug.",
"sept.",
"okt.",
"nov.",
"dec."],

wide:[
"janv\u0101ris",
"febru\u0101ris",
"marts",
"apr\u012Blis",
"maijs",
"j\u016Bnijs",
"j\u016Blijs",
"augusts",
"septembris",
"oktobris",
"novembris",
"decembris"]

};
var formattingMonthValues12={
narrow:["J","F","M","A","M","J","J","A","S","O","N","D"],
abbreviated:[
"janv.",
"febr.",
"mart\u0101",
"apr.",
"maijs",
"j\u016Bn.",
"j\u016Bl.",
"aug.",
"sept.",
"okt.",
"nov.",
"dec."],

wide:[
"janv\u0101r\u012B",
"febru\u0101r\u012B",
"mart\u0101",
"apr\u012Bl\u012B",
"maij\u0101",
"j\u016Bnij\u0101",
"j\u016Blij\u0101",
"august\u0101",
"septembr\u012B",
"oktobr\u012B",
"novembr\u012B",
"decembr\u012B"]

};
var dayValues52={
narrow:["S","P","O","T","C","P","S"],
short:["Sv","P","O","T","C","Pk","S"],
abbreviated:[
"sv\u0113td.",
"pirmd.",
"otrd.",
"tre\u0161d.",
"ceturtd.",
"piektd.",
"sestd."],

wide:[
"sv\u0113tdiena",
"pirmdiena",
"otrdiena",
"tre\u0161diena",
"ceturtdiena",
"piektdiena",
"sestdiena"]

};
var formattingDayValues3={
narrow:["S","P","O","T","C","P","S"],
short:["Sv","P","O","T","C","Pk","S"],
abbreviated:[
"sv\u0113td.",
"pirmd.",
"otrd.",
"tre\u0161d.",
"ceturtd.",
"piektd.",
"sestd."],

wide:[
"sv\u0113tdien\u0101",
"pirmdien\u0101",
"otrdien\u0101",
"tre\u0161dien\u0101",
"ceturtdien\u0101",
"piektdien\u0101",
"sestdien\u0101"]

};
var dayPeriodValues52={
narrow:{
am:"am",
pm:"pm",
midnight:"pusn.",
noon:"pusd.",
morning:"r\u012Bts",
afternoon:"diena",
evening:"vakars",
night:"nakts"
},
abbreviated:{
am:"am",
pm:"pm",
midnight:"pusn.",
noon:"pusd.",
morning:"r\u012Bts",
afternoon:"p\u0113cpusd.",
evening:"vakars",
night:"nakts"
},
wide:{
am:"am",
pm:"pm",
midnight:"pusnakts",
noon:"pusdienlaiks",
morning:"r\u012Bts",
afternoon:"p\u0113cpusdiena",
evening:"vakars",
night:"nakts"
}
};
var formattingDayPeriodValues44={
narrow:{
am:"am",
pm:"pm",
midnight:"pusn.",
noon:"pusd.",
morning:"r\u012Bt\u0101",
afternoon:"dien\u0101",
evening:"vakar\u0101",
night:"nakt\u012B"
},
abbreviated:{
am:"am",
pm:"pm",
midnight:"pusn.",
noon:"pusd.",
morning:"r\u012Bt\u0101",
afternoon:"p\u0113cpusd.",
evening:"vakar\u0101",
night:"nakt\u012B"
},
wide:{
am:"am",
pm:"pm",
midnight:"pusnakt\u012B",
noon:"pusdienlaik\u0101",
morning:"r\u012Bt\u0101",
afternoon:"p\u0113cpusdien\u0101",
evening:"vakar\u0101",
night:"nakt\u012B"
}
};
var ordinalNumber52=function ordinalNumber52(dirtyNumber,_options){
var number=Number(dirtyNumber);
return number+".";
};
var localize116={
ordinalNumber:ordinalNumber52,
era:buildLocalizeFn({
values:eraValues52,
defaultWidth:"wide"
}),
quarter:buildLocalizeFn({
values:quarterValues52,
defaultWidth:"wide",
formattingValues:formattingQuarterValues3,
defaultFormattingWidth:"wide",
argumentCallback:function argumentCallback(quarter){return quarter-1;}
}),
month:buildLocalizeFn({
values:monthValues52,
defaultWidth:"wide",
formattingValues:formattingMonthValues12,
defaultFormattingWidth:"wide"
}),
day:buildLocalizeFn({
values:dayValues52,
defaultWidth:"wide",
formattingValues:formattingDayValues3,
defaultFormattingWidth:"wide"
}),
dayPeriod:buildLocalizeFn({
values:dayPeriodValues52,
defaultWidth:"wide",
formattingValues:formattingDayPeriodValues44,
defaultFormattingWidth:"wide"
})
};

// lib/locale/lv/_lib/match.js
var matchOrdinalNumberPattern51=/^(\d+)\./i;
var parseOrdinalNumberPattern51=/\d+/i;
var matchEraPatterns51={
narrow:/^(p\.m\.ē|m\.ē)/i,
abbreviated:/^(p\. m\. ē\.|m\. ē\.)/i,
wide:/^(pirms mūsu ēras|mūsu ērā)/i
};
var parseEraPatterns51={
any:[/^p/i,/^m/i]
};
var matchQuarterPatterns51={
narrow:/^[1234]/i,
abbreviated:/^[1234](\. cet\.)/i,
wide:/^(pirma(is|jā)|otra(is|jā)|treša(is|jā)|ceturta(is|jā)) ceturksn(is|ī)/i
};
var parseQuarterPatterns51={
narrow:[/^1/i,/^2/i,/^3/i,/^4/i],
abbreviated:[/^1/i,/^2/i,/^3/i,/^4/i],
wide:[/^p/i,/^o/i,/^t/i,/^c/i]
};
var matchMonthPatterns51={
narrow:/^[jfmasond]/i,
abbreviated:/^(janv\.|febr\.|marts|apr\.|maijs|jūn\.|jūl\.|aug\.|sept\.|okt\.|nov\.|dec\.)/i,
wide:/^(janvār(is|ī)|februār(is|ī)|mart[sā]|aprīl(is|ī)|maij[sā]|jūnij[sā]|jūlij[sā]|august[sā]|septembr(is|ī)|oktobr(is|ī)|novembr(is|ī)|decembr(is|ī))/i
};
var parseMonthPatterns51={
narrow:[
/^j/i,
/^f/i,
/^m/i,
/^a/i,
/^m/i,
/^j/i,
/^j/i,
/^a/i,
/^s/i,
/^o/i,
/^n/i,
/^d/i],

any:[
/^ja/i,
/^f/i,
/^mar/i,
/^ap/i,
/^mai/i,
/^jūn/i,
/^jūl/i,
/^au/i,
/^s/i,
/^o/i,
/^n/i,
/^d/i]

};
var matchDayPatterns51={
narrow:/^[spotc]/i,
short:/^(sv|pi|o|t|c|pk|s)/i,
abbreviated:/^(svētd\.|pirmd\.|otrd.\|trešd\.|ceturtd\.|piektd\.|sestd\.)/i,
wide:/^(svētdien(a|ā)|pirmdien(a|ā)|otrdien(a|ā)|trešdien(a|ā)|ceturtdien(a|ā)|piektdien(a|ā)|sestdien(a|ā))/i
};
var parseDayPatterns51={
narrow:[/^s/i,/^p/i,/^o/i,/^t/i,/^c/i,/^p/i,/^s/i],
any:[/^sv/i,/^pi/i,/^o/i,/^t/i,/^c/i,/^p/i,/^se/i]
};
var matchDayPeriodPatterns51={
narrow:/^(am|pm|pusn\.|pusd\.|rīt(s|ā)|dien(a|ā)|vakar(s|ā)|nakt(s|ī))/,
abbreviated:/^(am|pm|pusn\.|pusd\.|rīt(s|ā)|pēcpusd\.|vakar(s|ā)|nakt(s|ī))/,
wide:/^(am|pm|pusnakt(s|ī)|pusdienlaik(s|ā)|rīt(s|ā)|pēcpusdien(a|ā)|vakar(s|ā)|nakt(s|ī))/i
};
var parseDayPeriodPatterns51={
any:{
am:/^am/i,
pm:/^pm/i,
midnight:/^pusn/i,
noon:/^pusd/i,
morning:/^r/i,
afternoon:/^(d|pēc)/i,
evening:/^v/i,
night:/^n/i
}
};
var match112={
ordinalNumber:buildMatchPatternFn({
matchPattern:matchOrdinalNumberPattern51,
parsePattern:parseOrdinalNumberPattern51,
valueCallback:function valueCallback(value){return parseInt(value,10);}
}),
era:buildMatchFn({
matchPatterns:matchEraPatterns51,
defaultMatchWidth:"wide",
parsePatterns:parseEraPatterns51,
defaultParseWidth:"any"
}),
quarter:buildMatchFn({
matchPatterns:matchQuarterPatterns51,
defaultMatchWidth:"wide",
parsePatterns:parseQuarterPatterns51,
defaultParseWidth:"wide",
valueCallback:function valueCallback(index){return index+1;}
}),
month:buildMatchFn({
matchPatterns:matchMonthPatterns51,
defaultMatchWidth:"wide",
parsePatterns:parseMonthPatterns51,
defaultParseWidth:"any"
}),
day:buildMatchFn({
matchPatterns:matchDayPatterns51,
defaultMatchWidth:"wide",
parsePatterns:parseDayPatterns51,
defaultParseWidth:"any"
}),
dayPeriod:buildMatchFn({
matchPatterns:matchDayPeriodPatterns51,
defaultMatchWidth:"wide",
parsePatterns:parseDayPeriodPatterns51,
defaultParseWidth:"any"
})
};

// lib/locale/lv.js
var _lv={
code:"lv",
formatDistance:formatDistance113,
formatLong:formatLong121,
formatRelative:formatRelative113,
localize:localize116,
match:match112,
options:{
weekStartsOn:1,
firstWeekContainsDate:4
}
};
// lib/locale/mk/_lib/formatDistance.js
var formatDistanceLocale52={
lessThanXSeconds:{
one:"\u043F\u043E\u043C\u0430\u043B\u043A\u0443 \u043E\u0434 \u0441\u0435\u043A\u0443\u043D\u0434\u0430",
other:"\u043F\u043E\u043C\u0430\u043B\u043A\u0443 \u043E\u0434 {{count}} \u0441\u0435\u043A\u0443\u043D\u0434\u0438"
},
xSeconds:{
one:"1 \u0441\u0435\u043A\u0443\u043D\u0434\u0430",
other:"{{count}} \u0441\u0435\u043A\u0443\u043D\u0434\u0438"
},
halfAMinute:"\u043F\u043E\u043B\u043E\u0432\u0438\u043D\u0430 \u043C\u0438\u043D\u0443\u0442\u0430",
lessThanXMinutes:{
one:"\u043F\u043E\u043C\u0430\u043B\u043A\u0443 \u043E\u0434 \u043C\u0438\u043D\u0443\u0442\u0430",
other:"\u043F\u043E\u043C\u0430\u043B\u043A\u0443 \u043E\u0434 {{count}} \u043C\u0438\u043D\u0443\u0442\u0438"
},
xMinutes:{
one:"1 \u043C\u0438\u043D\u0443\u0442\u0430",
other:"{{count}} \u043C\u0438\u043D\u0443\u0442\u0438"
},
aboutXHours:{
one:"\u043E\u043A\u043E\u043B\u0443 1 \u0447\u0430\u0441",
other:"\u043E\u043A\u043E\u043B\u0443 {{count}} \u0447\u0430\u0441\u0430"
},
xHours:{
one:"1 \u0447\u0430\u0441",
other:"{{count}} \u0447\u0430\u0441\u0430"
},
xDays:{
one:"1 \u0434\u0435\u043D",
other:"{{count}} \u0434\u0435\u043D\u0430"
},
aboutXWeeks:{
one:"\u043E\u043A\u043E\u043B\u0443 1 \u043D\u0435\u0434\u0435\u043B\u0430",
other:"\u043E\u043A\u043E\u043B\u0443 {{count}} \u043C\u0435\u0441\u0435\u0446\u0438"
},
xWeeks:{
one:"1 \u043D\u0435\u0434\u0435\u043B\u0430",
other:"{{count}} \u043D\u0435\u0434\u0435\u043B\u0438"
},
aboutXMonths:{
one:"\u043E\u043A\u043E\u043B\u0443 1 \u043C\u0435\u0441\u0435\u0446",
other:"\u043E\u043A\u043E\u043B\u0443 {{count}} \u043D\u0435\u0434\u0435\u043B\u0438"
},
xMonths:{
one:"1 \u043C\u0435\u0441\u0435\u0446",
other:"{{count}} \u043C\u0435\u0441\u0435\u0446\u0438"
},
aboutXYears:{
one:"\u043E\u043A\u043E\u043B\u0443 1 \u0433\u043E\u0434\u0438\u043D\u0430",
other:"\u043E\u043A\u043E\u043B\u0443 {{count}} \u0433\u043E\u0434\u0438\u043D\u0438"
},
xYears:{
one:"1 \u0433\u043E\u0434\u0438\u043D\u0430",
other:"{{count}} \u0433\u043E\u0434\u0438\u043D\u0438"
},
overXYears:{
one:"\u043F\u043E\u0432\u0435\u045C\u0435 \u043E\u0434 1 \u0433\u043E\u0434\u0438\u043D\u0430",
other:"\u043F\u043E\u0432\u0435\u045C\u0435 \u043E\u0434 {{count}} \u0433\u043E\u0434\u0438\u043D\u0438"
},
almostXYears:{
one:"\u0431\u0435\u0437\u043C\u0430\u043B\u043A\u0443 1 \u0433\u043E\u0434\u0438\u043D\u0430",
other:"\u0431\u0435\u0437\u043C\u0430\u043B\u043A\u0443 {{count}} \u0433\u043E\u0434\u0438\u043D\u0438"
}
};
var formatDistance115=function formatDistance115(token,count,options){
var result;
var tokenValue=formatDistanceLocale52[token];
if(typeof tokenValue==="string"){
result=tokenValue;
}else if(count===1){
result=tokenValue.one;
}else{
result=tokenValue.other.replace("{{count}}",String(count));
}
if(options!==null&&options!==void 0&&options.addSuffix){
if(options.comparison&&options.comparison>0){
return"\u0437\u0430 "+result;
}else{
return"\u043F\u0440\u0435\u0434 "+result;
}
}
return result;
};

// lib/locale/mk/_lib/formatLong.js
var dateFormats61={
full:"EEEE, dd MMMM yyyy",
long:"dd MMMM yyyy",
medium:"dd MMM yyyy",
short:"dd/MM/yyyy"
};
var timeFormats61={
full:"HH:mm:ss zzzz",
long:"HH:mm:ss z",
medium:"HH:mm:ss",
short:"H:mm"
};
var dateTimeFormats61={
any:"{{date}} {{time}}"
};
var formatLong123={
date:buildFormatLongFn({
formats:dateFormats61,
defaultWidth:"full"
}),
time:buildFormatLongFn({
formats:timeFormats61,
defaultWidth:"full"
}),
dateTime:buildFormatLongFn({
formats:dateTimeFormats61,
defaultWidth:"any"
})
};

// lib/locale/mk/_lib/formatRelative.js
function lastWeek6(day){
var weekday=weekdays4[day];
switch(day){
case 0:
case 3:
case 6:
return"'\u043C\u0438\u043D\u0430\u0442\u0430\u0442\u0430 "+weekday+" \u0432\u043E' p";
case 1:
case 2:
case 4:
case 5:
return"'\u043C\u0438\u043D\u0430\u0442\u0438\u043E\u0442 "+weekday+" \u0432\u043E' p";
}
}
function thisWeek6(day){
var weekday=weekdays4[day];
switch(day){
case 0:
case 3:
case 6:
return"'\u043E\u0432\u0430 "+weekday+" \u0432o' p";
case 1:
case 2:
case 4:
case 5:
return"'\u043E\u0432\u043E\u0458 "+weekday+" \u0432o' p";
}
}
function nextWeek6(day){
var weekday=weekdays4[day];
switch(day){
case 0:
case 3:
case 6:
return"'\u0441\u043B\u0435\u0434\u043D\u0430\u0442\u0430 "+weekday+" \u0432o' p";
case 1:
case 2:
case 4:
case 5:
return"'\u0441\u043B\u0435\u0434\u043D\u0438\u043E\u0442 "+weekday+" \u0432o' p";
}
}
var weekdays4=[
"\u043D\u0435\u0434\u0435\u043B\u0430",
"\u043F\u043E\u043D\u0435\u0434\u0435\u043B\u043D\u0438\u043A",
"\u0432\u0442\u043E\u0440\u043D\u0438\u043A",
"\u0441\u0440\u0435\u0434\u0430",
"\u0447\u0435\u0442\u0432\u0440\u0442\u043E\u043A",
"\u043F\u0435\u0442\u043E\u043A",
"\u0441\u0430\u0431\u043E\u0442\u0430"];

var formatRelativeLocale53={
lastWeek:function lastWeek(date,baseDate,options){
var day=date.getDay();
if(isSameWeek(date,baseDate,options)){
return thisWeek6(day);
}else{
return lastWeek6(day);
}
},
yesterday:"'\u0432\u0447\u0435\u0440\u0430 \u0432\u043E' p",
today:"'\u0434\u0435\u043D\u0435\u0441 \u0432\u043E' p",
tomorrow:"'\u0443\u0442\u0440\u0435 \u0432\u043E' p",
nextWeek:function nextWeek(date,baseDate,options){
var day=date.getDay();
if(isSameWeek(date,baseDate,options)){
return thisWeek6(day);
}else{
return nextWeek6(day);
}
},
other:"P"
};
var formatRelative115=function formatRelative115(token,date,baseDate,options){
var format=formatRelativeLocale53[token];
if(typeof format==="function"){
return format(date,baseDate,options);
}
return format;
};

// lib/locale/mk/_lib/localize.js
var eraValues53={
narrow:["\u043F\u0440.\u043D.\u0435.","\u043D.\u0435."],
abbreviated:["\u043F\u0440\u0435\u0434 \u043D. \u0435.","\u043D. \u0435."],
wide:["\u043F\u0440\u0435\u0434 \u043D\u0430\u0448\u0430\u0442\u0430 \u0435\u0440\u0430","\u043D\u0430\u0448\u0430\u0442\u0430 \u0435\u0440\u0430"]
};
var quarterValues53={
narrow:["1","2","3","4"],
abbreviated:["1-\u0432\u0438 \u043A\u0432.","2-\u0440\u0438 \u043A\u0432.","3-\u0442\u0438 \u043A\u0432.","4-\u0442\u0438 \u043A\u0432."],
wide:["1-\u0432\u0438 \u043A\u0432\u0430\u0440\u0442\u0430\u043B","2-\u0440\u0438 \u043A\u0432\u0430\u0440\u0442\u0430\u043B","3-\u0442\u0438 \u043A\u0432\u0430\u0440\u0442\u0430\u043B","4-\u0442\u0438 \u043A\u0432\u0430\u0440\u0442\u0430\u043B"]
};
var monthValues53={
abbreviated:[
"\u0458\u0430\u043D",
"\u0444\u0435\u0432",
"\u043C\u0430\u0440",
"\u0430\u043F\u0440",
"\u043C\u0430\u0458",
"\u0458\u0443\u043D",
"\u0458\u0443\u043B",
"\u0430\u0432\u0433",
"\u0441\u0435\u043F\u0442",
"\u043E\u043A\u0442",
"\u043D\u043E\u0435\u043C",
"\u0434\u0435\u043A"],

wide:[
"\u0458\u0430\u043D\u0443\u0430\u0440\u0438",
"\u0444\u0435\u0432\u0440\u0443\u0430\u0440\u0438",
"\u043C\u0430\u0440\u0442",
"\u0430\u043F\u0440\u0438\u043B",
"\u043C\u0430\u0458",
"\u0458\u0443\u043D\u0438",
"\u0458\u0443\u043B\u0438",
"\u0430\u0432\u0433\u0443\u0441\u0442",
"\u0441\u0435\u043F\u0442\u0435\u043C\u0432\u0440\u0438",
"\u043E\u043A\u0442\u043E\u043C\u0432\u0440\u0438",
"\u043D\u043E\u0435\u043C\u0432\u0440\u0438",
"\u0434\u0435\u043A\u0435\u043C\u0432\u0440\u0438"]

};
var dayValues53={
narrow:["\u041D","\u041F","\u0412","\u0421","\u0427","\u041F","\u0421"],
short:["\u043D\u0435","\u043F\u043E","\u0432\u0442","\u0441\u0440","\u0447\u0435","\u043F\u0435","\u0441\u0430"],
abbreviated:["\u043D\u0435\u0434","\u043F\u043E\u043D","\u0432\u0442\u043E","\u0441\u0440\u0435","\u0447\u0435\u0442","\u043F\u0435\u0442","\u0441\u0430\u0431"],
wide:[
"\u043D\u0435\u0434\u0435\u043B\u0430",
"\u043F\u043E\u043D\u0435\u0434\u0435\u043B\u043D\u0438\u043A",
"\u0432\u0442\u043E\u0440\u043D\u0438\u043A",
"\u0441\u0440\u0435\u0434\u0430",
"\u0447\u0435\u0442\u0432\u0440\u0442\u043E\u043A",
"\u043F\u0435\u0442\u043E\u043A",
"\u0441\u0430\u0431\u043E\u0442\u0430"]

};
var dayPeriodValues53={
wide:{
am:"\u043F\u0440\u0435\u0442\u043F\u043B\u0430\u0434\u043D\u0435",
pm:"\u043F\u043E\u043F\u043B\u0430\u0434\u043D\u0435",
midnight:"\u043F\u043E\u043B\u043D\u043E\u045C",
noon:"\u043D\u0430\u043F\u043B\u0430\u0434\u043D\u0435",
morning:"\u043D\u0430\u0443\u0442\u0440\u043E",
afternoon:"\u043F\u043E\u043F\u043B\u0430\u0434\u043D\u0435",
evening:"\u043D\u0430\u0432\u0435\u0447\u0435\u0440",
night:"\u043D\u043E\u045C\u0435"
}
};
var ordinalNumber53=function ordinalNumber53(dirtyNumber,_options){
var number=Number(dirtyNumber);
var rem100=number%100;
if(rem100>20||rem100<10){
switch(rem100%10){
case 1:
return number+"-\u0432\u0438";
case 2:
return number+"-\u0440\u0438";
case 7:
case 8:
return number+"-\u043C\u0438";
}
}
return number+"-\u0442\u0438";
};
var localize118={
ordinalNumber:ordinalNumber53,
era:buildLocalizeFn({
values:eraValues53,
defaultWidth:"wide"
}),
quarter:buildLocalizeFn({
values:quarterValues53,
defaultWidth:"wide",
argumentCallback:function argumentCallback(quarter){return quarter-1;}
}),
month:buildLocalizeFn({
values:monthValues53,
defaultWidth:"wide"
}),
day:buildLocalizeFn({
values:dayValues53,
defaultWidth:"wide"
}),
dayPeriod:buildLocalizeFn({
values:dayPeriodValues53,
defaultWidth:"wide"
})
};

// lib/locale/mk/_lib/match.js
var matchOrdinalNumberPattern52=/^(\d+)(-?[врмт][и])?/i;
var parseOrdinalNumberPattern52=/\d+/i;
var matchEraPatterns52={
narrow:/^((пр)?н\.?\s?е\.?)/i,
abbreviated:/^((пр)?н\.?\s?е\.?)/i,
wide:/^(пред нашата ера|нашата ера)/i
};
var parseEraPatterns52={
any:[/^п/i,/^н/i]
};
var matchQuarterPatterns52={
narrow:/^[1234]/i,
abbreviated:/^[1234](-?[врт]?и?)? кв.?/i,
wide:/^[1234](-?[врт]?и?)? квартал/i
};
var parseQuarterPatterns52={
any:[/1/i,/2/i,/3/i,/4/i]
};
var matchDayPatterns52={
narrow:/^[нпвсч]/i,
short:/^(не|по|вт|ср|че|пе|са)/i,
abbreviated:/^(нед|пон|вто|сре|чет|пет|саб)/i,
wide:/^(недела|понеделник|вторник|среда|четврток|петок|сабота)/i
};
var parseDayPatterns52={
narrow:[/^н/i,/^п/i,/^в/i,/^с/i,/^ч/i,/^п/i,/^с/i],
any:[/^н[ед]/i,/^п[он]/i,/^вт/i,/^ср/i,/^ч[ет]/i,/^п[ет]/i,/^с[аб]/i]
};
var matchMonthPatterns52={
abbreviated:/^(јан|фев|мар|апр|мај|јун|јул|авг|сеп|окт|ноем|дек)/i,
wide:/^(јануари|февруари|март|април|мај|јуни|јули|август|септември|октомври|ноември|декември)/i
};
var parseMonthPatterns52={
any:[
/^ја/i,
/^Ф/i,
/^мар/i,
/^ап/i,
/^мај/i,
/^јун/i,
/^јул/i,
/^ав/i,
/^се/i,
/^окт/i,
/^но/i,
/^де/i]

};
var matchDayPeriodPatterns52={
any:/^(претп|попл|полноќ|утро|пладне|вечер|ноќ)/i
};
var parseDayPeriodPatterns52={
any:{
am:/претпладне/i,
pm:/попладне/i,
midnight:/полноќ/i,
noon:/напладне/i,
morning:/наутро/i,
afternoon:/попладне/i,
evening:/навечер/i,
night:/ноќе/i
}
};
var match114={
ordinalNumber:buildMatchPatternFn({
matchPattern:matchOrdinalNumberPattern52,
parsePattern:parseOrdinalNumberPattern52,
valueCallback:function valueCallback(value){return parseInt(value,10);}
}),
era:buildMatchFn({
matchPatterns:matchEraPatterns52,
defaultMatchWidth:"wide",
parsePatterns:parseEraPatterns52,
defaultParseWidth:"any"
}),
quarter:buildMatchFn({
matchPatterns:matchQuarterPatterns52,
defaultMatchWidth:"wide",
parsePatterns:parseQuarterPatterns52,
defaultParseWidth:"any",
valueCallback:function valueCallback(index){return index+1;}
}),
month:buildMatchFn({
matchPatterns:matchMonthPatterns52,
defaultMatchWidth:"wide",
parsePatterns:parseMonthPatterns52,
defaultParseWidth:"any"
}),
day:buildMatchFn({
matchPatterns:matchDayPatterns52,
defaultMatchWidth:"wide",
parsePatterns:parseDayPatterns52,
defaultParseWidth:"any"
}),
dayPeriod:buildMatchFn({
matchPatterns:matchDayPeriodPatterns52,
defaultMatchWidth:"any",
parsePatterns:parseDayPeriodPatterns52,
defaultParseWidth:"any"
})
};

// lib/locale/mk.js
var _mk={
code:"mk",
formatDistance:formatDistance115,
formatLong:formatLong123,
formatRelative:formatRelative115,
localize:localize118,
match:match114,
options:{
weekStartsOn:1,
firstWeekContainsDate:4
}
};
// lib/locale/mn/_lib/formatDistance.js
var formatDistanceLocale53={
lessThanXSeconds:{
one:"\u0441\u0435\u043A\u0443\u043D\u0434 \u0445\u04AF\u0440\u044D\u0445\u0433\u04AF\u0439",
other:"{{count}} \u0441\u0435\u043A\u0443\u043D\u0434 \u0445\u04AF\u0440\u044D\u0445\u0433\u04AF\u0439"
},
xSeconds:{
one:"1 \u0441\u0435\u043A\u0443\u043D\u0434",
other:"{{count}} \u0441\u0435\u043A\u0443\u043D\u0434"
},
halfAMinute:"\u0445\u0430\u0433\u0430\u0441 \u043C\u0438\u043D\u0443\u0442",
lessThanXMinutes:{
one:"\u043C\u0438\u043D\u0443\u0442 \u0445\u04AF\u0440\u044D\u0445\u0433\u04AF\u0439",
other:"{{count}} \u043C\u0438\u043D\u0443\u0442 \u0445\u04AF\u0440\u044D\u0445\u0433\u04AF\u0439"
},
xMinutes:{
one:"1 \u043C\u0438\u043D\u0443\u0442",
other:"{{count}} \u043C\u0438\u043D\u0443\u0442"
},
aboutXHours:{
one:"\u043E\u0439\u0440\u043E\u043B\u0446\u043E\u043E\u0433\u043E\u043E\u0440 1 \u0446\u0430\u0433",
other:"\u043E\u0439\u0440\u043E\u043B\u0446\u043E\u043E\u0433\u043E\u043E\u0440 {{count}} \u0446\u0430\u0433"
},
xHours:{
one:"1 \u0446\u0430\u0433",
other:"{{count}} \u0446\u0430\u0433"
},
xDays:{
one:"1 \u04E9\u0434\u04E9\u0440",
other:"{{count}} \u04E9\u0434\u04E9\u0440"
},
aboutXWeeks:{
one:"\u043E\u0439\u0440\u043E\u043B\u0446\u043E\u043E\u0433\u043E\u043E\u0440 1 \u0434\u043E\u043B\u043E\u043E \u0445\u043E\u043D\u043E\u0433",
other:"\u043E\u0439\u0440\u043E\u043B\u0446\u043E\u043E\u0433\u043E\u043E\u0440 {{count}} \u0434\u043E\u043B\u043E\u043E \u0445\u043E\u043D\u043E\u0433"
},
xWeeks:{
one:"1 \u0434\u043E\u043B\u043E\u043E \u0445\u043E\u043D\u043E\u0433",
other:"{{count}} \u0434\u043E\u043B\u043E\u043E \u0445\u043E\u043D\u043E\u0433"
},
aboutXMonths:{
one:"\u043E\u0439\u0440\u043E\u043B\u0446\u043E\u043E\u0433\u043E\u043E\u0440 1 \u0441\u0430\u0440",
other:"\u043E\u0439\u0440\u043E\u043B\u0446\u043E\u043E\u0433\u043E\u043E\u0440 {{count}} \u0441\u0430\u0440"
},
xMonths:{
one:"1 \u0441\u0430\u0440",
other:"{{count}} \u0441\u0430\u0440"
},
aboutXYears:{
one:"\u043E\u0439\u0440\u043E\u043B\u0446\u043E\u043E\u0433\u043E\u043E\u0440 1 \u0436\u0438\u043B",
other:"\u043E\u0439\u0440\u043E\u043B\u0446\u043E\u043E\u0433\u043E\u043E\u0440 {{count}} \u0436\u0438\u043B"
},
xYears:{
one:"1 \u0436\u0438\u043B",
other:"{{count}} \u0436\u0438\u043B"
},
overXYears:{
one:"1 \u0436\u0438\u043B \u0433\u0430\u0440\u0430\u043D",
other:"{{count}} \u0436\u0438\u043B \u0433\u0430\u0440\u0430\u043D"
},
almostXYears:{
one:"\u0431\u0430\u0440\u0430\u0433 1 \u0436\u0438\u043B",
other:"\u0431\u0430\u0440\u0430\u0433 {{count}} \u0436\u0438\u043B"
}
};
var formatDistance117=function formatDistance117(token,count,options){
var result;
var tokenValue=formatDistanceLocale53[token];
if(typeof tokenValue==="string"){
result=tokenValue;
}else if(count===1){
result=tokenValue.one;
}else{
result=tokenValue.other.replace("{{count}}",String(count));
}
if(options!==null&&options!==void 0&&options.addSuffix){
var words=result.split(" ");
var lastword=words.pop();
result=words.join(" ");
switch(lastword){
case"\u0441\u0435\u043A\u0443\u043D\u0434":
result+=" \u0441\u0435\u043A\u0443\u043D\u0434\u0438\u0439\u043D";
break;
case"\u043C\u0438\u043D\u0443\u0442":
result+=" \u043C\u0438\u043D\u0443\u0442\u044B\u043D";
break;
case"\u0446\u0430\u0433":
result+=" \u0446\u0430\u0433\u0438\u0439\u043D";
break;
case"\u04E9\u0434\u04E9\u0440":
result+=" \u04E9\u0434\u0440\u0438\u0439\u043D";
break;
case"\u0441\u0430\u0440":
result+=" \u0441\u0430\u0440\u044B\u043D";
break;
case"\u0436\u0438\u043B":
result+=" \u0436\u0438\u043B\u0438\u0439\u043D";
break;
case"\u0445\u043E\u043D\u043E\u0433":
result+=" \u0445\u043E\u043D\u043E\u0433\u0438\u0439\u043D";
break;
case"\u0433\u0430\u0440\u0430\u043D":
result+=" \u0433\u0430\u0440\u0430\u043D\u044B";
break;
case"\u0445\u04AF\u0440\u044D\u0445\u0433\u04AF\u0439":
result+=" \u0445\u04AF\u0440\u044D\u0445\u0433\u04AF\u0439 \u0445\u0443\u0433\u0430\u0446\u0430\u0430\u043D\u044B";
break;
default:
result+=lastword+"-\u043D";
}
if(options.comparison&&options.comparison>0){
return result+" \u0434\u0430\u0440\u0430\u0430";
}else{
return result+" \u04E9\u043C\u043D\u04E9";
}
}
return result;
};

// lib/locale/mn/_lib/formatLong.js
var dateFormats62={
full:"y '\u043E\u043D\u044B' MMMM'\u044B\u043D' d, EEEE '\u0433\u0430\u0440\u0430\u0433'",
long:"y '\u043E\u043D\u044B' MMMM'\u044B\u043D' d",
medium:"y '\u043E\u043D\u044B' MMM'\u044B\u043D' d",
short:"y.MM.dd"
};
var timeFormats62={
full:"H:mm:ss zzzz",
long:"H:mm:ss z",
medium:"H:mm:ss",
short:"H:mm"
};
var dateTimeFormats62={
full:"{{date}} {{time}}",
long:"{{date}} {{time}}",
medium:"{{date}} {{time}}",
short:"{{date}} {{time}}"
};
var formatLong125={
date:buildFormatLongFn({
formats:dateFormats62,
defaultWidth:"full"
}),
time:buildFormatLongFn({
formats:timeFormats62,
defaultWidth:"full"
}),
dateTime:buildFormatLongFn({
formats:dateTimeFormats62,
defaultWidth:"full"
})
};

// lib/locale/mn/_lib/formatRelative.js
var formatRelativeLocale54={
lastWeek:"'\u04E9\u043D\u0433\u04E9\u0440\u0441\u04E9\u043D' eeee '\u0433\u0430\u0440\u0430\u0433\u0438\u0439\u043D' p '\u0446\u0430\u0433\u0442'",
yesterday:"'\u04E9\u0447\u0438\u0433\u0434\u04E9\u0440' p '\u0446\u0430\u0433\u0442'",
today:"'\u04E9\u043D\u04E9\u04E9\u0434\u04E9\u0440' p '\u0446\u0430\u0433\u0442'",
tomorrow:"'\u043C\u0430\u0440\u0433\u0430\u0430\u0448' p '\u0446\u0430\u0433\u0442'",
nextWeek:"'\u0438\u0440\u044D\u0445' eeee '\u0433\u0430\u0440\u0430\u0433\u0438\u0439\u043D' p '\u0446\u0430\u0433\u0442'",
other:"P"
};
var formatRelative117=function formatRelative117(token,_date,_baseDate,_options){return formatRelativeLocale54[token];};

// lib/locale/mn/_lib/localize.js
var eraValues54={
narrow:["\u041D\u0422\u04E8","\u041D\u0422"],
abbreviated:["\u041D\u0422\u04E8","\u041D\u0422"],
wide:["\u043D\u0438\u0439\u0442\u0438\u0439\u043D \u0442\u043E\u043E\u043B\u043B\u044B\u043D \u04E9\u043C\u043D\u04E9\u0445","\u043D\u0438\u0439\u0442\u0438\u0439\u043D \u0442\u043E\u043E\u043B\u043B\u044B\u043D"]
};
var quarterValues54={
narrow:["I","II","III","IV"],
abbreviated:["I \u0443\u043B\u0438\u0440\u0430\u043B","II \u0443\u043B\u0438\u0440\u0430\u043B","III \u0443\u043B\u0438\u0440\u0430\u043B","IV \u0443\u043B\u0438\u0440\u0430\u043B"],
wide:["1-\u0440 \u0443\u043B\u0438\u0440\u0430\u043B","2-\u0440 \u0443\u043B\u0438\u0440\u0430\u043B","3-\u0440 \u0443\u043B\u0438\u0440\u0430\u043B","4-\u0440 \u0443\u043B\u0438\u0440\u0430\u043B"]
};
var monthValues54={
narrow:[
"I",
"II",
"III",
"IV",
"V",
"VI",
"VII",
"VIII",
"IX",
"X",
"XI",
"XII"],

abbreviated:[
"1-\u0440 \u0441\u0430\u0440",
"2-\u0440 \u0441\u0430\u0440",
"3-\u0440 \u0441\u0430\u0440",
"4-\u0440 \u0441\u0430\u0440",
"5-\u0440 \u0441\u0430\u0440",
"6-\u0440 \u0441\u0430\u0440",
"7-\u0440 \u0441\u0430\u0440",
"8-\u0440 \u0441\u0430\u0440",
"9-\u0440 \u0441\u0430\u0440",
"10-\u0440 \u0441\u0430\u0440",
"11-\u0440 \u0441\u0430\u0440",
"12-\u0440 \u0441\u0430\u0440"],

wide:[
"\u041D\u044D\u0433\u0434\u04AF\u0433\u044D\u044D\u0440 \u0441\u0430\u0440",
"\u0425\u043E\u0451\u0440\u0434\u0443\u0433\u0430\u0430\u0440 \u0441\u0430\u0440",
"\u0413\u0443\u0440\u0430\u0432\u0434\u0443\u0433\u0430\u0430\u0440 \u0441\u0430\u0440",
"\u0414\u04E9\u0440\u04E9\u0432\u0434\u04AF\u0433\u044D\u044D\u0440 \u0441\u0430\u0440",
"\u0422\u0430\u0432\u0434\u0443\u0433\u0430\u0430\u0440 \u0441\u0430\u0440",
"\u0417\u0443\u0440\u0433\u0430\u0430\u0434\u0443\u0433\u0430\u0430\u0440 \u0441\u0430\u0440",
"\u0414\u043E\u043B\u043E\u043E\u0434\u0443\u0433\u0430\u0430\u0440 \u0441\u0430\u0440",
"\u041D\u0430\u0439\u043C\u0434\u0443\u0433\u0430\u0430\u0440 \u0441\u0430\u0440",
"\u0415\u0441\u0434\u04AF\u0433\u044D\u044D\u0440 \u0441\u0430\u0440",
"\u0410\u0440\u0430\u0432\u0434\u0443\u0433\u0430\u0430\u0440 \u0441\u0430\u0440",
"\u0410\u0440\u0432\u0430\u043D\u043D\u044D\u0433\u0434\u04AF\u0433\u044D\u044D\u0440 \u0441\u0430\u0440",
"\u0410\u0440\u0432\u0430\u043D \u0445\u043E\u0451\u0440\u0434\u0443\u0433\u0430\u0430\u0440 \u0441\u0430\u0440"]

};
var formattingMonthValues13={
narrow:[
"I",
"II",
"III",
"IV",
"V",
"VI",
"VII",
"VIII",
"IX",
"X",
"XI",
"XII"],

abbreviated:[
"1-\u0440 \u0441\u0430\u0440",
"2-\u0440 \u0441\u0430\u0440",
"3-\u0440 \u0441\u0430\u0440",
"4-\u0440 \u0441\u0430\u0440",
"5-\u0440 \u0441\u0430\u0440",
"6-\u0440 \u0441\u0430\u0440",
"7-\u0440 \u0441\u0430\u0440",
"8-\u0440 \u0441\u0430\u0440",
"9-\u0440 \u0441\u0430\u0440",
"10-\u0440 \u0441\u0430\u0440",
"11-\u0440 \u0441\u0430\u0440",
"12-\u0440 \u0441\u0430\u0440"],

wide:[
"\u043D\u044D\u0433\u0434\u04AF\u0433\u044D\u044D\u0440 \u0441\u0430\u0440",
"\u0445\u043E\u0451\u0440\u0434\u0443\u0433\u0430\u0430\u0440 \u0441\u0430\u0440",
"\u0433\u0443\u0440\u0430\u0432\u0434\u0443\u0433\u0430\u0430\u0440 \u0441\u0430\u0440",
"\u0434\u04E9\u0440\u04E9\u0432\u0434\u04AF\u0433\u044D\u044D\u0440 \u0441\u0430\u0440",
"\u0442\u0430\u0432\u0434\u0443\u0433\u0430\u0430\u0440 \u0441\u0430\u0440",
"\u0437\u0443\u0440\u0433\u0430\u0430\u0434\u0443\u0433\u0430\u0430\u0440 \u0441\u0430\u0440",
"\u0434\u043E\u043B\u043E\u043E\u0434\u0443\u0433\u0430\u0430\u0440 \u0441\u0430\u0440",
"\u043D\u0430\u0439\u043C\u0434\u0443\u0433\u0430\u0430\u0440 \u0441\u0430\u0440",
"\u0435\u0441\u0434\u04AF\u0433\u044D\u044D\u0440 \u0441\u0430\u0440",
"\u0430\u0440\u0430\u0432\u0434\u0443\u0433\u0430\u0430\u0440 \u0441\u0430\u0440",
"\u0430\u0440\u0432\u0430\u043D\u043D\u044D\u0433\u0434\u04AF\u0433\u044D\u044D\u0440 \u0441\u0430\u0440",
"\u0430\u0440\u0432\u0430\u043D \u0445\u043E\u0451\u0440\u0434\u0443\u0433\u0430\u0430\u0440 \u0441\u0430\u0440"]

};
var dayValues54={
narrow:["\u041D","\u0414","\u041C","\u041B","\u041F","\u0411","\u0411"],
short:["\u041D\u044F","\u0414\u0430","\u041C\u044F","\u041B\u0445","\u041F\u04AF","\u0411\u0430","\u0411\u044F"],
abbreviated:["\u041D\u044F\u043C","\u0414\u0430\u0432","\u041C\u044F\u0433","\u041B\u0445\u0430","\u041F\u04AF\u0440","\u0411\u0430\u0430","\u0411\u044F\u043C"],
wide:["\u041D\u044F\u043C","\u0414\u0430\u0432\u0430\u0430","\u041C\u044F\u0433\u043C\u0430\u0440","\u041B\u0445\u0430\u0433\u0432\u0430","\u041F\u04AF\u0440\u044D\u0432","\u0411\u0430\u0430\u0441\u0430\u043D","\u0411\u044F\u043C\u0431\u0430"]
};
var formattingDayValues4={
narrow:["\u041D","\u0414","\u041C","\u041B","\u041F","\u0411","\u0411"],
short:["\u041D\u044F","\u0414\u0430","\u041C\u044F","\u041B\u0445","\u041F\u04AF","\u0411\u0430","\u0411\u044F"],
abbreviated:["\u041D\u044F\u043C","\u0414\u0430\u0432","\u041C\u044F\u0433","\u041B\u0445\u0430","\u041F\u04AF\u0440","\u0411\u0430\u0430","\u0411\u044F\u043C"],
wide:["\u043D\u044F\u043C","\u0434\u0430\u0432\u0430\u0430","\u043C\u044F\u0433\u043C\u0430\u0440","\u043B\u0445\u0430\u0433\u0432\u0430","\u043F\u04AF\u0440\u044D\u0432","\u0431\u0430\u0430\u0441\u0430\u043D","\u0431\u044F\u043C\u0431\u0430"]
};
var dayPeriodValues54={
narrow:{
am:"\u04AF.\u04E9.",
pm:"\u04AF.\u0445.",
midnight:"\u0448\u04E9\u043D\u04E9 \u0434\u0443\u043D\u0434",
noon:"\u04AF\u0434 \u0434\u0443\u043D\u0434",
morning:"\u04E9\u0433\u043B\u04E9\u04E9",
afternoon:"\u04E9\u0434\u04E9\u0440",
evening:"\u043E\u0440\u043E\u0439",
night:"\u0448\u04E9\u043D\u04E9"
},
abbreviated:{
am:"\u04AF.\u04E9.",
pm:"\u04AF.\u0445.",
midnight:"\u0448\u04E9\u043D\u04E9 \u0434\u0443\u043D\u0434",
noon:"\u04AF\u0434 \u0434\u0443\u043D\u0434",
morning:"\u04E9\u0433\u043B\u04E9\u04E9",
afternoon:"\u04E9\u0434\u04E9\u0440",
evening:"\u043E\u0440\u043E\u0439",
night:"\u0448\u04E9\u043D\u04E9"
},
wide:{
am:"\u04AF.\u04E9.",
pm:"\u04AF.\u0445.",
midnight:"\u0448\u04E9\u043D\u04E9 \u0434\u0443\u043D\u0434",
noon:"\u04AF\u0434 \u0434\u0443\u043D\u0434",
morning:"\u04E9\u0433\u043B\u04E9\u04E9",
afternoon:"\u04E9\u0434\u04E9\u0440",
evening:"\u043E\u0440\u043E\u0439",
night:"\u0448\u04E9\u043D\u04E9"
}
};
var ordinalNumber54=function ordinalNumber54(dirtyNumber,_options){
return String(dirtyNumber);
};
var localize120={
ordinalNumber:ordinalNumber54,
era:buildLocalizeFn({
values:eraValues54,
defaultWidth:"wide"
}),
quarter:buildLocalizeFn({
values:quarterValues54,
defaultWidth:"wide",
argumentCallback:function argumentCallback(quarter){return quarter-1;}
}),
month:buildLocalizeFn({
values:monthValues54,
defaultWidth:"wide",
formattingValues:formattingMonthValues13,
defaultFormattingWidth:"wide"
}),
day:buildLocalizeFn({
values:dayValues54,
defaultWidth:"wide",
formattingValues:formattingDayValues4,
defaultFormattingWidth:"wide"
}),
dayPeriod:buildLocalizeFn({
values:dayPeriodValues54,
defaultWidth:"wide"
})
};

// lib/locale/mn/_lib/match.js
var matchOrdinalNumberPattern53=/\d+/i;
var parseOrdinalNumberPattern53=/\d+/i;
var matchEraPatterns53={
narrow:/^(нтө|нт)/i,
abbreviated:/^(нтө|нт)/i,
wide:/^(нийтийн тооллын өмнө|нийтийн тооллын)/i
};
var parseEraPatterns53={
any:[/^(нтө|нийтийн тооллын өмнө)/i,/^(нт|нийтийн тооллын)/i]
};
var matchQuarterPatterns53={
narrow:/^(iv|iii|ii|i)/i,
abbreviated:/^(iv|iii|ii|i) улирал/i,
wide:/^[1-4]-р улирал/i
};
var parseQuarterPatterns53={
any:[/^(i(\s|$)|1)/i,/^(ii(\s|$)|2)/i,/^(iii(\s|$)|3)/i,/^(iv(\s|$)|4)/i]
};
var matchMonthPatterns53={
narrow:/^(xii|xi|x|ix|viii|vii|vi|v|iv|iii|ii|i)/i,
abbreviated:/^(1-р сар|2-р сар|3-р сар|4-р сар|5-р сар|6-р сар|7-р сар|8-р сар|9-р сар|10-р сар|11-р сар|12-р сар)/i,
wide:/^(нэгдүгээр сар|хоёрдугаар сар|гуравдугаар сар|дөрөвдүгээр сар|тавдугаар сар|зургаадугаар сар|долоодугаар сар|наймдугаар сар|есдүгээр сар|аравдугаар сар|арван нэгдүгээр сар|арван хоёрдугаар сар)/i
};
var parseMonthPatterns53={
narrow:[
/^i$/i,
/^ii$/i,
/^iii$/i,
/^iv$/i,
/^v$/i,
/^vi$/i,
/^vii$/i,
/^viii$/i,
/^ix$/i,
/^x$/i,
/^xi$/i,
/^xii$/i],

any:[
/^(1|нэгдүгээр)/i,
/^(2|хоёрдугаар)/i,
/^(3|гуравдугаар)/i,
/^(4|дөрөвдүгээр)/i,
/^(5|тавдугаар)/i,
/^(6|зургаадугаар)/i,
/^(7|долоодугаар)/i,
/^(8|наймдугаар)/i,
/^(9|есдүгээр)/i,
/^(10|аравдугаар)/i,
/^(11|арван нэгдүгээр)/i,
/^(12|арван хоёрдугаар)/i]

};
var matchDayPatterns53={
narrow:/^[ндмлпбб]/i,
short:/^(ня|да|мя|лх|пү|ба|бя)/i,
abbreviated:/^(ням|дав|мяг|лха|пүр|баа|бям)/i,
wide:/^(ням|даваа|мягмар|лхагва|пүрэв|баасан|бямба)/i
};
var parseDayPatterns53={
narrow:[/^н/i,/^д/i,/^м/i,/^л/i,/^п/i,/^б/i,/^б/i],
any:[/^ня/i,/^да/i,/^мя/i,/^лх/i,/^пү/i,/^ба/i,/^бя/i]
};
var matchDayPeriodPatterns53={
narrow:/^(ү\.ө\.|ү\.х\.|шөнө дунд|үд дунд|өглөө|өдөр|орой|шөнө)/i,
any:/^(ү\.ө\.|ү\.х\.|шөнө дунд|үд дунд|өглөө|өдөр|орой|шөнө)/i
};
var parseDayPeriodPatterns53={
any:{
am:/^ү\.ө\./i,
pm:/^ү\.х\./i,
midnight:/^шөнө дунд/i,
noon:/^үд дунд/i,
morning:/өглөө/i,
afternoon:/өдөр/i,
evening:/орой/i,
night:/шөнө/i
}
};
var match116={
ordinalNumber:buildMatchPatternFn({
matchPattern:matchOrdinalNumberPattern53,
parsePattern:parseOrdinalNumberPattern53,
valueCallback:function valueCallback(value){return parseInt(value,10);}
}),
era:buildMatchFn({
matchPatterns:matchEraPatterns53,
defaultMatchWidth:"wide",
parsePatterns:parseEraPatterns53,
defaultParseWidth:"any"
}),
quarter:buildMatchFn({
matchPatterns:matchQuarterPatterns53,
defaultMatchWidth:"wide",
parsePatterns:parseQuarterPatterns53,
defaultParseWidth:"any",
valueCallback:function valueCallback(index){return index+1;}
}),
month:buildMatchFn({
matchPatterns:matchMonthPatterns53,
defaultMatchWidth:"wide",
parsePatterns:parseMonthPatterns53,
defaultParseWidth:"any"
}),
day:buildMatchFn({
matchPatterns:matchDayPatterns53,
defaultMatchWidth:"wide",
parsePatterns:parseDayPatterns53,
defaultParseWidth:"any"
}),
dayPeriod:buildMatchFn({
matchPatterns:matchDayPeriodPatterns53,
defaultMatchWidth:"any",
parsePatterns:parseDayPeriodPatterns53,
defaultParseWidth:"any"
})
};

// lib/locale/mn.js
var _mn={
code:"mn",
formatDistance:formatDistance117,
formatLong:formatLong125,
formatRelative:formatRelative117,
localize:localize120,
match:match116,
options:{
weekStartsOn:1,
firstWeekContainsDate:1
}
};
// lib/locale/ms/_lib/formatDistance.js
var formatDistanceLocale54={
lessThanXSeconds:{
one:"kurang dari 1 saat",
other:"kurang dari {{count}} saat"
},
xSeconds:{
one:"1 saat",
other:"{{count}} saat"
},
halfAMinute:"setengah minit",
lessThanXMinutes:{
one:"kurang dari 1 minit",
other:"kurang dari {{count}} minit"
},
xMinutes:{
one:"1 minit",
other:"{{count}} minit"
},
aboutXHours:{
one:"sekitar 1 jam",
other:"sekitar {{count}} jam"
},
xHours:{
one:"1 jam",
other:"{{count}} jam"
},
xDays:{
one:"1 hari",
other:"{{count}} hari"
},
aboutXWeeks:{
one:"sekitar 1 minggu",
other:"sekitar {{count}} minggu"
},
xWeeks:{
one:"1 minggu",
other:"{{count}} minggu"
},
aboutXMonths:{
one:"sekitar 1 bulan",
other:"sekitar {{count}} bulan"
},
xMonths:{
one:"1 bulan",
other:"{{count}} bulan"
},
aboutXYears:{
one:"sekitar 1 tahun",
other:"sekitar {{count}} tahun"
},
xYears:{
one:"1 tahun",
other:"{{count}} tahun"
},
overXYears:{
one:"lebih dari 1 tahun",
other:"lebih dari {{count}} tahun"
},
almostXYears:{
one:"hampir 1 tahun",
other:"hampir {{count}} tahun"
}
};
var formatDistance119=function formatDistance119(token,count,options){
var result;
var tokenValue=formatDistanceLocale54[token];
if(typeof tokenValue==="string"){
result=tokenValue;
}else if(count===1){
result=tokenValue.one;
}else{
result=tokenValue.other.replace("{{count}}",String(count));
}
if(options!==null&&options!==void 0&&options.addSuffix){
if(options.comparison&&options.comparison>0){
return"dalam masa "+result;
}else{
return result+" yang lalu";
}
}
return result;
};

// lib/locale/ms/_lib/formatLong.js
var dateFormats63={
full:"EEEE, d MMMM yyyy",
long:"d MMMM yyyy",
medium:"d MMM yyyy",
short:"d/M/yyyy"
};
var timeFormats63={
full:"HH.mm.ss",
long:"HH.mm.ss",
medium:"HH.mm",
short:"HH.mm"
};
var dateTimeFormats63={
full:"{{date}} 'pukul' {{time}}",
long:"{{date}} 'pukul' {{time}}",
medium:"{{date}}, {{time}}",
short:"{{date}}, {{time}}"
};
var formatLong127={
date:buildFormatLongFn({
formats:dateFormats63,
defaultWidth:"full"
}),
time:buildFormatLongFn({
formats:timeFormats63,
defaultWidth:"full"
}),
dateTime:buildFormatLongFn({
formats:dateTimeFormats63,
defaultWidth:"full"
})
};

// lib/locale/ms/_lib/formatRelative.js
var formatRelativeLocale55={
lastWeek:"eeee 'lepas pada jam' p",
yesterday:"'Semalam pada jam' p",
today:"'Hari ini pada jam' p",
tomorrow:"'Esok pada jam' p",
nextWeek:"eeee 'pada jam' p",
other:"P"
};
var formatRelative119=function formatRelative119(token,_date,_baseDate,_options){return formatRelativeLocale55[token];};

// lib/locale/ms/_lib/localize.js
var eraValues55={
narrow:["SM","M"],
abbreviated:["SM","M"],
wide:["Sebelum Masihi","Masihi"]
};
var quarterValues55={
narrow:["1","2","3","4"],
abbreviated:["S1","S2","S3","S4"],
wide:["Suku pertama","Suku kedua","Suku ketiga","Suku keempat"]
};
var monthValues55={
narrow:["J","F","M","A","M","J","J","O","S","O","N","D"],
abbreviated:[
"Jan",
"Feb",
"Mac",
"Apr",
"Mei",
"Jun",
"Jul",
"Ogo",
"Sep",
"Okt",
"Nov",
"Dis"],

wide:[
"Januari",
"Februari",
"Mac",
"April",
"Mei",
"Jun",
"Julai",
"Ogos",
"September",
"Oktober",
"November",
"Disember"]

};
var dayValues55={
narrow:["A","I","S","R","K","J","S"],
short:["Ahd","Isn","Sel","Rab","Kha","Jum","Sab"],
abbreviated:["Ahd","Isn","Sel","Rab","Kha","Jum","Sab"],
wide:["Ahad","Isnin","Selasa","Rabu","Khamis","Jumaat","Sabtu"]
};
var dayPeriodValues55={
narrow:{
am:"am",
pm:"pm",
midnight:"tgh malam",
noon:"tgh hari",
morning:"pagi",
afternoon:"tengah hari",
evening:"petang",
night:"malam"
},
abbreviated:{
am:"AM",
pm:"PM",
midnight:"tengah malam",
noon:"tengah hari",
morning:"pagi",
afternoon:"tengah hari",
evening:"petang",
night:"malam"
},
wide:{
am:"a.m.",
pm:"p.m.",
midnight:"tengah malam",
noon:"tengah hari",
morning:"pagi",
afternoon:"tengah hari",
evening:"petang",
night:"malam"
}
};
var formattingDayPeriodValues45={
narrow:{
am:"am",
pm:"pm",
midnight:"tengah malam",
noon:"tengah hari",
morning:"pagi",
afternoon:"tengah hari",
evening:"petang",
night:"malam"
},
abbreviated:{
am:"AM",
pm:"PM",
midnight:"tengah malam",
noon:"tengah hari",
morning:"pagi",
afternoon:"tengah hari",
evening:"petang",
night:"malam"
},
wide:{
am:"a.m.",
pm:"p.m.",
midnight:"tengah malam",
noon:"tengah hari",
morning:"pagi",
afternoon:"tengah hari",
evening:"petang",
night:"malam"
}
};
var ordinalNumber55=function ordinalNumber55(dirtyNumber,_options){
return"ke-"+Number(dirtyNumber);
};
var localize122={
ordinalNumber:ordinalNumber55,
era:buildLocalizeFn({
values:eraValues55,
defaultWidth:"wide"
}),
quarter:buildLocalizeFn({
values:quarterValues55,
defaultWidth:"wide",
argumentCallback:function argumentCallback(quarter){return quarter-1;}
}),
month:buildLocalizeFn({
values:monthValues55,
defaultWidth:"wide"
}),
day:buildLocalizeFn({
values:dayValues55,
defaultWidth:"wide"
}),
dayPeriod:buildLocalizeFn({
values:dayPeriodValues55,
defaultWidth:"wide",
formattingValues:formattingDayPeriodValues45,
defaultFormattingWidth:"wide"
})
};

// lib/locale/ms/_lib/match.js
var matchOrdinalNumberPattern54=/^ke-(\d+)?/i;
var parseOrdinalNumberPattern54=/petama|\d+/i;
var matchEraPatterns54={
narrow:/^(sm|m)/i,
abbreviated:/^(s\.?\s?m\.?|m\.?)/i,
wide:/^(sebelum masihi|masihi)/i
};
var parseEraPatterns54={
any:[/^s/i,/^(m)/i]
};
var matchQuarterPatterns54={
narrow:/^[1234]/i,
abbreviated:/^S[1234]/i,
wide:/Suku (pertama|kedua|ketiga|keempat)/i
};
var parseQuarterPatterns54={
any:[/pertama|1/i,/kedua|2/i,/ketiga|3/i,/keempat|4/i]
};
var matchMonthPatterns54={
narrow:/^[jfmasond]/i,
abbreviated:/^(jan|feb|mac|apr|mei|jun|jul|ogo|sep|okt|nov|dis)/i,
wide:/^(januari|februari|mac|april|mei|jun|julai|ogos|september|oktober|november|disember)/i
};
var parseMonthPatterns54={
narrow:[
/^j/i,
/^f/i,
/^m/i,
/^a/i,
/^m/i,
/^j/i,
/^j/i,
/^o/i,
/^s/i,
/^o/i,
/^n/i,
/^d/i],

any:[
/^ja/i,
/^f/i,
/^ma/i,
/^ap/i,
/^me/i,
/^jun/i,
/^jul/i,
/^og/i,
/^s/i,
/^ok/i,
/^n/i,
/^d/i]

};
var matchDayPatterns54={
narrow:/^[aisrkj]/i,
short:/^(ahd|isn|sel|rab|kha|jum|sab)/i,
abbreviated:/^(ahd|isn|sel|rab|kha|jum|sab)/i,
wide:/^(ahad|isnin|selasa|rabu|khamis|jumaat|sabtu)/i
};
var parseDayPatterns54={
narrow:[/^a/i,/^i/i,/^s/i,/^r/i,/^k/i,/^j/i,/^s/i],
any:[/^a/i,/^i/i,/^se/i,/^r/i,/^k/i,/^j/i,/^sa/i]
};
var matchDayPeriodPatterns54={
narrow:/^(am|pm|tengah malam|tengah hari|pagi|petang|malam)/i,
any:/^([ap]\.?\s?m\.?|tengah malam|tengah hari|pagi|petang|malam)/i
};
var parseDayPeriodPatterns54={
any:{
am:/^a/i,
pm:/^pm/i,
midnight:/^tengah m/i,
noon:/^tengah h/i,
morning:/pa/i,
afternoon:/tengah h/i,
evening:/pe/i,
night:/m/i
}
};
var match118={
ordinalNumber:buildMatchPatternFn({
matchPattern:matchOrdinalNumberPattern54,
parsePattern:parseOrdinalNumberPattern54,
valueCallback:function valueCallback(value){return parseInt(value,10);}
}),
era:buildMatchFn({
matchPatterns:matchEraPatterns54,
defaultMatchWidth:"wide",
parsePatterns:parseEraPatterns54,
defaultParseWidth:"any"
}),
quarter:buildMatchFn({
matchPatterns:matchQuarterPatterns54,
defaultMatchWidth:"wide",
parsePatterns:parseQuarterPatterns54,
defaultParseWidth:"any",
valueCallback:function valueCallback(index){return index+1;}
}),
month:buildMatchFn({
matchPatterns:matchMonthPatterns54,
defaultMatchWidth:"wide",
parsePatterns:parseMonthPatterns54,
defaultParseWidth:"any"
}),
day:buildMatchFn({
matchPatterns:matchDayPatterns54,
defaultMatchWidth:"wide",
parsePatterns:parseDayPatterns54,
defaultParseWidth:"any"
}),
dayPeriod:buildMatchFn({
matchPatterns:matchDayPeriodPatterns54,
defaultMatchWidth:"any",
parsePatterns:parseDayPeriodPatterns54,
defaultParseWidth:"any"
})
};

// lib/locale/ms.js
var _ms={
code:"ms",
formatDistance:formatDistance119,
formatLong:formatLong127,
formatRelative:formatRelative119,
localize:localize122,
match:match118,
options:{
weekStartsOn:1,
firstWeekContainsDate:1
}
};
// lib/locale/mt/_lib/formatDistance.js
var formatDistanceLocale55={
lessThanXSeconds:{
one:"inqas minn sekonda",
other:"inqas minn {{count}} sekondi"
},
xSeconds:{
one:"sekonda",
other:"{{count}} sekondi"
},
halfAMinute:"nofs minuta",
lessThanXMinutes:{
one:"inqas minn minuta",
other:"inqas minn {{count}} minuti"
},
xMinutes:{
one:"minuta",
other:"{{count}} minuti"
},
aboutXHours:{
one:"madwar sieg\u0127a",
other:"madwar {{count}} sieg\u0127at"
},
xHours:{
one:"sieg\u0127a",
other:"{{count}} sieg\u0127at"
},
xDays:{
one:"\u0121urnata",
other:"{{count}} \u0121ranet"
},
aboutXWeeks:{
one:"madwar \u0121img\u0127a",
other:"madwar {{count}} \u0121img\u0127at"
},
xWeeks:{
one:"\u0121img\u0127a",
other:"{{count}} \u0121img\u0127at"
},
aboutXMonths:{
one:"madwar xahar",
other:"madwar {{count}} xhur"
},
xMonths:{
one:"xahar",
other:"{{count}} xhur"
},
aboutXYears:{
one:"madwar sena",
two:"madwar sentejn",
other:"madwar {{count}} snin"
},
xYears:{
one:"sena",
two:"sentejn",
other:"{{count}} snin"
},
overXYears:{
one:"aktar minn sena",
two:"aktar minn sentejn",
other:"aktar minn {{count}} snin"
},
almostXYears:{
one:"kwa\u017Ci sena",
two:"kwa\u017Ci sentejn",
other:"kwa\u017Ci {{count}} snin"
}
};
var formatDistance121=function formatDistance121(token,count,options){
var result;
var tokenValue=formatDistanceLocale55[token];
if(typeof tokenValue==="string"){
result=tokenValue;
}else if(count===1){
result=tokenValue.one;
}else if(count===2&&tokenValue.two){
result=tokenValue.two;
}else{
result=tokenValue.other.replace("{{count}}",String(count));
}
if(options!==null&&options!==void 0&&options.addSuffix){
if(options.comparison&&options.comparison>0){
return"f'"+result;
}else{
return result+" ilu";
}
}
return result;
};

// lib/locale/mt/_lib/formatLong.js
var dateFormats64={
full:"EEEE, d MMMM yyyy",
long:"d MMMM yyyy",
medium:"d MMM yyyy",
short:"dd/MM/yyyy"
};
var timeFormats64={
full:"HH:mm:ss zzzz",
long:"HH:mm:ss z",
medium:"HH:mm:ss",
short:"HH:mm"
};
var dateTimeFormats64={
full:"{{date}} {{time}}",
long:"{{date}} {{time}}",
medium:"{{date}} {{time}}",
short:"{{date}} {{time}}"
};
var formatLong129={
date:buildFormatLongFn({
formats:dateFormats64,
defaultWidth:"full"
}),
time:buildFormatLongFn({
formats:timeFormats64,
defaultWidth:"full"
}),
dateTime:buildFormatLongFn({
formats:dateTimeFormats64,
defaultWidth:"full"
})
};

// lib/locale/mt/_lib/formatRelative.js
var formatRelativeLocale56={
lastWeek:"eeee 'li g\u0127adda' 'fil-'p",
yesterday:"'Il-biera\u0127 fil-'p",
today:"'Illum fil-'p",
tomorrow:"'G\u0127ada fil-'p",
nextWeek:"eeee 'fil-'p",
other:"P"
};
var formatRelative121=function formatRelative121(token,_date,_baseDate,_options){return formatRelativeLocale56[token];};

// lib/locale/mt/_lib/localize.js
var eraValues56={
narrow:["Q","W"],
abbreviated:["QK","WK"],
wide:["qabel Kristu","wara Kristu"]
};
var quarterValues56={
narrow:["1","2","3","4"],
abbreviated:["K1","K2","K3","K4"],
wide:["1. kwart","2. kwart","3. kwart","4. kwart"]
};
var monthValues56={
narrow:["J","F","M","A","M","\u0120","L","A","S","O","N","D"],
abbreviated:[
"Jan",
"Fra",
"Mar",
"Apr",
"Mej",
"\u0120un",
"Lul",
"Aww",
"Set",
"Ott",
"Nov",
"Di\u010B"],

wide:[
"Jannar",
"Frar",
"Marzu",
"April",
"Mejju",
"\u0120unju",
"Lulju",
"Awwissu",
"Settembru",
"Ottubru",
"Novembru",
"Di\u010Bembru"]

};
var dayValues56={
narrow:["\u0126","T","T","E","\u0126","\u0120","S"],
short:["\u0126a","Tn","Tl","Er","\u0126a","\u0120i","Si"],
abbreviated:["\u0126ad","Tne","Tli","Erb","\u0126am","\u0120im","Sib"],
wide:[
"Il-\u0126add",
"It-Tnejn",
"It-Tlieta",
"L-Erbg\u0127a",
"Il-\u0126amis",
"Il-\u0120img\u0127a",
"Is-Sibt"]

};
var dayPeriodValues56={
narrow:{
am:"a",
pm:"p",
midnight:"nofsillejl",
noon:"nofsinhar",
morning:"g\u0127odwa",
afternoon:"wara nofsinhar",
evening:"filg\u0127axija",
night:"lejl"
},
abbreviated:{
am:"AM",
pm:"PM",
midnight:"nofsillejl",
noon:"nofsinhar",
morning:"g\u0127odwa",
afternoon:"wara nofsinhar",
evening:"filg\u0127axija",
night:"lejl"
},
wide:{
am:"a.m.",
pm:"p.m.",
midnight:"nofsillejl",
noon:"nofsinhar",
morning:"g\u0127odwa",
afternoon:"wara nofsinhar",
evening:"filg\u0127axija",
night:"lejl"
}
};
var formattingDayPeriodValues46={
narrow:{
am:"a",
pm:"p",
midnight:"f'nofsillejl",
noon:"f'nofsinhar",
morning:"filg\u0127odu",
afternoon:"wara nofsinhar",
evening:"filg\u0127axija",
night:"billejl"
},
abbreviated:{
am:"AM",
pm:"PM",
midnight:"f'nofsillejl",
noon:"f'nofsinhar",
morning:"filg\u0127odu",
afternoon:"wara nofsinhar",
evening:"filg\u0127axija",
night:"billejl"
},
wide:{
am:"a.m.",
pm:"p.m.",
midnight:"f'nofsillejl",
noon:"f'nofsinhar",
morning:"filg\u0127odu",
afternoon:"wara nofsinhar",
evening:"filg\u0127axija",
night:"billejl"
}
};
var ordinalNumber56=function ordinalNumber56(dirtyNumber,_options){
var number=Number(dirtyNumber);
return number+"\xBA";
};
var localize124={
ordinalNumber:ordinalNumber56,
era:buildLocalizeFn({
values:eraValues56,
defaultWidth:"wide"
}),
quarter:buildLocalizeFn({
values:quarterValues56,
defaultWidth:"wide",
argumentCallback:function argumentCallback(quarter){return quarter-1;}
}),
month:buildLocalizeFn({
values:monthValues56,
defaultWidth:"wide"
}),
day:buildLocalizeFn({
values:dayValues56,
defaultWidth:"wide"
}),
dayPeriod:buildLocalizeFn({
values:dayPeriodValues56,
defaultWidth:"wide",
formattingValues:formattingDayPeriodValues46,
defaultFormattingWidth:"wide"
})
};

// lib/locale/mt/_lib/match.js
var matchOrdinalNumberPattern55=/^(\d+)(º)?/i;
var parseOrdinalNumberPattern55=/\d+/i;
var matchEraPatterns55={
narrow:/^(q|w)/i,
abbreviated:/^(q\.?\s?k\.?|b\.?\s?c\.?\s?e\.?|w\.?\s?k\.?)/i,
wide:/^(qabel kristu|before common era|wara kristu|common era)/i
};
var parseEraPatterns55={
any:[/^(q|b)/i,/^(w|c)/i]
};
var matchQuarterPatterns55={
narrow:/^[1234]/i,
abbreviated:/^k[1234]/i,
wide:/^[1234](\.)? kwart/i
};
var parseQuarterPatterns55={
any:[/1/i,/2/i,/3/i,/4/i]
};
var matchMonthPatterns55={
narrow:/^[jfmaglsond]/i,
abbreviated:/^(jan|fra|mar|apr|mej|ġun|lul|aww|set|ott|nov|diċ)/i,
wide:/^(jannar|frar|marzu|april|mejju|ġunju|lulju|awwissu|settembru|ottubru|novembru|diċembru)/i
};
var parseMonthPatterns55={
narrow:[
/^j/i,
/^f/i,
/^m/i,
/^a/i,
/^m/i,
/^ġ/i,
/^l/i,
/^a/i,
/^s/i,
/^o/i,
/^n/i,
/^d/i],

any:[
/^ja/i,
/^f/i,
/^mar/i,
/^ap/i,
/^mej/i,
/^ġ/i,
/^l/i,
/^aw/i,
/^s/i,
/^o/i,
/^n/i,
/^d/i]

};
var matchDayPatterns55={
narrow:/^[ħteġs]/i,
short:/^(ħa|tn|tl|er|ħa|ġi|si)/i,
abbreviated:/^(ħad|tne|tli|erb|ħam|ġim|sib)/i,
wide:/^(il-ħadd|it-tnejn|it-tlieta|l-erbgħa|il-ħamis|il-ġimgħa|is-sibt)/i
};
var parseDayPatterns55={
narrow:[/^ħ/i,/^t/i,/^t/i,/^e/i,/^ħ/i,/^ġ/i,/^s/i],
any:[
/^(il-)?ħad/i,
/^(it-)?tn/i,
/^(it-)?tl/i,
/^(l-)?er/i,
/^(il-)?ham/i,
/^(il-)?ġi/i,
/^(is-)?si/i]

};
var matchDayPeriodPatterns55={
narrow:/^(a|p|f'nofsillejl|f'nofsinhar|(ta') (għodwa|wara nofsinhar|filgħaxija|lejl))/i,
any:/^([ap]\.?\s?m\.?|f'nofsillejl|f'nofsinhar|(ta') (għodwa|wara nofsinhar|filgħaxija|lejl))/i
};
var parseDayPeriodPatterns55={
any:{
am:/^a/i,
pm:/^p/i,
midnight:/^f'nofsillejl/i,
noon:/^f'nofsinhar/i,
morning:/għodwa/i,
afternoon:/wara(\s.*)nofsinhar/i,
evening:/filgħaxija/i,
night:/lejl/i
}
};
var match120={
ordinalNumber:buildMatchPatternFn({
matchPattern:matchOrdinalNumberPattern55,
parsePattern:parseOrdinalNumberPattern55,
valueCallback:function valueCallback(value){return parseInt(value,10);}
}),
era:buildMatchFn({
matchPatterns:matchEraPatterns55,
defaultMatchWidth:"wide",
parsePatterns:parseEraPatterns55,
defaultParseWidth:"any"
}),
quarter:buildMatchFn({
matchPatterns:matchQuarterPatterns55,
defaultMatchWidth:"wide",
parsePatterns:parseQuarterPatterns55,
defaultParseWidth:"any",
valueCallback:function valueCallback(index){return index+1;}
}),
month:buildMatchFn({
matchPatterns:matchMonthPatterns55,
defaultMatchWidth:"wide",
parsePatterns:parseMonthPatterns55,
defaultParseWidth:"any"
}),
day:buildMatchFn({
matchPatterns:matchDayPatterns55,
defaultMatchWidth:"wide",
parsePatterns:parseDayPatterns55,
defaultParseWidth:"any"
}),
dayPeriod:buildMatchFn({
matchPatterns:matchDayPeriodPatterns55,
defaultMatchWidth:"any",
parsePatterns:parseDayPeriodPatterns55,
defaultParseWidth:"any"
})
};

// lib/locale/mt.js
var _mt={
code:"mt",
formatDistance:formatDistance121,
formatLong:formatLong129,
formatRelative:formatRelative121,
localize:localize124,
match:match120,
options:{
weekStartsOn:1,
firstWeekContainsDate:4
}
};
// lib/locale/nb/_lib/formatDistance.js
var formatDistanceLocale56={
lessThanXSeconds:{
one:"mindre enn ett sekund",
other:"mindre enn {{count}} sekunder"
},
xSeconds:{
one:"ett sekund",
other:"{{count}} sekunder"
},
halfAMinute:"et halvt minutt",
lessThanXMinutes:{
one:"mindre enn ett minutt",
other:"mindre enn {{count}} minutter"
},
xMinutes:{
one:"ett minutt",
other:"{{count}} minutter"
},
aboutXHours:{
one:"omtrent en time",
other:"omtrent {{count}} timer"
},
xHours:{
one:"en time",
other:"{{count}} timer"
},
xDays:{
one:"en dag",
other:"{{count}} dager"
},
aboutXWeeks:{
one:"omtrent en uke",
other:"omtrent {{count}} uker"
},
xWeeks:{
one:"en uke",
other:"{{count}} uker"
},
aboutXMonths:{
one:"omtrent en m\xE5ned",
other:"omtrent {{count}} m\xE5neder"
},
xMonths:{
one:"en m\xE5ned",
other:"{{count}} m\xE5neder"
},
aboutXYears:{
one:"omtrent ett \xE5r",
other:"omtrent {{count}} \xE5r"
},
xYears:{
one:"ett \xE5r",
other:"{{count}} \xE5r"
},
overXYears:{
one:"over ett \xE5r",
other:"over {{count}} \xE5r"
},
almostXYears:{
one:"nesten ett \xE5r",
other:"nesten {{count}} \xE5r"
}
};
var formatDistance123=function formatDistance123(token,count,options){
var result;
var tokenValue=formatDistanceLocale56[token];
if(typeof tokenValue==="string"){
result=tokenValue;
}else if(count===1){
result=tokenValue.one;
}else{
result=tokenValue.other.replace("{{count}}",String(count));
}
if(options!==null&&options!==void 0&&options.addSuffix){
if(options.comparison&&options.comparison>0){
return"om "+result;
}else{
return result+" siden";
}
}
return result;
};

// lib/locale/nb/_lib/formatLong.js
var dateFormats65={
full:"EEEE d. MMMM y",
long:"d. MMMM y",
medium:"d. MMM y",
short:"dd.MM.y"
};
var timeFormats65={
full:"'kl'. HH:mm:ss zzzz",
long:"HH:mm:ss z",
medium:"HH:mm:ss",
short:"HH:mm"
};
var dateTimeFormats65={
full:"{{date}} 'kl.' {{time}}",
long:"{{date}} 'kl.' {{time}}",
medium:"{{date}} {{time}}",
short:"{{date}} {{time}}"
};
var formatLong131={
date:buildFormatLongFn({
formats:dateFormats65,
defaultWidth:"full"
}),
time:buildFormatLongFn({
formats:timeFormats65,
defaultWidth:"full"
}),
dateTime:buildFormatLongFn({
formats:dateTimeFormats65,
defaultWidth:"full"
})
};

// lib/locale/nb/_lib/formatRelative.js
var formatRelativeLocale57={
lastWeek:"'forrige' eeee 'kl.' p",
yesterday:"'i g\xE5r kl.' p",
today:"'i dag kl.' p",
tomorrow:"'i morgen kl.' p",
nextWeek:"EEEE 'kl.' p",
other:"P"
};
var formatRelative123=function formatRelative123(token,_date,_baseDate,_options){return formatRelativeLocale57[token];};

// lib/locale/nb/_lib/localize.js
var eraValues57={
narrow:["f.Kr.","e.Kr."],
abbreviated:["f.Kr.","e.Kr."],
wide:["f\xF8r Kristus","etter Kristus"]
};
var quarterValues57={
narrow:["1","2","3","4"],
abbreviated:["Q1","Q2","Q3","Q4"],
wide:["1. kvartal","2. kvartal","3. kvartal","4. kvartal"]
};
var monthValues57={
narrow:["J","F","M","A","M","J","J","A","S","O","N","D"],
abbreviated:[
"jan.",
"feb.",
"mars",
"apr.",
"mai",
"juni",
"juli",
"aug.",
"sep.",
"okt.",
"nov.",
"des."],

wide:[
"januar",
"februar",
"mars",
"april",
"mai",
"juni",
"juli",
"august",
"september",
"oktober",
"november",
"desember"]

};
var dayValues57={
narrow:["S","M","T","O","T","F","L"],
short:["s\xF8","ma","ti","on","to","fr","l\xF8"],
abbreviated:["s\xF8n","man","tir","ons","tor","fre","l\xF8r"],
wide:[
"s\xF8ndag",
"mandag",
"tirsdag",
"onsdag",
"torsdag",
"fredag",
"l\xF8rdag"]

};
var dayPeriodValues57={
narrow:{
am:"a",
pm:"p",
midnight:"midnatt",
noon:"middag",
morning:"p\xE5 morg.",
afternoon:"p\xE5 etterm.",
evening:"p\xE5 kvelden",
night:"p\xE5 natten"
},
abbreviated:{
am:"a.m.",
pm:"p.m.",
midnight:"midnatt",
noon:"middag",
morning:"p\xE5 morg.",
afternoon:"p\xE5 etterm.",
evening:"p\xE5 kvelden",
night:"p\xE5 natten"
},
wide:{
am:"a.m.",
pm:"p.m.",
midnight:"midnatt",
noon:"middag",
morning:"p\xE5 morgenen",
afternoon:"p\xE5 ettermiddagen",
evening:"p\xE5 kvelden",
night:"p\xE5 natten"
}
};
var ordinalNumber57=function ordinalNumber57(dirtyNumber,_options){
var number=Number(dirtyNumber);
return number+".";
};
var localize126={
ordinalNumber:ordinalNumber57,
era:buildLocalizeFn({
values:eraValues57,
defaultWidth:"wide"
}),
quarter:buildLocalizeFn({
values:quarterValues57,
defaultWidth:"wide",
argumentCallback:function argumentCallback(quarter){return quarter-1;}
}),
month:buildLocalizeFn({
values:monthValues57,
defaultWidth:"wide"
}),
day:buildLocalizeFn({
values:dayValues57,
defaultWidth:"wide"
}),
dayPeriod:buildLocalizeFn({
values:dayPeriodValues57,
defaultWidth:"wide"
})
};

// lib/locale/nb/_lib/match.js
var matchOrdinalNumberPattern56=/^(\d+)\.?/i;
var parseOrdinalNumberPattern56=/\d+/i;
var matchEraPatterns56={
narrow:/^(f\.? ?Kr\.?|fvt\.?|e\.? ?Kr\.?|evt\.?)/i,
abbreviated:/^(f\.? ?Kr\.?|fvt\.?|e\.? ?Kr\.?|evt\.?)/i,
wide:/^(før Kristus|før vår tid|etter Kristus|vår tid)/i
};
var parseEraPatterns56={
any:[/^f/i,/^e/i]
};
var matchQuarterPatterns56={
narrow:/^[1234]/i,
abbreviated:/^q[1234]/i,
wide:/^[1234](\.)? kvartal/i
};
var parseQuarterPatterns56={
any:[/1/i,/2/i,/3/i,/4/i]
};
var matchMonthPatterns56={
narrow:/^[jfmasond]/i,
abbreviated:/^(jan|feb|mars?|apr|mai|juni?|juli?|aug|sep|okt|nov|des)\.?/i,
wide:/^(januar|februar|mars|april|mai|juni|juli|august|september|oktober|november|desember)/i
};
var parseMonthPatterns56={
narrow:[
/^j/i,
/^f/i,
/^m/i,
/^a/i,
/^m/i,
/^j/i,
/^j/i,
/^a/i,
/^s/i,
/^o/i,
/^n/i,
/^d/i],

any:[
/^ja/i,
/^f/i,
/^mar/i,
/^ap/i,
/^mai/i,
/^jun/i,
/^jul/i,
/^aug/i,
/^s/i,
/^o/i,
/^n/i,
/^d/i]

};
var matchDayPatterns56={
narrow:/^[smtofl]/i,
short:/^(sø|ma|ti|on|to|fr|lø)/i,
abbreviated:/^(søn|man|tir|ons|tor|fre|lør)/i,
wide:/^(søndag|mandag|tirsdag|onsdag|torsdag|fredag|lørdag)/i
};
var parseDayPatterns56={
any:[/^s/i,/^m/i,/^ti/i,/^o/i,/^to/i,/^f/i,/^l/i]
};
var matchDayPeriodPatterns56={
narrow:/^(midnatt|middag|(på) (morgenen|ettermiddagen|kvelden|natten)|[ap])/i,
any:/^([ap]\.?\s?m\.?|midnatt|middag|(på) (morgenen|ettermiddagen|kvelden|natten))/i
};
var parseDayPeriodPatterns56={
any:{
am:/^a(\.?\s?m\.?)?$/i,
pm:/^p(\.?\s?m\.?)?$/i,
midnight:/^midn/i,
noon:/^midd/i,
morning:/morgen/i,
afternoon:/ettermiddag/i,
evening:/kveld/i,
night:/natt/i
}
};
var match122={
ordinalNumber:buildMatchPatternFn({
matchPattern:matchOrdinalNumberPattern56,
parsePattern:parseOrdinalNumberPattern56,
valueCallback:function valueCallback(value){return parseInt(value,10);}
}),
era:buildMatchFn({
matchPatterns:matchEraPatterns56,
defaultMatchWidth:"wide",
parsePatterns:parseEraPatterns56,
defaultParseWidth:"any"
}),
quarter:buildMatchFn({
matchPatterns:matchQuarterPatterns56,
defaultMatchWidth:"wide",
parsePatterns:parseQuarterPatterns56,
defaultParseWidth:"any",
valueCallback:function valueCallback(index){return index+1;}
}),
month:buildMatchFn({
matchPatterns:matchMonthPatterns56,
defaultMatchWidth:"wide",
parsePatterns:parseMonthPatterns56,
defaultParseWidth:"any"
}),
day:buildMatchFn({
matchPatterns:matchDayPatterns56,
defaultMatchWidth:"wide",
parsePatterns:parseDayPatterns56,
defaultParseWidth:"any"
}),
dayPeriod:buildMatchFn({
matchPatterns:matchDayPeriodPatterns56,
defaultMatchWidth:"any",
parsePatterns:parseDayPeriodPatterns56,
defaultParseWidth:"any"
})
};

// lib/locale/nb.js
var _nb={
code:"nb",
formatDistance:formatDistance123,
formatLong:formatLong131,
formatRelative:formatRelative123,
localize:localize126,
match:match122,
options:{
weekStartsOn:1,
firstWeekContainsDate:4
}
};
// lib/locale/nl/_lib/formatDistance.js
var formatDistanceLocale57={
lessThanXSeconds:{
one:"minder dan een seconde",
other:"minder dan {{count}} seconden"
},
xSeconds:{
one:"1 seconde",
other:"{{count}} seconden"
},
halfAMinute:"een halve minuut",
lessThanXMinutes:{
one:"minder dan een minuut",
other:"minder dan {{count}} minuten"
},
xMinutes:{
one:"een minuut",
other:"{{count}} minuten"
},
aboutXHours:{
one:"ongeveer 1 uur",
other:"ongeveer {{count}} uur"
},
xHours:{
one:"1 uur",
other:"{{count}} uur"
},
xDays:{
one:"1 dag",
other:"{{count}} dagen"
},
aboutXWeeks:{
one:"ongeveer 1 week",
other:"ongeveer {{count}} weken"
},
xWeeks:{
one:"1 week",
other:"{{count}} weken"
},
aboutXMonths:{
one:"ongeveer 1 maand",
other:"ongeveer {{count}} maanden"
},
xMonths:{
one:"1 maand",
other:"{{count}} maanden"
},
aboutXYears:{
one:"ongeveer 1 jaar",
other:"ongeveer {{count}} jaar"
},
xYears:{
one:"1 jaar",
other:"{{count}} jaar"
},
overXYears:{
one:"meer dan 1 jaar",
other:"meer dan {{count}} jaar"
},
almostXYears:{
one:"bijna 1 jaar",
other:"bijna {{count}} jaar"
}
};
var formatDistance125=function formatDistance125(token,count,options){
var result;
var tokenValue=formatDistanceLocale57[token];
if(typeof tokenValue==="string"){
result=tokenValue;
}else if(count===1){
result=tokenValue.one;
}else{
result=tokenValue.other.replace("{{count}}",String(count));
}
if(options!==null&&options!==void 0&&options.addSuffix){
if(options.comparison&&options.comparison>0){
return"over "+result;
}else{
return result+" geleden";
}
}
return result;
};

// lib/locale/nl/_lib/formatLong.js
var dateFormats66={
full:"EEEE d MMMM y",
long:"d MMMM y",
medium:"d MMM y",
short:"dd-MM-y"
};
var timeFormats66={
full:"HH:mm:ss zzzz",
long:"HH:mm:ss z",
medium:"HH:mm:ss",
short:"HH:mm"
};
var dateTimeFormats66={
full:"{{date}} 'om' {{time}}",
long:"{{date}} 'om' {{time}}",
medium:"{{date}}, {{time}}",
short:"{{date}}, {{time}}"
};
var formatLong133={
date:buildFormatLongFn({
formats:dateFormats66,
defaultWidth:"full"
}),
time:buildFormatLongFn({
formats:timeFormats66,
defaultWidth:"full"
}),
dateTime:buildFormatLongFn({
formats:dateTimeFormats66,
defaultWidth:"full"
})
};

// lib/locale/nl/_lib/formatRelative.js
var formatRelativeLocale58={
lastWeek:"'afgelopen' eeee 'om' p",
yesterday:"'gisteren om' p",
today:"'vandaag om' p",
tomorrow:"'morgen om' p",
nextWeek:"eeee 'om' p",
other:"P"
};
var formatRelative125=function formatRelative125(token,_date,_baseDate,_options){return formatRelativeLocale58[token];};

// lib/locale/nl/_lib/localize.js
var eraValues58={
narrow:["v.C.","n.C."],
abbreviated:["v.Chr.","n.Chr."],
wide:["voor Christus","na Christus"]
};
var quarterValues58={
narrow:["1","2","3","4"],
abbreviated:["K1","K2","K3","K4"],
wide:["1e kwartaal","2e kwartaal","3e kwartaal","4e kwartaal"]
};
var monthValues58={
narrow:["J","F","M","A","M","J","J","A","S","O","N","D"],
abbreviated:[
"jan.",
"feb.",
"mrt.",
"apr.",
"mei",
"jun.",
"jul.",
"aug.",
"sep.",
"okt.",
"nov.",
"dec."],

wide:[
"januari",
"februari",
"maart",
"april",
"mei",
"juni",
"juli",
"augustus",
"september",
"oktober",
"november",
"december"]

};
var dayValues58={
narrow:["Z","M","D","W","D","V","Z"],
short:["zo","ma","di","wo","do","vr","za"],
abbreviated:["zon","maa","din","woe","don","vri","zat"],
wide:[
"zondag",
"maandag",
"dinsdag",
"woensdag",
"donderdag",
"vrijdag",
"zaterdag"]

};
var dayPeriodValues58={
narrow:{
am:"AM",
pm:"PM",
midnight:"middernacht",
noon:"het middaguur",
morning:"'s ochtends",
afternoon:"'s middags",
evening:"'s avonds",
night:"'s nachts"
},
abbreviated:{
am:"AM",
pm:"PM",
midnight:"middernacht",
noon:"het middaguur",
morning:"'s ochtends",
afternoon:"'s middags",
evening:"'s avonds",
night:"'s nachts"
},
wide:{
am:"AM",
pm:"PM",
midnight:"middernacht",
noon:"het middaguur",
morning:"'s ochtends",
afternoon:"'s middags",
evening:"'s avonds",
night:"'s nachts"
}
};
var ordinalNumber58=function ordinalNumber58(dirtyNumber,_options){
var number=Number(dirtyNumber);
return number+"e";
};
var localize128={
ordinalNumber:ordinalNumber58,
era:buildLocalizeFn({
values:eraValues58,
defaultWidth:"wide"
}),
quarter:buildLocalizeFn({
values:quarterValues58,
defaultWidth:"wide",
argumentCallback:function argumentCallback(quarter){return quarter-1;}
}),
month:buildLocalizeFn({
values:monthValues58,
defaultWidth:"wide"
}),
day:buildLocalizeFn({
values:dayValues58,
defaultWidth:"wide"
}),
dayPeriod:buildLocalizeFn({
values:dayPeriodValues58,
defaultWidth:"wide"
})
};

// lib/locale/nl/_lib/match.js
var matchOrdinalNumberPattern57=/^(\d+)e?/i;
var parseOrdinalNumberPattern57=/\d+/i;
var matchEraPatterns57={
narrow:/^([vn]\.? ?C\.?)/,
abbreviated:/^([vn]\. ?Chr\.?)/,
wide:/^((voor|na) Christus)/
};
var parseEraPatterns57={
any:[/^v/,/^n/]
};
var matchQuarterPatterns57={
narrow:/^[1234]/i,
abbreviated:/^K[1234]/i,
wide:/^[1234]e kwartaal/i
};
var parseQuarterPatterns57={
any:[/1/i,/2/i,/3/i,/4/i]
};
var matchMonthPatterns57={
narrow:/^[jfmasond]/i,
abbreviated:/^(jan.|feb.|mrt.|apr.|mei|jun.|jul.|aug.|sep.|okt.|nov.|dec.)/i,
wide:/^(januari|februari|maart|april|mei|juni|juli|augustus|september|oktober|november|december)/i
};
var parseMonthPatterns57={
narrow:[
/^j/i,
/^f/i,
/^m/i,
/^a/i,
/^m/i,
/^j/i,
/^j/i,
/^a/i,
/^s/i,
/^o/i,
/^n/i,
/^d/i],

any:[
/^jan/i,
/^feb/i,
/^m(r|a)/i,
/^apr/i,
/^mei/i,
/^jun/i,
/^jul/i,
/^aug/i,
/^sep/i,
/^okt/i,
/^nov/i,
/^dec/i]

};
var matchDayPatterns57={
narrow:/^[zmdwv]/i,
short:/^(zo|ma|di|wo|do|vr|za)/i,
abbreviated:/^(zon|maa|din|woe|don|vri|zat)/i,
wide:/^(zondag|maandag|dinsdag|woensdag|donderdag|vrijdag|zaterdag)/i
};
var parseDayPatterns57={
narrow:[/^z/i,/^m/i,/^d/i,/^w/i,/^d/i,/^v/i,/^z/i],
any:[/^zo/i,/^ma/i,/^di/i,/^wo/i,/^do/i,/^vr/i,/^za/i]
};
var matchDayPeriodPatterns57={
any:/^(am|pm|middernacht|het middaguur|'s (ochtends|middags|avonds|nachts))/i
};
var parseDayPeriodPatterns57={
any:{
am:/^am/i,
pm:/^pm/i,
midnight:/^middernacht/i,
noon:/^het middaguur/i,
morning:/ochtend/i,
afternoon:/middag/i,
evening:/avond/i,
night:/nacht/i
}
};
var match124={
ordinalNumber:buildMatchPatternFn({
matchPattern:matchOrdinalNumberPattern57,
parsePattern:parseOrdinalNumberPattern57,
valueCallback:function valueCallback(value){return parseInt(value,10);}
}),
era:buildMatchFn({
matchPatterns:matchEraPatterns57,
defaultMatchWidth:"wide",
parsePatterns:parseEraPatterns57,
defaultParseWidth:"any"
}),
quarter:buildMatchFn({
matchPatterns:matchQuarterPatterns57,
defaultMatchWidth:"wide",
parsePatterns:parseQuarterPatterns57,
defaultParseWidth:"any",
valueCallback:function valueCallback(index){return index+1;}
}),
month:buildMatchFn({
matchPatterns:matchMonthPatterns57,
defaultMatchWidth:"wide",
parsePatterns:parseMonthPatterns57,
defaultParseWidth:"any"
}),
day:buildMatchFn({
matchPatterns:matchDayPatterns57,
defaultMatchWidth:"wide",
parsePatterns:parseDayPatterns57,
defaultParseWidth:"any"
}),
dayPeriod:buildMatchFn({
matchPatterns:matchDayPeriodPatterns57,
defaultMatchWidth:"any",
parsePatterns:parseDayPeriodPatterns57,
defaultParseWidth:"any"
})
};

// lib/locale/nl.js
var _nl={
code:"nl",
formatDistance:formatDistance125,
formatLong:formatLong133,
formatRelative:formatRelative125,
localize:localize128,
match:match124,
options:{
weekStartsOn:1,
firstWeekContainsDate:4
}
};
// lib/locale/nl-BE/_lib/formatDistance.js
var formatDistanceLocale58={
lessThanXSeconds:{
one:"minder dan een seconde",
other:"minder dan {{count}} seconden"
},
xSeconds:{
one:"1 seconde",
other:"{{count}} seconden"
},
halfAMinute:"een halve minuut",
lessThanXMinutes:{
one:"minder dan een minuut",
other:"minder dan {{count}} minuten"
},
xMinutes:{
one:"een minuut",
other:"{{count}} minuten"
},
aboutXHours:{
one:"ongeveer 1 uur",
other:"ongeveer {{count}} uur"
},
xHours:{
one:"1 uur",
other:"{{count}} uur"
},
xDays:{
one:"1 dag",
other:"{{count}} dagen"
},
aboutXWeeks:{
one:"ongeveer 1 week",
other:"ongeveer {{count}} weken"
},
xWeeks:{
one:"1 week",
other:"{{count}} weken"
},
aboutXMonths:{
one:"ongeveer 1 maand",
other:"ongeveer {{count}} maanden"
},
xMonths:{
one:"1 maand",
other:"{{count}} maanden"
},
aboutXYears:{
one:"ongeveer 1 jaar",
other:"ongeveer {{count}} jaar"
},
xYears:{
one:"1 jaar",
other:"{{count}} jaar"
},
overXYears:{
one:"meer dan 1 jaar",
other:"meer dan {{count}} jaar"
},
almostXYears:{
one:"bijna 1 jaar",
other:"bijna {{count}} jaar"
}
};
var formatDistance127=function formatDistance127(token,count,options){
var result;
var tokenValue=formatDistanceLocale58[token];
if(typeof tokenValue==="string"){
result=tokenValue;
}else if(count===1){
result=tokenValue.one;
}else{
result=tokenValue.other.replace("{{count}}",String(count));
}
if(options!==null&&options!==void 0&&options.addSuffix){
if(options.comparison&&options.comparison>0){
return"over "+result;
}else{
return result+" geleden";
}
}
return result;
};

// lib/locale/nl-BE/_lib/formatLong.js
var dateFormats67={
full:"EEEE d MMMM y",
long:"d MMMM y",
medium:"d MMM y",
short:"dd.MM.y"
};
var timeFormats67={
full:"HH:mm:ss zzzz",
long:"HH:mm:ss z",
medium:"HH:mm:ss",
short:"HH:mm"
};
var dateTimeFormats67={
full:"{{date}} 'om' {{time}}",
long:"{{date}} 'om' {{time}}",
medium:"{{date}}, {{time}}",
short:"{{date}}, {{time}}"
};
var formatLong135={
date:buildFormatLongFn({
formats:dateFormats67,
defaultWidth:"full"
}),
time:buildFormatLongFn({
formats:timeFormats67,
defaultWidth:"full"
}),
dateTime:buildFormatLongFn({
formats:dateTimeFormats67,
defaultWidth:"full"
})
};

// lib/locale/nl-BE/_lib/formatRelative.js
var formatRelativeLocale59={
lastWeek:"'vorige' eeee 'om' p",
yesterday:"'gisteren om' p",
today:"'vandaag om' p",
tomorrow:"'morgen om' p",
nextWeek:"eeee 'om' p",
other:"P"
};
var formatRelative127=function formatRelative127(token,_date,_baseDate,_options){return formatRelativeLocale59[token];};

// lib/locale/nl-BE/_lib/localize.js
var eraValues59={
narrow:["v.C.","n.C."],
abbreviated:["v.Chr.","n.Chr."],
wide:["voor Christus","na Christus"]
};
var quarterValues59={
narrow:["1","2","3","4"],
abbreviated:["K1","K2","K3","K4"],
wide:["1e kwartaal","2e kwartaal","3e kwartaal","4e kwartaal"]
};
var monthValues59={
narrow:["J","F","M","A","M","J","J","A","S","O","N","D"],
abbreviated:[
"jan.",
"feb.",
"mrt.",
"apr.",
"mei",
"jun.",
"jul.",
"aug.",
"sep.",
"okt.",
"nov.",
"dec."],

wide:[
"januari",
"februari",
"maart",
"april",
"mei",
"juni",
"juli",
"augustus",
"september",
"oktober",
"november",
"december"]

};
var dayValues59={
narrow:["Z","M","D","W","D","V","Z"],
short:["zo","ma","di","wo","do","vr","za"],
abbreviated:["zon","maa","din","woe","don","vri","zat"],
wide:[
"zondag",
"maandag",
"dinsdag",
"woensdag",
"donderdag",
"vrijdag",
"zaterdag"]

};
var dayPeriodValues59={
narrow:{
am:"AM",
pm:"PM",
midnight:"middernacht",
noon:"het middag",
morning:"'s ochtends",
afternoon:"'s namiddags",
evening:"'s avonds",
night:"'s nachts"
},
abbreviated:{
am:"AM",
pm:"PM",
midnight:"middernacht",
noon:"het middag",
morning:"'s ochtends",
afternoon:"'s namiddags",
evening:"'s avonds",
night:"'s nachts"
},
wide:{
am:"AM",
pm:"PM",
midnight:"middernacht",
noon:"het middag",
morning:"'s ochtends",
afternoon:"'s namiddags",
evening:"'s avonds",
night:"'s nachts"
}
};
var ordinalNumber59=function ordinalNumber59(dirtyNumber,_options){
var number=Number(dirtyNumber);
return number+"e";
};
var localize130={
ordinalNumber:ordinalNumber59,
era:buildLocalizeFn({
values:eraValues59,
defaultWidth:"wide"
}),
quarter:buildLocalizeFn({
values:quarterValues59,
defaultWidth:"wide",
argumentCallback:function argumentCallback(quarter){return quarter-1;}
}),
month:buildLocalizeFn({
values:monthValues59,
defaultWidth:"wide"
}),
day:buildLocalizeFn({
values:dayValues59,
defaultWidth:"wide"
}),
dayPeriod:buildLocalizeFn({
values:dayPeriodValues59,
defaultWidth:"wide"
})
};

// lib/locale/nl-BE/_lib/match.js
var matchOrdinalNumberPattern58=/^(\d+)e?/i;
var parseOrdinalNumberPattern58=/\d+/i;
var matchEraPatterns58={
narrow:/^([vn]\.? ?C\.?)/,
abbreviated:/^([vn]\. ?Chr\.?)/,
wide:/^((voor|na) Christus)/
};
var parseEraPatterns58={
any:[/^v/,/^n/]
};
var matchQuarterPatterns58={
narrow:/^[1234]/i,
abbreviated:/^K[1234]/i,
wide:/^[1234]e kwartaal/i
};
var parseQuarterPatterns58={
any:[/1/i,/2/i,/3/i,/4/i]
};
var matchMonthPatterns58={
narrow:/^[jfmasond]/i,
abbreviated:/^(jan.|feb.|mrt.|apr.|mei|jun.|jul.|aug.|sep.|okt.|nov.|dec.)/i,
wide:/^(januari|februari|maart|april|mei|juni|juli|augustus|september|oktober|november|december)/i
};
var parseMonthPatterns58={
narrow:[
/^j/i,
/^f/i,
/^m/i,
/^a/i,
/^m/i,
/^j/i,
/^j/i,
/^a/i,
/^s/i,
/^o/i,
/^n/i,
/^d/i],

any:[
/^jan/i,
/^feb/i,
/^m(r|a)/i,
/^apr/i,
/^mei/i,
/^jun/i,
/^jul/i,
/^aug/i,
/^sep/i,
/^okt/i,
/^nov/i,
/^dec/i]

};
var matchDayPatterns58={
narrow:/^[zmdwv]/i,
short:/^(zo|ma|di|wo|do|vr|za)/i,
abbreviated:/^(zon|maa|din|woe|don|vri|zat)/i,
wide:/^(zondag|maandag|dinsdag|woensdag|donderdag|vrijdag|zaterdag)/i
};
var parseDayPatterns58={
narrow:[/^z/i,/^m/i,/^d/i,/^w/i,/^d/i,/^v/i,/^z/i],
any:[/^zo/i,/^ma/i,/^di/i,/^wo/i,/^do/i,/^vr/i,/^za/i]
};
var matchDayPeriodPatterns58={
any:/^(am|pm|middernacht|het middaguur|'s (ochtends|middags|avonds|nachts))/i
};
var parseDayPeriodPatterns58={
any:{
am:/^am/i,
pm:/^pm/i,
midnight:/^middernacht/i,
noon:/^het middaguur/i,
morning:/ochtend/i,
afternoon:/middag/i,
evening:/avond/i,
night:/nacht/i
}
};
var match126={
ordinalNumber:buildMatchPatternFn({
matchPattern:matchOrdinalNumberPattern58,
parsePattern:parseOrdinalNumberPattern58,
valueCallback:function valueCallback(value){return parseInt(value,10);}
}),
era:buildMatchFn({
matchPatterns:matchEraPatterns58,
defaultMatchWidth:"wide",
parsePatterns:parseEraPatterns58,
defaultParseWidth:"any"
}),
quarter:buildMatchFn({
matchPatterns:matchQuarterPatterns58,
defaultMatchWidth:"wide",
parsePatterns:parseQuarterPatterns58,
defaultParseWidth:"any",
valueCallback:function valueCallback(index){return index+1;}
}),
month:buildMatchFn({
matchPatterns:matchMonthPatterns58,
defaultMatchWidth:"wide",
parsePatterns:parseMonthPatterns58,
defaultParseWidth:"any"
}),
day:buildMatchFn({
matchPatterns:matchDayPatterns58,
defaultMatchWidth:"wide",
parsePatterns:parseDayPatterns58,
defaultParseWidth:"any"
}),
dayPeriod:buildMatchFn({
matchPatterns:matchDayPeriodPatterns58,
defaultMatchWidth:"any",
parsePatterns:parseDayPeriodPatterns58,
defaultParseWidth:"any"
})
};

// lib/locale/nl-BE.js
var _nlBE={
code:"nl-BE",
formatDistance:formatDistance127,
formatLong:formatLong135,
formatRelative:formatRelative127,
localize:localize130,
match:match126,
options:{
weekStartsOn:1,
firstWeekContainsDate:4
}
};
// lib/locale/nn/_lib/formatDistance.js
var formatDistanceLocale59={
lessThanXSeconds:{
one:"mindre enn eitt sekund",
other:"mindre enn {{count}} sekund"
},
xSeconds:{
one:"eitt sekund",
other:"{{count}} sekund"
},
halfAMinute:"eit halvt minutt",
lessThanXMinutes:{
one:"mindre enn eitt minutt",
other:"mindre enn {{count}} minutt"
},
xMinutes:{
one:"eitt minutt",
other:"{{count}} minutt"
},
aboutXHours:{
one:"omtrent ein time",
other:"omtrent {{count}} timar"
},
xHours:{
one:"ein time",
other:"{{count}} timar"
},
xDays:{
one:"ein dag",
other:"{{count}} dagar"
},
aboutXWeeks:{
one:"omtrent ei veke",
other:"omtrent {{count}} veker"
},
xWeeks:{
one:"ei veke",
other:"{{count}} veker"
},
aboutXMonths:{
one:"omtrent ein m\xE5nad",
other:"omtrent {{count}} m\xE5nader"
},
xMonths:{
one:"ein m\xE5nad",
other:"{{count}} m\xE5nader"
},
aboutXYears:{
one:"omtrent eitt \xE5r",
other:"omtrent {{count}} \xE5r"
},
xYears:{
one:"eitt \xE5r",
other:"{{count}} \xE5r"
},
overXYears:{
one:"over eitt \xE5r",
other:"over {{count}} \xE5r"
},
almostXYears:{
one:"nesten eitt \xE5r",
other:"nesten {{count}} \xE5r"
}
};
var wordMapping=[
"null",
"ein",
"to",
"tre",
"fire",
"fem",
"seks",
"sju",
"\xE5tte",
"ni",
"ti",
"elleve",
"tolv"];

var formatDistance129=function formatDistance129(token,count,options){
var result;
var tokenValue=formatDistanceLocale59[token];
if(typeof tokenValue==="string"){
result=tokenValue;
}else if(count===1){
result=tokenValue.one;
}else{
result=tokenValue.other.replace("{{count}}",count<13?wordMapping[count]:String(count));
}
if(options!==null&&options!==void 0&&options.addSuffix){
if(options.comparison&&options.comparison>0){
return"om "+result;
}else{
return result+" sidan";
}
}
return result;
};

// lib/locale/nn/_lib/formatLong.js
var dateFormats68={
full:"EEEE d. MMMM y",
long:"d. MMMM y",
medium:"d. MMM y",
short:"dd.MM.y"
};
var timeFormats68={
full:"'kl'. HH:mm:ss zzzz",
long:"HH:mm:ss z",
medium:"HH:mm:ss",
short:"HH:mm"
};
var dateTimeFormats68={
full:"{{date}} 'kl.' {{time}}",
long:"{{date}} 'kl.' {{time}}",
medium:"{{date}} {{time}}",
short:"{{date}} {{time}}"
};
var formatLong137={
date:buildFormatLongFn({
formats:dateFormats68,
defaultWidth:"full"
}),
time:buildFormatLongFn({
formats:timeFormats68,
defaultWidth:"full"
}),
dateTime:buildFormatLongFn({
formats:dateTimeFormats68,
defaultWidth:"full"
})
};

// lib/locale/nn/_lib/formatRelative.js
var formatRelativeLocale60={
lastWeek:"'f\xF8rre' eeee 'kl.' p",
yesterday:"'i g\xE5r kl.' p",
today:"'i dag kl.' p",
tomorrow:"'i morgon kl.' p",
nextWeek:"EEEE 'kl.' p",
other:"P"
};
var formatRelative129=function formatRelative129(token,_date,_baseDate,_options){return formatRelativeLocale60[token];};

// lib/locale/nn/_lib/localize.js
var eraValues60={
narrow:["f.Kr.","e.Kr."],
abbreviated:["f.Kr.","e.Kr."],
wide:["f\xF8r Kristus","etter Kristus"]
};
var quarterValues60={
narrow:["1","2","3","4"],
abbreviated:["Q1","Q2","Q3","Q4"],
wide:["1. kvartal","2. kvartal","3. kvartal","4. kvartal"]
};
var monthValues60={
narrow:["J","F","M","A","M","J","J","A","S","O","N","D"],
abbreviated:[
"jan.",
"feb.",
"mars",
"apr.",
"mai",
"juni",
"juli",
"aug.",
"sep.",
"okt.",
"nov.",
"des."],

wide:[
"januar",
"februar",
"mars",
"april",
"mai",
"juni",
"juli",
"august",
"september",
"oktober",
"november",
"desember"]

};
var dayValues60={
narrow:["S","M","T","O","T","F","L"],
short:["su","m\xE5","ty","on","to","fr","lau"],
abbreviated:["sun","m\xE5n","tys","ons","tor","fre","laur"],
wide:[
"sundag",
"m\xE5ndag",
"tysdag",
"onsdag",
"torsdag",
"fredag",
"laurdag"]

};
var dayPeriodValues60={
narrow:{
am:"a",
pm:"p",
midnight:"midnatt",
noon:"middag",
morning:"p\xE5 morg.",
afternoon:"p\xE5 etterm.",
evening:"p\xE5 kvelden",
night:"p\xE5 natta"
},
abbreviated:{
am:"a.m.",
pm:"p.m.",
midnight:"midnatt",
noon:"middag",
morning:"p\xE5 morg.",
afternoon:"p\xE5 etterm.",
evening:"p\xE5 kvelden",
night:"p\xE5 natta"
},
wide:{
am:"a.m.",
pm:"p.m.",
midnight:"midnatt",
noon:"middag",
morning:"p\xE5 morgonen",
afternoon:"p\xE5 ettermiddagen",
evening:"p\xE5 kvelden",
night:"p\xE5 natta"
}
};
var ordinalNumber60=function ordinalNumber60(dirtyNumber,_options){
var number=Number(dirtyNumber);
return number+".";
};
var localize132={
ordinalNumber:ordinalNumber60,
era:buildLocalizeFn({
values:eraValues60,
defaultWidth:"wide"
}),
quarter:buildLocalizeFn({
values:quarterValues60,
defaultWidth:"wide",
argumentCallback:function argumentCallback(quarter){return quarter-1;}
}),
month:buildLocalizeFn({
values:monthValues60,
defaultWidth:"wide"
}),
day:buildLocalizeFn({
values:dayValues60,
defaultWidth:"wide"
}),
dayPeriod:buildLocalizeFn({
values:dayPeriodValues60,
defaultWidth:"wide"
})
};

// lib/locale/nn/_lib/match.js
var matchOrdinalNumberPattern59=/^(\d+)\.?/i;
var parseOrdinalNumberPattern59=/\d+/i;
var matchEraPatterns59={
narrow:/^(f\.? ?Kr\.?|fvt\.?|e\.? ?Kr\.?|evt\.?)/i,
abbreviated:/^(f\.? ?Kr\.?|fvt\.?|e\.? ?Kr\.?|evt\.?)/i,
wide:/^(før Kristus|før vår tid|etter Kristus|vår tid)/i
};
var parseEraPatterns59={
any:[/^f/i,/^e/i]
};
var matchQuarterPatterns59={
narrow:/^[1234]/i,
abbreviated:/^q[1234]/i,
wide:/^[1234](\.)? kvartal/i
};
var parseQuarterPatterns59={
any:[/1/i,/2/i,/3/i,/4/i]
};
var matchMonthPatterns59={
narrow:/^[jfmasond]/i,
abbreviated:/^(jan|feb|mars?|apr|mai|juni?|juli?|aug|sep|okt|nov|des)\.?/i,
wide:/^(januar|februar|mars|april|mai|juni|juli|august|september|oktober|november|desember)/i
};
var parseMonthPatterns59={
narrow:[
/^j/i,
/^f/i,
/^m/i,
/^a/i,
/^m/i,
/^j/i,
/^j/i,
/^a/i,
/^s/i,
/^o/i,
/^n/i,
/^d/i],

any:[
/^ja/i,
/^f/i,
/^mar/i,
/^ap/i,
/^mai/i,
/^jun/i,
/^jul/i,
/^aug/i,
/^s/i,
/^o/i,
/^n/i,
/^d/i]

};
var matchDayPatterns59={
narrow:/^[smtofl]/i,
short:/^(su|må|ty|on|to|fr|la)/i,
abbreviated:/^(sun|mån|tys|ons|tor|fre|laur)/i,
wide:/^(sundag|måndag|tysdag|onsdag|torsdag|fredag|laurdag)/i
};
var parseDayPatterns59={
any:[/^s/i,/^m/i,/^ty/i,/^o/i,/^to/i,/^f/i,/^l/i]
};
var matchDayPeriodPatterns59={
narrow:/^(midnatt|middag|(på) (morgonen|ettermiddagen|kvelden|natta)|[ap])/i,
any:/^([ap]\.?\s?m\.?|midnatt|middag|(på) (morgonen|ettermiddagen|kvelden|natta))/i
};
var parseDayPeriodPatterns59={
any:{
am:/^a(\.?\s?m\.?)?$/i,
pm:/^p(\.?\s?m\.?)?$/i,
midnight:/^midn/i,
noon:/^midd/i,
morning:/morgon/i,
afternoon:/ettermiddag/i,
evening:/kveld/i,
night:/natt/i
}
};
var match128={
ordinalNumber:buildMatchPatternFn({
matchPattern:matchOrdinalNumberPattern59,
parsePattern:parseOrdinalNumberPattern59,
valueCallback:function valueCallback(value){return parseInt(value,10);}
}),
era:buildMatchFn({
matchPatterns:matchEraPatterns59,
defaultMatchWidth:"wide",
parsePatterns:parseEraPatterns59,
defaultParseWidth:"any"
}),
quarter:buildMatchFn({
matchPatterns:matchQuarterPatterns59,
defaultMatchWidth:"wide",
parsePatterns:parseQuarterPatterns59,
defaultParseWidth:"any",
valueCallback:function valueCallback(index){return index+1;}
}),
month:buildMatchFn({
matchPatterns:matchMonthPatterns59,
defaultMatchWidth:"wide",
parsePatterns:parseMonthPatterns59,
defaultParseWidth:"any"
}),
day:buildMatchFn({
matchPatterns:matchDayPatterns59,
defaultMatchWidth:"wide",
parsePatterns:parseDayPatterns59,
defaultParseWidth:"any"
}),
dayPeriod:buildMatchFn({
matchPatterns:matchDayPeriodPatterns59,
defaultMatchWidth:"any",
parsePatterns:parseDayPeriodPatterns59,
defaultParseWidth:"any"
})
};

// lib/locale/nn.js
var _nn={
code:"nn",
formatDistance:formatDistance129,
formatLong:formatLong137,
formatRelative:formatRelative129,
localize:localize132,
match:match128,
options:{
weekStartsOn:1,
firstWeekContainsDate:4
}
};
// lib/locale/oc/_lib/formatDistance.js
var formatDistanceLocale60={
lessThanXSeconds:{
one:"mens d\u2019una segonda",
other:"mens de {{count}} segondas"
},
xSeconds:{
one:"1 segonda",
other:"{{count}} segondas"
},
halfAMinute:"30 segondas",
lessThanXMinutes:{
one:"mens d\u2019una minuta",
other:"mens de {{count}} minutas"
},
xMinutes:{
one:"1 minuta",
other:"{{count}} minutas"
},
aboutXHours:{
one:"environ 1 ora",
other:"environ {{count}} oras"
},
xHours:{
one:"1 ora",
other:"{{count}} oras"
},
xDays:{
one:"1 jorn",
other:"{{count}} jorns"
},
aboutXWeeks:{
one:"environ 1 setmana",
other:"environ {{count}} setmanas"
},
xWeeks:{
one:"1 setmana",
other:"{{count}} setmanas"
},
aboutXMonths:{
one:"environ 1 mes",
other:"environ {{count}} meses"
},
xMonths:{
one:"1 mes",
other:"{{count}} meses"
},
aboutXYears:{
one:"environ 1 an",
other:"environ {{count}} ans"
},
xYears:{
one:"1 an",
other:"{{count}} ans"
},
overXYears:{
one:"mai d\u2019un an",
other:"mai de {{count}} ans"
},
almostXYears:{
one:"gaireben un an",
other:"gaireben {{count}} ans"
}
};
var formatDistance131=function formatDistance131(token,count,options){
var result;
var tokenValue=formatDistanceLocale60[token];
if(typeof tokenValue==="string"){
result=tokenValue;
}else if(count===1){
result=tokenValue.one;
}else{
result=tokenValue.other.replace("{{count}}",String(count));
}
if(options!==null&&options!==void 0&&options.addSuffix){
if(options.comparison&&options.comparison>0){
return"d\u2019aqu\xED "+result;
}else{
return"fa "+result;
}
}
return result;
};

// lib/locale/oc/_lib/formatLong.js
var dateFormats69={
full:"EEEE d 'de' MMMM y",
long:"d 'de' MMMM y",
medium:"d MMM y",
short:"dd/MM/y"
};
var timeFormats69={
full:"HH:mm:ss zzzz",
long:"HH:mm:ss z",
medium:"HH:mm:ss",
short:"HH:mm"
};
var dateTimeFormats69={
full:"{{date}} 'a' {{time}}",
long:"{{date}} 'a' {{time}}",
medium:"{{date}}, {{time}}",
short:"{{date}}, {{time}}"
};
var formatLong139={
date:buildFormatLongFn({
formats:dateFormats69,
defaultWidth:"full"
}),
time:buildFormatLongFn({
formats:timeFormats69,
defaultWidth:"full"
}),
dateTime:buildFormatLongFn({
formats:dateTimeFormats69,
defaultWidth:"full"
})
};

// lib/locale/oc/_lib/formatRelative.js
var formatRelativeLocale61={
lastWeek:"eeee 'passat a' p",
yesterday:"'i\xE8r a' p",
today:"'u\xE8i a' p",
tomorrow:"'deman a' p",
nextWeek:"eeee 'a' p",
other:"P"
};
var formatRelative131=function formatRelative131(token,_date,_baseDate,_options){return formatRelativeLocale61[token];};

// lib/locale/oc/_lib/localize.js
var eraValues61={
narrow:["ab. J.C.","apr. J.C."],
abbreviated:["ab. J.C.","apr. J.C."],
wide:["abans J\xE8sus-Crist","apr\xE8s J\xE8sus-Crist"]
};
var quarterValues61={
narrow:["T1","T2","T3","T4"],
abbreviated:["1\xE8r trim.","2nd trim.","3en trim.","4en trim."],
wide:["1\xE8r trim\xE8stre","2nd trim\xE8stre","3en trim\xE8stre","4en trim\xE8stre"]
};
var monthValues61={
narrow:[
"GN",
"FB",
"M\xC7",
"AB",
"MA",
"JN",
"JL",
"AG",
"ST",
"OC",
"NV",
"DC"],

abbreviated:[
"gen.",
"febr.",
"mar\xE7",
"abr.",
"mai",
"junh",
"jul.",
"ag.",
"set.",
"oct.",
"nov.",
"dec."],

wide:[
"geni\xE8r",
"febri\xE8r",
"mar\xE7",
"abril",
"mai",
"junh",
"julhet",
"agost",
"setembre",
"oct\xF2bre",
"novembre",
"decembre"]

};
var dayValues61={
narrow:["dg.","dl.","dm.","dc.","dj.","dv.","ds."],
short:["dg.","dl.","dm.","dc.","dj.","dv.","ds."],
abbreviated:["dg.","dl.","dm.","dc.","dj.","dv.","ds."],
wide:[
"dimenge",
"diluns",
"dimars",
"dim\xE8cres",
"dij\xF2us",
"divendres",
"dissabte"]

};
var dayPeriodValues61={
narrow:{
am:"am",
pm:"pm",
midnight:"mi\xE8janu\xE8ch",
noon:"mi\xE8gjorn",
morning:"matin",
afternoon:"apr\xE8p-mi\xE8gjorn",
evening:"v\xE8spre",
night:"nu\xE8ch"
},
abbreviated:{
am:"a.m.",
pm:"p.m.",
midnight:"mi\xE8janu\xE8ch",
noon:"mi\xE8gjorn",
morning:"matin",
afternoon:"apr\xE8p-mi\xE8gjorn",
evening:"v\xE8spre",
night:"nu\xE8ch"
},
wide:{
am:"a.m.",
pm:"p.m.",
midnight:"mi\xE8janu\xE8ch",
noon:"mi\xE8gjorn",
morning:"matin",
afternoon:"apr\xE8p-mi\xE8gjorn",
evening:"v\xE8spre",
night:"nu\xE8ch"
}
};
var formattingDayPeriodValues47={
narrow:{
am:"am",
pm:"pm",
midnight:"mi\xE8janu\xE8ch",
noon:"mi\xE8gjorn",
morning:"del matin",
afternoon:"de l\u2019apr\xE8p-mi\xE8gjorn",
evening:"del ser",
night:"de la nu\xE8ch"
},
abbreviated:{
am:"AM",
pm:"PM",
midnight:"mi\xE8janu\xE8ch",
noon:"mi\xE8gjorn",
morning:"del matin",
afternoon:"de l\u2019apr\xE8p-mi\xE8gjorn",
evening:"del ser",
night:"de la nu\xE8ch"
},
wide:{
am:"ante meridiem",
pm:"post meridiem",
midnight:"mi\xE8janu\xE8ch",
noon:"mi\xE8gjorn",
morning:"del matin",
afternoon:"de l\u2019apr\xE8p-mi\xE8gjorn",
evening:"del ser",
night:"de la nu\xE8ch"
}
};
var ordinalNumber61=function ordinalNumber61(dirtyNumber,options){
var number=Number(dirtyNumber);
var unit=options===null||options===void 0?void 0:options.unit;
var ordinal;
switch(number){
case 1:
ordinal="\xE8r";
break;
case 2:
ordinal="nd";
break;
default:
ordinal="en";
}
if(unit==="year"||unit==="week"||unit==="hour"||unit==="minute"||unit==="second"){
ordinal+="a";
}
return number+ordinal;
};
var localize134={
ordinalNumber:ordinalNumber61,
era:buildLocalizeFn({
values:eraValues61,
defaultWidth:"wide"
}),
quarter:buildLocalizeFn({
values:quarterValues61,
defaultWidth:"wide",
argumentCallback:function argumentCallback(quarter){return quarter-1;}
}),
month:buildLocalizeFn({
values:monthValues61,
defaultWidth:"wide"
}),
day:buildLocalizeFn({
values:dayValues61,
defaultWidth:"wide"
}),
dayPeriod:buildLocalizeFn({
values:dayPeriodValues61,
defaultWidth:"wide",
formattingValues:formattingDayPeriodValues47,
defaultFormattingWidth:"wide"
})
};

// lib/locale/oc/_lib/match.js
var matchOrdinalNumberPattern60=/^(\d+)(èr|nd|en)?[a]?/i;
var parseOrdinalNumberPattern60=/\d+/i;
var matchEraPatterns60={
narrow:/^(ab\.J\.C|apr\.J\.C|apr\.J\.-C)/i,
abbreviated:/^(ab\.J\.-C|ab\.J-C|apr\.J\.-C|apr\.J-C|ap\.J-C)/i,
wide:/^(abans Jèsus-Crist|après Jèsus-Crist)/i
};
var parseEraPatterns60={
any:[/^ab/i,/^ap/i]
};
var matchQuarterPatterns60={
narrow:/^T[1234]/i,
abbreviated:/^[1234](èr|nd|en)? trim\.?/i,
wide:/^[1234](èr|nd|en)? trimèstre/i
};
var parseQuarterPatterns60={
any:[/1/i,/2/i,/3/i,/4/i]
};
var matchMonthPatterns60={
narrow:/^(GN|FB|MÇ|AB|MA|JN|JL|AG|ST|OC|NV|DC)/i,
abbreviated:/^(gen|febr|març|abr|mai|junh|jul|ag|set|oct|nov|dec)\.?/i,
wide:/^(genièr|febrièr|març|abril|mai|junh|julhet|agost|setembre|octòbre|novembre|decembre)/i
};
var parseMonthPatterns60={
any:[
/^g/i,
/^f/i,
/^ma[r?]|MÇ/i,
/^ab/i,
/^ma[i?]/i,
/^ju[n?]|JN/i,
/^ju[l?]|JL/i,
/^ag/i,
/^s/i,
/^o/i,
/^n/i,
/^d/i]

};
var matchDayPatterns60={
narrow:/^d[glmcjvs]\.?/i,
short:/^d[glmcjvs]\.?/i,
abbreviated:/^d[glmcjvs]\.?/i,
wide:/^(dimenge|diluns|dimars|dimècres|dijòus|divendres|dissabte)/i
};
var parseDayPatterns60={
narrow:[/^dg/i,/^dl/i,/^dm/i,/^dc/i,/^dj/i,/^dv/i,/^ds/i],
short:[/^dg/i,/^dl/i,/^dm/i,/^dc/i,/^dj/i,/^dv/i,/^ds/i],
abbreviated:[/^dg/i,/^dl/i,/^dm/i,/^dc/i,/^dj/i,/^dv/i,/^ds/i],
any:[
/^dg|dime/i,
/^dl|dil/i,
/^dm|dima/i,
/^dc|dimè/i,
/^dj|dij/i,
/^dv|div/i,
/^ds|dis/i]

};
var matchDayPeriodPatterns60={
any:/(^(a\.?m|p\.?m))|(ante meridiem|post meridiem)|((del |de la |de l’)(matin|aprèp-miègjorn|vèspre|ser|nuèch))/i
};
var parseDayPeriodPatterns60={
any:{
am:/(^a)|ante meridiem/i,
pm:/(^p)|post meridiem/i,
midnight:/^mièj/i,
noon:/^mièg/i,
morning:/matin/i,
afternoon:/aprèp-miègjorn/i,
evening:/vèspre|ser/i,
night:/nuèch/i
}
};
var match130={
ordinalNumber:buildMatchPatternFn({
matchPattern:matchOrdinalNumberPattern60,
parsePattern:parseOrdinalNumberPattern60,
valueCallback:function valueCallback(value){return parseInt(value,10);}
}),
era:buildMatchFn({
matchPatterns:matchEraPatterns60,
defaultMatchWidth:"wide",
parsePatterns:parseEraPatterns60,
defaultParseWidth:"any"
}),
quarter:buildMatchFn({
matchPatterns:matchQuarterPatterns60,
defaultMatchWidth:"wide",
parsePatterns:parseQuarterPatterns60,
defaultParseWidth:"any",
valueCallback:function valueCallback(index){return index+1;}
}),
month:buildMatchFn({
matchPatterns:matchMonthPatterns60,
defaultMatchWidth:"wide",
parsePatterns:parseMonthPatterns60,
defaultParseWidth:"any"
}),
day:buildMatchFn({
matchPatterns:matchDayPatterns60,
defaultMatchWidth:"wide",
parsePatterns:parseDayPatterns60,
defaultParseWidth:"any"
}),
dayPeriod:buildMatchFn({
matchPatterns:matchDayPeriodPatterns60,
defaultMatchWidth:"any",
parsePatterns:parseDayPeriodPatterns60,
defaultParseWidth:"any"
})
};

// lib/locale/oc.js
var _oc={
code:"oc",
formatDistance:formatDistance131,
formatLong:formatLong139,
formatRelative:formatRelative131,
localize:localize134,
match:match130,
options:{
weekStartsOn:1,
firstWeekContainsDate:4
}
};
// lib/locale/pl/_lib/formatDistance.js
function declensionGroup(scheme,count){
if(count===1){
return scheme.one;
}
var rem100=count%100;
if(rem100<=20&&rem100>10){
return scheme.other;
}
var rem10=rem100%10;
if(rem10>=2&&rem10<=4){
return scheme.twoFour;
}
return scheme.other;
}
function declension4(scheme,count,time){
var group=declensionGroup(scheme,count);
var finalText=typeof group==="string"?group:group[time];
return finalText.replace("{{count}}",String(count));
}
var formatDistanceLocale61={
lessThanXSeconds:{
one:{
regular:"mniej ni\u017C sekunda",
past:"mniej ni\u017C sekund\u0119",
future:"mniej ni\u017C sekund\u0119"
},
twoFour:"mniej ni\u017C {{count}} sekundy",
other:"mniej ni\u017C {{count}} sekund"
},
xSeconds:{
one:{
regular:"sekunda",
past:"sekund\u0119",
future:"sekund\u0119"
},
twoFour:"{{count}} sekundy",
other:"{{count}} sekund"
},
halfAMinute:{
one:"p\xF3\u0142 minuty",
twoFour:"p\xF3\u0142 minuty",
other:"p\xF3\u0142 minuty"
},
lessThanXMinutes:{
one:{
regular:"mniej ni\u017C minuta",
past:"mniej ni\u017C minut\u0119",
future:"mniej ni\u017C minut\u0119"
},
twoFour:"mniej ni\u017C {{count}} minuty",
other:"mniej ni\u017C {{count}} minut"
},
xMinutes:{
one:{
regular:"minuta",
past:"minut\u0119",
future:"minut\u0119"
},
twoFour:"{{count}} minuty",
other:"{{count}} minut"
},
aboutXHours:{
one:{
regular:"oko\u0142o godziny",
past:"oko\u0142o godziny",
future:"oko\u0142o godzin\u0119"
},
twoFour:"oko\u0142o {{count}} godziny",
other:"oko\u0142o {{count}} godzin"
},
xHours:{
one:{
regular:"godzina",
past:"godzin\u0119",
future:"godzin\u0119"
},
twoFour:"{{count}} godziny",
other:"{{count}} godzin"
},
xDays:{
one:{
regular:"dzie\u0144",
past:"dzie\u0144",
future:"1 dzie\u0144"
},
twoFour:"{{count}} dni",
other:"{{count}} dni"
},
aboutXWeeks:{
one:"oko\u0142o tygodnia",
twoFour:"oko\u0142o {{count}} tygodni",
other:"oko\u0142o {{count}} tygodni"
},
xWeeks:{
one:"tydzie\u0144",
twoFour:"{{count}} tygodnie",
other:"{{count}} tygodni"
},
aboutXMonths:{
one:"oko\u0142o miesi\u0105c",
twoFour:"oko\u0142o {{count}} miesi\u0105ce",
other:"oko\u0142o {{count}} miesi\u0119cy"
},
xMonths:{
one:"miesi\u0105c",
twoFour:"{{count}} miesi\u0105ce",
other:"{{count}} miesi\u0119cy"
},
aboutXYears:{
one:"oko\u0142o rok",
twoFour:"oko\u0142o {{count}} lata",
other:"oko\u0142o {{count}} lat"
},
xYears:{
one:"rok",
twoFour:"{{count}} lata",
other:"{{count}} lat"
},
overXYears:{
one:"ponad rok",
twoFour:"ponad {{count}} lata",
other:"ponad {{count}} lat"
},
almostXYears:{
one:"prawie rok",
twoFour:"prawie {{count}} lata",
other:"prawie {{count}} lat"
}
};
var formatDistance133=function formatDistance133(token,count,options){
var scheme=formatDistanceLocale61[token];
if(!(options!==null&&options!==void 0&&options.addSuffix)){
return declension4(scheme,count,"regular");
}
if(options.comparison&&options.comparison>0){
return"za "+declension4(scheme,count,"future");
}else{
return declension4(scheme,count,"past")+" temu";
}
};

// lib/locale/pl/_lib/formatLong.js
var dateFormats70={
full:"EEEE, do MMMM y",
long:"do MMMM y",
medium:"do MMM y",
short:"dd.MM.y"
};
var timeFormats70={
full:"HH:mm:ss zzzz",
long:"HH:mm:ss z",
medium:"HH:mm:ss",
short:"HH:mm"
};
var dateTimeFormats70={
full:"{{date}} {{time}}",
long:"{{date}} {{time}}",
medium:"{{date}}, {{time}}",
short:"{{date}}, {{time}}"
};
var formatLong141={
date:buildFormatLongFn({
formats:dateFormats70,
defaultWidth:"full"
}),
time:buildFormatLongFn({
formats:timeFormats70,
defaultWidth:"full"
}),
dateTime:buildFormatLongFn({
formats:dateTimeFormats70,
defaultWidth:"full"
})
};

// lib/locale/pl/_lib/formatRelative.js
function dayAndTimeWithAdjective(token,date,baseDate,options){
var adjectives;
if(isSameWeek(date,baseDate,options)){
adjectives=adjectivesThisWeek;
}else if(token==="lastWeek"){
adjectives=adjectivesLastWeek;
}else if(token==="nextWeek"){
adjectives=adjectivesNextWeek;
}else{
throw new Error("Cannot determine adjectives for token ".concat(token));
}
var day=date.getDay();
var grammaticalGender=dayGrammaticalGender[day];
var adjective=adjectives[grammaticalGender];
return"'".concat(adjective,"' eeee 'o' p");
}
var adjectivesLastWeek={
masculine:"ostatni",
feminine:"ostatnia"
};
var adjectivesThisWeek={
masculine:"ten",
feminine:"ta"
};
var adjectivesNextWeek={
masculine:"nast\u0119pny",
feminine:"nast\u0119pna"
};
var dayGrammaticalGender={
0:"feminine",
1:"masculine",
2:"masculine",
3:"feminine",
4:"masculine",
5:"masculine",
6:"feminine"
};
var formatRelativeLocale62={
lastWeek:dayAndTimeWithAdjective,
yesterday:"'wczoraj o' p",
today:"'dzisiaj o' p",
tomorrow:"'jutro o' p",
nextWeek:dayAndTimeWithAdjective,
other:"P"
};
var formatRelative133=function formatRelative133(token,date,baseDate,options){
var format=formatRelativeLocale62[token];
if(typeof format==="function"){
return format(token,date,baseDate,options);
}
return format;
};

// lib/locale/pl/_lib/localize.js
var eraValues62={
narrow:["p.n.e.","n.e."],
abbreviated:["p.n.e.","n.e."],
wide:["przed nasz\u0105 er\u0105","naszej ery"]
};
var quarterValues62={
narrow:["1","2","3","4"],
abbreviated:["I kw.","II kw.","III kw.","IV kw."],
wide:["I kwarta\u0142","II kwarta\u0142","III kwarta\u0142","IV kwarta\u0142"]
};
var monthValues62={
narrow:["S","L","M","K","M","C","L","S","W","P","L","G"],
abbreviated:[
"sty",
"lut",
"mar",
"kwi",
"maj",
"cze",
"lip",
"sie",
"wrz",
"pa\u017A",
"lis",
"gru"],

wide:[
"stycze\u0144",
"luty",
"marzec",
"kwiecie\u0144",
"maj",
"czerwiec",
"lipiec",
"sierpie\u0144",
"wrzesie\u0144",
"pa\u017Adziernik",
"listopad",
"grudzie\u0144"]

};
var monthFormattingValues={
narrow:["s","l","m","k","m","c","l","s","w","p","l","g"],
abbreviated:[
"sty",
"lut",
"mar",
"kwi",
"maj",
"cze",
"lip",
"sie",
"wrz",
"pa\u017A",
"lis",
"gru"],

wide:[
"stycznia",
"lutego",
"marca",
"kwietnia",
"maja",
"czerwca",
"lipca",
"sierpnia",
"wrze\u015Bnia",
"pa\u017Adziernika",
"listopada",
"grudnia"]

};
var dayValues62={
narrow:["N","P","W","\u015A","C","P","S"],
short:["nie","pon","wto","\u015Bro","czw","pi\u0105","sob"],
abbreviated:["niedz.","pon.","wt.","\u015Br.","czw.","pt.","sob."],
wide:[
"niedziela",
"poniedzia\u0142ek",
"wtorek",
"\u015Broda",
"czwartek",
"pi\u0105tek",
"sobota"]

};
var dayFormattingValues={
narrow:["n","p","w","\u015B","c","p","s"],
short:["nie","pon","wto","\u015Bro","czw","pi\u0105","sob"],
abbreviated:["niedz.","pon.","wt.","\u015Br.","czw.","pt.","sob."],
wide:[
"niedziela",
"poniedzia\u0142ek",
"wtorek",
"\u015Broda",
"czwartek",
"pi\u0105tek",
"sobota"]

};
var dayPeriodValues62={
narrow:{
am:"a",
pm:"p",
midnight:"p\xF3\u0142n.",
noon:"po\u0142",
morning:"rano",
afternoon:"popo\u0142.",
evening:"wiecz.",
night:"noc"
},
abbreviated:{
am:"AM",
pm:"PM",
midnight:"p\xF3\u0142noc",
noon:"po\u0142udnie",
morning:"rano",
afternoon:"popo\u0142udnie",
evening:"wiecz\xF3r",
night:"noc"
},
wide:{
am:"AM",
pm:"PM",
midnight:"p\xF3\u0142noc",
noon:"po\u0142udnie",
morning:"rano",
afternoon:"popo\u0142udnie",
evening:"wiecz\xF3r",
night:"noc"
}
};
var dayPeriodFormattingValues={
narrow:{
am:"a",
pm:"p",
midnight:"o p\xF3\u0142n.",
noon:"w po\u0142.",
morning:"rano",
afternoon:"po po\u0142.",
evening:"wiecz.",
night:"w nocy"
},
abbreviated:{
am:"AM",
pm:"PM",
midnight:"o p\xF3\u0142nocy",
noon:"w po\u0142udnie",
morning:"rano",
afternoon:"po po\u0142udniu",
evening:"wieczorem",
night:"w nocy"
},
wide:{
am:"AM",
pm:"PM",
midnight:"o p\xF3\u0142nocy",
noon:"w po\u0142udnie",
morning:"rano",
afternoon:"po po\u0142udniu",
evening:"wieczorem",
night:"w nocy"
}
};
var ordinalNumber62=function ordinalNumber62(dirtyNumber,_options){
return String(dirtyNumber);
};
var localize136={
ordinalNumber:ordinalNumber62,
era:buildLocalizeFn({
values:eraValues62,
defaultWidth:"wide"
}),
quarter:buildLocalizeFn({
values:quarterValues62,
defaultWidth:"wide",
argumentCallback:function argumentCallback(quarter){return quarter-1;}
}),
month:buildLocalizeFn({
values:monthValues62,
defaultWidth:"wide",
formattingValues:monthFormattingValues,
defaultFormattingWidth:"wide"
}),
day:buildLocalizeFn({
values:dayValues62,
defaultWidth:"wide",
formattingValues:dayFormattingValues,
defaultFormattingWidth:"wide"
}),
dayPeriod:buildLocalizeFn({
values:dayPeriodValues62,
defaultWidth:"wide",
formattingValues:dayPeriodFormattingValues,
defaultFormattingWidth:"wide"
})
};

// lib/locale/pl/_lib/match.js
var matchOrdinalNumberPattern61=/^(\d+)?/i;
var parseOrdinalNumberPattern61=/\d+/i;
var matchEraPatterns61={
narrow:/^(p\.?\s*n\.?\s*e\.?\s*|n\.?\s*e\.?\s*)/i,
abbreviated:/^(p\.?\s*n\.?\s*e\.?\s*|n\.?\s*e\.?\s*)/i,
wide:/^(przed\s*nasz(ą|a)\s*er(ą|a)|naszej\s*ery)/i
};
var parseEraPatterns61={
any:[/^p/i,/^n/i]
};
var matchQuarterPatterns61={
narrow:/^[1234]/i,
abbreviated:/^(I|II|III|IV)\s*kw\.?/i,
wide:/^(I|II|III|IV)\s*kwarta(ł|l)/i
};
var parseQuarterPatterns61={
narrow:[/1/i,/2/i,/3/i,/4/i],
any:[/^I kw/i,/^II kw/i,/^III kw/i,/^IV kw/i]
};
var matchMonthPatterns61={
narrow:/^[slmkcwpg]/i,
abbreviated:/^(sty|lut|mar|kwi|maj|cze|lip|sie|wrz|pa(ź|z)|lis|gru)/i,
wide:/^(stycznia|stycze(ń|n)|lutego|luty|marca|marzec|kwietnia|kwiecie(ń|n)|maja|maj|czerwca|czerwiec|lipca|lipiec|sierpnia|sierpie(ń|n)|wrze(ś|s)nia|wrzesie(ń|n)|pa(ź|z)dziernika|pa(ź|z)dziernik|listopada|listopad|grudnia|grudzie(ń|n))/i
};
var parseMonthPatterns61={
narrow:[
/^s/i,
/^l/i,
/^m/i,
/^k/i,
/^m/i,
/^c/i,
/^l/i,
/^s/i,
/^w/i,
/^p/i,
/^l/i,
/^g/i],

any:[
/^st/i,
/^lu/i,
/^mar/i,
/^k/i,
/^maj/i,
/^c/i,
/^lip/i,
/^si/i,
/^w/i,
/^p/i,
/^lis/i,
/^g/i]

};
var matchDayPatterns61={
narrow:/^[npwścs]/i,
short:/^(nie|pon|wto|(ś|s)ro|czw|pi(ą|a)|sob)/i,
abbreviated:/^(niedz|pon|wt|(ś|s)r|czw|pt|sob)\.?/i,
wide:/^(niedziela|poniedzia(ł|l)ek|wtorek|(ś|s)roda|czwartek|pi(ą|a)tek|sobota)/i
};
var parseDayPatterns61={
narrow:[/^n/i,/^p/i,/^w/i,/^ś/i,/^c/i,/^p/i,/^s/i],
abbreviated:[/^n/i,/^po/i,/^w/i,/^(ś|s)r/i,/^c/i,/^pt/i,/^so/i],
any:[/^n/i,/^po/i,/^w/i,/^(ś|s)r/i,/^c/i,/^pi/i,/^so/i]
};
var matchDayPeriodPatterns61={
narrow:/^(^a$|^p$|pó(ł|l)n\.?|o\s*pó(ł|l)n\.?|po(ł|l)\.?|w\s*po(ł|l)\.?|po\s*po(ł|l)\.?|rano|wiecz\.?|noc|w\s*nocy)/i,
any:/^(am|pm|pó(ł|l)noc|o\s*pó(ł|l)nocy|po(ł|l)udnie|w\s*po(ł|l)udnie|popo(ł|l)udnie|po\s*po(ł|l)udniu|rano|wieczór|wieczorem|noc|w\s*nocy)/i
};
var parseDayPeriodPatterns61={
narrow:{
am:/^a$/i,
pm:/^p$/i,
midnight:/pó(ł|l)n/i,
noon:/po(ł|l)/i,
morning:/rano/i,
afternoon:/po\s*po(ł|l)/i,
evening:/wiecz/i,
night:/noc/i
},
any:{
am:/^am/i,
pm:/^pm/i,
midnight:/pó(ł|l)n/i,
noon:/po(ł|l)/i,
morning:/rano/i,
afternoon:/po\s*po(ł|l)/i,
evening:/wiecz/i,
night:/noc/i
}
};
var match132={
ordinalNumber:buildMatchPatternFn({
matchPattern:matchOrdinalNumberPattern61,
parsePattern:parseOrdinalNumberPattern61,
valueCallback:function valueCallback(value){return parseInt(value,10);}
}),
era:buildMatchFn({
matchPatterns:matchEraPatterns61,
defaultMatchWidth:"wide",
parsePatterns:parseEraPatterns61,
defaultParseWidth:"any"
}),
quarter:buildMatchFn({
matchPatterns:matchQuarterPatterns61,
defaultMatchWidth:"wide",
parsePatterns:parseQuarterPatterns61,
defaultParseWidth:"any",
valueCallback:function valueCallback(index){return index+1;}
}),
month:buildMatchFn({
matchPatterns:matchMonthPatterns61,
defaultMatchWidth:"wide",
parsePatterns:parseMonthPatterns61,
defaultParseWidth:"any"
}),
day:buildMatchFn({
matchPatterns:matchDayPatterns61,
defaultMatchWidth:"wide",
parsePatterns:parseDayPatterns61,
defaultParseWidth:"any"
}),
dayPeriod:buildMatchFn({
matchPatterns:matchDayPeriodPatterns61,
defaultMatchWidth:"any",
parsePatterns:parseDayPeriodPatterns61,
defaultParseWidth:"any"
})
};

// lib/locale/pl.js
var _pl={
code:"pl",
formatDistance:formatDistance133,
formatLong:formatLong141,
formatRelative:formatRelative133,
localize:localize136,
match:match132,
options:{
weekStartsOn:1,
firstWeekContainsDate:4
}
};
// lib/locale/pt/_lib/formatDistance.js
var formatDistanceLocale62={
lessThanXSeconds:{
one:"menos de um segundo",
other:"menos de {{count}} segundos"
},
xSeconds:{
one:"1 segundo",
other:"{{count}} segundos"
},
halfAMinute:"meio minuto",
lessThanXMinutes:{
one:"menos de um minuto",
other:"menos de {{count}} minutos"
},
xMinutes:{
one:"1 minuto",
other:"{{count}} minutos"
},
aboutXHours:{
one:"aproximadamente 1 hora",
other:"aproximadamente {{count}} horas"
},
xHours:{
one:"1 hora",
other:"{{count}} horas"
},
xDays:{
one:"1 dia",
other:"{{count}} dias"
},
aboutXWeeks:{
one:"aproximadamente 1 semana",
other:"aproximadamente {{count}} semanas"
},
xWeeks:{
one:"1 semana",
other:"{{count}} semanas"
},
aboutXMonths:{
one:"aproximadamente 1 m\xEAs",
other:"aproximadamente {{count}} meses"
},
xMonths:{
one:"1 m\xEAs",
other:"{{count}} meses"
},
aboutXYears:{
one:"aproximadamente 1 ano",
other:"aproximadamente {{count}} anos"
},
xYears:{
one:"1 ano",
other:"{{count}} anos"
},
overXYears:{
one:"mais de 1 ano",
other:"mais de {{count}} anos"
},
almostXYears:{
one:"quase 1 ano",
other:"quase {{count}} anos"
}
};
var formatDistance135=function formatDistance135(token,count,options){
var result;
var tokenValue=formatDistanceLocale62[token];
if(typeof tokenValue==="string"){
result=tokenValue;
}else if(count===1){
result=tokenValue.one;
}else{
result=tokenValue.other.replace("{{count}}",String(count));
}
if(options!==null&&options!==void 0&&options.addSuffix){
if(options.comparison&&options.comparison>0){
return"daqui a "+result;
}else{
return"h\xE1 "+result;
}
}
return result;
};

// lib/locale/pt/_lib/formatLong.js
var dateFormats71={
full:"EEEE, d 'de' MMMM 'de' y",
long:"d 'de' MMMM 'de' y",
medium:"d 'de' MMM 'de' y",
short:"dd/MM/y"
};
var timeFormats71={
full:"HH:mm:ss zzzz",
long:"HH:mm:ss z",
medium:"HH:mm:ss",
short:"HH:mm"
};
var dateTimeFormats71={
full:"{{date}} '\xE0s' {{time}}",
long:"{{date}} '\xE0s' {{time}}",
medium:"{{date}}, {{time}}",
short:"{{date}}, {{time}}"
};
var formatLong143={
date:buildFormatLongFn({
formats:dateFormats71,
defaultWidth:"full"
}),
time:buildFormatLongFn({
formats:timeFormats71,
defaultWidth:"full"
}),
dateTime:buildFormatLongFn({
formats:dateTimeFormats71,
defaultWidth:"full"
})
};

// lib/locale/pt/_lib/formatRelative.js
var formatRelativeLocale63={
lastWeek:function lastWeek(date){
var weekday=date.getDay();
var last=weekday===0||weekday===6?"\xFAltimo":"\xFAltima";
return"'"+last+"' eeee '\xE0s' p";
},
yesterday:"'ontem \xE0s' p",
today:"'hoje \xE0s' p",
tomorrow:"'amanh\xE3 \xE0s' p",
nextWeek:"eeee '\xE0s' p",
other:"P"
};
var formatRelative135=function formatRelative135(token,date,_baseDate,_options){
var format=formatRelativeLocale63[token];
if(typeof format==="function"){
return format(date);
}
return format;
};

// lib/locale/pt/_lib/localize.js
var eraValues63={
narrow:["aC","dC"],
abbreviated:["a.C.","d.C."],
wide:["antes de Cristo","depois de Cristo"]
};
var quarterValues63={
narrow:["1","2","3","4"],
abbreviated:["T1","T2","T3","T4"],
wide:["1\xBA trimestre","2\xBA trimestre","3\xBA trimestre","4\xBA trimestre"]
};
var monthValues63={
narrow:["j","f","m","a","m","j","j","a","s","o","n","d"],
abbreviated:[
"jan",
"fev",
"mar",
"abr",
"mai",
"jun",
"jul",
"ago",
"set",
"out",
"nov",
"dez"],

wide:[
"janeiro",
"fevereiro",
"mar\xE7o",
"abril",
"maio",
"junho",
"julho",
"agosto",
"setembro",
"outubro",
"novembro",
"dezembro"]

};
var dayValues63={
narrow:["d","s","t","q","q","s","s"],
short:["dom","seg","ter","qua","qui","sex","s\xE1b"],
abbreviated:["dom","seg","ter","qua","qui","sex","s\xE1b"],
wide:[
"domingo",
"segunda-feira",
"ter\xE7a-feira",
"quarta-feira",
"quinta-feira",
"sexta-feira",
"s\xE1bado"]

};
var dayPeriodValues63={
narrow:{
am:"AM",
pm:"PM",
midnight:"meia-noite",
noon:"meio-dia",
morning:"manh\xE3",
afternoon:"tarde",
evening:"noite",
night:"madrugada"
},
abbreviated:{
am:"AM",
pm:"PM",
midnight:"meia-noite",
noon:"meio-dia",
morning:"manh\xE3",
afternoon:"tarde",
evening:"noite",
night:"madrugada"
},
wide:{
am:"AM",
pm:"PM",
midnight:"meia-noite",
noon:"meio-dia",
morning:"manh\xE3",
afternoon:"tarde",
evening:"noite",
night:"madrugada"
}
};
var formattingDayPeriodValues48={
narrow:{
am:"AM",
pm:"PM",
midnight:"meia-noite",
noon:"meio-dia",
morning:"da manh\xE3",
afternoon:"da tarde",
evening:"da noite",
night:"da madrugada"
},
abbreviated:{
am:"AM",
pm:"PM",
midnight:"meia-noite",
noon:"meio-dia",
morning:"da manh\xE3",
afternoon:"da tarde",
evening:"da noite",
night:"da madrugada"
},
wide:{
am:"AM",
pm:"PM",
midnight:"meia-noite",
noon:"meio-dia",
morning:"da manh\xE3",
afternoon:"da tarde",
evening:"da noite",
night:"da madrugada"
}
};
var ordinalNumber63=function ordinalNumber63(dirtyNumber,_options){
var number=Number(dirtyNumber);
return number+"\xBA";
};
var localize138={
ordinalNumber:ordinalNumber63,
era:buildLocalizeFn({
values:eraValues63,
defaultWidth:"wide"
}),
quarter:buildLocalizeFn({
values:quarterValues63,
defaultWidth:"wide",
argumentCallback:function argumentCallback(quarter){return quarter-1;}
}),
month:buildLocalizeFn({
values:monthValues63,
defaultWidth:"wide"
}),
day:buildLocalizeFn({
values:dayValues63,
defaultWidth:"wide"
}),
dayPeriod:buildLocalizeFn({
values:dayPeriodValues63,
defaultWidth:"wide",
formattingValues:formattingDayPeriodValues48,
defaultFormattingWidth:"wide"
})
};

// lib/locale/pt/_lib/match.js
var matchOrdinalNumberPattern62=/^(\d+)(º|ª)?/i;
var parseOrdinalNumberPattern62=/\d+/i;
var matchEraPatterns62={
narrow:/^(ac|dc|a|d)/i,
abbreviated:/^(a\.?\s?c\.?|a\.?\s?e\.?\s?c\.?|d\.?\s?c\.?|e\.?\s?c\.?)/i,
wide:/^(antes de cristo|antes da era comum|depois de cristo|era comum)/i
};
var parseEraPatterns62={
any:[/^ac/i,/^dc/i],
wide:[
/^(antes de cristo|antes da era comum)/i,
/^(depois de cristo|era comum)/i]

};
var matchQuarterPatterns62={
narrow:/^[1234]/i,
abbreviated:/^T[1234]/i,
wide:/^[1234](º|ª)? trimestre/i
};
var parseQuarterPatterns62={
any:[/1/i,/2/i,/3/i,/4/i]
};
var matchMonthPatterns62={
narrow:/^[jfmasond]/i,
abbreviated:/^(jan|fev|mar|abr|mai|jun|jul|ago|set|out|nov|dez)/i,
wide:/^(janeiro|fevereiro|março|abril|maio|junho|julho|agosto|setembro|outubro|novembro|dezembro)/i
};
var parseMonthPatterns62={
narrow:[
/^j/i,
/^f/i,
/^m/i,
/^a/i,
/^m/i,
/^j/i,
/^j/i,
/^a/i,
/^s/i,
/^o/i,
/^n/i,
/^d/i],

any:[
/^ja/i,
/^f/i,
/^mar/i,
/^ab/i,
/^mai/i,
/^jun/i,
/^jul/i,
/^ag/i,
/^s/i,
/^o/i,
/^n/i,
/^d/i]

};
var matchDayPatterns62={
narrow:/^[dstq]/i,
short:/^(dom|seg|ter|qua|qui|sex|s[áa]b)/i,
abbreviated:/^(dom|seg|ter|qua|qui|sex|s[áa]b)/i,
wide:/^(domingo|segunda-?\s?feira|terça-?\s?feira|quarta-?\s?feira|quinta-?\s?feira|sexta-?\s?feira|s[áa]bado)/i
};
var parseDayPatterns62={
narrow:[/^d/i,/^s/i,/^t/i,/^q/i,/^q/i,/^s/i,/^s/i],
any:[/^d/i,/^seg/i,/^t/i,/^qua/i,/^qui/i,/^sex/i,/^s[áa]/i]
};
var matchDayPeriodPatterns62={
narrow:/^(a|p|meia-?\s?noite|meio-?\s?dia|(da) (manh[ãa]|tarde|noite|madrugada))/i,
any:/^([ap]\.?\s?m\.?|meia-?\s?noite|meio-?\s?dia|(da) (manh[ãa]|tarde|noite|madrugada))/i
};
var parseDayPeriodPatterns62={
any:{
am:/^a/i,
pm:/^p/i,
midnight:/^meia/i,
noon:/^meio/i,
morning:/manh[ãa]/i,
afternoon:/tarde/i,
evening:/noite/i,
night:/madrugada/i
}
};
var match134={
ordinalNumber:buildMatchPatternFn({
matchPattern:matchOrdinalNumberPattern62,
parsePattern:parseOrdinalNumberPattern62,
valueCallback:function valueCallback(value){return parseInt(value,10);}
}),
era:buildMatchFn({
matchPatterns:matchEraPatterns62,
defaultMatchWidth:"wide",
parsePatterns:parseEraPatterns62,
defaultParseWidth:"any"
}),
quarter:buildMatchFn({
matchPatterns:matchQuarterPatterns62,
defaultMatchWidth:"wide",
parsePatterns:parseQuarterPatterns62,
defaultParseWidth:"any",
valueCallback:function valueCallback(index){return index+1;}
}),
month:buildMatchFn({
matchPatterns:matchMonthPatterns62,
defaultMatchWidth:"wide",
parsePatterns:parseMonthPatterns62,
defaultParseWidth:"any"
}),
day:buildMatchFn({
matchPatterns:matchDayPatterns62,
defaultMatchWidth:"wide",
parsePatterns:parseDayPatterns62,
defaultParseWidth:"any"
}),
dayPeriod:buildMatchFn({
matchPatterns:matchDayPeriodPatterns62,
defaultMatchWidth:"any",
parsePatterns:parseDayPeriodPatterns62,
defaultParseWidth:"any"
})
};

// lib/locale/pt.js
var _pt={
code:"pt",
formatDistance:formatDistance135,
formatLong:formatLong143,
formatRelative:formatRelative135,
localize:localize138,
match:match134,
options:{
weekStartsOn:1,
firstWeekContainsDate:4
}
};
// lib/locale/pt-BR/_lib/formatDistance.js
var formatDistanceLocale63={
lessThanXSeconds:{
one:"menos de um segundo",
other:"menos de {{count}} segundos"
},
xSeconds:{
one:"1 segundo",
other:"{{count}} segundos"
},
halfAMinute:"meio minuto",
lessThanXMinutes:{
one:"menos de um minuto",
other:"menos de {{count}} minutos"
},
xMinutes:{
one:"1 minuto",
other:"{{count}} minutos"
},
aboutXHours:{
one:"cerca de 1 hora",
other:"cerca de {{count}} horas"
},
xHours:{
one:"1 hora",
other:"{{count}} horas"
},
xDays:{
one:"1 dia",
other:"{{count}} dias"
},
aboutXWeeks:{
one:"cerca de 1 semana",
other:"cerca de {{count}} semanas"
},
xWeeks:{
one:"1 semana",
other:"{{count}} semanas"
},
aboutXMonths:{
one:"cerca de 1 m\xEAs",
other:"cerca de {{count}} meses"
},
xMonths:{
one:"1 m\xEAs",
other:"{{count}} meses"
},
aboutXYears:{
one:"cerca de 1 ano",
other:"cerca de {{count}} anos"
},
xYears:{
one:"1 ano",
other:"{{count}} anos"
},
overXYears:{
one:"mais de 1 ano",
other:"mais de {{count}} anos"
},
almostXYears:{
one:"quase 1 ano",
other:"quase {{count}} anos"
}
};
var formatDistance137=function formatDistance137(token,count,options){
var result;
var tokenValue=formatDistanceLocale63[token];
if(typeof tokenValue==="string"){
result=tokenValue;
}else if(count===1){
result=tokenValue.one;
}else{
result=tokenValue.other.replace("{{count}}",String(count));
}
if(options!==null&&options!==void 0&&options.addSuffix){
if(options.comparison&&options.comparison>0){
return"em "+result;
}else{
return"h\xE1 "+result;
}
}
return result;
};

// lib/locale/pt-BR/_lib/formatLong.js
var dateFormats72={
full:"EEEE, d 'de' MMMM 'de' y",
long:"d 'de' MMMM 'de' y",
medium:"d MMM y",
short:"dd/MM/yyyy"
};
var timeFormats72={
full:"HH:mm:ss zzzz",
long:"HH:mm:ss z",
medium:"HH:mm:ss",
short:"HH:mm"
};
var dateTimeFormats72={
full:"{{date}} '\xE0s' {{time}}",
long:"{{date}} '\xE0s' {{time}}",
medium:"{{date}}, {{time}}",
short:"{{date}}, {{time}}"
};
var formatLong145={
date:buildFormatLongFn({
formats:dateFormats72,
defaultWidth:"full"
}),
time:buildFormatLongFn({
formats:timeFormats72,
defaultWidth:"full"
}),
dateTime:buildFormatLongFn({
formats:dateTimeFormats72,
defaultWidth:"full"
})
};

// lib/locale/pt-BR/_lib/formatRelative.js
var formatRelativeLocale64={
lastWeek:function lastWeek(date){
var weekday=date.getDay();
var last=weekday===0||weekday===6?"\xFAltimo":"\xFAltima";
return"'"+last+"' eeee '\xE0s' p";
},
yesterday:"'ontem \xE0s' p",
today:"'hoje \xE0s' p",
tomorrow:"'amanh\xE3 \xE0s' p",
nextWeek:"eeee '\xE0s' p",
other:"P"
};
var formatRelative137=function formatRelative137(token,date,_baseDate,_options){
var format=formatRelativeLocale64[token];
if(typeof format==="function"){
return format(date);
}
return format;
};

// lib/locale/pt-BR/_lib/localize.js
var eraValues64={
narrow:["AC","DC"],
abbreviated:["AC","DC"],
wide:["antes de cristo","depois de cristo"]
};
var quarterValues64={
narrow:["1","2","3","4"],
abbreviated:["T1","T2","T3","T4"],
wide:["1\xBA trimestre","2\xBA trimestre","3\xBA trimestre","4\xBA trimestre"]
};
var monthValues64={
narrow:["j","f","m","a","m","j","j","a","s","o","n","d"],
abbreviated:[
"jan",
"fev",
"mar",
"abr",
"mai",
"jun",
"jul",
"ago",
"set",
"out",
"nov",
"dez"],

wide:[
"janeiro",
"fevereiro",
"mar\xE7o",
"abril",
"maio",
"junho",
"julho",
"agosto",
"setembro",
"outubro",
"novembro",
"dezembro"]

};
var dayValues64={
narrow:["D","S","T","Q","Q","S","S"],
short:["dom","seg","ter","qua","qui","sex","sab"],
abbreviated:[
"domingo",
"segunda",
"ter\xE7a",
"quarta",
"quinta",
"sexta",
"s\xE1bado"],

wide:[
"domingo",
"segunda-feira",
"ter\xE7a-feira",
"quarta-feira",
"quinta-feira",
"sexta-feira",
"s\xE1bado"]

};
var dayPeriodValues64={
narrow:{
am:"a",
pm:"p",
midnight:"mn",
noon:"md",
morning:"manh\xE3",
afternoon:"tarde",
evening:"tarde",
night:"noite"
},
abbreviated:{
am:"AM",
pm:"PM",
midnight:"meia-noite",
noon:"meio-dia",
morning:"manh\xE3",
afternoon:"tarde",
evening:"tarde",
night:"noite"
},
wide:{
am:"a.m.",
pm:"p.m.",
midnight:"meia-noite",
noon:"meio-dia",
morning:"manh\xE3",
afternoon:"tarde",
evening:"tarde",
night:"noite"
}
};
var formattingDayPeriodValues49={
narrow:{
am:"a",
pm:"p",
midnight:"mn",
noon:"md",
morning:"da manh\xE3",
afternoon:"da tarde",
evening:"da tarde",
night:"da noite"
},
abbreviated:{
am:"AM",
pm:"PM",
midnight:"meia-noite",
noon:"meio-dia",
morning:"da manh\xE3",
afternoon:"da tarde",
evening:"da tarde",
night:"da noite"
},
wide:{
am:"a.m.",
pm:"p.m.",
midnight:"meia-noite",
noon:"meio-dia",
morning:"da manh\xE3",
afternoon:"da tarde",
evening:"da tarde",
night:"da noite"
}
};
var ordinalNumber64=function ordinalNumber64(dirtyNumber,options){
var number=Number(dirtyNumber);
if((options===null||options===void 0?void 0:options.unit)==="week"){
return number+"\xAA";
}
return number+"\xBA";
};
var localize140={
ordinalNumber:ordinalNumber64,
era:buildLocalizeFn({
values:eraValues64,
defaultWidth:"wide"
}),
quarter:buildLocalizeFn({
values:quarterValues64,
defaultWidth:"wide",
argumentCallback:function argumentCallback(quarter){return quarter-1;}
}),
month:buildLocalizeFn({
values:monthValues64,
defaultWidth:"wide"
}),
day:buildLocalizeFn({
values:dayValues64,
defaultWidth:"wide"
}),
dayPeriod:buildLocalizeFn({
values:dayPeriodValues64,
defaultWidth:"wide",
formattingValues:formattingDayPeriodValues49,
defaultFormattingWidth:"wide"
})
};

// lib/locale/pt-BR/_lib/match.js
var matchOrdinalNumberPattern63=/^(\d+)[ºªo]?/i;
var parseOrdinalNumberPattern63=/\d+/i;
var matchEraPatterns63={
narrow:/^(ac|dc|a|d)/i,
abbreviated:/^(a\.?\s?c\.?|d\.?\s?c\.?)/i,
wide:/^(antes de cristo|depois de cristo)/i
};
var parseEraPatterns63={
any:[/^ac/i,/^dc/i],
wide:[/^antes de cristo/i,/^depois de cristo/i]
};
var matchQuarterPatterns63={
narrow:/^[1234]/i,
abbreviated:/^T[1234]/i,
wide:/^[1234](º)? trimestre/i
};
var parseQuarterPatterns63={
any:[/1/i,/2/i,/3/i,/4/i]
};
var matchMonthPatterns63={
narrow:/^[jfmajsond]/i,
abbreviated:/^(jan|fev|mar|abr|mai|jun|jul|ago|set|out|nov|dez)/i,
wide:/^(janeiro|fevereiro|março|abril|maio|junho|julho|agosto|setembro|outubro|novembro|dezembro)/i
};
var parseMonthPatterns63={
narrow:[
/^j/i,
/^f/i,
/^m/i,
/^a/i,
/^m/i,
/^j/i,
/^j/i,
/^a/i,
/^s/i,
/^o/i,
/^n/i,
/^d/i],

any:[
/^ja/i,
/^fev/i,
/^mar/i,
/^abr/i,
/^mai/i,
/^jun/i,
/^jul/i,
/^ago/i,
/^set/i,
/^out/i,
/^nov/i,
/^dez/i]

};
var matchDayPatterns63={
narrow:/^(dom|[23456]ª?|s[aá]b)/i,
short:/^(dom|[23456]ª?|s[aá]b)/i,
abbreviated:/^(dom|seg|ter|qua|qui|sex|s[aá]b)/i,
wide:/^(domingo|(segunda|ter[cç]a|quarta|quinta|sexta)([- ]feira)?|s[aá]bado)/i
};
var parseDayPatterns63={
short:[/^d/i,/^2/i,/^3/i,/^4/i,/^5/i,/^6/i,/^s[aá]/i],
narrow:[/^d/i,/^2/i,/^3/i,/^4/i,/^5/i,/^6/i,/^s[aá]/i],
any:[/^d/i,/^seg/i,/^t/i,/^qua/i,/^qui/i,/^sex/i,/^s[aá]b/i]
};
var matchDayPeriodPatterns63={
narrow:/^(a|p|mn|md|(da) (manhã|tarde|noite))/i,
any:/^([ap]\.?\s?m\.?|meia[-\s]noite|meio[-\s]dia|(da) (manhã|tarde|noite))/i
};
var parseDayPeriodPatterns63={
any:{
am:/^a/i,
pm:/^p/i,
midnight:/^mn|^meia[-\s]noite/i,
noon:/^md|^meio[-\s]dia/i,
morning:/manhã/i,
afternoon:/tarde/i,
evening:/tarde/i,
night:/noite/i
}
};
var match136={
ordinalNumber:buildMatchPatternFn({
matchPattern:matchOrdinalNumberPattern63,
parsePattern:parseOrdinalNumberPattern63,
valueCallback:function valueCallback(value){return parseInt(value,10);}
}),
era:buildMatchFn({
matchPatterns:matchEraPatterns63,
defaultMatchWidth:"wide",
parsePatterns:parseEraPatterns63,
defaultParseWidth:"any"
}),
quarter:buildMatchFn({
matchPatterns:matchQuarterPatterns63,
defaultMatchWidth:"wide",
parsePatterns:parseQuarterPatterns63,
defaultParseWidth:"any",
valueCallback:function valueCallback(index){return index+1;}
}),
month:buildMatchFn({
matchPatterns:matchMonthPatterns63,
defaultMatchWidth:"wide",
parsePatterns:parseMonthPatterns63,
defaultParseWidth:"any"
}),
day:buildMatchFn({
matchPatterns:matchDayPatterns63,
defaultMatchWidth:"wide",
parsePatterns:parseDayPatterns63,
defaultParseWidth:"any"
}),
dayPeriod:buildMatchFn({
matchPatterns:matchDayPeriodPatterns63,
defaultMatchWidth:"any",
parsePatterns:parseDayPeriodPatterns63,
defaultParseWidth:"any"
})
};

// lib/locale/pt-BR.js
var _ptBR={
code:"pt-BR",
formatDistance:formatDistance137,
formatLong:formatLong145,
formatRelative:formatRelative137,
localize:localize140,
match:match136,
options:{
weekStartsOn:0,
firstWeekContainsDate:1
}
};
// lib/locale/ro/_lib/formatDistance.js
var formatDistanceLocale64={
lessThanXSeconds:{
one:"mai pu\u021Bin de o secund\u0103",
other:"mai pu\u021Bin de {{count}} secunde"
},
xSeconds:{
one:"1 secund\u0103",
other:"{{count}} secunde"
},
halfAMinute:"jum\u0103tate de minut",
lessThanXMinutes:{
one:"mai pu\u021Bin de un minut",
other:"mai pu\u021Bin de {{count}} minute"
},
xMinutes:{
one:"1 minut",
other:"{{count}} minute"
},
aboutXHours:{
one:"circa 1 or\u0103",
other:"circa {{count}} ore"
},
xHours:{
one:"1 or\u0103",
other:"{{count}} ore"
},
xDays:{
one:"1 zi",
other:"{{count}} zile"
},
aboutXWeeks:{
one:"circa o s\u0103pt\u0103m\xE2n\u0103",
other:"circa {{count}} s\u0103pt\u0103m\xE2ni"
},
xWeeks:{
one:"1 s\u0103pt\u0103m\xE2n\u0103",
other:"{{count}} s\u0103pt\u0103m\xE2ni"
},
aboutXMonths:{
one:"circa 1 lun\u0103",
other:"circa {{count}} luni"
},
xMonths:{
one:"1 lun\u0103",
other:"{{count}} luni"
},
aboutXYears:{
one:"circa 1 an",
other:"circa {{count}} ani"
},
xYears:{
one:"1 an",
other:"{{count}} ani"
},
overXYears:{
one:"peste 1 an",
other:"peste {{count}} ani"
},
almostXYears:{
one:"aproape 1 an",
other:"aproape {{count}} ani"
}
};
var formatDistance139=function formatDistance139(token,count,options){
var result;
var tokenValue=formatDistanceLocale64[token];
if(typeof tokenValue==="string"){
result=tokenValue;
}else if(count===1){
result=tokenValue.one;
}else{
result=tokenValue.other.replace("{{count}}",String(count));
}
if(options!==null&&options!==void 0&&options.addSuffix){
if(options.comparison&&options.comparison>0){
return"\xEEn "+result;
}else{
return result+" \xEEn urm\u0103";
}
}
return result;
};

// lib/locale/ro/_lib/formatLong.js
var dateFormats73={
full:"EEEE, d MMMM yyyy",
long:"d MMMM yyyy",
medium:"d MMM yyyy",
short:"dd.MM.yyyy"
};
var timeFormats73={
full:"HH:mm:ss zzzz",
long:"HH:mm:ss z",
medium:"HH:mm:ss",
short:"HH:mm"
};
var dateTimeFormats73={
full:"{{date}} 'la' {{time}}",
long:"{{date}} 'la' {{time}}",
medium:"{{date}}, {{time}}",
short:"{{date}}, {{time}}"
};
var formatLong147={
date:buildFormatLongFn({
formats:dateFormats73,
defaultWidth:"full"
}),
time:buildFormatLongFn({
formats:timeFormats73,
defaultWidth:"full"
}),
dateTime:buildFormatLongFn({
formats:dateTimeFormats73,
defaultWidth:"full"
})
};

// lib/locale/ro/_lib/formatRelative.js
var formatRelativeLocale65={
lastWeek:"eeee 'trecut\u0103 la' p",
yesterday:"'ieri la' p",
today:"'ast\u0103zi la' p",
tomorrow:"'m\xE2ine la' p",
nextWeek:"eeee 'viitoare la' p",
other:"P"
};
var formatRelative139=function formatRelative139(token,_date,_baseDate,_options){return formatRelativeLocale65[token];};

// lib/locale/ro/_lib/localize.js
var eraValues65={
narrow:["\xCE","D"],
abbreviated:["\xCE.d.C.","D.C."],
wide:["\xCEnainte de Cristos","Dup\u0103 Cristos"]
};
var quarterValues65={
narrow:["1","2","3","4"],
abbreviated:["T1","T2","T3","T4"],
wide:[
"primul trimestru",
"al doilea trimestru",
"al treilea trimestru",
"al patrulea trimestru"]

};
var monthValues65={
narrow:["I","F","M","A","M","I","I","A","S","O","N","D"],
abbreviated:[
"ian",
"feb",
"mar",
"apr",
"mai",
"iun",
"iul",
"aug",
"sep",
"oct",
"noi",
"dec"],

wide:[
"ianuarie",
"februarie",
"martie",
"aprilie",
"mai",
"iunie",
"iulie",
"august",
"septembrie",
"octombrie",
"noiembrie",
"decembrie"]

};
var dayValues65={
narrow:["d","l","m","m","j","v","s"],
short:["du","lu","ma","mi","jo","vi","s\xE2"],
abbreviated:["dum","lun","mar","mie","joi","vin","s\xE2m"],
wide:["duminic\u0103","luni","mar\u021Bi","miercuri","joi","vineri","s\xE2mb\u0103t\u0103"]
};
var dayPeriodValues65={
narrow:{
am:"a",
pm:"p",
midnight:"mn",
noon:"ami",
morning:"dim",
afternoon:"da",
evening:"s",
night:"n"
},
abbreviated:{
am:"AM",
pm:"PM",
midnight:"miezul nop\u021Bii",
noon:"amiaz\u0103",
morning:"diminea\u021B\u0103",
afternoon:"dup\u0103-amiaz\u0103",
evening:"sear\u0103",
night:"noapte"
},
wide:{
am:"a.m.",
pm:"p.m.",
midnight:"miezul nop\u021Bii",
noon:"amiaz\u0103",
morning:"diminea\u021B\u0103",
afternoon:"dup\u0103-amiaz\u0103",
evening:"sear\u0103",
night:"noapte"
}
};
var formattingDayPeriodValues50={
narrow:{
am:"a",
pm:"p",
midnight:"mn",
noon:"amiaz\u0103",
morning:"diminea\u021B\u0103",
afternoon:"dup\u0103-amiaz\u0103",
evening:"sear\u0103",
night:"noapte"
},
abbreviated:{
am:"AM",
pm:"PM",
midnight:"miezul nop\u021Bii",
noon:"amiaz\u0103",
morning:"diminea\u021B\u0103",
afternoon:"dup\u0103-amiaz\u0103",
evening:"sear\u0103",
night:"noapte"
},
wide:{
am:"a.m.",
pm:"p.m.",
midnight:"miezul nop\u021Bii",
noon:"amiaz\u0103",
morning:"diminea\u021B\u0103",
afternoon:"dup\u0103-amiaz\u0103",
evening:"sear\u0103",
night:"noapte"
}
};
var ordinalNumber65=function ordinalNumber65(dirtyNumber,_options){
return String(dirtyNumber);
};
var localize142={
ordinalNumber:ordinalNumber65,
era:buildLocalizeFn({
values:eraValues65,
defaultWidth:"wide"
}),
quarter:buildLocalizeFn({
values:quarterValues65,
defaultWidth:"wide",
argumentCallback:function argumentCallback(quarter){return quarter-1;}
}),
month:buildLocalizeFn({
values:monthValues65,
defaultWidth:"wide"
}),
day:buildLocalizeFn({
values:dayValues65,
defaultWidth:"wide"
}),
dayPeriod:buildLocalizeFn({
values:dayPeriodValues65,
defaultWidth:"wide",
formattingValues:formattingDayPeriodValues50,
defaultFormattingWidth:"wide"
})
};

// lib/locale/ro/_lib/match.js
var matchOrdinalNumberPattern64=/^(\d+)?/i;
var parseOrdinalNumberPattern64=/\d+/i;
var matchEraPatterns64={
narrow:/^(Î|D)/i,
abbreviated:/^(Î\.?\s?d\.?\s?C\.?|Î\.?\s?e\.?\s?n\.?|D\.?\s?C\.?|e\.?\s?n\.?)/i,
wide:/^(Înainte de Cristos|Înaintea erei noastre|După Cristos|Era noastră)/i
};
var parseEraPatterns64={
any:[/^ÎC/i,/^DC/i],
wide:[
/^(Înainte de Cristos|Înaintea erei noastre)/i,
/^(După Cristos|Era noastră)/i]

};
var matchQuarterPatterns64={
narrow:/^[1234]/i,
abbreviated:/^T[1234]/i,
wide:/^trimestrul [1234]/i
};
var parseQuarterPatterns64={
any:[/1/i,/2/i,/3/i,/4/i]
};
var matchMonthPatterns64={
narrow:/^[ifmaasond]/i,
abbreviated:/^(ian|feb|mar|apr|mai|iun|iul|aug|sep|oct|noi|dec)/i,
wide:/^(ianuarie|februarie|martie|aprilie|mai|iunie|iulie|august|septembrie|octombrie|noiembrie|decembrie)/i
};
var parseMonthPatterns64={
narrow:[
/^i/i,
/^f/i,
/^m/i,
/^a/i,
/^m/i,
/^i/i,
/^i/i,
/^a/i,
/^s/i,
/^o/i,
/^n/i,
/^d/i],

any:[
/^ia/i,
/^f/i,
/^mar/i,
/^ap/i,
/^mai/i,
/^iun/i,
/^iul/i,
/^au/i,
/^s/i,
/^o/i,
/^n/i,
/^d/i]

};
var matchDayPatterns64={
narrow:/^[dlmjvs]/i,
short:/^(d|l|ma|mi|j|v|s)/i,
abbreviated:/^(dum|lun|mar|mie|jo|vi|sâ)/i,
wide:/^(duminica|luni|marţi|miercuri|joi|vineri|sâmbătă)/i
};
var parseDayPatterns64={
narrow:[/^d/i,/^l/i,/^m/i,/^m/i,/^j/i,/^v/i,/^s/i],
any:[/^d/i,/^l/i,/^ma/i,/^mi/i,/^j/i,/^v/i,/^s/i]
};
var matchDayPeriodPatterns64={
narrow:/^(a|p|mn|a|(dimineaţa|după-amiaza|seara|noaptea))/i,
any:/^([ap]\.?\s?m\.?|miezul nopții|amiaza|(dimineaţa|după-amiaza|seara|noaptea))/i
};
var parseDayPeriodPatterns64={
any:{
am:/^a/i,
pm:/^p/i,
midnight:/^mn/i,
noon:/amiaza/i,
morning:/dimineaţa/i,
afternoon:/după-amiaza/i,
evening:/seara/i,
night:/noaptea/i
}
};
var match138={
ordinalNumber:buildMatchPatternFn({
matchPattern:matchOrdinalNumberPattern64,
parsePattern:parseOrdinalNumberPattern64,
valueCallback:function valueCallback(value){return parseInt(value,10);}
}),
era:buildMatchFn({
matchPatterns:matchEraPatterns64,
defaultMatchWidth:"wide",
parsePatterns:parseEraPatterns64,
defaultParseWidth:"any"
}),
quarter:buildMatchFn({
matchPatterns:matchQuarterPatterns64,
defaultMatchWidth:"wide",
parsePatterns:parseQuarterPatterns64,
defaultParseWidth:"any",
valueCallback:function valueCallback(index){return index+1;}
}),
month:buildMatchFn({
matchPatterns:matchMonthPatterns64,
defaultMatchWidth:"wide",
parsePatterns:parseMonthPatterns64,
defaultParseWidth:"any"
}),
day:buildMatchFn({
matchPatterns:matchDayPatterns64,
defaultMatchWidth:"wide",
parsePatterns:parseDayPatterns64,
defaultParseWidth:"any"
}),
dayPeriod:buildMatchFn({
matchPatterns:matchDayPeriodPatterns64,
defaultMatchWidth:"any",
parsePatterns:parseDayPeriodPatterns64,
defaultParseWidth:"any"
})
};

// lib/locale/ro.js
var _ro={
code:"ro",
formatDistance:formatDistance139,
formatLong:formatLong147,
formatRelative:formatRelative139,
localize:localize142,
match:match138,
options:{
weekStartsOn:1,
firstWeekContainsDate:1
}
};
// lib/locale/ru/_lib/formatDistance.js
function declension5(scheme,count){
if(scheme.one!==undefined&&count===1){
return scheme.one;
}
var rem10=count%10;
var rem100=count%100;
if(rem10===1&&rem100!==11){
return scheme.singularNominative.replace("{{count}}",String(count));
}else if(rem10>=2&&rem10<=4&&(rem100<10||rem100>20)){
return scheme.singularGenitive.replace("{{count}}",String(count));
}else{
return scheme.pluralGenitive.replace("{{count}}",String(count));
}
}
function buildLocalizeTokenFn4(scheme){
return function(count,options){
if(options!==null&&options!==void 0&&options.addSuffix){
if(options.comparison&&options.comparison>0){
if(scheme.future){
return declension5(scheme.future,count);
}else{
return"\u0447\u0435\u0440\u0435\u0437 "+declension5(scheme.regular,count);
}
}else{
if(scheme.past){
return declension5(scheme.past,count);
}else{
return declension5(scheme.regular,count)+" \u043D\u0430\u0437\u0430\u0434";
}
}
}else{
return declension5(scheme.regular,count);
}
};
}
var formatDistanceLocale65={
lessThanXSeconds:buildLocalizeTokenFn4({
regular:{
one:"\u043C\u0435\u043D\u044C\u0448\u0435 \u0441\u0435\u043A\u0443\u043D\u0434\u044B",
singularNominative:"\u043C\u0435\u043D\u044C\u0448\u0435 {{count}} \u0441\u0435\u043A\u0443\u043D\u0434\u044B",
singularGenitive:"\u043C\u0435\u043D\u044C\u0448\u0435 {{count}} \u0441\u0435\u043A\u0443\u043D\u0434",
pluralGenitive:"\u043C\u0435\u043D\u044C\u0448\u0435 {{count}} \u0441\u0435\u043A\u0443\u043D\u0434"
},
future:{
one:"\u043C\u0435\u043D\u044C\u0448\u0435, \u0447\u0435\u043C \u0447\u0435\u0440\u0435\u0437 \u0441\u0435\u043A\u0443\u043D\u0434\u0443",
singularNominative:"\u043C\u0435\u043D\u044C\u0448\u0435, \u0447\u0435\u043C \u0447\u0435\u0440\u0435\u0437 {{count}} \u0441\u0435\u043A\u0443\u043D\u0434\u0443",
singularGenitive:"\u043C\u0435\u043D\u044C\u0448\u0435, \u0447\u0435\u043C \u0447\u0435\u0440\u0435\u0437 {{count}} \u0441\u0435\u043A\u0443\u043D\u0434\u044B",
pluralGenitive:"\u043C\u0435\u043D\u044C\u0448\u0435, \u0447\u0435\u043C \u0447\u0435\u0440\u0435\u0437 {{count}} \u0441\u0435\u043A\u0443\u043D\u0434"
}
}),
xSeconds:buildLocalizeTokenFn4({
regular:{
singularNominative:"{{count}} \u0441\u0435\u043A\u0443\u043D\u0434\u0430",
singularGenitive:"{{count}} \u0441\u0435\u043A\u0443\u043D\u0434\u044B",
pluralGenitive:"{{count}} \u0441\u0435\u043A\u0443\u043D\u0434"
},
past:{
singularNominative:"{{count}} \u0441\u0435\u043A\u0443\u043D\u0434\u0443 \u043D\u0430\u0437\u0430\u0434",
singularGenitive:"{{count}} \u0441\u0435\u043A\u0443\u043D\u0434\u044B \u043D\u0430\u0437\u0430\u0434",
pluralGenitive:"{{count}} \u0441\u0435\u043A\u0443\u043D\u0434 \u043D\u0430\u0437\u0430\u0434"
},
future:{
singularNominative:"\u0447\u0435\u0440\u0435\u0437 {{count}} \u0441\u0435\u043A\u0443\u043D\u0434\u0443",
singularGenitive:"\u0447\u0435\u0440\u0435\u0437 {{count}} \u0441\u0435\u043A\u0443\u043D\u0434\u044B",
pluralGenitive:"\u0447\u0435\u0440\u0435\u0437 {{count}} \u0441\u0435\u043A\u0443\u043D\u0434"
}
}),
halfAMinute:function halfAMinute(_count,options){
if(options!==null&&options!==void 0&&options.addSuffix){
if(options.comparison&&options.comparison>0){
return"\u0447\u0435\u0440\u0435\u0437 \u043F\u043E\u043B\u043C\u0438\u043D\u0443\u0442\u044B";
}else{
return"\u043F\u043E\u043B\u043C\u0438\u043D\u0443\u0442\u044B \u043D\u0430\u0437\u0430\u0434";
}
}
return"\u043F\u043E\u043B\u043C\u0438\u043D\u0443\u0442\u044B";
},
lessThanXMinutes:buildLocalizeTokenFn4({
regular:{
one:"\u043C\u0435\u043D\u044C\u0448\u0435 \u043C\u0438\u043D\u0443\u0442\u044B",
singularNominative:"\u043C\u0435\u043D\u044C\u0448\u0435 {{count}} \u043C\u0438\u043D\u0443\u0442\u044B",
singularGenitive:"\u043C\u0435\u043D\u044C\u0448\u0435 {{count}} \u043C\u0438\u043D\u0443\u0442",
pluralGenitive:"\u043C\u0435\u043D\u044C\u0448\u0435 {{count}} \u043C\u0438\u043D\u0443\u0442"
},
future:{
one:"\u043C\u0435\u043D\u044C\u0448\u0435, \u0447\u0435\u043C \u0447\u0435\u0440\u0435\u0437 \u043C\u0438\u043D\u0443\u0442\u0443",
singularNominative:"\u043C\u0435\u043D\u044C\u0448\u0435, \u0447\u0435\u043C \u0447\u0435\u0440\u0435\u0437 {{count}} \u043C\u0438\u043D\u0443\u0442\u0443",
singularGenitive:"\u043C\u0435\u043D\u044C\u0448\u0435, \u0447\u0435\u043C \u0447\u0435\u0440\u0435\u0437 {{count}} \u043C\u0438\u043D\u0443\u0442\u044B",
pluralGenitive:"\u043C\u0435\u043D\u044C\u0448\u0435, \u0447\u0435\u043C \u0447\u0435\u0440\u0435\u0437 {{count}} \u043C\u0438\u043D\u0443\u0442"
}
}),
xMinutes:buildLocalizeTokenFn4({
regular:{
singularNominative:"{{count}} \u043C\u0438\u043D\u0443\u0442\u0430",
singularGenitive:"{{count}} \u043C\u0438\u043D\u0443\u0442\u044B",
pluralGenitive:"{{count}} \u043C\u0438\u043D\u0443\u0442"
},
past:{
singularNominative:"{{count}} \u043C\u0438\u043D\u0443\u0442\u0443 \u043D\u0430\u0437\u0430\u0434",
singularGenitive:"{{count}} \u043C\u0438\u043D\u0443\u0442\u044B \u043D\u0430\u0437\u0430\u0434",
pluralGenitive:"{{count}} \u043C\u0438\u043D\u0443\u0442 \u043D\u0430\u0437\u0430\u0434"
},
future:{
singularNominative:"\u0447\u0435\u0440\u0435\u0437 {{count}} \u043C\u0438\u043D\u0443\u0442\u0443",
singularGenitive:"\u0447\u0435\u0440\u0435\u0437 {{count}} \u043C\u0438\u043D\u0443\u0442\u044B",
pluralGenitive:"\u0447\u0435\u0440\u0435\u0437 {{count}} \u043C\u0438\u043D\u0443\u0442"
}
}),
aboutXHours:buildLocalizeTokenFn4({
regular:{
singularNominative:"\u043E\u043A\u043E\u043B\u043E {{count}} \u0447\u0430\u0441\u0430",
singularGenitive:"\u043E\u043A\u043E\u043B\u043E {{count}} \u0447\u0430\u0441\u043E\u0432",
pluralGenitive:"\u043E\u043A\u043E\u043B\u043E {{count}} \u0447\u0430\u0441\u043E\u0432"
},
future:{
singularNominative:"\u043F\u0440\u0438\u0431\u043B\u0438\u0437\u0438\u0442\u0435\u043B\u044C\u043D\u043E \u0447\u0435\u0440\u0435\u0437 {{count}} \u0447\u0430\u0441",
singularGenitive:"\u043F\u0440\u0438\u0431\u043B\u0438\u0437\u0438\u0442\u0435\u043B\u044C\u043D\u043E \u0447\u0435\u0440\u0435\u0437 {{count}} \u0447\u0430\u0441\u0430",
pluralGenitive:"\u043F\u0440\u0438\u0431\u043B\u0438\u0437\u0438\u0442\u0435\u043B\u044C\u043D\u043E \u0447\u0435\u0440\u0435\u0437 {{count}} \u0447\u0430\u0441\u043E\u0432"
}
}),
xHours:buildLocalizeTokenFn4({
regular:{
singularNominative:"{{count}} \u0447\u0430\u0441",
singularGenitive:"{{count}} \u0447\u0430\u0441\u0430",
pluralGenitive:"{{count}} \u0447\u0430\u0441\u043E\u0432"
}
}),
xDays:buildLocalizeTokenFn4({
regular:{
singularNominative:"{{count}} \u0434\u0435\u043D\u044C",
singularGenitive:"{{count}} \u0434\u043D\u044F",
pluralGenitive:"{{count}} \u0434\u043D\u0435\u0439"
}
}),
aboutXWeeks:buildLocalizeTokenFn4({
regular:{
singularNominative:"\u043E\u043A\u043E\u043B\u043E {{count}} \u043D\u0435\u0434\u0435\u043B\u0438",
singularGenitive:"\u043E\u043A\u043E\u043B\u043E {{count}} \u043D\u0435\u0434\u0435\u043B\u044C",
pluralGenitive:"\u043E\u043A\u043E\u043B\u043E {{count}} \u043D\u0435\u0434\u0435\u043B\u044C"
},
future:{
singularNominative:"\u043F\u0440\u0438\u0431\u043B\u0438\u0437\u0438\u0442\u0435\u043B\u044C\u043D\u043E \u0447\u0435\u0440\u0435\u0437 {{count}} \u043D\u0435\u0434\u0435\u043B\u044E",
singularGenitive:"\u043F\u0440\u0438\u0431\u043B\u0438\u0437\u0438\u0442\u0435\u043B\u044C\u043D\u043E \u0447\u0435\u0440\u0435\u0437 {{count}} \u043D\u0435\u0434\u0435\u043B\u0438",
pluralGenitive:"\u043F\u0440\u0438\u0431\u043B\u0438\u0437\u0438\u0442\u0435\u043B\u044C\u043D\u043E \u0447\u0435\u0440\u0435\u0437 {{count}} \u043D\u0435\u0434\u0435\u043B\u044C"
}
}),
xWeeks:buildLocalizeTokenFn4({
regular:{
singularNominative:"{{count}} \u043D\u0435\u0434\u0435\u043B\u044F",
singularGenitive:"{{count}} \u043D\u0435\u0434\u0435\u043B\u0438",
pluralGenitive:"{{count}} \u043D\u0435\u0434\u0435\u043B\u044C"
}
}),
aboutXMonths:buildLocalizeTokenFn4({
regular:{
singularNominative:"\u043E\u043A\u043E\u043B\u043E {{count}} \u043C\u0435\u0441\u044F\u0446\u0430",
singularGenitive:"\u043E\u043A\u043E\u043B\u043E {{count}} \u043C\u0435\u0441\u044F\u0446\u0435\u0432",
pluralGenitive:"\u043E\u043A\u043E\u043B\u043E {{count}} \u043C\u0435\u0441\u044F\u0446\u0435\u0432"
},
future:{
singularNominative:"\u043F\u0440\u0438\u0431\u043B\u0438\u0437\u0438\u0442\u0435\u043B\u044C\u043D\u043E \u0447\u0435\u0440\u0435\u0437 {{count}} \u043C\u0435\u0441\u044F\u0446",
singularGenitive:"\u043F\u0440\u0438\u0431\u043B\u0438\u0437\u0438\u0442\u0435\u043B\u044C\u043D\u043E \u0447\u0435\u0440\u0435\u0437 {{count}} \u043C\u0435\u0441\u044F\u0446\u0430",
pluralGenitive:"\u043F\u0440\u0438\u0431\u043B\u0438\u0437\u0438\u0442\u0435\u043B\u044C\u043D\u043E \u0447\u0435\u0440\u0435\u0437 {{count}} \u043C\u0435\u0441\u044F\u0446\u0435\u0432"
}
}),
xMonths:buildLocalizeTokenFn4({
regular:{
singularNominative:"{{count}} \u043C\u0435\u0441\u044F\u0446",
singularGenitive:"{{count}} \u043C\u0435\u0441\u044F\u0446\u0430",
pluralGenitive:"{{count}} \u043C\u0435\u0441\u044F\u0446\u0435\u0432"
}
}),
aboutXYears:buildLocalizeTokenFn4({
regular:{
singularNominative:"\u043E\u043A\u043E\u043B\u043E {{count}} \u0433\u043E\u0434\u0430",
singularGenitive:"\u043E\u043A\u043E\u043B\u043E {{count}} \u043B\u0435\u0442",
pluralGenitive:"\u043E\u043A\u043E\u043B\u043E {{count}} \u043B\u0435\u0442"
},
future:{
singularNominative:"\u043F\u0440\u0438\u0431\u043B\u0438\u0437\u0438\u0442\u0435\u043B\u044C\u043D\u043E \u0447\u0435\u0440\u0435\u0437 {{count}} \u0433\u043E\u0434",
singularGenitive:"\u043F\u0440\u0438\u0431\u043B\u0438\u0437\u0438\u0442\u0435\u043B\u044C\u043D\u043E \u0447\u0435\u0440\u0435\u0437 {{count}} \u0433\u043E\u0434\u0430",
pluralGenitive:"\u043F\u0440\u0438\u0431\u043B\u0438\u0437\u0438\u0442\u0435\u043B\u044C\u043D\u043E \u0447\u0435\u0440\u0435\u0437 {{count}} \u043B\u0435\u0442"
}
}),
xYears:buildLocalizeTokenFn4({
regular:{
singularNominative:"{{count}} \u0433\u043E\u0434",
singularGenitive:"{{count}} \u0433\u043E\u0434\u0430",
pluralGenitive:"{{count}} \u043B\u0435\u0442"
}
}),
overXYears:buildLocalizeTokenFn4({
regular:{
singularNominative:"\u0431\u043E\u043B\u044C\u0448\u0435 {{count}} \u0433\u043E\u0434\u0430",
singularGenitive:"\u0431\u043E\u043B\u044C\u0448\u0435 {{count}} \u043B\u0435\u0442",
pluralGenitive:"\u0431\u043E\u043B\u044C\u0448\u0435 {{count}} \u043B\u0435\u0442"
},
future:{
singularNominative:"\u0431\u043E\u043B\u044C\u0448\u0435, \u0447\u0435\u043C \u0447\u0435\u0440\u0435\u0437 {{count}} \u0433\u043E\u0434",
singularGenitive:"\u0431\u043E\u043B\u044C\u0448\u0435, \u0447\u0435\u043C \u0447\u0435\u0440\u0435\u0437 {{count}} \u0433\u043E\u0434\u0430",
pluralGenitive:"\u0431\u043E\u043B\u044C\u0448\u0435, \u0447\u0435\u043C \u0447\u0435\u0440\u0435\u0437 {{count}} \u043B\u0435\u0442"
}
}),
almostXYears:buildLocalizeTokenFn4({
regular:{
singularNominative:"\u043F\u043E\u0447\u0442\u0438 {{count}} \u0433\u043E\u0434",
singularGenitive:"\u043F\u043E\u0447\u0442\u0438 {{count}} \u0433\u043E\u0434\u0430",
pluralGenitive:"\u043F\u043E\u0447\u0442\u0438 {{count}} \u043B\u0435\u0442"
},
future:{
singularNominative:"\u043F\u043E\u0447\u0442\u0438 \u0447\u0435\u0440\u0435\u0437 {{count}} \u0433\u043E\u0434",
singularGenitive:"\u043F\u043E\u0447\u0442\u0438 \u0447\u0435\u0440\u0435\u0437 {{count}} \u0433\u043E\u0434\u0430",
pluralGenitive:"\u043F\u043E\u0447\u0442\u0438 \u0447\u0435\u0440\u0435\u0437 {{count}} \u043B\u0435\u0442"
}
})
};
var formatDistance141=function formatDistance141(token,count,options){
return formatDistanceLocale65[token](count,options);
};

// lib/locale/ru/_lib/formatLong.js
var dateFormats74={
full:"EEEE, d MMMM y '\u0433.'",
long:"d MMMM y '\u0433.'",
medium:"d MMM y '\u0433.'",
short:"dd.MM.y"
};
var timeFormats74={
full:"H:mm:ss zzzz",
long:"H:mm:ss z",
medium:"H:mm:ss",
short:"H:mm"
};
var dateTimeFormats74={
any:"{{date}}, {{time}}"
};
var formatLong149={
date:buildFormatLongFn({
formats:dateFormats74,
defaultWidth:"full"
}),
time:buildFormatLongFn({
formats:timeFormats74,
defaultWidth:"full"
}),
dateTime:buildFormatLongFn({
formats:dateTimeFormats74,
defaultWidth:"any"
})
};

// lib/locale/ru/_lib/formatRelative.js
function lastWeek7(day){
var weekday=accusativeWeekdays6[day];
switch(day){
case 0:
return"'\u0432 \u043F\u0440\u043E\u0448\u043B\u043E\u0435 "+weekday+" \u0432' p";
case 1:
case 2:
case 4:
return"'\u0432 \u043F\u0440\u043E\u0448\u043B\u044B\u0439 "+weekday+" \u0432' p";
case 3:
case 5:
case 6:
return"'\u0432 \u043F\u0440\u043E\u0448\u043B\u0443\u044E "+weekday+" \u0432' p";
}
}
function thisWeek7(day){
var weekday=accusativeWeekdays6[day];
if(day===2){
return"'\u0432\u043E "+weekday+" \u0432' p";
}else{
return"'\u0432 "+weekday+" \u0432' p";
}
}
function nextWeek7(day){
var weekday=accusativeWeekdays6[day];
switch(day){
case 0:
return"'\u0432 \u0441\u043B\u0435\u0434\u0443\u044E\u0449\u0435\u0435 "+weekday+" \u0432' p";
case 1:
case 2:
case 4:
return"'\u0432 \u0441\u043B\u0435\u0434\u0443\u044E\u0449\u0438\u0439 "+weekday+" \u0432' p";
case 3:
case 5:
case 6:
return"'\u0432 \u0441\u043B\u0435\u0434\u0443\u044E\u0449\u0443\u044E "+weekday+" \u0432' p";
}
}
var accusativeWeekdays6=[
"\u0432\u043E\u0441\u043A\u0440\u0435\u0441\u0435\u043D\u044C\u0435",
"\u043F\u043E\u043D\u0435\u0434\u0435\u043B\u044C\u043D\u0438\u043A",
"\u0432\u0442\u043E\u0440\u043D\u0438\u043A",
"\u0441\u0440\u0435\u0434\u0443",
"\u0447\u0435\u0442\u0432\u0435\u0440\u0433",
"\u043F\u044F\u0442\u043D\u0438\u0446\u0443",
"\u0441\u0443\u0431\u0431\u043E\u0442\u0443"];

var formatRelativeLocale66={
lastWeek:function lastWeek(date,baseDate,options){
var day=date.getDay();
if(isSameWeek(date,baseDate,options)){
return thisWeek7(day);
}else{
return lastWeek7(day);
}
},
yesterday:"'\u0432\u0447\u0435\u0440\u0430 \u0432' p",
today:"'\u0441\u0435\u0433\u043E\u0434\u043D\u044F \u0432' p",
tomorrow:"'\u0437\u0430\u0432\u0442\u0440\u0430 \u0432' p",
nextWeek:function nextWeek(date,baseDate,options){
var day=date.getDay();
if(isSameWeek(date,baseDate,options)){
return thisWeek7(day);
}else{
return nextWeek7(day);
}
},
other:"P"
};
var formatRelative141=function formatRelative141(token,date,baseDate,options){
var format=formatRelativeLocale66[token];
if(typeof format==="function"){
return format(date,baseDate,options);
}
return format;
};

// lib/locale/ru/_lib/localize.js
var eraValues66={
narrow:["\u0434\u043E \u043D.\u044D.","\u043D.\u044D."],
abbreviated:["\u0434\u043E \u043D. \u044D.","\u043D. \u044D."],
wide:["\u0434\u043E \u043D\u0430\u0448\u0435\u0439 \u044D\u0440\u044B","\u043D\u0430\u0448\u0435\u0439 \u044D\u0440\u044B"]
};
var quarterValues66={
narrow:["1","2","3","4"],
abbreviated:["1-\u0439 \u043A\u0432.","2-\u0439 \u043A\u0432.","3-\u0439 \u043A\u0432.","4-\u0439 \u043A\u0432."],
wide:["1-\u0439 \u043A\u0432\u0430\u0440\u0442\u0430\u043B","2-\u0439 \u043A\u0432\u0430\u0440\u0442\u0430\u043B","3-\u0439 \u043A\u0432\u0430\u0440\u0442\u0430\u043B","4-\u0439 \u043A\u0432\u0430\u0440\u0442\u0430\u043B"]
};
var monthValues66={
narrow:["\u042F","\u0424","\u041C","\u0410","\u041C","\u0418","\u0418","\u0410","\u0421","\u041E","\u041D","\u0414"],
abbreviated:[
"\u044F\u043D\u0432.",
"\u0444\u0435\u0432.",
"\u043C\u0430\u0440\u0442",
"\u0430\u043F\u0440.",
"\u043C\u0430\u0439",
"\u0438\u044E\u043D\u044C",
"\u0438\u044E\u043B\u044C",
"\u0430\u0432\u0433.",
"\u0441\u0435\u043D\u0442.",
"\u043E\u043A\u0442.",
"\u043D\u043E\u044F\u0431.",
"\u0434\u0435\u043A."],

wide:[
"\u044F\u043D\u0432\u0430\u0440\u044C",
"\u0444\u0435\u0432\u0440\u0430\u043B\u044C",
"\u043C\u0430\u0440\u0442",
"\u0430\u043F\u0440\u0435\u043B\u044C",
"\u043C\u0430\u0439",
"\u0438\u044E\u043D\u044C",
"\u0438\u044E\u043B\u044C",
"\u0430\u0432\u0433\u0443\u0441\u0442",
"\u0441\u0435\u043D\u0442\u044F\u0431\u0440\u044C",
"\u043E\u043A\u0442\u044F\u0431\u0440\u044C",
"\u043D\u043E\u044F\u0431\u0440\u044C",
"\u0434\u0435\u043A\u0430\u0431\u0440\u044C"]

};
var formattingMonthValues14={
narrow:["\u042F","\u0424","\u041C","\u0410","\u041C","\u0418","\u0418","\u0410","\u0421","\u041E","\u041D","\u0414"],
abbreviated:[
"\u044F\u043D\u0432.",
"\u0444\u0435\u0432.",
"\u043C\u0430\u0440.",
"\u0430\u043F\u0440.",
"\u043C\u0430\u044F",
"\u0438\u044E\u043D.",
"\u0438\u044E\u043B.",
"\u0430\u0432\u0433.",
"\u0441\u0435\u043D\u0442.",
"\u043E\u043A\u0442.",
"\u043D\u043E\u044F\u0431.",
"\u0434\u0435\u043A."],

wide:[
"\u044F\u043D\u0432\u0430\u0440\u044F",
"\u0444\u0435\u0432\u0440\u0430\u043B\u044F",
"\u043C\u0430\u0440\u0442\u0430",
"\u0430\u043F\u0440\u0435\u043B\u044F",
"\u043C\u0430\u044F",
"\u0438\u044E\u043D\u044F",
"\u0438\u044E\u043B\u044F",
"\u0430\u0432\u0433\u0443\u0441\u0442\u0430",
"\u0441\u0435\u043D\u0442\u044F\u0431\u0440\u044F",
"\u043E\u043A\u0442\u044F\u0431\u0440\u044F",
"\u043D\u043E\u044F\u0431\u0440\u044F",
"\u0434\u0435\u043A\u0430\u0431\u0440\u044F"]

};
var dayValues66={
narrow:["\u0412","\u041F","\u0412","\u0421","\u0427","\u041F","\u0421"],
short:["\u0432\u0441","\u043F\u043D","\u0432\u0442","\u0441\u0440","\u0447\u0442","\u043F\u0442","\u0441\u0431"],
abbreviated:["\u0432\u0441\u043A","\u043F\u043D\u0434","\u0432\u0442\u0440","\u0441\u0440\u0434","\u0447\u0442\u0432","\u043F\u0442\u043D","\u0441\u0443\u0431"],
wide:[
"\u0432\u043E\u0441\u043A\u0440\u0435\u0441\u0435\u043D\u044C\u0435",
"\u043F\u043E\u043D\u0435\u0434\u0435\u043B\u044C\u043D\u0438\u043A",
"\u0432\u0442\u043E\u0440\u043D\u0438\u043A",
"\u0441\u0440\u0435\u0434\u0430",
"\u0447\u0435\u0442\u0432\u0435\u0440\u0433",
"\u043F\u044F\u0442\u043D\u0438\u0446\u0430",
"\u0441\u0443\u0431\u0431\u043E\u0442\u0430"]

};
var dayPeriodValues66={
narrow:{
am:"\u0414\u041F",
pm:"\u041F\u041F",
midnight:"\u043F\u043E\u043B\u043D.",
noon:"\u043F\u043E\u043B\u0434.",
morning:"\u0443\u0442\u0440\u043E",
afternoon:"\u0434\u0435\u043D\u044C",
evening:"\u0432\u0435\u0447.",
night:"\u043D\u043E\u0447\u044C"
},
abbreviated:{
am:"\u0414\u041F",
pm:"\u041F\u041F",
midnight:"\u043F\u043E\u043B\u043D.",
noon:"\u043F\u043E\u043B\u0434.",
morning:"\u0443\u0442\u0440\u043E",
afternoon:"\u0434\u0435\u043D\u044C",
evening:"\u0432\u0435\u0447.",
night:"\u043D\u043E\u0447\u044C"
},
wide:{
am:"\u0414\u041F",
pm:"\u041F\u041F",
midnight:"\u043F\u043E\u043B\u043D\u043E\u0447\u044C",
noon:"\u043F\u043E\u043B\u0434\u0435\u043D\u044C",
morning:"\u0443\u0442\u0440\u043E",
afternoon:"\u0434\u0435\u043D\u044C",
evening:"\u0432\u0435\u0447\u0435\u0440",
night:"\u043D\u043E\u0447\u044C"
}
};
var formattingDayPeriodValues51={
narrow:{
am:"\u0414\u041F",
pm:"\u041F\u041F",
midnight:"\u043F\u043E\u043B\u043D.",
noon:"\u043F\u043E\u043B\u0434.",
morning:"\u0443\u0442\u0440\u0430",
afternoon:"\u0434\u043D\u044F",
evening:"\u0432\u0435\u0447.",
night:"\u043D\u043E\u0447\u0438"
},
abbreviated:{
am:"\u0414\u041F",
pm:"\u041F\u041F",
midnight:"\u043F\u043E\u043B\u043D.",
noon:"\u043F\u043E\u043B\u0434.",
morning:"\u0443\u0442\u0440\u0430",
afternoon:"\u0434\u043D\u044F",
evening:"\u0432\u0435\u0447.",
night:"\u043D\u043E\u0447\u0438"
},
wide:{
am:"\u0414\u041F",
pm:"\u041F\u041F",
midnight:"\u043F\u043E\u043B\u043D\u043E\u0447\u044C",
noon:"\u043F\u043E\u043B\u0434\u0435\u043D\u044C",
morning:"\u0443\u0442\u0440\u0430",
afternoon:"\u0434\u043D\u044F",
evening:"\u0432\u0435\u0447\u0435\u0440\u0430",
night:"\u043D\u043E\u0447\u0438"
}
};
var ordinalNumber66=function ordinalNumber66(dirtyNumber,options){
var number=Number(dirtyNumber);
var unit=options===null||options===void 0?void 0:options.unit;
var suffix;
if(unit==="date"){
suffix="-\u0435";
}else if(unit==="week"||unit==="minute"||unit==="second"){
suffix="-\u044F";
}else{
suffix="-\u0439";
}
return number+suffix;
};
var localize144={
ordinalNumber:ordinalNumber66,
era:buildLocalizeFn({
values:eraValues66,
defaultWidth:"wide"
}),
quarter:buildLocalizeFn({
values:quarterValues66,
defaultWidth:"wide",
argumentCallback:function argumentCallback(quarter){return quarter-1;}
}),
month:buildLocalizeFn({
values:monthValues66,
defaultWidth:"wide",
formattingValues:formattingMonthValues14,
defaultFormattingWidth:"wide"
}),
day:buildLocalizeFn({
values:dayValues66,
defaultWidth:"wide"
}),
dayPeriod:buildLocalizeFn({
values:dayPeriodValues66,
defaultWidth:"any",
formattingValues:formattingDayPeriodValues51,
defaultFormattingWidth:"wide"
})
};

// lib/locale/ru/_lib/match.js
var matchOrdinalNumberPattern65=/^(\d+)(-?(е|я|й|ое|ье|ая|ья|ый|ой|ий|ый))?/i;
var parseOrdinalNumberPattern65=/\d+/i;
var matchEraPatterns65={
narrow:/^((до )?н\.?\s?э\.?)/i,
abbreviated:/^((до )?н\.?\s?э\.?)/i,
wide:/^(до нашей эры|нашей эры|наша эра)/i
};
var parseEraPatterns65={
any:[/^д/i,/^н/i]
};
var matchQuarterPatterns65={
narrow:/^[1234]/i,
abbreviated:/^[1234](-?[ыои]?й?)? кв.?/i,
wide:/^[1234](-?[ыои]?й?)? квартал/i
};
var parseQuarterPatterns65={
any:[/1/i,/2/i,/3/i,/4/i]
};
var matchMonthPatterns65={
narrow:/^[яфмаисонд]/i,
abbreviated:/^(янв|фев|март?|апр|ма[йя]|июн[ья]?|июл[ья]?|авг|сент?|окт|нояб?|дек)\.?/i,
wide:/^(январ[ья]|феврал[ья]|марта?|апрел[ья]|ма[йя]|июн[ья]|июл[ья]|августа?|сентябр[ья]|октябр[ья]|октябр[ья]|ноябр[ья]|декабр[ья])/i
};
var parseMonthPatterns65={
narrow:[
/^я/i,
/^ф/i,
/^м/i,
/^а/i,
/^м/i,
/^и/i,
/^и/i,
/^а/i,
/^с/i,
/^о/i,
/^н/i,
/^я/i],

any:[
/^я/i,
/^ф/i,
/^мар/i,
/^ап/i,
/^ма[йя]/i,
/^июн/i,
/^июл/i,
/^ав/i,
/^с/i,
/^о/i,
/^н/i,
/^д/i]

};
var matchDayPatterns65={
narrow:/^[впсч]/i,
short:/^(вс|во|пн|по|вт|ср|чт|че|пт|пя|сб|су)\.?/i,
abbreviated:/^(вск|вос|пнд|пон|втр|вто|срд|сре|чтв|чет|птн|пят|суб).?/i,
wide:/^(воскресень[ея]|понедельника?|вторника?|сред[аы]|четверга?|пятниц[аы]|суббот[аы])/i
};
var parseDayPatterns65={
narrow:[/^в/i,/^п/i,/^в/i,/^с/i,/^ч/i,/^п/i,/^с/i],
any:[/^в[ос]/i,/^п[он]/i,/^в/i,/^ср/i,/^ч/i,/^п[ят]/i,/^с[уб]/i]
};
var matchDayPeriodPatterns65={
narrow:/^([дп]п|полн\.?|полд\.?|утр[оа]|день|дня|веч\.?|ноч[ьи])/i,
abbreviated:/^([дп]п|полн\.?|полд\.?|утр[оа]|день|дня|веч\.?|ноч[ьи])/i,
wide:/^([дп]п|полночь|полдень|утр[оа]|день|дня|вечера?|ноч[ьи])/i
};
var parseDayPeriodPatterns65={
any:{
am:/^дп/i,
pm:/^пп/i,
midnight:/^полн/i,
noon:/^полд/i,
morning:/^у/i,
afternoon:/^д[ен]/i,
evening:/^в/i,
night:/^н/i
}
};
var match140={
ordinalNumber:buildMatchPatternFn({
matchPattern:matchOrdinalNumberPattern65,
parsePattern:parseOrdinalNumberPattern65,
valueCallback:function valueCallback(value){return parseInt(value,10);}
}),
era:buildMatchFn({
matchPatterns:matchEraPatterns65,
defaultMatchWidth:"wide",
parsePatterns:parseEraPatterns65,
defaultParseWidth:"any"
}),
quarter:buildMatchFn({
matchPatterns:matchQuarterPatterns65,
defaultMatchWidth:"wide",
parsePatterns:parseQuarterPatterns65,
defaultParseWidth:"any",
valueCallback:function valueCallback(index){return index+1;}
}),
month:buildMatchFn({
matchPatterns:matchMonthPatterns65,
defaultMatchWidth:"wide",
parsePatterns:parseMonthPatterns65,
defaultParseWidth:"any"
}),
day:buildMatchFn({
matchPatterns:matchDayPatterns65,
defaultMatchWidth:"wide",
parsePatterns:parseDayPatterns65,
defaultParseWidth:"any"
}),
dayPeriod:buildMatchFn({
matchPatterns:matchDayPeriodPatterns65,
defaultMatchWidth:"wide",
parsePatterns:parseDayPeriodPatterns65,
defaultParseWidth:"any"
})
};

// lib/locale/ru.js
var _ru={
code:"ru",
formatDistance:formatDistance141,
formatLong:formatLong149,
formatRelative:formatRelative141,
localize:localize144,
match:match140,
options:{
weekStartsOn:1,
firstWeekContainsDate:1
}
};
// lib/locale/se/_lib/formatDistance.js
var formatDistanceLocale66={
lessThanXSeconds:{
one:"unnit go ovtta sekundda",
other:"unnit go {{count}} sekundda"
},
xSeconds:{
one:"sekundda",
other:"{{count}} sekundda"
},
halfAMinute:"bealle minuhta",
lessThanXMinutes:{
one:"unnit go bealle minuhta",
other:"unnit go {{count}} minuhta"
},
xMinutes:{
one:"minuhta",
other:"{{count}} minuhta"
},
aboutXHours:{
one:"sullii ovtta diimmu",
other:"sullii {{count}} diimmu"
},
xHours:{
one:"diimmu",
other:"{{count}} diimmu"
},
xDays:{
one:"beaivvi",
other:"{{count}} beaivvi"
},
aboutXWeeks:{
one:"sullii ovtta vahku",
other:"sullii {{count}} vahku"
},
xWeeks:{
one:"vahku",
other:"{{count}} vahku"
},
aboutXMonths:{
one:"sullii ovtta m\xE1nu",
other:"sullii {{count}} m\xE1nu"
},
xMonths:{
one:"m\xE1nu",
other:"{{count}} m\xE1nu"
},
aboutXYears:{
one:"sullii ovtta jagi",
other:"sullii {{count}} jagi"
},
xYears:{
one:"jagi",
other:"{{count}} jagi"
},
overXYears:{
one:"guhkit go jagi",
other:"guhkit go {{count}} jagi"
},
almostXYears:{
one:"measta jagi",
other:"measta {{count}} jagi"
}
};
var formatDistance143=function formatDistance143(token,count,options){
var result;
var tokenValue=formatDistanceLocale66[token];
if(typeof tokenValue==="string"){
result=tokenValue;
}else if(count===1){
result=tokenValue.one;
}else{
result=tokenValue.other.replace("{{count}}",String(count));
}
if(options!==null&&options!==void 0&&options.addSuffix){
if(options.comparison&&options.comparison>0){
return"geah\u010Den "+result;
}else{
return result+" \xE1igi";
}
}
return result;
};

// lib/locale/se/_lib/formatLong.js
var dateFormats75={
full:"EEEE MMMM d. 'b.' y",
long:"MMMM d. 'b.' y",
medium:"MMM d. 'b.' y",
short:"dd.MM.y"
};
var timeFormats75={
full:"'dii.' HH:mm:ss zzzz",
long:"HH:mm:ss z",
medium:"HH:mm:ss",
short:"HH:mm"
};
var dateTimeFormats75={
full:"{{date}} 'dii.' {{time}}",
long:"{{date}} 'dii.' {{time}}",
medium:"{{date}} {{time}}",
short:"{{date}} {{time}}"
};
var formatLong151={
date:buildFormatLongFn({
formats:dateFormats75,
defaultWidth:"full"
}),
time:buildFormatLongFn({
formats:timeFormats75,
defaultWidth:"full"
}),
dateTime:buildFormatLongFn({
formats:dateTimeFormats75,
defaultWidth:"full"
})
};

// lib/locale/se/_lib/formatRelative.js
var formatRelativeLocale67={
lastWeek:"'ovddit' eeee 'dii.' p",
yesterday:"'ikte dii.' p",
today:"'odne dii.' p",
tomorrow:"'ihtin dii.' p",
nextWeek:"EEEE 'dii.' p",
other:"P"
};
var formatRelative143=function formatRelative143(token,_date,_baseDate,_options){return formatRelativeLocale67[token];};

// lib/locale/se/_lib/localize.js
var eraValues67={
narrow:["o.Kr.","m.Kr."],
abbreviated:["o.Kr.","m.Kr."],
wide:["ovdal Kristusa","ma\u014B\u014Bel Kristusa"]
};
var quarterValues67={
narrow:["1","2","3","4"],
abbreviated:["Q1","Q2","Q3","Q4"],
wide:["1. kvart\xE1la","2. kvart\xE1la","3. kvart\xE1la","4. kvart\xE1la"]
};
var monthValues67={
narrow:["O","G","N","C","M","G","S","B","\u010C","G","S","J"],
abbreviated:[
"o\u0111\u0111a",
"guov",
"njuk",
"cuo",
"mies",
"geas",
"suoi",
"borg",
"\u010Dak\u010D",
"golg",
"sk\xE1b",
"juov"],

wide:[
"o\u0111\u0111ajagem\xE1nnu",
"guovvam\xE1nnu",
"njuk\u010Dam\xE1nnu",
"cuo\u014Bom\xE1nnu",
"miessem\xE1nnu",
"geassem\xE1nnu",
"suoidnem\xE1nnu",
"borgem\xE1nnu",
"\u010Dak\u010Dam\xE1nnu",
"golggotm\xE1nnu",
"sk\xE1bmam\xE1nnu",
"juovlam\xE1nnu"]

};
var dayValues67={
narrow:["S","V","M","G","D","B","L"],
short:["sotn","vuos","ma\u014B","gask","duor","bear","l\xE1v"],
abbreviated:["sotn","vuos","ma\u014B","gask","duor","bear","l\xE1v"],
wide:[
"sotnabeaivi",
"vuoss\xE1rga",
"ma\u014B\u014Beb\xE1rga",
"gaskavahkku",
"duorastat",
"bearjadat",
"l\xE1vvardat"]

};
var dayPeriodValues67={
narrow:{
am:"a",
pm:"p",
midnight:"gaskaidja",
noon:"gaskabeaivi",
morning:"i\u0111\u0111es",
afternoon:"ma\u014B\u014Bel gaska.",
evening:"eahkes",
night:"ihkku"
},
abbreviated:{
am:"a.m.",
pm:"p.m.",
midnight:"gaskaidja",
noon:"gaskabeaivvi",
morning:"i\u0111\u0111es",
afternoon:"ma\u014B\u014Bel gaskabea.",
evening:"eahkes",
night:"ihkku"
},
wide:{
am:"a.m.",
pm:"p.m.",
midnight:"gaskaidja",
noon:"gaskabeavvi",
morning:"i\u0111\u0111es",
afternoon:"ma\u014B\u014Bel gaskabeaivvi",
evening:"eahkes",
night:"ihkku"
}
};
var ordinalNumber67=function ordinalNumber67(dirtyNumber,_options){
var number=Number(dirtyNumber);
return number+".";
};
var localize146={
ordinalNumber:ordinalNumber67,
era:buildLocalizeFn({
values:eraValues67,
defaultWidth:"wide"
}),
quarter:buildLocalizeFn({
values:quarterValues67,
defaultWidth:"wide",
argumentCallback:function argumentCallback(quarter){return quarter-1;}
}),
month:buildLocalizeFn({
values:monthValues67,
defaultWidth:"wide"
}),
day:buildLocalizeFn({
values:dayValues67,
defaultWidth:"wide"
}),
dayPeriod:buildLocalizeFn({
values:dayPeriodValues67,
defaultWidth:"wide"
})
};

// lib/locale/se/_lib/match.js
var matchOrdinalNumberPattern66=/^(\d+)\.?/i;
var parseOrdinalNumberPattern66=/\d+/i;
var matchEraPatterns66={
narrow:/^(o\.? ?Kr\.?|m\.? ?Kr\.?)/i,
abbreviated:/^(o\.? ?Kr\.?|m\.? ?Kr\.?)/i,
wide:/^(ovdal Kristusa|ovdal min áiggi|maŋŋel Kristusa|min áigi)/i
};
var parseEraPatterns66={
any:[/^o/i,/^m/i]
};
var matchQuarterPatterns66={
narrow:/^[1234]/i,
abbreviated:/^q[1234]/i,
wide:/^[1234](\.)? kvartála/i
};
var parseQuarterPatterns66={
any:[/1/i,/2/i,/3/i,/4/i]
};
var matchMonthPatterns66={
narrow:/^[ogncmsbčj]/i,
abbreviated:/^(ođđa|guov|njuk|cuo|mies|geas|suoi|borg|čakč|golg|skáb|juov)\.?/i,
wide:/^(ođđajagemánnu|guovvamánnu|njukčamánnu|cuoŋománnu|miessemánnu|geassemánnu|suoidnemánnu|borgemánnu|čakčamánnu|golggotmánnu|skábmamánnu|juovlamánnu)/i
};
var parseMonthPatterns66={
narrow:[
/^o/i,
/^g/i,
/^n/i,
/^c/i,
/^m/i,
/^g/i,
/^s/i,
/^b/i,
/^č/i,
/^g/i,
/^s/i,
/^j/i],

any:[
/^o/i,
/^gu/i,
/^n/i,
/^c/i,
/^m/i,
/^ge/i,
/^su/i,
/^b/i,
/^č/i,
/^go/i,
/^sk/i,
/^j/i]

};
var matchDayPatterns66={
narrow:/^[svmgdbl]/i,
short:/^(sotn|vuos|maŋ|gask|duor|bear|láv)/i,
abbreviated:/^(sotn|vuos|maŋ|gask|duor|bear|láv)/i,
wide:/^(sotnabeaivi|vuossárga|maŋŋebárga|gaskavahkku|duorastat|bearjadat|lávvardat)/i
};
var parseDayPatterns66={
any:[/^s/i,/^v/i,/^m/i,/^g/i,/^d/i,/^b/i,/^l/i]
};
var matchDayPeriodPatterns66={
narrow:/^(gaskaidja|gaskabeaivvi|(på) (iđđes|maŋŋel gaskabeaivvi|eahkes|ihkku)|[ap])/i,
any:/^([ap]\.?\s?m\.?|gaskaidja|gaskabeaivvi|(på) (iđđes|maŋŋel gaskabeaivvi|eahkes|ihkku))/i
};
var parseDayPeriodPatterns66={
any:{
am:/^a(\.?\s?m\.?)?$/i,
pm:/^p(\.?\s?m\.?)?$/i,
midnight:/^gaskai/i,
noon:/^gaskab/i,
morning:/iđđes/i,
afternoon:/maŋŋel gaskabeaivvi/i,
evening:/eahkes/i,
night:/ihkku/i
}
};
var match142={
ordinalNumber:buildMatchPatternFn({
matchPattern:matchOrdinalNumberPattern66,
parsePattern:parseOrdinalNumberPattern66,
valueCallback:function valueCallback(value){return parseInt(value,10);}
}),
era:buildMatchFn({
matchPatterns:matchEraPatterns66,
defaultMatchWidth:"wide",
parsePatterns:parseEraPatterns66,
defaultParseWidth:"any"
}),
quarter:buildMatchFn({
matchPatterns:matchQuarterPatterns66,
defaultMatchWidth:"wide",
parsePatterns:parseQuarterPatterns66,
defaultParseWidth:"any",
valueCallback:function valueCallback(index){return index+1;}
}),
month:buildMatchFn({
matchPatterns:matchMonthPatterns66,
defaultMatchWidth:"wide",
parsePatterns:parseMonthPatterns66,
defaultParseWidth:"any"
}),
day:buildMatchFn({
matchPatterns:matchDayPatterns66,
defaultMatchWidth:"wide",
parsePatterns:parseDayPatterns66,
defaultParseWidth:"any"
}),
dayPeriod:buildMatchFn({
matchPatterns:matchDayPeriodPatterns66,
defaultMatchWidth:"any",
parsePatterns:parseDayPeriodPatterns66,
defaultParseWidth:"any"
})
};

// lib/locale/se.js
var _se={
code:"se",
formatDistance:formatDistance143,
formatLong:formatLong151,
formatRelative:formatRelative143,
localize:localize146,
match:match142,
options:{
weekStartsOn:1,
firstWeekContainsDate:4
}
};
// lib/locale/sk/_lib/formatDistance.js
function declensionGroup2(scheme,count){
if(count===1&&scheme.one){
return scheme.one;
}
if(count>=2&&count<=4&&scheme.twoFour){
return scheme.twoFour;
}
return scheme.other;
}
function declension6(scheme,count,time){
var group=declensionGroup2(scheme,count);
var finalText=group[time];
return finalText.replace("{{count}}",String(count));
}
function extractPreposition(token){
var result=["lessThan","about","over","almost"].filter(function(preposition){
return!!token.match(new RegExp("^"+preposition));
});
return result[0];
}
function prefixPreposition(preposition){
var translation="";
if(preposition==="almost"){
translation="takmer";
}
if(preposition==="about"){
translation="pribli\u017Ene";
}
return translation.length>0?translation+" ":"";
}
function suffixPreposition(preposition){
var translation="";
if(preposition==="lessThan"){
translation="menej ne\u017E";
}
if(preposition==="over"){
translation="viac ne\u017E";
}
return translation.length>0?translation+" ":"";
}
function lowercaseFirstLetter(string){
return string.charAt(0).toLowerCase()+string.slice(1);
}
var formatDistanceLocale67={
xSeconds:{
one:{
present:"sekunda",
past:"sekundou",
future:"sekundu"
},
twoFour:{
present:"{{count}} sekundy",
past:"{{count}} sekundami",
future:"{{count}} sekundy"
},
other:{
present:"{{count}} sek\xFAnd",
past:"{{count}} sekundami",
future:"{{count}} sek\xFAnd"
}
},
halfAMinute:{
other:{
present:"pol min\xFAty",
past:"pol min\xFAtou",
future:"pol min\xFAty"
}
},
xMinutes:{
one:{
present:"min\xFAta",
past:"min\xFAtou",
future:"min\xFAtu"
},
twoFour:{
present:"{{count}} min\xFAty",
past:"{{count}} min\xFAtami",
future:"{{count}} min\xFAty"
},
other:{
present:"{{count}} min\xFAt",
past:"{{count}} min\xFAtami",
future:"{{count}} min\xFAt"
}
},
xHours:{
one:{
present:"hodina",
past:"hodinou",
future:"hodinu"
},
twoFour:{
present:"{{count}} hodiny",
past:"{{count}} hodinami",
future:"{{count}} hodiny"
},
other:{
present:"{{count}} hod\xEDn",
past:"{{count}} hodinami",
future:"{{count}} hod\xEDn"
}
},
xDays:{
one:{
present:"de\u0148",
past:"d\u0148om",
future:"de\u0148"
},
twoFour:{
present:"{{count}} dni",
past:"{{count}} d\u0148ami",
future:"{{count}} dni"
},
other:{
present:"{{count}} dn\xED",
past:"{{count}} d\u0148ami",
future:"{{count}} dn\xED"
}
},
xWeeks:{
one:{
present:"t\xFD\u017Ede\u0148",
past:"t\xFD\u017Ed\u0148om",
future:"t\xFD\u017Ede\u0148"
},
twoFour:{
present:"{{count}} t\xFD\u017Edne",
past:"{{count}} t\xFD\u017Ed\u0148ami",
future:"{{count}} t\xFD\u017Edne"
},
other:{
present:"{{count}} t\xFD\u017Ed\u0148ov",
past:"{{count}} t\xFD\u017Ed\u0148ami",
future:"{{count}} t\xFD\u017Ed\u0148ov"
}
},
xMonths:{
one:{
present:"mesiac",
past:"mesiacom",
future:"mesiac"
},
twoFour:{
present:"{{count}} mesiace",
past:"{{count}} mesiacmi",
future:"{{count}} mesiace"
},
other:{
present:"{{count}} mesiacov",
past:"{{count}} mesiacmi",
future:"{{count}} mesiacov"
}
},
xYears:{
one:{
present:"rok",
past:"rokom",
future:"rok"
},
twoFour:{
present:"{{count}} roky",
past:"{{count}} rokmi",
future:"{{count}} roky"
},
other:{
present:"{{count}} rokov",
past:"{{count}} rokmi",
future:"{{count}} rokov"
}
}
};
var formatDistance145=function formatDistance145(token,count,options){
var preposition=extractPreposition(token)||"";
var key=lowercaseFirstLetter(token.substring(preposition.length));
var scheme=formatDistanceLocale67[key];
if(!(options!==null&&options!==void 0&&options.addSuffix)){
return prefixPreposition(preposition)+suffixPreposition(preposition)+declension6(scheme,count,"present");
}
if(options.comparison&&options.comparison>0){
return prefixPreposition(preposition)+"o "+suffixPreposition(preposition)+declension6(scheme,count,"future");
}else{
return prefixPreposition(preposition)+"pred "+suffixPreposition(preposition)+declension6(scheme,count,"past");
}
};

// lib/locale/sk/_lib/formatLong.js
var dateFormats76={
full:"EEEE d. MMMM y",
long:"d. MMMM y",
medium:"d. M. y",
short:"d. M. y"
};
var timeFormats76={
full:"H:mm:ss zzzz",
long:"H:mm:ss z",
medium:"H:mm:ss",
short:"H:mm"
};
var dateTimeFormats76={
full:"{{date}}, {{time}}",
long:"{{date}}, {{time}}",
medium:"{{date}}, {{time}}",
short:"{{date}} {{time}}"
};
var formatLong153={
date:buildFormatLongFn({
formats:dateFormats76,
defaultWidth:"full"
}),
time:buildFormatLongFn({
formats:timeFormats76,
defaultWidth:"full"
}),
dateTime:buildFormatLongFn({
formats:dateTimeFormats76,
defaultWidth:"full"
})
};

// lib/locale/sk/_lib/formatRelative.js
function lastWeek8(day){
var weekday=accusativeWeekdays7[day];
switch(day){
case 0:
case 3:
case 6:
return"'minul\xFA "+weekday+" o' p";
default:
return"'minul\xFD' eeee 'o' p";
}
}
function thisWeek8(day){
var weekday=accusativeWeekdays7[day];
if(day===4){
return"'vo' eeee 'o' p";
}else{
return"'v "+weekday+" o' p";
}
}
function nextWeek8(day){
var weekday=accusativeWeekdays7[day];
switch(day){
case 0:
case 4:
case 6:
return"'bud\xFAcu "+weekday+" o' p";
default:
return"'bud\xFAci' eeee 'o' p";
}
}
var accusativeWeekdays7=[
"nede\u013Eu",
"pondelok",
"utorok",
"stredu",
"\u0161tvrtok",
"piatok",
"sobotu"];

var formatRelativeLocale68={
lastWeek:function lastWeek(date,baseDate,options){
var day=date.getDay();
if(isSameWeek(date,baseDate,options)){
return thisWeek8(day);
}else{
return lastWeek8(day);
}
},
yesterday:"'v\u010Dera o' p",
today:"'dnes o' p",
tomorrow:"'zajtra o' p",
nextWeek:function nextWeek(date,baseDate,options){
var day=date.getDay();
if(isSameWeek(date,baseDate,options)){
return thisWeek8(day);
}else{
return nextWeek8(day);
}
},
other:"P"
};
var formatRelative145=function formatRelative145(token,date,baseDate,options){
var format=formatRelativeLocale68[token];
if(typeof format==="function"){
return format(date,baseDate,options);
}
return format;
};

// lib/locale/sk/_lib/localize.js
var eraValues68={
narrow:["pred Kr.","po Kr."],
abbreviated:["pred Kr.","po Kr."],
wide:["pred Kristom","po Kristovi"]
};
var quarterValues68={
narrow:["1","2","3","4"],
abbreviated:["Q1","Q2","Q3","Q4"],
wide:["1. \u0161tvr\u0165rok","2. \u0161tvr\u0165rok","3. \u0161tvr\u0165rok","4. \u0161tvr\u0165rok"]
};
var monthValues68={
narrow:["j","f","m","a","m","j","j","a","s","o","n","d"],
abbreviated:[
"jan",
"feb",
"mar",
"apr",
"m\xE1j",
"j\xFAn",
"j\xFAl",
"aug",
"sep",
"okt",
"nov",
"dec"],

wide:[
"janu\xE1r",
"febru\xE1r",
"marec",
"apr\xEDl",
"m\xE1j",
"j\xFAn",
"j\xFAl",
"august",
"september",
"okt\xF3ber",
"november",
"december"]

};
var formattingMonthValues15={
narrow:["j","f","m","a","m","j","j","a","s","o","n","d"],
abbreviated:[
"jan",
"feb",
"mar",
"apr",
"m\xE1j",
"j\xFAn",
"j\xFAl",
"aug",
"sep",
"okt",
"nov",
"dec"],

wide:[
"janu\xE1ra",
"febru\xE1ra",
"marca",
"apr\xEDla",
"m\xE1ja",
"j\xFAna",
"j\xFAla",
"augusta",
"septembra",
"okt\xF3bra",
"novembra",
"decembra"]

};
var dayValues68={
narrow:["n","p","u","s","\u0161","p","s"],
short:["ne","po","ut","st","\u0161t","pi","so"],
abbreviated:["ne","po","ut","st","\u0161t","pi","so"],
wide:[
"nede\u013Ea",
"pondelok",
"utorok",
"streda",
"\u0161tvrtok",
"piatok",
"sobota"]

};
var dayPeriodValues68={
narrow:{
am:"AM",
pm:"PM",
midnight:"poln.",
noon:"pol.",
morning:"r\xE1no",
afternoon:"pop.",
evening:"ve\u010D.",
night:"noc"
},
abbreviated:{
am:"AM",
pm:"PM",
midnight:"poln.",
noon:"pol.",
morning:"r\xE1no",
afternoon:"popol.",
evening:"ve\u010Der",
night:"noc"
},
wide:{
am:"AM",
pm:"PM",
midnight:"polnoc",
noon:"poludnie",
morning:"r\xE1no",
afternoon:"popoludnie",
evening:"ve\u010Der",
night:"noc"
}
};
var formattingDayPeriodValues52={
narrow:{
am:"AM",
pm:"PM",
midnight:"o poln.",
noon:"nap.",
morning:"r\xE1no",
afternoon:"pop.",
evening:"ve\u010D.",
night:"v n."
},
abbreviated:{
am:"AM",
pm:"PM",
midnight:"o poln.",
noon:"napol.",
morning:"r\xE1no",
afternoon:"popol.",
evening:"ve\u010Der",
night:"v noci"
},
wide:{
am:"AM",
pm:"PM",
midnight:"o polnoci",
noon:"napoludnie",
morning:"r\xE1no",
afternoon:"popoludn\xED",
evening:"ve\u010Der",
night:"v noci"
}
};
var ordinalNumber68=function ordinalNumber68(dirtyNumber,_options){
var number=Number(dirtyNumber);
return number+".";
};
var localize148={
ordinalNumber:ordinalNumber68,
era:buildLocalizeFn({
values:eraValues68,
defaultWidth:"wide"
}),
quarter:buildLocalizeFn({
values:quarterValues68,
defaultWidth:"wide",
argumentCallback:function argumentCallback(quarter){return quarter-1;}
}),
month:buildLocalizeFn({
values:monthValues68,
defaultWidth:"wide",
formattingValues:formattingMonthValues15,
defaultFormattingWidth:"wide"
}),
day:buildLocalizeFn({
values:dayValues68,
defaultWidth:"wide"
}),
dayPeriod:buildLocalizeFn({
values:dayPeriodValues68,
defaultWidth:"wide",
formattingValues:formattingDayPeriodValues52,
defaultFormattingWidth:"wide"
})
};

// lib/locale/sk/_lib/match.js
var matchOrdinalNumberPattern67=/^(\d+)\.?/i;
var parseOrdinalNumberPattern67=/\d+/i;
var matchEraPatterns67={
narrow:/^(pred Kr\.|pred n\. l\.|po Kr\.|n\. l\.)/i,
abbreviated:/^(pred Kr\.|pred n\. l\.|po Kr\.|n\. l\.)/i,
wide:/^(pred Kristom|pred na[šs][íi]m letopo[čc]tom|po Kristovi|n[áa][šs]ho letopo[čc]tu)/i
};
var parseEraPatterns67={
any:[/^pr/i,/^(po|n)/i]
};
var matchQuarterPatterns67={
narrow:/^[1234]/i,
abbreviated:/^q[1234]/i,
wide:/^[1234]\. [šs]tvr[ťt]rok/i
};
var parseQuarterPatterns67={
any:[/1/i,/2/i,/3/i,/4/i]
};
var matchMonthPatterns67={
narrow:/^[jfmasond]/i,
abbreviated:/^(jan|feb|mar|apr|m[áa]j|j[úu]n|j[úu]l|aug|sep|okt|nov|dec)/i,
wide:/^(janu[áa]ra?|febru[áa]ra?|(marec|marca)|apr[íi]la?|m[áa]ja?|j[úu]na?|j[úu]la?|augusta?|(september|septembra)|(okt[óo]ber|okt[óo]bra)|(november|novembra)|(december|decembra))/i
};
var parseMonthPatterns67={
narrow:[
/^j/i,
/^f/i,
/^m/i,
/^a/i,
/^m/i,
/^j/i,
/^j/i,
/^a/i,
/^s/i,
/^o/i,
/^n/i,
/^d/i],

any:[
/^ja/i,
/^f/i,
/^mar/i,
/^ap/i,
/^m[áa]j/i,
/^j[úu]n/i,
/^j[úu]l/i,
/^au/i,
/^s/i,
/^o/i,
/^n/i,
/^d/i]

};
var matchDayPatterns67={
narrow:/^[npusšp]/i,
short:/^(ne|po|ut|st|št|pi|so)/i,
abbreviated:/^(ne|po|ut|st|št|pi|so)/i,
wide:/^(nede[ľl]a|pondelok|utorok|streda|[šs]tvrtok|piatok|sobota])/i
};
var parseDayPatterns67={
narrow:[/^n/i,/^p/i,/^u/i,/^s/i,/^š/i,/^p/i,/^s/i],
any:[/^n/i,/^po/i,/^u/i,/^st/i,/^(št|stv)/i,/^pi/i,/^so/i]
};
var matchDayPeriodPatterns67={
narrow:/^(am|pm|(o )?poln\.?|(nap\.?|pol\.?)|r[áa]no|pop\.?|ve[čc]\.?|(v n\.?|noc))/i,
abbreviated:/^(am|pm|(o )?poln\.?|(napol\.?|pol\.?)|r[áa]no|pop\.?|ve[čc]er|(v )?noci?)/i,
any:/^(am|pm|(o )?polnoci?|(na)?poludnie|r[áa]no|popoludn(ie|í|i)|ve[čc]er|(v )?noci?)/i
};
var parseDayPeriodPatterns67={
any:{
am:/^am/i,
pm:/^pm/i,
midnight:/poln/i,
noon:/^(nap|(na)?pol(\.|u))/i,
morning:/^r[áa]no/i,
afternoon:/^pop/i,
evening:/^ve[čc]/i,
night:/^(noc|v n\.)/i
}
};
var match144={
ordinalNumber:buildMatchPatternFn({
matchPattern:matchOrdinalNumberPattern67,
parsePattern:parseOrdinalNumberPattern67,
valueCallback:function valueCallback(value){return parseInt(value,10);}
}),
era:buildMatchFn({
matchPatterns:matchEraPatterns67,
defaultMatchWidth:"wide",
parsePatterns:parseEraPatterns67,
defaultParseWidth:"any"
}),
quarter:buildMatchFn({
matchPatterns:matchQuarterPatterns67,
defaultMatchWidth:"wide",
parsePatterns:parseQuarterPatterns67,
defaultParseWidth:"any",
valueCallback:function valueCallback(index){return index+1;}
}),
month:buildMatchFn({
matchPatterns:matchMonthPatterns67,
defaultMatchWidth:"wide",
parsePatterns:parseMonthPatterns67,
defaultParseWidth:"any"
}),
day:buildMatchFn({
matchPatterns:matchDayPatterns67,
defaultMatchWidth:"wide",
parsePatterns:parseDayPatterns67,
defaultParseWidth:"any"
}),
dayPeriod:buildMatchFn({
matchPatterns:matchDayPeriodPatterns67,
defaultMatchWidth:"any",
parsePatterns:parseDayPeriodPatterns67,
defaultParseWidth:"any"
})
};

// lib/locale/sk.js
var _sk={
code:"sk",
formatDistance:formatDistance145,
formatLong:formatLong153,
formatRelative:formatRelative145,
localize:localize148,
match:match144,
options:{
weekStartsOn:1,
firstWeekContainsDate:4
}
};
// lib/locale/sl/_lib/formatDistance.js
function isPluralType(val){
return val.one!==undefined;
}
function getFormFromCount(count){
switch(count%100){
case 1:
return"one";
case 2:
return"two";
case 3:
case 4:
return"few";
default:
return"other";
}
}
var formatDistanceLocale68={
lessThanXSeconds:{
present:{
one:"manj kot {{count}} sekunda",
two:"manj kot {{count}} sekundi",
few:"manj kot {{count}} sekunde",
other:"manj kot {{count}} sekund"
},
past:{
one:"manj kot {{count}} sekundo",
two:"manj kot {{count}} sekundama",
few:"manj kot {{count}} sekundami",
other:"manj kot {{count}} sekundami"
},
future:{
one:"manj kot {{count}} sekundo",
two:"manj kot {{count}} sekundi",
few:"manj kot {{count}} sekunde",
other:"manj kot {{count}} sekund"
}
},
xSeconds:{
present:{
one:"{{count}} sekunda",
two:"{{count}} sekundi",
few:"{{count}} sekunde",
other:"{{count}} sekund"
},
past:{
one:"{{count}} sekundo",
two:"{{count}} sekundama",
few:"{{count}} sekundami",
other:"{{count}} sekundami"
},
future:{
one:"{{count}} sekundo",
two:"{{count}} sekundi",
few:"{{count}} sekunde",
other:"{{count}} sekund"
}
},
halfAMinute:"pol minute",
lessThanXMinutes:{
present:{
one:"manj kot {{count}} minuta",
two:"manj kot {{count}} minuti",
few:"manj kot {{count}} minute",
other:"manj kot {{count}} minut"
},
past:{
one:"manj kot {{count}} minuto",
two:"manj kot {{count}} minutama",
few:"manj kot {{count}} minutami",
other:"manj kot {{count}} minutami"
},
future:{
one:"manj kot {{count}} minuto",
two:"manj kot {{count}} minuti",
few:"manj kot {{count}} minute",
other:"manj kot {{count}} minut"
}
},
xMinutes:{
present:{
one:"{{count}} minuta",
two:"{{count}} minuti",
few:"{{count}} minute",
other:"{{count}} minut"
},
past:{
one:"{{count}} minuto",
two:"{{count}} minutama",
few:"{{count}} minutami",
other:"{{count}} minutami"
},
future:{
one:"{{count}} minuto",
two:"{{count}} minuti",
few:"{{count}} minute",
other:"{{count}} minut"
}
},
aboutXHours:{
present:{
one:"pribli\u017Eno {{count}} ura",
two:"pribli\u017Eno {{count}} uri",
few:"pribli\u017Eno {{count}} ure",
other:"pribli\u017Eno {{count}} ur"
},
past:{
one:"pribli\u017Eno {{count}} uro",
two:"pribli\u017Eno {{count}} urama",
few:"pribli\u017Eno {{count}} urami",
other:"pribli\u017Eno {{count}} urami"
},
future:{
one:"pribli\u017Eno {{count}} uro",
two:"pribli\u017Eno {{count}} uri",
few:"pribli\u017Eno {{count}} ure",
other:"pribli\u017Eno {{count}} ur"
}
},
xHours:{
present:{
one:"{{count}} ura",
two:"{{count}} uri",
few:"{{count}} ure",
other:"{{count}} ur"
},
past:{
one:"{{count}} uro",
two:"{{count}} urama",
few:"{{count}} urami",
other:"{{count}} urami"
},
future:{
one:"{{count}} uro",
two:"{{count}} uri",
few:"{{count}} ure",
other:"{{count}} ur"
}
},
xDays:{
present:{
one:"{{count}} dan",
two:"{{count}} dni",
few:"{{count}} dni",
other:"{{count}} dni"
},
past:{
one:"{{count}} dnem",
two:"{{count}} dnevoma",
few:"{{count}} dnevi",
other:"{{count}} dnevi"
},
future:{
one:"{{count}} dan",
two:"{{count}} dni",
few:"{{count}} dni",
other:"{{count}} dni"
}
},
aboutXWeeks:{
one:"pribli\u017Eno {{count}} teden",
two:"pribli\u017Eno {{count}} tedna",
few:"pribli\u017Eno {{count}} tedne",
other:"pribli\u017Eno {{count}} tednov"
},
xWeeks:{
one:"{{count}} teden",
two:"{{count}} tedna",
few:"{{count}} tedne",
other:"{{count}} tednov"
},
aboutXMonths:{
present:{
one:"pribli\u017Eno {{count}} mesec",
two:"pribli\u017Eno {{count}} meseca",
few:"pribli\u017Eno {{count}} mesece",
other:"pribli\u017Eno {{count}} mesecev"
},
past:{
one:"pribli\u017Eno {{count}} mesecem",
two:"pribli\u017Eno {{count}} mesecema",
few:"pribli\u017Eno {{count}} meseci",
other:"pribli\u017Eno {{count}} meseci"
},
future:{
one:"pribli\u017Eno {{count}} mesec",
two:"pribli\u017Eno {{count}} meseca",
few:"pribli\u017Eno {{count}} mesece",
other:"pribli\u017Eno {{count}} mesecev"
}
},
xMonths:{
present:{
one:"{{count}} mesec",
two:"{{count}} meseca",
few:"{{count}} meseci",
other:"{{count}} mesecev"
},
past:{
one:"{{count}} mesecem",
two:"{{count}} mesecema",
few:"{{count}} meseci",
other:"{{count}} meseci"
},
future:{
one:"{{count}} mesec",
two:"{{count}} meseca",
few:"{{count}} mesece",
other:"{{count}} mesecev"
}
},
aboutXYears:{
present:{
one:"pribli\u017Eno {{count}} leto",
two:"pribli\u017Eno {{count}} leti",
few:"pribli\u017Eno {{count}} leta",
other:"pribli\u017Eno {{count}} let"
},
past:{
one:"pribli\u017Eno {{count}} letom",
two:"pribli\u017Eno {{count}} letoma",
few:"pribli\u017Eno {{count}} leti",
other:"pribli\u017Eno {{count}} leti"
},
future:{
one:"pribli\u017Eno {{count}} leto",
two:"pribli\u017Eno {{count}} leti",
few:"pribli\u017Eno {{count}} leta",
other:"pribli\u017Eno {{count}} let"
}
},
xYears:{
present:{
one:"{{count}} leto",
two:"{{count}} leti",
few:"{{count}} leta",
other:"{{count}} let"
},
past:{
one:"{{count}} letom",
two:"{{count}} letoma",
few:"{{count}} leti",
other:"{{count}} leti"
},
future:{
one:"{{count}} leto",
two:"{{count}} leti",
few:"{{count}} leta",
other:"{{count}} let"
}
},
overXYears:{
present:{
one:"ve\u010D kot {{count}} leto",
two:"ve\u010D kot {{count}} leti",
few:"ve\u010D kot {{count}} leta",
other:"ve\u010D kot {{count}} let"
},
past:{
one:"ve\u010D kot {{count}} letom",
two:"ve\u010D kot {{count}} letoma",
few:"ve\u010D kot {{count}} leti",
other:"ve\u010D kot {{count}} leti"
},
future:{
one:"ve\u010D kot {{count}} leto",
two:"ve\u010D kot {{count}} leti",
few:"ve\u010D kot {{count}} leta",
other:"ve\u010D kot {{count}} let"
}
},
almostXYears:{
present:{
one:"skoraj {{count}} leto",
two:"skoraj {{count}} leti",
few:"skoraj {{count}} leta",
other:"skoraj {{count}} let"
},
past:{
one:"skoraj {{count}} letom",
two:"skoraj {{count}} letoma",
few:"skoraj {{count}} leti",
other:"skoraj {{count}} leti"
},
future:{
one:"skoraj {{count}} leto",
two:"skoraj {{count}} leti",
few:"skoraj {{count}} leta",
other:"skoraj {{count}} let"
}
}
};
var formatDistance147=function formatDistance147(token,count,options){
var result="";
var tense="present";
if(options!==null&&options!==void 0&&options.addSuffix){
if(options.comparison&&options.comparison>0){
tense="future";
result="\u010Dez ";
}else{
tense="past";
result="pred ";
}
}
var tokenValue=formatDistanceLocale68[token];
if(typeof tokenValue==="string"){
result+=tokenValue;
}else{
var form=getFormFromCount(count);
if(isPluralType(tokenValue)){
result+=tokenValue[form].replace("{{count}}",String(count));
}else{
result+=tokenValue[tense][form].replace("{{count}}",String(count));
}
}
return result;
};

// lib/locale/sl/_lib/formatLong.js
var dateFormats77={
full:"EEEE, dd. MMMM y",
long:"dd. MMMM y",
medium:"d. MMM y",
short:"d. MM. yy"
};
var timeFormats77={
full:"HH:mm:ss zzzz",
long:"HH:mm:ss z",
medium:"HH:mm:ss",
short:"HH:mm"
};
var dateTimeFormats77={
full:"{{date}} {{time}}",
long:"{{date}} {{time}}",
medium:"{{date}} {{time}}",
short:"{{date}} {{time}}"
};
var formatLong155={
date:buildFormatLongFn({
formats:dateFormats77,
defaultWidth:"full"
}),
time:buildFormatLongFn({
formats:timeFormats77,
defaultWidth:"full"
}),
dateTime:buildFormatLongFn({
formats:dateTimeFormats77,
defaultWidth:"full"
})
};

// lib/locale/sl/_lib/formatRelative.js
var formatRelativeLocale69={
lastWeek:function lastWeek(date){
var day=date.getDay();
switch(day){
case 0:
return"'prej\u0161njo nedeljo ob' p";
case 3:
return"'prej\u0161njo sredo ob' p";
case 6:
return"'prej\u0161njo soboto ob' p";
default:
return"'prej\u0161nji' EEEE 'ob' p";
}
},
yesterday:"'v\u010Deraj ob' p",
today:"'danes ob' p",
tomorrow:"'jutri ob' p",
nextWeek:function nextWeek(date){
var day=date.getDay();
switch(day){
case 0:
return"'naslednjo nedeljo ob' p";
case 3:
return"'naslednjo sredo ob' p";
case 6:
return"'naslednjo soboto ob' p";
default:
return"'naslednji' EEEE 'ob' p";
}
},
other:"P"
};
var formatRelative147=function formatRelative147(token,date,_baseDate,_options){
var format=formatRelativeLocale69[token];
if(typeof format==="function"){
return format(date);
}
return format;
};

// lib/locale/sl/_lib/localize.js
var eraValues69={
narrow:["pr. n. \u0161t.","po n. \u0161t."],
abbreviated:["pr. n. \u0161t.","po n. \u0161t."],
wide:["pred na\u0161im \u0161tetjem","po na\u0161em \u0161tetju"]
};
var quarterValues69={
narrow:["1","2","3","4"],
abbreviated:["1. \u010Det.","2. \u010Det.","3. \u010Det.","4. \u010Det."],
wide:["1. \u010Detrtletje","2. \u010Detrtletje","3. \u010Detrtletje","4. \u010Detrtletje"]
};
var monthValues69={
narrow:["j","f","m","a","m","j","j","a","s","o","n","d"],
abbreviated:[
"jan.",
"feb.",
"mar.",
"apr.",
"maj",
"jun.",
"jul.",
"avg.",
"sep.",
"okt.",
"nov.",
"dec."],

wide:[
"januar",
"februar",
"marec",
"april",
"maj",
"junij",
"julij",
"avgust",
"september",
"oktober",
"november",
"december"]

};
var dayValues69={
narrow:["n","p","t","s","\u010D","p","s"],
short:["ned.","pon.","tor.","sre.","\u010Det.","pet.","sob."],
abbreviated:["ned.","pon.","tor.","sre.","\u010Det.","pet.","sob."],
wide:[
"nedelja",
"ponedeljek",
"torek",
"sreda",
"\u010Detrtek",
"petek",
"sobota"]

};
var dayPeriodValues69={
narrow:{
am:"d",
pm:"p",
midnight:"24.00",
noon:"12.00",
morning:"j",
afternoon:"p",
evening:"v",
night:"n"
},
abbreviated:{
am:"dop.",
pm:"pop.",
midnight:"poln.",
noon:"pold.",
morning:"jut.",
afternoon:"pop.",
evening:"ve\u010D.",
night:"no\u010D"
},
wide:{
am:"dop.",
pm:"pop.",
midnight:"polno\u010D",
noon:"poldne",
morning:"jutro",
afternoon:"popoldne",
evening:"ve\u010Der",
night:"no\u010D"
}
};
var formattingDayPeriodValues53={
narrow:{
am:"d",
pm:"p",
midnight:"24.00",
noon:"12.00",
morning:"zj",
afternoon:"p",
evening:"zv",
night:"po"
},
abbreviated:{
am:"dop.",
pm:"pop.",
midnight:"opoln.",
noon:"opold.",
morning:"zjut.",
afternoon:"pop.",
evening:"zve\u010D.",
night:"pono\u010Di"
},
wide:{
am:"dop.",
pm:"pop.",
midnight:"opolno\u010Di",
noon:"opoldne",
morning:"zjutraj",
afternoon:"popoldan",
evening:"zve\u010Der",
night:"pono\u010Di"
}
};
var ordinalNumber69=function ordinalNumber69(dirtyNumber,_options){
var number=Number(dirtyNumber);
return number+".";
};
var localize150={
ordinalNumber:ordinalNumber69,
era:buildLocalizeFn({
values:eraValues69,
defaultWidth:"wide"
}),
quarter:buildLocalizeFn({
values:quarterValues69,
defaultWidth:"wide",
argumentCallback:function argumentCallback(quarter){return quarter-1;}
}),
month:buildLocalizeFn({
values:monthValues69,
defaultWidth:"wide"
}),
day:buildLocalizeFn({
values:dayValues69,
defaultWidth:"wide"
}),
dayPeriod:buildLocalizeFn({
values:dayPeriodValues69,
defaultWidth:"wide",
formattingValues:formattingDayPeriodValues53,
defaultFormattingWidth:"wide"
})
};

// lib/locale/sl/_lib/match.js
var matchOrdinalNumberPattern68=/^(\d+)\./i;
var parseOrdinalNumberPattern68=/\d+/i;
var matchEraPatterns68={
abbreviated:/^(pr\. n\. št\.|po n\. št\.)/i,
wide:/^(pred Kristusom|pred na[sš]im [sš]tetjem|po Kristusu|po na[sš]em [sš]tetju|na[sš]ega [sš]tetja)/i
};
var parseEraPatterns68={
any:[/^pr/i,/^(po|na[sš]em)/i]
};
var matchQuarterPatterns68={
narrow:/^[1234]/i,
abbreviated:/^[1234]\.\s?[čc]et\.?/i,
wide:/^[1234]\. [čc]etrtletje/i
};
var parseQuarterPatterns68={
any:[/1/i,/2/i,/3/i,/4/i]
};
var matchMonthPatterns68={
narrow:/^[jfmasond]/i,
abbreviated:/^(jan\.|feb\.|mar\.|apr\.|maj|jun\.|jul\.|avg\.|sep\.|okt\.|nov\.|dec\.)/i,
wide:/^(januar|februar|marec|april|maj|junij|julij|avgust|september|oktober|november|december)/i
};
var parseMonthPatterns68={
narrow:[
/^j/i,
/^f/i,
/^m/i,
/^a/i,
/^m/i,
/^j/i,
/^j/i,
/^a/i,
/^s/i,
/^o/i,
/^n/i,
/^d/i],

abbreviated:[
/^ja/i,
/^fe/i,
/^mar/i,
/^ap/i,
/^maj/i,
/^jun/i,
/^jul/i,
/^av/i,
/^s/i,
/^o/i,
/^n/i,
/^d/i],

wide:[
/^ja/i,
/^fe/i,
/^mar/i,
/^ap/i,
/^maj/i,
/^jun/i,
/^jul/i,
/^av/i,
/^s/i,
/^o/i,
/^n/i,
/^d/i]

};
var matchDayPatterns68={
narrow:/^[nptsčc]/i,
short:/^(ned\.|pon\.|tor\.|sre\.|[cč]et\.|pet\.|sob\.)/i,
abbreviated:/^(ned\.|pon\.|tor\.|sre\.|[cč]et\.|pet\.|sob\.)/i,
wide:/^(nedelja|ponedeljek|torek|sreda|[cč]etrtek|petek|sobota)/i
};
var parseDayPatterns68={
narrow:[/^n/i,/^p/i,/^t/i,/^s/i,/^[cč]/i,/^p/i,/^s/i],
any:[/^n/i,/^po/i,/^t/i,/^sr/i,/^[cč]/i,/^pe/i,/^so/i]
};
var matchDayPeriodPatterns68={
narrow:/^(d|po?|z?v|n|z?j|24\.00|12\.00)/i,
any:/^(dop\.|pop\.|o?poln(\.|o[cč]i?)|o?pold(\.|ne)|z?ve[cč](\.|er)|(po)?no[cč]i?|popold(ne|an)|jut(\.|ro)|zjut(\.|raj))/i
};
var parseDayPeriodPatterns68={
narrow:{
am:/^d/i,
pm:/^p/i,
midnight:/^24/i,
noon:/^12/i,
morning:/^(z?j)/i,
afternoon:/^p/i,
evening:/^(z?v)/i,
night:/^(n|po)/i
},
any:{
am:/^dop\./i,
pm:/^pop\./i,
midnight:/^o?poln/i,
noon:/^o?pold/i,
morning:/j/i,
afternoon:/^pop\./i,
evening:/^z?ve/i,
night:/(po)?no/i
}
};
var match146={
ordinalNumber:buildMatchPatternFn({
matchPattern:matchOrdinalNumberPattern68,
parsePattern:parseOrdinalNumberPattern68,
valueCallback:function valueCallback(value){return parseInt(value,10);}
}),
era:buildMatchFn({
matchPatterns:matchEraPatterns68,
defaultMatchWidth:"wide",
parsePatterns:parseEraPatterns68,
defaultParseWidth:"any"
}),
quarter:buildMatchFn({
matchPatterns:matchQuarterPatterns68,
defaultMatchWidth:"wide",
parsePatterns:parseQuarterPatterns68,
defaultParseWidth:"any",
valueCallback:function valueCallback(index){return index+1;}
}),
month:buildMatchFn({
matchPatterns:matchMonthPatterns68,
defaultMatchWidth:"wide",
parsePatterns:parseMonthPatterns68,
defaultParseWidth:"wide"
}),
day:buildMatchFn({
matchPatterns:matchDayPatterns68,
defaultMatchWidth:"wide",
parsePatterns:parseDayPatterns68,
defaultParseWidth:"any"
}),
dayPeriod:buildMatchFn({
matchPatterns:matchDayPeriodPatterns68,
defaultMatchWidth:"any",
parsePatterns:parseDayPeriodPatterns68,
defaultParseWidth:"any"
})
};

// lib/locale/sl.js
var _sl={
code:"sl",
formatDistance:formatDistance147,
formatLong:formatLong155,
formatRelative:formatRelative147,
localize:localize150,
match:match146,
options:{
weekStartsOn:1,
firstWeekContainsDate:1
}
};
// lib/locale/sq/_lib/formatDistance.js
var formatDistanceLocale69={
lessThanXSeconds:{
one:"m\xEB pak se nj\xEB sekond\xEB",
other:"m\xEB pak se {{count}} sekonda"
},
xSeconds:{
one:"1 sekond\xEB",
other:"{{count}} sekonda"
},
halfAMinute:"gjys\xEBm minuti",
lessThanXMinutes:{
one:"m\xEB pak se nj\xEB minute",
other:"m\xEB pak se {{count}} minuta"
},
xMinutes:{
one:"1 minut\xEB",
other:"{{count}} minuta"
},
aboutXHours:{
one:"rreth 1 or\xEB",
other:"rreth {{count}} or\xEB"
},
xHours:{
one:"1 or\xEB",
other:"{{count}} or\xEB"
},
xDays:{
one:"1 dit\xEB",
other:"{{count}} dit\xEB"
},
aboutXWeeks:{
one:"rreth 1 jav\xEB",
other:"rreth {{count}} jav\xEB"
},
xWeeks:{
one:"1 jav\xEB",
other:"{{count}} jav\xEB"
},
aboutXMonths:{
one:"rreth 1 muaj",
other:"rreth {{count}} muaj"
},
xMonths:{
one:"1 muaj",
other:"{{count}} muaj"
},
aboutXYears:{
one:"rreth 1 vit",
other:"rreth {{count}} vite"
},
xYears:{
one:"1 vit",
other:"{{count}} vite"
},
overXYears:{
one:"mbi 1 vit",
other:"mbi {{count}} vite"
},
almostXYears:{
one:"pothuajse 1 vit",
other:"pothuajse {{count}} vite"
}
};
var formatDistance149=function formatDistance149(token,count,options){
var result;
var tokenValue=formatDistanceLocale69[token];
if(typeof tokenValue==="string"){
result=tokenValue;
}else if(count===1){
result=tokenValue.one;
}else{
result=tokenValue.other.replace("{{count}}",String(count));
}
if(options!==null&&options!==void 0&&options.addSuffix){
if(options.comparison&&options.comparison>0){
return"n\xEB "+result;
}else{
return result+" m\xEB par\xEB";
}
}
return result;
};

// lib/locale/sq/_lib/formatLong.js
var dateFormats78={
full:"EEEE, MMMM do, y",
long:"MMMM do, y",
medium:"MMM d, y",
short:"MM/dd/yyyy"
};
var timeFormats78={
full:"h:mm:ss a zzzz",
long:"h:mm:ss a z",
medium:"h:mm:ss a",
short:"h:mm a"
};
var dateTimeFormats78={
full:"{{date}} 'n\xEB' {{time}}",
long:"{{date}} 'n\xEB' {{time}}",
medium:"{{date}}, {{time}}",
short:"{{date}}, {{time}}"
};
var formatLong157={
date:buildFormatLongFn({
formats:dateFormats78,
defaultWidth:"full"
}),
time:buildFormatLongFn({
formats:timeFormats78,
defaultWidth:"full"
}),
dateTime:buildFormatLongFn({
formats:dateTimeFormats78,
defaultWidth:"full"
})
};

// lib/locale/sq/_lib/formatRelative.js
var formatRelativeLocale70={
lastWeek:"'t\xEB' eeee 'e shkuar n\xEB' p",
yesterday:"'dje n\xEB' p",
today:"'sot n\xEB' p",
tomorrow:"'nes\xEBr n\xEB' p",
nextWeek:"eeee 'at' p",
other:"P"
};
var formatRelative149=function formatRelative149(token,_date,_baseDate,_options){return formatRelativeLocale70[token];};

// lib/locale/sq/_lib/localize.js
var eraValues70={
narrow:["P","M"],
abbreviated:["PK","MK"],
wide:["Para Krishtit","Mbas Krishtit"]
};
var quarterValues70={
narrow:["1","2","3","4"],
abbreviated:["Q1","Q2","Q3","Q4"],
wide:["4-mujori I","4-mujori II","4-mujori III","4-mujori IV"]
};
var monthValues70={
narrow:["J","S","M","P","M","Q","K","G","S","T","N","D"],
abbreviated:[
"Jan",
"Shk",
"Mar",
"Pri",
"Maj",
"Qer",
"Kor",
"Gus",
"Sht",
"Tet",
"N\xEBn",
"Dhj"],

wide:[
"Janar",
"Shkurt",
"Mars",
"Prill",
"Maj",
"Qershor",
"Korrik",
"Gusht",
"Shtator",
"Tetor",
"N\xEBntor",
"Dhjetor"]

};
var dayValues70={
narrow:["D","H","M","M","E","P","S"],
short:["Di","H\xEB","Ma","M\xEB","En","Pr","Sh"],
abbreviated:["Die","H\xEBn","Mar","M\xEBr","Enj","Pre","Sht"],
wide:["Diel\xEB","H\xEBn\xEB","Mart\xEB","M\xEBrkur\xEB","Enjte","Premte","Shtun\xEB"]
};
var dayPeriodValues70={
narrow:{
am:"p",
pm:"m",
midnight:"m",
noon:"d",
morning:"m\xEBngjes",
afternoon:"dite",
evening:"mbr\xEBmje",
night:"nat\xEB"
},
abbreviated:{
am:"PD",
pm:"MD",
midnight:"mesn\xEBt\xEB",
noon:"drek",
morning:"m\xEBngjes",
afternoon:"mbasdite",
evening:"mbr\xEBmje",
night:"nat\xEB"
},
wide:{
am:"p.d.",
pm:"m.d.",
midnight:"mesn\xEBt\xEB",
noon:"drek",
morning:"m\xEBngjes",
afternoon:"mbasdite",
evening:"mbr\xEBmje",
night:"nat\xEB"
}
};
var formattingDayPeriodValues54={
narrow:{
am:"p",
pm:"m",
midnight:"m",
noon:"d",
morning:"n\xEB m\xEBngjes",
afternoon:"n\xEB mbasdite",
evening:"n\xEB mbr\xEBmje",
night:"n\xEB mesnat\xEB"
},
abbreviated:{
am:"PD",
pm:"MD",
midnight:"mesnat\xEB",
noon:"drek",
morning:"n\xEB m\xEBngjes",
afternoon:"n\xEB mbasdite",
evening:"n\xEB mbr\xEBmje",
night:"n\xEB mesnat\xEB"
},
wide:{
am:"p.d.",
pm:"m.d.",
midnight:"mesnat\xEB",
noon:"drek",
morning:"n\xEB m\xEBngjes",
afternoon:"n\xEB mbasdite",
evening:"n\xEB mbr\xEBmje",
night:"n\xEB mesnat\xEB"
}
};
var ordinalNumber70=function ordinalNumber70(dirtyNumber,options){
var number=Number(dirtyNumber);
if((options===null||options===void 0?void 0:options.unit)==="hour")
return String(number);
if(number===1)
return number+"-r\xEB";
if(number===4)
return number+"t";
return number+"-t\xEB";
};
var localize152={
ordinalNumber:ordinalNumber70,
era:buildLocalizeFn({
values:eraValues70,
defaultWidth:"wide"
}),
quarter:buildLocalizeFn({
values:quarterValues70,
defaultWidth:"wide",
argumentCallback:function argumentCallback(quarter){return quarter-1;}
}),
month:buildLocalizeFn({
values:monthValues70,
defaultWidth:"wide"
}),
day:buildLocalizeFn({
values:dayValues70,
defaultWidth:"wide"
}),
dayPeriod:buildLocalizeFn({
values:dayPeriodValues70,
defaultWidth:"wide",
formattingValues:formattingDayPeriodValues54,
defaultFormattingWidth:"wide"
})
};

// lib/locale/sq/_lib/match.js
var matchOrdinalNumberPattern69=/^(\d+)(-rë|-të|t|)?/i;
var parseOrdinalNumberPattern69=/\d+/i;
var matchEraPatterns69={
narrow:/^(p|m)/i,
abbreviated:/^(b\.?\s?c\.?|b\.?\s?c\.?\s?e\.?|a\.?\s?d\.?|c\.?\s?e\.?)/i,
wide:/^(para krishtit|mbas krishtit)/i
};
var parseEraPatterns69={
any:[/^b/i,/^(p|m)/i]
};
var matchQuarterPatterns69={
narrow:/^[1234]/i,
abbreviated:/^q[1234]/i,
wide:/^[1234]-mujori (i{1,3}|iv)/i
};
var parseQuarterPatterns69={
any:[/1/i,/2/i,/3/i,/4/i]
};
var matchMonthPatterns69={
narrow:/^[jsmpqkftnd]/i,
abbreviated:/^(jan|shk|mar|pri|maj|qer|kor|gus|sht|tet|nën|dhj)/i,
wide:/^(janar|shkurt|mars|prill|maj|qershor|korrik|gusht|shtator|tetor|nëntor|dhjetor)/i
};
var parseMonthPatterns69={
narrow:[
/^j/i,
/^s/i,
/^m/i,
/^p/i,
/^m/i,
/^q/i,
/^k/i,
/^g/i,
/^s/i,
/^t/i,
/^n/i,
/^d/i],

any:[
/^ja/i,
/^shk/i,
/^mar/i,
/^pri/i,
/^maj/i,
/^qer/i,
/^kor/i,
/^gu/i,
/^sht/i,
/^tet/i,
/^n/i,
/^d/i]

};
var matchDayPatterns69={
narrow:/^[dhmeps]/i,
short:/^(di|hë|ma|më|en|pr|sh)/i,
abbreviated:/^(die|hën|mar|mër|enj|pre|sht)/i,
wide:/^(dielë|hënë|martë|mërkurë|enjte|premte|shtunë)/i
};
var parseDayPatterns69={
narrow:[/^d/i,/^h/i,/^m/i,/^m/i,/^e/i,/^p/i,/^s/i],
any:[/^d/i,/^h/i,/^ma/i,/^më/i,/^e/i,/^p/i,/^s/i]
};
var matchDayPeriodPatterns69={
narrow:/^(p|m|me|në (mëngjes|mbasdite|mbrëmje|mesnatë))/i,
any:/^([pm]\.?\s?d\.?|drek|në (mëngjes|mbasdite|mbrëmje|mesnatë))/i
};
var parseDayPeriodPatterns69={
any:{
am:/^p/i,
pm:/^m/i,
midnight:/^me/i,
noon:/^dr/i,
morning:/mëngjes/i,
afternoon:/mbasdite/i,
evening:/mbrëmje/i,
night:/natë/i
}
};
var match148={
ordinalNumber:buildMatchPatternFn({
matchPattern:matchOrdinalNumberPattern69,
parsePattern:parseOrdinalNumberPattern69,
valueCallback:function valueCallback(value){return parseInt(value,10);}
}),
era:buildMatchFn({
matchPatterns:matchEraPatterns69,
defaultMatchWidth:"wide",
parsePatterns:parseEraPatterns69,
defaultParseWidth:"any"
}),
quarter:buildMatchFn({
matchPatterns:matchQuarterPatterns69,
defaultMatchWidth:"wide",
parsePatterns:parseQuarterPatterns69,
defaultParseWidth:"any",
valueCallback:function valueCallback(index){return index+1;}
}),
month:buildMatchFn({
matchPatterns:matchMonthPatterns69,
defaultMatchWidth:"wide",
parsePatterns:parseMonthPatterns69,
defaultParseWidth:"any"
}),
day:buildMatchFn({
matchPatterns:matchDayPatterns69,
defaultMatchWidth:"wide",
parsePatterns:parseDayPatterns69,
defaultParseWidth:"any"
}),
dayPeriod:buildMatchFn({
matchPatterns:matchDayPeriodPatterns69,
defaultMatchWidth:"any",
parsePatterns:parseDayPeriodPatterns69,
defaultParseWidth:"any"
})
};

// lib/locale/sq.js
var _sq={
code:"sq",
formatDistance:formatDistance149,
formatLong:formatLong157,
formatRelative:formatRelative149,
localize:localize152,
match:match148,
options:{
weekStartsOn:1,
firstWeekContainsDate:1
}
};
// lib/locale/sr/_lib/formatDistance.js
var formatDistanceLocale70={
lessThanXSeconds:{
one:{
standalone:"\u043C\u0430\u045A\u0435 \u043E\u0434 1 \u0441\u0435\u043A\u0443\u043D\u0434\u0435",
withPrepositionAgo:"\u043C\u0430\u045A\u0435 \u043E\u0434 1 \u0441\u0435\u043A\u0443\u043D\u0434\u0435",
withPrepositionIn:"\u043C\u0430\u045A\u0435 \u043E\u0434 1 \u0441\u0435\u043A\u0443\u043D\u0434\u0443"
},
dual:"\u043C\u0430\u045A\u0435 \u043E\u0434 {{count}} \u0441\u0435\u043A\u0443\u043D\u0434\u0435",
other:"\u043C\u0430\u045A\u0435 \u043E\u0434 {{count}} \u0441\u0435\u043A\u0443\u043D\u0434\u0438"
},
xSeconds:{
one:{
standalone:"1 \u0441\u0435\u043A\u0443\u043D\u0434\u0430",
withPrepositionAgo:"1 \u0441\u0435\u043A\u0443\u043D\u0434\u0435",
withPrepositionIn:"1 \u0441\u0435\u043A\u0443\u043D\u0434\u0443"
},
dual:"{{count}} \u0441\u0435\u043A\u0443\u043D\u0434\u0435",
other:"{{count}} \u0441\u0435\u043A\u0443\u043D\u0434\u0438"
},
halfAMinute:"\u043F\u043E\u043B\u0430 \u043C\u0438\u043D\u0443\u0442\u0435",
lessThanXMinutes:{
one:{
standalone:"\u043C\u0430\u045A\u0435 \u043E\u0434 1 \u043C\u0438\u043D\u0443\u0442\u0435",
withPrepositionAgo:"\u043C\u0430\u045A\u0435 \u043E\u0434 1 \u043C\u0438\u043D\u0443\u0442\u0435",
withPrepositionIn:"\u043C\u0430\u045A\u0435 \u043E\u0434 1 \u043C\u0438\u043D\u0443\u0442\u0443"
},
dual:"\u043C\u0430\u045A\u0435 \u043E\u0434 {{count}} \u043C\u0438\u043D\u0443\u0442\u0435",
other:"\u043C\u0430\u045A\u0435 \u043E\u0434 {{count}} \u043C\u0438\u043D\u0443\u0442\u0430"
},
xMinutes:{
one:{
standalone:"1 \u043C\u0438\u043D\u0443\u0442\u0430",
withPrepositionAgo:"1 \u043C\u0438\u043D\u0443\u0442\u0435",
withPrepositionIn:"1 \u043C\u0438\u043D\u0443\u0442\u0443"
},
dual:"{{count}} \u043C\u0438\u043D\u0443\u0442\u0435",
other:"{{count}} \u043C\u0438\u043D\u0443\u0442\u0430"
},
aboutXHours:{
one:{
standalone:"\u043E\u043A\u043E 1 \u0441\u0430\u0442",
withPrepositionAgo:"\u043E\u043A\u043E 1 \u0441\u0430\u0442",
withPrepositionIn:"\u043E\u043A\u043E 1 \u0441\u0430\u0442"
},
dual:"\u043E\u043A\u043E {{count}} \u0441\u0430\u0442\u0430",
other:"\u043E\u043A\u043E {{count}} \u0441\u0430\u0442\u0438"
},
xHours:{
one:{
standalone:"1 \u0441\u0430\u0442",
withPrepositionAgo:"1 \u0441\u0430\u0442",
withPrepositionIn:"1 \u0441\u0430\u0442"
},
dual:"{{count}} \u0441\u0430\u0442\u0430",
other:"{{count}} \u0441\u0430\u0442\u0438"
},
xDays:{
one:{
standalone:"1 \u0434\u0430\u043D",
withPrepositionAgo:"1 \u0434\u0430\u043D",
withPrepositionIn:"1 \u0434\u0430\u043D"
},
dual:"{{count}} \u0434\u0430\u043D\u0430",
other:"{{count}} \u0434\u0430\u043D\u0430"
},
aboutXWeeks:{
one:{
standalone:"\u043E\u043A\u043E 1 \u043D\u0435\u0434\u0435\u0459\u0443",
withPrepositionAgo:"\u043E\u043A\u043E 1 \u043D\u0435\u0434\u0435\u0459\u0443",
withPrepositionIn:"\u043E\u043A\u043E 1 \u043D\u0435\u0434\u0435\u0459\u0443"
},
dual:"\u043E\u043A\u043E {{count}} \u043D\u0435\u0434\u0435\u0459\u0435",
other:"\u043E\u043A\u043E {{count}} \u043D\u0435\u0434\u0435\u0459\u0435"
},
xWeeks:{
one:{
standalone:"1 \u043D\u0435\u0434\u0435\u0459\u0443",
withPrepositionAgo:"1 \u043D\u0435\u0434\u0435\u0459\u0443",
withPrepositionIn:"1 \u043D\u0435\u0434\u0435\u0459\u0443"
},
dual:"{{count}} \u043D\u0435\u0434\u0435\u0459\u0435",
other:"{{count}} \u043D\u0435\u0434\u0435\u0459\u0435"
},
aboutXMonths:{
one:{
standalone:"\u043E\u043A\u043E 1 \u043C\u0435\u0441\u0435\u0446",
withPrepositionAgo:"\u043E\u043A\u043E 1 \u043C\u0435\u0441\u0435\u0446",
withPrepositionIn:"\u043E\u043A\u043E 1 \u043C\u0435\u0441\u0435\u0446"
},
dual:"\u043E\u043A\u043E {{count}} \u043C\u0435\u0441\u0435\u0446\u0430",
other:"\u043E\u043A\u043E {{count}} \u043C\u0435\u0441\u0435\u0446\u0438"
},
xMonths:{
one:{
standalone:"1 \u043C\u0435\u0441\u0435\u0446",
withPrepositionAgo:"1 \u043C\u0435\u0441\u0435\u0446",
withPrepositionIn:"1 \u043C\u0435\u0441\u0435\u0446"
},
dual:"{{count}} \u043C\u0435\u0441\u0435\u0446\u0430",
other:"{{count}} \u043C\u0435\u0441\u0435\u0446\u0438"
},
aboutXYears:{
one:{
standalone:"\u043E\u043A\u043E 1 \u0433\u043E\u0434\u0438\u043D\u0443",
withPrepositionAgo:"\u043E\u043A\u043E 1 \u0433\u043E\u0434\u0438\u043D\u0443",
withPrepositionIn:"\u043E\u043A\u043E 1 \u0433\u043E\u0434\u0438\u043D\u0443"
},
dual:"\u043E\u043A\u043E {{count}} \u0433\u043E\u0434\u0438\u043D\u0435",
other:"\u043E\u043A\u043E {{count}} \u0433\u043E\u0434\u0438\u043D\u0430"
},
xYears:{
one:{
standalone:"1 \u0433\u043E\u0434\u0438\u043D\u0430",
withPrepositionAgo:"1 \u0433\u043E\u0434\u0438\u043D\u0435",
withPrepositionIn:"1 \u0433\u043E\u0434\u0438\u043D\u0443"
},
dual:"{{count}} \u0433\u043E\u0434\u0438\u043D\u0435",
other:"{{count}} \u0433\u043E\u0434\u0438\u043D\u0430"
},
overXYears:{
one:{
standalone:"\u043F\u0440\u0435\u043A\u043E 1 \u0433\u043E\u0434\u0438\u043D\u0443",
withPrepositionAgo:"\u043F\u0440\u0435\u043A\u043E 1 \u0433\u043E\u0434\u0438\u043D\u0443",
withPrepositionIn:"\u043F\u0440\u0435\u043A\u043E 1 \u0433\u043E\u0434\u0438\u043D\u0443"
},
dual:"\u043F\u0440\u0435\u043A\u043E {{count}} \u0433\u043E\u0434\u0438\u043D\u0435",
other:"\u043F\u0440\u0435\u043A\u043E {{count}} \u0433\u043E\u0434\u0438\u043D\u0430"
},
almostXYears:{
one:{
standalone:"\u0433\u043E\u0442\u043E\u0432\u043E 1 \u0433\u043E\u0434\u0438\u043D\u0443",
withPrepositionAgo:"\u0433\u043E\u0442\u043E\u0432\u043E 1 \u0433\u043E\u0434\u0438\u043D\u0443",
withPrepositionIn:"\u0433\u043E\u0442\u043E\u0432\u043E 1 \u0433\u043E\u0434\u0438\u043D\u0443"
},
dual:"\u0433\u043E\u0442\u043E\u0432\u043E {{count}} \u0433\u043E\u0434\u0438\u043D\u0435",
other:"\u0433\u043E\u0442\u043E\u0432\u043E {{count}} \u0433\u043E\u0434\u0438\u043D\u0430"
}
};
var formatDistance151=function formatDistance151(token,count,options){
var result;
var tokenValue=formatDistanceLocale70[token];
if(typeof tokenValue==="string"){
result=tokenValue;
}else if(count===1){
if(options!==null&&options!==void 0&&options.addSuffix){
if(options.comparison&&options.comparison>0){
result=tokenValue.one.withPrepositionIn;
}else{
result=tokenValue.one.withPrepositionAgo;
}
}else{
result=tokenValue.one.standalone;
}
}else if(count%10>1&&count%10<5&&String(count).substr(-2,1)!=="1"){
result=tokenValue.dual.replace("{{count}}",String(count));
}else{
result=tokenValue.other.replace("{{count}}",String(count));
}
if(options!==null&&options!==void 0&&options.addSuffix){
if(options.comparison&&options.comparison>0){
return"\u0437\u0430 "+result;
}else{
return"\u043F\u0440\u0435 "+result;
}
}
return result;
};

// lib/locale/sr/_lib/formatLong.js
var dateFormats79={
full:"EEEE, d. MMMM yyyy.",
long:"d. MMMM yyyy.",
medium:"d. MMM yy.",
short:"dd. MM. yy."
};
var timeFormats79={
full:"HH:mm:ss (zzzz)",
long:"HH:mm:ss z",
medium:"HH:mm:ss",
short:"HH:mm"
};
var dateTimeFormats79={
full:"{{date}} '\u0443' {{time}}",
long:"{{date}} '\u0443' {{time}}",
medium:"{{date}} {{time}}",
short:"{{date}} {{time}}"
};
var formatLong159={
date:buildFormatLongFn({
formats:dateFormats79,
defaultWidth:"full"
}),
time:buildFormatLongFn({
formats:timeFormats79,
defaultWidth:"full"
}),
dateTime:buildFormatLongFn({
formats:dateTimeFormats79,
defaultWidth:"full"
})
};

// lib/locale/sr/_lib/formatRelative.js
var formatRelativeLocale71={
lastWeek:function lastWeek(date){
var day=date.getDay();
switch(day){
case 0:
return"'\u043F\u0440\u043E\u0448\u043B\u0435 \u043D\u0435\u0434\u0435\u0459\u0435 \u0443' p";
case 3:
return"'\u043F\u0440\u043E\u0448\u043B\u0435 \u0441\u0440\u0435\u0434\u0435 \u0443' p";
case 6:
return"'\u043F\u0440\u043E\u0448\u043B\u0435 \u0441\u0443\u0431\u043E\u0442\u0435 \u0443' p";
default:
return"'\u043F\u0440\u043E\u0448\u043B\u0438' EEEE '\u0443' p";
}
},
yesterday:"'\u0458\u0443\u0447\u0435 \u0443' p",
today:"'\u0434\u0430\u043D\u0430\u0441 \u0443' p",
tomorrow:"'\u0441\u0443\u0442\u0440\u0430 \u0443' p",
nextWeek:function nextWeek(date){
var day=date.getDay();
switch(day){
case 0:
return"'\u0441\u043B\u0435\u0434\u0435\u045B\u0435 \u043D\u0435\u0434\u0435\u0459\u0435 \u0443' p";
case 3:
return"'\u0441\u043B\u0435\u0434\u0435\u045B\u0443 \u0441\u0440\u0435\u0434\u0443 \u0443' p";
case 6:
return"'\u0441\u043B\u0435\u0434\u0435\u045B\u0443 \u0441\u0443\u0431\u043E\u0442\u0443 \u0443' p";
default:
return"'\u0441\u043B\u0435\u0434\u0435\u045B\u0438' EEEE '\u0443' p";
}
},
other:"P"
};
var formatRelative151=function formatRelative151(token,date,_baseDate,_options){
var format=formatRelativeLocale71[token];
if(typeof format==="function"){
return format(date);
}
return format;
};

// lib/locale/sr/_lib/localize.js
var eraValues71={
narrow:["\u043F\u0440.\u043D.\u0435.","\u0410\u0414"],
abbreviated:["\u043F\u0440. \u0425\u0440.","\u043F\u043E. \u0425\u0440."],
wide:["\u041F\u0440\u0435 \u0425\u0440\u0438\u0441\u0442\u0430","\u041F\u043E\u0441\u043B\u0435 \u0425\u0440\u0438\u0441\u0442\u0430"]
};
var quarterValues71={
narrow:["1.","2.","3.","4."],
abbreviated:["1. \u043A\u0432.","2. \u043A\u0432.","3. \u043A\u0432.","4. \u043A\u0432."],
wide:["1. \u043A\u0432\u0430\u0440\u0442\u0430\u043B","2. \u043A\u0432\u0430\u0440\u0442\u0430\u043B","3. \u043A\u0432\u0430\u0440\u0442\u0430\u043B","4. \u043A\u0432\u0430\u0440\u0442\u0430\u043B"]
};
var monthValues71={
narrow:[
"1.",
"2.",
"3.",
"4.",
"5.",
"6.",
"7.",
"8.",
"9.",
"10.",
"11.",
"12."],

abbreviated:[
"\u0458\u0430\u043D",
"\u0444\u0435\u0431",
"\u043C\u0430\u0440",
"\u0430\u043F\u0440",
"\u043C\u0430\u0458",
"\u0458\u0443\u043D",
"\u0458\u0443\u043B",
"\u0430\u0432\u0433",
"\u0441\u0435\u043F",
"\u043E\u043A\u0442",
"\u043D\u043E\u0432",
"\u0434\u0435\u0446"],

wide:[
"\u0458\u0430\u043D\u0443\u0430\u0440",
"\u0444\u0435\u0431\u0440\u0443\u0430\u0440",
"\u043C\u0430\u0440\u0442",
"\u0430\u043F\u0440\u0438\u043B",
"\u043C\u0430\u0458",
"\u0458\u0443\u043D",
"\u0458\u0443\u043B",
"\u0430\u0432\u0433\u0443\u0441\u0442",
"\u0441\u0435\u043F\u0442\u0435\u043C\u0431\u0430\u0440",
"\u043E\u043A\u0442\u043E\u0431\u0430\u0440",
"\u043D\u043E\u0432\u0435\u043C\u0431\u0430\u0440",
"\u0434\u0435\u0446\u0435\u043C\u0431\u0430\u0440"]

};
var formattingMonthValues16={
narrow:[
"1.",
"2.",
"3.",
"4.",
"5.",
"6.",
"7.",
"8.",
"9.",
"10.",
"11.",
"12."],

abbreviated:[
"\u0458\u0430\u043D",
"\u0444\u0435\u0431",
"\u043C\u0430\u0440",
"\u0430\u043F\u0440",
"\u043C\u0430\u0458",
"\u0458\u0443\u043D",
"\u0458\u0443\u043B",
"\u0430\u0432\u0433",
"\u0441\u0435\u043F",
"\u043E\u043A\u0442",
"\u043D\u043E\u0432",
"\u0434\u0435\u0446"],

wide:[
"\u0458\u0430\u043D\u0443\u0430\u0440",
"\u0444\u0435\u0431\u0440\u0443\u0430\u0440",
"\u043C\u0430\u0440\u0442",
"\u0430\u043F\u0440\u0438\u043B",
"\u043C\u0430\u0458",
"\u0458\u0443\u043D",
"\u0458\u0443\u043B",
"\u0430\u0432\u0433\u0443\u0441\u0442",
"\u0441\u0435\u043F\u0442\u0435\u043C\u0431\u0430\u0440",
"\u043E\u043A\u0442\u043E\u0431\u0430\u0440",
"\u043D\u043E\u0432\u0435\u043C\u0431\u0430\u0440",
"\u0434\u0435\u0446\u0435\u043C\u0431\u0430\u0440"]

};
var dayValues71={
narrow:["\u041D","\u041F","\u0423","\u0421","\u0427","\u041F","\u0421"],
short:["\u043D\u0435\u0434","\u043F\u043E\u043D","\u0443\u0442\u043E","\u0441\u0440\u0435","\u0447\u0435\u0442","\u043F\u0435\u0442","\u0441\u0443\u0431"],
abbreviated:["\u043D\u0435\u0434","\u043F\u043E\u043D","\u0443\u0442\u043E","\u0441\u0440\u0435","\u0447\u0435\u0442","\u043F\u0435\u0442","\u0441\u0443\u0431"],
wide:[
"\u043D\u0435\u0434\u0435\u0459\u0430",
"\u043F\u043E\u043D\u0435\u0434\u0435\u0459\u0430\u043A",
"\u0443\u0442\u043E\u0440\u0430\u043A",
"\u0441\u0440\u0435\u0434\u0430",
"\u0447\u0435\u0442\u0432\u0440\u0442\u0430\u043A",
"\u043F\u0435\u0442\u0430\u043A",
"\u0441\u0443\u0431\u043E\u0442\u0430"]

};
var formattingDayPeriodValues55={
narrow:{
am:"\u0410\u041C",
pm:"\u041F\u041C",
midnight:"\u043F\u043E\u043D\u043E\u045B",
noon:"\u043F\u043E\u0434\u043D\u0435",
morning:"\u0443\u0458\u0443\u0442\u0440\u0443",
afternoon:"\u043F\u043E\u043F\u043E\u0434\u043D\u0435",
evening:"\u0443\u0432\u0435\u0447\u0435",
night:"\u043D\u043E\u045B\u0443"
},
abbreviated:{
am:"\u0410\u041C",
pm:"\u041F\u041C",
midnight:"\u043F\u043E\u043D\u043E\u045B",
noon:"\u043F\u043E\u0434\u043D\u0435",
morning:"\u0443\u0458\u0443\u0442\u0440\u0443",
afternoon:"\u043F\u043E\u043F\u043E\u0434\u043D\u0435",
evening:"\u0443\u0432\u0435\u0447\u0435",
night:"\u043D\u043E\u045B\u0443"
},
wide:{
am:"AM",
pm:"PM",
midnight:"\u043F\u043E\u043D\u043E\u045B",
noon:"\u043F\u043E\u0434\u043D\u0435",
morning:"\u0443\u0458\u0443\u0442\u0440\u0443",
afternoon:"\u043F\u043E\u0441\u043B\u0435 \u043F\u043E\u0434\u043D\u0435",
evening:"\u0443\u0432\u0435\u0447\u0435",
night:"\u043D\u043E\u045B\u0443"
}
};
var dayPeriodValues71={
narrow:{
am:"AM",
pm:"PM",
midnight:"\u043F\u043E\u043D\u043E\u045B",
noon:"\u043F\u043E\u0434\u043D\u0435",
morning:"\u0443\u0458\u0443\u0442\u0440\u0443",
afternoon:"\u043F\u043E\u043F\u043E\u0434\u043D\u0435",
evening:"\u0443\u0432\u0435\u0447\u0435",
night:"\u043D\u043E\u045B\u0443"
},
abbreviated:{
am:"AM",
pm:"PM",
midnight:"\u043F\u043E\u043D\u043E\u045B",
noon:"\u043F\u043E\u0434\u043D\u0435",
morning:"\u0443\u0458\u0443\u0442\u0440\u0443",
afternoon:"\u043F\u043E\u043F\u043E\u0434\u043D\u0435",
evening:"\u0443\u0432\u0435\u0447\u0435",
night:"\u043D\u043E\u045B\u0443"
},
wide:{
am:"AM",
pm:"PM",
midnight:"\u043F\u043E\u043D\u043E\u045B",
noon:"\u043F\u043E\u0434\u043D\u0435",
morning:"\u0443\u0458\u0443\u0442\u0440\u0443",
afternoon:"\u043F\u043E\u0441\u043B\u0435 \u043F\u043E\u0434\u043D\u0435",
evening:"\u0443\u0432\u0435\u0447\u0435",
night:"\u043D\u043E\u045B\u0443"
}
};
var ordinalNumber71=function ordinalNumber71(dirtyNumber,_options){
var number=Number(dirtyNumber);
return number+".";
};
var localize154={
ordinalNumber:ordinalNumber71,
era:buildLocalizeFn({
values:eraValues71,
defaultWidth:"wide"
}),
quarter:buildLocalizeFn({
values:quarterValues71,
defaultWidth:"wide",
argumentCallback:function argumentCallback(quarter){return quarter-1;}
}),
month:buildLocalizeFn({
values:monthValues71,
defaultWidth:"wide",
formattingValues:formattingMonthValues16,
defaultFormattingWidth:"wide"
}),
day:buildLocalizeFn({
values:dayValues71,
defaultWidth:"wide"
}),
dayPeriod:buildLocalizeFn({
values:dayPeriodValues71,
defaultWidth:"wide",
formattingValues:formattingDayPeriodValues55,
defaultFormattingWidth:"wide"
})
};

// lib/locale/sr/_lib/match.js
var matchOrdinalNumberPattern70=/^(\d+)\./i;
var parseOrdinalNumberPattern70=/\d+/i;
var matchEraPatterns70={
narrow:/^(пр\.н\.е\.|АД)/i,
abbreviated:/^(пр\.\s?Хр\.|по\.\s?Хр\.)/i,
wide:/^(Пре Христа|пре нове ере|После Христа|нова ера)/i
};
var parseEraPatterns70={
any:[/^пр/i,/^(по|нова)/i]
};
var matchQuarterPatterns70={
narrow:/^[1234]/i,
abbreviated:/^[1234]\.\s?кв\.?/i,
wide:/^[1234]\. квартал/i
};
var parseQuarterPatterns70={
any:[/1/i,/2/i,/3/i,/4/i]
};
var matchMonthPatterns70={
narrow:/^(10|11|12|[123456789])\./i,
abbreviated:/^(јан|феб|мар|апр|мај|јун|јул|авг|сеп|окт|нов|дец)/i,
wide:/^((јануар|јануара)|(фебруар|фебруара)|(март|марта)|(април|априла)|(мја|маја)|(јун|јуна)|(јул|јула)|(август|августа)|(септембар|септембра)|(октобар|октобра)|(новембар|новембра)|(децембар|децембра))/i
};
var parseMonthPatterns70={
narrow:[
/^1/i,
/^2/i,
/^3/i,
/^4/i,
/^5/i,
/^6/i,
/^7/i,
/^8/i,
/^9/i,
/^10/i,
/^11/i,
/^12/i],

any:[
/^ја/i,
/^ф/i,
/^мар/i,
/^ап/i,
/^мај/i,
/^јун/i,
/^јул/i,
/^авг/i,
/^с/i,
/^о/i,
/^н/i,
/^д/i]

};
var matchDayPatterns70={
narrow:/^[пусчн]/i,
short:/^(нед|пон|уто|сре|чет|пет|суб)/i,
abbreviated:/^(нед|пон|уто|сре|чет|пет|суб)/i,
wide:/^(недеља|понедељак|уторак|среда|четвртак|петак|субота)/i
};
var parseDayPatterns70={
narrow:[/^п/i,/^у/i,/^с/i,/^ч/i,/^п/i,/^с/i,/^н/i],
any:[/^нед/i,/^пон/i,/^уто/i,/^сре/i,/^чет/i,/^пет/i,/^суб/i]
};
var matchDayPeriodPatterns70={
any:/^(ам|пм|поноћ|(по)?подне|увече|ноћу|после подне|ујутру)/i
};
var parseDayPeriodPatterns70={
any:{
am:/^a/i,
pm:/^p/i,
midnight:/^поно/i,
noon:/^под/i,
morning:/ујутру/i,
afternoon:/(после\s|по)+подне/i,
evening:/(увече)/i,
night:/(ноћу)/i
}
};
var match150={
ordinalNumber:buildMatchPatternFn({
matchPattern:matchOrdinalNumberPattern70,
parsePattern:parseOrdinalNumberPattern70,
valueCallback:function valueCallback(value){return parseInt(value,10);}
}),
era:buildMatchFn({
matchPatterns:matchEraPatterns70,
defaultMatchWidth:"wide",
parsePatterns:parseEraPatterns70,
defaultParseWidth:"any"
}),
quarter:buildMatchFn({
matchPatterns:matchQuarterPatterns70,
defaultMatchWidth:"wide",
parsePatterns:parseQuarterPatterns70,
defaultParseWidth:"any",
valueCallback:function valueCallback(index){return index+1;}
}),
month:buildMatchFn({
matchPatterns:matchMonthPatterns70,
defaultMatchWidth:"wide",
parsePatterns:parseMonthPatterns70,
defaultParseWidth:"any"
}),
day:buildMatchFn({
matchPatterns:matchDayPatterns70,
defaultMatchWidth:"wide",
parsePatterns:parseDayPatterns70,
defaultParseWidth:"any"
}),
dayPeriod:buildMatchFn({
matchPatterns:matchDayPeriodPatterns70,
defaultMatchWidth:"any",
parsePatterns:parseDayPeriodPatterns70,
defaultParseWidth:"any"
})
};

// lib/locale/sr.js
var _sr={
code:"sr",
formatDistance:formatDistance151,
formatLong:formatLong159,
formatRelative:formatRelative151,
localize:localize154,
match:match150,
options:{
weekStartsOn:1,
firstWeekContainsDate:1
}
};
// lib/locale/sr-Latn/_lib/formatDistance.js
var formatDistanceLocale71={
lessThanXSeconds:{
one:{
standalone:"manje od 1 sekunde",
withPrepositionAgo:"manje od 1 sekunde",
withPrepositionIn:"manje od 1 sekundu"
},
dual:"manje od {{count}} sekunde",
other:"manje od {{count}} sekundi"
},
xSeconds:{
one:{
standalone:"1 sekunda",
withPrepositionAgo:"1 sekunde",
withPrepositionIn:"1 sekundu"
},
dual:"{{count}} sekunde",
other:"{{count}} sekundi"
},
halfAMinute:"pola minute",
lessThanXMinutes:{
one:{
standalone:"manje od 1 minute",
withPrepositionAgo:"manje od 1 minute",
withPrepositionIn:"manje od 1 minutu"
},
dual:"manje od {{count}} minute",
other:"manje od {{count}} minuta"
},
xMinutes:{
one:{
standalone:"1 minuta",
withPrepositionAgo:"1 minute",
withPrepositionIn:"1 minutu"
},
dual:"{{count}} minute",
other:"{{count}} minuta"
},
aboutXHours:{
one:{
standalone:"oko 1 sat",
withPrepositionAgo:"oko 1 sat",
withPrepositionIn:"oko 1 sat"
},
dual:"oko {{count}} sata",
other:"oko {{count}} sati"
},
xHours:{
one:{
standalone:"1 sat",
withPrepositionAgo:"1 sat",
withPrepositionIn:"1 sat"
},
dual:"{{count}} sata",
other:"{{count}} sati"
},
xDays:{
one:{
standalone:"1 dan",
withPrepositionAgo:"1 dan",
withPrepositionIn:"1 dan"
},
dual:"{{count}} dana",
other:"{{count}} dana"
},
aboutXWeeks:{
one:{
standalone:"oko 1 nedelju",
withPrepositionAgo:"oko 1 nedelju",
withPrepositionIn:"oko 1 nedelju"
},
dual:"oko {{count}} nedelje",
other:"oko {{count}} nedelje"
},
xWeeks:{
one:{
standalone:"1 nedelju",
withPrepositionAgo:"1 nedelju",
withPrepositionIn:"1 nedelju"
},
dual:"{{count}} nedelje",
other:"{{count}} nedelje"
},
aboutXMonths:{
one:{
standalone:"oko 1 mesec",
withPrepositionAgo:"oko 1 mesec",
withPrepositionIn:"oko 1 mesec"
},
dual:"oko {{count}} meseca",
other:"oko {{count}} meseci"
},
xMonths:{
one:{
standalone:"1 mesec",
withPrepositionAgo:"1 mesec",
withPrepositionIn:"1 mesec"
},
dual:"{{count}} meseca",
other:"{{count}} meseci"
},
aboutXYears:{
one:{
standalone:"oko 1 godinu",
withPrepositionAgo:"oko 1 godinu",
withPrepositionIn:"oko 1 godinu"
},
dual:"oko {{count}} godine",
other:"oko {{count}} godina"
},
xYears:{
one:{
standalone:"1 godina",
withPrepositionAgo:"1 godine",
withPrepositionIn:"1 godinu"
},
dual:"{{count}} godine",
other:"{{count}} godina"
},
overXYears:{
one:{
standalone:"preko 1 godinu",
withPrepositionAgo:"preko 1 godinu",
withPrepositionIn:"preko 1 godinu"
},
dual:"preko {{count}} godine",
other:"preko {{count}} godina"
},
almostXYears:{
one:{
standalone:"gotovo 1 godinu",
withPrepositionAgo:"gotovo 1 godinu",
withPrepositionIn:"gotovo 1 godinu"
},
dual:"gotovo {{count}} godine",
other:"gotovo {{count}} godina"
}
};
var formatDistance153=function formatDistance153(token,count,options){
var result;
var tokenValue=formatDistanceLocale71[token];
if(typeof tokenValue==="string"){
result=tokenValue;
}else if(count===1){
if(options!==null&&options!==void 0&&options.addSuffix){
if(options.comparison&&options.comparison>0){
result=tokenValue.one.withPrepositionIn;
}else{
result=tokenValue.one.withPrepositionAgo;
}
}else{
result=tokenValue.one.standalone;
}
}else if(count%10>1&&count%10<5&&String(count).substr(-2,1)!=="1"){
result=tokenValue.dual.replace("{{count}}",String(count));
}else{
result=tokenValue.other.replace("{{count}}",String(count));
}
if(options!==null&&options!==void 0&&options.addSuffix){
if(options.comparison&&options.comparison>0){
return"za "+result;
}else{
return"pre "+result;
}
}
return result;
};

// lib/locale/sr-Latn/_lib/formatLong.js
var dateFormats80={
full:"EEEE, d. MMMM yyyy.",
long:"d. MMMM yyyy.",
medium:"d. MMM yy.",
short:"dd. MM. yy."
};
var timeFormats80={
full:"HH:mm:ss (zzzz)",
long:"HH:mm:ss z",
medium:"HH:mm:ss",
short:"HH:mm"
};
var dateTimeFormats80={
full:"{{date}} 'u' {{time}}",
long:"{{date}} 'u' {{time}}",
medium:"{{date}} {{time}}",
short:"{{date}} {{time}}"
};
var formatLong161={
date:buildFormatLongFn({
formats:dateFormats80,
defaultWidth:"full"
}),
time:buildFormatLongFn({
formats:timeFormats80,
defaultWidth:"full"
}),
dateTime:buildFormatLongFn({
formats:dateTimeFormats80,
defaultWidth:"full"
})
};

// lib/locale/sr-Latn/_lib/formatRelative.js
var formatRelativeLocale72={
lastWeek:function lastWeek(date){
switch(date.getDay()){
case 0:
return"'pro\u0161le nedelje u' p";
case 3:
return"'pro\u0161le srede u' p";
case 6:
return"'pro\u0161le subote u' p";
default:
return"'pro\u0161li' EEEE 'u' p";
}
},
yesterday:"'ju\u010De u' p",
today:"'danas u' p",
tomorrow:"'sutra u' p",
nextWeek:function nextWeek(date){
switch(date.getDay()){
case 0:
return"'slede\u0107e nedelje u' p";
case 3:
return"'slede\u0107u sredu u' p";
case 6:
return"'slede\u0107u subotu u' p";
default:
return"'slede\u0107i' EEEE 'u' p";
}
},
other:"P"
};
var formatRelative153=function formatRelative153(token,date,_baseDate,_options){
var format=formatRelativeLocale72[token];
if(typeof format==="function"){
return format(date);
}
return format;
};

// lib/locale/sr-Latn/_lib/localize.js
var eraValues72={
narrow:["pr.n.e.","AD"],
abbreviated:["pr. Hr.","po. Hr."],
wide:["Pre Hrista","Posle Hrista"]
};
var quarterValues72={
narrow:["1.","2.","3.","4."],
abbreviated:["1. kv.","2. kv.","3. kv.","4. kv."],
wide:["1. kvartal","2. kvartal","3. kvartal","4. kvartal"]
};
var monthValues72={
narrow:[
"1.",
"2.",
"3.",
"4.",
"5.",
"6.",
"7.",
"8.",
"9.",
"10.",
"11.",
"12."],

abbreviated:[
"jan",
"feb",
"mar",
"apr",
"maj",
"jun",
"jul",
"avg",
"sep",
"okt",
"nov",
"dec"],

wide:[
"januar",
"februar",
"mart",
"april",
"maj",
"jun",
"jul",
"avgust",
"septembar",
"oktobar",
"novembar",
"decembar"]

};
var formattingMonthValues17={
narrow:[
"1.",
"2.",
"3.",
"4.",
"5.",
"6.",
"7.",
"8.",
"9.",
"10.",
"11.",
"12."],

abbreviated:[
"jan",
"feb",
"mar",
"apr",
"maj",
"jun",
"jul",
"avg",
"sep",
"okt",
"nov",
"dec"],

wide:[
"januar",
"februar",
"mart",
"april",
"maj",
"jun",
"jul",
"avgust",
"septembar",
"oktobar",
"novembar",
"decembar"]

};
var dayValues72={
narrow:["N","P","U","S","\u010C","P","S"],
short:["ned","pon","uto","sre","\u010Det","pet","sub"],
abbreviated:["ned","pon","uto","sre","\u010Det","pet","sub"],
wide:[
"nedelja",
"ponedeljak",
"utorak",
"sreda",
"\u010Detvrtak",
"petak",
"subota"]

};
var formattingDayPeriodValues56={
narrow:{
am:"AM",
pm:"PM",
midnight:"pono\u0107",
noon:"podne",
morning:"ujutru",
afternoon:"popodne",
evening:"uve\u010De",
night:"no\u0107u"
},
abbreviated:{
am:"AM",
pm:"PM",
midnight:"pono\u0107",
noon:"podne",
morning:"ujutru",
afternoon:"popodne",
evening:"uve\u010De",
night:"no\u0107u"
},
wide:{
am:"AM",
pm:"PM",
midnight:"pono\u0107",
noon:"podne",
morning:"ujutru",
afternoon:"posle podne",
evening:"uve\u010De",
night:"no\u0107u"
}
};
var dayPeriodValues72={
narrow:{
am:"AM",
pm:"PM",
midnight:"pono\u0107",
noon:"podne",
morning:"ujutru",
afternoon:"popodne",
evening:"uve\u010De",
night:"no\u0107u"
},
abbreviated:{
am:"AM",
pm:"PM",
midnight:"pono\u0107",
noon:"podne",
morning:"ujutru",
afternoon:"popodne",
evening:"uve\u010De",
night:"no\u0107u"
},
wide:{
am:"AM",
pm:"PM",
midnight:"pono\u0107",
noon:"podne",
morning:"ujutru",
afternoon:"posle podne",
evening:"uve\u010De",
night:"no\u0107u"
}
};
var ordinalNumber72=function ordinalNumber72(dirtyNumber,_options){
var number=Number(dirtyNumber);
return number+".";
};
var localize156={
ordinalNumber:ordinalNumber72,
era:buildLocalizeFn({
values:eraValues72,
defaultWidth:"wide"
}),
quarter:buildLocalizeFn({
values:quarterValues72,
defaultWidth:"wide",
argumentCallback:function argumentCallback(quarter){return quarter-1;}
}),
month:buildLocalizeFn({
values:monthValues72,
defaultWidth:"wide",
formattingValues:formattingMonthValues17,
defaultFormattingWidth:"wide"
}),
day:buildLocalizeFn({
values:dayValues72,
defaultWidth:"wide"
}),
dayPeriod:buildLocalizeFn({
values:dayPeriodValues72,
defaultWidth:"wide",
formattingValues:formattingDayPeriodValues56,
defaultFormattingWidth:"wide"
})
};

// lib/locale/sr-Latn/_lib/match.js
var matchOrdinalNumberPattern71=/^(\d+)\./i;
var parseOrdinalNumberPattern71=/\d+/i;
var matchEraPatterns71={
narrow:/^(pr\.n\.e\.|AD)/i,
abbreviated:/^(pr\.\s?Hr\.|po\.\s?Hr\.)/i,
wide:/^(Pre Hrista|pre nove ere|Posle Hrista|nova era)/i
};
var parseEraPatterns71={
any:[/^pr/i,/^(po|nova)/i]
};
var matchQuarterPatterns71={
narrow:/^[1234]/i,
abbreviated:/^[1234]\.\s?kv\.?/i,
wide:/^[1234]\. kvartal/i
};
var parseQuarterPatterns71={
any:[/1/i,/2/i,/3/i,/4/i]
};
var matchMonthPatterns71={
narrow:/^(10|11|12|[123456789])\./i,
abbreviated:/^(jan|feb|mar|apr|maj|jun|jul|avg|sep|okt|nov|dec)/i,
wide:/^((januar|januara)|(februar|februara)|(mart|marta)|(april|aprila)|(maj|maja)|(jun|juna)|(jul|jula)|(avgust|avgusta)|(septembar|septembra)|(oktobar|oktobra)|(novembar|novembra)|(decembar|decembra))/i
};
var parseMonthPatterns71={
narrow:[
/^1/i,
/^2/i,
/^3/i,
/^4/i,
/^5/i,
/^6/i,
/^7/i,
/^8/i,
/^9/i,
/^10/i,
/^11/i,
/^12/i],

any:[
/^ja/i,
/^f/i,
/^mar/i,
/^ap/i,
/^maj/i,
/^jun/i,
/^jul/i,
/^avg/i,
/^s/i,
/^o/i,
/^n/i,
/^d/i]

};
var matchDayPatterns71={
narrow:/^[npusčc]/i,
short:/^(ned|pon|uto|sre|(čet|cet)|pet|sub)/i,
abbreviated:/^(ned|pon|uto|sre|(čet|cet)|pet|sub)/i,
wide:/^(nedelja|ponedeljak|utorak|sreda|(četvrtak|cetvrtak)|petak|subota)/i
};
var parseDayPatterns71={
narrow:[/^s/i,/^m/i,/^t/i,/^w/i,/^t/i,/^f/i,/^s/i],
any:[/^su/i,/^m/i,/^tu/i,/^w/i,/^th/i,/^f/i,/^sa/i]
};
var matchDayPeriodPatterns71={
any:/^(am|pm|ponoc|ponoć|(po)?podne|uvece|uveče|noću|posle podne|ujutru)/i
};
var parseDayPeriodPatterns71={
any:{
am:/^a/i,
pm:/^p/i,
midnight:/^pono/i,
noon:/^pod/i,
morning:/jutro/i,
afternoon:/(posle\s|po)+podne/i,
evening:/(uvece|uveče)/i,
night:/(nocu|noću)/i
}
};
var match152={
ordinalNumber:buildMatchPatternFn({
matchPattern:matchOrdinalNumberPattern71,
parsePattern:parseOrdinalNumberPattern71,
valueCallback:function valueCallback(value){return parseInt(value,10);}
}),
era:buildMatchFn({
matchPatterns:matchEraPatterns71,
defaultMatchWidth:"wide",
parsePatterns:parseEraPatterns71,
defaultParseWidth:"any"
}),
quarter:buildMatchFn({
matchPatterns:matchQuarterPatterns71,
defaultMatchWidth:"wide",
parsePatterns:parseQuarterPatterns71,
defaultParseWidth:"any",
valueCallback:function valueCallback(index){return index+1;}
}),
month:buildMatchFn({
matchPatterns:matchMonthPatterns71,
defaultMatchWidth:"wide",
parsePatterns:parseMonthPatterns71,
defaultParseWidth:"any"
}),
day:buildMatchFn({
matchPatterns:matchDayPatterns71,
defaultMatchWidth:"wide",
parsePatterns:parseDayPatterns71,
defaultParseWidth:"any"
}),
dayPeriod:buildMatchFn({
matchPatterns:matchDayPeriodPatterns71,
defaultMatchWidth:"any",
parsePatterns:parseDayPeriodPatterns71,
defaultParseWidth:"any"
})
};

// lib/locale/sr-Latn.js
var _srLatn={
code:"sr-Latn",
formatDistance:formatDistance153,
formatLong:formatLong161,
formatRelative:formatRelative153,
localize:localize156,
match:match152,
options:{
weekStartsOn:1,
firstWeekContainsDate:1
}
};
// lib/locale/sv/_lib/formatDistance.js
var formatDistanceLocale72={
lessThanXSeconds:{
one:"mindre \xE4n en sekund",
other:"mindre \xE4n {{count}} sekunder"
},
xSeconds:{
one:"en sekund",
other:"{{count}} sekunder"
},
halfAMinute:"en halv minut",
lessThanXMinutes:{
one:"mindre \xE4n en minut",
other:"mindre \xE4n {{count}} minuter"
},
xMinutes:{
one:"en minut",
other:"{{count}} minuter"
},
aboutXHours:{
one:"ungef\xE4r en timme",
other:"ungef\xE4r {{count}} timmar"
},
xHours:{
one:"en timme",
other:"{{count}} timmar"
},
xDays:{
one:"en dag",
other:"{{count}} dagar"
},
aboutXWeeks:{
one:"ungef\xE4r en vecka",
other:"ungef\xE4r {{count}} veckor"
},
xWeeks:{
one:"en vecka",
other:"{{count}} veckor"
},
aboutXMonths:{
one:"ungef\xE4r en m\xE5nad",
other:"ungef\xE4r {{count}} m\xE5nader"
},
xMonths:{
one:"en m\xE5nad",
other:"{{count}} m\xE5nader"
},
aboutXYears:{
one:"ungef\xE4r ett \xE5r",
other:"ungef\xE4r {{count}} \xE5r"
},
xYears:{
one:"ett \xE5r",
other:"{{count}} \xE5r"
},
overXYears:{
one:"\xF6ver ett \xE5r",
other:"\xF6ver {{count}} \xE5r"
},
almostXYears:{
one:"n\xE4stan ett \xE5r",
other:"n\xE4stan {{count}} \xE5r"
}
};
var wordMapping2=[
"noll",
"en",
"tv\xE5",
"tre",
"fyra",
"fem",
"sex",
"sju",
"\xE5tta",
"nio",
"tio",
"elva",
"tolv"];

var formatDistance155=function formatDistance155(token,count,options){
var result;
var tokenValue=formatDistanceLocale72[token];
if(typeof tokenValue==="string"){
result=tokenValue;
}else if(count===1){
result=tokenValue.one;
}else{
result=tokenValue.other.replace("{{count}}",count<13?wordMapping2[count]:String(count));
}
if(options!==null&&options!==void 0&&options.addSuffix){
if(options.comparison&&options.comparison>0){
return"om "+result;
}else{
return result+" sedan";
}
}
return result;
};

// lib/locale/sv/_lib/formatLong.js
var dateFormats81={
full:"EEEE d MMMM y",
long:"d MMMM y",
medium:"d MMM y",
short:"y-MM-dd"
};
var timeFormats81={
full:"'kl'. HH:mm:ss zzzz",
long:"HH:mm:ss z",
medium:"HH:mm:ss",
short:"HH:mm"
};
var dateTimeFormats81={
full:"{{date}} 'kl.' {{time}}",
long:"{{date}} 'kl.' {{time}}",
medium:"{{date}} {{time}}",
short:"{{date}} {{time}}"
};
var formatLong163={
date:buildFormatLongFn({
formats:dateFormats81,
defaultWidth:"full"
}),
time:buildFormatLongFn({
formats:timeFormats81,
defaultWidth:"full"
}),
dateTime:buildFormatLongFn({
formats:dateTimeFormats81,
defaultWidth:"full"
})
};

// lib/locale/sv/_lib/formatRelative.js
var formatRelativeLocale73={
lastWeek:"'i' EEEE's kl.' p",
yesterday:"'ig\xE5r kl.' p",
today:"'idag kl.' p",
tomorrow:"'imorgon kl.' p",
nextWeek:"EEEE 'kl.' p",
other:"P"
};
var formatRelative155=function formatRelative155(token,_date,_baseDate,_options){return formatRelativeLocale73[token];};

// lib/locale/sv/_lib/localize.js
var eraValues73={
narrow:["f.Kr.","e.Kr."],
abbreviated:["f.Kr.","e.Kr."],
wide:["f\xF6re Kristus","efter Kristus"]
};
var quarterValues73={
narrow:["1","2","3","4"],
abbreviated:["Q1","Q2","Q3","Q4"],
wide:["1:a kvartalet","2:a kvartalet","3:e kvartalet","4:e kvartalet"]
};
var monthValues73={
narrow:["J","F","M","A","M","J","J","A","S","O","N","D"],
abbreviated:[
"jan.",
"feb.",
"mars",
"apr.",
"maj",
"juni",
"juli",
"aug.",
"sep.",
"okt.",
"nov.",
"dec."],

wide:[
"januari",
"februari",
"mars",
"april",
"maj",
"juni",
"juli",
"augusti",
"september",
"oktober",
"november",
"december"]

};
var dayValues73={
narrow:["S","M","T","O","T","F","L"],
short:["s\xF6","m\xE5","ti","on","to","fr","l\xF6"],
abbreviated:["s\xF6n","m\xE5n","tis","ons","tors","fre","l\xF6r"],
wide:["s\xF6ndag","m\xE5ndag","tisdag","onsdag","torsdag","fredag","l\xF6rdag"]
};
var dayPeriodValues73={
narrow:{
am:"fm",
pm:"em",
midnight:"midnatt",
noon:"middag",
morning:"morg.",
afternoon:"efterm.",
evening:"kv\xE4ll",
night:"natt"
},
abbreviated:{
am:"f.m.",
pm:"e.m.",
midnight:"midnatt",
noon:"middag",
morning:"morgon",
afternoon:"efterm.",
evening:"kv\xE4ll",
night:"natt"
},
wide:{
am:"f\xF6rmiddag",
pm:"eftermiddag",
midnight:"midnatt",
noon:"middag",
morning:"morgon",
afternoon:"eftermiddag",
evening:"kv\xE4ll",
night:"natt"
}
};
var formattingDayPeriodValues57={
narrow:{
am:"fm",
pm:"em",
midnight:"midnatt",
noon:"middag",
morning:"p\xE5 morg.",
afternoon:"p\xE5 efterm.",
evening:"p\xE5 kv\xE4llen",
night:"p\xE5 natten"
},
abbreviated:{
am:"fm",
pm:"em",
midnight:"midnatt",
noon:"middag",
morning:"p\xE5 morg.",
afternoon:"p\xE5 efterm.",
evening:"p\xE5 kv\xE4llen",
night:"p\xE5 natten"
},
wide:{
am:"fm",
pm:"em",
midnight:"midnatt",
noon:"middag",
morning:"p\xE5 morgonen",
afternoon:"p\xE5 eftermiddagen",
evening:"p\xE5 kv\xE4llen",
night:"p\xE5 natten"
}
};
var ordinalNumber73=function ordinalNumber73(dirtyNumber,_options){
var number=Number(dirtyNumber);
var rem100=number%100;
if(rem100>20||rem100<10){
switch(rem100%10){
case 1:
case 2:
return number+":a";
}
}
return number+":e";
};
var localize158={
ordinalNumber:ordinalNumber73,
era:buildLocalizeFn({
values:eraValues73,
defaultWidth:"wide"
}),
quarter:buildLocalizeFn({
values:quarterValues73,
defaultWidth:"wide",
argumentCallback:function argumentCallback(quarter){return quarter-1;}
}),
month:buildLocalizeFn({
values:monthValues73,
defaultWidth:"wide"
}),
day:buildLocalizeFn({
values:dayValues73,
defaultWidth:"wide"
}),
dayPeriod:buildLocalizeFn({
values:dayPeriodValues73,
defaultWidth:"wide",
formattingValues:formattingDayPeriodValues57,
defaultFormattingWidth:"wide"
})
};

// lib/locale/sv/_lib/match.js
var matchOrdinalNumberPattern72=/^(\d+)(:a|:e)?/i;
var parseOrdinalNumberPattern72=/\d+/i;
var matchEraPatterns72={
narrow:/^(f\.? ?Kr\.?|f\.? ?v\.? ?t\.?|e\.? ?Kr\.?|v\.? ?t\.?)/i,
abbreviated:/^(f\.? ?Kr\.?|f\.? ?v\.? ?t\.?|e\.? ?Kr\.?|v\.? ?t\.?)/i,
wide:/^(före Kristus|före vår tid|efter Kristus|vår tid)/i
};
var parseEraPatterns72={
any:[/^f/i,/^[ev]/i]
};
var matchQuarterPatterns72={
narrow:/^[1234]/i,
abbreviated:/^q[1234]/i,
wide:/^[1234](:a|:e)? kvartalet/i
};
var parseQuarterPatterns72={
any:[/1/i,/2/i,/3/i,/4/i]
};
var matchMonthPatterns72={
narrow:/^[jfmasond]/i,
abbreviated:/^(jan|feb|mar[s]?|apr|maj|jun[i]?|jul[i]?|aug|sep|okt|nov|dec)\.?/i,
wide:/^(januari|februari|mars|april|maj|juni|juli|augusti|september|oktober|november|december)/i
};
var parseMonthPatterns72={
narrow:[
/^j/i,
/^f/i,
/^m/i,
/^a/i,
/^m/i,
/^j/i,
/^j/i,
/^a/i,
/^s/i,
/^o/i,
/^n/i,
/^d/i],

any:[
/^ja/i,
/^f/i,
/^mar/i,
/^ap/i,
/^maj/i,
/^jun/i,
/^jul/i,
/^au/i,
/^s/i,
/^o/i,
/^n/i,
/^d/i]

};
var matchDayPatterns72={
narrow:/^[smtofl]/i,
short:/^(sö|må|ti|on|to|fr|lö)/i,
abbreviated:/^(sön|mån|tis|ons|tors|fre|lör)/i,
wide:/^(söndag|måndag|tisdag|onsdag|torsdag|fredag|lördag)/i
};
var parseDayPatterns72={
any:[/^s/i,/^m/i,/^ti/i,/^o/i,/^to/i,/^f/i,/^l/i]
};
var matchDayPeriodPatterns72={
any:/^([fe]\.?\s?m\.?|midn(att)?|midd(ag)?|(på) (morgonen|eftermiddagen|kvällen|natten))/i
};
var parseDayPeriodPatterns72={
any:{
am:/^f/i,
pm:/^e/i,
midnight:/^midn/i,
noon:/^midd/i,
morning:/morgon/i,
afternoon:/eftermiddag/i,
evening:/kväll/i,
night:/natt/i
}
};
var match154={
ordinalNumber:buildMatchPatternFn({
matchPattern:matchOrdinalNumberPattern72,
parsePattern:parseOrdinalNumberPattern72,
valueCallback:function valueCallback(value){return parseInt(value,10);}
}),
era:buildMatchFn({
matchPatterns:matchEraPatterns72,
defaultMatchWidth:"wide",
parsePatterns:parseEraPatterns72,
defaultParseWidth:"any"
}),
quarter:buildMatchFn({
matchPatterns:matchQuarterPatterns72,
defaultMatchWidth:"wide",
parsePatterns:parseQuarterPatterns72,
defaultParseWidth:"any",
valueCallback:function valueCallback(index){return index+1;}
}),
month:buildMatchFn({
matchPatterns:matchMonthPatterns72,
defaultMatchWidth:"wide",
parsePatterns:parseMonthPatterns72,
defaultParseWidth:"any"
}),
day:buildMatchFn({
matchPatterns:matchDayPatterns72,
defaultMatchWidth:"wide",
parsePatterns:parseDayPatterns72,
defaultParseWidth:"any"
}),
dayPeriod:buildMatchFn({
matchPatterns:matchDayPeriodPatterns72,
defaultMatchWidth:"any",
parsePatterns:parseDayPeriodPatterns72,
defaultParseWidth:"any"
})
};

// lib/locale/sv.js
var _sv={
code:"sv",
formatDistance:formatDistance155,
formatLong:formatLong163,
formatRelative:formatRelative155,
localize:localize158,
match:match154,
options:{
weekStartsOn:1,
firstWeekContainsDate:4
}
};
// lib/locale/ta/_lib/formatDistance.js
function isPluralType2(val){
return val.one!==undefined;
}
var formatDistanceLocale73={
lessThanXSeconds:{
one:{
default:"\u0B92\u0BB0\u0BC1 \u0BB5\u0BBF\u0BA9\u0BBE\u0B9F\u0BBF\u0B95\u0BCD\u0B95\u0BC1 \u0B95\u0BC1\u0BB1\u0BC8\u0BB5\u0BBE\u0B95",
in:"\u0B92\u0BB0\u0BC1 \u0BB5\u0BBF\u0BA9\u0BBE\u0B9F\u0BBF\u0B95\u0BCD\u0B95\u0BC1\u0BB3\u0BCD",
ago:"\u0B92\u0BB0\u0BC1 \u0BB5\u0BBF\u0BA9\u0BBE\u0B9F\u0BBF\u0B95\u0BCD\u0B95\u0BC1 \u0BAE\u0BC1\u0BA9\u0BCD\u0BAA\u0BC1"
},
other:{
default:"{{count}} \u0BB5\u0BBF\u0BA9\u0BBE\u0B9F\u0BBF\u0B95\u0BB3\u0BC1\u0B95\u0BCD\u0B95\u0BC1 \u0B95\u0BC1\u0BB1\u0BC8\u0BB5\u0BBE\u0B95",
in:"{{count}} \u0BB5\u0BBF\u0BA9\u0BBE\u0B9F\u0BBF\u0B95\u0BB3\u0BC1\u0B95\u0BCD\u0B95\u0BC1\u0BB3\u0BCD",
ago:"{{count}} \u0BB5\u0BBF\u0BA9\u0BBE\u0B9F\u0BBF\u0B95\u0BB3\u0BC1\u0B95\u0BCD\u0B95\u0BC1 \u0BAE\u0BC1\u0BA9\u0BCD\u0BAA\u0BC1"
}
},
xSeconds:{
one:{
default:"1 \u0BB5\u0BBF\u0BA9\u0BBE\u0B9F\u0BBF",
in:"1 \u0BB5\u0BBF\u0BA9\u0BBE\u0B9F\u0BBF\u0BAF\u0BBF\u0BB2\u0BCD",
ago:"1 \u0BB5\u0BBF\u0BA9\u0BBE\u0B9F\u0BBF \u0BAE\u0BC1\u0BA9\u0BCD\u0BAA\u0BC1"
},
other:{
default:"{{count}} \u0BB5\u0BBF\u0BA8\u0BBE\u0B9F\u0BBF\u0B95\u0BB3\u0BCD",
in:"{{count}} \u0BB5\u0BBF\u0BA9\u0BBE\u0B9F\u0BBF\u0B95\u0BB3\u0BBF\u0BB2\u0BCD",
ago:"{{count}} \u0BB5\u0BBF\u0BA8\u0BBE\u0B9F\u0BBF\u0B95\u0BB3\u0BC1\u0B95\u0BCD\u0B95\u0BC1 \u0BAE\u0BC1\u0BA9\u0BCD\u0BAA\u0BC1"
}
},
halfAMinute:{
default:"\u0B85\u0BB0\u0BC8 \u0BA8\u0BBF\u0BAE\u0BBF\u0B9F\u0BAE\u0BCD",
in:"\u0B85\u0BB0\u0BC8 \u0BA8\u0BBF\u0BAE\u0BBF\u0B9F\u0BA4\u0BCD\u0BA4\u0BBF\u0BB2\u0BCD",
ago:"\u0B85\u0BB0\u0BC8 \u0BA8\u0BBF\u0BAE\u0BBF\u0B9F\u0BAE\u0BCD \u0BAE\u0BC1\u0BA9\u0BCD\u0BAA\u0BC1"
},
lessThanXMinutes:{
one:{
default:"\u0B92\u0BB0\u0BC1 \u0BA8\u0BBF\u0BAE\u0BBF\u0B9F\u0BA4\u0BCD\u0BA4\u0BBF\u0BB1\u0BCD\u0B95\u0BC1\u0BAE\u0BCD \u0B95\u0BC1\u0BB1\u0BC8\u0BB5\u0BBE\u0B95",
in:"\u0B92\u0BB0\u0BC1 \u0BA8\u0BBF\u0BAE\u0BBF\u0B9F\u0BA4\u0BCD\u0BA4\u0BBF\u0BB1\u0BCD\u0B95\u0BC1\u0BB3\u0BCD",
ago:"\u0B92\u0BB0\u0BC1 \u0BA8\u0BBF\u0BAE\u0BBF\u0B9F\u0BA4\u0BCD\u0BA4\u0BBF\u0BB1\u0BCD\u0B95\u0BC1 \u0BAE\u0BC1\u0BA9\u0BCD\u0BAA\u0BC1"
},
other:{
default:"{{count}} \u0BA8\u0BBF\u0BAE\u0BBF\u0B9F\u0B99\u0BCD\u0B95\u0BB3\u0BC1\u0B95\u0BCD\u0B95\u0BC1\u0BAE\u0BCD \u0B95\u0BC1\u0BB1\u0BC8\u0BB5\u0BBE\u0B95",
in:"{{count}} \u0BA8\u0BBF\u0BAE\u0BBF\u0B9F\u0B99\u0BCD\u0B95\u0BB3\u0BC1\u0B95\u0BCD\u0B95\u0BC1\u0BB3\u0BCD",
ago:"{{count}} \u0BA8\u0BBF\u0BAE\u0BBF\u0B9F\u0B99\u0BCD\u0B95\u0BB3\u0BC1\u0B95\u0BCD\u0B95\u0BC1 \u0BAE\u0BC1\u0BA9\u0BCD\u0BAA\u0BC1"
}
},
xMinutes:{
one:{
default:"1 \u0BA8\u0BBF\u0BAE\u0BBF\u0B9F\u0BAE\u0BCD",
in:"1 \u0BA8\u0BBF\u0BAE\u0BBF\u0B9F\u0BA4\u0BCD\u0BA4\u0BBF\u0BB2\u0BCD",
ago:"1 \u0BA8\u0BBF\u0BAE\u0BBF\u0B9F\u0BAE\u0BCD \u0BAE\u0BC1\u0BA9\u0BCD\u0BAA\u0BC1"
},
other:{
default:"{{count}} \u0BA8\u0BBF\u0BAE\u0BBF\u0B9F\u0B99\u0BCD\u0B95\u0BB3\u0BCD",
in:"{{count}} \u0BA8\u0BBF\u0BAE\u0BBF\u0B9F\u0B99\u0BCD\u0B95\u0BB3\u0BBF\u0BB2\u0BCD",
ago:"{{count}} \u0BA8\u0BBF\u0BAE\u0BBF\u0B9F\u0B99\u0BCD\u0B95\u0BB3\u0BC1\u0B95\u0BCD\u0B95\u0BC1 \u0BAE\u0BC1\u0BA9\u0BCD\u0BAA\u0BC1"
}
},
aboutXHours:{
one:{
default:"\u0B9A\u0BC1\u0BAE\u0BBE\u0BB0\u0BCD 1 \u0BAE\u0BA3\u0BBF \u0BA8\u0BC7\u0BB0\u0BAE\u0BCD",
in:"\u0B9A\u0BC1\u0BAE\u0BBE\u0BB0\u0BCD 1 \u0BAE\u0BA3\u0BBF \u0BA8\u0BC7\u0BB0\u0BA4\u0BCD\u0BA4\u0BBF\u0BB2\u0BCD",
ago:"\u0B9A\u0BC1\u0BAE\u0BBE\u0BB0\u0BCD 1 \u0BAE\u0BA3\u0BBF \u0BA8\u0BC7\u0BB0\u0BA4\u0BCD\u0BA4\u0BBF\u0BB1\u0BCD\u0B95\u0BC1 \u0BAE\u0BC1\u0BA9\u0BCD\u0BAA\u0BC1"
},
other:{
default:"\u0B9A\u0BC1\u0BAE\u0BBE\u0BB0\u0BCD {{count}} \u0BAE\u0BA3\u0BBF \u0BA8\u0BC7\u0BB0\u0BAE\u0BCD",
in:"\u0B9A\u0BC1\u0BAE\u0BBE\u0BB0\u0BCD {{count}} \u0BAE\u0BA3\u0BBF \u0BA8\u0BC7\u0BB0\u0BA4\u0BCD\u0BA4\u0BBF\u0BB1\u0BCD\u0B95\u0BC1 \u0BAE\u0BC1\u0BA9\u0BCD\u0BAA\u0BC1",
ago:"\u0B9A\u0BC1\u0BAE\u0BBE\u0BB0\u0BCD {{count}} \u0BAE\u0BA3\u0BBF \u0BA8\u0BC7\u0BB0\u0BA4\u0BCD\u0BA4\u0BBF\u0BB2\u0BCD"
}
},
xHours:{
one:{
default:"1 \u0BAE\u0BA3\u0BBF \u0BA8\u0BC7\u0BB0\u0BAE\u0BCD",
in:"1 \u0BAE\u0BA3\u0BBF \u0BA8\u0BC7\u0BB0\u0BA4\u0BCD\u0BA4\u0BBF\u0BB2\u0BCD",
ago:"1 \u0BAE\u0BA3\u0BBF \u0BA8\u0BC7\u0BB0\u0BA4\u0BCD\u0BA4\u0BBF\u0BB1\u0BCD\u0B95\u0BC1 \u0BAE\u0BC1\u0BA9\u0BCD\u0BAA\u0BC1"
},
other:{
default:"{{count}} \u0BAE\u0BA3\u0BBF \u0BA8\u0BC7\u0BB0\u0BAE\u0BCD",
in:"{{count}} \u0BAE\u0BA3\u0BBF \u0BA8\u0BC7\u0BB0\u0BA4\u0BCD\u0BA4\u0BBF\u0BB2\u0BCD",
ago:"{{count}} \u0BAE\u0BA3\u0BBF \u0BA8\u0BC7\u0BB0\u0BA4\u0BCD\u0BA4\u0BBF\u0BB1\u0BCD\u0B95\u0BC1 \u0BAE\u0BC1\u0BA9\u0BCD\u0BAA\u0BC1"
}
},
xDays:{
one:{
default:"1 \u0BA8\u0BBE\u0BB3\u0BCD",
in:"1 \u0BA8\u0BBE\u0BB3\u0BBF\u0BB2\u0BCD",
ago:"1 \u0BA8\u0BBE\u0BB3\u0BCD \u0BAE\u0BC1\u0BA9\u0BCD\u0BAA\u0BC1"
},
other:{
default:"{{count}} \u0BA8\u0BBE\u0B9F\u0BCD\u0B95\u0BB3\u0BCD",
in:"{{count}} \u0BA8\u0BBE\u0B9F\u0BCD\u0B95\u0BB3\u0BBF\u0BB2\u0BCD",
ago:"{{count}} \u0BA8\u0BBE\u0B9F\u0BCD\u0B95\u0BB3\u0BC1\u0B95\u0BCD\u0B95\u0BC1 \u0BAE\u0BC1\u0BA9\u0BCD\u0BAA\u0BC1"
}
},
aboutXWeeks:{
one:{
default:"\u0B9A\u0BC1\u0BAE\u0BBE\u0BB0\u0BCD 1 \u0BB5\u0BBE\u0BB0\u0BAE\u0BCD",
in:"\u0B9A\u0BC1\u0BAE\u0BBE\u0BB0\u0BCD 1 \u0BB5\u0BBE\u0BB0\u0BA4\u0BCD\u0BA4\u0BBF\u0BB2\u0BCD",
ago:"\u0B9A\u0BC1\u0BAE\u0BBE\u0BB0\u0BCD 1 \u0BB5\u0BBE\u0BB0\u0BAE\u0BCD \u0BAE\u0BC1\u0BA9\u0BCD\u0BAA\u0BC1"
},
other:{
default:"\u0B9A\u0BC1\u0BAE\u0BBE\u0BB0\u0BCD {{count}} \u0BB5\u0BBE\u0BB0\u0B99\u0BCD\u0B95\u0BB3\u0BCD",
in:"\u0B9A\u0BC1\u0BAE\u0BBE\u0BB0\u0BCD {{count}} \u0BB5\u0BBE\u0BB0\u0B99\u0BCD\u0B95\u0BB3\u0BBF\u0BB2\u0BCD",
ago:"\u0B9A\u0BC1\u0BAE\u0BBE\u0BB0\u0BCD {{count}} \u0BB5\u0BBE\u0BB0\u0B99\u0BCD\u0B95\u0BB3\u0BC1\u0B95\u0BCD\u0B95\u0BC1 \u0BAE\u0BC1\u0BA9\u0BCD\u0BAA\u0BC1"
}
},
xWeeks:{
one:{
default:"1 \u0BB5\u0BBE\u0BB0\u0BAE\u0BCD",
in:"1 \u0BB5\u0BBE\u0BB0\u0BA4\u0BCD\u0BA4\u0BBF\u0BB2\u0BCD",
ago:"1 \u0BB5\u0BBE\u0BB0\u0BAE\u0BCD \u0BAE\u0BC1\u0BA9\u0BCD\u0BAA\u0BC1"
},
other:{
default:"{{count}} \u0BB5\u0BBE\u0BB0\u0B99\u0BCD\u0B95\u0BB3\u0BCD",
in:"{{count}} \u0BB5\u0BBE\u0BB0\u0B99\u0BCD\u0B95\u0BB3\u0BBF\u0BB2\u0BCD",
ago:"{{count}} \u0BB5\u0BBE\u0BB0\u0B99\u0BCD\u0B95\u0BB3\u0BC1\u0B95\u0BCD\u0B95\u0BC1 \u0BAE\u0BC1\u0BA9\u0BCD\u0BAA\u0BC1"
}
},
aboutXMonths:{
one:{
default:"\u0B9A\u0BC1\u0BAE\u0BBE\u0BB0\u0BCD 1 \u0BAE\u0BBE\u0BA4\u0BAE\u0BCD",
in:"\u0B9A\u0BC1\u0BAE\u0BBE\u0BB0\u0BCD 1 \u0BAE\u0BBE\u0BA4\u0BA4\u0BCD\u0BA4\u0BBF\u0BB2\u0BCD",
ago:"\u0B9A\u0BC1\u0BAE\u0BBE\u0BB0\u0BCD 1 \u0BAE\u0BBE\u0BA4\u0BA4\u0BCD\u0BA4\u0BBF\u0BB1\u0BCD\u0B95\u0BC1 \u0BAE\u0BC1\u0BA9\u0BCD\u0BAA\u0BC1"
},
other:{
default:"\u0B9A\u0BC1\u0BAE\u0BBE\u0BB0\u0BCD {{count}} \u0BAE\u0BBE\u0BA4\u0B99\u0BCD\u0B95\u0BB3\u0BCD",
in:"\u0B9A\u0BC1\u0BAE\u0BBE\u0BB0\u0BCD {{count}} \u0BAE\u0BBE\u0BA4\u0B99\u0BCD\u0B95\u0BB3\u0BBF\u0BB2\u0BCD",
ago:"\u0B9A\u0BC1\u0BAE\u0BBE\u0BB0\u0BCD {{count}} \u0BAE\u0BBE\u0BA4\u0B99\u0BCD\u0B95\u0BB3\u0BC1\u0B95\u0BCD\u0B95\u0BC1 \u0BAE\u0BC1\u0BA9\u0BCD\u0BAA\u0BC1"
}
},
xMonths:{
one:{
default:"1 \u0BAE\u0BBE\u0BA4\u0BAE\u0BCD",
in:"1 \u0BAE\u0BBE\u0BA4\u0BA4\u0BCD\u0BA4\u0BBF\u0BB2\u0BCD",
ago:"1 \u0BAE\u0BBE\u0BA4\u0BAE\u0BCD \u0BAE\u0BC1\u0BA9\u0BCD\u0BAA\u0BC1"
},
other:{
default:"{{count}} \u0BAE\u0BBE\u0BA4\u0B99\u0BCD\u0B95\u0BB3\u0BCD",
in:"{{count}} \u0BAE\u0BBE\u0BA4\u0B99\u0BCD\u0B95\u0BB3\u0BBF\u0BB2\u0BCD",
ago:"{{count}} \u0BAE\u0BBE\u0BA4\u0B99\u0BCD\u0B95\u0BB3\u0BC1\u0B95\u0BCD\u0B95\u0BC1 \u0BAE\u0BC1\u0BA9\u0BCD\u0BAA\u0BC1"
}
},
aboutXYears:{
one:{
default:"\u0B9A\u0BC1\u0BAE\u0BBE\u0BB0\u0BCD 1 \u0BB5\u0BB0\u0BC1\u0B9F\u0BAE\u0BCD",
in:"\u0B9A\u0BC1\u0BAE\u0BBE\u0BB0\u0BCD 1 \u0B86\u0BA3\u0BCD\u0B9F\u0BBF\u0BB2\u0BCD",
ago:"\u0B9A\u0BC1\u0BAE\u0BBE\u0BB0\u0BCD 1 \u0BB5\u0BB0\u0BC1\u0B9F\u0BAE\u0BCD \u0BAE\u0BC1\u0BA9\u0BCD\u0BAA\u0BC1"
},
other:{
default:"\u0B9A\u0BC1\u0BAE\u0BBE\u0BB0\u0BCD {{count}} \u0B86\u0BA3\u0BCD\u0B9F\u0BC1\u0B95\u0BB3\u0BCD",
in:"\u0B9A\u0BC1\u0BAE\u0BBE\u0BB0\u0BCD {{count}} \u0B86\u0BA3\u0BCD\u0B9F\u0BC1\u0B95\u0BB3\u0BBF\u0BB2\u0BCD",
ago:"\u0B9A\u0BC1\u0BAE\u0BBE\u0BB0\u0BCD {{count}} \u0B86\u0BA3\u0BCD\u0B9F\u0BC1\u0B95\u0BB3\u0BC1\u0B95\u0BCD\u0B95\u0BC1 \u0BAE\u0BC1\u0BA9\u0BCD\u0BAA\u0BC1"
}
},
xYears:{
one:{
default:"1 \u0BB5\u0BB0\u0BC1\u0B9F\u0BAE\u0BCD",
in:"1 \u0B86\u0BA3\u0BCD\u0B9F\u0BBF\u0BB2\u0BCD",
ago:"1 \u0BB5\u0BB0\u0BC1\u0B9F\u0BAE\u0BCD \u0BAE\u0BC1\u0BA9\u0BCD\u0BAA\u0BC1"
},
other:{
default:"{{count}} \u0B86\u0BA3\u0BCD\u0B9F\u0BC1\u0B95\u0BB3\u0BCD",
in:"{{count}} \u0B86\u0BA3\u0BCD\u0B9F\u0BC1\u0B95\u0BB3\u0BBF\u0BB2\u0BCD",
ago:"{{count}} \u0B86\u0BA3\u0BCD\u0B9F\u0BC1\u0B95\u0BB3\u0BC1\u0B95\u0BCD\u0B95\u0BC1 \u0BAE\u0BC1\u0BA9\u0BCD\u0BAA\u0BC1"
}
},
overXYears:{
one:{
default:"1 \u0BB5\u0BB0\u0BC1\u0B9F\u0BA4\u0BCD\u0BA4\u0BBF\u0BB1\u0BCD\u0B95\u0BC1 \u0BAE\u0BC7\u0BB2\u0BCD",
in:"1 \u0BB5\u0BB0\u0BC1\u0B9F\u0BA4\u0BCD\u0BA4\u0BBF\u0BB1\u0BCD\u0B95\u0BC1\u0BAE\u0BCD \u0BAE\u0BC7\u0BB2\u0BBE\u0B95",
ago:"1 \u0BB5\u0BB0\u0BC1\u0B9F\u0BAE\u0BCD \u0BAE\u0BC1\u0BA9\u0BCD\u0BAA\u0BC1"
},
other:{
default:"{{count}} \u0B86\u0BA3\u0BCD\u0B9F\u0BC1\u0B95\u0BB3\u0BC1\u0B95\u0BCD\u0B95\u0BC1\u0BAE\u0BCD \u0BAE\u0BC7\u0BB2\u0BBE\u0B95",
in:"{{count}} \u0B86\u0BA3\u0BCD\u0B9F\u0BC1\u0B95\u0BB3\u0BBF\u0BB2\u0BCD",
ago:"{{count}} \u0B86\u0BA3\u0BCD\u0B9F\u0BC1\u0B95\u0BB3\u0BC1\u0B95\u0BCD\u0B95\u0BC1 \u0BAE\u0BC1\u0BA9\u0BCD\u0BAA\u0BC1"
}
},
almostXYears:{
one:{
default:"\u0B95\u0BBF\u0B9F\u0BCD\u0B9F\u0BA4\u0BCD\u0BA4\u0B9F\u0BCD\u0B9F 1 \u0BB5\u0BB0\u0BC1\u0B9F\u0BAE\u0BCD",
in:"\u0B95\u0BBF\u0B9F\u0BCD\u0B9F\u0BA4\u0BCD\u0BA4\u0B9F\u0BCD\u0B9F 1 \u0B86\u0BA3\u0BCD\u0B9F\u0BBF\u0BB2\u0BCD",
ago:"\u0B95\u0BBF\u0B9F\u0BCD\u0B9F\u0BA4\u0BCD\u0BA4\u0B9F\u0BCD\u0B9F 1 \u0BB5\u0BB0\u0BC1\u0B9F\u0BAE\u0BCD \u0BAE\u0BC1\u0BA9\u0BCD\u0BAA\u0BC1"
},
other:{
default:"\u0B95\u0BBF\u0B9F\u0BCD\u0B9F\u0BA4\u0BCD\u0BA4\u0B9F\u0BCD\u0B9F {{count}} \u0B86\u0BA3\u0BCD\u0B9F\u0BC1\u0B95\u0BB3\u0BCD",
in:"\u0B95\u0BBF\u0B9F\u0BCD\u0B9F\u0BA4\u0BCD\u0BA4\u0B9F\u0BCD\u0B9F {{count}} \u0B86\u0BA3\u0BCD\u0B9F\u0BC1\u0B95\u0BB3\u0BBF\u0BB2\u0BCD",
ago:"\u0B95\u0BBF\u0B9F\u0BCD\u0B9F\u0BA4\u0BCD\u0BA4\u0B9F\u0BCD\u0B9F {{count}} \u0B86\u0BA3\u0BCD\u0B9F\u0BC1\u0B95\u0BB3\u0BC1\u0B95\u0BCD\u0B95\u0BC1 \u0BAE\u0BC1\u0BA9\u0BCD\u0BAA\u0BC1"
}
}
};
var formatDistance157=function formatDistance157(token,count,options){
var tense=options!==null&&options!==void 0&&options.addSuffix?options.comparison&&options.comparison>0?"in":"ago":"default";
var tokenValue=formatDistanceLocale73[token];
if(!isPluralType2(tokenValue))
return tokenValue[tense];
if(count===1){
return tokenValue.one[tense];
}else{
return tokenValue.other[tense].replace("{{count}}",String(count));
}
};

// lib/locale/ta/_lib/formatLong.js
var dateFormats82={
full:"EEEE, d MMMM, y",
long:"d MMMM, y",
medium:"d MMM, y",
short:"d/M/yy"
};
var timeFormats82={
full:"a h:mm:ss zzzz",
long:"a h:mm:ss z",
medium:"a h:mm:ss",
short:"a h:mm"
};
var dateTimeFormats82={
full:"{{date}} {{time}}",
long:"{{date}} {{time}}",
medium:"{{date}}, {{time}}",
short:"{{date}}, {{time}}"
};
var formatLong165={
date:buildFormatLongFn({
formats:dateFormats82,
defaultWidth:"full"
}),
time:buildFormatLongFn({
formats:timeFormats82,
defaultWidth:"full"
}),
dateTime:buildFormatLongFn({
formats:dateTimeFormats82,
defaultWidth:"full"
})
};

// lib/locale/ta/_lib/formatRelative.js
var formatRelativeLocale74={
lastWeek:"'\u0B95\u0B9F\u0BA8\u0BCD\u0BA4' eeee p '\u0BAE\u0BA3\u0BBF\u0B95\u0BCD\u0B95\u0BC1'",
yesterday:"'\u0BA8\u0BC7\u0BB1\u0BCD\u0BB1\u0BC1 ' p '\u0BAE\u0BA3\u0BBF\u0B95\u0BCD\u0B95\u0BC1'",
today:"'\u0B87\u0BA9\u0BCD\u0BB1\u0BC1 ' p '\u0BAE\u0BA3\u0BBF\u0B95\u0BCD\u0B95\u0BC1'",
tomorrow:"'\u0BA8\u0BBE\u0BB3\u0BC8 ' p '\u0BAE\u0BA3\u0BBF\u0B95\u0BCD\u0B95\u0BC1'",
nextWeek:"eeee p '\u0BAE\u0BA3\u0BBF\u0B95\u0BCD\u0B95\u0BC1'",
other:"P"
};
var formatRelative157=function formatRelative157(token,_date,_baseDate,_options){return formatRelativeLocale74[token];};

// lib/locale/ta/_lib/localize.js
var eraValues74={
narrow:["\u0B95\u0BBF.\u0BAE\u0BC1.","\u0B95\u0BBF.\u0BAA\u0BBF."],
abbreviated:["\u0B95\u0BBF.\u0BAE\u0BC1.","\u0B95\u0BBF.\u0BAA\u0BBF."],
wide:["\u0B95\u0BBF\u0BB1\u0BBF\u0BB8\u0BCD\u0BA4\u0BC1\u0BB5\u0BC1\u0B95\u0BCD\u0B95\u0BC1 \u0BAE\u0BC1\u0BA9\u0BCD","\u0B85\u0BA9\u0BCD\u0BA9\u0BCB \u0B9F\u0BCB\u0BAE\u0BBF\u0BA9\u0BBF"]
};
var quarterValues74={
narrow:["1","2","3","4"],
abbreviated:["\u0B95\u0BBE\u0BB2\u0BBE.1","\u0B95\u0BBE\u0BB2\u0BBE.2","\u0B95\u0BBE\u0BB2\u0BBE.3","\u0B95\u0BBE\u0BB2\u0BBE.4"],
wide:[
"\u0B92\u0BA9\u0BCD\u0BB1\u0BBE\u0BAE\u0BCD \u0B95\u0BBE\u0BB2\u0BBE\u0BA3\u0BCD\u0B9F\u0BC1",
"\u0B87\u0BB0\u0BA3\u0BCD\u0B9F\u0BBE\u0BAE\u0BCD \u0B95\u0BBE\u0BB2\u0BBE\u0BA3\u0BCD\u0B9F\u0BC1",
"\u0BAE\u0BC2\u0BA9\u0BCD\u0BB1\u0BBE\u0BAE\u0BCD \u0B95\u0BBE\u0BB2\u0BBE\u0BA3\u0BCD\u0B9F\u0BC1",
"\u0BA8\u0BBE\u0BA9\u0BCD\u0B95\u0BBE\u0BAE\u0BCD \u0B95\u0BBE\u0BB2\u0BBE\u0BA3\u0BCD\u0B9F\u0BC1"]

};
var monthValues74={
narrow:["\u0B9C","\u0BAA\u0BBF","\u0BAE\u0BBE","\u0B8F","\u0BAE\u0BC7","\u0B9C\u0BC2","\u0B9C\u0BC2","\u0B86","\u0B9A\u0BC6","\u0B85","\u0BA8","\u0B9F\u0BBF"],
abbreviated:[
"\u0B9C\u0BA9.",
"\u0BAA\u0BBF\u0BAA\u0BCD.",
"\u0BAE\u0BBE\u0BB0\u0BCD.",
"\u0B8F\u0BAA\u0BCD.",
"\u0BAE\u0BC7",
"\u0B9C\u0BC2\u0BA9\u0BCD",
"\u0B9C\u0BC2\u0BB2\u0BC8",
"\u0B86\u0B95.",
"\u0B9A\u0BC6\u0BAA\u0BCD.",
"\u0B85\u0B95\u0BCD.",
"\u0BA8\u0BB5.",
"\u0B9F\u0BBF\u0B9A."],

wide:[
"\u0B9C\u0BA9\u0BB5\u0BB0\u0BBF",
"\u0BAA\u0BBF\u0BAA\u0BCD\u0BB0\u0BB5\u0BB0\u0BBF",
"\u0BAE\u0BBE\u0BB0\u0BCD\u0B9A\u0BCD",
"\u0B8F\u0BAA\u0BCD\u0BB0\u0BB2\u0BCD",
"\u0BAE\u0BC7",
"\u0B9C\u0BC2\u0BA9\u0BCD",
"\u0B9C\u0BC2\u0BB2\u0BC8",
"\u0B86\u0B95\u0BB8\u0BCD\u0B9F\u0BCD",
"\u0B9A\u0BC6\u0BAA\u0BCD\u0B9F\u0BAE\u0BCD\u0BAA\u0BB0\u0BCD",
"\u0B85\u0B95\u0BCD\u0B9F\u0BCB\u0BAA\u0BB0\u0BCD",
"\u0BA8\u0BB5\u0BAE\u0BCD\u0BAA\u0BB0\u0BCD",
"\u0B9F\u0BBF\u0B9A\u0BAE\u0BCD\u0BAA\u0BB0\u0BCD"]

};
var dayValues74={
narrow:["\u0B9E\u0BBE","\u0BA4\u0BBF","\u0B9A\u0BC6","\u0BAA\u0BC1","\u0BB5\u0BBF","\u0BB5\u0BC6","\u0B9A"],
short:["\u0B9E\u0BBE","\u0BA4\u0BBF","\u0B9A\u0BC6","\u0BAA\u0BC1","\u0BB5\u0BBF","\u0BB5\u0BC6","\u0B9A"],
abbreviated:["\u0B9E\u0BBE\u0BAF\u0BBF.","\u0BA4\u0BBF\u0B99\u0BCD.","\u0B9A\u0BC6\u0BB5\u0BCD.","\u0BAA\u0BC1\u0BA4.","\u0BB5\u0BBF\u0BAF\u0BBE.","\u0BB5\u0BC6\u0BB3\u0BCD.","\u0B9A\u0BA9\u0BBF"],
wide:[
"\u0B9E\u0BBE\u0BAF\u0BBF\u0BB1\u0BC1",
"\u0BA4\u0BBF\u0B99\u0BCD\u0B95\u0BB3\u0BCD",
"\u0B9A\u0BC6\u0BB5\u0BCD\u0BB5\u0BBE\u0BAF\u0BCD",
"\u0BAA\u0BC1\u0BA4\u0BA9\u0BCD",
"\u0BB5\u0BBF\u0BAF\u0BBE\u0BB4\u0BA9\u0BCD",
"\u0BB5\u0BC6\u0BB3\u0BCD\u0BB3\u0BBF",
"\u0B9A\u0BA9\u0BBF"]

};
var dayPeriodValues74={
narrow:{
am:"\u0BAE\u0BC1.\u0BAA",
pm:"\u0BAA\u0BBF.\u0BAA",
midnight:"\u0BA8\u0BB3\u0BCD.",
noon:"\u0BA8\u0BA3\u0BCD.",
morning:"\u0B95\u0BBE.",
afternoon:"\u0BAE\u0BA4\u0BBF.",
evening:"\u0BAE\u0BBE.",
night:"\u0B87\u0BB0."
},
abbreviated:{
am:"\u0BAE\u0BC1\u0BB1\u0BCD\u0BAA\u0B95\u0BB2\u0BCD",
pm:"\u0BAA\u0BBF\u0BB1\u0BCD\u0BAA\u0B95\u0BB2\u0BCD",
midnight:"\u0BA8\u0BB3\u0BCD\u0BB3\u0BBF\u0BB0\u0BB5\u0BC1",
noon:"\u0BA8\u0BA3\u0BCD\u0BAA\u0B95\u0BB2\u0BCD",
morning:"\u0B95\u0BBE\u0BB2\u0BC8",
afternoon:"\u0BAE\u0BA4\u0BBF\u0BAF\u0BAE\u0BCD",
evening:"\u0BAE\u0BBE\u0BB2\u0BC8",
night:"\u0B87\u0BB0\u0BB5\u0BC1"
},
wide:{
am:"\u0BAE\u0BC1\u0BB1\u0BCD\u0BAA\u0B95\u0BB2\u0BCD",
pm:"\u0BAA\u0BBF\u0BB1\u0BCD\u0BAA\u0B95\u0BB2\u0BCD",
midnight:"\u0BA8\u0BB3\u0BCD\u0BB3\u0BBF\u0BB0\u0BB5\u0BC1",
noon:"\u0BA8\u0BA3\u0BCD\u0BAA\u0B95\u0BB2\u0BCD",
morning:"\u0B95\u0BBE\u0BB2\u0BC8",
afternoon:"\u0BAE\u0BA4\u0BBF\u0BAF\u0BAE\u0BCD",
evening:"\u0BAE\u0BBE\u0BB2\u0BC8",
night:"\u0B87\u0BB0\u0BB5\u0BC1"
}
};
var formattingDayPeriodValues58={
narrow:{
am:"\u0BAE\u0BC1.\u0BAA",
pm:"\u0BAA\u0BBF.\u0BAA",
midnight:"\u0BA8\u0BB3\u0BCD.",
noon:"\u0BA8\u0BA3\u0BCD.",
morning:"\u0B95\u0BBE.",
afternoon:"\u0BAE\u0BA4\u0BBF.",
evening:"\u0BAE\u0BBE.",
night:"\u0B87\u0BB0."
},
abbreviated:{
am:"\u0BAE\u0BC1\u0BB1\u0BCD\u0BAA\u0B95\u0BB2\u0BCD",
pm:"\u0BAA\u0BBF\u0BB1\u0BCD\u0BAA\u0B95\u0BB2\u0BCD",
midnight:"\u0BA8\u0BB3\u0BCD\u0BB3\u0BBF\u0BB0\u0BB5\u0BC1",
noon:"\u0BA8\u0BA3\u0BCD\u0BAA\u0B95\u0BB2\u0BCD",
morning:"\u0B95\u0BBE\u0BB2\u0BC8",
afternoon:"\u0BAE\u0BA4\u0BBF\u0BAF\u0BAE\u0BCD",
evening:"\u0BAE\u0BBE\u0BB2\u0BC8",
night:"\u0B87\u0BB0\u0BB5\u0BC1"
},
wide:{
am:"\u0BAE\u0BC1\u0BB1\u0BCD\u0BAA\u0B95\u0BB2\u0BCD",
pm:"\u0BAA\u0BBF\u0BB1\u0BCD\u0BAA\u0B95\u0BB2\u0BCD",
midnight:"\u0BA8\u0BB3\u0BCD\u0BB3\u0BBF\u0BB0\u0BB5\u0BC1",
noon:"\u0BA8\u0BA3\u0BCD\u0BAA\u0B95\u0BB2\u0BCD",
morning:"\u0B95\u0BBE\u0BB2\u0BC8",
afternoon:"\u0BAE\u0BA4\u0BBF\u0BAF\u0BAE\u0BCD",
evening:"\u0BAE\u0BBE\u0BB2\u0BC8",
night:"\u0B87\u0BB0\u0BB5\u0BC1"
}
};
var ordinalNumber74=function ordinalNumber74(dirtyNumber,_options){
return String(dirtyNumber);
};
var localize160={
ordinalNumber:ordinalNumber74,
era:buildLocalizeFn({
values:eraValues74,
defaultWidth:"wide"
}),
quarter:buildLocalizeFn({
values:quarterValues74,
defaultWidth:"wide",
argumentCallback:function argumentCallback(quarter){return quarter-1;}
}),
month:buildLocalizeFn({
values:monthValues74,
defaultWidth:"wide"
}),
day:buildLocalizeFn({
values:dayValues74,
defaultWidth:"wide"
}),
dayPeriod:buildLocalizeFn({
values:dayPeriodValues74,
defaultWidth:"wide",
formattingValues:formattingDayPeriodValues58,
defaultFormattingWidth:"wide"
})
};

// lib/locale/ta/_lib/match.js
var matchOrdinalNumberPattern73=/^(\d+)(வது)?/i;
var parseOrdinalNumberPattern73=/\d+/i;
var matchEraPatterns73={
narrow:/^(கி.மு.|கி.பி.)/i,
abbreviated:/^(கி\.?\s?மு\.?|கி\.?\s?பி\.?)/,
wide:/^(கிறிஸ்துவுக்கு\sமுன்|அன்னோ\sடோமினி)/i
};
var parseEraPatterns73={
any:[/கி\.?\s?மு\.?/,/கி\.?\s?பி\.?/]
};
var matchQuarterPatterns73={
narrow:/^[1234]/i,
abbreviated:/^காலா.[1234]/i,
wide:/^(ஒன்றாம்|இரண்டாம்|மூன்றாம்|நான்காம்) காலாண்டு/i
};
var parseQuarterPatterns73={
narrow:[/1/i,/2/i,/3/i,/4/i],
any:[
/(1|காலா.1|ஒன்றாம்)/i,
/(2|காலா.2|இரண்டாம்)/i,
/(3|காலா.3|மூன்றாம்)/i,
/(4|காலா.4|நான்காம்)/i]

};
var matchMonthPatterns73={
narrow:/^(ஜ|பி|மா|ஏ|மே|ஜூ|ஆ|செ|அ|ந|டி)$/i,
abbreviated:/^(ஜன.|பிப்.|மார்.|ஏப்.|மே|ஜூன்|ஜூலை|ஆக.|செப்.|அக்.|நவ.|டிச.)/i,
wide:/^(ஜனவரி|பிப்ரவரி|மார்ச்|ஏப்ரல்|மே|ஜூன்|ஜூலை|ஆகஸ்ட்|செப்டம்பர்|அக்டோபர்|நவம்பர்|டிசம்பர்)/i
};
var parseMonthPatterns73={
narrow:[
/^ஜ$/i,
/^பி/i,
/^மா/i,
/^ஏ/i,
/^மே/i,
/^ஜூ/i,
/^ஜூ/i,
/^ஆ/i,
/^செ/i,
/^அ/i,
/^ந/i,
/^டி/i],

any:[
/^ஜன/i,
/^பி/i,
/^மா/i,
/^ஏ/i,
/^மே/i,
/^ஜூன்/i,
/^ஜூலை/i,
/^ஆ/i,
/^செ/i,
/^அ/i,
/^ந/i,
/^டி/i]

};
var matchDayPatterns73={
narrow:/^(ஞா|தி|செ|பு|வி|வெ|ச)/i,
short:/^(ஞா|தி|செ|பு|வி|வெ|ச)/i,
abbreviated:/^(ஞாயி.|திங்.|செவ்.|புத.|வியா.|வெள்.|சனி)/i,
wide:/^(ஞாயிறு|திங்கள்|செவ்வாய்|புதன்|வியாழன்|வெள்ளி|சனி)/i
};
var parseDayPatterns73={
narrow:[/^ஞா/i,/^தி/i,/^செ/i,/^பு/i,/^வி/i,/^வெ/i,/^ச/i],
any:[/^ஞா/i,/^தி/i,/^செ/i,/^பு/i,/^வி/i,/^வெ/i,/^ச/i]
};
var matchDayPeriodPatterns73={
narrow:/^(மு.ப|பி.ப|நள்|நண்|காலை|மதியம்|மாலை|இரவு)/i,
any:/^(மு.ப|பி.ப|முற்பகல்|பிற்பகல்|நள்ளிரவு|நண்பகல்|காலை|மதியம்|மாலை|இரவு)/i
};
var parseDayPeriodPatterns73={
any:{
am:/^மு/i,
pm:/^பி/i,
midnight:/^நள்/i,
noon:/^நண்/i,
morning:/காலை/i,
afternoon:/மதியம்/i,
evening:/மாலை/i,
night:/இரவு/i
}
};
var match156={
ordinalNumber:buildMatchPatternFn({
matchPattern:matchOrdinalNumberPattern73,
parsePattern:parseOrdinalNumberPattern73,
valueCallback:function valueCallback(value){return parseInt(value,10);}
}),
era:buildMatchFn({
matchPatterns:matchEraPatterns73,
defaultMatchWidth:"wide",
parsePatterns:parseEraPatterns73,
defaultParseWidth:"any"
}),
quarter:buildMatchFn({
matchPatterns:matchQuarterPatterns73,
defaultMatchWidth:"wide",
parsePatterns:parseQuarterPatterns73,
defaultParseWidth:"any",
valueCallback:function valueCallback(index){return index+1;}
}),
month:buildMatchFn({
matchPatterns:matchMonthPatterns73,
defaultMatchWidth:"wide",
parsePatterns:parseMonthPatterns73,
defaultParseWidth:"any"
}),
day:buildMatchFn({
matchPatterns:matchDayPatterns73,
defaultMatchWidth:"wide",
parsePatterns:parseDayPatterns73,
defaultParseWidth:"any"
}),
dayPeriod:buildMatchFn({
matchPatterns:matchDayPeriodPatterns73,
defaultMatchWidth:"any",
parsePatterns:parseDayPeriodPatterns73,
defaultParseWidth:"any"
})
};

// lib/locale/ta.js
var _ta={
code:"ta",
formatDistance:formatDistance157,
formatLong:formatLong165,
formatRelative:formatRelative157,
localize:localize160,
match:match156,
options:{
weekStartsOn:1,
firstWeekContainsDate:4
}
};
// lib/locale/te/_lib/formatDistance.js
var formatDistanceLocale74={
lessThanXSeconds:{
standalone:{
one:"\u0C38\u0C46\u0C15\u0C28\u0C41 \u0C15\u0C28\u0C4D\u0C28\u0C3E \u0C24\u0C15\u0C4D\u0C15\u0C41\u0C35",
other:"{{count}} \u0C38\u0C46\u0C15\u0C28\u0C4D\u0C32 \u0C15\u0C28\u0C4D\u0C28\u0C3E \u0C24\u0C15\u0C4D\u0C15\u0C41\u0C35"
},
withPreposition:{
one:"\u0C38\u0C46\u0C15\u0C28\u0C41",
other:"{{count}} \u0C38\u0C46\u0C15\u0C28\u0C4D\u0C32"
}
},
xSeconds:{
standalone:{
one:"\u0C12\u0C15 \u0C38\u0C46\u0C15\u0C28\u0C41",
other:"{{count}} \u0C38\u0C46\u0C15\u0C28\u0C4D\u0C32"
},
withPreposition:{
one:"\u0C12\u0C15 \u0C38\u0C46\u0C15\u0C28\u0C41",
other:"{{count}} \u0C38\u0C46\u0C15\u0C28\u0C4D\u0C32"
}
},
halfAMinute:{
standalone:"\u0C05\u0C30 \u0C28\u0C3F\u0C2E\u0C3F\u0C37\u0C02",
withPreposition:"\u0C05\u0C30 \u0C28\u0C3F\u0C2E\u0C3F\u0C37\u0C02"
},
lessThanXMinutes:{
standalone:{
one:"\u0C12\u0C15 \u0C28\u0C3F\u0C2E\u0C3F\u0C37\u0C02 \u0C15\u0C28\u0C4D\u0C28\u0C3E \u0C24\u0C15\u0C4D\u0C15\u0C41\u0C35",
other:"{{count}} \u0C28\u0C3F\u0C2E\u0C3F\u0C37\u0C3E\u0C32 \u0C15\u0C28\u0C4D\u0C28\u0C3E \u0C24\u0C15\u0C4D\u0C15\u0C41\u0C35"
},
withPreposition:{
one:"\u0C12\u0C15 \u0C28\u0C3F\u0C2E\u0C3F\u0C37\u0C02",
other:"{{count}} \u0C28\u0C3F\u0C2E\u0C3F\u0C37\u0C3E\u0C32"
}
},
xMinutes:{
standalone:{
one:"\u0C12\u0C15 \u0C28\u0C3F\u0C2E\u0C3F\u0C37\u0C02",
other:"{{count}} \u0C28\u0C3F\u0C2E\u0C3F\u0C37\u0C3E\u0C32\u0C41"
},
withPreposition:{
one:"\u0C12\u0C15 \u0C28\u0C3F\u0C2E\u0C3F\u0C37\u0C02",
other:"{{count}} \u0C28\u0C3F\u0C2E\u0C3F\u0C37\u0C3E\u0C32"
}
},
aboutXHours:{
standalone:{
one:"\u0C38\u0C41\u0C2E\u0C3E\u0C30\u0C41 \u0C12\u0C15 \u0C17\u0C02\u0C1F",
other:"\u0C38\u0C41\u0C2E\u0C3E\u0C30\u0C41 {{count}} \u0C17\u0C02\u0C1F\u0C32\u0C41"
},
withPreposition:{
one:"\u0C38\u0C41\u0C2E\u0C3E\u0C30\u0C41 \u0C12\u0C15 \u0C17\u0C02\u0C1F",
other:"\u0C38\u0C41\u0C2E\u0C3E\u0C30\u0C41 {{count}} \u0C17\u0C02\u0C1F\u0C32"
}
},
xHours:{
standalone:{
one:"\u0C12\u0C15 \u0C17\u0C02\u0C1F",
other:"{{count}} \u0C17\u0C02\u0C1F\u0C32\u0C41"
},
withPreposition:{
one:"\u0C12\u0C15 \u0C17\u0C02\u0C1F",
other:"{{count}} \u0C17\u0C02\u0C1F\u0C32"
}
},
xDays:{
standalone:{
one:"\u0C12\u0C15 \u0C30\u0C4B\u0C1C\u0C41",
other:"{{count}} \u0C30\u0C4B\u0C1C\u0C41\u0C32\u0C41"
},
withPreposition:{
one:"\u0C12\u0C15 \u0C30\u0C4B\u0C1C\u0C41",
other:"{{count}} \u0C30\u0C4B\u0C1C\u0C41\u0C32"
}
},
aboutXWeeks:{
standalone:{
one:"\u0C38\u0C41\u0C2E\u0C3E\u0C30\u0C41 \u0C12\u0C15 \u0C35\u0C3E\u0C30\u0C02",
other:"\u0C38\u0C41\u0C2E\u0C3E\u0C30\u0C41 {{count}} \u0C35\u0C3E\u0C30\u0C3E\u0C32\u0C41"
},
withPreposition:{
one:"\u0C38\u0C41\u0C2E\u0C3E\u0C30\u0C41 \u0C12\u0C15 \u0C35\u0C3E\u0C30\u0C02",
other:"\u0C38\u0C41\u0C2E\u0C3E\u0C30\u0C41 {{count}} \u0C35\u0C3E\u0C30\u0C3E\u0C32\u0C32"
}
},
xWeeks:{
standalone:{
one:"\u0C12\u0C15 \u0C35\u0C3E\u0C30\u0C02",
other:"{{count}} \u0C35\u0C3E\u0C30\u0C3E\u0C32\u0C41"
},
withPreposition:{
one:"\u0C12\u0C15 \u0C35\u0C3E\u0C30\u0C02",
other:"{{count}} \u0C35\u0C3E\u0C30\u0C3E\u0C32\u0C32"
}
},
aboutXMonths:{
standalone:{
one:"\u0C38\u0C41\u0C2E\u0C3E\u0C30\u0C41 \u0C12\u0C15 \u0C28\u0C46\u0C32",
other:"\u0C38\u0C41\u0C2E\u0C3E\u0C30\u0C41 {{count}} \u0C28\u0C46\u0C32\u0C32\u0C41"
},
withPreposition:{
one:"\u0C38\u0C41\u0C2E\u0C3E\u0C30\u0C41 \u0C12\u0C15 \u0C28\u0C46\u0C32",
other:"\u0C38\u0C41\u0C2E\u0C3E\u0C30\u0C41 {{count}} \u0C28\u0C46\u0C32\u0C32"
}
},
xMonths:{
standalone:{
one:"\u0C12\u0C15 \u0C28\u0C46\u0C32",
other:"{{count}} \u0C28\u0C46\u0C32\u0C32\u0C41"
},
withPreposition:{
one:"\u0C12\u0C15 \u0C28\u0C46\u0C32",
other:"{{count}} \u0C28\u0C46\u0C32\u0C32"
}
},
aboutXYears:{
standalone:{
one:"\u0C38\u0C41\u0C2E\u0C3E\u0C30\u0C41 \u0C12\u0C15 \u0C38\u0C02\u0C35\u0C24\u0C4D\u0C38\u0C30\u0C02",
other:"\u0C38\u0C41\u0C2E\u0C3E\u0C30\u0C41 {{count}} \u0C38\u0C02\u0C35\u0C24\u0C4D\u0C38\u0C30\u0C3E\u0C32\u0C41"
},
withPreposition:{
one:"\u0C38\u0C41\u0C2E\u0C3E\u0C30\u0C41 \u0C12\u0C15 \u0C38\u0C02\u0C35\u0C24\u0C4D\u0C38\u0C30\u0C02",
other:"\u0C38\u0C41\u0C2E\u0C3E\u0C30\u0C41 {{count}} \u0C38\u0C02\u0C35\u0C24\u0C4D\u0C38\u0C30\u0C3E\u0C32"
}
},
xYears:{
standalone:{
one:"\u0C12\u0C15 \u0C38\u0C02\u0C35\u0C24\u0C4D\u0C38\u0C30\u0C02",
other:"{{count}} \u0C38\u0C02\u0C35\u0C24\u0C4D\u0C38\u0C30\u0C3E\u0C32\u0C41"
},
withPreposition:{
one:"\u0C12\u0C15 \u0C38\u0C02\u0C35\u0C24\u0C4D\u0C38\u0C30\u0C02",
other:"{{count}} \u0C38\u0C02\u0C35\u0C24\u0C4D\u0C38\u0C30\u0C3E\u0C32"
}
},
overXYears:{
standalone:{
one:"\u0C12\u0C15 \u0C38\u0C02\u0C35\u0C24\u0C4D\u0C38\u0C30\u0C02 \u0C2A\u0C48\u0C17\u0C3E",
other:"{{count}} \u0C38\u0C02\u0C35\u0C24\u0C4D\u0C38\u0C30\u0C3E\u0C32\u0C15\u0C41 \u0C2A\u0C48\u0C17\u0C3E"
},
withPreposition:{
one:"\u0C12\u0C15 \u0C38\u0C02\u0C35\u0C24\u0C4D\u0C38\u0C30\u0C02",
other:"{{count}} \u0C38\u0C02\u0C35\u0C24\u0C4D\u0C38\u0C30\u0C3E\u0C32"
}
},
almostXYears:{
standalone:{
one:"\u0C26\u0C3E\u0C26\u0C3E\u0C2A\u0C41 \u0C12\u0C15 \u0C38\u0C02\u0C35\u0C24\u0C4D\u0C38\u0C30\u0C02",
other:"\u0C26\u0C3E\u0C26\u0C3E\u0C2A\u0C41 {{count}} \u0C38\u0C02\u0C35\u0C24\u0C4D\u0C38\u0C30\u0C3E\u0C32\u0C41"
},
withPreposition:{
one:"\u0C26\u0C3E\u0C26\u0C3E\u0C2A\u0C41 \u0C12\u0C15 \u0C38\u0C02\u0C35\u0C24\u0C4D\u0C38\u0C30\u0C02",
other:"\u0C26\u0C3E\u0C26\u0C3E\u0C2A\u0C41 {{count}} \u0C38\u0C02\u0C35\u0C24\u0C4D\u0C38\u0C30\u0C3E\u0C32"
}
}
};
var formatDistance159=function formatDistance159(token,count,options){
var result;
var tokenValue=options!==null&&options!==void 0&&options.addSuffix?formatDistanceLocale74[token].withPreposition:formatDistanceLocale74[token].standalone;
if(typeof tokenValue==="string"){
result=tokenValue;
}else if(count===1){
result=tokenValue.one;
}else{
result=tokenValue.other.replace("{{count}}",String(count));
}
if(options!==null&&options!==void 0&&options.addSuffix){
if(options.comparison&&options.comparison>0){
return result+"\u0C32\u0C4B";
}else{
return result+" \u0C15\u0C4D\u0C30\u0C3F\u0C24\u0C02";
}
}
return result;
};

// lib/locale/te/_lib/formatLong.js
var dateFormats83={
full:"d, MMMM y, EEEE",
long:"d MMMM, y",
medium:"d MMM, y",
short:"dd-MM-yy"
};
var timeFormats83={
full:"h:mm:ss a zzzz",
long:"h:mm:ss a z",
medium:"h:mm:ss a",
short:"h:mm a"
};
var dateTimeFormats83={
full:"{{date}} {{time}}'\u0C15\u0C3F'",
long:"{{date}} {{time}}'\u0C15\u0C3F'",
medium:"{{date}} {{time}}",
short:"{{date}} {{time}}"
};
var formatLong167={
date:buildFormatLongFn({
formats:dateFormats83,
defaultWidth:"full"
}),
time:buildFormatLongFn({
formats:timeFormats83,
defaultWidth:"full"
}),
dateTime:buildFormatLongFn({
formats:dateTimeFormats83,
defaultWidth:"full"
})
};

// lib/locale/te/_lib/formatRelative.js
var formatRelativeLocale75={
lastWeek:"'\u0C17\u0C24' eeee p",
yesterday:"'\u0C28\u0C3F\u0C28\u0C4D\u0C28' p",
today:"'\u0C08 \u0C30\u0C4B\u0C1C\u0C41' p",
tomorrow:"'\u0C30\u0C47\u0C2A\u0C41' p",
nextWeek:"'\u0C24\u0C26\u0C41\u0C2A\u0C30\u0C3F' eeee p",
other:"P"
};
var formatRelative159=function formatRelative159(token,_date,_baseDate,_options){return formatRelativeLocale75[token];};

// lib/locale/te/_lib/localize.js
var eraValues75={
narrow:["\u0C15\u0C4D\u0C30\u0C40.\u0C2A\u0C42.","\u0C15\u0C4D\u0C30\u0C40.\u0C36."],
abbreviated:["\u0C15\u0C4D\u0C30\u0C40.\u0C2A\u0C42.","\u0C15\u0C4D\u0C30\u0C40.\u0C36."],
wide:["\u0C15\u0C4D\u0C30\u0C40\u0C38\u0C4D\u0C24\u0C41 \u0C2A\u0C42\u0C30\u0C4D\u0C35\u0C02","\u0C15\u0C4D\u0C30\u0C40\u0C38\u0C4D\u0C24\u0C41\u0C36\u0C15\u0C02"]
};
var quarterValues75={
narrow:["1","2","3","4"],
abbreviated:["\u0C24\u0C4D\u0C30\u0C481","\u0C24\u0C4D\u0C30\u0C482","\u0C24\u0C4D\u0C30\u0C483","\u0C24\u0C4D\u0C30\u0C484"],
wide:["1\u0C35 \u0C24\u0C4D\u0C30\u0C48\u0C2E\u0C3E\u0C38\u0C3F\u0C15\u0C02","2\u0C35 \u0C24\u0C4D\u0C30\u0C48\u0C2E\u0C3E\u0C38\u0C3F\u0C15\u0C02","3\u0C35 \u0C24\u0C4D\u0C30\u0C48\u0C2E\u0C3E\u0C38\u0C3F\u0C15\u0C02","4\u0C35 \u0C24\u0C4D\u0C30\u0C48\u0C2E\u0C3E\u0C38\u0C3F\u0C15\u0C02"]
};
var monthValues75={
narrow:["\u0C1C","\u0C2B\u0C3F","\u0C2E\u0C3E","\u0C0F","\u0C2E\u0C47","\u0C1C\u0C42","\u0C1C\u0C41","\u0C06","\u0C38\u0C46","\u0C05","\u0C28","\u0C21\u0C3F"],
abbreviated:[
"\u0C1C\u0C28",
"\u0C2B\u0C3F\u0C2C\u0C4D\u0C30",
"\u0C2E\u0C3E\u0C30\u0C4D\u0C1A\u0C3F",
"\u0C0F\u0C2A\u0C4D\u0C30\u0C3F",
"\u0C2E\u0C47",
"\u0C1C\u0C42\u0C28\u0C4D",
"\u0C1C\u0C41\u0C32\u0C48",
"\u0C06\u0C17",
"\u0C38\u0C46\u0C2A\u0C4D\u0C1F\u0C46\u0C02",
"\u0C05\u0C15\u0C4D\u0C1F\u0C4B",
"\u0C28\u0C35\u0C02",
"\u0C21\u0C3F\u0C38\u0C46\u0C02"],

wide:[
"\u0C1C\u0C28\u0C35\u0C30\u0C3F",
"\u0C2B\u0C3F\u0C2C\u0C4D\u0C30\u0C35\u0C30\u0C3F",
"\u0C2E\u0C3E\u0C30\u0C4D\u0C1A\u0C3F",
"\u0C0F\u0C2A\u0C4D\u0C30\u0C3F\u0C32\u0C4D",
"\u0C2E\u0C47",
"\u0C1C\u0C42\u0C28\u0C4D",
"\u0C1C\u0C41\u0C32\u0C48",
"\u0C06\u0C17\u0C38\u0C4D\u0C1F\u0C41",
"\u0C38\u0C46\u0C2A\u0C4D\u0C1F\u0C46\u0C02\u0C2C\u0C30\u0C4D",
"\u0C05\u0C15\u0C4D\u0C1F\u0C4B\u0C2C\u0C30\u0C4D",
"\u0C28\u0C35\u0C02\u0C2C\u0C30\u0C4D",
"\u0C21\u0C3F\u0C38\u0C46\u0C02\u0C2C\u0C30\u0C4D"]

};
var dayValues75={
narrow:["\u0C06","\u0C38\u0C4B","\u0C2E","\u0C2C\u0C41","\u0C17\u0C41","\u0C36\u0C41","\u0C36"],
short:["\u0C06\u0C26\u0C3F","\u0C38\u0C4B\u0C2E","\u0C2E\u0C02\u0C17\u0C33","\u0C2C\u0C41\u0C27","\u0C17\u0C41\u0C30\u0C41","\u0C36\u0C41\u0C15\u0C4D\u0C30","\u0C36\u0C28\u0C3F"],
abbreviated:["\u0C06\u0C26\u0C3F","\u0C38\u0C4B\u0C2E","\u0C2E\u0C02\u0C17\u0C33","\u0C2C\u0C41\u0C27","\u0C17\u0C41\u0C30\u0C41","\u0C36\u0C41\u0C15\u0C4D\u0C30","\u0C36\u0C28\u0C3F"],
wide:[
"\u0C06\u0C26\u0C3F\u0C35\u0C3E\u0C30\u0C02",
"\u0C38\u0C4B\u0C2E\u0C35\u0C3E\u0C30\u0C02",
"\u0C2E\u0C02\u0C17\u0C33\u0C35\u0C3E\u0C30\u0C02",
"\u0C2C\u0C41\u0C27\u0C35\u0C3E\u0C30\u0C02",
"\u0C17\u0C41\u0C30\u0C41\u0C35\u0C3E\u0C30\u0C02",
"\u0C36\u0C41\u0C15\u0C4D\u0C30\u0C35\u0C3E\u0C30\u0C02",
"\u0C36\u0C28\u0C3F\u0C35\u0C3E\u0C30\u0C02"]

};
var dayPeriodValues75={
narrow:{
am:"\u0C2A\u0C42\u0C30\u0C4D\u0C35\u0C3E\u0C39\u0C4D\u0C28\u0C02",
pm:"\u0C05\u0C2A\u0C30\u0C3E\u0C39\u0C4D\u0C28\u0C02",
midnight:"\u0C05\u0C30\u0C4D\u0C27\u0C30\u0C3E\u0C24\u0C4D\u0C30\u0C3F",
noon:"\u0C2E\u0C3F\u0C1F\u0C4D\u0C1F\u0C2E\u0C27\u0C4D\u0C2F\u0C3E\u0C39\u0C4D\u0C28\u0C02",
morning:"\u0C09\u0C26\u0C2F\u0C02",
afternoon:"\u0C2E\u0C27\u0C4D\u0C2F\u0C3E\u0C39\u0C4D\u0C28\u0C02",
evening:"\u0C38\u0C3E\u0C2F\u0C02\u0C24\u0C4D\u0C30\u0C02",
night:"\u0C30\u0C3E\u0C24\u0C4D\u0C30\u0C3F"
},
abbreviated:{
am:"\u0C2A\u0C42\u0C30\u0C4D\u0C35\u0C3E\u0C39\u0C4D\u0C28\u0C02",
pm:"\u0C05\u0C2A\u0C30\u0C3E\u0C39\u0C4D\u0C28\u0C02",
midnight:"\u0C05\u0C30\u0C4D\u0C27\u0C30\u0C3E\u0C24\u0C4D\u0C30\u0C3F",
noon:"\u0C2E\u0C3F\u0C1F\u0C4D\u0C1F\u0C2E\u0C27\u0C4D\u0C2F\u0C3E\u0C39\u0C4D\u0C28\u0C02",
morning:"\u0C09\u0C26\u0C2F\u0C02",
afternoon:"\u0C2E\u0C27\u0C4D\u0C2F\u0C3E\u0C39\u0C4D\u0C28\u0C02",
evening:"\u0C38\u0C3E\u0C2F\u0C02\u0C24\u0C4D\u0C30\u0C02",
night:"\u0C30\u0C3E\u0C24\u0C4D\u0C30\u0C3F"
},
wide:{
am:"\u0C2A\u0C42\u0C30\u0C4D\u0C35\u0C3E\u0C39\u0C4D\u0C28\u0C02",
pm:"\u0C05\u0C2A\u0C30\u0C3E\u0C39\u0C4D\u0C28\u0C02",
midnight:"\u0C05\u0C30\u0C4D\u0C27\u0C30\u0C3E\u0C24\u0C4D\u0C30\u0C3F",
noon:"\u0C2E\u0C3F\u0C1F\u0C4D\u0C1F\u0C2E\u0C27\u0C4D\u0C2F\u0C3E\u0C39\u0C4D\u0C28\u0C02",
morning:"\u0C09\u0C26\u0C2F\u0C02",
afternoon:"\u0C2E\u0C27\u0C4D\u0C2F\u0C3E\u0C39\u0C4D\u0C28\u0C02",
evening:"\u0C38\u0C3E\u0C2F\u0C02\u0C24\u0C4D\u0C30\u0C02",
night:"\u0C30\u0C3E\u0C24\u0C4D\u0C30\u0C3F"
}
};
var formattingDayPeriodValues59={
narrow:{
am:"\u0C2A\u0C42\u0C30\u0C4D\u0C35\u0C3E\u0C39\u0C4D\u0C28\u0C02",
pm:"\u0C05\u0C2A\u0C30\u0C3E\u0C39\u0C4D\u0C28\u0C02",
midnight:"\u0C05\u0C30\u0C4D\u0C27\u0C30\u0C3E\u0C24\u0C4D\u0C30\u0C3F",
noon:"\u0C2E\u0C3F\u0C1F\u0C4D\u0C1F\u0C2E\u0C27\u0C4D\u0C2F\u0C3E\u0C39\u0C4D\u0C28\u0C02",
morning:"\u0C09\u0C26\u0C2F\u0C02",
afternoon:"\u0C2E\u0C27\u0C4D\u0C2F\u0C3E\u0C39\u0C4D\u0C28\u0C02",
evening:"\u0C38\u0C3E\u0C2F\u0C02\u0C24\u0C4D\u0C30\u0C02",
night:"\u0C30\u0C3E\u0C24\u0C4D\u0C30\u0C3F"
},
abbreviated:{
am:"\u0C2A\u0C42\u0C30\u0C4D\u0C35\u0C3E\u0C39\u0C4D\u0C28\u0C02",
pm:"\u0C05\u0C2A\u0C30\u0C3E\u0C39\u0C4D\u0C28\u0C02",
midnight:"\u0C05\u0C30\u0C4D\u0C27\u0C30\u0C3E\u0C24\u0C4D\u0C30\u0C3F",
noon:"\u0C2E\u0C3F\u0C1F\u0C4D\u0C1F\u0C2E\u0C27\u0C4D\u0C2F\u0C3E\u0C39\u0C4D\u0C28\u0C02",
morning:"\u0C09\u0C26\u0C2F\u0C02",
afternoon:"\u0C2E\u0C27\u0C4D\u0C2F\u0C3E\u0C39\u0C4D\u0C28\u0C02",
evening:"\u0C38\u0C3E\u0C2F\u0C02\u0C24\u0C4D\u0C30\u0C02",
night:"\u0C30\u0C3E\u0C24\u0C4D\u0C30\u0C3F"
},
wide:{
am:"\u0C2A\u0C42\u0C30\u0C4D\u0C35\u0C3E\u0C39\u0C4D\u0C28\u0C02",
pm:"\u0C05\u0C2A\u0C30\u0C3E\u0C39\u0C4D\u0C28\u0C02",
midnight:"\u0C05\u0C30\u0C4D\u0C27\u0C30\u0C3E\u0C24\u0C4D\u0C30\u0C3F",
noon:"\u0C2E\u0C3F\u0C1F\u0C4D\u0C1F\u0C2E\u0C27\u0C4D\u0C2F\u0C3E\u0C39\u0C4D\u0C28\u0C02",
morning:"\u0C09\u0C26\u0C2F\u0C02",
afternoon:"\u0C2E\u0C27\u0C4D\u0C2F\u0C3E\u0C39\u0C4D\u0C28\u0C02",
evening:"\u0C38\u0C3E\u0C2F\u0C02\u0C24\u0C4D\u0C30\u0C02",
night:"\u0C30\u0C3E\u0C24\u0C4D\u0C30\u0C3F"
}
};
var ordinalNumber75=function ordinalNumber75(dirtyNumber,_options){
var number=Number(dirtyNumber);
return number+"\u0C35";
};
var localize162={
ordinalNumber:ordinalNumber75,
era:buildLocalizeFn({
values:eraValues75,
defaultWidth:"wide"
}),
quarter:buildLocalizeFn({
values:quarterValues75,
defaultWidth:"wide",
argumentCallback:function argumentCallback(quarter){return quarter-1;}
}),
month:buildLocalizeFn({
values:monthValues75,
defaultWidth:"wide"
}),
day:buildLocalizeFn({
values:dayValues75,
defaultWidth:"wide"
}),
dayPeriod:buildLocalizeFn({
values:dayPeriodValues75,
defaultWidth:"wide",
formattingValues:formattingDayPeriodValues59,
defaultFormattingWidth:"wide"
})
};

// lib/locale/te/_lib/match.js
var matchOrdinalNumberPattern74=/^(\d+)(వ)?/i;
var parseOrdinalNumberPattern74=/\d+/i;
var matchEraPatterns74={
narrow:/^(క్రీ\.పూ\.|క్రీ\.శ\.)/i,
abbreviated:/^(క్రీ\.?\s?పూ\.?|ప్ర\.?\s?శ\.?\s?పూ\.?|క్రీ\.?\s?శ\.?|సా\.?\s?శ\.?)/i,
wide:/^(క్రీస్తు పూర్వం|ప్రస్తుత శకానికి పూర్వం|క్రీస్తు శకం|ప్రస్తుత శకం)/i
};
var parseEraPatterns74={
any:[/^(పూ|శ)/i,/^సా/i]
};
var matchQuarterPatterns74={
narrow:/^[1234]/i,
abbreviated:/^త్రై[1234]/i,
wide:/^[1234](వ)? త్రైమాసికం/i
};
var parseQuarterPatterns74={
any:[/1/i,/2/i,/3/i,/4/i]
};
var matchMonthPatterns74={
narrow:/^(జూ|జు|జ|ఫి|మా|ఏ|మే|ఆ|సె|అ|న|డి)/i,
abbreviated:/^(జన|ఫిబ్ర|మార్చి|ఏప్రి|మే|జూన్|జులై|ఆగ|సెప్|అక్టో|నవ|డిసె)/i,
wide:/^(జనవరి|ఫిబ్రవరి|మార్చి|ఏప్రిల్|మే|జూన్|జులై|ఆగస్టు|సెప్టెంబర్|అక్టోబర్|నవంబర్|డిసెంబర్)/i
};
var parseMonthPatterns74={
narrow:[
/^జ/i,
/^ఫి/i,
/^మా/i,
/^ఏ/i,
/^మే/i,
/^జూ/i,
/^జు/i,
/^ఆ/i,
/^సె/i,
/^అ/i,
/^న/i,
/^డి/i],

any:[
/^జన/i,
/^ఫి/i,
/^మా/i,
/^ఏ/i,
/^మే/i,
/^జూన్/i,
/^జులై/i,
/^ఆగ/i,
/^సె/i,
/^అ/i,
/^న/i,
/^డి/i]

};
var matchDayPatterns74={
narrow:/^(ఆ|సో|మ|బు|గు|శు|శ)/i,
short:/^(ఆది|సోమ|మం|బుధ|గురు|శుక్ర|శని)/i,
abbreviated:/^(ఆది|సోమ|మం|బుధ|గురు|శుక్ర|శని)/i,
wide:/^(ఆదివారం|సోమవారం|మంగళవారం|బుధవారం|గురువారం|శుక్రవారం|శనివారం)/i
};
var parseDayPatterns74={
narrow:[/^ఆ/i,/^సో/i,/^మ/i,/^బు/i,/^గు/i,/^శు/i,/^శ/i],
any:[/^ఆది/i,/^సోమ/i,/^మం/i,/^బుధ/i,/^గురు/i,/^శుక్ర/i,/^శని/i]
};
var matchDayPeriodPatterns74={
narrow:/^(పూర్వాహ్నం|అపరాహ్నం|అర్ధరాత్రి|మిట్టమధ్యాహ్నం|ఉదయం|మధ్యాహ్నం|సాయంత్రం|రాత్రి)/i,
any:/^(పూర్వాహ్నం|అపరాహ్నం|అర్ధరాత్రి|మిట్టమధ్యాహ్నం|ఉదయం|మధ్యాహ్నం|సాయంత్రం|రాత్రి)/i
};
var parseDayPeriodPatterns74={
any:{
am:/^పూర్వాహ్నం/i,
pm:/^అపరాహ్నం/i,
midnight:/^అర్ధ/i,
noon:/^మిట్ట/i,
morning:/ఉదయం/i,
afternoon:/మధ్యాహ్నం/i,
evening:/సాయంత్రం/i,
night:/రాత్రి/i
}
};
var match158={
ordinalNumber:buildMatchPatternFn({
matchPattern:matchOrdinalNumberPattern74,
parsePattern:parseOrdinalNumberPattern74,
valueCallback:function valueCallback(value){return parseInt(value,10);}
}),
era:buildMatchFn({
matchPatterns:matchEraPatterns74,
defaultMatchWidth:"wide",
parsePatterns:parseEraPatterns74,
defaultParseWidth:"any"
}),
quarter:buildMatchFn({
matchPatterns:matchQuarterPatterns74,
defaultMatchWidth:"wide",
parsePatterns:parseQuarterPatterns74,
defaultParseWidth:"any",
valueCallback:function valueCallback(index){return index+1;}
}),
month:buildMatchFn({
matchPatterns:matchMonthPatterns74,
defaultMatchWidth:"wide",
parsePatterns:parseMonthPatterns74,
defaultParseWidth:"any"
}),
day:buildMatchFn({
matchPatterns:matchDayPatterns74,
defaultMatchWidth:"wide",
parsePatterns:parseDayPatterns74,
defaultParseWidth:"any"
}),
dayPeriod:buildMatchFn({
matchPatterns:matchDayPeriodPatterns74,
defaultMatchWidth:"any",
parsePatterns:parseDayPeriodPatterns74,
defaultParseWidth:"any"
})
};

// lib/locale/te.js
var _te={
code:"te",
formatDistance:formatDistance159,
formatLong:formatLong167,
formatRelative:formatRelative159,
localize:localize162,
match:match158,
options:{
weekStartsOn:0,
firstWeekContainsDate:1
}
};
// lib/locale/th/_lib/formatDistance.js
var formatDistanceLocale75={
lessThanXSeconds:{
one:"\u0E19\u0E49\u0E2D\u0E22\u0E01\u0E27\u0E48\u0E32 1 \u0E27\u0E34\u0E19\u0E32\u0E17\u0E35",
other:"\u0E19\u0E49\u0E2D\u0E22\u0E01\u0E27\u0E48\u0E32 {{count}} \u0E27\u0E34\u0E19\u0E32\u0E17\u0E35"
},
xSeconds:{
one:"1 \u0E27\u0E34\u0E19\u0E32\u0E17\u0E35",
other:"{{count}} \u0E27\u0E34\u0E19\u0E32\u0E17\u0E35"
},
halfAMinute:"\u0E04\u0E23\u0E36\u0E48\u0E07\u0E19\u0E32\u0E17\u0E35",
lessThanXMinutes:{
one:"\u0E19\u0E49\u0E2D\u0E22\u0E01\u0E27\u0E48\u0E32 1 \u0E19\u0E32\u0E17\u0E35",
other:"\u0E19\u0E49\u0E2D\u0E22\u0E01\u0E27\u0E48\u0E32 {{count}} \u0E19\u0E32\u0E17\u0E35"
},
xMinutes:{
one:"1 \u0E19\u0E32\u0E17\u0E35",
other:"{{count}} \u0E19\u0E32\u0E17\u0E35"
},
aboutXHours:{
one:"\u0E1B\u0E23\u0E30\u0E21\u0E32\u0E13 1 \u0E0A\u0E31\u0E48\u0E27\u0E42\u0E21\u0E07",
other:"\u0E1B\u0E23\u0E30\u0E21\u0E32\u0E13 {{count}} \u0E0A\u0E31\u0E48\u0E27\u0E42\u0E21\u0E07"
},
xHours:{
one:"1 \u0E0A\u0E31\u0E48\u0E27\u0E42\u0E21\u0E07",
other:"{{count}} \u0E0A\u0E31\u0E48\u0E27\u0E42\u0E21\u0E07"
},
xDays:{
one:"1 \u0E27\u0E31\u0E19",
other:"{{count}} \u0E27\u0E31\u0E19"
},
aboutXWeeks:{
one:"\u0E1B\u0E23\u0E30\u0E21\u0E32\u0E13 1 \u0E2A\u0E31\u0E1B\u0E14\u0E32\u0E2B\u0E4C",
other:"\u0E1B\u0E23\u0E30\u0E21\u0E32\u0E13 {{count}} \u0E2A\u0E31\u0E1B\u0E14\u0E32\u0E2B\u0E4C"
},
xWeeks:{
one:"1 \u0E2A\u0E31\u0E1B\u0E14\u0E32\u0E2B\u0E4C",
other:"{{count}} \u0E2A\u0E31\u0E1B\u0E14\u0E32\u0E2B\u0E4C"
},
aboutXMonths:{
one:"\u0E1B\u0E23\u0E30\u0E21\u0E32\u0E13 1 \u0E40\u0E14\u0E37\u0E2D\u0E19",
other:"\u0E1B\u0E23\u0E30\u0E21\u0E32\u0E13 {{count}} \u0E40\u0E14\u0E37\u0E2D\u0E19"
},
xMonths:{
one:"1 \u0E40\u0E14\u0E37\u0E2D\u0E19",
other:"{{count}} \u0E40\u0E14\u0E37\u0E2D\u0E19"
},
aboutXYears:{
one:"\u0E1B\u0E23\u0E30\u0E21\u0E32\u0E13 1 \u0E1B\u0E35",
other:"\u0E1B\u0E23\u0E30\u0E21\u0E32\u0E13 {{count}} \u0E1B\u0E35"
},
xYears:{
one:"1 \u0E1B\u0E35",
other:"{{count}} \u0E1B\u0E35"
},
overXYears:{
one:"\u0E21\u0E32\u0E01\u0E01\u0E27\u0E48\u0E32 1 \u0E1B\u0E35",
other:"\u0E21\u0E32\u0E01\u0E01\u0E27\u0E48\u0E32 {{count}} \u0E1B\u0E35"
},
almostXYears:{
one:"\u0E40\u0E01\u0E37\u0E2D\u0E1A 1 \u0E1B\u0E35",
other:"\u0E40\u0E01\u0E37\u0E2D\u0E1A {{count}} \u0E1B\u0E35"
}
};
var formatDistance161=function formatDistance161(token,count,options){
var result;
var tokenValue=formatDistanceLocale75[token];
if(typeof tokenValue==="string"){
result=tokenValue;
}else if(count===1){
result=tokenValue.one;
}else{
result=tokenValue.other.replace("{{count}}",String(count));
}
if(options!==null&&options!==void 0&&options.addSuffix){
if(options.comparison&&options.comparison>0){
if(token==="halfAMinute"){
return"\u0E43\u0E19"+result;
}else{
return"\u0E43\u0E19 "+result;
}
}else{
return result+"\u0E17\u0E35\u0E48\u0E1C\u0E48\u0E32\u0E19\u0E21\u0E32";
}
}
return result;
};

// lib/locale/th/_lib/formatLong.js
var dateFormats84={
full:"\u0E27\u0E31\u0E19EEEE\u0E17\u0E35\u0E48 do MMMM y",
long:"do MMMM y",
medium:"d MMM y",
short:"dd/MM/yyyy"
};
var timeFormats84={
full:"H:mm:ss \u0E19. zzzz",
long:"H:mm:ss \u0E19. z",
medium:"H:mm:ss \u0E19.",
short:"H:mm \u0E19."
};
var dateTimeFormats84={
full:"{{date}} '\u0E40\u0E27\u0E25\u0E32' {{time}}",
long:"{{date}} '\u0E40\u0E27\u0E25\u0E32' {{time}}",
medium:"{{date}}, {{time}}",
short:"{{date}}, {{time}}"
};
var formatLong169={
date:buildFormatLongFn({
formats:dateFormats84,
defaultWidth:"full"
}),
time:buildFormatLongFn({
formats:timeFormats84,
defaultWidth:"medium"
}),
dateTime:buildFormatLongFn({
formats:dateTimeFormats84,
defaultWidth:"full"
})
};

// lib/locale/th/_lib/formatRelative.js
var formatRelativeLocale76={
lastWeek:"eeee'\u0E17\u0E35\u0E48\u0E41\u0E25\u0E49\u0E27\u0E40\u0E27\u0E25\u0E32' p",
yesterday:"'\u0E40\u0E21\u0E37\u0E48\u0E2D\u0E27\u0E32\u0E19\u0E19\u0E35\u0E49\u0E40\u0E27\u0E25\u0E32' p",
today:"'\u0E27\u0E31\u0E19\u0E19\u0E35\u0E49\u0E40\u0E27\u0E25\u0E32' p",
tomorrow:"'\u0E1E\u0E23\u0E38\u0E48\u0E07\u0E19\u0E35\u0E49\u0E40\u0E27\u0E25\u0E32' p",
nextWeek:"eeee '\u0E40\u0E27\u0E25\u0E32' p",
other:"P"
};
var formatRelative161=function formatRelative161(token,_date,_baseDate,_options){return formatRelativeLocale76[token];};

// lib/locale/th/_lib/localize.js
var eraValues76={
narrow:["B","\u0E04\u0E28"],
abbreviated:["BC","\u0E04.\u0E28."],
wide:["\u0E1B\u0E35\u0E01\u0E48\u0E2D\u0E19\u0E04\u0E23\u0E34\u0E2A\u0E15\u0E01\u0E32\u0E25","\u0E04\u0E23\u0E34\u0E2A\u0E15\u0E4C\u0E28\u0E31\u0E01\u0E23\u0E32\u0E0A"]
};
var quarterValues76={
narrow:["1","2","3","4"],
abbreviated:["Q1","Q2","Q3","Q4"],
wide:["\u0E44\u0E15\u0E23\u0E21\u0E32\u0E2A\u0E41\u0E23\u0E01","\u0E44\u0E15\u0E23\u0E21\u0E32\u0E2A\u0E17\u0E35\u0E48\u0E2A\u0E2D\u0E07","\u0E44\u0E15\u0E23\u0E21\u0E32\u0E2A\u0E17\u0E35\u0E48\u0E2A\u0E32\u0E21","\u0E44\u0E15\u0E23\u0E21\u0E32\u0E2A\u0E17\u0E35\u0E48\u0E2A\u0E35\u0E48"]
};
var dayValues76={
narrow:["\u0E2D\u0E32.","\u0E08.","\u0E2D.","\u0E1E.","\u0E1E\u0E24.","\u0E28.","\u0E2A."],
short:["\u0E2D\u0E32.","\u0E08.","\u0E2D.","\u0E1E.","\u0E1E\u0E24.","\u0E28.","\u0E2A."],
abbreviated:["\u0E2D\u0E32.","\u0E08.","\u0E2D.","\u0E1E.","\u0E1E\u0E24.","\u0E28.","\u0E2A."],
wide:["\u0E2D\u0E32\u0E17\u0E34\u0E15\u0E22\u0E4C","\u0E08\u0E31\u0E19\u0E17\u0E23\u0E4C","\u0E2D\u0E31\u0E07\u0E04\u0E32\u0E23","\u0E1E\u0E38\u0E18","\u0E1E\u0E24\u0E2B\u0E31\u0E2A\u0E1A\u0E14\u0E35","\u0E28\u0E38\u0E01\u0E23\u0E4C","\u0E40\u0E2A\u0E32\u0E23\u0E4C"]
};
var monthValues76={
narrow:[
"\u0E21.\u0E04.",
"\u0E01.\u0E1E.",
"\u0E21\u0E35.\u0E04.",
"\u0E40\u0E21.\u0E22.",
"\u0E1E.\u0E04.",
"\u0E21\u0E34.\u0E22.",
"\u0E01.\u0E04.",
"\u0E2A.\u0E04.",
"\u0E01.\u0E22.",
"\u0E15.\u0E04.",
"\u0E1E.\u0E22.",
"\u0E18.\u0E04."],

abbreviated:[
"\u0E21.\u0E04.",
"\u0E01.\u0E1E.",
"\u0E21\u0E35.\u0E04.",
"\u0E40\u0E21.\u0E22.",
"\u0E1E.\u0E04.",
"\u0E21\u0E34.\u0E22.",
"\u0E01.\u0E04.",
"\u0E2A.\u0E04.",
"\u0E01.\u0E22.",
"\u0E15.\u0E04.",
"\u0E1E.\u0E22.",
"\u0E18.\u0E04."],

wide:[
"\u0E21\u0E01\u0E23\u0E32\u0E04\u0E21",
"\u0E01\u0E38\u0E21\u0E20\u0E32\u0E1E\u0E31\u0E19\u0E18\u0E4C",
"\u0E21\u0E35\u0E19\u0E32\u0E04\u0E21",
"\u0E40\u0E21\u0E29\u0E32\u0E22\u0E19",
"\u0E1E\u0E24\u0E29\u0E20\u0E32\u0E04\u0E21",
"\u0E21\u0E34\u0E16\u0E38\u0E19\u0E32\u0E22\u0E19",
"\u0E01\u0E23\u0E01\u0E0E\u0E32\u0E04\u0E21",
"\u0E2A\u0E34\u0E07\u0E2B\u0E32\u0E04\u0E21",
"\u0E01\u0E31\u0E19\u0E22\u0E32\u0E22\u0E19",
"\u0E15\u0E38\u0E25\u0E32\u0E04\u0E21",
"\u0E1E\u0E24\u0E28\u0E08\u0E34\u0E01\u0E32\u0E22\u0E19",
"\u0E18\u0E31\u0E19\u0E27\u0E32\u0E04\u0E21"]

};
var dayPeriodValues76={
narrow:{
am:"\u0E01\u0E48\u0E2D\u0E19\u0E40\u0E17\u0E35\u0E48\u0E22\u0E07",
pm:"\u0E2B\u0E25\u0E31\u0E07\u0E40\u0E17\u0E35\u0E48\u0E22\u0E07",
midnight:"\u0E40\u0E17\u0E35\u0E48\u0E22\u0E07\u0E04\u0E37\u0E19",
noon:"\u0E40\u0E17\u0E35\u0E48\u0E22\u0E07",
morning:"\u0E40\u0E0A\u0E49\u0E32",
afternoon:"\u0E1A\u0E48\u0E32\u0E22",
evening:"\u0E40\u0E22\u0E47\u0E19",
night:"\u0E01\u0E25\u0E32\u0E07\u0E04\u0E37\u0E19"
},
abbreviated:{
am:"\u0E01\u0E48\u0E2D\u0E19\u0E40\u0E17\u0E35\u0E48\u0E22\u0E07",
pm:"\u0E2B\u0E25\u0E31\u0E07\u0E40\u0E17\u0E35\u0E48\u0E22\u0E07",
midnight:"\u0E40\u0E17\u0E35\u0E48\u0E22\u0E07\u0E04\u0E37\u0E19",
noon:"\u0E40\u0E17\u0E35\u0E48\u0E22\u0E07",
morning:"\u0E40\u0E0A\u0E49\u0E32",
afternoon:"\u0E1A\u0E48\u0E32\u0E22",
evening:"\u0E40\u0E22\u0E47\u0E19",
night:"\u0E01\u0E25\u0E32\u0E07\u0E04\u0E37\u0E19"
},
wide:{
am:"\u0E01\u0E48\u0E2D\u0E19\u0E40\u0E17\u0E35\u0E48\u0E22\u0E07",
pm:"\u0E2B\u0E25\u0E31\u0E07\u0E40\u0E17\u0E35\u0E48\u0E22\u0E07",
midnight:"\u0E40\u0E17\u0E35\u0E48\u0E22\u0E07\u0E04\u0E37\u0E19",
noon:"\u0E40\u0E17\u0E35\u0E48\u0E22\u0E07",
morning:"\u0E40\u0E0A\u0E49\u0E32",
afternoon:"\u0E1A\u0E48\u0E32\u0E22",
evening:"\u0E40\u0E22\u0E47\u0E19",
night:"\u0E01\u0E25\u0E32\u0E07\u0E04\u0E37\u0E19"
}
};
var formattingDayPeriodValues60={
narrow:{
am:"\u0E01\u0E48\u0E2D\u0E19\u0E40\u0E17\u0E35\u0E48\u0E22\u0E07",
pm:"\u0E2B\u0E25\u0E31\u0E07\u0E40\u0E17\u0E35\u0E48\u0E22\u0E07",
midnight:"\u0E40\u0E17\u0E35\u0E48\u0E22\u0E07\u0E04\u0E37\u0E19",
noon:"\u0E40\u0E17\u0E35\u0E48\u0E22\u0E07",
morning:"\u0E15\u0E2D\u0E19\u0E40\u0E0A\u0E49\u0E32",
afternoon:"\u0E15\u0E2D\u0E19\u0E01\u0E25\u0E32\u0E07\u0E27\u0E31\u0E19",
evening:"\u0E15\u0E2D\u0E19\u0E40\u0E22\u0E47\u0E19",
night:"\u0E15\u0E2D\u0E19\u0E01\u0E25\u0E32\u0E07\u0E04\u0E37\u0E19"
},
abbreviated:{
am:"\u0E01\u0E48\u0E2D\u0E19\u0E40\u0E17\u0E35\u0E48\u0E22\u0E07",
pm:"\u0E2B\u0E25\u0E31\u0E07\u0E40\u0E17\u0E35\u0E48\u0E22\u0E07",
midnight:"\u0E40\u0E17\u0E35\u0E48\u0E22\u0E07\u0E04\u0E37\u0E19",
noon:"\u0E40\u0E17\u0E35\u0E48\u0E22\u0E07",
morning:"\u0E15\u0E2D\u0E19\u0E40\u0E0A\u0E49\u0E32",
afternoon:"\u0E15\u0E2D\u0E19\u0E01\u0E25\u0E32\u0E07\u0E27\u0E31\u0E19",
evening:"\u0E15\u0E2D\u0E19\u0E40\u0E22\u0E47\u0E19",
night:"\u0E15\u0E2D\u0E19\u0E01\u0E25\u0E32\u0E07\u0E04\u0E37\u0E19"
},
wide:{
am:"\u0E01\u0E48\u0E2D\u0E19\u0E40\u0E17\u0E35\u0E48\u0E22\u0E07",
pm:"\u0E2B\u0E25\u0E31\u0E07\u0E40\u0E17\u0E35\u0E48\u0E22\u0E07",
midnight:"\u0E40\u0E17\u0E35\u0E48\u0E22\u0E07\u0E04\u0E37\u0E19",
noon:"\u0E40\u0E17\u0E35\u0E48\u0E22\u0E07",
morning:"\u0E15\u0E2D\u0E19\u0E40\u0E0A\u0E49\u0E32",
afternoon:"\u0E15\u0E2D\u0E19\u0E01\u0E25\u0E32\u0E07\u0E27\u0E31\u0E19",
evening:"\u0E15\u0E2D\u0E19\u0E40\u0E22\u0E47\u0E19",
night:"\u0E15\u0E2D\u0E19\u0E01\u0E25\u0E32\u0E07\u0E04\u0E37\u0E19"
}
};
var ordinalNumber76=function ordinalNumber76(dirtyNumber,_options){
return String(dirtyNumber);
};
var localize164={
ordinalNumber:ordinalNumber76,
era:buildLocalizeFn({
values:eraValues76,
defaultWidth:"wide"
}),
quarter:buildLocalizeFn({
values:quarterValues76,
defaultWidth:"wide",
argumentCallback:function argumentCallback(quarter){return quarter-1;}
}),
month:buildLocalizeFn({
values:monthValues76,
defaultWidth:"wide"
}),
day:buildLocalizeFn({
values:dayValues76,
defaultWidth:"wide"
}),
dayPeriod:buildLocalizeFn({
values:dayPeriodValues76,
defaultWidth:"wide",
formattingValues:formattingDayPeriodValues60,
defaultFormattingWidth:"wide"
})
};

// lib/locale/th/_lib/match.js
var matchOrdinalNumberPattern75=/^\d+/i;
var parseOrdinalNumberPattern75=/\d+/i;
var matchEraPatterns75={
narrow:/^([bB]|[aA]|คศ)/i,
abbreviated:/^([bB]\.?\s?[cC]\.?|b\.?\s?c\.?\s?e\.?|a\.?\s?d\.?|c\.?\s?e\.?|ค\.?ศ\.?)/i,
wide:/^(ก่อนคริสตกาล|คริสต์ศักราช|คริสตกาล)/i
};
var parseEraPatterns75={
any:[/^[bB]/i,/^(^[aA]|ค\.?ศ\.?|คริสตกาล|คริสต์ศักราช|)/i]
};
var matchQuarterPatterns75={
narrow:/^[1234]/i,
abbreviated:/^q[1234]/i,
wide:/^ไตรมาส(ที่)? ?[1234]/i
};
var parseQuarterPatterns75={
any:[/(1|แรก|หนึ่ง)/i,/(2|สอง)/i,/(3|สาม)/i,/(4|สี่)/i]
};
var matchMonthPatterns75={
narrow:/^(ม\.?ค\.?|ก\.?พ\.?|มี\.?ค\.?|เม\.?ย\.?|พ\.?ค\.?|มิ\.?ย\.?|ก\.?ค\.?|ส\.?ค\.?|ก\.?ย\.?|ต\.?ค\.?|พ\.?ย\.?|ธ\.?ค\.?)/i,
abbreviated:/^(ม\.?ค\.?|ก\.?พ\.?|มี\.?ค\.?|เม\.?ย\.?|พ\.?ค\.?|มิ\.?ย\.?|ก\.?ค\.?|ส\.?ค\.?|ก\.?ย\.?|ต\.?ค\.?|พ\.?ย\.?|ธ\.?ค\.?')/i,
wide:/^(มกราคม|กุมภาพันธ์|มีนาคม|เมษายน|พฤษภาคม|มิถุนายน|กรกฎาคม|สิงหาคม|กันยายน|ตุลาคม|พฤศจิกายน|ธันวาคม)/i
};
var parseMonthPatterns75={
wide:[
/^มก/i,
/^กุม/i,
/^มี/i,
/^เม/i,
/^พฤษ/i,
/^มิ/i,
/^กรก/i,
/^ส/i,
/^กัน/i,
/^ต/i,
/^พฤศ/i,
/^ธ/i],

any:[
/^ม\.?ค\.?/i,
/^ก\.?พ\.?/i,
/^มี\.?ค\.?/i,
/^เม\.?ย\.?/i,
/^พ\.?ค\.?/i,
/^มิ\.?ย\.?/i,
/^ก\.?ค\.?/i,
/^ส\.?ค\.?/i,
/^ก\.?ย\.?/i,
/^ต\.?ค\.?/i,
/^พ\.?ย\.?/i,
/^ธ\.?ค\.?/i]

};
var matchDayPatterns75={
narrow:/^(อา\.?|จ\.?|อ\.?|พฤ\.?|พ\.?|ศ\.?|ส\.?)/i,
short:/^(อา\.?|จ\.?|อ\.?|พฤ\.?|พ\.?|ศ\.?|ส\.?)/i,
abbreviated:/^(อา\.?|จ\.?|อ\.?|พฤ\.?|พ\.?|ศ\.?|ส\.?)/i,
wide:/^(อาทิตย์|จันทร์|อังคาร|พุธ|พฤหัสบดี|ศุกร์|เสาร์)/i
};
var parseDayPatterns75={
wide:[/^อา/i,/^จั/i,/^อั/i,/^พุธ/i,/^พฤ/i,/^ศ/i,/^เส/i],
any:[/^อา/i,/^จ/i,/^อ/i,/^พ(?!ฤ)/i,/^พฤ/i,/^ศ/i,/^ส/i]
};
var matchDayPeriodPatterns75={
any:/^(ก่อนเที่ยง|หลังเที่ยง|เที่ยงคืน|เที่ยง|(ตอน.*?)?.*(เที่ยง|เช้า|บ่าย|เย็น|กลางคืน))/i
};
var parseDayPeriodPatterns75={
any:{
am:/^ก่อนเที่ยง/i,
pm:/^หลังเที่ยง/i,
midnight:/^เที่ยงคืน/i,
noon:/^เที่ยง/i,
morning:/เช้า/i,
afternoon:/บ่าย/i,
evening:/เย็น/i,
night:/กลางคืน/i
}
};
var match160={
ordinalNumber:buildMatchPatternFn({
matchPattern:matchOrdinalNumberPattern75,
parsePattern:parseOrdinalNumberPattern75,
valueCallback:function valueCallback(value){return parseInt(value,10);}
}),
era:buildMatchFn({
matchPatterns:matchEraPatterns75,
defaultMatchWidth:"wide",
parsePatterns:parseEraPatterns75,
defaultParseWidth:"any"
}),
quarter:buildMatchFn({
matchPatterns:matchQuarterPatterns75,
defaultMatchWidth:"wide",
parsePatterns:parseQuarterPatterns75,
defaultParseWidth:"any",
valueCallback:function valueCallback(index){return index+1;}
}),
month:buildMatchFn({
matchPatterns:matchMonthPatterns75,
defaultMatchWidth:"wide",
parsePatterns:parseMonthPatterns75,
defaultParseWidth:"any"
}),
day:buildMatchFn({
matchPatterns:matchDayPatterns75,
defaultMatchWidth:"wide",
parsePatterns:parseDayPatterns75,
defaultParseWidth:"any"
}),
dayPeriod:buildMatchFn({
matchPatterns:matchDayPeriodPatterns75,
defaultMatchWidth:"any",
parsePatterns:parseDayPeriodPatterns75,
defaultParseWidth:"any"
})
};

// lib/locale/th.js
var _th={
code:"th",
formatDistance:formatDistance161,
formatLong:formatLong169,
formatRelative:formatRelative161,
localize:localize164,
match:match160,
options:{
weekStartsOn:0,
firstWeekContainsDate:1
}
};
// lib/locale/tr/_lib/formatDistance.js
var formatDistanceLocale76={
lessThanXSeconds:{
one:"bir saniyeden az",
other:"{{count}} saniyeden az"
},
xSeconds:{
one:"1 saniye",
other:"{{count}} saniye"
},
halfAMinute:"yar\u0131m dakika",
lessThanXMinutes:{
one:"bir dakikadan az",
other:"{{count}} dakikadan az"
},
xMinutes:{
one:"1 dakika",
other:"{{count}} dakika"
},
aboutXHours:{
one:"yakla\u015F\u0131k 1 saat",
other:"yakla\u015F\u0131k {{count}} saat"
},
xHours:{
one:"1 saat",
other:"{{count}} saat"
},
xDays:{
one:"1 g\xFCn",
other:"{{count}} g\xFCn"
},
aboutXWeeks:{
one:"yakla\u015F\u0131k 1 hafta",
other:"yakla\u015F\u0131k {{count}} hafta"
},
xWeeks:{
one:"1 hafta",
other:"{{count}} hafta"
},
aboutXMonths:{
one:"yakla\u015F\u0131k 1 ay",
other:"yakla\u015F\u0131k {{count}} ay"
},
xMonths:{
one:"1 ay",
other:"{{count}} ay"
},
aboutXYears:{
one:"yakla\u015F\u0131k 1 y\u0131l",
other:"yakla\u015F\u0131k {{count}} y\u0131l"
},
xYears:{
one:"1 y\u0131l",
other:"{{count}} y\u0131l"
},
overXYears:{
one:"1 y\u0131ldan fazla",
other:"{{count}} y\u0131ldan fazla"
},
almostXYears:{
one:"neredeyse 1 y\u0131l",
other:"neredeyse {{count}} y\u0131l"
}
};
var formatDistance163=function formatDistance163(token,count,options){
var result;
var tokenValue=formatDistanceLocale76[token];
if(typeof tokenValue==="string"){
result=tokenValue;
}else if(count===1){
result=tokenValue.one;
}else{
result=tokenValue.other.replace("{{count}}",count.toString());
}
if(options!==null&&options!==void 0&&options.addSuffix){
if(options.comparison&&options.comparison>0){
return result+" sonra";
}else{
return result+" \xF6nce";
}
}
return result;
};

// lib/locale/tr/_lib/formatLong.js
var dateFormats85={
full:"d MMMM y EEEE",
long:"d MMMM y",
medium:"d MMM y",
short:"dd.MM.yyyy"
};
var timeFormats85={
full:"HH:mm:ss zzzz",
long:"HH:mm:ss z",
medium:"HH:mm:ss",
short:"HH:mm"
};
var dateTimeFormats85={
full:"{{date}} 'saat' {{time}}",
long:"{{date}} 'saat' {{time}}",
medium:"{{date}}, {{time}}",
short:"{{date}}, {{time}}"
};
var formatLong171={
date:buildFormatLongFn({
formats:dateFormats85,
defaultWidth:"full"
}),
time:buildFormatLongFn({
formats:timeFormats85,
defaultWidth:"full"
}),
dateTime:buildFormatLongFn({
formats:dateTimeFormats85,
defaultWidth:"full"
})
};

// lib/locale/tr/_lib/formatRelative.js
var formatRelativeLocale77={
lastWeek:"'ge\xE7en hafta' eeee 'saat' p",
yesterday:"'d\xFCn saat' p",
today:"'bug\xFCn saat' p",
tomorrow:"'yar\u0131n saat' p",
nextWeek:"eeee 'saat' p",
other:"P"
};
var formatRelative163=function formatRelative163(token,_date,_baseDate,_options){return formatRelativeLocale77[token];};

// lib/locale/tr/_lib/localize.js
var eraValues77={
narrow:["M\xD6","MS"],
abbreviated:["M\xD6","MS"],
wide:["Milattan \xD6nce","Milattan Sonra"]
};
var quarterValues77={
narrow:["1","2","3","4"],
abbreviated:["1\xC7","2\xC7","3\xC7","4\xC7"],
wide:["\u0130lk \xE7eyrek","\u0130kinci \xC7eyrek","\xDC\xE7\xFCnc\xFC \xE7eyrek","Son \xE7eyrek"]
};
var monthValues77={
narrow:["O","\u015E","M","N","M","H","T","A","E","E","K","A"],
abbreviated:[
"Oca",
"\u015Eub",
"Mar",
"Nis",
"May",
"Haz",
"Tem",
"A\u011Fu",
"Eyl",
"Eki",
"Kas",
"Ara"],

wide:[
"Ocak",
"\u015Eubat",
"Mart",
"Nisan",
"May\u0131s",
"Haziran",
"Temmuz",
"A\u011Fustos",
"Eyl\xFCl",
"Ekim",
"Kas\u0131m",
"Aral\u0131k"]

};
var dayValues77={
narrow:["P","P","S","\xC7","P","C","C"],
short:["Pz","Pt","Sa","\xC7a","Pe","Cu","Ct"],
abbreviated:["Paz","Pzt","Sal","\xC7ar","Per","Cum","Cts"],
wide:[
"Pazar",
"Pazartesi",
"Sal\u0131",
"\xC7ar\u015Famba",
"Per\u015Fembe",
"Cuma",
"Cumartesi"]

};
var dayPeriodValues77={
narrow:{
am:"\xF6\xF6",
pm:"\xF6s",
midnight:"gy",
noon:"\xF6",
morning:"sa",
afternoon:"\xF6s",
evening:"ak",
night:"ge"
},
abbreviated:{
am:"\xD6\xD6",
pm:"\xD6S",
midnight:"gece yar\u0131s\u0131",
noon:"\xF6\u011Fle",
morning:"sabah",
afternoon:"\xF6\u011Fleden sonra",
evening:"ak\u015Fam",
night:"gece"
},
wide:{
am:"\xD6.\xD6.",
pm:"\xD6.S.",
midnight:"gece yar\u0131s\u0131",
noon:"\xF6\u011Fle",
morning:"sabah",
afternoon:"\xF6\u011Fleden sonra",
evening:"ak\u015Fam",
night:"gece"
}
};
var formattingDayPeriodValues61={
narrow:{
am:"\xF6\xF6",
pm:"\xF6s",
midnight:"gy",
noon:"\xF6",
morning:"sa",
afternoon:"\xF6s",
evening:"ak",
night:"ge"
},
abbreviated:{
am:"\xD6\xD6",
pm:"\xD6S",
midnight:"gece yar\u0131s\u0131",
noon:"\xF6\u011Flen",
morning:"sabahleyin",
afternoon:"\xF6\u011Fleden sonra",
evening:"ak\u015Famleyin",
night:"geceleyin"
},
wide:{
am:"\xF6.\xF6.",
pm:"\xF6.s.",
midnight:"gece yar\u0131s\u0131",
noon:"\xF6\u011Flen",
morning:"sabahleyin",
afternoon:"\xF6\u011Fleden sonra",
evening:"ak\u015Famleyin",
night:"geceleyin"
}
};
var ordinalNumber77=function ordinalNumber77(dirtyNumber,_options){
var number=Number(dirtyNumber);
return number+".";
};
var localize166={
ordinalNumber:ordinalNumber77,
era:buildLocalizeFn({
values:eraValues77,
defaultWidth:"wide"
}),
quarter:buildLocalizeFn({
values:quarterValues77,
defaultWidth:"wide",
argumentCallback:function argumentCallback(quarter){return Number(quarter)-1;}
}),
month:buildLocalizeFn({
values:monthValues77,
defaultWidth:"wide"
}),
day:buildLocalizeFn({
values:dayValues77,
defaultWidth:"wide"
}),
dayPeriod:buildLocalizeFn({
values:dayPeriodValues77,
defaultWidth:"wide",
formattingValues:formattingDayPeriodValues61,
defaultFormattingWidth:"wide"
})
};

// lib/locale/tr/_lib/match.js
var matchOrdinalNumberPattern76=/^(\d+)(\.)?/i;
var parseOrdinalNumberPattern76=/\d+/i;
var matchEraPatterns76={
narrow:/^(mö|ms)/i,
abbreviated:/^(mö|ms)/i,
wide:/^(milattan önce|milattan sonra)/i
};
var parseEraPatterns76={
any:[/(^mö|^milattan önce)/i,/(^ms|^milattan sonra)/i]
};
var matchQuarterPatterns76={
narrow:/^[1234]/i,
abbreviated:/^[1234]ç/i,
wide:/^((i|İ)lk|(i|İ)kinci|üçüncü|son) çeyrek/i
};
var parseQuarterPatterns76={
any:[/1/i,/2/i,/3/i,/4/i],
abbreviated:[/1ç/i,/2ç/i,/3ç/i,/4ç/i],
wide:[
/^(i|İ)lk çeyrek/i,
/(i|İ)kinci çeyrek/i,
/üçüncü çeyrek/i,
/son çeyrek/i]

};
var matchMonthPatterns76={
narrow:/^[oşmnhtaek]/i,
abbreviated:/^(oca|şub|mar|nis|may|haz|tem|ağu|eyl|eki|kas|ara)/i,
wide:/^(ocak|şubat|mart|nisan|mayıs|haziran|temmuz|ağustos|eylül|ekim|kasım|aralık)/i
};
var parseMonthPatterns76={
narrow:[
/^o/i,
/^ş/i,
/^m/i,
/^n/i,
/^m/i,
/^h/i,
/^t/i,
/^a/i,
/^e/i,
/^e/i,
/^k/i,
/^a/i],

any:[
/^o/i,
/^ş/i,
/^mar/i,
/^n/i,
/^may/i,
/^h/i,
/^t/i,
/^ağ/i,
/^ey/i,
/^ek/i,
/^k/i,
/^ar/i]

};
var matchDayPatterns76={
narrow:/^[psçc]/i,
short:/^(pz|pt|sa|ça|pe|cu|ct)/i,
abbreviated:/^(paz|pzt|sal|çar|per|cum|cts)/i,
wide:/^(pazar(?!tesi)|pazartesi|salı|çarşamba|perşembe|cuma(?!rtesi)|cumartesi)/i
};
var parseDayPatterns76={
narrow:[/^p/i,/^p/i,/^s/i,/^ç/i,/^p/i,/^c/i,/^c/i],
any:[/^pz/i,/^pt/i,/^sa/i,/^ça/i,/^pe/i,/^cu/i,/^ct/i],
wide:[
/^pazar(?!tesi)/i,
/^pazartesi/i,
/^salı/i,
/^çarşamba/i,
/^perşembe/i,
/^cuma(?!rtesi)/i,
/^cumartesi/i]

};
var matchDayPeriodPatterns76={
narrow:/^(öö|ös|gy|ö|sa|ös|ak|ge)/i,
any:/^(ö\.?\s?[ös]\.?|öğleden sonra|gece yarısı|öğle|(sabah|öğ|akşam|gece)(leyin))/i
};
var parseDayPeriodPatterns76={
any:{
am:/^ö\.?ö\.?/i,
pm:/^ö\.?s\.?/i,
midnight:/^(gy|gece yarısı)/i,
noon:/^öğ/i,
morning:/^sa/i,
afternoon:/^öğleden sonra/i,
evening:/^ak/i,
night:/^ge/i
}
};
var match162={
ordinalNumber:buildMatchPatternFn({
matchPattern:matchOrdinalNumberPattern76,
parsePattern:parseOrdinalNumberPattern76,
valueCallback:function valueCallback(value){
return parseInt(value,10);
}
}),
era:buildMatchFn({
matchPatterns:matchEraPatterns76,
defaultMatchWidth:"wide",
parsePatterns:parseEraPatterns76,
defaultParseWidth:"any"
}),
quarter:buildMatchFn({
matchPatterns:matchQuarterPatterns76,
defaultMatchWidth:"wide",
parsePatterns:parseQuarterPatterns76,
defaultParseWidth:"any",
valueCallback:function valueCallback(index){return index+1;}
}),
month:buildMatchFn({
matchPatterns:matchMonthPatterns76,
defaultMatchWidth:"wide",
parsePatterns:parseMonthPatterns76,
defaultParseWidth:"any"
}),
day:buildMatchFn({
matchPatterns:matchDayPatterns76,
defaultMatchWidth:"wide",
parsePatterns:parseDayPatterns76,
defaultParseWidth:"any"
}),
dayPeriod:buildMatchFn({
matchPatterns:matchDayPeriodPatterns76,
defaultMatchWidth:"any",
parsePatterns:parseDayPeriodPatterns76,
defaultParseWidth:"any"
})
};

// lib/locale/tr.js
var _tr={
code:"tr",
formatDistance:formatDistance163,
formatLong:formatLong171,
formatRelative:formatRelative163,
localize:localize166,
match:match162,
options:{
weekStartsOn:1,
firstWeekContainsDate:1
}
};
// lib/locale/ug/_lib/formatDistance.js
var formatDistanceLocale77={
lessThanXSeconds:{
one:"\u0628\u0649\u0631 \u0633\u0649\u0643\u06C7\u0646\u062A \u0626\u0649\u0686\u0649\u062F\u06D5",
other:"\u0633\u0649\u0643\u06C7\u0646\u062A \u0626\u0649\u0686\u0649\u062F\u06D5 {{count}}"
},
xSeconds:{
one:"\u0628\u0649\u0631 \u0633\u0649\u0643\u06C7\u0646\u062A",
other:"\u0633\u0649\u0643\u06C7\u0646\u062A {{count}}"
},
halfAMinute:"\u064A\u0649\u0631\u0649\u0645 \u0645\u0649\u0646\u06C7\u062A",
lessThanXMinutes:{
one:"\u0628\u0649\u0631 \u0645\u0649\u0646\u06C7\u062A \u0626\u0649\u0686\u0649\u062F\u06D5",
other:"\u0645\u0649\u0646\u06C7\u062A \u0626\u0649\u0686\u0649\u062F\u06D5 {{count}}"
},
xMinutes:{
one:"\u0628\u0649\u0631 \u0645\u0649\u0646\u06C7\u062A",
other:"\u0645\u0649\u0646\u06C7\u062A {{count}}"
},
aboutXHours:{
one:"\u062A\u06D5\u062E\u0645\u0649\u0646\u06D5\u0646 \u0628\u0649\u0631 \u0633\u0627\u0626\u06D5\u062A",
other:"\u0633\u0627\u0626\u06D5\u062A {{count}} \u062A\u06D5\u062E\u0645\u0649\u0646\u06D5\u0646"
},
xHours:{
one:"\u0628\u0649\u0631 \u0633\u0627\u0626\u06D5\u062A",
other:"\u0633\u0627\u0626\u06D5\u062A {{count}}"
},
xDays:{
one:"\u0628\u0649\u0631 \u0643\u06C8\u0646",
other:"\u0643\u06C8\u0646 {{count}}"
},
aboutXWeeks:{
one:"\u062A\u06D5\u062E\u0645\u0649\u0646\u06D5\u0646 \u0628\u0649\u0631\u06BE\u06D5\u067E\u062A\u06D5",
other:"\u06BE\u06D5\u067E\u062A\u06D5 {{count}} \u062A\u06D5\u062E\u0645\u0649\u0646\u06D5\u0646"
},
xWeeks:{
one:"\u0628\u0649\u0631\u06BE\u06D5\u067E\u062A\u06D5",
other:"\u06BE\u06D5\u067E\u062A\u06D5 {{count}}"
},
aboutXMonths:{
one:"\u062A\u06D5\u062E\u0645\u0649\u0646\u06D5\u0646 \u0628\u0649\u0631 \u0626\u0627\u064A",
other:"\u0626\u0627\u064A {{count}} \u062A\u06D5\u062E\u0645\u0649\u0646\u06D5\u0646"
},
xMonths:{
one:"\u0628\u0649\u0631 \u0626\u0627\u064A",
other:"\u0626\u0627\u064A {{count}}"
},
aboutXYears:{
one:"\u062A\u06D5\u062E\u0645\u0649\u0646\u06D5\u0646 \u0628\u0649\u0631 \u064A\u0649\u0644",
other:"\u064A\u0649\u0644 {{count}} \u062A\u06D5\u062E\u0645\u0649\u0646\u06D5\u0646"
},
xYears:{
one:"\u0628\u0649\u0631 \u064A\u0649\u0644",
other:"\u064A\u0649\u0644 {{count}}"
},
overXYears:{
one:"\u0628\u0649\u0631 \u064A\u0649\u0644\u062F\u0649\u0646 \u0626\u0627\u0631\u062A\u06C7\u0642",
other:"\u064A\u0649\u0644\u062F\u0649\u0646 \u0626\u0627\u0631\u062A\u06C7\u0642 {{count}}"
},
almostXYears:{
one:"\u0626\u0627\u0633\u0627\u0633\u06D5\u0646 \u0628\u0649\u0631 \u064A\u0649\u0644",
other:"\u064A\u0649\u0644 {{count}} \u0626\u0627\u0633\u0627\u0633\u06D5\u0646"
}
};
var formatDistance165=function formatDistance165(token,count,options){
var result;
var tokenValue=formatDistanceLocale77[token];
if(typeof tokenValue==="string"){
result=tokenValue;
}else if(count===1){
result=tokenValue.one;
}else{
result=tokenValue.other.replace("{{count}}",String(count));
}
if(options!==null&&options!==void 0&&options.addSuffix){
if(options.comparison&&options.comparison>0){
return result;
}else{
return result+" \u0628\u0648\u0644\u062F\u0649";
}
}
return result;
};

// lib/locale/ug/_lib/formatLong.js
var dateFormats86={
full:"EEEE, MMMM do, y",
long:"MMMM do, y",
medium:"MMM d, y",
short:"MM/dd/yyyy"
};
var timeFormats86={
full:"h:mm:ss a zzzz",
long:"h:mm:ss a z",
medium:"h:mm:ss a",
short:"h:mm a"
};
var dateTimeFormats86={
full:"{{date}} '\u062F\u06D5' {{time}}",
long:"{{date}} '\u062F\u06D5' {{time}}",
medium:"{{date}}, {{time}}",
short:"{{date}}, {{time}}"
};
var formatLong173={
date:buildFormatLongFn({
formats:dateFormats86,
defaultWidth:"full"
}),
time:buildFormatLongFn({
formats:timeFormats86,
defaultWidth:"full"
}),
dateTime:buildFormatLongFn({
formats:dateTimeFormats86,
defaultWidth:"full"
})
};

// lib/locale/ug/_lib/formatRelative.js
var formatRelativeLocale78={
lastWeek:"'\u0626\u200D\u06C6\u062A\u0643\u06D5\u0646' eeee '\u062F\u06D5' p",
yesterday:"'\u062A\u06C8\u0646\u06C8\u06AF\u06C8\u0646 \u062F\u06D5' p",
today:"'\u0628\u06C8\u06AF\u06C8\u0646 \u062F\u06D5' p",
tomorrow:"'\u0626\u06D5\u062A\u06D5 \u062F\u06D5' p",
nextWeek:"eeee '\u062F\u06D5' p",
other:"P"
};
var formatRelative165=function formatRelative165(token,_date,_baseDate,_options){return formatRelativeLocale78[token];};

// lib/locale/ug/_lib/localize.js
var eraValues78={
narrow:["\u0628","\u0643"],
abbreviated:["\u0628","\u0643"],
wide:["\u0645\u0649\u064A\u0644\u0627\u062F\u0649\u062F\u0649\u0646 \u0628\u06C7\u0631\u06C7\u0646","\u0645\u0649\u064A\u0644\u0627\u062F\u0649\u062F\u0649\u0646 \u0643\u0649\u064A\u0649\u0646"]
};
var quarterValues78={
narrow:["1","2","3","4"],
abbreviated:["1","2","3","4"],
wide:["\u0628\u0649\u0631\u0649\u0646\u062C\u0649 \u0686\u0627\u0631\u06D5\u0643","\u0626\u0649\u0643\u0643\u0649\u0646\u062C\u0649 \u0686\u0627\u0631\u06D5\u0643","\u0626\u06C8\u0686\u0649\u0646\u062C\u0649 \u0686\u0627\u0631\u06D5\u0643","\u062A\u06C6\u062A\u0649\u0646\u062C\u0649 \u0686\u0627\u0631\u06D5\u0643"]
};
var monthValues78={
narrow:["\u064A","\u0641","\u0645","\u0627","\u0645","\u0649","\u0649","\u0627","\u0633","\u06C6","\u0646","\u062F"],
abbreviated:[
"\u064A\u0627\u0646\u06CB\u0627\u0631",
"\u0641\u06D0\u06CB\u0649\u0631\u0627\u0644",
"\u0645\u0627\u0631\u062A",
"\u0626\u0627\u067E\u0631\u0649\u0644",
"\u0645\u0627\u064A",
"\u0626\u0649\u064A\u06C7\u0646",
"\u0626\u0649\u064A\u0648\u0644",
"\u0626\u0627\u06CB\u063A\u06C7\u0633\u062A",
"\u0633\u0649\u0646\u062A\u06D5\u0628\u0649\u0631",
"\u0626\u06C6\u0643\u062A\u06D5\u0628\u0649\u0631",
"\u0646\u0648\u064A\u0627\u0628\u0649\u0631",
"\u062F\u0649\u0643\u0627\u0628\u0649\u0631"],

wide:[
"\u064A\u0627\u0646\u06CB\u0627\u0631",
"\u0641\u06D0\u06CB\u0649\u0631\u0627\u0644",
"\u0645\u0627\u0631\u062A",
"\u0626\u0627\u067E\u0631\u0649\u0644",
"\u0645\u0627\u064A",
"\u0626\u0649\u064A\u06C7\u0646",
"\u0626\u0649\u064A\u0648\u0644",
"\u0626\u0627\u06CB\u063A\u06C7\u0633\u062A",
"\u0633\u0649\u0646\u062A\u06D5\u0628\u0649\u0631",
"\u0626\u06C6\u0643\u062A\u06D5\u0628\u0649\u0631",
"\u0646\u0648\u064A\u0627\u0628\u0649\u0631",
"\u062F\u0649\u0643\u0627\u0628\u0649\u0631"]

};
var dayValues78={
narrow:["\u064A","\u062F","\u0633","\u0686","\u067E","\u062C","\u0634"],
short:["\u064A","\u062F","\u0633","\u0686","\u067E","\u062C","\u0634"],
abbreviated:[
"\u064A\u06D5\u0643\u0634\u06D5\u0646\u0628\u06D5",
"\u062F\u06C8\u0634\u06D5\u0646\u0628\u06D5",
"\u0633\u06D5\u064A\u0634\u06D5\u0646\u0628\u06D5",
"\u0686\u0627\u0631\u0634\u06D5\u0646\u0628\u06D5",
"\u067E\u06D5\u064A\u0634\u06D5\u0646\u0628\u06D5",
"\u062C\u06C8\u0645\u06D5",
"\u0634\u06D5\u0646\u0628\u06D5"],

wide:[
"\u064A\u06D5\u0643\u0634\u06D5\u0646\u0628\u06D5",
"\u062F\u06C8\u0634\u06D5\u0646\u0628\u06D5",
"\u0633\u06D5\u064A\u0634\u06D5\u0646\u0628\u06D5",
"\u0686\u0627\u0631\u0634\u06D5\u0646\u0628\u06D5",
"\u067E\u06D5\u064A\u0634\u06D5\u0646\u0628\u06D5",
"\u062C\u06C8\u0645\u06D5",
"\u0634\u06D5\u0646\u0628\u06D5"]

};
var dayPeriodValues78={
narrow:{
am:"\u0626\u06D5",
pm:"\u0686",
midnight:"\u0643",
noon:"\u0686",
morning:"\u0626\u06D5\u062A\u0649\u06AF\u06D5\u0646",
afternoon:"\u0686\u06C8\u0634\u062A\u0649\u0646 \u0643\u0649\u064A\u0649\u0646",
evening:"\u0626\u0627\u062E\u0634\u0649\u0645",
night:"\u0643\u0649\u0686\u06D5"
},
abbreviated:{
am:"\u0626\u06D5",
pm:"\u0686",
midnight:"\u0643",
noon:"\u0686",
morning:"\u0626\u06D5\u062A\u0649\u06AF\u06D5\u0646",
afternoon:"\u0686\u06C8\u0634\u062A\u0649\u0646 \u0643\u0649\u064A\u0649\u0646",
evening:"\u0626\u0627\u062E\u0634\u0649\u0645",
night:"\u0643\u0649\u0686\u06D5"
},
wide:{
am:"\u0626\u06D5",
pm:"\u0686",
midnight:"\u0643",
noon:"\u0686",
morning:"\u0626\u06D5\u062A\u0649\u06AF\u06D5\u0646",
afternoon:"\u0686\u06C8\u0634\u062A\u0649\u0646 \u0643\u0649\u064A\u0649\u0646",
evening:"\u0626\u0627\u062E\u0634\u0649\u0645",
night:"\u0643\u0649\u0686\u06D5"
}
};
var formattingDayPeriodValues62={
narrow:{
am:"\u0626\u06D5",
pm:"\u0686",
midnight:"\u0643",
noon:"\u0686",
morning:"\u0626\u06D5\u062A\u0649\u06AF\u06D5\u0646\u062F\u06D5",
afternoon:"\u0686\u06C8\u0634\u062A\u0649\u0646 \u0643\u0649\u064A\u0649\u0646",
evening:"\u0626\u0627\u062E\u0634\u0627\u0645\u062F\u0627",
night:"\u0643\u0649\u0686\u0649\u062F\u06D5"
},
abbreviated:{
am:"\u0626\u06D5",
pm:"\u0686",
midnight:"\u0643",
noon:"\u0686",
morning:"\u0626\u06D5\u062A\u0649\u06AF\u06D5\u0646\u062F\u06D5",
afternoon:"\u0686\u06C8\u0634\u062A\u0649\u0646 \u0643\u0649\u064A\u0649\u0646",
evening:"\u0626\u0627\u062E\u0634\u0627\u0645\u062F\u0627",
night:"\u0643\u0649\u0686\u0649\u062F\u06D5"
},
wide:{
am:"\u0626\u06D5",
pm:"\u0686",
midnight:"\u0643",
noon:"\u0686",
morning:"\u0626\u06D5\u062A\u0649\u06AF\u06D5\u0646\u062F\u06D5",
afternoon:"\u0686\u06C8\u0634\u062A\u0649\u0646 \u0643\u0649\u064A\u0649\u0646",
evening:"\u0626\u0627\u062E\u0634\u0627\u0645\u062F\u0627",
night:"\u0643\u0649\u0686\u0649\u062F\u06D5"
}
};
var ordinalNumber78=function ordinalNumber78(dirtyNumber,_options){
return String(dirtyNumber);
};
var localize168={
ordinalNumber:ordinalNumber78,
era:buildLocalizeFn({
values:eraValues78,
defaultWidth:"wide"
}),
quarter:buildLocalizeFn({
values:quarterValues78,
defaultWidth:"wide",
argumentCallback:function argumentCallback(quarter){return quarter-1;}
}),
month:buildLocalizeFn({
values:monthValues78,
defaultWidth:"wide"
}),
day:buildLocalizeFn({
values:dayValues78,
defaultWidth:"wide"
}),
dayPeriod:buildLocalizeFn({
values:dayPeriodValues78,
defaultWidth:"wide",
formattingValues:formattingDayPeriodValues62,
defaultFormattingWidth:"wide"
})
};

// lib/locale/ug/_lib/match.js
var matchOrdinalNumberPattern77=/^(\d+)(th|st|nd|rd)?/i;
var parseOrdinalNumberPattern77=/\d+/i;
var matchEraPatterns77={
narrow:/^(ب|ك)/i,
wide:/^(مىيلادىدىن بۇرۇن|مىيلادىدىن كىيىن)/i
};
var parseEraPatterns77={
any:[/^بۇرۇن/i,/^كىيىن/i]
};
var matchQuarterPatterns77={
narrow:/^[1234]/i,
abbreviated:/^چ[1234]/i,
wide:/^چارەك [1234]/i
};
var parseQuarterPatterns77={
any:[/1/i,/2/i,/3/i,/4/i]
};
var matchMonthPatterns77={
narrow:/^[يفمئامئ‍ئاسۆند]/i,
abbreviated:/^(يانۋار|فېۋىرال|مارت|ئاپرىل|ماي|ئىيۇن|ئىيول|ئاۋغۇست|سىنتەبىر|ئۆكتەبىر|نويابىر|دىكابىر)/i,
wide:/^(يانۋار|فېۋىرال|مارت|ئاپرىل|ماي|ئىيۇن|ئىيول|ئاۋغۇست|سىنتەبىر|ئۆكتەبىر|نويابىر|دىكابىر)/i
};
var parseMonthPatterns77={
narrow:[
/^ي/i,
/^ف/i,
/^م/i,
/^ا/i,
/^م/i,
/^ى‍/i,
/^ى‍/i,
/^ا‍/i,
/^س/i,
/^ۆ/i,
/^ن/i,
/^د/i],

any:[
/^يان/i,
/^فېۋ/i,
/^مار/i,
/^ئاپ/i,
/^ماي/i,
/^ئىيۇن/i,
/^ئىيول/i,
/^ئاۋ/i,
/^سىن/i,
/^ئۆك/i,
/^نوي/i,
/^دىك/i]

};
var matchDayPatterns77={
narrow:/^[دسچپجشي]/i,
short:/^(يە|دۈ|سە|چا|پە|جۈ|شە)/i,
abbreviated:/^(يە|دۈ|سە|چا|پە|جۈ|شە)/i,
wide:/^(يەكشەنبە|دۈشەنبە|سەيشەنبە|چارشەنبە|پەيشەنبە|جۈمە|شەنبە)/i
};
var parseDayPatterns77={
narrow:[/^ي/i,/^د/i,/^س/i,/^چ/i,/^پ/i,/^ج/i,/^ش/i],
any:[/^ي/i,/^د/i,/^س/i,/^چ/i,/^پ/i,/^ج/i,/^ش/i]
};
var matchDayPeriodPatterns77={
narrow:/^(ئە|چ|ك|چ|(دە|ئەتىگەن) ( ئە‍|چۈشتىن كىيىن|ئاخشىم|كىچە))/i,
any:/^(ئە|چ|ك|چ|(دە|ئەتىگەن) ( ئە‍|چۈشتىن كىيىن|ئاخشىم|كىچە))/i
};
var parseDayPeriodPatterns77={
any:{
am:/^ئە/i,
pm:/^چ/i,
midnight:/^ك/i,
noon:/^چ/i,
morning:/ئەتىگەن/i,
afternoon:/چۈشتىن كىيىن/i,
evening:/ئاخشىم/i,
night:/كىچە/i
}
};
var match164={
ordinalNumber:buildMatchPatternFn({
matchPattern:matchOrdinalNumberPattern77,
parsePattern:parseOrdinalNumberPattern77,
valueCallback:function valueCallback(value){return parseInt(value,10);}
}),
era:buildMatchFn({
matchPatterns:matchEraPatterns77,
defaultMatchWidth:"wide",
parsePatterns:parseEraPatterns77,
defaultParseWidth:"any"
}),
quarter:buildMatchFn({
matchPatterns:matchQuarterPatterns77,
defaultMatchWidth:"wide",
parsePatterns:parseQuarterPatterns77,
defaultParseWidth:"any",
valueCallback:function valueCallback(index){return index+1;}
}),
month:buildMatchFn({
matchPatterns:matchMonthPatterns77,
defaultMatchWidth:"wide",
parsePatterns:parseMonthPatterns77,
defaultParseWidth:"any"
}),
day:buildMatchFn({
matchPatterns:matchDayPatterns77,
defaultMatchWidth:"wide",
parsePatterns:parseDayPatterns77,
defaultParseWidth:"any"
}),
dayPeriod:buildMatchFn({
matchPatterns:matchDayPeriodPatterns77,
defaultMatchWidth:"any",
parsePatterns:parseDayPeriodPatterns77,
defaultParseWidth:"any"
})
};

// lib/locale/ug.js
var _ug={
code:"ug",
formatDistance:formatDistance165,
formatLong:formatLong173,
formatRelative:formatRelative165,
localize:localize168,
match:match164,
options:{
weekStartsOn:0,
firstWeekContainsDate:1
}
};
// lib/locale/uk/_lib/formatDistance.js
function declension7(scheme,count){
if(scheme.one!==undefined&&count===1){
return scheme.one;
}
var rem10=count%10;
var rem100=count%100;
if(rem10===1&&rem100!==11){
return scheme.singularNominative.replace("{{count}}",String(count));
}else if(rem10>=2&&rem10<=4&&(rem100<10||rem100>20)){
return scheme.singularGenitive.replace("{{count}}",String(count));
}else{
return scheme.pluralGenitive.replace("{{count}}",String(count));
}
}
function buildLocalizeTokenFn5(scheme){
return function(count,options){
if(options&&options.addSuffix){
if(options.comparison&&options.comparison>0){
if(scheme.future){
return declension7(scheme.future,count);
}else{
return"\u0437\u0430 "+declension7(scheme.regular,count);
}
}else{
if(scheme.past){
return declension7(scheme.past,count);
}else{
return declension7(scheme.regular,count)+" \u0442\u043E\u043C\u0443";
}
}
}else{
return declension7(scheme.regular,count);
}
};
}
var halfAtMinute=function halfAtMinute(_,options){
if(options&&options.addSuffix){
if(options.comparison&&options.comparison>0){
return"\u0437\u0430 \u043F\u0456\u0432\u0445\u0432\u0438\u043B\u0438\u043D\u0438";
}else{
return"\u043F\u0456\u0432\u0445\u0432\u0438\u043B\u0438\u043D\u0438 \u0442\u043E\u043C\u0443";
}
}
return"\u043F\u0456\u0432\u0445\u0432\u0438\u043B\u0438\u043D\u0438";
};
var formatDistanceLocale78={
lessThanXSeconds:buildLocalizeTokenFn5({
regular:{
one:"\u043C\u0435\u043D\u0448\u0435 \u0441\u0435\u043A\u0443\u043D\u0434\u0438",
singularNominative:"\u043C\u0435\u043D\u0448\u0435 {{count}} \u0441\u0435\u043A\u0443\u043D\u0434\u0438",
singularGenitive:"\u043C\u0435\u043D\u0448\u0435 {{count}} \u0441\u0435\u043A\u0443\u043D\u0434",
pluralGenitive:"\u043C\u0435\u043D\u0448\u0435 {{count}} \u0441\u0435\u043A\u0443\u043D\u0434"
},
future:{
one:"\u043C\u0435\u043D\u0448\u0435, \u043D\u0456\u0436 \u0437\u0430 \u0441\u0435\u043A\u0443\u043D\u0434\u0443",
singularNominative:"\u043C\u0435\u043D\u0448\u0435, \u043D\u0456\u0436 \u0437\u0430 {{count}} \u0441\u0435\u043A\u0443\u043D\u0434\u0443",
singularGenitive:"\u043C\u0435\u043D\u0448\u0435, \u043D\u0456\u0436 \u0437\u0430 {{count}} \u0441\u0435\u043A\u0443\u043D\u0434\u0438",
pluralGenitive:"\u043C\u0435\u043D\u0448\u0435, \u043D\u0456\u0436 \u0437\u0430 {{count}} \u0441\u0435\u043A\u0443\u043D\u0434"
}
}),
xSeconds:buildLocalizeTokenFn5({
regular:{
singularNominative:"{{count}} \u0441\u0435\u043A\u0443\u043D\u0434\u0430",
singularGenitive:"{{count}} \u0441\u0435\u043A\u0443\u043D\u0434\u0438",
pluralGenitive:"{{count}} \u0441\u0435\u043A\u0443\u043D\u0434"
},
past:{
singularNominative:"{{count}} \u0441\u0435\u043A\u0443\u043D\u0434\u0443 \u0442\u043E\u043C\u0443",
singularGenitive:"{{count}} \u0441\u0435\u043A\u0443\u043D\u0434\u0438 \u0442\u043E\u043C\u0443",
pluralGenitive:"{{count}} \u0441\u0435\u043A\u0443\u043D\u0434 \u0442\u043E\u043C\u0443"
},
future:{
singularNominative:"\u0437\u0430 {{count}} \u0441\u0435\u043A\u0443\u043D\u0434\u0443",
singularGenitive:"\u0437\u0430 {{count}} \u0441\u0435\u043A\u0443\u043D\u0434\u0438",
pluralGenitive:"\u0437\u0430 {{count}} \u0441\u0435\u043A\u0443\u043D\u0434"
}
}),
halfAMinute:halfAtMinute,
lessThanXMinutes:buildLocalizeTokenFn5({
regular:{
one:"\u043C\u0435\u043D\u0448\u0435 \u0445\u0432\u0438\u043B\u0438\u043D\u0438",
singularNominative:"\u043C\u0435\u043D\u0448\u0435 {{count}} \u0445\u0432\u0438\u043B\u0438\u043D\u0438",
singularGenitive:"\u043C\u0435\u043D\u0448\u0435 {{count}} \u0445\u0432\u0438\u043B\u0438\u043D",
pluralGenitive:"\u043C\u0435\u043D\u0448\u0435 {{count}} \u0445\u0432\u0438\u043B\u0438\u043D"
},
future:{
one:"\u043C\u0435\u043D\u0448\u0435, \u043D\u0456\u0436 \u0437\u0430 \u0445\u0432\u0438\u043B\u0438\u043D\u0443",
singularNominative:"\u043C\u0435\u043D\u0448\u0435, \u043D\u0456\u0436 \u0437\u0430 {{count}} \u0445\u0432\u0438\u043B\u0438\u043D\u0443",
singularGenitive:"\u043C\u0435\u043D\u0448\u0435, \u043D\u0456\u0436 \u0437\u0430 {{count}} \u0445\u0432\u0438\u043B\u0438\u043D\u0438",
pluralGenitive:"\u043C\u0435\u043D\u0448\u0435, \u043D\u0456\u0436 \u0437\u0430 {{count}} \u0445\u0432\u0438\u043B\u0438\u043D"
}
}),
xMinutes:buildLocalizeTokenFn5({
regular:{
singularNominative:"{{count}} \u0445\u0432\u0438\u043B\u0438\u043D\u0430",
singularGenitive:"{{count}} \u0445\u0432\u0438\u043B\u0438\u043D\u0438",
pluralGenitive:"{{count}} \u0445\u0432\u0438\u043B\u0438\u043D"
},
past:{
singularNominative:"{{count}} \u0445\u0432\u0438\u043B\u0438\u043D\u0443 \u0442\u043E\u043C\u0443",
singularGenitive:"{{count}} \u0445\u0432\u0438\u043B\u0438\u043D\u0438 \u0442\u043E\u043C\u0443",
pluralGenitive:"{{count}} \u0445\u0432\u0438\u043B\u0438\u043D \u0442\u043E\u043C\u0443"
},
future:{
singularNominative:"\u0437\u0430 {{count}} \u0445\u0432\u0438\u043B\u0438\u043D\u0443",
singularGenitive:"\u0437\u0430 {{count}} \u0445\u0432\u0438\u043B\u0438\u043D\u0438",
pluralGenitive:"\u0437\u0430 {{count}} \u0445\u0432\u0438\u043B\u0438\u043D"
}
}),
aboutXHours:buildLocalizeTokenFn5({
regular:{
singularNominative:"\u0431\u043B\u0438\u0437\u044C\u043A\u043E {{count}} \u0433\u043E\u0434\u0438\u043D\u0438",
singularGenitive:"\u0431\u043B\u0438\u0437\u044C\u043A\u043E {{count}} \u0433\u043E\u0434\u0438\u043D",
pluralGenitive:"\u0431\u043B\u0438\u0437\u044C\u043A\u043E {{count}} \u0433\u043E\u0434\u0438\u043D"
},
future:{
singularNominative:"\u043F\u0440\u0438\u0431\u043B\u0438\u0437\u043D\u043E \u0437\u0430 {{count}} \u0433\u043E\u0434\u0438\u043D\u0443",
singularGenitive:"\u043F\u0440\u0438\u0431\u043B\u0438\u0437\u043D\u043E \u0437\u0430 {{count}} \u0433\u043E\u0434\u0438\u043D\u0438",
pluralGenitive:"\u043F\u0440\u0438\u0431\u043B\u0438\u0437\u043D\u043E \u0437\u0430 {{count}} \u0433\u043E\u0434\u0438\u043D"
}
}),
xHours:buildLocalizeTokenFn5({
regular:{
singularNominative:"{{count}} \u0433\u043E\u0434\u0438\u043D\u0443",
singularGenitive:"{{count}} \u0433\u043E\u0434\u0438\u043D\u0438",
pluralGenitive:"{{count}} \u0433\u043E\u0434\u0438\u043D"
}
}),
xDays:buildLocalizeTokenFn5({
regular:{
singularNominative:"{{count}} \u0434\u0435\u043D\u044C",
singularGenitive:"{{count}} \u0434\u043Di",
pluralGenitive:"{{count}} \u0434\u043D\u0456\u0432"
}
}),
aboutXWeeks:buildLocalizeTokenFn5({
regular:{
singularNominative:"\u0431\u043B\u0438\u0437\u044C\u043A\u043E {{count}} \u0442\u0438\u0436\u043D\u044F",
singularGenitive:"\u0431\u043B\u0438\u0437\u044C\u043A\u043E {{count}} \u0442\u0438\u0436\u043D\u0456\u0432",
pluralGenitive:"\u0431\u043B\u0438\u0437\u044C\u043A\u043E {{count}} \u0442\u0438\u0436\u043D\u0456\u0432"
},
future:{
singularNominative:"\u043F\u0440\u0438\u0431\u043B\u0438\u0437\u043D\u043E \u0437\u0430 {{count}} \u0442\u0438\u0436\u0434\u0435\u043D\u044C",
singularGenitive:"\u043F\u0440\u0438\u0431\u043B\u0438\u0437\u043D\u043E \u0437\u0430 {{count}} \u0442\u0438\u0436\u043D\u0456",
pluralGenitive:"\u043F\u0440\u0438\u0431\u043B\u0438\u0437\u043D\u043E \u0437\u0430 {{count}} \u0442\u0438\u0436\u043D\u0456\u0432"
}
}),
xWeeks:buildLocalizeTokenFn5({
regular:{
singularNominative:"{{count}} \u0442\u0438\u0436\u0434\u0435\u043D\u044C",
singularGenitive:"{{count}} \u0442\u0438\u0436\u043D\u0456",
pluralGenitive:"{{count}} \u0442\u0438\u0436\u043D\u0456\u0432"
}
}),
aboutXMonths:buildLocalizeTokenFn5({
regular:{
singularNominative:"\u0431\u043B\u0438\u0437\u044C\u043A\u043E {{count}} \u043C\u0456\u0441\u044F\u0446\u044F",
singularGenitive:"\u0431\u043B\u0438\u0437\u044C\u043A\u043E {{count}} \u043C\u0456\u0441\u044F\u0446\u0456\u0432",
pluralGenitive:"\u0431\u043B\u0438\u0437\u044C\u043A\u043E {{count}} \u043C\u0456\u0441\u044F\u0446\u0456\u0432"
},
future:{
singularNominative:"\u043F\u0440\u0438\u0431\u043B\u0438\u0437\u043D\u043E \u0437\u0430 {{count}} \u043C\u0456\u0441\u044F\u0446\u044C",
singularGenitive:"\u043F\u0440\u0438\u0431\u043B\u0438\u0437\u043D\u043E \u0437\u0430 {{count}} \u043C\u0456\u0441\u044F\u0446\u0456",
pluralGenitive:"\u043F\u0440\u0438\u0431\u043B\u0438\u0437\u043D\u043E \u0437\u0430 {{count}} \u043C\u0456\u0441\u044F\u0446\u0456\u0432"
}
}),
xMonths:buildLocalizeTokenFn5({
regular:{
singularNominative:"{{count}} \u043C\u0456\u0441\u044F\u0446\u044C",
singularGenitive:"{{count}} \u043C\u0456\u0441\u044F\u0446\u0456",
pluralGenitive:"{{count}} \u043C\u0456\u0441\u044F\u0446\u0456\u0432"
}
}),
aboutXYears:buildLocalizeTokenFn5({
regular:{
singularNominative:"\u0431\u043B\u0438\u0437\u044C\u043A\u043E {{count}} \u0440\u043E\u043A\u0443",
singularGenitive:"\u0431\u043B\u0438\u0437\u044C\u043A\u043E {{count}} \u0440\u043E\u043A\u0456\u0432",
pluralGenitive:"\u0431\u043B\u0438\u0437\u044C\u043A\u043E {{count}} \u0440\u043E\u043A\u0456\u0432"
},
future:{
singularNominative:"\u043F\u0440\u0438\u0431\u043B\u0438\u0437\u043D\u043E \u0437\u0430 {{count}} \u0440\u0456\u043A",
singularGenitive:"\u043F\u0440\u0438\u0431\u043B\u0438\u0437\u043D\u043E \u0437\u0430 {{count}} \u0440\u043E\u043A\u0438",
pluralGenitive:"\u043F\u0440\u0438\u0431\u043B\u0438\u0437\u043D\u043E \u0437\u0430 {{count}} \u0440\u043E\u043A\u0456\u0432"
}
}),
xYears:buildLocalizeTokenFn5({
regular:{
singularNominative:"{{count}} \u0440\u0456\u043A",
singularGenitive:"{{count}} \u0440\u043E\u043A\u0438",
pluralGenitive:"{{count}} \u0440\u043E\u043A\u0456\u0432"
}
}),
overXYears:buildLocalizeTokenFn5({
regular:{
singularNominative:"\u0431\u0456\u043B\u044C\u0448\u0435 {{count}} \u0440\u043E\u043A\u0443",
singularGenitive:"\u0431\u0456\u043B\u044C\u0448\u0435 {{count}} \u0440\u043E\u043A\u0456\u0432",
pluralGenitive:"\u0431\u0456\u043B\u044C\u0448\u0435 {{count}} \u0440\u043E\u043A\u0456\u0432"
},
future:{
singularNominative:"\u0431\u0456\u043B\u044C\u0448\u0435, \u043D\u0456\u0436 \u0437\u0430 {{count}} \u0440\u0456\u043A",
singularGenitive:"\u0431\u0456\u043B\u044C\u0448\u0435, \u043D\u0456\u0436 \u0437\u0430 {{count}} \u0440\u043E\u043A\u0438",
pluralGenitive:"\u0431\u0456\u043B\u044C\u0448\u0435, \u043D\u0456\u0436 \u0437\u0430 {{count}} \u0440\u043E\u043A\u0456\u0432"
}
}),
almostXYears:buildLocalizeTokenFn5({
regular:{
singularNominative:"\u043C\u0430\u0439\u0436\u0435 {{count}} \u0440\u0456\u043A",
singularGenitive:"\u043C\u0430\u0439\u0436\u0435 {{count}} \u0440\u043E\u043A\u0438",
pluralGenitive:"\u043C\u0430\u0439\u0436\u0435 {{count}} \u0440\u043E\u043A\u0456\u0432"
},
future:{
singularNominative:"\u043C\u0430\u0439\u0436\u0435 \u0437\u0430 {{count}} \u0440\u0456\u043A",
singularGenitive:"\u043C\u0430\u0439\u0436\u0435 \u0437\u0430 {{count}} \u0440\u043E\u043A\u0438",
pluralGenitive:"\u043C\u0430\u0439\u0436\u0435 \u0437\u0430 {{count}} \u0440\u043E\u043A\u0456\u0432"
}
})
};
var formatDistance167=function formatDistance167(token,count,options){
options=options||{};
return formatDistanceLocale78[token](count,options);
};

// lib/locale/uk/_lib/formatLong.js
var dateFormats87={
full:"EEEE, do MMMM y '\u0440.'",
long:"do MMMM y '\u0440.'",
medium:"d MMM y '\u0440.'",
short:"dd.MM.y"
};
var timeFormats87={
full:"H:mm:ss zzzz",
long:"H:mm:ss z",
medium:"H:mm:ss",
short:"H:mm"
};
var dateTimeFormats87={
full:"{{date}} '\u043E' {{time}}",
long:"{{date}} '\u043E' {{time}}",
medium:"{{date}}, {{time}}",
short:"{{date}}, {{time}}"
};
var formatLong175={
date:buildFormatLongFn({
formats:dateFormats87,
defaultWidth:"full"
}),
time:buildFormatLongFn({
formats:timeFormats87,
defaultWidth:"full"
}),
dateTime:buildFormatLongFn({
formats:dateTimeFormats87,
defaultWidth:"full"
})
};

// lib/locale/uk/_lib/formatRelative.js
function lastWeek9(day){
var weekday=accusativeWeekdays8[day];
switch(day){
case 0:
case 3:
case 5:
case 6:
return"'\u0443 \u043C\u0438\u043D\u0443\u043B\u0443 "+weekday+" \u043E' p";
case 1:
case 2:
case 4:
return"'\u0443 \u043C\u0438\u043D\u0443\u043B\u0438\u0439 "+weekday+" \u043E' p";
}
}
function thisWeek9(day){
var weekday=accusativeWeekdays8[day];
return"'\u0443 "+weekday+" \u043E' p";
}
function nextWeek9(day){
var weekday=accusativeWeekdays8[day];
switch(day){
case 0:
case 3:
case 5:
case 6:
return"'\u0443 \u043D\u0430\u0441\u0442\u0443\u043F\u043D\u0443 "+weekday+" \u043E' p";
case 1:
case 2:
case 4:
return"'\u0443 \u043D\u0430\u0441\u0442\u0443\u043F\u043D\u0438\u0439 "+weekday+" \u043E' p";
}
}
var accusativeWeekdays8=[
"\u043D\u0435\u0434\u0456\u043B\u044E",
"\u043F\u043E\u043D\u0435\u0434\u0456\u043B\u043E\u043A",
"\u0432\u0456\u0432\u0442\u043E\u0440\u043E\u043A",
"\u0441\u0435\u0440\u0435\u0434\u0443",
"\u0447\u0435\u0442\u0432\u0435\u0440",
"\u043F\u2019\u044F\u0442\u043D\u0438\u0446\u044E",
"\u0441\u0443\u0431\u043E\u0442\u0443"];

var lastWeekFormat3=function lastWeekFormat3(dirtyDate,baseDate,options){
var date=toDate(dirtyDate);
var day=date.getDay();
if(isSameWeek(date,baseDate,options)){
return thisWeek9(day);
}else{
return lastWeek9(day);
}
};
var nextWeekFormat3=function nextWeekFormat3(dirtyDate,baseDate,options){
var date=toDate(dirtyDate);
var day=date.getDay();
if(isSameWeek(date,baseDate,options)){
return thisWeek9(day);
}else{
return nextWeek9(day);
}
};
var formatRelativeLocale79={
lastWeek:lastWeekFormat3,
yesterday:"'\u0432\u0447\u043E\u0440\u0430 \u043E' p",
today:"'\u0441\u044C\u043E\u0433\u043E\u0434\u043D\u0456 \u043E' p",
tomorrow:"'\u0437\u0430\u0432\u0442\u0440\u0430 \u043E' p",
nextWeek:nextWeekFormat3,
other:"P"
};
var formatRelative167=function formatRelative167(token,date,baseDate,options){
var format=formatRelativeLocale79[token];
if(typeof format==="function"){
return format(date,baseDate,options);
}
return format;
};

// lib/locale/uk/_lib/localize.js
var eraValues79={
narrow:["\u0434\u043E \u043D.\u0435.","\u043D.\u0435."],
abbreviated:["\u0434\u043E \u043D. \u0435.","\u043D. \u0435."],
wide:["\u0434\u043E \u043D\u0430\u0448\u043E\u0457 \u0435\u0440\u0438","\u043D\u0430\u0448\u043E\u0457 \u0435\u0440\u0438"]
};
var quarterValues79={
narrow:["1","2","3","4"],
abbreviated:["1-\u0439 \u043A\u0432.","2-\u0439 \u043A\u0432.","3-\u0439 \u043A\u0432.","4-\u0439 \u043A\u0432."],
wide:["1-\u0439 \u043A\u0432\u0430\u0440\u0442\u0430\u043B","2-\u0439 \u043A\u0432\u0430\u0440\u0442\u0430\u043B","3-\u0439 \u043A\u0432\u0430\u0440\u0442\u0430\u043B","4-\u0439 \u043A\u0432\u0430\u0440\u0442\u0430\u043B"]
};
var monthValues79={
narrow:["\u0421","\u041B","\u0411","\u041A","\u0422","\u0427","\u041B","\u0421","\u0412","\u0416","\u041B","\u0413"],
abbreviated:[
"\u0441\u0456\u0447.",
"\u043B\u044E\u0442.",
"\u0431\u0435\u0440\u0435\u0437.",
"\u043A\u0432\u0456\u0442.",
"\u0442\u0440\u0430\u0432.",
"\u0447\u0435\u0440\u0432.",
"\u043B\u0438\u043F.",
"\u0441\u0435\u0440\u043F.",
"\u0432\u0435\u0440\u0435\u0441.",
"\u0436\u043E\u0432\u0442.",
"\u043B\u0438\u0441\u0442\u043E\u043F.",
"\u0433\u0440\u0443\u0434."],

wide:[
"\u0441\u0456\u0447\u0435\u043D\u044C",
"\u043B\u044E\u0442\u0438\u0439",
"\u0431\u0435\u0440\u0435\u0437\u0435\u043D\u044C",
"\u043A\u0432\u0456\u0442\u0435\u043D\u044C",
"\u0442\u0440\u0430\u0432\u0435\u043D\u044C",
"\u0447\u0435\u0440\u0432\u0435\u043D\u044C",
"\u043B\u0438\u043F\u0435\u043D\u044C",
"\u0441\u0435\u0440\u043F\u0435\u043D\u044C",
"\u0432\u0435\u0440\u0435\u0441\u0435\u043D\u044C",
"\u0436\u043E\u0432\u0442\u0435\u043D\u044C",
"\u043B\u0438\u0441\u0442\u043E\u043F\u0430\u0434",
"\u0433\u0440\u0443\u0434\u0435\u043D\u044C"]

};
var formattingMonthValues18={
narrow:["\u0421","\u041B","\u0411","\u041A","\u0422","\u0427","\u041B","\u0421","\u0412","\u0416","\u041B","\u0413"],
abbreviated:[
"\u0441\u0456\u0447.",
"\u043B\u044E\u0442.",
"\u0431\u0435\u0440\u0435\u0437.",
"\u043A\u0432\u0456\u0442.",
"\u0442\u0440\u0430\u0432.",
"\u0447\u0435\u0440\u0432.",
"\u043B\u0438\u043F.",
"\u0441\u0435\u0440\u043F.",
"\u0432\u0435\u0440\u0435\u0441.",
"\u0436\u043E\u0432\u0442.",
"\u043B\u0438\u0441\u0442\u043E\u043F.",
"\u0433\u0440\u0443\u0434."],

wide:[
"\u0441\u0456\u0447\u043D\u044F",
"\u043B\u044E\u0442\u043E\u0433\u043E",
"\u0431\u0435\u0440\u0435\u0437\u043D\u044F",
"\u043A\u0432\u0456\u0442\u043D\u044F",
"\u0442\u0440\u0430\u0432\u043D\u044F",
"\u0447\u0435\u0440\u0432\u043D\u044F",
"\u043B\u0438\u043F\u043D\u044F",
"\u0441\u0435\u0440\u043F\u043D\u044F",
"\u0432\u0435\u0440\u0435\u0441\u043D\u044F",
"\u0436\u043E\u0432\u0442\u043D\u044F",
"\u043B\u0438\u0441\u0442\u043E\u043F\u0430\u0434\u0430",
"\u0433\u0440\u0443\u0434\u043D\u044F"]

};
var dayValues79={
narrow:["\u041D","\u041F","\u0412","\u0421","\u0427","\u041F","\u0421"],
short:["\u043D\u0434","\u043F\u043D","\u0432\u0442","\u0441\u0440","\u0447\u0442","\u043F\u0442","\u0441\u0431"],
abbreviated:["\u043D\u0435\u0434","\u043F\u043E\u043D","\u0432\u0456\u0432","\u0441\u0435\u0440","\u0447\u0442\u0432","\u043F\u0442\u043D","\u0441\u0443\u0431"],
wide:[
"\u043D\u0435\u0434\u0456\u043B\u044F",
"\u043F\u043E\u043D\u0435\u0434\u0456\u043B\u043E\u043A",
"\u0432\u0456\u0432\u0442\u043E\u0440\u043E\u043A",
"\u0441\u0435\u0440\u0435\u0434\u0430",
"\u0447\u0435\u0442\u0432\u0435\u0440",
"\u043F\u2019\u044F\u0442\u043D\u0438\u0446\u044F",
"\u0441\u0443\u0431\u043E\u0442\u0430"]

};
var dayPeriodValues79={
narrow:{
am:"\u0414\u041F",
pm:"\u041F\u041F",
midnight:"\u043F\u0456\u0432\u043D.",
noon:"\u043F\u043E\u043B.",
morning:"\u0440\u0430\u043D\u043E\u043A",
afternoon:"\u0434\u0435\u043D\u044C",
evening:"\u0432\u0435\u0447.",
night:"\u043D\u0456\u0447"
},
abbreviated:{
am:"\u0414\u041F",
pm:"\u041F\u041F",
midnight:"\u043F\u0456\u0432\u043D.",
noon:"\u043F\u043E\u043B.",
morning:"\u0440\u0430\u043D\u043E\u043A",
afternoon:"\u0434\u0435\u043D\u044C",
evening:"\u0432\u0435\u0447.",
night:"\u043D\u0456\u0447"
},
wide:{
am:"\u0414\u041F",
pm:"\u041F\u041F",
midnight:"\u043F\u0456\u0432\u043D\u0456\u0447",
noon:"\u043F\u043E\u043B\u0443\u0434\u0435\u043D\u044C",
morning:"\u0440\u0430\u043D\u043E\u043A",
afternoon:"\u0434\u0435\u043D\u044C",
evening:"\u0432\u0435\u0447\u0456\u0440",
night:"\u043D\u0456\u0447"
}
};
var formattingDayPeriodValues63={
narrow:{
am:"\u0414\u041F",
pm:"\u041F\u041F",
midnight:"\u043F\u0456\u0432\u043D.",
noon:"\u043F\u043E\u043B.",
morning:"\u0440\u0430\u043D\u043A\u0443",
afternoon:"\u0434\u043D\u044F",
evening:"\u0432\u0435\u0447.",
night:"\u043D\u043E\u0447\u0456"
},
abbreviated:{
am:"\u0414\u041F",
pm:"\u041F\u041F",
midnight:"\u043F\u0456\u0432\u043D.",
noon:"\u043F\u043E\u043B.",
morning:"\u0440\u0430\u043D\u043A\u0443",
afternoon:"\u0434\u043D\u044F",
evening:"\u0432\u0435\u0447.",
night:"\u043D\u043E\u0447\u0456"
},
wide:{
am:"\u0414\u041F",
pm:"\u041F\u041F",
midnight:"\u043F\u0456\u0432\u043D\u0456\u0447",
noon:"\u043F\u043E\u043B\u0443\u0434\u0435\u043D\u044C",
morning:"\u0440\u0430\u043D\u043A\u0443",
afternoon:"\u0434\u043D\u044F",
evening:"\u0432\u0435\u0447.",
night:"\u043D\u043E\u0447\u0456"
}
};
var ordinalNumber79=function ordinalNumber79(dirtyNumber,options){
var unit=String(options===null||options===void 0?void 0:options.unit);
var number=Number(dirtyNumber);
var suffix;
if(unit==="date"){
if(number===3||number===23){
suffix="-\u0454";
}else{
suffix="-\u0435";
}
}else if(unit==="minute"||unit==="second"||unit==="hour"){
suffix="-\u0430";
}else{
suffix="-\u0439";
}
return number+suffix;
};
var localize170={
ordinalNumber:ordinalNumber79,
era:buildLocalizeFn({
values:eraValues79,
defaultWidth:"wide"
}),
quarter:buildLocalizeFn({
values:quarterValues79,
defaultWidth:"wide",
argumentCallback:function argumentCallback(quarter){return quarter-1;}
}),
month:buildLocalizeFn({
values:monthValues79,
defaultWidth:"wide",
formattingValues:formattingMonthValues18,
defaultFormattingWidth:"wide"
}),
day:buildLocalizeFn({
values:dayValues79,
defaultWidth:"wide"
}),
dayPeriod:buildLocalizeFn({
values:dayPeriodValues79,
defaultWidth:"any",
formattingValues:formattingDayPeriodValues63,
defaultFormattingWidth:"wide"
})
};

// lib/locale/uk/_lib/match.js
var matchOrdinalNumberPattern78=/^(\d+)(-?(е|й|є|а|я))?/i;
var parseOrdinalNumberPattern78=/\d+/i;
var matchEraPatterns78={
narrow:/^((до )?н\.?\s?е\.?)/i,
abbreviated:/^((до )?н\.?\s?е\.?)/i,
wide:/^(до нашої ери|нашої ери|наша ера)/i
};
var parseEraPatterns78={
any:[/^д/i,/^н/i]
};
var matchQuarterPatterns78={
narrow:/^[1234]/i,
abbreviated:/^[1234](-?[иі]?й?)? кв.?/i,
wide:/^[1234](-?[иі]?й?)? квартал/i
};
var parseQuarterPatterns78={
any:[/1/i,/2/i,/3/i,/4/i]
};
var matchMonthPatterns78={
narrow:/^[слбктчвжг]/i,
abbreviated:/^(січ|лют|бер(ез)?|квіт|трав|черв|лип|серп|вер(ес)?|жовт|лис(топ)?|груд)\.?/i,
wide:/^(січень|січня|лютий|лютого|березень|березня|квітень|квітня|травень|травня|червня|червень|липень|липня|серпень|серпня|вересень|вересня|жовтень|жовтня|листопад[а]?|грудень|грудня)/i
};
var parseMonthPatterns78={
narrow:[
/^с/i,
/^л/i,
/^б/i,
/^к/i,
/^т/i,
/^ч/i,
/^л/i,
/^с/i,
/^в/i,
/^ж/i,
/^л/i,
/^г/i],

any:[
/^сі/i,
/^лю/i,
/^б/i,
/^к/i,
/^т/i,
/^ч/i,
/^лип/i,
/^се/i,
/^в/i,
/^ж/i,
/^лис/i,
/^г/i]

};
var matchDayPatterns78={
narrow:/^[нпвсч]/i,
short:/^(нд|пн|вт|ср|чт|пт|сб)\.?/i,
abbreviated:/^(нед|пон|вів|сер|че?тв|птн?|суб)\.?/i,
wide:/^(неділ[яі]|понеділ[ок][ка]|вівтор[ок][ка]|серед[аи]|четвер(га)?|п\W*?ятниц[яі]|субот[аи])/i
};
var parseDayPatterns78={
narrow:[/^н/i,/^п/i,/^в/i,/^с/i,/^ч/i,/^п/i,/^с/i],
any:[/^н/i,/^п[он]/i,/^в/i,/^с[ер]/i,/^ч/i,/^п\W*?[ят]/i,/^с[уб]/i]
};
var matchDayPeriodPatterns78={
narrow:/^([дп]п|півн\.?|пол\.?|ранок|ранку|день|дня|веч\.?|ніч|ночі)/i,
abbreviated:/^([дп]п|півн\.?|пол\.?|ранок|ранку|день|дня|веч\.?|ніч|ночі)/i,
wide:/^([дп]п|північ|полудень|ранок|ранку|день|дня|вечір|вечора|ніч|ночі)/i
};
var parseDayPeriodPatterns78={
any:{
am:/^дп/i,
pm:/^пп/i,
midnight:/^півн/i,
noon:/^пол/i,
morning:/^р/i,
afternoon:/^д[ен]/i,
evening:/^в/i,
night:/^н/i
}
};
var match166={
ordinalNumber:buildMatchPatternFn({
matchPattern:matchOrdinalNumberPattern78,
parsePattern:parseOrdinalNumberPattern78,
valueCallback:function valueCallback(value){return parseInt(value,10);}
}),
era:buildMatchFn({
matchPatterns:matchEraPatterns78,
defaultMatchWidth:"wide",
parsePatterns:parseEraPatterns78,
defaultParseWidth:"any"
}),
quarter:buildMatchFn({
matchPatterns:matchQuarterPatterns78,
defaultMatchWidth:"wide",
parsePatterns:parseQuarterPatterns78,
defaultParseWidth:"any",
valueCallback:function valueCallback(index){return index+1;}
}),
month:buildMatchFn({
matchPatterns:matchMonthPatterns78,
defaultMatchWidth:"wide",
parsePatterns:parseMonthPatterns78,
defaultParseWidth:"any"
}),
day:buildMatchFn({
matchPatterns:matchDayPatterns78,
defaultMatchWidth:"wide",
parsePatterns:parseDayPatterns78,
defaultParseWidth:"any"
}),
dayPeriod:buildMatchFn({
matchPatterns:matchDayPeriodPatterns78,
defaultMatchWidth:"wide",
parsePatterns:parseDayPeriodPatterns78,
defaultParseWidth:"any"
})
};

// lib/locale/uk.js
var _uk={
code:"uk",
formatDistance:formatDistance167,
formatLong:formatLong175,
formatRelative:formatRelative167,
localize:localize170,
match:match166,
options:{
weekStartsOn:1,
firstWeekContainsDate:1
}
};
// lib/locale/uz/_lib/formatDistance.js
var formatDistanceLocale79={
lessThanXSeconds:{
one:"sekunddan kam",
other:"{{count}} sekunddan kam"
},
xSeconds:{
one:"1 sekund",
other:"{{count}} sekund"
},
halfAMinute:"yarim minut",
lessThanXMinutes:{
one:"bir minutdan kam",
other:"{{count}} minutdan kam"
},
xMinutes:{
one:"1 minut",
other:"{{count}} minut"
},
aboutXHours:{
one:"tahminan 1 soat",
other:"tahminan {{count}} soat"
},
xHours:{
one:"1 soat",
other:"{{count}} soat"
},
xDays:{
one:"1 kun",
other:"{{count}} kun"
},
aboutXWeeks:{
one:"tahminan 1 hafta",
other:"tahminan {{count}} hafta"
},
xWeeks:{
one:"1 hafta",
other:"{{count}} hafta"
},
aboutXMonths:{
one:"tahminan 1 oy",
other:"tahminan {{count}} oy"
},
xMonths:{
one:"1 oy",
other:"{{count}} oy"
},
aboutXYears:{
one:"tahminan 1 yil",
other:"tahminan {{count}} yil"
},
xYears:{
one:"1 yil",
other:"{{count}} yil"
},
overXYears:{
one:"1 yildan ko'p",
other:"{{count}} yildan ko'p"
},
almostXYears:{
one:"deyarli 1 yil",
other:"deyarli {{count}} yil"
}
};
var formatDistance169=function formatDistance169(token,count,options){
var result;
var tokenValue=formatDistanceLocale79[token];
if(typeof tokenValue==="string"){
result=tokenValue;
}else if(count===1){
result=tokenValue.one;
}else{
result=tokenValue.other.replace("{{count}}",String(count));
}
if(options!==null&&options!==void 0&&options.addSuffix){
if(options.comparison&&options.comparison>0){
return result+" dan keyin";
}else{
return result+" oldin";
}
}
return result;
};

// lib/locale/uz/_lib/formatLong.js
var dateFormats88={
full:"EEEE, do MMMM, y",
long:"do MMMM, y",
medium:"d MMM, y",
short:"dd/MM/yyyy"
};
var timeFormats88={
full:"h:mm:ss zzzz",
long:"h:mm:ss z",
medium:"h:mm:ss",
short:"h:mm"
};
var dateTimeFormats88={
any:"{{date}}, {{time}}"
};
var formatLong177={
date:buildFormatLongFn({
formats:dateFormats88,
defaultWidth:"full"
}),
time:buildFormatLongFn({
formats:timeFormats88,
defaultWidth:"full"
}),
dateTime:buildFormatLongFn({
formats:dateTimeFormats88,
defaultWidth:"any"
})
};

// lib/locale/uz/_lib/formatRelative.js
var formatRelativeLocale80={
lastWeek:"'oldingi' eeee p 'da'",
yesterday:"'kecha' p 'da'",
today:"'bugun' p 'da'",
tomorrow:"'ertaga' p 'da'",
nextWeek:"eeee p 'da'",
other:"P"
};
var formatRelative169=function formatRelative169(token,_date,_baseDate,_options){return formatRelativeLocale80[token];};

// lib/locale/uz/_lib/localize.js
var eraValues80={
narrow:["M.A","M."],
abbreviated:["M.A","M."],
wide:["Miloddan Avvalgi","Milodiy"]
};
var quarterValues80={
narrow:["1","2","3","4"],
abbreviated:["CH.1","CH.2","CH.3","CH.4"],
wide:["1-chi chorak","2-chi chorak","3-chi chorak","4-chi chorak"]
};
var monthValues80={
narrow:["Y","F","M","A","M","I","I","A","S","O","N","D"],
abbreviated:[
"Yan",
"Fev",
"Mar",
"Apr",
"May",
"Iyun",
"Iyul",
"Avg",
"Sen",
"Okt",
"Noy",
"Dek"],

wide:[
"Yanvar",
"Fevral",
"Mart",
"Aprel",
"May",
"Iyun",
"Iyul",
"Avgust",
"Sentabr",
"Oktabr",
"Noyabr",
"Dekabr"]

};
var dayValues80={
narrow:["Y","D","S","CH","P","J","SH"],
short:["Ya","Du","Se","Cho","Pa","Ju","Sha"],
abbreviated:["Yak","Dush","Sesh","Chor","Pay","Jum","Shan"],
wide:[
"Yakshanba",
"Dushanba",
"Seshanba",
"Chorshanba",
"Payshanba",
"Juma",
"Shanba"]

};
var dayPeriodValues80={
narrow:{
am:"a",
pm:"p",
midnight:"y.t",
noon:"p.",
morning:"ertalab",
afternoon:"tushdan keyin",
evening:"kechqurun",
night:"tun"
},
abbreviated:{
am:"AM",
pm:"PM",
midnight:"yarim tun",
noon:"peshin",
morning:"ertalab",
afternoon:"tushdan keyin",
evening:"kechqurun",
night:"tun"
},
wide:{
am:"a.m.",
pm:"p.m.",
midnight:"yarim tun",
noon:"peshin",
morning:"ertalab",
afternoon:"tushdan keyin",
evening:"kechqurun",
night:"tun"
}
};
var formattingDayPeriodValues64={
narrow:{
am:"a",
pm:"p",
midnight:"y.t",
noon:"p.",
morning:"ertalab",
afternoon:"tushdan keyin",
evening:"kechqurun",
night:"tun"
},
abbreviated:{
am:"AM",
pm:"PM",
midnight:"yarim tun",
noon:"peshin",
morning:"ertalab",
afternoon:"tushdan keyin",
evening:"kechqurun",
night:"tun"
},
wide:{
am:"a.m.",
pm:"p.m.",
midnight:"yarim tun",
noon:"peshin",
morning:"ertalab",
afternoon:"tushdan keyin",
evening:"kechqurun",
night:"tun"
}
};
var ordinalNumber80=function ordinalNumber80(dirtyNumber,_options){
return String(dirtyNumber);
};
var localize172={
ordinalNumber:ordinalNumber80,
era:buildLocalizeFn({
values:eraValues80,
defaultWidth:"wide"
}),
quarter:buildLocalizeFn({
values:quarterValues80,
defaultWidth:"wide",
argumentCallback:function argumentCallback(quarter){return quarter-1;}
}),
month:buildLocalizeFn({
values:monthValues80,
defaultWidth:"wide"
}),
day:buildLocalizeFn({
values:dayValues80,
defaultWidth:"wide"
}),
dayPeriod:buildLocalizeFn({
values:dayPeriodValues80,
defaultWidth:"wide",
formattingValues:formattingDayPeriodValues64,
defaultFormattingWidth:"wide"
})
};

// lib/locale/uz/_lib/match.js
var matchOrdinalNumberPattern79=/^(\d+)(chi)?/i;
var parseOrdinalNumberPattern79=/\d+/i;
var matchEraPatterns79={
narrow:/^(m\.a|m\.)/i,
abbreviated:/^(m\.a\.?\s?m\.?)/i,
wide:/^(miloddan avval|miloddan keyin)/i
};
var parseEraPatterns79={
any:[/^b/i,/^(a|c)/i]
};
var matchQuarterPatterns79={
narrow:/^[1234]/i,
abbreviated:/^q[1234]/i,
wide:/^[1234](chi)? chorak/i
};
var parseQuarterPatterns79={
any:[/1/i,/2/i,/3/i,/4/i]
};
var matchMonthPatterns79={
narrow:/^[yfmasond]/i,
abbreviated:/^(yan|fev|mar|apr|may|iyun|iyul|avg|sen|okt|noy|dek)/i,
wide:/^(yanvar|fevral|mart|aprel|may|iyun|iyul|avgust|sentabr|oktabr|noyabr|dekabr)/i
};
var parseMonthPatterns79={
narrow:[
/^y/i,
/^f/i,
/^m/i,
/^a/i,
/^m/i,
/^i/i,
/^i/i,
/^a/i,
/^s/i,
/^o/i,
/^n/i,
/^d/i],

any:[
/^ya/i,
/^f/i,
/^mar/i,
/^ap/i,
/^may/i,
/^iyun/i,
/^iyul/i,
/^av/i,
/^s/i,
/^o/i,
/^n/i,
/^d/i]

};
var matchDayPatterns79={
narrow:/^[ydschj]/i,
short:/^(ya|du|se|cho|pa|ju|sha)/i,
abbreviated:/^(yak|dush|sesh|chor|pay|jum|shan)/i,
wide:/^(yakshanba|dushanba|seshanba|chorshanba|payshanba|juma|shanba)/i
};
var parseDayPatterns79={
narrow:[/^y/i,/^d/i,/^s/i,/^ch/i,/^p/i,/^j/i,/^sh/i],
any:[/^ya/i,/^d/i,/^se/i,/^ch/i,/^p/i,/^j/i,/^sh/i]
};
var matchDayPeriodPatterns79={
narrow:/^(a|p|y\.t|p| (ertalab|tushdan keyin|kechqurun|tun))/i,
any:/^([ap]\.?\s?m\.?|yarim tun|peshin| (ertalab|tushdan keyin|kechqurun|tun))/i
};
var parseDayPeriodPatterns79={
any:{
am:/^a/i,
pm:/^p/i,
midnight:/^y\.t/i,
noon:/^pe/i,
morning:/ertalab/i,
afternoon:/tushdan keyin/i,
evening:/kechqurun/i,
night:/tun/i
}
};
var match168={
ordinalNumber:buildMatchPatternFn({
matchPattern:matchOrdinalNumberPattern79,
parsePattern:parseOrdinalNumberPattern79,
valueCallback:function valueCallback(value){return parseInt(value,10);}
}),
era:buildMatchFn({
matchPatterns:matchEraPatterns79,
defaultMatchWidth:"wide",
parsePatterns:parseEraPatterns79,
defaultParseWidth:"any"
}),
quarter:buildMatchFn({
matchPatterns:matchQuarterPatterns79,
defaultMatchWidth:"wide",
parsePatterns:parseQuarterPatterns79,
defaultParseWidth:"any",
valueCallback:function valueCallback(index){return index+1;}
}),
month:buildMatchFn({
matchPatterns:matchMonthPatterns79,
defaultMatchWidth:"wide",
parsePatterns:parseMonthPatterns79,
defaultParseWidth:"any"
}),
day:buildMatchFn({
matchPatterns:matchDayPatterns79,
defaultMatchWidth:"wide",
parsePatterns:parseDayPatterns79,
defaultParseWidth:"any"
}),
dayPeriod:buildMatchFn({
matchPatterns:matchDayPeriodPatterns79,
defaultMatchWidth:"any",
parsePatterns:parseDayPeriodPatterns79,
defaultParseWidth:"any"
})
};

// lib/locale/uz.js
var _uz={
code:"uz",
formatDistance:formatDistance169,
formatLong:formatLong177,
formatRelative:formatRelative169,
localize:localize172,
match:match168,
options:{
weekStartsOn:1,
firstWeekContainsDate:1
}
};
// lib/locale/uz-Cyrl/_lib/formatDistance.js
var formatDistanceLocale80={
lessThanXSeconds:{
one:"1 \u0441\u043E\u043D\u0438\u044F\u0434\u0430\u043D \u043A\u0430\u043C",
other:"{{count}} \u0441\u043E\u043D\u0438\u044F\u0434\u0430\u043D \u043A\u0430\u043C"
},
xSeconds:{
one:"1 \u0441\u043E\u043D\u0438\u044F",
other:"{{count}} \u0441\u043E\u043D\u0438\u044F"
},
halfAMinute:"\u044F\u0440\u0438\u043C \u0434\u0430\u049B\u0438\u049B\u0430",
lessThanXMinutes:{
one:"1 \u0434\u0430\u049B\u0438\u049B\u0430\u0434\u0430\u043D \u043A\u0430\u043C",
other:"{{count}} \u0434\u0430\u049B\u0438\u049B\u0430\u0434\u0430\u043D \u043A\u0430\u043C"
},
xMinutes:{
one:"1 \u0434\u0430\u049B\u0438\u049B\u0430",
other:"{{count}} \u0434\u0430\u049B\u0438\u049B\u0430"
},
aboutXHours:{
one:"\u0442\u0430\u0445\u043C\u0438\u043D\u0430\u043D 1 \u0441\u043E\u0430\u0442",
other:"\u0442\u0430\u0445\u043C\u0438\u043D\u0430\u043D {{count}} \u0441\u043E\u0430\u0442"
},
xHours:{
one:"1 \u0441\u043E\u0430\u0442",
other:"{{count}} \u0441\u043E\u0430\u0442"
},
xDays:{
one:"1 \u043A\u0443\u043D",
other:"{{count}} \u043A\u0443\u043D"
},
aboutXWeeks:{
one:"\u0442\u0430\u0445\u043C\u0438\u043D\u0430\u043D 1 \u0445\u0430\u0444\u0442\u0430",
other:"\u0442\u0430\u0445\u043C\u0438\u043D\u0430\u043D {{count}} \u0445\u0430\u0444\u0442\u0430"
},
xWeeks:{
one:"1 \u0445\u0430\u0444\u0442\u0430",
other:"{{count}} \u0445\u0430\u0444\u0442\u0430"
},
aboutXMonths:{
one:"\u0442\u0430\u0445\u043C\u0438\u043D\u0430\u043D 1 \u043E\u0439",
other:"\u0442\u0430\u0445\u043C\u0438\u043D\u0430\u043D {{count}} \u043E\u0439"
},
xMonths:{
one:"1 \u043E\u0439",
other:"{{count}} \u043E\u0439"
},
aboutXYears:{
one:"\u0442\u0430\u0445\u043C\u0438\u043D\u0430\u043D 1 \u0439\u0438\u043B",
other:"\u0442\u0430\u0445\u043C\u0438\u043D\u0430\u043D {{count}} \u0439\u0438\u043B"
},
xYears:{
one:"1 \u0439\u0438\u043B",
other:"{{count}} \u0439\u0438\u043B"
},
overXYears:{
one:"1 \u0439\u0438\u043B\u0434\u0430\u043D \u043A\u045E\u043F",
other:"{{count}} \u0439\u0438\u043B\u0434\u0430\u043D \u043A\u045E\u043F"
},
almostXYears:{
one:"\u0434\u0435\u044F\u0440\u043B\u0438 1 \u0439\u0438\u043B",
other:"\u0434\u0435\u044F\u0440\u043B\u0438 {{count}} \u0439\u0438\u043B"
}
};
var formatDistance171=function formatDistance171(token,count,options){
var result;
var tokenValue=formatDistanceLocale80[token];
if(typeof tokenValue==="string"){
result=tokenValue;
}else if(count===1){
result=tokenValue.one;
}else{
result=tokenValue.other.replace("{{count}}",String(count));
}
if(options!==null&&options!==void 0&&options.addSuffix){
if(options.comparison&&options.comparison>0){
return result+"\u0434\u0430\u043D \u043A\u0435\u0439\u0438\u043D";
}else{
return result+" \u043E\u043B\u0434\u0438\u043D";
}
}
return result;
};

// lib/locale/uz-Cyrl/_lib/formatLong.js
var dateFormats89={
full:"EEEE, do MMMM, y",
long:"do MMMM, y",
medium:"d MMM, y",
short:"dd/MM/yyyy"
};
var timeFormats89={
full:"H:mm:ss zzzz",
long:"H:mm:ss z",
medium:"H:mm:ss",
short:"H:mm"
};
var dateTimeFormats89={
any:"{{date}}, {{time}}"
};
var formatLong179={
date:buildFormatLongFn({
formats:dateFormats89,
defaultWidth:"full"
}),
time:buildFormatLongFn({
formats:timeFormats89,
defaultWidth:"full"
}),
dateTime:buildFormatLongFn({
formats:dateTimeFormats89,
defaultWidth:"any"
})
};

// lib/locale/uz-Cyrl/_lib/formatRelative.js
var formatRelativeLocale81={
lastWeek:"'\u045E\u0442\u0433\u0430\u043D' eeee p '\u0434\u0430'",
yesterday:"'\u043A\u0435\u0447\u0430' p '\u0434\u0430'",
today:"'\u0431\u0443\u0433\u0443\u043D' p '\u0434\u0430'",
tomorrow:"'\u044D\u0440\u0442\u0430\u0433\u0430' p '\u0434\u0430'",
nextWeek:"eeee p '\u0434\u0430'",
other:"P"
};
var formatRelative171=function formatRelative171(token,_date,_baseDate,_options){return formatRelativeLocale81[token];};

// lib/locale/uz-Cyrl/_lib/localize.js
var eraValues81={
narrow:["\u041C.\u0410","\u041C"],
abbreviated:["\u041C.\u0410","\u041C"],
wide:["\u041C\u0438\u043B\u043E\u0434\u0434\u0430\u043D \u0410\u0432\u0432\u0430\u043B\u0433\u0438","\u041C\u0438\u043B\u043E\u0434\u0438\u0439"]
};
var quarterValues81={
narrow:["1","2","3","4"],
abbreviated:["1-\u0447\u043E\u0440.","2-\u0447\u043E\u0440.","3-\u0447\u043E\u0440.","4-\u0447\u043E\u0440."],
wide:["1-\u0447\u043E\u0440\u0430\u043A","2-\u0447\u043E\u0440\u0430\u043A","3-\u0447\u043E\u0440\u0430\u043A","4-\u0447\u043E\u0440\u0430\u043A"]
};
var monthValues81={
narrow:["\u042F","\u0424","\u041C","\u0410","\u041C","\u0418","\u0418","\u0410","\u0421","\u041E","\u041D","\u0414"],
abbreviated:[
"\u044F\u043D\u0432",
"\u0444\u0435\u0432",
"\u043C\u0430\u0440",
"\u0430\u043F\u0440",
"\u043C\u0430\u0439",
"\u0438\u044E\u043D",
"\u0438\u044E\u043B",
"\u0430\u0432\u0433",
"\u0441\u0435\u043D",
"\u043E\u043A\u0442",
"\u043D\u043E\u044F",
"\u0434\u0435\u043A"],

wide:[
"\u044F\u043D\u0432\u0430\u0440",
"\u0444\u0435\u0432\u0440\u0430\u043B",
"\u043C\u0430\u0440\u0442",
"\u0430\u043F\u0440\u0435\u043B",
"\u043C\u0430\u0439",
"\u0438\u044E\u043D",
"\u0438\u044E\u043B",
"\u0430\u0432\u0433\u0443\u0441\u0442",
"\u0441\u0435\u043D\u0442\u0430\u0431\u0440",
"\u043E\u043A\u0442\u0430\u0431\u0440",
"\u043D\u043E\u044F\u0431\u0440",
"\u0434\u0435\u043A\u0430\u0431\u0440"]

};
var dayValues81={
narrow:["\u042F","\u0414","\u0421","\u0427","\u041F","\u0416","\u0428"],
short:["\u044F\u043A","\u0434\u0443","\u0441\u0435","\u0447\u043E","\u043F\u0430","\u0436\u0443","\u0448\u0430"],
abbreviated:["\u044F\u043A\u0448","\u0434\u0443\u0448","\u0441\u0435\u0448","\u0447\u043E\u0440","\u043F\u0430\u0439","\u0436\u0443\u043C","\u0448\u0430\u043D"],
wide:[
"\u044F\u043A\u0448\u0430\u043D\u0431\u0430",
"\u0434\u0443\u0448\u0430\u043D\u0431\u0430",
"\u0441\u0435\u0448\u0430\u043D\u0431\u0430",
"\u0447\u043E\u0440\u0448\u0430\u043D\u0431\u0430",
"\u043F\u0430\u0439\u0448\u0430\u043D\u0431\u0430",
"\u0436\u0443\u043C\u0430",
"\u0448\u0430\u043D\u0431\u0430"]

};
var dayPeriodValues81={
any:{
am:"\u041F.\u041E.",
pm:"\u041F.\u041A.",
midnight:"\u044F\u0440\u0438\u043C \u0442\u0443\u043D",
noon:"\u043F\u0435\u0448\u0438\u043D",
morning:"\u044D\u0440\u0442\u0430\u043B\u0430\u0431",
afternoon:"\u043F\u0435\u0448\u0438\u043D\u0434\u0430\u043D \u043A\u0435\u0439\u0438\u043D",
evening:"\u043A\u0435\u0447\u0430\u0441\u0438",
night:"\u0442\u0443\u043D"
}
};
var formattingDayPeriodValues65={
any:{
am:"\u041F.\u041E.",
pm:"\u041F.\u041A.",
midnight:"\u044F\u0440\u0438\u043C \u0442\u0443\u043D",
noon:"\u043F\u0435\u0448\u0438\u043D",
morning:"\u044D\u0440\u0442\u0430\u043B\u0430\u0431",
afternoon:"\u043F\u0435\u0448\u0438\u043D\u0434\u0430\u043D \u043A\u0435\u0439\u0438\u043D",
evening:"\u043A\u0435\u0447\u0430\u0441\u0438",
night:"\u0442\u0443\u043D"
}
};
var ordinalNumber81=function ordinalNumber81(dirtyNumber,_options){
return String(dirtyNumber);
};
var localize174={
ordinalNumber:ordinalNumber81,
era:buildLocalizeFn({
values:eraValues81,
defaultWidth:"wide"
}),
quarter:buildLocalizeFn({
values:quarterValues81,
defaultWidth:"wide",
argumentCallback:function argumentCallback(quarter){return quarter-1;}
}),
month:buildLocalizeFn({
values:monthValues81,
defaultWidth:"wide"
}),
day:buildLocalizeFn({
values:dayValues81,
defaultWidth:"wide"
}),
dayPeriod:buildLocalizeFn({
values:dayPeriodValues81,
defaultWidth:"any",
formattingValues:formattingDayPeriodValues65,
defaultFormattingWidth:"any"
})
};

// lib/locale/uz-Cyrl/_lib/match.js
var matchOrdinalNumberPattern80=/^(\d+)(чи)?/i;
var parseOrdinalNumberPattern80=/\d+/i;
var matchEraPatterns80={
narrow:/^(м\.а|м\.)/i,
abbreviated:/^(м\.а|м\.)/i,
wide:/^(милоддан аввал|милоддан кейин)/i
};
var parseEraPatterns80={
any:[/^м/i,/^а/i]
};
var matchQuarterPatterns80={
narrow:/^[1234]/i,
abbreviated:/^[1234]-чор./i,
wide:/^[1234]-чорак/i
};
var parseQuarterPatterns80={
any:[/1/i,/2/i,/3/i,/4/i]
};
var matchMonthPatterns80={
narrow:/^[яфмамииасонд]/i,
abbreviated:/^(янв|фев|мар|апр|май|июн|июл|авг|сен|окт|ноя|дек)/i,
wide:/^(январ|феврал|март|апрел|май|июн|июл|август|сентабр|октабр|ноябр|декабр)/i
};
var parseMonthPatterns80={
narrow:[
/^я/i,
/^ф/i,
/^м/i,
/^а/i,
/^м/i,
/^и/i,
/^и/i,
/^а/i,
/^с/i,
/^о/i,
/^н/i,
/^д/i],

any:[
/^я/i,
/^ф/i,
/^мар/i,
/^ап/i,
/^май/i,
/^июн/i,
/^июл/i,
/^ав/i,
/^с/i,
/^о/i,
/^н/i,
/^д/i]

};
var matchDayPatterns80={
narrow:/^[ядсчпжш]/i,
short:/^(як|ду|се|чо|па|жу|ша)/i,
abbreviated:/^(якш|душ|сеш|чор|пай|жум|шан)/i,
wide:/^(якшанба|душанба|сешанба|чоршанба|пайшанба|жума|шанба)/i
};
var parseDayPatterns80={
narrow:[/^я/i,/^д/i,/^с/i,/^ч/i,/^п/i,/^ж/i,/^ш/i],
any:[/^як/i,/^ду/i,/^се/i,/^чор/i,/^пай/i,/^жу/i,/^шан/i]
};
var matchDayPeriodPatterns80={
any:/^(п\.о\.|п\.к\.|ярим тун|пешиндан кейин|(эрталаб|пешиндан кейин|кечаси|тун))/i
};
var parseDayPeriodPatterns80={
any:{
am:/^п\.о\./i,
pm:/^п\.к\./i,
midnight:/^ярим тун/i,
noon:/^пешиндан кейин/i,
morning:/эрталаб/i,
afternoon:/пешиндан кейин/i,
evening:/кечаси/i,
night:/тун/i
}
};
var match170={
ordinalNumber:buildMatchPatternFn({
matchPattern:matchOrdinalNumberPattern80,
parsePattern:parseOrdinalNumberPattern80,
valueCallback:function valueCallback(value){return parseInt(value,10);}
}),
era:buildMatchFn({
matchPatterns:matchEraPatterns80,
defaultMatchWidth:"wide",
parsePatterns:parseEraPatterns80,
defaultParseWidth:"any"
}),
quarter:buildMatchFn({
matchPatterns:matchQuarterPatterns80,
defaultMatchWidth:"wide",
parsePatterns:parseQuarterPatterns80,
defaultParseWidth:"any",
valueCallback:function valueCallback(index){return index+1;}
}),
month:buildMatchFn({
matchPatterns:matchMonthPatterns80,
defaultMatchWidth:"wide",
parsePatterns:parseMonthPatterns80,
defaultParseWidth:"any"
}),
day:buildMatchFn({
matchPatterns:matchDayPatterns80,
defaultMatchWidth:"wide",
parsePatterns:parseDayPatterns80,
defaultParseWidth:"any"
}),
dayPeriod:buildMatchFn({
matchPatterns:matchDayPeriodPatterns80,
defaultMatchWidth:"any",
parsePatterns:parseDayPeriodPatterns80,
defaultParseWidth:"any"
})
};

// lib/locale/uz-Cyrl.js
var _uzCyrl={
code:"uz-Cyrl",
formatDistance:formatDistance171,
formatLong:formatLong179,
formatRelative:formatRelative171,
localize:localize174,
match:match170,
options:{
weekStartsOn:1,
firstWeekContainsDate:1
}
};
// lib/locale/vi/_lib/formatDistance.js
var formatDistanceLocale81={
lessThanXSeconds:{
one:"d\u01B0\u1EDBi 1 gi\xE2y",
other:"d\u01B0\u1EDBi {{count}} gi\xE2y"
},
xSeconds:{
one:"1 gi\xE2y",
other:"{{count}} gi\xE2y"
},
halfAMinute:"n\u1EEDa ph\xFAt",
lessThanXMinutes:{
one:"d\u01B0\u1EDBi 1 ph\xFAt",
other:"d\u01B0\u1EDBi {{count}} ph\xFAt"
},
xMinutes:{
one:"1 ph\xFAt",
other:"{{count}} ph\xFAt"
},
aboutXHours:{
one:"kho\u1EA3ng 1 gi\u1EDD",
other:"kho\u1EA3ng {{count}} gi\u1EDD"
},
xHours:{
one:"1 gi\u1EDD",
other:"{{count}} gi\u1EDD"
},
xDays:{
one:"1 ng\xE0y",
other:"{{count}} ng\xE0y"
},
aboutXWeeks:{
one:"kho\u1EA3ng 1 tu\u1EA7n",
other:"kho\u1EA3ng {{count}} tu\u1EA7n"
},
xWeeks:{
one:"1 tu\u1EA7n",
other:"{{count}} tu\u1EA7n"
},
aboutXMonths:{
one:"kho\u1EA3ng 1 th\xE1ng",
other:"kho\u1EA3ng {{count}} th\xE1ng"
},
xMonths:{
one:"1 th\xE1ng",
other:"{{count}} th\xE1ng"
},
aboutXYears:{
one:"kho\u1EA3ng 1 n\u0103m",
other:"kho\u1EA3ng {{count}} n\u0103m"
},
xYears:{
one:"1 n\u0103m",
other:"{{count}} n\u0103m"
},
overXYears:{
one:"h\u01A1n 1 n\u0103m",
other:"h\u01A1n {{count}} n\u0103m"
},
almostXYears:{
one:"g\u1EA7n 1 n\u0103m",
other:"g\u1EA7n {{count}} n\u0103m"
}
};
var formatDistance173=function formatDistance173(token,count,options){
var result;
var tokenValue=formatDistanceLocale81[token];
if(typeof tokenValue==="string"){
result=tokenValue;
}else if(count===1){
result=tokenValue.one;
}else{
result=tokenValue.other.replace("{{count}}",String(count));
}
if(options!==null&&options!==void 0&&options.addSuffix){
if(options.comparison&&options.comparison>0){
return result+" n\u1EEFa";
}else{
return result+" tr\u01B0\u1EDBc";
}
}
return result;
};

// lib/locale/vi/_lib/formatLong.js
var dateFormats90={
full:"EEEE, 'ng\xE0y' d MMMM 'n\u0103m' y",
long:"'ng\xE0y' d MMMM 'n\u0103m' y",
medium:"d MMM 'n\u0103m' y",
short:"dd/MM/y"
};
var timeFormats90={
full:"HH:mm:ss zzzz",
long:"HH:mm:ss z",
medium:"HH:mm:ss",
short:"HH:mm"
};
var dateTimeFormats90={
full:"{{date}} {{time}}",
long:"{{date}} {{time}}",
medium:"{{date}} {{time}}",
short:"{{date}} {{time}}"
};
var formatLong181={
date:buildFormatLongFn({
formats:dateFormats90,
defaultWidth:"full"
}),
time:buildFormatLongFn({
formats:timeFormats90,
defaultWidth:"full"
}),
dateTime:buildFormatLongFn({
formats:dateTimeFormats90,
defaultWidth:"full"
})
};

// lib/locale/vi/_lib/formatRelative.js
var formatRelativeLocale82={
lastWeek:"eeee 'tu\u1EA7n tr\u01B0\u1EDBc v\xE0o l\xFAc' p",
yesterday:"'h\xF4m qua v\xE0o l\xFAc' p",
today:"'h\xF4m nay v\xE0o l\xFAc' p",
tomorrow:"'ng\xE0y mai v\xE0o l\xFAc' p",
nextWeek:"eeee 't\u1EDBi v\xE0o l\xFAc' p",
other:"P"
};
var formatRelative173=function formatRelative173(token,_date,_baseDate,_options){return formatRelativeLocale82[token];};

// lib/locale/vi/_lib/localize.js
var eraValues82={
narrow:["TCN","SCN"],
abbreviated:["tr\u01B0\u1EDBc CN","sau CN"],
wide:["tr\u01B0\u1EDBc C\xF4ng Nguy\xEAn","sau C\xF4ng Nguy\xEAn"]
};
var quarterValues82={
narrow:["1","2","3","4"],
abbreviated:["Q1","Q2","Q3","Q4"],
wide:["Qu\xFD 1","Qu\xFD 2","Qu\xFD 3","Qu\xFD 4"]
};
var formattingQuarterValues4={
narrow:["1","2","3","4"],
abbreviated:["Q1","Q2","Q3","Q4"],
wide:["qu\xFD I","qu\xFD II","qu\xFD III","qu\xFD IV"]
};
var monthValues82={
narrow:["1","2","3","4","5","6","7","8","9","10","11","12"],
abbreviated:[
"Thg 1",
"Thg 2",
"Thg 3",
"Thg 4",
"Thg 5",
"Thg 6",
"Thg 7",
"Thg 8",
"Thg 9",
"Thg 10",
"Thg 11",
"Thg 12"],

wide:[
"Th\xE1ng M\u1ED9t",
"Th\xE1ng Hai",
"Th\xE1ng Ba",
"Th\xE1ng T\u01B0",
"Th\xE1ng N\u0103m",
"Th\xE1ng S\xE1u",
"Th\xE1ng B\u1EA3y",
"Th\xE1ng T\xE1m",
"Th\xE1ng Ch\xEDn",
"Th\xE1ng M\u01B0\u1EDDi",
"Th\xE1ng M\u01B0\u1EDDi M\u1ED9t",
"Th\xE1ng M\u01B0\u1EDDi Hai"]

};
var formattingMonthValues19={
narrow:[
"01",
"02",
"03",
"04",
"05",
"06",
"07",
"08",
"09",
"10",
"11",
"12"],

abbreviated:[
"thg 1",
"thg 2",
"thg 3",
"thg 4",
"thg 5",
"thg 6",
"thg 7",
"thg 8",
"thg 9",
"thg 10",
"thg 11",
"thg 12"],

wide:[
"th\xE1ng 01",
"th\xE1ng 02",
"th\xE1ng 03",
"th\xE1ng 04",
"th\xE1ng 05",
"th\xE1ng 06",
"th\xE1ng 07",
"th\xE1ng 08",
"th\xE1ng 09",
"th\xE1ng 10",
"th\xE1ng 11",
"th\xE1ng 12"]

};
var dayValues82={
narrow:["CN","T2","T3","T4","T5","T6","T7"],
short:["CN","Th 2","Th 3","Th 4","Th 5","Th 6","Th 7"],
abbreviated:["CN","Th\u1EE9 2","Th\u1EE9 3","Th\u1EE9 4","Th\u1EE9 5","Th\u1EE9 6","Th\u1EE9 7"],
wide:[
"Ch\u1EE7 Nh\u1EADt",
"Th\u1EE9 Hai",
"Th\u1EE9 Ba",
"Th\u1EE9 T\u01B0",
"Th\u1EE9 N\u0103m",
"Th\u1EE9 S\xE1u",
"Th\u1EE9 B\u1EA3y"]

};
var dayPeriodValues82={
narrow:{
am:"am",
pm:"pm",
midnight:"n\u1EEDa \u0111\xEAm",
noon:"tr",
morning:"sg",
afternoon:"ch",
evening:"t\u1ED1i",
night:"\u0111\xEAm"
},
abbreviated:{
am:"AM",
pm:"PM",
midnight:"n\u1EEDa \u0111\xEAm",
noon:"tr\u01B0a",
morning:"s\xE1ng",
afternoon:"chi\u1EC1u",
evening:"t\u1ED1i",
night:"\u0111\xEAm"
},
wide:{
am:"SA",
pm:"CH",
midnight:"n\u1EEDa \u0111\xEAm",
noon:"tr\u01B0a",
morning:"s\xE1ng",
afternoon:"chi\u1EC1u",
evening:"t\u1ED1i",
night:"\u0111\xEAm"
}
};
var formattingDayPeriodValues66={
narrow:{
am:"am",
pm:"pm",
midnight:"n\u1EEDa \u0111\xEAm",
noon:"tr",
morning:"sg",
afternoon:"ch",
evening:"t\u1ED1i",
night:"\u0111\xEAm"
},
abbreviated:{
am:"AM",
pm:"PM",
midnight:"n\u1EEDa \u0111\xEAm",
noon:"tr\u01B0a",
morning:"s\xE1ng",
afternoon:"chi\u1EC1u",
evening:"t\u1ED1i",
night:"\u0111\xEAm"
},
wide:{
am:"SA",
pm:"CH",
midnight:"n\u1EEDa \u0111\xEAm",
noon:"gi\u1EEFa tr\u01B0a",
morning:"v\xE0o bu\u1ED5i s\xE1ng",
afternoon:"v\xE0o bu\u1ED5i chi\u1EC1u",
evening:"v\xE0o bu\u1ED5i t\u1ED1i",
night:"v\xE0o ban \u0111\xEAm"
}
};
var ordinalNumber82=function ordinalNumber82(dirtyNumber,options){
var number=Number(dirtyNumber);
var unit=options===null||options===void 0?void 0:options.unit;
if(unit==="quarter"){
switch(number){
case 1:
return"I";
case 2:
return"II";
case 3:
return"III";
case 4:
return"IV";
}
}else if(unit==="day"){
switch(number){
case 1:
return"th\u1EE9 2";
case 2:
return"th\u1EE9 3";
case 3:
return"th\u1EE9 4";
case 4:
return"th\u1EE9 5";
case 5:
return"th\u1EE9 6";
case 6:
return"th\u1EE9 7";
case 7:
return"ch\u1EE7 nh\u1EADt";
}
}else if(unit==="week"){
if(number===1){
return"th\u1EE9 nh\u1EA5t";
}else{
return"th\u1EE9 "+number;
}
}else if(unit==="dayOfYear"){
if(number===1){
return"\u0111\u1EA7u ti\xEAn";
}else{
return"th\u1EE9 "+number;
}
}
return String(number);
};
var localize176={
ordinalNumber:ordinalNumber82,
era:buildLocalizeFn({
values:eraValues82,
defaultWidth:"wide"
}),
quarter:buildLocalizeFn({
values:quarterValues82,
defaultWidth:"wide",
formattingValues:formattingQuarterValues4,
defaultFormattingWidth:"wide",
argumentCallback:function argumentCallback(quarter){return quarter-1;}
}),
month:buildLocalizeFn({
values:monthValues82,
defaultWidth:"wide",
formattingValues:formattingMonthValues19,
defaultFormattingWidth:"wide"
}),
day:buildLocalizeFn({
values:dayValues82,
defaultWidth:"wide"
}),
dayPeriod:buildLocalizeFn({
values:dayPeriodValues82,
defaultWidth:"wide",
formattingValues:formattingDayPeriodValues66,
defaultFormattingWidth:"wide"
})
};

// lib/locale/vi/_lib/match.js
var matchOrdinalNumberPattern81=/^(\d+)/i;
var parseOrdinalNumberPattern81=/\d+/i;
var matchEraPatterns81={
narrow:/^(tcn|scn)/i,
abbreviated:/^(trước CN|sau CN)/i,
wide:/^(trước Công Nguyên|sau Công Nguyên)/i
};
var parseEraPatterns81={
any:[/^t/i,/^s/i]
};
var matchQuarterPatterns81={
narrow:/^([1234]|i{1,3}v?)/i,
abbreviated:/^q([1234]|i{1,3}v?)/i,
wide:/^quý ([1234]|i{1,3}v?)/i
};
var parseQuarterPatterns81={
any:[/(1|i)$/i,/(2|ii)$/i,/(3|iii)$/i,/(4|iv)$/i]
};
var matchMonthPatterns81={
narrow:/^(0?[2-9]|10|11|12|0?1)/i,
abbreviated:/^thg[ _]?(0?[1-9](?!\d)|10|11|12)/i,
wide:/^tháng ?(Một|Hai|Ba|Tư|Năm|Sáu|Bảy|Tám|Chín|Mười|Mười ?Một|Mười ?Hai|0?[1-9](?!\d)|10|11|12)/i
};
var parseMonthPatterns81={
narrow:[
/0?1$/i,
/0?2/i,
/3/,
/4/,
/5/,
/6/,
/7/,
/8/,
/9/,
/10/,
/11/,
/12/],

abbreviated:[
/^thg[ _]?0?1(?!\d)/i,
/^thg[ _]?0?2/i,
/^thg[ _]?0?3/i,
/^thg[ _]?0?4/i,
/^thg[ _]?0?5/i,
/^thg[ _]?0?6/i,
/^thg[ _]?0?7/i,
/^thg[ _]?0?8/i,
/^thg[ _]?0?9/i,
/^thg[ _]?10/i,
/^thg[ _]?11/i,
/^thg[ _]?12/i],

wide:[
/^tháng ?(Một|0?1(?!\d))/i,
/^tháng ?(Hai|0?2)/i,
/^tháng ?(Ba|0?3)/i,
/^tháng ?(Tư|0?4)/i,
/^tháng ?(Năm|0?5)/i,
/^tháng ?(Sáu|0?6)/i,
/^tháng ?(Bảy|0?7)/i,
/^tháng ?(Tám|0?8)/i,
/^tháng ?(Chín|0?9)/i,
/^tháng ?(Mười|10)/i,
/^tháng ?(Mười ?Một|11)/i,
/^tháng ?(Mười ?Hai|12)/i]

};
var matchDayPatterns81={
narrow:/^(CN|T2|T3|T4|T5|T6|T7)/i,
short:/^(CN|Th ?2|Th ?3|Th ?4|Th ?5|Th ?6|Th ?7)/i,
abbreviated:/^(CN|Th ?2|Th ?3|Th ?4|Th ?5|Th ?6|Th ?7)/i,
wide:/^(Chủ ?Nhật|Chúa ?Nhật|thứ ?Hai|thứ ?Ba|thứ ?Tư|thứ ?Năm|thứ ?Sáu|thứ ?Bảy)/i
};
var parseDayPatterns81={
narrow:[/CN/i,/2/i,/3/i,/4/i,/5/i,/6/i,/7/i],
short:[/CN/i,/2/i,/3/i,/4/i,/5/i,/6/i,/7/i],
abbreviated:[/CN/i,/2/i,/3/i,/4/i,/5/i,/6/i,/7/i],
wide:[/(Chủ|Chúa) ?Nhật/i,/Hai/i,/Ba/i,/Tư/i,/Năm/i,/Sáu/i,/Bảy/i]
};
var matchDayPeriodPatterns81={
narrow:/^(a|p|nửa đêm|trưa|(giờ) (sáng|chiều|tối|đêm))/i,
abbreviated:/^(am|pm|nửa đêm|trưa|(giờ) (sáng|chiều|tối|đêm))/i,
wide:/^(ch[^i]*|sa|nửa đêm|trưa|(giờ) (sáng|chiều|tối|đêm))/i
};
var parseDayPeriodPatterns81={
any:{
am:/^(a|sa)/i,
pm:/^(p|ch[^i]*)/i,
midnight:/nửa đêm/i,
noon:/trưa/i,
morning:/sáng/i,
afternoon:/chiều/i,
evening:/tối/i,
night:/^đêm/i
}
};
var match172={
ordinalNumber:buildMatchPatternFn({
matchPattern:matchOrdinalNumberPattern81,
parsePattern:parseOrdinalNumberPattern81,
valueCallback:function valueCallback(value){return parseInt(value,10);}
}),
era:buildMatchFn({
matchPatterns:matchEraPatterns81,
defaultMatchWidth:"wide",
parsePatterns:parseEraPatterns81,
defaultParseWidth:"any"
}),
quarter:buildMatchFn({
matchPatterns:matchQuarterPatterns81,
defaultMatchWidth:"wide",
parsePatterns:parseQuarterPatterns81,
defaultParseWidth:"any",
valueCallback:function valueCallback(index){return index+1;}
}),
month:buildMatchFn({
matchPatterns:matchMonthPatterns81,
defaultMatchWidth:"wide",
parsePatterns:parseMonthPatterns81,
defaultParseWidth:"wide"
}),
day:buildMatchFn({
matchPatterns:matchDayPatterns81,
defaultMatchWidth:"wide",
parsePatterns:parseDayPatterns81,
defaultParseWidth:"wide"
}),
dayPeriod:buildMatchFn({
matchPatterns:matchDayPeriodPatterns81,
defaultMatchWidth:"wide",
parsePatterns:parseDayPeriodPatterns81,
defaultParseWidth:"any"
})
};

// lib/locale/vi.js
var _vi={
code:"vi",
formatDistance:formatDistance173,
formatLong:formatLong181,
formatRelative:formatRelative173,
localize:localize176,
match:match172,
options:{
weekStartsOn:1,
firstWeekContainsDate:1
}
};
// lib/locale/zh-CN/_lib/formatDistance.js
var formatDistanceLocale82={
lessThanXSeconds:{
one:"\u4E0D\u5230 1 \u79D2",
other:"\u4E0D\u5230 {{count}} \u79D2"
},
xSeconds:{
one:"1 \u79D2",
other:"{{count}} \u79D2"
},
halfAMinute:"\u534A\u5206\u949F",
lessThanXMinutes:{
one:"\u4E0D\u5230 1 \u5206\u949F",
other:"\u4E0D\u5230 {{count}} \u5206\u949F"
},
xMinutes:{
one:"1 \u5206\u949F",
other:"{{count}} \u5206\u949F"
},
xHours:{
one:"1 \u5C0F\u65F6",
other:"{{count}} \u5C0F\u65F6"
},
aboutXHours:{
one:"\u5927\u7EA6 1 \u5C0F\u65F6",
other:"\u5927\u7EA6 {{count}} \u5C0F\u65F6"
},
xDays:{
one:"1 \u5929",
other:"{{count}} \u5929"
},
aboutXWeeks:{
one:"\u5927\u7EA6 1 \u4E2A\u661F\u671F",
other:"\u5927\u7EA6 {{count}} \u4E2A\u661F\u671F"
},
xWeeks:{
one:"1 \u4E2A\u661F\u671F",
other:"{{count}} \u4E2A\u661F\u671F"
},
aboutXMonths:{
one:"\u5927\u7EA6 1 \u4E2A\u6708",
other:"\u5927\u7EA6 {{count}} \u4E2A\u6708"
},
xMonths:{
one:"1 \u4E2A\u6708",
other:"{{count}} \u4E2A\u6708"
},
aboutXYears:{
one:"\u5927\u7EA6 1 \u5E74",
other:"\u5927\u7EA6 {{count}} \u5E74"
},
xYears:{
one:"1 \u5E74",
other:"{{count}} \u5E74"
},
overXYears:{
one:"\u8D85\u8FC7 1 \u5E74",
other:"\u8D85\u8FC7 {{count}} \u5E74"
},
almostXYears:{
one:"\u5C06\u8FD1 1 \u5E74",
other:"\u5C06\u8FD1 {{count}} \u5E74"
}
};
var formatDistance175=function formatDistance175(token,count,options){
var result;
var tokenValue=formatDistanceLocale82[token];
if(typeof tokenValue==="string"){
result=tokenValue;
}else if(count===1){
result=tokenValue.one;
}else{
result=tokenValue.other.replace("{{count}}",String(count));
}
if(options!==null&&options!==void 0&&options.addSuffix){
if(options.comparison&&options.comparison>0){
return result+"\u5185";
}else{
return result+"\u524D";
}
}
return result;
};

// lib/locale/zh-CN/_lib/formatLong.js
var dateFormats91={
full:"y'\u5E74'M'\u6708'd'\u65E5' EEEE",
long:"y'\u5E74'M'\u6708'd'\u65E5'",
medium:"yyyy-MM-dd",
short:"yy-MM-dd"
};
var timeFormats91={
full:"zzzz a h:mm:ss",
long:"z a h:mm:ss",
medium:"a h:mm:ss",
short:"a h:mm"
};
var dateTimeFormats91={
full:"{{date}} {{time}}",
long:"{{date}} {{time}}",
medium:"{{date}} {{time}}",
short:"{{date}} {{time}}"
};
var formatLong183={
date:buildFormatLongFn({
formats:dateFormats91,
defaultWidth:"full"
}),
time:buildFormatLongFn({
formats:timeFormats91,
defaultWidth:"full"
}),
dateTime:buildFormatLongFn({
formats:dateTimeFormats91,
defaultWidth:"full"
})
};

// lib/locale/zh-CN/_lib/formatRelative.js
function checkWeek(date,baseDate,options){
var baseFormat="eeee p";
if(isSameWeek(date,baseDate,options)){
return baseFormat;
}else if(date.getTime()>baseDate.getTime()){
return"'\u4E0B\u4E2A'"+baseFormat;
}
return"'\u4E0A\u4E2A'"+baseFormat;
}
var formatRelativeLocale83={
lastWeek:checkWeek,
yesterday:"'\u6628\u5929' p",
today:"'\u4ECA\u5929' p",
tomorrow:"'\u660E\u5929' p",
nextWeek:checkWeek,
other:"PP p"
};
var formatRelative175=function formatRelative175(token,date,baseDate,options){
var format=formatRelativeLocale83[token];
if(typeof format==="function"){
return format(date,baseDate,options);
}
return format;
};

// lib/locale/zh-CN/_lib/localize.js
var eraValues83={
narrow:["\u524D","\u516C\u5143"],
abbreviated:["\u524D","\u516C\u5143"],
wide:["\u516C\u5143\u524D","\u516C\u5143"]
};
var quarterValues83={
narrow:["1","2","3","4"],
abbreviated:["\u7B2C\u4E00\u5B63","\u7B2C\u4E8C\u5B63","\u7B2C\u4E09\u5B63","\u7B2C\u56DB\u5B63"],
wide:["\u7B2C\u4E00\u5B63\u5EA6","\u7B2C\u4E8C\u5B63\u5EA6","\u7B2C\u4E09\u5B63\u5EA6","\u7B2C\u56DB\u5B63\u5EA6"]
};
var monthValues83={
narrow:[
"\u4E00",
"\u4E8C",
"\u4E09",
"\u56DB",
"\u4E94",
"\u516D",
"\u4E03",
"\u516B",
"\u4E5D",
"\u5341",
"\u5341\u4E00",
"\u5341\u4E8C"],

abbreviated:[
"1\u6708",
"2\u6708",
"3\u6708",
"4\u6708",
"5\u6708",
"6\u6708",
"7\u6708",
"8\u6708",
"9\u6708",
"10\u6708",
"11\u6708",
"12\u6708"],

wide:[
"\u4E00\u6708",
"\u4E8C\u6708",
"\u4E09\u6708",
"\u56DB\u6708",
"\u4E94\u6708",
"\u516D\u6708",
"\u4E03\u6708",
"\u516B\u6708",
"\u4E5D\u6708",
"\u5341\u6708",
"\u5341\u4E00\u6708",
"\u5341\u4E8C\u6708"]

};
var dayValues83={
narrow:["\u65E5","\u4E00","\u4E8C","\u4E09","\u56DB","\u4E94","\u516D"],
short:["\u65E5","\u4E00","\u4E8C","\u4E09","\u56DB","\u4E94","\u516D"],
abbreviated:["\u5468\u65E5","\u5468\u4E00","\u5468\u4E8C","\u5468\u4E09","\u5468\u56DB","\u5468\u4E94","\u5468\u516D"],
wide:["\u661F\u671F\u65E5","\u661F\u671F\u4E00","\u661F\u671F\u4E8C","\u661F\u671F\u4E09","\u661F\u671F\u56DB","\u661F\u671F\u4E94","\u661F\u671F\u516D"]
};
var dayPeriodValues83={
narrow:{
am:"\u4E0A",
pm:"\u4E0B",
midnight:"\u51CC\u6668",
noon:"\u5348",
morning:"\u65E9",
afternoon:"\u4E0B\u5348",
evening:"\u665A",
night:"\u591C"
},
abbreviated:{
am:"\u4E0A\u5348",
pm:"\u4E0B\u5348",
midnight:"\u51CC\u6668",
noon:"\u4E2D\u5348",
morning:"\u65E9\u6668",
afternoon:"\u4E2D\u5348",
evening:"\u665A\u4E0A",
night:"\u591C\u95F4"
},
wide:{
am:"\u4E0A\u5348",
pm:"\u4E0B\u5348",
midnight:"\u51CC\u6668",
noon:"\u4E2D\u5348",
morning:"\u65E9\u6668",
afternoon:"\u4E2D\u5348",
evening:"\u665A\u4E0A",
night:"\u591C\u95F4"
}
};
var formattingDayPeriodValues67={
narrow:{
am:"\u4E0A",
pm:"\u4E0B",
midnight:"\u51CC\u6668",
noon:"\u5348",
morning:"\u65E9",
afternoon:"\u4E0B\u5348",
evening:"\u665A",
night:"\u591C"
},
abbreviated:{
am:"\u4E0A\u5348",
pm:"\u4E0B\u5348",
midnight:"\u51CC\u6668",
noon:"\u4E2D\u5348",
morning:"\u65E9\u6668",
afternoon:"\u4E2D\u5348",
evening:"\u665A\u4E0A",
night:"\u591C\u95F4"
},
wide:{
am:"\u4E0A\u5348",
pm:"\u4E0B\u5348",
midnight:"\u51CC\u6668",
noon:"\u4E2D\u5348",
morning:"\u65E9\u6668",
afternoon:"\u4E2D\u5348",
evening:"\u665A\u4E0A",
night:"\u591C\u95F4"
}
};
var ordinalNumber83=function ordinalNumber83(dirtyNumber,options){
var number=Number(dirtyNumber);
switch(options===null||options===void 0?void 0:options.unit){
case"date":
return number.toString()+"\u65E5";
case"hour":
return number.toString()+"\u65F6";
case"minute":
return number.toString()+"\u5206";
case"second":
return number.toString()+"\u79D2";
default:
return"\u7B2C "+number.toString();
}
};
var localize178={
ordinalNumber:ordinalNumber83,
era:buildLocalizeFn({
values:eraValues83,
defaultWidth:"wide"
}),
quarter:buildLocalizeFn({
values:quarterValues83,
defaultWidth:"wide",
argumentCallback:function argumentCallback(quarter){return quarter-1;}
}),
month:buildLocalizeFn({
values:monthValues83,
defaultWidth:"wide"
}),
day:buildLocalizeFn({
values:dayValues83,
defaultWidth:"wide"
}),
dayPeriod:buildLocalizeFn({
values:dayPeriodValues83,
defaultWidth:"wide",
formattingValues:formattingDayPeriodValues67,
defaultFormattingWidth:"wide"
})
};

// lib/locale/zh-CN/_lib/match.js
var matchOrdinalNumberPattern82=/^(第\s*)?\d+(日|时|分|秒)?/i;
var parseOrdinalNumberPattern82=/\d+/i;
var matchEraPatterns82={
narrow:/^(前)/i,
abbreviated:/^(前)/i,
wide:/^(公元前|公元)/i
};
var parseEraPatterns82={
any:[/^(前)/i,/^(公元)/i]
};
var matchQuarterPatterns82={
narrow:/^[1234]/i,
abbreviated:/^第[一二三四]刻/i,
wide:/^第[一二三四]刻钟/i
};
var parseQuarterPatterns82={
any:[/(1|一)/i,/(2|二)/i,/(3|三)/i,/(4|四)/i]
};
var matchMonthPatterns82={
narrow:/^(一|二|三|四|五|六|七|八|九|十[二一])/i,
abbreviated:/^(一|二|三|四|五|六|七|八|九|十[二一]|\d|1[12])月/i,
wide:/^(一|二|三|四|五|六|七|八|九|十[二一])月/i
};
var parseMonthPatterns82={
narrow:[
/^一/i,
/^二/i,
/^三/i,
/^四/i,
/^五/i,
/^六/i,
/^七/i,
/^八/i,
/^九/i,
/^十(?!(一|二))/i,
/^十一/i,
/^十二/i],

any:[
/^一|1/i,
/^二|2/i,
/^三|3/i,
/^四|4/i,
/^五|5/i,
/^六|6/i,
/^七|7/i,
/^八|8/i,
/^九|9/i,
/^十(?!(一|二))|10/i,
/^十一|11/i,
/^十二|12/i]

};
var matchDayPatterns82={
narrow:/^[一二三四五六日]/i,
short:/^[一二三四五六日]/i,
abbreviated:/^周[一二三四五六日]/i,
wide:/^星期[一二三四五六日]/i
};
var parseDayPatterns82={
any:[/日/i,/一/i,/二/i,/三/i,/四/i,/五/i,/六/i]
};
var matchDayPeriodPatterns82={
any:/^(上午?|下午?|午夜|[中正]午|早上?|下午|晚上?|凌晨|)/i
};
var parseDayPeriodPatterns82={
any:{
am:/^上午?/i,
pm:/^下午?/i,
midnight:/^午夜/i,
noon:/^[中正]午/i,
morning:/^早上/i,
afternoon:/^下午/i,
evening:/^晚上?/i,
night:/^凌晨/i
}
};
var match174={
ordinalNumber:buildMatchPatternFn({
matchPattern:matchOrdinalNumberPattern82,
parsePattern:parseOrdinalNumberPattern82,
valueCallback:function valueCallback(value){return parseInt(value,10);}
}),
era:buildMatchFn({
matchPatterns:matchEraPatterns82,
defaultMatchWidth:"wide",
parsePatterns:parseEraPatterns82,
defaultParseWidth:"any"
}),
quarter:buildMatchFn({
matchPatterns:matchQuarterPatterns82,
defaultMatchWidth:"wide",
parsePatterns:parseQuarterPatterns82,
defaultParseWidth:"any",
valueCallback:function valueCallback(index){return index+1;}
}),
month:buildMatchFn({
matchPatterns:matchMonthPatterns82,
defaultMatchWidth:"wide",
parsePatterns:parseMonthPatterns82,
defaultParseWidth:"any"
}),
day:buildMatchFn({
matchPatterns:matchDayPatterns82,
defaultMatchWidth:"wide",
parsePatterns:parseDayPatterns82,
defaultParseWidth:"any"
}),
dayPeriod:buildMatchFn({
matchPatterns:matchDayPeriodPatterns82,
defaultMatchWidth:"any",
parsePatterns:parseDayPeriodPatterns82,
defaultParseWidth:"any"
})
};

// lib/locale/zh-CN.js
var _zhCN={
code:"zh-CN",
formatDistance:formatDistance175,
formatLong:formatLong183,
formatRelative:formatRelative175,
localize:localize178,
match:match174,
options:{
weekStartsOn:1,
firstWeekContainsDate:4
}
};
// lib/locale/zh-HK/_lib/formatDistance.js
var formatDistanceLocale83={
lessThanXSeconds:{
one:"\u5C11\u65BC 1 \u79D2",
other:"\u5C11\u65BC {{count}} \u79D2"
},
xSeconds:{
one:"1 \u79D2",
other:"{{count}} \u79D2"
},
halfAMinute:"\u534A\u5206\u9418",
lessThanXMinutes:{
one:"\u5C11\u65BC 1 \u5206\u9418",
other:"\u5C11\u65BC {{count}} \u5206\u9418"
},
xMinutes:{
one:"1 \u5206\u9418",
other:"{{count}} \u5206\u9418"
},
xHours:{
one:"1 \u5C0F\u6642",
other:"{{count}} \u5C0F\u6642"
},
aboutXHours:{
one:"\u5927\u7D04 1 \u5C0F\u6642",
other:"\u5927\u7D04 {{count}} \u5C0F\u6642"
},
xDays:{
one:"1 \u5929",
other:"{{count}} \u5929"
},
aboutXWeeks:{
one:"\u5927\u7D04 1 \u500B\u661F\u671F",
other:"\u5927\u7D04 {{count}} \u500B\u661F\u671F"
},
xWeeks:{
one:"1 \u500B\u661F\u671F",
other:"{{count}} \u500B\u661F\u671F"
},
aboutXMonths:{
one:"\u5927\u7D04 1 \u500B\u6708",
other:"\u5927\u7D04 {{count}} \u500B\u6708"
},
xMonths:{
one:"1 \u500B\u6708",
other:"{{count}} \u500B\u6708"
},
aboutXYears:{
one:"\u5927\u7D04 1 \u5E74",
other:"\u5927\u7D04 {{count}} \u5E74"
},
xYears:{
one:"1 \u5E74",
other:"{{count}} \u5E74"
},
overXYears:{
one:"\u8D85\u904E 1 \u5E74",
other:"\u8D85\u904E {{count}} \u5E74"
},
almostXYears:{
one:"\u5C07\u8FD1 1 \u5E74",
other:"\u5C07\u8FD1 {{count}} \u5E74"
}
};
var formatDistance177=function formatDistance177(token,count,options){
var result;
var tokenValue=formatDistanceLocale83[token];
if(typeof tokenValue==="string"){
result=tokenValue;
}else if(count===1){
result=tokenValue.one;
}else{
result=tokenValue.other.replace("{{count}}",String(count));
}
if(options!==null&&options!==void 0&&options.addSuffix){
if(options.comparison&&options.comparison>0){
return result+"\u5167";
}else{
return result+"\u524D";
}
}
return result;
};

// lib/locale/zh-HK/_lib/formatLong.js
var dateFormats92={
full:"y'\u5E74'M'\u6708'd'\u65E5' EEEE",
long:"y'\u5E74'M'\u6708'd'\u65E5'",
medium:"yyyy-MM-dd",
short:"yy-MM-dd"
};
var timeFormats92={
full:"zzzz a h:mm:ss",
long:"z a h:mm:ss",
medium:"a h:mm:ss",
short:"a h:mm"
};
var dateTimeFormats92={
full:"{{date}} {{time}}",
long:"{{date}} {{time}}",
medium:"{{date}} {{time}}",
short:"{{date}} {{time}}"
};
var formatLong185={
date:buildFormatLongFn({
formats:dateFormats92,
defaultWidth:"full"
}),
time:buildFormatLongFn({
formats:timeFormats92,
defaultWidth:"full"
}),
dateTime:buildFormatLongFn({
formats:dateTimeFormats92,
defaultWidth:"full"
})
};

// lib/locale/zh-HK/_lib/formatRelative.js
var formatRelativeLocale84={
lastWeek:"'\u4E0A\u500B'eeee p",
yesterday:"'\u6628\u5929' p",
today:"'\u4ECA\u5929' p",
tomorrow:"'\u660E\u5929' p",
nextWeek:"'\u4E0B\u500B'eeee p",
other:"P"
};
var formatRelative177=function formatRelative177(token,_date,_baseDate,_options){return formatRelativeLocale84[token];};

// lib/locale/zh-HK/_lib/localize.js
var eraValues84={
narrow:["\u524D","\u516C\u5143"],
abbreviated:["\u524D","\u516C\u5143"],
wide:["\u516C\u5143\u524D","\u516C\u5143"]
};
var quarterValues84={
narrow:["1","2","3","4"],
abbreviated:["\u7B2C\u4E00\u5B63","\u7B2C\u4E8C\u5B63","\u7B2C\u4E09\u5B63","\u7B2C\u56DB\u5B63"],
wide:["\u7B2C\u4E00\u5B63\u5EA6","\u7B2C\u4E8C\u5B63\u5EA6","\u7B2C\u4E09\u5B63\u5EA6","\u7B2C\u56DB\u5B63\u5EA6"]
};
var monthValues84={
narrow:[
"\u4E00",
"\u4E8C",
"\u4E09",
"\u56DB",
"\u4E94",
"\u516D",
"\u4E03",
"\u516B",
"\u4E5D",
"\u5341",
"\u5341\u4E00",
"\u5341\u4E8C"],

abbreviated:[
"1\u6708",
"2\u6708",
"3\u6708",
"4\u6708",
"5\u6708",
"6\u6708",
"7\u6708",
"8\u6708",
"9\u6708",
"10\u6708",
"11\u6708",
"12\u6708"],

wide:[
"\u4E00\u6708",
"\u4E8C\u6708",
"\u4E09\u6708",
"\u56DB\u6708",
"\u4E94\u6708",
"\u516D\u6708",
"\u4E03\u6708",
"\u516B\u6708",
"\u4E5D\u6708",
"\u5341\u6708",
"\u5341\u4E00\u6708",
"\u5341\u4E8C\u6708"]

};
var dayValues84={
narrow:["\u65E5","\u4E00","\u4E8C","\u4E09","\u56DB","\u4E94","\u516D"],
short:["\u65E5","\u4E00","\u4E8C","\u4E09","\u56DB","\u4E94","\u516D"],
abbreviated:["\u9031\u65E5","\u9031\u4E00","\u9031\u4E8C","\u9031\u4E09","\u9031\u56DB","\u9031\u4E94","\u9031\u516D"],
wide:["\u661F\u671F\u65E5","\u661F\u671F\u4E00","\u661F\u671F\u4E8C","\u661F\u671F\u4E09","\u661F\u671F\u56DB","\u661F\u671F\u4E94","\u661F\u671F\u516D"]
};
var dayPeriodValues84={
narrow:{
am:"\u4E0A",
pm:"\u4E0B",
midnight:"\u5348\u591C",
noon:"\u664C",
morning:"\u65E9",
afternoon:"\u5348",
evening:"\u665A",
night:"\u591C"
},
abbreviated:{
am:"\u4E0A\u5348",
pm:"\u4E0B\u5348",
midnight:"\u5348\u591C",
noon:"\u4E2D\u5348",
morning:"\u4E0A\u5348",
afternoon:"\u4E0B\u5348",
evening:"\u665A\u4E0A",
night:"\u591C\u665A"
},
wide:{
am:"\u4E0A\u5348",
pm:"\u4E0B\u5348",
midnight:"\u5348\u591C",
noon:"\u4E2D\u5348",
morning:"\u4E0A\u5348",
afternoon:"\u4E0B\u5348",
evening:"\u665A\u4E0A",
night:"\u591C\u665A"
}
};
var formattingDayPeriodValues68={
narrow:{
am:"\u4E0A",
pm:"\u4E0B",
midnight:"\u5348\u591C",
noon:"\u664C",
morning:"\u65E9",
afternoon:"\u5348",
evening:"\u665A",
night:"\u591C"
},
abbreviated:{
am:"\u4E0A\u5348",
pm:"\u4E0B\u5348",
midnight:"\u5348\u591C",
noon:"\u4E2D\u5348",
morning:"\u4E0A\u5348",
afternoon:"\u4E0B\u5348",
evening:"\u665A\u4E0A",
night:"\u591C\u665A"
},
wide:{
am:"\u4E0A\u5348",
pm:"\u4E0B\u5348",
midnight:"\u5348\u591C",
noon:"\u4E2D\u5348",
morning:"\u4E0A\u5348",
afternoon:"\u4E0B\u5348",
evening:"\u665A\u4E0A",
night:"\u591C\u665A"
}
};
var ordinalNumber84=function ordinalNumber84(dirtyNumber,options){
var number=Number(dirtyNumber);
switch(options===null||options===void 0?void 0:options.unit){
case"date":
return number+"\u65E5";
case"hour":
return number+"\u6642";
case"minute":
return number+"\u5206";
case"second":
return number+"\u79D2";
default:
return"\u7B2C "+number;
}
};
var localize180={
ordinalNumber:ordinalNumber84,
era:buildLocalizeFn({
values:eraValues84,
defaultWidth:"wide"
}),
quarter:buildLocalizeFn({
values:quarterValues84,
defaultWidth:"wide",
argumentCallback:function argumentCallback(quarter){return quarter-1;}
}),
month:buildLocalizeFn({
values:monthValues84,
defaultWidth:"wide"
}),
day:buildLocalizeFn({
values:dayValues84,
defaultWidth:"wide"
}),
dayPeriod:buildLocalizeFn({
values:dayPeriodValues84,
defaultWidth:"wide",
formattingValues:formattingDayPeriodValues68,
defaultFormattingWidth:"wide"
})
};

// lib/locale/zh-HK/_lib/match.js
var matchOrdinalNumberPattern83=/^(第\s*)?\d+(日|時|分|秒)?/i;
var parseOrdinalNumberPattern83=/\d+/i;
var matchEraPatterns83={
narrow:/^(前)/i,
abbreviated:/^(前)/i,
wide:/^(公元前|公元)/i
};
var parseEraPatterns83={
any:[/^(前)/i,/^(公元)/i]
};
var matchQuarterPatterns83={
narrow:/^[1234]/i,
abbreviated:/^第[一二三四]季/i,
wide:/^第[一二三四]季度/i
};
var parseQuarterPatterns83={
any:[/(1|一)/i,/(2|二)/i,/(3|三)/i,/(4|四)/i]
};
var matchMonthPatterns83={
narrow:/^(一|二|三|四|五|六|七|八|九|十[二一])/i,
abbreviated:/^(一|二|三|四|五|六|七|八|九|十[二一]|\d|1[12])月/i,
wide:/^(一|二|三|四|五|六|七|八|九|十[二一])月/i
};
var parseMonthPatterns83={
narrow:[
/^一/i,
/^二/i,
/^三/i,
/^四/i,
/^五/i,
/^六/i,
/^七/i,
/^八/i,
/^九/i,
/^十(?!(一|二))/i,
/^十一/i,
/^十二/i],

any:[
/^一|1/i,
/^二|2/i,
/^三|3/i,
/^四|4/i,
/^五|5/i,
/^六|6/i,
/^七|7/i,
/^八|8/i,
/^九|9/i,
/^十(?!(一|二))|10/i,
/^十一|11/i,
/^十二|12/i]

};
var matchDayPatterns83={
narrow:/^[一二三四五六日]/i,
short:/^[一二三四五六日]/i,
abbreviated:/^週[一二三四五六日]/i,
wide:/^星期[一二三四五六日]/i
};
var parseDayPatterns83={
any:[/日/i,/一/i,/二/i,/三/i,/四/i,/五/i,/六/i]
};
var matchDayPeriodPatterns83={
any:/^(上午?|下午?|午夜|[中正]午|早上?|下午|晚上?|凌晨)/i
};
var parseDayPeriodPatterns83={
any:{
am:/^上午?/i,
pm:/^下午?/i,
midnight:/^午夜/i,
noon:/^[中正]午/i,
morning:/^早上/i,
afternoon:/^下午/i,
evening:/^晚上?/i,
night:/^凌晨/i
}
};
var match176={
ordinalNumber:buildMatchPatternFn({
matchPattern:matchOrdinalNumberPattern83,
parsePattern:parseOrdinalNumberPattern83,
valueCallback:function valueCallback(value){return parseInt(value,10);}
}),
era:buildMatchFn({
matchPatterns:matchEraPatterns83,
defaultMatchWidth:"wide",
parsePatterns:parseEraPatterns83,
defaultParseWidth:"any"
}),
quarter:buildMatchFn({
matchPatterns:matchQuarterPatterns83,
defaultMatchWidth:"wide",
parsePatterns:parseQuarterPatterns83,
defaultParseWidth:"any",
valueCallback:function valueCallback(index){return index+1;}
}),
month:buildMatchFn({
matchPatterns:matchMonthPatterns83,
defaultMatchWidth:"wide",
parsePatterns:parseMonthPatterns83,
defaultParseWidth:"any"
}),
day:buildMatchFn({
matchPatterns:matchDayPatterns83,
defaultMatchWidth:"wide",
parsePatterns:parseDayPatterns83,
defaultParseWidth:"any"
}),
dayPeriod:buildMatchFn({
matchPatterns:matchDayPeriodPatterns83,
defaultMatchWidth:"any",
parsePatterns:parseDayPeriodPatterns83,
defaultParseWidth:"any"
})
};

// lib/locale/zh-HK.js
var _zhHK={
code:"zh-HK",
formatDistance:formatDistance177,
formatLong:formatLong185,
formatRelative:formatRelative177,
localize:localize180,
match:match176,
options:{
weekStartsOn:0,
firstWeekContainsDate:1
}
};
// lib/locale/zh-TW/_lib/formatDistance.js
var formatDistanceLocale84={
lessThanXSeconds:{
one:"\u5C11\u65BC 1 \u79D2",
other:"\u5C11\u65BC {{count}} \u79D2"
},
xSeconds:{
one:"1 \u79D2",
other:"{{count}} \u79D2"
},
halfAMinute:"\u534A\u5206\u9418",
lessThanXMinutes:{
one:"\u5C11\u65BC 1 \u5206\u9418",
other:"\u5C11\u65BC {{count}} \u5206\u9418"
},
xMinutes:{
one:"1 \u5206\u9418",
other:"{{count}} \u5206\u9418"
},
xHours:{
one:"1 \u5C0F\u6642",
other:"{{count}} \u5C0F\u6642"
},
aboutXHours:{
one:"\u5927\u7D04 1 \u5C0F\u6642",
other:"\u5927\u7D04 {{count}} \u5C0F\u6642"
},
xDays:{
one:"1 \u5929",
other:"{{count}} \u5929"
},
aboutXWeeks:{
one:"\u5927\u7D04 1 \u500B\u661F\u671F",
other:"\u5927\u7D04 {{count}} \u500B\u661F\u671F"
},
xWeeks:{
one:"1 \u500B\u661F\u671F",
other:"{{count}} \u500B\u661F\u671F"
},
aboutXMonths:{
one:"\u5927\u7D04 1 \u500B\u6708",
other:"\u5927\u7D04 {{count}} \u500B\u6708"
},
xMonths:{
one:"1 \u500B\u6708",
other:"{{count}} \u500B\u6708"
},
aboutXYears:{
one:"\u5927\u7D04 1 \u5E74",
other:"\u5927\u7D04 {{count}} \u5E74"
},
xYears:{
one:"1 \u5E74",
other:"{{count}} \u5E74"
},
overXYears:{
one:"\u8D85\u904E 1 \u5E74",
other:"\u8D85\u904E {{count}} \u5E74"
},
almostXYears:{
one:"\u5C07\u8FD1 1 \u5E74",
other:"\u5C07\u8FD1 {{count}} \u5E74"
}
};
var formatDistance179=function formatDistance179(token,count,options){
var result;
var tokenValue=formatDistanceLocale84[token];
if(typeof tokenValue==="string"){
result=tokenValue;
}else if(count===1){
result=tokenValue.one;
}else{
result=tokenValue.other.replace("{{count}}",String(count));
}
if(options!==null&&options!==void 0&&options.addSuffix){
if(options.comparison&&options.comparison>0){
return result+"\u5167";
}else{
return result+"\u524D";
}
}
return result;
};

// lib/locale/zh-TW/_lib/formatLong.js
var dateFormats93={
full:"y'\u5E74'M'\u6708'd'\u65E5' EEEE",
long:"y'\u5E74'M'\u6708'd'\u65E5'",
medium:"yyyy-MM-dd",
short:"yy-MM-dd"
};
var timeFormats93={
full:"zzzz a h:mm:ss",
long:"z a h:mm:ss",
medium:"a h:mm:ss",
short:"a h:mm"
};
var dateTimeFormats93={
full:"{{date}} {{time}}",
long:"{{date}} {{time}}",
medium:"{{date}} {{time}}",
short:"{{date}} {{time}}"
};
var formatLong187={
date:buildFormatLongFn({
formats:dateFormats93,
defaultWidth:"full"
}),
time:buildFormatLongFn({
formats:timeFormats93,
defaultWidth:"full"
}),
dateTime:buildFormatLongFn({
formats:dateTimeFormats93,
defaultWidth:"full"
})
};

// lib/locale/zh-TW/_lib/formatRelative.js
var formatRelativeLocale85={
lastWeek:"'\u4E0A\u500B'eeee p",
yesterday:"'\u6628\u5929' p",
today:"'\u4ECA\u5929' p",
tomorrow:"'\u660E\u5929' p",
nextWeek:"'\u4E0B\u500B'eeee p",
other:"P"
};
var formatRelative179=function formatRelative179(token,_date,_baseDate,_options){return formatRelativeLocale85[token];};

// lib/locale/zh-TW/_lib/localize.js
var eraValues85={
narrow:["\u524D","\u516C\u5143"],
abbreviated:["\u524D","\u516C\u5143"],
wide:["\u516C\u5143\u524D","\u516C\u5143"]
};
var quarterValues85={
narrow:["1","2","3","4"],
abbreviated:["\u7B2C\u4E00\u523B","\u7B2C\u4E8C\u523B","\u7B2C\u4E09\u523B","\u7B2C\u56DB\u523B"],
wide:["\u7B2C\u4E00\u523B\u9418","\u7B2C\u4E8C\u523B\u9418","\u7B2C\u4E09\u523B\u9418","\u7B2C\u56DB\u523B\u9418"]
};
var monthValues85={
narrow:[
"\u4E00",
"\u4E8C",
"\u4E09",
"\u56DB",
"\u4E94",
"\u516D",
"\u4E03",
"\u516B",
"\u4E5D",
"\u5341",
"\u5341\u4E00",
"\u5341\u4E8C"],

abbreviated:[
"1\u6708",
"2\u6708",
"3\u6708",
"4\u6708",
"5\u6708",
"6\u6708",
"7\u6708",
"8\u6708",
"9\u6708",
"10\u6708",
"11\u6708",
"12\u6708"],

wide:[
"\u4E00\u6708",
"\u4E8C\u6708",
"\u4E09\u6708",
"\u56DB\u6708",
"\u4E94\u6708",
"\u516D\u6708",
"\u4E03\u6708",
"\u516B\u6708",
"\u4E5D\u6708",
"\u5341\u6708",
"\u5341\u4E00\u6708",
"\u5341\u4E8C\u6708"]

};
var dayValues85={
narrow:["\u65E5","\u4E00","\u4E8C","\u4E09","\u56DB","\u4E94","\u516D"],
short:["\u65E5","\u4E00","\u4E8C","\u4E09","\u56DB","\u4E94","\u516D"],
abbreviated:["\u9031\u65E5","\u9031\u4E00","\u9031\u4E8C","\u9031\u4E09","\u9031\u56DB","\u9031\u4E94","\u9031\u516D"],
wide:["\u661F\u671F\u65E5","\u661F\u671F\u4E00","\u661F\u671F\u4E8C","\u661F\u671F\u4E09","\u661F\u671F\u56DB","\u661F\u671F\u4E94","\u661F\u671F\u516D"]
};
var dayPeriodValues85={
narrow:{
am:"\u4E0A",
pm:"\u4E0B",
midnight:"\u51CC\u6668",
noon:"\u5348",
morning:"\u65E9",
afternoon:"\u4E0B\u5348",
evening:"\u665A",
night:"\u591C"
},
abbreviated:{
am:"\u4E0A\u5348",
pm:"\u4E0B\u5348",
midnight:"\u51CC\u6668",
noon:"\u4E2D\u5348",
morning:"\u65E9\u6668",
afternoon:"\u4E2D\u5348",
evening:"\u665A\u4E0A",
night:"\u591C\u9593"
},
wide:{
am:"\u4E0A\u5348",
pm:"\u4E0B\u5348",
midnight:"\u51CC\u6668",
noon:"\u4E2D\u5348",
morning:"\u65E9\u6668",
afternoon:"\u4E2D\u5348",
evening:"\u665A\u4E0A",
night:"\u591C\u9593"
}
};
var formattingDayPeriodValues69={
narrow:{
am:"\u4E0A",
pm:"\u4E0B",
midnight:"\u51CC\u6668",
noon:"\u5348",
morning:"\u65E9",
afternoon:"\u4E0B\u5348",
evening:"\u665A",
night:"\u591C"
},
abbreviated:{
am:"\u4E0A\u5348",
pm:"\u4E0B\u5348",
midnight:"\u51CC\u6668",
noon:"\u4E2D\u5348",
morning:"\u65E9\u6668",
afternoon:"\u4E2D\u5348",
evening:"\u665A\u4E0A",
night:"\u591C\u9593"
},
wide:{
am:"\u4E0A\u5348",
pm:"\u4E0B\u5348",
midnight:"\u51CC\u6668",
noon:"\u4E2D\u5348",
morning:"\u65E9\u6668",
afternoon:"\u4E2D\u5348",
evening:"\u665A\u4E0A",
night:"\u591C\u9593"
}
};
var ordinalNumber85=function ordinalNumber85(dirtyNumber,options){
var number=Number(dirtyNumber);
switch(options===null||options===void 0?void 0:options.unit){
case"date":
return number+"\u65E5";
case"hour":
return number+"\u6642";
case"minute":
return number+"\u5206";
case"second":
return number+"\u79D2";
default:
return"\u7B2C "+number;
}
};
var localize182={
ordinalNumber:ordinalNumber85,
era:buildLocalizeFn({
values:eraValues85,
defaultWidth:"wide"
}),
quarter:buildLocalizeFn({
values:quarterValues85,
defaultWidth:"wide",
argumentCallback:function argumentCallback(quarter){return quarter-1;}
}),
month:buildLocalizeFn({
values:monthValues85,
defaultWidth:"wide"
}),
day:buildLocalizeFn({
values:dayValues85,
defaultWidth:"wide"
}),
dayPeriod:buildLocalizeFn({
values:dayPeriodValues85,
defaultWidth:"wide",
formattingValues:formattingDayPeriodValues69,
defaultFormattingWidth:"wide"
})
};

// lib/locale/zh-TW/_lib/match.js
var matchOrdinalNumberPattern84=/^(第\s*)?\d+(日|時|分|秒)?/i;
var parseOrdinalNumberPattern84=/\d+/i;
var matchEraPatterns84={
narrow:/^(前)/i,
abbreviated:/^(前)/i,
wide:/^(公元前|公元)/i
};
var parseEraPatterns84={
any:[/^(前)/i,/^(公元)/i]
};
var matchQuarterPatterns84={
narrow:/^[1234]/i,
abbreviated:/^第[一二三四]刻/i,
wide:/^第[一二三四]刻鐘/i
};
var parseQuarterPatterns84={
any:[/(1|一)/i,/(2|二)/i,/(3|三)/i,/(4|四)/i]
};
var matchMonthPatterns84={
narrow:/^(一|二|三|四|五|六|七|八|九|十[二一])/i,
abbreviated:/^(一|二|三|四|五|六|七|八|九|十[二一]|\d|1[12])月/i,
wide:/^(一|二|三|四|五|六|七|八|九|十[二一])月/i
};
var parseMonthPatterns84={
narrow:[
/^一/i,
/^二/i,
/^三/i,
/^四/i,
/^五/i,
/^六/i,
/^七/i,
/^八/i,
/^九/i,
/^十(?!(一|二))/i,
/^十一/i,
/^十二/i],

any:[
/^一|1/i,
/^二|2/i,
/^三|3/i,
/^四|4/i,
/^五|5/i,
/^六|6/i,
/^七|7/i,
/^八|8/i,
/^九|9/i,
/^十(?!(一|二))|10/i,
/^十一|11/i,
/^十二|12/i]

};
var matchDayPatterns84={
narrow:/^[一二三四五六日]/i,
short:/^[一二三四五六日]/i,
abbreviated:/^週[一二三四五六日]/i,
wide:/^星期[一二三四五六日]/i
};
var parseDayPatterns84={
any:[/日/i,/一/i,/二/i,/三/i,/四/i,/五/i,/六/i]
};
var matchDayPeriodPatterns84={
any:/^(上午?|下午?|午夜|[中正]午|早上?|下午|晚上?|凌晨)/i
};
var parseDayPeriodPatterns84={
any:{
am:/^上午?/i,
pm:/^下午?/i,
midnight:/^午夜/i,
noon:/^[中正]午/i,
morning:/^早上/i,
afternoon:/^下午/i,
evening:/^晚上?/i,
night:/^凌晨/i
}
};
var match178={
ordinalNumber:buildMatchPatternFn({
matchPattern:matchOrdinalNumberPattern84,
parsePattern:parseOrdinalNumberPattern84,
valueCallback:function valueCallback(value){return parseInt(value,10);}
}),
era:buildMatchFn({
matchPatterns:matchEraPatterns84,
defaultMatchWidth:"wide",
parsePatterns:parseEraPatterns84,
defaultParseWidth:"any"
}),
quarter:buildMatchFn({
matchPatterns:matchQuarterPatterns84,
defaultMatchWidth:"wide",
parsePatterns:parseQuarterPatterns84,
defaultParseWidth:"any",
valueCallback:function valueCallback(index){return index+1;}
}),
month:buildMatchFn({
matchPatterns:matchMonthPatterns84,
defaultMatchWidth:"wide",
parsePatterns:parseMonthPatterns84,
defaultParseWidth:"any"
}),
day:buildMatchFn({
matchPatterns:matchDayPatterns84,
defaultMatchWidth:"wide",
parsePatterns:parseDayPatterns84,
defaultParseWidth:"any"
}),
dayPeriod:buildMatchFn({
matchPatterns:matchDayPeriodPatterns84,
defaultMatchWidth:"any",
parsePatterns:parseDayPeriodPatterns84,
defaultParseWidth:"any"
})
};

// lib/locale/zh-TW.js
var _zhTW={
code:"zh-TW",
formatDistance:formatDistance179,
formatLong:formatLong187,
formatRelative:formatRelative179,
localize:localize182,
match:match178,
options:{
weekStartsOn:1,
firstWeekContainsDate:4
}
};
// lib/locale/cdn.js
window.dateFns=_objectSpread(_objectSpread({},
window.dateFns),{},{
locale:_objectSpread(_objectSpread({},(_window$dateFns=
window.dateFns)===null||_window$dateFns===void 0?void 0:_window$dateFns.locale),
exports_locale)});



//# debugId=005B991D6C3713B564756E2164756E21

//# sourceMappingURL=cdn.js.map
})();